module.exports = {
	"clusters": [
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 100
			},
			"enrolment": 2438,
			"level": "Primary",
			"ligo": 0.81,
			"name": "Bathurst City Primary",
			"playspace": 107.57,
			"projections": [
				2438,
				2685,
				2830,
				2845,
				2930
			],
			"projections_percentage": [
				0,
				10.13,
				16.08,
				16.69,
				20.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 18
					},
					"classroomspace": 2.99,
					"enrolment": 564,
					"ligo": 0.63,
					"location": [
						149.569957036472,
						-33.4217450011272
					],
					"name": "Bathurst Public School",
					"playspace": 49.49,
					"projections": [
						464,
						564,
						620,
						650,
						640,
						660
					],
					"projections_orig": [
						"464",
						"564",
						"620",
						"650",
						"640",
						"660"
					],
					"projections_percentage": [
						-17.73,
						0,
						9.93,
						15.25,
						13.48,
						17.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1150
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.7,
					"enrolment": 487,
					"ligo": 0.77,
					"location": [
						149.540380876478,
						-33.3775730412862
					],
					"name": "Eglinton Public School",
					"playspace": 35.66,
					"projections": [
						477,
						487,
						575,
						605,
						595,
						615
					],
					"projections_orig": [
						"477",
						"487",
						"575",
						"605",
						"595",
						"615"
					],
					"projections_percentage": [
						-2.05,
						0,
						18.07,
						24.23,
						22.18,
						26.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1823
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.39,
					"enrolment": 274,
					"ligo": 0.87,
					"location": [
						149.604090656805,
						-33.4167325274107
					],
					"name": "Kelso Public School",
					"playspace": 95.3,
					"projections": [
						275,
						274,
						305,
						320,
						335,
						345
					],
					"projections_orig": [
						"275",
						"274",
						"305",
						"320",
						"335",
						"345"
					],
					"projections_percentage": [
						0.36,
						0,
						11.31,
						16.79,
						22.26,
						25.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2275
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 2.94,
					"enrolment": 131,
					"ligo": 1,
					"location": [
						149.549243697678,
						-33.4912630702383
					],
					"name": "Perthville Public School",
					"playspace": 78.23,
					"projections": [
						116,
						131,
						130,
						135,
						140,
						145
					],
					"projections_orig": [
						"116",
						"131",
						"130",
						"135",
						"140",
						"145"
					],
					"projections_percentage": [
						-11.45,
						0,
						-0.76,
						3.05,
						6.87,
						10.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2862
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.62,
					"enrolment": 271,
					"ligo": 0.78,
					"location": [
						149.647003118759,
						-33.4279781924847
					],
					"name": "Raglan Public School",
					"playspace": 127.81,
					"projections": [
						237,
						271,
						295,
						310,
						320,
						330
					],
					"projections_orig": [
						"237",
						"271",
						"295",
						"310",
						"320",
						"330"
					],
					"projections_percentage": [
						-12.55,
						0,
						8.86,
						14.39,
						18.08,
						21.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2927
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.49,
					"enrolment": 20,
					"ligo": 1,
					"location": [
						149.562762120857,
						-33.6920076364636
					],
					"name": "Rockley Public School",
					"playspace": 326.63,
					"projections": [
						7,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-65,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2974
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.75,
					"enrolment": 436,
					"ligo": 0.76,
					"location": [
						149.558773614588,
						-33.4118485332193
					],
					"name": "Bathurst West Public School",
					"playspace": 59.04,
					"projections": [
						402,
						436,
						475,
						510,
						505,
						520
					],
					"projections_orig": [
						"402",
						"436",
						"475",
						"510",
						"505",
						"520"
					],
					"projections_percentage": [
						-7.8,
						0,
						8.94,
						16.97,
						15.83,
						19.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3824
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.77,
					"enrolment": 255,
					"ligo": 0.7,
					"location": [
						149.569679563804,
						-33.4335915035141
					],
					"name": "Bathurst South Public School",
					"playspace": 88.37,
					"projections": [
						222,
						255,
						265,
						280,
						290,
						295
					],
					"projections_orig": [
						"222",
						"255",
						"265",
						"280",
						"290",
						"295"
					],
					"projections_percentage": [
						-12.94,
						0,
						3.92,
						9.8,
						13.73,
						15.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3847
				}
			],
			"uid": 10001
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 155
			},
			"enrolment": 3089,
			"level": "Primary",
			"ligo": 0.66,
			"name": "North Wollongong",
			"playspace": 94.84,
			"projections": [
				3089,
				3160,
				3320,
				3405,
				3435
			],
			"projections_percentage": [
				0,
				2.3,
				7.48,
				10.23,
				11.2
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.62,
					"enrolment": 346,
					"ligo": 0.62,
					"location": [
						150.872555034596,
						-34.387173075239
					],
					"name": "Balgownie Public School",
					"playspace": 33.37,
					"projections": [
						300,
						346,
						355,
						370,
						380,
						385
					],
					"projections_orig": [
						"300",
						"346",
						"355",
						"370",
						"380",
						"385"
					],
					"projections_percentage": [
						-13.29,
						0,
						2.6,
						6.94,
						9.83,
						11.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1106
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.17,
					"enrolment": 194,
					"ligo": 0.78,
					"location": [
						150.899537222568,
						-34.3680570137568
					],
					"name": "Corrimal Public School",
					"playspace": 51.87,
					"projections": [
						159,
						194,
						180,
						190,
						195,
						195
					],
					"projections_orig": [
						"159",
						"194",
						"180",
						"190",
						"195",
						"195"
					],
					"projections_percentage": [
						-18.04,
						0,
						-7.22,
						-2.06,
						0.52,
						0.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1661
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.14,
					"enrolment": 375,
					"ligo": 0.5,
					"location": [
						150.892082396198,
						-34.3908959163072
					],
					"name": "Fairy Meadow Public School",
					"playspace": 55.13,
					"projections": [
						423,
						375,
						390,
						410,
						420,
						425
					],
					"projections_orig": [
						"423",
						"375",
						"390",
						"410",
						"420",
						"425"
					],
					"projections_percentage": [
						12.8,
						0,
						4,
						9.33,
						12,
						13.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1898
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 1.96,
					"enrolment": 547,
					"ligo": 0.85,
					"location": [
						150.906020904158,
						-34.3456750994195
					],
					"name": "Woonona Public School",
					"playspace": 38.07,
					"projections": [
						394,
						547,
						530,
						555,
						565,
						570
					],
					"projections_orig": [
						"394",
						"547",
						"530",
						"555",
						"565",
						"570"
					],
					"projections_percentage": [
						-27.97,
						0,
						-3.11,
						1.46,
						3.29,
						4.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3510
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 5.02,
					"enrolment": 123,
					"ligo": 0.58,
					"location": [
						150.890141249507,
						-34.3800091768286
					],
					"name": "Tarrawanna Public School",
					"playspace": 324.79,
					"projections": [
						131,
						123,
						130,
						140,
						140,
						145
					],
					"projections_orig": [
						"131",
						"123",
						"130",
						"140",
						"140",
						"145"
					],
					"projections_percentage": [
						6.5,
						0,
						5.69,
						13.82,
						13.82,
						17.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3820
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.63,
					"enrolment": 173,
					"ligo": 0.62,
					"location": [
						150.902082397861,
						-34.3897864671792
					],
					"name": "Towradgi Public School",
					"playspace": 119.14,
					"projections": [
						148,
						173,
						175,
						185,
						190,
						190
					],
					"projections_orig": [
						"148",
						"173",
						"175",
						"185",
						"190",
						"190"
					],
					"projections_percentage": [
						-14.45,
						0,
						1.16,
						6.94,
						9.83,
						9.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3866
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.76,
					"enrolment": 223,
					"ligo": 0.52,
					"location": [
						150.905091397685,
						-34.3778919479532
					],
					"name": "Corrimal East Public School",
					"playspace": 150.41,
					"projections": [
						267,
						223,
						235,
						245,
						255,
						255
					],
					"projections_orig": [
						"267",
						"223",
						"235",
						"245",
						"255",
						"255"
					],
					"projections_percentage": [
						19.73,
						0,
						5.38,
						9.87,
						14.35,
						14.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3877
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.27,
					"enrolment": 256,
					"ligo": 0.8,
					"location": [
						150.90652345035,
						-34.3590166835345
					],
					"name": "Russell Vale Public School",
					"playspace": 48.97,
					"projections": [
						248,
						256,
						265,
						280,
						285,
						290
					],
					"projections_orig": [
						"248",
						"256",
						"265",
						"280",
						"285",
						"290"
					],
					"projections_percentage": [
						-3.12,
						0,
						3.52,
						9.38,
						11.33,
						13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3973
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 8.64,
					"enrolment": 161,
					"ligo": 0.86,
					"location": [
						150.913095691602,
						-34.3711959160968
					],
					"name": "Bellambi Public School",
					"playspace": 159.78,
					"projections": [
						169,
						161,
						185,
						195,
						200,
						205
					],
					"projections_orig": [
						"169",
						"161",
						"185",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						4.97,
						0,
						14.91,
						21.12,
						24.22,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3979
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.73,
					"enrolment": 223,
					"ligo": 0.55,
					"location": [
						150.889461075648,
						-34.399042115404
					],
					"name": "Mount Ousley Public School",
					"playspace": 40.72,
					"projections": [
						165,
						223,
						215,
						225,
						235,
						235
					],
					"projections_orig": [
						"165",
						"223",
						"215",
						"225",
						"235",
						"235"
					],
					"projections_percentage": [
						-26.01,
						0,
						-3.59,
						0.9,
						5.38,
						5.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4095
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.93,
					"enrolment": 216,
					"ligo": 0.64,
					"location": [
						150.914642239957,
						-34.3520526946849
					],
					"name": "Woonona East Public School",
					"playspace": 102.25,
					"projections": [
						273,
						216,
						255,
						265,
						275,
						275
					],
					"projections_orig": [
						"273",
						"216",
						"255",
						"265",
						"275",
						"275"
					],
					"projections_percentage": [
						26.39,
						0,
						18.06,
						22.69,
						27.31,
						27.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4296
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 2.98,
					"enrolment": 252,
					"ligo": 0.62,
					"location": [
						150.872493825157,
						-34.3960730091053
					],
					"name": "Pleasant Heights Public School",
					"playspace": 13.53,
					"projections": [
						188,
						252,
						245,
						260,
						265,
						265
					],
					"projections_orig": [
						"188",
						"252",
						"245",
						"260",
						"265",
						"265"
					],
					"projections_percentage": [
						-25.4,
						0,
						-2.78,
						3.17,
						5.16,
						5.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4357
				}
			],
			"uid": 10003
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 71
			},
			"enrolment": 1995,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Shellharbour",
			"playspace": 65.22,
			"projections": [
				1995,
				2060,
				2090,
				2090,
				2090
			],
			"projections_percentage": [
				0,
				3.26,
				4.76,
				4.76,
				4.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.41,
					"enrolment": 478,
					"ligo": 0.41,
					"location": [
						150.865093268961,
						-34.5781386336009
					],
					"name": "Shellharbour Public School",
					"playspace": 37.17,
					"projections": [
						461,
						478,
						515,
						525,
						525,
						525
					],
					"projections_orig": [
						"461",
						"478",
						"515",
						"525",
						"525",
						"525"
					],
					"projections_percentage": [
						-3.56,
						0,
						7.74,
						9.83,
						9.83,
						9.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3060
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.57,
					"enrolment": 553,
					"ligo": 0.73,
					"location": [
						150.848167528148,
						-34.5819365533343
					],
					"name": "Flinders Public School",
					"playspace": 139.06,
					"projections": [
						532,
						553,
						560,
						565,
						565,
						565
					],
					"projections_orig": [
						"532",
						"553",
						"560",
						"565",
						"565",
						"565"
					],
					"projections_percentage": [
						-3.8,
						0,
						1.27,
						2.17,
						2.17,
						2.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4463
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.81,
					"enrolment": 402,
					"ligo": 0.87,
					"location": [
						150.85168512495,
						-34.6244038578664
					],
					"name": "Minnamurra Public School",
					"playspace": 48.55,
					"projections": [
						437,
						402,
						440,
						445,
						445,
						445
					],
					"projections_orig": [
						"437",
						"402",
						"440",
						"445",
						"445",
						"445"
					],
					"projections_percentage": [
						8.71,
						0,
						9.45,
						10.7,
						10.7,
						10.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4498
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 14
					},
					"classroomspace": 2.73,
					"enrolment": 562,
					"ligo": 0.82,
					"location": [
						150.854167461507,
						-34.5956218502914
					],
					"name": "Shell Cove Public School",
					"playspace": 36.11,
					"projections": [
						496,
						562,
						545,
						555,
						555,
						555
					],
					"projections_orig": [
						"496",
						"562",
						"545",
						"555",
						"555",
						"555"
					],
					"projections_percentage": [
						-11.74,
						0,
						-3.02,
						-1.25,
						-1.25,
						-1.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4641
				}
			],
			"uid": 10004
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 111
			},
			"enrolment": 1616,
			"level": "Primary",
			"ligo": 0.62,
			"name": "South Wollongong",
			"playspace": 90.56,
			"projections": [
				1616,
				1645,
				1715,
				1765,
				1775
			],
			"projections_percentage": [
				0,
				1.79,
				6.13,
				9.22,
				9.84
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.89,
					"enrolment": 336,
					"ligo": 0.67,
					"location": [
						150.855153611246,
						-34.4800694274536
					],
					"name": "Berkeley Public School",
					"playspace": 64.13,
					"projections": [
						286,
						336,
						335,
						350,
						360,
						365
					],
					"projections_orig": [
						"286",
						"336",
						"335",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						-14.88,
						0,
						-0.3,
						4.17,
						7.14,
						8.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1202
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.43,
					"enrolment": 273,
					"ligo": 0.58,
					"location": [
						150.914985829546,
						-34.4856816457399
					],
					"name": "Port Kembla Public School",
					"playspace": 65.32,
					"projections": [
						214,
						273,
						275,
						290,
						300,
						300
					],
					"projections_orig": [
						"214",
						"273",
						"275",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						-21.61,
						0,
						0.73,
						6.23,
						9.89,
						9.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2896
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.99,
					"enrolment": 112,
					"ligo": 0.65,
					"location": [
						150.881577395598,
						-34.5016108694209
					],
					"name": "Primbee Public School",
					"playspace": 86.55,
					"projections": [
						81,
						112,
						105,
						110,
						115,
						115
					],
					"projections_orig": [
						"81",
						"112",
						"105",
						"110",
						"115",
						"115"
					],
					"projections_percentage": [
						-27.68,
						0,
						-6.25,
						-1.79,
						2.68,
						2.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2904
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 6.04,
					"enrolment": 286,
					"ligo": 0.61,
					"location": [
						150.877907197116,
						-34.4810706587907
					],
					"name": "Warrawong Public School",
					"playspace": 111.35,
					"projections": [
						284,
						286,
						300,
						315,
						320,
						325
					],
					"projections_orig": [
						"284",
						"286",
						"300",
						"315",
						"320",
						"325"
					],
					"projections_percentage": [
						-0.7,
						0,
						4.9,
						10.14,
						11.89,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3104
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.58,
					"enrolment": 149,
					"ligo": 0.6,
					"location": [
						150.86773121972,
						-34.4891150242797
					],
					"name": "Lake Heights Public School",
					"playspace": 46.99,
					"projections": [
						147,
						149,
						155,
						160,
						165,
						165
					],
					"projections_orig": [
						"147",
						"149",
						"155",
						"160",
						"165",
						"165"
					],
					"projections_percentage": [
						-1.34,
						0,
						4.03,
						7.38,
						10.74,
						10.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4011
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 8.02,
					"enrolment": 153,
					"ligo": 0.64,
					"location": [
						150.869952043968,
						-34.4714558508906
					],
					"name": "Cringila Public School",
					"playspace": 118.29,
					"projections": [
						150,
						153,
						170,
						175,
						180,
						180
					],
					"projections_orig": [
						"150",
						"153",
						"170",
						"175",
						"180",
						"180"
					],
					"projections_percentage": [
						-1.96,
						0,
						11.11,
						14.38,
						17.65,
						17.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4037
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 4.71,
					"enrolment": 111,
					"ligo": 0.37,
					"location": [
						150.893426541994,
						-34.4887428213478
					],
					"name": "Kemblawarra Public School",
					"playspace": 186.55,
					"projections": [
						108,
						111,
						100,
						100,
						105,
						105
					],
					"projections_orig": [
						"108",
						"111",
						"100",
						"100",
						"105",
						"105"
					],
					"projections_percentage": [
						-2.7,
						0,
						-9.91,
						-9.91,
						-5.41,
						-5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4083
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.93,
					"enrolment": 196,
					"ligo": 0.87,
					"location": [
						150.840164077477,
						-34.4755664804454
					],
					"name": "Berkeley West Public School",
					"playspace": 45.27,
					"projections": [
						187,
						196,
						205,
						215,
						220,
						220
					],
					"projections_orig": [
						"187",
						"196",
						"205",
						"215",
						"220",
						"220"
					],
					"projections_percentage": [
						-4.59,
						0,
						4.59,
						9.69,
						12.24,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4180
				}
			],
			"uid": 10005
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 102
			},
			"enrolment": 2187,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Westlake Primary",
			"playspace": 69.96,
			"projections": [
				2187,
				2355,
				2415,
				2460,
				2515
			],
			"projections_percentage": [
				0,
				7.68,
				10.43,
				12.48,
				15
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 18
					},
					"classroomspace": 2.82,
					"enrolment": 709,
					"ligo": 0.86,
					"location": [
						150.77753446986,
						-34.4953338293473
					],
					"name": "Dapto Public School",
					"playspace": 26.16,
					"projections": [
						622,
						709,
						705,
						735,
						770,
						800
					],
					"projections_orig": [
						"622",
						"709",
						"705",
						"735",
						"770",
						"800"
					],
					"projections_percentage": [
						-12.27,
						0,
						-0.56,
						3.67,
						8.6,
						12.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1727
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.37,
					"enrolment": 318,
					"ligo": 0.55,
					"location": [
						150.795075970518,
						-34.5058279358415
					],
					"name": "Lakelands Public School",
					"playspace": 79.14,
					"projections": [
						294,
						318,
						345,
						350,
						350,
						355
					],
					"projections_orig": [
						"294",
						"318",
						"345",
						"350",
						"350",
						"355"
					],
					"projections_percentage": [
						-7.55,
						0,
						8.49,
						10.06,
						10.06,
						11.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4266
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.67,
					"enrolment": 538,
					"ligo": 0.66,
					"location": [
						150.815686364942,
						-34.4924233225085
					],
					"name": "Hayes Park Public School",
					"playspace": 44.43,
					"projections": [
						521,
						538,
						605,
						620,
						625,
						635
					],
					"projections_orig": [
						"521",
						"538",
						"605",
						"620",
						"625",
						"635"
					],
					"projections_percentage": [
						-3.16,
						0,
						12.45,
						15.24,
						16.17,
						18.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4399
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 7.13,
					"enrolment": 232,
					"ligo": 0.86,
					"location": [
						150.807806161489,
						-34.502089069897
					],
					"name": "Koonawarra Public School",
					"playspace": 127.37,
					"projections": [
						313,
						232,
						285,
						290,
						290,
						295
					],
					"projections_orig": [
						"313",
						"232",
						"285",
						"290",
						"290",
						"295"
					],
					"projections_percentage": [
						34.91,
						0,
						22.84,
						25,
						25,
						27.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4409
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.5,
					"enrolment": 390,
					"ligo": 0.73,
					"location": [
						150.785793204803,
						-34.5160487005655
					],
					"name": "Mount Brown Public School",
					"playspace": 72.7,
					"projections": [
						354,
						390,
						415,
						420,
						425,
						430
					],
					"projections_orig": [
						"354",
						"390",
						"415",
						"420",
						"425",
						"430"
					],
					"projections_percentage": [
						-9.23,
						0,
						6.41,
						7.69,
						8.97,
						10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4423
				}
			],
			"uid": 10006
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 125
			},
			"enrolment": 3138,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Wollongong Cbd Primary",
			"playspace": 53.99,
			"projections": [
				3138,
				3260,
				3410,
				3495,
				3515
			],
			"projections_percentage": [
				0,
				3.89,
				8.67,
				11.38,
				12.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.66,
					"enrolment": 188,
					"ligo": 0.81,
					"location": [
						150.886688863028,
						-34.4386544208947
					],
					"name": "Coniston Public School",
					"playspace": 66.66,
					"projections": [
						235,
						188,
						230,
						240,
						245,
						245
					],
					"projections_orig": [
						"235",
						"188",
						"230",
						"240",
						"245",
						"245"
					],
					"projections_percentage": [
						25,
						0,
						22.34,
						27.66,
						30.32,
						30.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1612
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.5,
					"enrolment": 341,
					"ligo": 0.69,
					"location": [
						150.872867529441,
						-34.4145916209238
					],
					"name": "Keiraville Public School",
					"playspace": 34.56,
					"projections": [
						259,
						341,
						325,
						340,
						350,
						350
					],
					"projections_orig": [
						"259",
						"341",
						"325",
						"340",
						"350",
						"350"
					],
					"projections_percentage": [
						-24.05,
						0,
						-4.69,
						-0.29,
						2.64,
						2.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2271
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.32,
					"enrolment": 87,
					"ligo": 0.63,
					"location": [
						150.855926808222,
						-34.4112215867063
					],
					"name": "Mount Keira Public School",
					"playspace": 45.36,
					"projections": [
						76,
						87,
						95,
						100,
						100,
						105
					],
					"projections_orig": [
						"76",
						"87",
						"95",
						"100",
						"100",
						"105"
					],
					"projections_percentage": [
						-12.64,
						0,
						9.2,
						14.94,
						14.94,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2642
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.6,
					"enrolment": 242,
					"ligo": 0.73,
					"location": [
						150.870494013188,
						-34.4238197765219
					],
					"name": "Wollongong West Public School",
					"playspace": 74.43,
					"projections": [
						213,
						242,
						245,
						260,
						265,
						265
					],
					"projections_orig": [
						"213",
						"242",
						"245",
						"260",
						"265",
						"265"
					],
					"projections_percentage": [
						-11.98,
						0,
						1.24,
						7.44,
						9.5,
						9.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3477
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 7
					},
					"classroomspace": 2.66,
					"enrolment": 237,
					"ligo": 0.63,
					"location": [
						150.879784322533,
						-34.418264398008
					],
					"name": "Gwynneville Public School",
					"playspace": 101.46,
					"projections": [
						193,
						237,
						250,
						265,
						270,
						270
					],
					"projections_orig": [
						"193",
						"237",
						"250",
						"265",
						"270",
						"270"
					],
					"projections_percentage": [
						-18.57,
						0,
						5.49,
						11.81,
						13.92,
						13.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3826
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.18,
					"enrolment": 329,
					"ligo": 0.72,
					"location": [
						150.870662755164,
						-34.4370363937347
					],
					"name": "Mount St Thomas Public School",
					"playspace": 30.25,
					"projections": [
						312,
						329,
						345,
						360,
						370,
						370
					],
					"projections_orig": [
						"312",
						"329",
						"345",
						"360",
						"370",
						"370"
					],
					"projections_percentage": [
						-5.17,
						0,
						4.86,
						9.42,
						12.46,
						12.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3881
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 17
					},
					"classroomspace": 2.46,
					"enrolment": 458,
					"ligo": 0.57,
					"location": [
						150.896216289691,
						-34.4223353210806
					],
					"name": "Wollongong Public School",
					"playspace": 21.61,
					"projections": [
						422,
						458,
						470,
						490,
						505,
						505
					],
					"projections_orig": [
						"422",
						"458",
						"470",
						"490",
						"505",
						"505"
					],
					"projections_percentage": [
						-7.86,
						0,
						2.62,
						6.99,
						10.26,
						10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3954
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.55,
					"enrolment": 297,
					"ligo": 0.54,
					"location": [
						150.853836125583,
						-34.4400883171415
					],
					"name": "Figtree Public School",
					"playspace": 66.88,
					"projections": [
						319,
						297,
						325,
						340,
						350,
						350
					],
					"projections_orig": [
						"319",
						"297",
						"325",
						"340",
						"350",
						"350"
					],
					"projections_percentage": [
						7.41,
						0,
						9.43,
						14.48,
						17.85,
						17.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3964
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.47,
					"enrolment": 416,
					"ligo": 0.64,
					"location": [
						150.860841540884,
						-34.4293040507253
					],
					"name": "Lindsay Park Public School",
					"playspace": 36.92,
					"projections": [
						308,
						416,
						390,
						405,
						415,
						420
					],
					"projections_orig": [
						"308",
						"416",
						"390",
						"405",
						"415",
						"420"
					],
					"projections_percentage": [
						-25.96,
						0,
						-6.25,
						-2.64,
						-0.24,
						0.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4042
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.45,
					"enrolment": 244,
					"ligo": 0.66,
					"location": [
						150.856085634133,
						-34.4316035350907
					],
					"name": "Figtree Heights Public School",
					"playspace": 44.51,
					"projections": [
						223,
						244,
						260,
						270,
						275,
						280
					],
					"projections_orig": [
						"223",
						"244",
						"260",
						"270",
						"275",
						"280"
					],
					"projections_percentage": [
						-8.61,
						0,
						6.56,
						10.66,
						12.7,
						14.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4462
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 2.5,
					"enrolment": 299,
					"ligo": 0.67,
					"location": [
						150.847149569334,
						-34.4265102280745
					],
					"name": "Nareena Hills Public School",
					"playspace": 71.26,
					"projections": [
						317,
						299,
						325,
						340,
						350,
						355
					],
					"projections_orig": [
						"317",
						"299",
						"325",
						"340",
						"350",
						"355"
					],
					"projections_percentage": [
						6.02,
						0,
						8.7,
						13.71,
						17.06,
						18.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4500
				}
			],
			"uid": 10007
		},
		{
			"classrooms": {
				"demountable": 21,
				"permanent": 75
			},
			"enrolment": 2286,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Wollongong Northern Beaches",
			"playspace": 52.87,
			"projections": [
				2286,
				2365,
				2510,
				2605,
				2665
			],
			"projections_percentage": [
				0,
				3.46,
				9.8,
				13.95,
				16.58
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 7
					},
					"classroomspace": 2.7,
					"enrolment": 338,
					"ligo": 0.65,
					"location": [
						150.935247752811,
						-34.3054032786763
					],
					"name": "Austinmer Public School",
					"playspace": 15.81,
					"projections": [
						344,
						338,
						365,
						385,
						395,
						395
					],
					"projections_orig": [
						"344",
						"338",
						"365",
						"385",
						"395",
						"395"
					],
					"projections_percentage": [
						1.78,
						0,
						7.99,
						13.91,
						16.86,
						16.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1076
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 7
					},
					"classroomspace": 2.56,
					"enrolment": 216,
					"ligo": 0.79,
					"location": [
						150.912103535895,
						-34.3273101757218
					],
					"name": "Bulli Public School",
					"playspace": 61.31,
					"projections": [
						212,
						216,
						225,
						235,
						240,
						240
					],
					"projections_orig": [
						"212",
						"216",
						"225",
						"235",
						"240",
						"240"
					],
					"projections_percentage": [
						-1.85,
						0,
						4.17,
						8.8,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1411
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 2.63,
					"enrolment": 139,
					"ligo": 0.66,
					"location": [
						150.946582642598,
						-34.2895666255615
					],
					"name": "Coledale Public School",
					"playspace": 78.06,
					"projections": [
						114,
						139,
						135,
						140,
						145,
						145
					],
					"projections_orig": [
						"114",
						"139",
						"135",
						"140",
						"145",
						"145"
					],
					"projections_percentage": [
						-17.99,
						0,
						-2.88,
						0.72,
						4.32,
						4.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1587
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 19
					},
					"classroomspace": 2.53,
					"enrolment": 482,
					"ligo": 0.98,
					"location": [
						150.987791542614,
						-34.1839389145216
					],
					"name": "Helensburgh Public School",
					"playspace": 29.47,
					"projections": [
						481,
						482,
						500,
						540,
						580,
						620
					],
					"projections_orig": [
						"481",
						"482",
						"500",
						"540",
						"580",
						"620"
					],
					"projections_percentage": [
						-0.21,
						0,
						3.73,
						12.03,
						20.33,
						28.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2153
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.97,
					"enrolment": 57,
					"ligo": 0.64,
					"location": [
						151.001836432641,
						-34.2123524681033
					],
					"name": "Otford Public School",
					"playspace": 77.73,
					"projections": [
						63,
						57,
						60,
						65,
						70,
						75
					],
					"projections_orig": [
						"63",
						"57",
						"60",
						"65",
						"70",
						"75"
					],
					"projections_percentage": [
						10.53,
						0,
						5.26,
						14.04,
						22.81,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2818
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.64,
					"enrolment": 73,
					"ligo": 0.78,
					"location": [
						150.9660782928,
						-34.2656968445563
					],
					"name": "Scarborough Public School",
					"playspace": 62.59,
					"projections": [
						66,
						73,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"66",
						"73",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						-9.59,
						0,
						9.59,
						16.44,
						16.44,
						16.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3045
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.64,
					"enrolment": 154,
					"ligo": 0.73,
					"location": [
						150.984362576867,
						-34.2291926498658
					],
					"name": "Stanwell Park Public School",
					"playspace": 38.01,
					"projections": [
						168,
						154,
						170,
						185,
						195,
						205
					],
					"projections_orig": [
						"168",
						"154",
						"170",
						"185",
						"195",
						"205"
					],
					"projections_percentage": [
						9.09,
						0,
						10.39,
						20.13,
						26.62,
						33.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3103
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.36,
					"enrolment": 465,
					"ligo": 0.82,
					"location": [
						150.918825192459,
						-34.315723511646
					],
					"name": "Thirroul Public School",
					"playspace": 35.33,
					"projections": [
						348,
						465,
						460,
						485,
						495,
						500
					],
					"projections_orig": [
						"348",
						"465",
						"460",
						"485",
						"495",
						"500"
					],
					"projections_percentage": [
						-25.16,
						0,
						-1.08,
						4.3,
						6.45,
						7.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3201
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 10
					},
					"classroomspace": 2.71,
					"enrolment": 362,
					"ligo": 0.49,
					"location": [
						150.918608972705,
						-34.3359011469774
					],
					"name": "Waniora Public School",
					"playspace": 77.52,
					"projections": [
						320,
						362,
						370,
						390,
						400,
						400
					],
					"projections_orig": [
						"320",
						"362",
						"370",
						"390",
						"400",
						"400"
					],
					"projections_percentage": [
						-11.6,
						0,
						2.21,
						7.73,
						10.5,
						10.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3960
				}
			],
			"uid": 10008
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 47
			},
			"enrolment": 717,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Unanderra",
			"playspace": 89.33,
			"projections": [
				717,
				810,
				850,
				875,
				880
			],
			"projections_percentage": [
				0,
				12.97,
				18.55,
				22.04,
				22.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.16,
					"enrolment": 126,
					"ligo": 0.64,
					"location": [
						150.817004066212,
						-34.4327681191786
					],
					"name": "Mount Kembla Public School",
					"playspace": 81.47,
					"projections": [
						151,
						126,
						140,
						150,
						155,
						155
					],
					"projections_orig": [
						"151",
						"126",
						"140",
						"150",
						"155",
						"155"
					],
					"projections_percentage": [
						19.84,
						0,
						11.11,
						19.05,
						23.02,
						23.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2643
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.92,
					"enrolment": 401,
					"ligo": 0.65,
					"location": [
						150.834677275787,
						-34.4449139532128
					],
					"name": "Unanderra Public School",
					"playspace": 33.95,
					"projections": [
						483,
						401,
						465,
						485,
						500,
						505
					],
					"projections_orig": [
						"483",
						"401",
						"465",
						"485",
						"500",
						"505"
					],
					"projections_percentage": [
						20.45,
						0,
						15.96,
						20.95,
						24.69,
						25.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3308
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 5.99,
					"enrolment": 190,
					"ligo": 0.82,
					"location": [
						150.835312354999,
						-34.4610699140548
					],
					"name": "Farmborough Road Public School",
					"playspace": 152.56,
					"projections": [
						223,
						190,
						205,
						215,
						220,
						220
					],
					"projections_orig": [
						"223",
						"190",
						"205",
						"215",
						"220",
						"220"
					],
					"projections_percentage": [
						17.37,
						0,
						7.89,
						13.16,
						15.79,
						15.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3976
				}
			],
			"uid": 10009
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 130
			},
			"enrolment": 2041,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Lake Illawarra Primary",
			"playspace": 84.74,
			"projections": [
				2041,
				2255,
				2295,
				2310,
				2340
			],
			"projections_percentage": [
				0,
				10.49,
				12.44,
				13.18,
				14.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.36,
					"enrolment": 180,
					"ligo": 0.71,
					"location": [
						150.86669220596,
						-34.5319749700228
					],
					"name": "Windang Public School",
					"playspace": 129.96,
					"projections": [
						171,
						180,
						190,
						195,
						200,
						205
					],
					"projections_orig": [
						"171",
						"180",
						"190",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						-5,
						0,
						5.56,
						8.33,
						11.11,
						13.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1992
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.02,
					"enrolment": 439,
					"ligo": 0.68,
					"location": [
						150.817393119255,
						-34.5630059698292
					],
					"name": "Oak Flats Public School",
					"playspace": 30.39,
					"projections": [
						454,
						439,
						480,
						485,
						490,
						495
					],
					"projections_orig": [
						"454",
						"439",
						"480",
						"485",
						"490",
						"495"
					],
					"projections_percentage": [
						3.42,
						0,
						9.34,
						10.48,
						11.62,
						12.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3860
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.03,
					"enrolment": 244,
					"ligo": 0.52,
					"location": [
						150.859062616159,
						-34.5390194596889
					],
					"name": "Lake Illawarra South Public School",
					"playspace": 102.55,
					"projections": [
						278,
						244,
						275,
						280,
						280,
						285
					],
					"projections_orig": [
						"278",
						"244",
						"275",
						"280",
						"280",
						"285"
					],
					"projections_percentage": [
						13.93,
						0,
						12.7,
						14.75,
						14.75,
						16.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3867
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.65,
					"enrolment": 250,
					"ligo": 0.81,
					"location": [
						150.853921641464,
						-34.5572030806258
					],
					"name": "Warilla Public School",
					"playspace": 52.21,
					"projections": [
						207,
						250,
						245,
						250,
						250,
						255
					],
					"projections_orig": [
						"207",
						"250",
						"245",
						"250",
						"250",
						"255"
					],
					"projections_percentage": [
						-17.2,
						0,
						-2,
						0,
						0,
						2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4005
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.05,
					"enrolment": 282,
					"ligo": 0.57,
					"location": [
						150.830573389364,
						-34.5593404189686
					],
					"name": "Balarang Public School",
					"playspace": 88.78,
					"projections": [
						377,
						282,
						365,
						370,
						375,
						380
					],
					"projections_orig": [
						"377",
						"282",
						"365",
						"370",
						"375",
						"380"
					],
					"projections_percentage": [
						33.69,
						0,
						29.43,
						31.21,
						32.98,
						34.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4291
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.07,
					"enrolment": 152,
					"ligo": 0.88,
					"location": [
						150.85351222295,
						-34.5467797912314
					],
					"name": "Warilla North Public School",
					"playspace": 102.21,
					"projections": [
						108,
						152,
						160,
						165,
						165,
						165
					],
					"projections_orig": [
						"108",
						"152",
						"160",
						"165",
						"165",
						"165"
					],
					"projections_percentage": [
						-28.95,
						0,
						5.26,
						8.55,
						8.55,
						8.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4333
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 5.87,
					"enrolment": 243,
					"ligo": 0.61,
					"location": [
						150.844248571402,
						-34.5547141065624
					],
					"name": "Mount Warrigal Public School",
					"playspace": 79.38,
					"projections": [
						264,
						243,
						265,
						270,
						270,
						275
					],
					"projections_orig": [
						"264",
						"243",
						"265",
						"270",
						"270",
						"275"
					],
					"projections_percentage": [
						8.64,
						0,
						9.05,
						11.11,
						11.11,
						13.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4395
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 5.44,
					"enrolment": 251,
					"ligo": 0.63,
					"location": [
						150.846152946655,
						-34.5598871276146
					],
					"name": "Barrack Heights Public School",
					"playspace": 92.46,
					"projections": [
						263,
						251,
						275,
						280,
						280,
						280
					],
					"projections_orig": [
						"263",
						"251",
						"275",
						"280",
						"280",
						"280"
					],
					"projections_percentage": [
						4.78,
						0,
						9.56,
						11.55,
						11.55,
						11.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4501
				}
			],
			"uid": 10010
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 173
			},
			"enrolment": 4668,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Bellevue Hill Primary",
			"playspace": 9.96,
			"projections": [
				4668,
				4880,
				4790,
				4800,
				4900
			],
			"projections_percentage": [
				0,
				4.54,
				2.61,
				2.83,
				4.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 20
					},
					"classroomspace": 2.44,
					"enrolment": 607,
					"ligo": 0.45,
					"location": [
						151.259475518191,
						-33.8866737539736
					],
					"name": "Bellevue Hill Public School",
					"playspace": 5.29,
					"projections": [
						533,
						607,
						665,
						650,
						655,
						675
					],
					"projections_orig": [
						"533",
						"607",
						"665",
						"650",
						"655",
						"675"
					],
					"projections_percentage": [
						-12.19,
						0,
						9.56,
						7.08,
						7.91,
						11.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1179
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 1.92,
					"enrolment": 643,
					"ligo": 0.71,
					"location": [
						151.276781114553,
						-33.8888375925686
					],
					"name": "Bondi Beach Public School",
					"playspace": 10.61,
					"projections": [
						384,
						643,
						705,
						690,
						665,
						665
					],
					"projections_orig": [
						"384",
						"643",
						"705",
						"690",
						"665",
						"665"
					],
					"projections_percentage": [
						-40.28,
						0,
						9.64,
						7.31,
						3.42,
						3.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1292
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.7,
					"enrolment": 336,
					"ligo": 0.44,
					"location": [
						151.241062190599,
						-33.8753108010719
					],
					"name": "Double Bay Public School",
					"playspace": 8.33,
					"projections": [
						368,
						336,
						410,
						410,
						415,
						420
					],
					"projections_orig": [
						"368",
						"336",
						"410",
						"410",
						"415",
						"420"
					],
					"projections_percentage": [
						9.52,
						0,
						22.02,
						22.02,
						23.51,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1768
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.3,
					"enrolment": 353,
					"ligo": 0.76,
					"location": [
						151.230041583736,
						-33.8816525094199
					],
					"name": "Glenmore Road Public School",
					"playspace": 10.58,
					"projections": [
						301,
						353,
						385,
						385,
						390,
						415
					],
					"projections_orig": [
						"301",
						"353",
						"385",
						"385",
						"390",
						"415"
					],
					"projections_percentage": [
						-14.73,
						0,
						9.07,
						9.07,
						10.48,
						17.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2009
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 2.26,
					"enrolment": 642,
					"ligo": 0.68,
					"location": [
						151.271017215784,
						-33.8736394820853
					],
					"name": "Rose Bay Public School",
					"playspace": 8.8,
					"projections": [
						556,
						642,
						650,
						630,
						630,
						630
					],
					"projections_orig": [
						"556",
						"642",
						"650",
						"630",
						"630",
						"630"
					],
					"projections_percentage": [
						-13.4,
						0,
						1.25,
						-1.87,
						-1.87,
						-1.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2988
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 13
					},
					"classroomspace": 2.97,
					"enrolment": 381,
					"ligo": 0.86,
					"location": [
						151.281527315039,
						-33.8502885887502
					],
					"name": "Vaucluse Public School",
					"playspace": 25.23,
					"projections": [
						216,
						381,
						340,
						330,
						330,
						330
					],
					"projections_orig": [
						"216",
						"381",
						"340",
						"330",
						"330",
						"330"
					],
					"projections_percentage": [
						-43.31,
						0,
						-10.76,
						-13.39,
						-13.39,
						-13.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3325
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 1.83,
					"enrolment": 592,
					"ligo": 0.71,
					"location": [
						151.264352475637,
						-33.892955334127
					],
					"name": "Bondi Public School",
					"playspace": 10.89,
					"projections": [
						398,
						592,
						610,
						610,
						605,
						620
					],
					"projections_orig": [
						"398",
						"592",
						"610",
						"610",
						"605",
						"620"
					],
					"projections_percentage": [
						-32.77,
						0,
						3.04,
						3.04,
						2.2,
						4.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.42,
					"enrolment": 326,
					"ligo": 0.37,
					"location": [
						151.230412035628,
						-33.8877266900375
					],
					"name": "Paddington Public School",
					"playspace": 5.88,
					"projections": [
						266,
						326,
						330,
						320,
						330,
						355
					],
					"projections_orig": [
						"266",
						"326",
						"330",
						"320",
						"330",
						"355"
					],
					"projections_percentage": [
						-18.4,
						0,
						1.23,
						-1.84,
						1.23,
						8.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7432
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 2.31,
					"enrolment": 788,
					"ligo": 0.62,
					"location": [
						151.241540290263,
						-33.8865503101473
					],
					"name": "Woollahra Public School",
					"playspace": 4.03,
					"projections": [
						647,
						788,
						785,
						765,
						780,
						790
					],
					"projections_orig": [
						"647",
						"788",
						"785",
						"765",
						"780",
						"790"
					],
					"projections_percentage": [
						-17.89,
						0,
						-0.38,
						-2.92,
						-1.02,
						0.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7442
				}
			],
			"uid": 10011
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 196
			},
			"enrolment": 4565,
			"level": "Primary",
			"ligo": 0.63,
			"name": "Randwick Primary",
			"playspace": 20.29,
			"projections": [
				4565,
				4990,
				5155,
				5155,
				5390
			],
			"projections_percentage": [
				0,
				9.31,
				12.92,
				12.92,
				18.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.25,
					"enrolment": 421,
					"ligo": 0.68,
					"location": [
						151.262347991875,
						-33.9004589700813
					],
					"name": "Bronte Public School",
					"playspace": 7.01,
					"projections": [
						369,
						421,
						450,
						440,
						450,
						485
					],
					"projections_orig": [
						"369",
						"421",
						"450",
						"440",
						"450",
						"485"
					],
					"projections_percentage": [
						-12.35,
						0,
						6.89,
						4.51,
						6.89,
						15.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1372
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 26
					},
					"classroomspace": 2.47,
					"enrolment": 601,
					"ligo": 0.75,
					"location": [
						151.260821669587,
						-33.9071881120155
					],
					"name": "Clovelly Public School",
					"playspace": 12.27,
					"projections": [
						515,
						601,
						635,
						630,
						625,
						650
					],
					"projections_orig": [
						"515",
						"601",
						"635",
						"630",
						"625",
						"650"
					],
					"projections_percentage": [
						-14.31,
						0,
						5.66,
						4.83,
						3.99,
						8.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1573
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 23
					},
					"classroomspace": 2.11,
					"enrolment": 621,
					"ligo": 0.74,
					"location": [
						151.249631759227,
						-33.9204968688459
					],
					"name": "Coogee Public School",
					"playspace": 7.22,
					"projections": [
						617,
						621,
						680,
						700,
						685,
						735
					],
					"projections_orig": [
						"617",
						"621",
						"680",
						"700",
						"685",
						"735"
					],
					"projections_percentage": [
						-0.64,
						0,
						9.5,
						12.72,
						10.31,
						18.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1616
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.7,
					"enrolment": 451,
					"ligo": 0.67,
					"location": [
						151.224663933127,
						-33.9091323268954
					],
					"name": "Kensington Public School",
					"playspace": 8.1,
					"projections": [
						396,
						451,
						525,
						585,
						585,
						580
					],
					"projections_orig": [
						"396",
						"451",
						"525",
						"585",
						"585",
						"580"
					],
					"projections_percentage": [
						-12.2,
						0,
						16.41,
						29.71,
						29.71,
						28.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2283
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 19
					},
					"classroomspace": 5.55,
					"enrolment": 447,
					"ligo": 0.62,
					"location": [
						151.236787336296,
						-33.9249308372524
					],
					"name": "Rainbow Street Public School",
					"playspace": 23.83,
					"projections": [
						411,
						447,
						540,
						565,
						570,
						585
					],
					"projections_orig": [
						"411",
						"447",
						"540",
						"565",
						"570",
						"585"
					],
					"projections_percentage": [
						-8.05,
						0,
						20.81,
						26.4,
						27.52,
						30.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2930
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.71,
					"enrolment": 535,
					"ligo": 0.56,
					"location": [
						151.254498904242,
						-33.9336808981312
					],
					"name": "South Coogee Public School",
					"playspace": 21.43,
					"projections": [
						539,
						535,
						620,
						675,
						650,
						670
					],
					"projections_orig": [
						"539",
						"535",
						"620",
						"675",
						"650",
						"670"
					],
					"projections_percentage": [
						0.75,
						0,
						15.89,
						26.17,
						21.5,
						25.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3703
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.52,
					"enrolment": 281,
					"ligo": 0.62,
					"location": [
						151.252097666311,
						-33.8986882162533
					],
					"name": "Waverley Public School",
					"playspace": 24.17,
					"projections": [
						217,
						281,
						255,
						245,
						250,
						275
					],
					"projections_orig": [
						"217",
						"281",
						"255",
						"245",
						"250",
						"275"
					],
					"projections_percentage": [
						-22.78,
						0,
						-9.25,
						-12.81,
						-11.03,
						-2.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3953
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 32
					},
					"classroomspace": 2.4,
					"enrolment": 927,
					"ligo": 0.59,
					"location": [
						151.241433395817,
						-33.9105666952041
					],
					"name": "Randwick Public School",
					"playspace": 8.14,
					"projections": [
						719,
						927,
						950,
						945,
						960,
						1030
					],
					"projections_orig": [
						"719",
						"927",
						"950",
						"945",
						"960",
						"1030"
					],
					"projections_percentage": [
						-22.44,
						0,
						2.48,
						1.94,
						3.56,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4250
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.35,
					"enrolment": 281,
					"ligo": 0.41,
					"location": [
						151.228465528834,
						-33.9288804877056
					],
					"name": "Daceyville Public School",
					"playspace": 70.46,
					"projections": [
						242,
						281,
						335,
						370,
						380,
						380
					],
					"projections_orig": [
						"242",
						"281",
						"335",
						"370",
						"380",
						"380"
					],
					"projections_percentage": [
						-13.88,
						0,
						19.22,
						31.67,
						35.23,
						35.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7413
				}
			],
			"uid": 10012
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 100
			},
			"enrolment": 1941,
			"level": "Primary",
			"ligo": 0.54,
			"name": "Maroubra Primary",
			"playspace": 253.34,
			"projections": [
				1941,
				2400,
				2790,
				2820,
				2790
			],
			"projections_percentage": [
				0,
				23.65,
				43.74,
				45.29,
				43.74
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 28.94,
					"enrolment": 26,
					"ligo": 0.54,
					"location": [
						151.235668132664,
						-33.9794855157581
					],
					"name": "La Perouse Public School",
					"playspace": 1407.79,
					"projections": [
						47,
						26,
						60,
						70,
						70,
						70
					],
					"projections_orig": [
						"47",
						"26",
						"60",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						80.77,
						0,
						130.77,
						169.23,
						169.23,
						169.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2373
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 6
					},
					"classroomspace": 2.63,
					"enrolment": 303,
					"ligo": 0.39,
					"location": [
						151.248546484368,
						-33.9614897343349
					],
					"name": "Malabar Public School",
					"playspace": 24.97,
					"projections": [
						259,
						303,
						355,
						435,
						430,
						420
					],
					"projections_orig": [
						"259",
						"303",
						"355",
						"435",
						"430",
						"420"
					],
					"projections_percentage": [
						-14.52,
						0,
						17.16,
						43.56,
						41.91,
						38.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2454
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.83,
					"enrolment": 329,
					"ligo": 0.74,
					"location": [
						151.2531786247,
						-33.943900767357
					],
					"name": "Maroubra Bay Public School",
					"playspace": 56.43,
					"projections": [
						188,
						329,
						365,
						410,
						405,
						400
					],
					"projections_orig": [
						"188",
						"329",
						"365",
						"410",
						"405",
						"400"
					],
					"projections_percentage": [
						-42.86,
						0,
						10.94,
						24.62,
						23.1,
						21.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2482
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 4.4,
					"enrolment": 226,
					"ligo": 0.78,
					"location": [
						151.22999838766,
						-33.9551052755874
					],
					"name": "Matraville Public School",
					"playspace": 51.04,
					"projections": [
						201,
						226,
						300,
						365,
						400,
						405
					],
					"projections_orig": [
						"201",
						"226",
						"300",
						"365",
						"400",
						"405"
					],
					"projections_percentage": [
						-11.06,
						0,
						32.74,
						61.5,
						76.99,
						79.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2502
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.04,
					"enrolment": 228,
					"ligo": 0.26,
					"location": [
						151.23955238238,
						-33.9575223244423
					],
					"name": "Matraville Soldiers Settlement Public School",
					"playspace": 26.42,
					"projections": [
						217,
						228,
						285,
						330,
						330,
						325
					],
					"projections_orig": [
						"217",
						"228",
						"285",
						"330",
						"330",
						"325"
					],
					"projections_percentage": [
						-4.82,
						0,
						25,
						44.74,
						44.74,
						42.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4067
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 3.86,
					"enrolment": 169,
					"ligo": 0.45,
					"location": [
						151.242692501035,
						-33.9662213938743
					],
					"name": "Chifley Public School",
					"playspace": 186.6,
					"projections": [
						230,
						169,
						230,
						270,
						270,
						260
					],
					"projections_orig": [
						"230",
						"169",
						"230",
						"270",
						"270",
						"260"
					],
					"projections_percentage": [
						36.09,
						0,
						36.09,
						59.76,
						59.76,
						53.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4299
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 26
					},
					"classroomspace": 2.58,
					"enrolment": 660,
					"ligo": 0.65,
					"location": [
						151.239728856488,
						-33.9370270595463
					],
					"name": "Maroubra Junction Public School",
					"playspace": 20.11,
					"projections": [
						570,
						660,
						805,
						910,
						915,
						910
					],
					"projections_orig": [
						"570",
						"660",
						"805",
						"910",
						"915",
						"910"
					],
					"projections_percentage": [
						-13.64,
						0,
						21.97,
						37.88,
						38.64,
						37.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7427
				}
			],
			"uid": 10013
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 65
			},
			"enrolment": 1343,
			"level": "Primary",
			"ligo": 0.59,
			"name": "Botany Primary",
			"playspace": 62.94,
			"projections": [
				1343,
				1760,
				2090,
				2320,
				2390
			],
			"projections_percentage": [
				0,
				31.05,
				55.62,
				72.75,
				77.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 11
					},
					"classroomspace": 2.87,
					"enrolment": 270,
					"ligo": 0.46,
					"location": [
						151.206758012382,
						-33.9529246419934
					],
					"name": "Banksmeadow Public School",
					"playspace": 80.44,
					"projections": [
						262,
						270,
						330,
						400,
						440,
						435
					],
					"projections_orig": [
						"262",
						"270",
						"330",
						"400",
						"440",
						"435"
					],
					"projections_percentage": [
						-2.96,
						0,
						22.22,
						48.15,
						62.96,
						61.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1121
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.44,
					"enrolment": 284,
					"ligo": 0.62,
					"location": [
						151.195347229319,
						-33.942844983843
					],
					"name": "Botany Public School",
					"playspace": 50.39,
					"projections": [
						194,
						284,
						355,
						420,
						475,
						460
					],
					"projections_orig": [
						"194",
						"284",
						"355",
						"420",
						"475",
						"460"
					],
					"projections_percentage": [
						-31.69,
						0,
						25,
						47.89,
						67.25,
						61.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1323
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.71,
					"enrolment": 350,
					"ligo": 0.5,
					"location": [
						151.192999298401,
						-33.9293430357274
					],
					"name": "Mascot Public School",
					"playspace": 83.28,
					"projections": [
						461,
						350,
						430,
						540,
						615,
						650
					],
					"projections_orig": [
						"461",
						"350",
						"430",
						"540",
						"615",
						"650"
					],
					"projections_percentage": [
						31.71,
						0,
						22.86,
						54.29,
						75.71,
						85.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2499
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 3.01,
					"enrolment": 263,
					"ligo": 0.47,
					"location": [
						151.215012301461,
						-33.9426915649607
					],
					"name": "Pagewood Public School",
					"playspace": 38.38,
					"projections": [
						184,
						263,
						360,
						415,
						450,
						495
					],
					"projections_orig": [
						"184",
						"263",
						"360",
						"415",
						"450",
						"495"
					],
					"projections_percentage": [
						-30.04,
						0,
						36.88,
						57.79,
						71.1,
						88.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3905
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.76,
					"enrolment": 176,
					"ligo": 0.9,
					"location": [
						151.213245859943,
						-33.9278421249237
					],
					"name": "Eastlakes Public School",
					"playspace": 62.19,
					"projections": [
						211,
						176,
						285,
						315,
						340,
						350
					],
					"projections_orig": [
						"211",
						"176",
						"285",
						"315",
						"340",
						"350"
					],
					"projections_percentage": [
						19.89,
						0,
						61.93,
						78.98,
						93.18,
						98.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4516
				}
			],
			"uid": 10014
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 165
			},
			"enrolment": 2129,
			"level": "Primary",
			"ligo": 0.52,
			"name": "Green Square Primary",
			"playspace": 20.42,
			"projections": [
				2847,
				3435,
				4000,
				4275,
				4475
			],
			"projections_percentage": [
				0,
				20.65,
				40.5,
				50.16,
				57.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.05,
					"enrolment": 241,
					"ligo": 0.55,
					"location": [
						151.189640992739,
						-33.8923881515648
					],
					"name": "Darlington Public School",
					"playspace": 13.8,
					"projections": [
						270,
						241,
						315,
						330,
						340,
						340
					],
					"projections_orig": [
						"270",
						"241",
						"315",
						"330",
						"340",
						"340"
					],
					"projections_percentage": [
						12.03,
						0,
						30.71,
						36.93,
						41.08,
						41.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.68,
					"enrolment": 380,
					"ligo": 0.59,
					"location": [
						151.186309677469,
						-33.9008383609057
					],
					"name": "Erskineville Public School",
					"playspace": 15.17,
					"projections": [
						334,
						380,
						435,
						465,
						470,
						475
					],
					"projections_orig": [
						"334",
						"380",
						"435",
						"465",
						"470",
						"475"
					],
					"projections_percentage": [
						-12.11,
						0,
						14.47,
						22.37,
						23.68,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4147
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 1.48,
					"enrolment": 430,
					"ligo": 0.61,
					"location": [
						151.2149369965,
						-33.8904205974704
					],
					"name": "Bourke Street Public School",
					"playspace": 6.37,
					"projections": [
						137,
						430,
						450,
						475,
						480,
						485
					],
					"projections_orig": [
						"137",
						"430",
						"450",
						"475",
						"480",
						"485"
					],
					"projections_percentage": [
						-68.14,
						0,
						4.65,
						10.47,
						11.63,
						12.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.86,
					"enrolment": 360,
					"ligo": 0.42,
					"location": [
						151.197909720288,
						-33.9215401934209
					],
					"name": "Gardeners Road Public School",
					"playspace": 38.75,
					"projections": [
						268,
						360,
						505,
						620,
						685,
						705
					],
					"projections_orig": [
						"268",
						"360",
						"505",
						"620",
						"685",
						"705"
					],
					"projections_percentage": [
						-25.56,
						0,
						40.28,
						72.22,
						90.28,
						95.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7418
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 48
					},
					"classroomspace": 4.85,
					"enrolment": 371,
					"ligo": 0.46,
					"location": [
						151.195595971057,
						-33.9013345944937
					],
					"name": "Alexandria Park Community School",
					"playspace": 23.4,
					"projections": [
						397,
						397,
						718,
						718,
						865,
						865,
						1055,
						1055,
						1150,
						1150,
						1235,
						1235
					],
					"projections_orig": [
						"397",
						"397",
						"718",
						"718",
						"865",
						"865",
						"1055",
						"1055",
						"1150",
						"1150",
						"1235",
						"1235"
					],
					"projections_percentage": [
						0,
						0,
						80.86,
						80.86,
						117.88,
						117.88,
						165.74,
						165.74,
						189.67,
						189.67,
						211.08,
						211.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8556
				}
			],
			"uid": 10015
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 165
			},
			"enrolment": 2129,
			"level": "Secondary",
			"ligo": 0.52,
			"name": "Green Square Primary",
			"playspace": 20.42,
			"projections": [
				2847,
				3435,
				4000,
				4275,
				4475
			],
			"projections_percentage": [
				0,
				20.65,
				40.5,
				50.16,
				57.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.05,
					"enrolment": 241,
					"ligo": 0.55,
					"location": [
						151.189640992739,
						-33.8923881515648
					],
					"name": "Darlington Public School",
					"playspace": 13.8,
					"projections": [
						270,
						241,
						315,
						330,
						340,
						340
					],
					"projections_orig": [
						"270",
						"241",
						"315",
						"330",
						"340",
						"340"
					],
					"projections_percentage": [
						12.03,
						0,
						30.71,
						36.93,
						41.08,
						41.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.68,
					"enrolment": 380,
					"ligo": 0.59,
					"location": [
						151.186309677469,
						-33.9008383609057
					],
					"name": "Erskineville Public School",
					"playspace": 15.17,
					"projections": [
						334,
						380,
						435,
						465,
						470,
						475
					],
					"projections_orig": [
						"334",
						"380",
						"435",
						"465",
						"470",
						"475"
					],
					"projections_percentage": [
						-12.11,
						0,
						14.47,
						22.37,
						23.68,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4147
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 1.48,
					"enrolment": 430,
					"ligo": 0.61,
					"location": [
						151.2149369965,
						-33.8904205974704
					],
					"name": "Bourke Street Public School",
					"playspace": 6.37,
					"projections": [
						137,
						430,
						450,
						475,
						480,
						485
					],
					"projections_orig": [
						"137",
						"430",
						"450",
						"475",
						"480",
						"485"
					],
					"projections_percentage": [
						-68.14,
						0,
						4.65,
						10.47,
						11.63,
						12.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.86,
					"enrolment": 360,
					"ligo": 0.42,
					"location": [
						151.197909720288,
						-33.9215401934209
					],
					"name": "Gardeners Road Public School",
					"playspace": 38.75,
					"projections": [
						268,
						360,
						505,
						620,
						685,
						705
					],
					"projections_orig": [
						"268",
						"360",
						"505",
						"620",
						"685",
						"705"
					],
					"projections_percentage": [
						-25.56,
						0,
						40.28,
						72.22,
						90.28,
						95.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7418
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 48
					},
					"classroomspace": 4.85,
					"enrolment": 371,
					"ligo": 0.46,
					"location": [
						151.195595971057,
						-33.9013345944937
					],
					"name": "Alexandria Park Community School",
					"playspace": 23.4,
					"projections": [
						397,
						397,
						718,
						718,
						865,
						865,
						1055,
						1055,
						1150,
						1150,
						1235,
						1235
					],
					"projections_orig": [
						"397",
						"397",
						"718",
						"718",
						"865",
						"865",
						"1055",
						"1055",
						"1150",
						"1150",
						"1235",
						"1235"
					],
					"projections_percentage": [
						0,
						0,
						80.86,
						80.86,
						117.88,
						117.88,
						165.74,
						165.74,
						189.67,
						189.67,
						211.08,
						211.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8556
				}
			],
			"uid": 10015
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 73
			},
			"enrolment": 1701,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Inner City Primary",
			"playspace": 20.99,
			"projections": [
				1701,
				2050,
				2205,
				2245,
				2310
			],
			"projections_percentage": [
				0,
				20.52,
				29.63,
				31.98,
				35.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 1.92,
					"enrolment": 344,
					"ligo": 0.61,
					"location": [
						151.181060188296,
						-33.8824323394974
					],
					"name": "Forest Lodge Public School",
					"playspace": 9.26,
					"projections": [
						314,
						344,
						395,
						435,
						425,
						415
					],
					"projections_orig": [
						"314",
						"344",
						"395",
						"435",
						"425",
						"415"
					],
					"projections_percentage": [
						-8.72,
						0,
						14.83,
						26.45,
						23.55,
						20.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1932
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 1.37,
					"enrolment": 193,
					"ligo": 0.58,
					"location": [
						151.205273419505,
						-33.8604766978692
					],
					"name": "Fort Street Public School",
					"playspace": 10.02,
					"projections": [
						97,
						193,
						210,
						235,
						255,
						275
					],
					"projections_orig": [
						"97",
						"193",
						"210",
						"235",
						"255",
						"275"
					],
					"projections_percentage": [
						-49.74,
						0,
						8.81,
						21.76,
						32.12,
						42.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1937
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 3.44,
					"enrolment": 279,
					"ligo": 0.92,
					"location": [
						151.195820650611,
						-33.8772844491475
					],
					"name": "Ultimo Public School",
					"playspace": 8.63,
					"projections": [
						287,
						279,
						400,
						430,
						445,
						460
					],
					"projections_orig": [
						"287",
						"279",
						"400",
						"430",
						"445",
						"460"
					],
					"projections_percentage": [
						2.87,
						0,
						43.37,
						54.12,
						59.5,
						64.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3305
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.39,
					"enrolment": 280,
					"ligo": 0.6,
					"location": [
						151.215446699665,
						-33.8820573301366
					],
					"name": "Crown Street Public School",
					"playspace": 8.92,
					"projections": [
						292,
						280,
						350,
						370,
						380,
						400
					],
					"projections_orig": [
						"292",
						"280",
						"350",
						"370",
						"380",
						"400"
					],
					"projections_percentage": [
						4.29,
						0,
						25,
						32.14,
						35.71,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3935
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.37,
					"enrolment": 35,
					"ligo": 0.8,
					"location": [
						151.220913133045,
						-33.8707612263727
					],
					"name": "Plunkett Street Public School",
					"playspace": 91.19,
					"projections": [
						60,
						35,
						55,
						60,
						65,
						70
					],
					"projections_orig": [
						"60",
						"35",
						"55",
						"60",
						"65",
						"70"
					],
					"projections_percentage": [
						71.43,
						0,
						57.14,
						71.43,
						85.71,
						100
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4551
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.43,
					"enrolment": 311,
					"ligo": 0.52,
					"location": [
						151.223312462447,
						-33.8782482488838
					],
					"name": "Darlinghurst Public School",
					"playspace": 7.29,
					"projections": [
						220,
						311,
						360,
						375,
						385,
						400
					],
					"projections_orig": [
						"220",
						"311",
						"360",
						"375",
						"385",
						"400"
					],
					"projections_percentage": [
						-29.26,
						0,
						15.76,
						20.58,
						23.79,
						28.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7414
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.03,
					"enrolment": 259,
					"ligo": 0.7,
					"location": [
						151.191171379351,
						-33.8837410248622
					],
					"name": "Glebe Public School",
					"playspace": 11.65,
					"projections": [
						139,
						259,
						280,
						300,
						290,
						290
					],
					"projections_orig": [
						"139",
						"259",
						"280",
						"300",
						"290",
						"290"
					],
					"projections_percentage": [
						-46.33,
						0,
						8.11,
						15.83,
						11.97,
						11.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7419
				}
			],
			"uid": 10016
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 69
			},
			"enrolment": 1478,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Newtown Primary",
			"playspace": 42.35,
			"projections": [
				1478,
				1555,
				1595,
				1645,
				1675
			],
			"projections_percentage": [
				0,
				5.21,
				7.92,
				11.3,
				13.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.15,
					"enrolment": 264,
					"ligo": 0.66,
					"location": [
						151.175783974597,
						-33.9062078048056
					],
					"name": "Camdenville Public School",
					"playspace": 35.39,
					"projections": [
						235,
						264,
						260,
						265,
						275,
						280
					],
					"projections_orig": [
						"235",
						"264",
						"260",
						"265",
						"275",
						"280"
					],
					"projections_percentage": [
						-10.98,
						0,
						-1.52,
						0.38,
						4.17,
						6.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1483
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.51,
					"enrolment": 284,
					"ligo": 0.56,
					"location": [
						151.185911055226,
						-33.8919747278783
					],
					"name": "Newtown North Public School",
					"playspace": 13.36,
					"projections": [
						263,
						284,
						285,
						300,
						310,
						310
					],
					"projections_orig": [
						"263",
						"284",
						"285",
						"300",
						"310",
						"310"
					],
					"projections_percentage": [
						-7.39,
						0,
						0.35,
						5.63,
						9.15,
						9.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2744
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 4.14,
					"enrolment": 90,
					"ligo": 0.72,
					"location": [
						151.177959625748,
						-33.9127874358669
					],
					"name": "St Peters Public School",
					"playspace": 151.9,
					"projections": [
						60,
						90,
						90,
						95,
						100,
						105
					],
					"projections_orig": [
						"60",
						"90",
						"90",
						"95",
						"100",
						"105"
					],
					"projections_percentage": [
						-33.33,
						0,
						0,
						5.56,
						11.11,
						16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3032
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.85,
					"enrolment": 321,
					"ligo": 0.65,
					"location": [
						151.161506806585,
						-33.9201726114034
					],
					"name": "Tempe Public School",
					"playspace": 34.66,
					"projections": [
						231,
						321,
						335,
						345,
						365,
						380
					],
					"projections_orig": [
						"231",
						"321",
						"335",
						"345",
						"365",
						"380"
					],
					"projections_percentage": [
						-28.04,
						0,
						4.36,
						7.48,
						13.71,
						18.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3948
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.85,
					"enrolment": 123,
					"ligo": 1,
					"location": [
						151.177886816808,
						-33.8957216390437
					],
					"name": "Australia Street Infants School",
					"playspace": 9.85,
					"projections": [
						136,
						123,
						135,
						140,
						140,
						140
					],
					"projections_orig": [
						"136",
						"123",
						"135",
						"140",
						"140",
						"140"
					],
					"projections_percentage": [
						10.57,
						0,
						9.76,
						13.82,
						13.82,
						13.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5104
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 9
					},
					"classroomspace": 2.29,
					"enrolment": 396,
					"ligo": 0.6,
					"location": [
						151.179373167956,
						-33.8998552806166
					],
					"name": "Newtown Public School",
					"playspace": 8.93,
					"projections": [
						295,
						396,
						450,
						450,
						455,
						460
					],
					"projections_orig": [
						"295",
						"396",
						"450",
						"450",
						"455",
						"460"
					],
					"projections_percentage": [
						-25.51,
						0,
						13.64,
						13.64,
						14.9,
						16.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7431
				}
			],
			"uid": 10017
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 194
			},
			"enrolment": 4708,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Orange Grove Primary",
			"playspace": 15.66,
			"projections": [
				4708,
				4720,
				4870,
				5145,
				5140
			],
			"projections_percentage": [
				0,
				0.25,
				3.44,
				9.28,
				9.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.34,
					"enrolment": 418,
					"ligo": 0.73,
					"location": [
						151.168868767707,
						-33.8858905217732
					],
					"name": "Annandale Public School",
					"playspace": 13.79,
					"projections": [
						400,
						418,
						430,
						440,
						455,
						455
					],
					"projections_orig": [
						"400",
						"418",
						"430",
						"440",
						"455",
						"455"
					],
					"projections_percentage": [
						-4.31,
						0,
						2.87,
						5.26,
						8.85,
						8.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1041
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.38,
					"enrolment": 401,
					"ligo": 0.63,
					"location": [
						151.172058507888,
						-33.878029649028
					],
					"name": "Annandale North Public School",
					"playspace": 6.28,
					"projections": [
						415,
						401,
						470,
						520,
						555,
						555
					],
					"projections_orig": [
						"415",
						"401",
						"470",
						"520",
						"555",
						"555"
					],
					"projections_percentage": [
						3.49,
						0,
						17.21,
						29.68,
						38.4,
						38.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1042
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.17,
					"enrolment": 368,
					"ligo": 0.74,
					"location": [
						151.176486282558,
						-33.8529271000012
					],
					"name": "Birchgrove Public School",
					"playspace": 10.11,
					"projections": [
						392,
						368,
						360,
						360,
						365,
						360
					],
					"projections_orig": [
						"392",
						"368",
						"360",
						"360",
						"365",
						"360"
					],
					"projections_percentage": [
						6.52,
						0,
						-2.17,
						-2.17,
						-0.82,
						-2.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1240
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 2.52,
					"enrolment": 634,
					"ligo": 0.24,
					"location": [
						151.134993595091,
						-33.8795425615584
					],
					"name": "Haberfield Public School",
					"playspace": 14.76,
					"projections": [
						600,
						634,
						670,
						690,
						740,
						720
					],
					"projections_orig": [
						"600",
						"634",
						"670",
						"690",
						"740",
						"720"
					],
					"projections_percentage": [
						-5.36,
						0,
						5.68,
						8.83,
						16.72,
						13.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2117
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.88,
					"enrolment": 336,
					"ligo": 0.59,
					"location": [
						151.147436221457,
						-33.8865327586997
					],
					"name": "Kegworth Public School",
					"playspace": 30.73,
					"projections": [
						310,
						336,
						335,
						345,
						350,
						350
					],
					"projections_orig": [
						"310",
						"336",
						"335",
						"345",
						"350",
						"350"
					],
					"projections_percentage": [
						-7.74,
						0,
						-0.3,
						2.68,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2270
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.9,
					"enrolment": 170,
					"ligo": 0.48,
					"location": [
						151.192792525038,
						-33.8560846728761
					],
					"name": "Nicholson Street Public School",
					"playspace": 16.08,
					"projections": [
						160,
						170,
						170,
						175,
						180,
						180
					],
					"projections_orig": [
						"160",
						"170",
						"170",
						"175",
						"180",
						"180"
					],
					"projections_percentage": [
						-5.88,
						0,
						0,
						2.94,
						5.88,
						5.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2749
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.04,
					"enrolment": 429,
					"ligo": 0.86,
					"location": [
						151.158624498632,
						-33.8727127893945
					],
					"name": "Orange Grove Public School",
					"playspace": 27.53,
					"projections": [
						240,
						429,
						380,
						380,
						430,
						430
					],
					"projections_orig": [
						"240",
						"429",
						"380",
						"380",
						"430",
						"430"
					],
					"projections_percentage": [
						-44.06,
						0,
						-11.42,
						-11.42,
						0.23,
						0.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2812
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 8
					},
					"classroomspace": 3.14,
					"enrolment": 242,
					"ligo": 0.51,
					"location": [
						151.140251329795,
						-33.8746976547612
					],
					"name": "Dobroyd Point Public School",
					"playspace": 24.51,
					"projections": [
						244,
						242,
						260,
						265,
						275,
						275
					],
					"projections_orig": [
						"244",
						"242",
						"260",
						"265",
						"275",
						"275"
					],
					"projections_percentage": [
						0.83,
						0,
						7.44,
						9.5,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3873
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 1.99,
					"enrolment": 341,
					"ligo": 0.61,
					"location": [
						151.183686919397,
						-33.8590603875269
					],
					"name": "Balmain Public School",
					"playspace": 4.75,
					"projections": [
						223,
						341,
						315,
						335,
						345,
						340
					],
					"projections_orig": [
						"223",
						"341",
						"315",
						"335",
						"345",
						"340"
					],
					"projections_percentage": [
						-34.6,
						0,
						-7.62,
						-1.76,
						1.17,
						-0.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7404
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.26,
					"enrolment": 730,
					"ligo": 0.55,
					"location": [
						151.157834337243,
						-33.8838365825982
					],
					"name": "Leichhardt Public School",
					"playspace": 10.19,
					"projections": [
						572,
						730,
						715,
						730,
						745,
						745
					],
					"projections_orig": [
						"572",
						"730",
						"715",
						"730",
						"745",
						"745"
					],
					"projections_percentage": [
						-21.64,
						0,
						-2.05,
						0,
						2.05,
						2.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7423
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.35,
					"enrolment": 639,
					"ligo": 0.89,
					"location": [
						151.170144641606,
						-33.8625455347685
					],
					"name": "Rozelle Public School",
					"playspace": 13.57,
					"projections": [
						538,
						639,
						615,
						630,
						705,
						730
					],
					"projections_orig": [
						"538",
						"639",
						"615",
						"630",
						"705",
						"730"
					],
					"projections_percentage": [
						-15.81,
						0,
						-3.76,
						-1.41,
						10.33,
						14.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7435
				}
			],
			"uid": 10018
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 73
			},
			"enrolment": 1915,
			"level": "Primary",
			"ligo": 0.84,
			"name": "Drummoyne Peninsula Primary",
			"playspace": 26.61,
			"projections": [
				1915,
				2125,
				2200,
				2305,
				2380
			],
			"projections_percentage": [
				0,
				10.97,
				14.88,
				20.37,
				24.28
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 17
					},
					"classroomspace": 2.57,
					"enrolment": 639,
					"ligo": 0.81,
					"location": [
						151.129929883859,
						-33.8532607910629
					],
					"name": "Abbotsford Public School",
					"playspace": 24.83,
					"projections": [
						461,
						639,
						625,
						640,
						665,
						680
					],
					"projections_orig": [
						"461",
						"639",
						"625",
						"640",
						"665",
						"680"
					],
					"projections_percentage": [
						-27.86,
						0,
						-2.19,
						0.16,
						4.07,
						6.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1001
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.18,
					"enrolment": 687,
					"ligo": 0.77,
					"location": [
						151.152820412447,
						-33.8556076663427
					],
					"name": "Drummoyne Public School",
					"playspace": 7.72,
					"projections": [
						610,
						687,
						725,
						735,
						760,
						800
					],
					"projections_orig": [
						"610",
						"687",
						"725",
						"735",
						"760",
						"800"
					],
					"projections_percentage": [
						-11.21,
						0,
						5.53,
						6.99,
						10.63,
						16.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1774
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.86,
					"enrolment": 412,
					"ligo": 0.78,
					"location": [
						151.128183003411,
						-33.8670858248609
					],
					"name": "Five Dock Public School",
					"playspace": 28.31,
					"projections": [
						331,
						412,
						435,
						475,
						515,
						525
					],
					"projections_orig": [
						"331",
						"412",
						"435",
						"475",
						"515",
						"525"
					],
					"projections_percentage": [
						-19.66,
						0,
						5.58,
						15.29,
						25,
						27.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1920
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.55,
					"enrolment": 177,
					"ligo": 1,
					"location": [
						151.142922426586,
						-33.8616958448601
					],
					"name": "Russell Lea Public School",
					"playspace": 45.58,
					"projections": [
						146,
						177,
						340,
						350,
						365,
						375
					],
					"projections_orig": [
						"146",
						"177",
						"340",
						"350",
						"365",
						"375"
					],
					"projections_percentage": [
						-17.51,
						0,
						92.09,
						97.74,
						106.21,
						111.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5132
				}
			],
			"uid": 10019
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 87
			},
			"enrolment": 1787,
			"level": "Primary",
			"ligo": 0.54,
			"name": "Marrickville Primary",
			"playspace": 30.83,
			"projections": [
				1787,
				1830,
				1905,
				2070,
				2180
			],
			"projections_percentage": [
				0,
				2.41,
				6.6,
				15.84,
				21.99
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.29,
					"enrolment": 376,
					"ligo": 0.65,
					"location": [
						151.144696642717,
						-33.9141589819501
					],
					"name": "Marrickville West Public School",
					"playspace": 20.95,
					"projections": [
						250,
						376,
						345,
						365,
						410,
						440
					],
					"projections_orig": [
						"250",
						"376",
						"345",
						"365",
						"410",
						"440"
					],
					"projections_percentage": [
						-33.51,
						0,
						-8.24,
						-2.93,
						9.04,
						17.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3951
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 4.36,
					"enrolment": 312,
					"ligo": 0.53,
					"location": [
						151.16233944032,
						-33.9069775300149
					],
					"name": "Marrickville Public School",
					"playspace": 43.26,
					"projections": [
						192,
						312,
						295,
						300,
						325,
						345
					],
					"projections_orig": [
						"192",
						"312",
						"295",
						"300",
						"325",
						"345"
					],
					"projections_percentage": [
						-38.46,
						0,
						-5.45,
						-3.85,
						4.17,
						10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3952
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 20
					},
					"classroomspace": 2.63,
					"enrolment": 654,
					"ligo": 0.48,
					"location": [
						151.156147181195,
						-33.9011959806341
					],
					"name": "Wilkins Public School",
					"playspace": 44.42,
					"projections": [
						589,
						654,
						710,
						735,
						780,
						800
					],
					"projections_orig": [
						"589",
						"654",
						"710",
						"735",
						"780",
						"800"
					],
					"projections_percentage": [
						-9.94,
						0,
						8.56,
						12.39,
						19.27,
						22.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4543
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.54,
					"enrolment": 445,
					"ligo": 0.48,
					"location": [
						151.152268575467,
						-33.9205593154717
					],
					"name": "Ferncourt Public School",
					"playspace": 14.69,
					"projections": [
						385,
						445,
						480,
						505,
						555,
						595
					],
					"projections_orig": [
						"385",
						"445",
						"480",
						"505",
						"555",
						"595"
					],
					"projections_percentage": [
						-13.48,
						0,
						7.87,
						13.48,
						24.72,
						33.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5114
				}
			],
			"uid": 10020
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 105
			},
			"enrolment": 2530,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Inner West Primary",
			"playspace": 18.93,
			"projections": [
				2530,
				2730,
				2885,
				3045,
				3055
			],
			"projections_percentage": [
				0,
				7.91,
				14.03,
				20.36,
				20.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.41,
					"enrolment": 813,
					"ligo": 0.74,
					"location": [
						151.136524255578,
						-33.895551790359
					],
					"name": "Summer Hill Public School",
					"playspace": 9.28,
					"projections": [
						768,
						813,
						895,
						945,
						995,
						965
					],
					"projections_orig": [
						"768",
						"813",
						"895",
						"945",
						"995",
						"965"
					],
					"projections_percentage": [
						-5.54,
						0,
						10.09,
						16.24,
						22.39,
						18.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.28,
					"enrolment": 197,
					"ligo": 0.46,
					"location": [
						151.145741112095,
						-33.8975921716683
					],
					"name": "Lewisham Public School",
					"playspace": 29.91,
					"projections": [
						95,
						197,
						190,
						195,
						205,
						210
					],
					"projections_orig": [
						"95",
						"197",
						"190",
						"195",
						"205",
						"210"
					],
					"projections_percentage": [
						-51.78,
						0,
						-3.55,
						-1.02,
						4.06,
						6.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4369
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 23
					},
					"classroomspace": 2.85,
					"enrolment": 510,
					"ligo": 0.63,
					"location": [
						151.14057334101,
						-33.9057177239983
					],
					"name": "Dulwich Hill Public School",
					"playspace": 17.26,
					"projections": [
						531,
						510,
						595,
						660,
						720,
						735
					],
					"projections_orig": [
						"531",
						"510",
						"595",
						"660",
						"720",
						"735"
					],
					"projections_percentage": [
						4.12,
						0,
						16.67,
						29.41,
						41.18,
						44.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4496
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 6
					},
					"classroomspace": 2.5,
					"enrolment": 256,
					"ligo": 0.57,
					"location": [
						151.150659854346,
						-33.8956637004032
					],
					"name": "Petersham Public School",
					"playspace": 30.92,
					"projections": [
						232,
						256,
						275,
						290,
						300,
						305
					],
					"projections_orig": [
						"232",
						"256",
						"275",
						"290",
						"300",
						"305"
					],
					"projections_percentage": [
						-9.38,
						0,
						7.42,
						13.28,
						17.19,
						19.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4502
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.87,
					"enrolment": 89,
					"ligo": 1,
					"location": [
						151.157437294327,
						-33.8887833440851
					],
					"name": "Taverners Hill Infants School",
					"playspace": 11.93,
					"projections": [
						77,
						89,
						90,
						95,
						95,
						100
					],
					"projections_orig": [
						"77",
						"89",
						"90",
						"95",
						"95",
						"100"
					],
					"projections_percentage": [
						-13.48,
						0,
						1.12,
						6.74,
						6.74,
						12.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5112
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 2.42,
					"enrolment": 665,
					"ligo": 0.7,
					"location": [
						151.165234634111,
						-33.8952392021891
					],
					"name": "Stanmore Public School",
					"playspace": 14.29,
					"projections": [
						543,
						665,
						685,
						700,
						730,
						740
					],
					"projections_orig": [
						"543",
						"665",
						"685",
						"700",
						"730",
						"740"
					],
					"projections_percentage": [
						-18.35,
						0,
						3.01,
						5.26,
						9.77,
						11.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7436
				}
			],
			"uid": 10021
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 177
			},
			"enrolment": 4595,
			"level": "Primary",
			"ligo": 0.64,
			"name": "Burwood Primary",
			"playspace": 18.47,
			"projections": [
				4595,
				5705,
				6730,
				7445,
				7830
			],
			"projections_percentage": [
				0,
				24.16,
				46.46,
				62.02,
				70.4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.64,
					"enrolment": 439,
					"ligo": 0.77,
					"location": [
						151.127747661555,
						-33.8894137929762
					],
					"name": "Ashfield Public School",
					"playspace": 12.13,
					"projections": [
						236,
						439,
						440,
						470,
						500,
						510
					],
					"projections_orig": [
						"236",
						"439",
						"440",
						"470",
						"500",
						"510"
					],
					"projections_percentage": [
						-46.24,
						0,
						0.23,
						7.06,
						13.9,
						16.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1065
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 18
					},
					"classroomspace": 2.95,
					"enrolment": 634,
					"ligo": 0.75,
					"location": [
						151.099026028474,
						-33.8775813593982
					],
					"name": "Burwood Public School",
					"playspace": 18.55,
					"projections": [
						595,
						634,
						845,
						1080,
						1245,
						1380
					],
					"projections_orig": [
						"595",
						"634",
						"845",
						"1080",
						"1245",
						"1380"
					],
					"projections_percentage": [
						-6.15,
						0,
						33.28,
						70.35,
						96.37,
						117.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1455
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.36,
					"enrolment": 280,
					"ligo": 0.5,
					"location": [
						151.093754960803,
						-33.8888615258936
					],
					"name": "Enfield Public School",
					"playspace": 30.99,
					"projections": [
						273,
						280,
						360,
						390,
						415,
						430
					],
					"projections_orig": [
						"273",
						"280",
						"360",
						"390",
						"415",
						"430"
					],
					"projections_percentage": [
						-2.5,
						0,
						28.57,
						39.29,
						48.21,
						53.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1844
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.43,
					"enrolment": 451,
					"ligo": 0.54,
					"location": [
						151.0847963428,
						-33.8673864484321
					],
					"name": "Homebush Public School",
					"playspace": 9.47,
					"projections": [
						462,
						451,
						565,
						765,
						950,
						1015
					],
					"projections_orig": [
						"462",
						"451",
						"565",
						"765",
						"950",
						"1015"
					],
					"projections_percentage": [
						2.44,
						0,
						25.28,
						69.62,
						110.64,
						125.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2173
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 31
					},
					"classroomspace": 2.54,
					"enrolment": 800,
					"ligo": 0.47,
					"location": [
						151.085322805185,
						-33.8907762819474
					],
					"name": "Strathfield South Public School",
					"playspace": 17.86,
					"projections": [
						808,
						800,
						955,
						1060,
						1095,
						1125
					],
					"projections_orig": [
						"808",
						"800",
						"955",
						"1060",
						"1095",
						"1125"
					],
					"projections_percentage": [
						1,
						0,
						19.38,
						32.5,
						36.88,
						40.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3124
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.41,
					"enrolment": 322,
					"ligo": 0.64,
					"location": [
						151.078599736164,
						-33.8749092612902
					],
					"name": "Marie Bashir Public School",
					"playspace": 26.69,
					"projections": [
						0,
						322,
						580,
						655,
						680,
						695
					],
					"projections_orig": [
						"0",
						"322",
						"580",
						"655",
						"680",
						"695"
					],
					"projections_percentage": [
						-100,
						0,
						80.12,
						103.42,
						111.18,
						115.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4652
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 552,
					"ligo": 0.74,
					"location": [
						151.066334856928,
						-33.866204304963
					],
					"name": "Homebush West Public School",
					"playspace": 10.1,
					"projections": [
						389,
						552,
						630,
						790,
						905,
						960
					],
					"projections_orig": [
						"389",
						"552",
						"630",
						"790",
						"905",
						"960"
					],
					"projections_percentage": [
						-29.53,
						0,
						14.13,
						43.12,
						63.95,
						73.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5251
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 24
					},
					"classroomspace": 2.46,
					"enrolment": 695,
					"ligo": 0.78,
					"location": [
						151.115555015904,
						-33.8802211866954
					],
					"name": "Croydon Public School",
					"playspace": 18.71,
					"projections": [
						656,
						695,
						855,
						1015,
						1115,
						1160
					],
					"projections_orig": [
						"656",
						"695",
						"855",
						"1015",
						"1115",
						"1160"
					],
					"projections_percentage": [
						-5.61,
						0,
						23.02,
						46.04,
						60.43,
						66.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7411
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.1,
					"enrolment": 422,
					"ligo": 0.59,
					"location": [
						151.10861312836,
						-33.8941216856458
					],
					"name": "Croydon Park Public School",
					"playspace": 21.76,
					"projections": [
						367,
						422,
						475,
						505,
						540,
						555
					],
					"projections_orig": [
						"367",
						"422",
						"475",
						"505",
						"540",
						"555"
					],
					"projections_percentage": [
						-13.03,
						0,
						12.56,
						19.67,
						27.96,
						31.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7412
				}
			],
			"uid": 10022
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 97
			},
			"enrolment": 1910,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Concord Primary",
			"playspace": 95.96,
			"projections": [
				1910,
				2800,
				3370,
				4030,
				4390
			],
			"projections_percentage": [
				0,
				46.6,
				76.44,
				110.99,
				129.84
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.69,
					"enrolment": 280,
					"ligo": 0.63,
					"location": [
						151.106536361661,
						-33.8636648439982
					],
					"name": "Concord Public School",
					"playspace": 26.38,
					"projections": [
						246,
						280,
						345,
						405,
						440,
						455
					],
					"projections_orig": [
						"246",
						"280",
						"345",
						"405",
						"440",
						"455"
					],
					"projections_percentage": [
						-12.14,
						0,
						23.21,
						44.64,
						57.14,
						62.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1607
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 3.45,
					"enrolment": 382,
					"ligo": 0.59,
					"location": [
						151.08633141656,
						-33.8400710321112
					],
					"name": "Concord West Public School",
					"playspace": 22.05,
					"projections": [
						421,
						382,
						700,
						775,
						925,
						1050
					],
					"projections_orig": [
						"421",
						"382",
						"700",
						"775",
						"925",
						"1050"
					],
					"projections_percentage": [
						10.21,
						0,
						83.25,
						102.88,
						142.15,
						174.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1608
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 2.28,
					"enrolment": 411,
					"ligo": 0.84,
					"location": [
						151.103390472131,
						-33.8498291660043
					],
					"name": "Mortlake Public School",
					"playspace": 26.98,
					"projections": [
						346,
						411,
						465,
						535,
						595,
						620
					],
					"projections_orig": [
						"346",
						"411",
						"465",
						"535",
						"595",
						"620"
					],
					"projections_percentage": [
						-15.82,
						0,
						13.14,
						30.17,
						44.77,
						50.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2625
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 22
					},
					"classroomspace": 3.02,
					"enrolment": 599,
					"ligo": 0.62,
					"location": [
						151.092696722437,
						-33.8551117117025
					],
					"name": "Strathfield North Public School",
					"playspace": 14.97,
					"projections": [
						643,
						599,
						840,
						895,
						1020,
						1175
					],
					"projections_orig": [
						"643",
						"599",
						"840",
						"895",
						"1020",
						"1175"
					],
					"projections_percentage": [
						7.35,
						0,
						40.23,
						49.42,
						70.28,
						96.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3123
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 7.08,
					"enrolment": 238,
					"ligo": 0.66,
					"location": [
						151.082650235778,
						-33.8488329168886
					],
					"name": "Victoria Avenue Public School",
					"playspace": 389.44,
					"projections": [
						0,
						238,
						450,
						760,
						1050,
						1090
					],
					"projections_orig": [
						"0",
						"238",
						"450",
						"760",
						"1050",
						"1090"
					],
					"projections_percentage": [
						-100,
						0,
						89.08,
						219.33,
						341.18,
						357.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4655
				}
			],
			"uid": 10023
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 175
			},
			"enrolment": 3850,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Canterbury Primary",
			"playspace": 36.88,
			"projections": [
				3850,
				4450,
				5165,
				5690,
				5980
			],
			"projections_percentage": [
				0,
				15.58,
				34.16,
				47.79,
				55.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.14,
					"enrolment": 372,
					"ligo": 0.63,
					"location": [
						151.119412032017,
						-33.8993827698717
					],
					"name": "Ashbury Public School",
					"playspace": 17.79,
					"projections": [
						383,
						372,
						415,
						500,
						535,
						550
					],
					"projections_orig": [
						"383",
						"372",
						"415",
						"500",
						"535",
						"550"
					],
					"projections_percentage": [
						2.96,
						0,
						11.56,
						34.41,
						43.82,
						47.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1064
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 32
					},
					"classroomspace": 2.06,
					"enrolment": 775,
					"ligo": 0.68,
					"location": [
						151.10460939895,
						-33.9121608958901
					],
					"name": "Campsie Public School",
					"playspace": 4.81,
					"projections": [
						689,
						775,
						870,
						1065,
						1195,
						1250
					],
					"projections_orig": [
						"689",
						"775",
						"870",
						"1065",
						"1195",
						"1250"
					],
					"projections_percentage": [
						-11.1,
						0,
						12.26,
						37.42,
						54.19,
						61.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1488
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.46,
					"enrolment": 324,
					"ligo": 0.6,
					"location": [
						151.122951004063,
						-33.9092569466019
					],
					"name": "Canterbury Public School",
					"playspace": 46.23,
					"projections": [
						257,
						324,
						350,
						450,
						525,
						545
					],
					"projections_orig": [
						"257",
						"324",
						"350",
						"450",
						"525",
						"545"
					],
					"projections_percentage": [
						-20.68,
						0,
						8.02,
						38.89,
						62.04,
						68.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1497
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 25
					},
					"classroomspace": 2.75,
					"enrolment": 589,
					"ligo": 0.7,
					"location": [
						151.10904147734,
						-33.9290649356982
					],
					"name": "Clemton Park Public School",
					"playspace": 28.03,
					"projections": [
						612,
						589,
						725,
						795,
						860,
						890
					],
					"projections_orig": [
						"612",
						"589",
						"725",
						"795",
						"860",
						"890"
					],
					"projections_percentage": [
						3.9,
						0,
						23.09,
						34.97,
						46.01,
						51.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1566
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 2.33,
					"enrolment": 661,
					"ligo": 0.47,
					"location": [
						151.123260290432,
						-33.9288031807345
					],
					"name": "Earlwood Public School",
					"playspace": 20.69,
					"projections": [
						630,
						661,
						750,
						820,
						895,
						935
					],
					"projections_orig": [
						"630",
						"661",
						"750",
						"820",
						"895",
						"935"
					],
					"projections_percentage": [
						-4.69,
						0,
						13.46,
						24.05,
						35.4,
						41.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1807
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.07,
					"enrolment": 220,
					"ligo": 0.69,
					"location": [
						151.138890555506,
						-33.9245938640605
					],
					"name": "Undercliffe Public School",
					"playspace": 15.64,
					"projections": [
						155,
						220,
						245,
						270,
						295,
						315
					],
					"projections_orig": [
						"155",
						"220",
						"245",
						"270",
						"295",
						"315"
					],
					"projections_percentage": [
						-29.55,
						0,
						11.36,
						22.73,
						34.09,
						43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3310
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.63,
					"enrolment": 283,
					"ligo": 0.71,
					"location": [
						151.116231011291,
						-33.9173671688228
					],
					"name": "Canterbury South Public School",
					"playspace": 43.76,
					"projections": [
						192,
						283,
						320,
						345,
						375,
						400
					],
					"projections_orig": [
						"192",
						"283",
						"320",
						"345",
						"375",
						"400"
					],
					"projections_percentage": [
						-32.16,
						0,
						13.07,
						21.91,
						32.51,
						41.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 3.06,
					"enrolment": 566,
					"ligo": 0.65,
					"location": [
						151.095124890015,
						-33.90920849144
					],
					"name": "Harcourt Public School",
					"playspace": 20.96,
					"projections": [
						612,
						566,
						685,
						825,
						910,
						995
					],
					"projections_orig": [
						"612",
						"566",
						"685",
						"825",
						"910",
						"995"
					],
					"projections_percentage": [
						8.13,
						0,
						21.02,
						45.76,
						60.78,
						75.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5118
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.31,
					"enrolment": 60,
					"ligo": 1,
					"location": [
						151.129611642504,
						-33.9022432879165
					],
					"name": "Yeo Park Infants School",
					"playspace": 134,
					"projections": [
						81,
						60,
						90,
						95,
						100,
						100
					],
					"projections_orig": [
						"81",
						"60",
						"90",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						35,
						0,
						50,
						58.33,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5120
				}
			],
			"uid": 10024
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 88
			},
			"enrolment": 2682,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Middle Harbour Primary",
			"playspace": 10.42,
			"projections": [
				2682,
				2705,
				2630,
				2610,
				2630
			],
			"projections_percentage": [
				0,
				0.86,
				-1.94,
				-2.68,
				-1.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 21
					},
					"classroomspace": 2.17,
					"enrolment": 655,
					"ligo": 0.73,
					"location": [
						151.231905591634,
						-33.8232263713789
					],
					"name": "Middle Harbour Public School",
					"playspace": 10.18,
					"projections": [
						519,
						655,
						635,
						615,
						610,
						615
					],
					"projections_orig": [
						"519",
						"655",
						"635",
						"615",
						"610",
						"615"
					],
					"projections_percentage": [
						-20.76,
						0,
						-3.05,
						-6.11,
						-6.87,
						-6.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2543
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 33
					},
					"classroomspace": 2.14,
					"enrolment": 995,
					"ligo": 0.73,
					"location": [
						151.21922157852,
						-33.8324876907797
					],
					"name": "Neutral Bay Public School",
					"playspace": 4.56,
					"projections": [
						845,
						995,
						985,
						970,
						970,
						985
					],
					"projections_orig": [
						"845",
						"995",
						"985",
						"970",
						"970",
						"985"
					],
					"projections_percentage": [
						-15.08,
						0,
						-1.01,
						-2.51,
						-2.51,
						-1.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2730
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 5
					},
					"classroomspace": 3.02,
					"enrolment": 313,
					"ligo": 0.71,
					"location": [
						151.242786626574,
						-33.8119567926538
					],
					"name": "Beauty Point Public School",
					"playspace": 18.12,
					"projections": [
						271,
						313,
						330,
						320,
						315,
						315
					],
					"projections_orig": [
						"271",
						"313",
						"330",
						"320",
						"315",
						"315"
					],
					"projections_percentage": [
						-13.42,
						0,
						5.43,
						2.24,
						0.64,
						0.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5212
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 2.48,
					"enrolment": 719,
					"ligo": 0.86,
					"location": [
						151.240738170793,
						-33.8275977069646
					],
					"name": "Mosman Public School",
					"playspace": 8.8,
					"projections": [
						695,
						719,
						755,
						725,
						715,
						715
					],
					"projections_orig": [
						"695",
						"719",
						"755",
						"725",
						"715",
						"715"
					],
					"projections_percentage": [
						-3.34,
						0,
						5.01,
						0.83,
						-0.56,
						-0.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7430
				}
			],
			"uid": 10025
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 95
			},
			"enrolment": 2817,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Lane Cove Primary",
			"playspace": 20.59,
			"projections": [
				2817,
				3145,
				3320,
				3520,
				3700
			],
			"projections_percentage": [
				0,
				11.64,
				17.86,
				24.96,
				31.35
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 10
					},
					"classroomspace": 2.94,
					"enrolment": 486,
					"ligo": 0.76,
					"location": [
						151.183355706403,
						-33.8257287627576
					],
					"name": "Greenwich Public School",
					"playspace": 39.47,
					"projections": [
						432,
						486,
						595,
						605,
						635,
						680
					],
					"projections_orig": [
						"432",
						"486",
						"595",
						"605",
						"635",
						"680"
					],
					"projections_percentage": [
						-11.11,
						0,
						22.43,
						24.49,
						30.66,
						39.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2076
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 37
					},
					"classroomspace": 2.41,
					"enrolment": 851,
					"ligo": 0.83,
					"location": [
						151.169114562966,
						-33.8158164070545
					],
					"name": "Lane Cove Public School",
					"playspace": 14.45,
					"projections": [
						815,
						851,
						965,
						995,
						1040,
						1085
					],
					"projections_orig": [
						"815",
						"851",
						"965",
						"995",
						"1040",
						"1085"
					],
					"projections_percentage": [
						-4.23,
						0,
						13.4,
						16.92,
						22.21,
						27.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2368
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 29
					},
					"classroomspace": 1.91,
					"enrolment": 894,
					"ligo": 0.86,
					"location": [
						151.202417879362,
						-33.8346858680164
					],
					"name": "North Sydney Public School",
					"playspace": 13.38,
					"projections": [
						709,
						894,
						940,
						1055,
						1145,
						1180
					],
					"projections_orig": [
						"709",
						"894",
						"940",
						"1055",
						"1145",
						"1180"
					],
					"projections_percentage": [
						-20.69,
						0,
						5.15,
						18.01,
						28.08,
						31.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2766
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 19
					},
					"classroomspace": 2.39,
					"enrolment": 586,
					"ligo": 0.6,
					"location": [
						151.151472732228,
						-33.8100777932264
					],
					"name": "Lane Cove West Public School",
					"playspace": 15.05,
					"projections": [
						533,
						586,
						645,
						665,
						700,
						755
					],
					"projections_orig": [
						"533",
						"586",
						"645",
						"665",
						"700",
						"755"
					],
					"projections_percentage": [
						-9.04,
						0,
						10.07,
						13.48,
						19.45,
						28.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3908
				}
			],
			"uid": 10026
		},
		{
			"classrooms": {
				"demountable": 73,
				"permanent": 356
			},
			"enrolment": 9213,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Chatswood Primary",
			"playspace": 18.66,
			"projections": [
				9213,
				10050,
				10305,
				10585,
				10945
			],
			"projections_percentage": [
				0,
				9.08,
				11.85,
				14.89,
				18.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 35
					},
					"classroomspace": 2.58,
					"enrolment": 1145,
					"ligo": 0.8,
					"location": [
						151.185863931389,
						-33.8107887531249
					],
					"name": "Artarmon Public School",
					"playspace": 5.5,
					"projections": [
						858,
						1145,
						1205,
						1220,
						1245,
						1280
					],
					"projections_orig": [
						"858",
						"1145",
						"1205",
						"1220",
						"1245",
						"1280"
					],
					"projections_percentage": [
						-25.07,
						0,
						5.24,
						6.55,
						8.73,
						11.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1061
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 27
					},
					"classroomspace": 2.35,
					"enrolment": 935,
					"ligo": 0.84,
					"location": [
						151.21181143356,
						-33.821205875267
					],
					"name": "Cammeray Public School",
					"playspace": 7.7,
					"projections": [
						767,
						935,
						710,
						690,
						705,
						740
					],
					"projections_orig": [
						"767",
						"935",
						"710",
						"690",
						"705",
						"740"
					],
					"projections_percentage": [
						-17.97,
						0,
						-24.06,
						-26.2,
						-24.6,
						-20.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1485
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.42,
					"enrolment": 765,
					"ligo": 0.8,
					"location": [
						151.169423327822,
						-33.7805072907259
					],
					"name": "Lindfield Public School",
					"playspace": 14.11,
					"projections": [
						729,
						765,
						835,
						875,
						895,
						920
					],
					"projections_orig": [
						"729",
						"765",
						"835",
						"875",
						"895",
						"920"
					],
					"projections_percentage": [
						-4.71,
						0,
						9.15,
						14.38,
						16.99,
						20.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2403
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.38,
					"enrolment": 722,
					"ligo": 0.78,
					"location": [
						151.18455170918,
						-33.7680569621218
					],
					"name": "Lindfield East Public School",
					"playspace": 24.58,
					"projections": [
						738,
						722,
						860,
						880,
						885,
						900
					],
					"projections_orig": [
						"738",
						"722",
						"860",
						"880",
						"885",
						"900"
					],
					"projections_percentage": [
						2.22,
						0,
						19.11,
						21.88,
						22.58,
						24.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2404
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 2.44,
					"enrolment": 540,
					"ligo": 0.84,
					"location": [
						151.219018365301,
						-33.8121990897143
					],
					"name": "Northbridge Public School",
					"playspace": 11.76,
					"projections": [
						535,
						540,
						575,
						590,
						605,
						630
					],
					"projections_orig": [
						"535",
						"540",
						"575",
						"590",
						"605",
						"630"
					],
					"projections_percentage": [
						-0.93,
						0,
						6.48,
						9.26,
						12.04,
						16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2761
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 2.59,
					"enrolment": 615,
					"ligo": 0.92,
					"location": [
						151.18852927863,
						-33.7815218655458
					],
					"name": "Roseville Public School",
					"playspace": 13.65,
					"projections": [
						568,
						615,
						735,
						745,
						760,
						785
					],
					"projections_orig": [
						"568",
						"615",
						"735",
						"745",
						"760",
						"785"
					],
					"projections_percentage": [
						-7.64,
						0,
						19.51,
						21.14,
						23.58,
						27.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2994
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 34
					},
					"classroomspace": 2.44,
					"enrolment": 1085,
					"ligo": 0.92,
					"location": [
						151.200784769196,
						-33.8018810533138
					],
					"name": "Willoughby Public School",
					"playspace": 8.16,
					"projections": [
						939,
						1085,
						1225,
						1255,
						1295,
						1345
					],
					"projections_orig": [
						"939",
						"1085",
						"1225",
						"1255",
						"1295",
						"1345"
					],
					"projections_percentage": [
						-13.46,
						0,
						12.9,
						15.67,
						19.35,
						23.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3449
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 11
					},
					"classroomspace": 2.64,
					"enrolment": 446,
					"ligo": 0.79,
					"location": [
						151.148832520504,
						-33.7658255351927
					],
					"name": "Killara Public School",
					"playspace": 21.98,
					"projections": [
						282,
						446,
						430,
						470,
						485,
						485
					],
					"projections_orig": [
						"282",
						"446",
						"430",
						"470",
						"485",
						"485"
					],
					"projections_percentage": [
						-36.77,
						0,
						-3.59,
						5.38,
						8.74,
						8.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3918
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.77,
					"enrolment": 471,
					"ligo": 0.79,
					"location": [
						151.202378147964,
						-33.7831699555336
					],
					"name": "Castle Cove Public School",
					"playspace": 31.59,
					"projections": [
						465,
						471,
						565,
						575,
						585,
						605
					],
					"projections_orig": [
						"465",
						"471",
						"565",
						"575",
						"585",
						"605"
					],
					"projections_percentage": [
						-1.27,
						0,
						19.96,
						22.08,
						24.2,
						28.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3919
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.82,
					"enrolment": 415,
					"ligo": 0.83,
					"location": [
						151.145694284021,
						-33.7749000338003
					],
					"name": "Beaumont Road Public School",
					"playspace": 33.98,
					"projections": [
						372,
						415,
						465,
						480,
						490,
						495
					],
					"projections_orig": [
						"372",
						"415",
						"465",
						"480",
						"490",
						"495"
					],
					"projections_percentage": [
						-10.36,
						0,
						12.05,
						15.66,
						18.07,
						19.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3956
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 4.41,
					"enrolment": 511,
					"ligo": 0.7,
					"location": [
						151.154788425904,
						-33.8043293941286
					],
					"name": "Mowbray Public School",
					"playspace": 49.62,
					"projections": [
						327,
						511,
						505,
						525,
						550,
						580
					],
					"projections_orig": [
						"327",
						"511",
						"505",
						"525",
						"550",
						"580"
					],
					"projections_percentage": [
						-36.01,
						0,
						-1.17,
						2.74,
						7.63,
						13.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4015
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 7.57,
					"enrolment": 317,
					"ligo": 0.85,
					"location": [
						151.2099198,
						-33.8261132
					],
					"name": "Anzac Park Public School",
					"playspace": 17.03,
					"projections": [
						0,
						317,
						720,
						760,
						800,
						855
					],
					"projections_orig": [
						"0",
						"317",
						"720",
						"760",
						"800",
						"855"
					],
					"projections_percentage": [
						-100,
						0,
						127.13,
						139.75,
						152.37,
						169.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4656
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						151.154788425904,
						-33.8043293941286
					],
					"name": "Lindfield Learning Village",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4658
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 33
					},
					"classroomspace": 2.4,
					"enrolment": 1246,
					"ligo": 0.87,
					"location": [
						151.178171883234,
						-33.797784835502
					],
					"name": "Chatswood Public School",
					"playspace": 2.88,
					"projections": [
						823,
						1246,
						1220,
						1240,
						1285,
						1325
					],
					"projections_orig": [
						"823",
						"1246",
						"1220",
						"1240",
						"1285",
						"1325"
					],
					"projections_percentage": [
						-33.95,
						0,
						-2.09,
						-0.48,
						3.13,
						6.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7409
				}
			],
			"uid": 10027
		},
		{
			"classrooms": {
				"demountable": 35,
				"permanent": 210
			},
			"enrolment": 5386,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Ryde Primary",
			"playspace": 30.76,
			"projections": [
				5386,
				5805,
				6385,
				6620,
				6745
			],
			"projections_percentage": [
				0,
				7.78,
				18.55,
				22.91,
				25.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 18
					},
					"classroomspace": 2.46,
					"enrolment": 518,
					"ligo": 0.74,
					"location": [
						151.13590060927,
						-33.8219285536797
					],
					"name": "Boronia Park Public School",
					"playspace": 11.26,
					"projections": [
						392,
						518,
						520,
						555,
						565,
						570
					],
					"projections_orig": [
						"392",
						"518",
						"520",
						"555",
						"565",
						"570"
					],
					"projections_percentage": [
						-24.32,
						0,
						0.39,
						7.14,
						9.07,
						10.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1320
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.48,
					"enrolment": 368,
					"ligo": 0.8,
					"location": [
						151.150881180823,
						-33.8356581387433
					],
					"name": "Hunters Hill Public School",
					"playspace": 16.78,
					"projections": [
						360,
						368,
						370,
						380,
						385,
						385
					],
					"projections_orig": [
						"360",
						"368",
						"370",
						"380",
						"385",
						"385"
					],
					"projections_percentage": [
						-2.17,
						0,
						0.54,
						3.26,
						4.62,
						4.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2189
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 3.25,
					"enrolment": 579,
					"ligo": 0.61,
					"location": [
						151.106515554485,
						-33.8133355488522
					],
					"name": "Ryde Public School",
					"playspace": 39.94,
					"projections": [
						430,
						579,
						625,
						680,
						705,
						720
					],
					"projections_orig": [
						"430",
						"579",
						"625",
						"680",
						"705",
						"720"
					],
					"projections_percentage": [
						-25.73,
						0,
						7.94,
						17.44,
						21.76,
						24.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3021
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 15
					},
					"classroomspace": 2.75,
					"enrolment": 384,
					"ligo": 0.7,
					"location": [
						151.120764622388,
						-33.7941009237394
					],
					"name": "North Ryde Public School",
					"playspace": 56.18,
					"projections": [
						264,
						384,
						360,
						410,
						420,
						425
					],
					"projections_orig": [
						"264",
						"384",
						"360",
						"410",
						"420",
						"425"
					],
					"projections_percentage": [
						-31.25,
						0,
						-6.25,
						6.77,
						9.38,
						10.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3022
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 29
					},
					"classroomspace": 3.09,
					"enrolment": 756,
					"ligo": 0.72,
					"location": [
						151.096094522173,
						-33.7935228065192
					],
					"name": "Denistone East Public School",
					"playspace": 16.89,
					"projections": [
						838,
						756,
						900,
						960,
						990,
						1005
					],
					"projections_orig": [
						"838",
						"756",
						"900",
						"960",
						"990",
						"1005"
					],
					"projections_percentage": [
						10.85,
						0,
						19.05,
						26.98,
						30.95,
						32.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3862
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 15
					},
					"classroomspace": 2.75,
					"enrolment": 484,
					"ligo": 0.75,
					"location": [
						151.095549276911,
						-33.78116460338
					],
					"name": "Eastwood Heights Public School",
					"playspace": 28.02,
					"projections": [
						332,
						484,
						525,
						550,
						555,
						560
					],
					"projections_orig": [
						"332",
						"484",
						"525",
						"550",
						"555",
						"560"
					],
					"projections_percentage": [
						-31.4,
						0,
						8.47,
						13.64,
						14.67,
						15.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4041
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 16
					},
					"classroomspace": 3,
					"enrolment": 637,
					"ligo": 0.6,
					"location": [
						151.10984641685,
						-33.7868451851011
					],
					"name": "Kent Road Public School",
					"playspace": 49.58,
					"projections": [
						338,
						637,
						645,
						740,
						815,
						895
					],
					"projections_orig": [
						"338",
						"637",
						"645",
						"740",
						"815",
						"895"
					],
					"projections_percentage": [
						-46.94,
						0,
						1.26,
						16.17,
						27.94,
						40.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4160
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.09,
					"enrolment": 325,
					"ligo": 0.48,
					"location": [
						151.130029829195,
						-33.7948034958414
					],
					"name": "Truscott Street Public School",
					"playspace": 29.02,
					"projections": [
						290,
						325,
						410,
						535,
						560,
						545
					],
					"projections_orig": [
						"290",
						"325",
						"410",
						"535",
						"560",
						"545"
					],
					"projections_percentage": [
						-10.77,
						0,
						26.15,
						64.62,
						72.31,
						67.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4164
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.44,
					"enrolment": 512,
					"ligo": 0.64,
					"location": [
						151.126891601742,
						-33.8062784497401
					],
					"name": "Ryde East Public School",
					"playspace": 49.98,
					"projections": [
						435,
						512,
						555,
						575,
						585,
						595
					],
					"projections_orig": [
						"435",
						"512",
						"555",
						"575",
						"585",
						"595"
					],
					"projections_percentage": [
						-15.04,
						0,
						8.4,
						12.3,
						14.26,
						16.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4257
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 30
					},
					"classroomspace": 2.34,
					"enrolment": 823,
					"ligo": 0.61,
					"location": [
						151.078710289919,
						-33.7931616478117
					],
					"name": "Eastwood Public School",
					"playspace": 9.94,
					"projections": [
						706,
						823,
						895,
						1000,
						1040,
						1045
					],
					"projections_orig": [
						"706",
						"823",
						"895",
						"1000",
						"1040",
						"1045"
					],
					"projections_percentage": [
						-14.22,
						0,
						8.75,
						21.51,
						26.37,
						26.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7416
				}
			],
			"uid": 10028
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 92
			},
			"enrolment": 2720,
			"level": "Primary",
			"ligo": 0.65,
			"name": "West Ryde Primary",
			"playspace": 49.16,
			"projections": [
				2720,
				2995,
				3260,
				3440,
				3560
			],
			"projections_percentage": [
				0,
				10.11,
				19.85,
				26.47,
				30.88
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 14
					},
					"classroomspace": 2.46,
					"enrolment": 441,
					"ligo": 0.51,
					"location": [
						151.070149735628,
						-33.8051961967448
					],
					"name": "Ermington Public School",
					"playspace": 32.75,
					"projections": [
						450,
						441,
						500,
						540,
						570,
						595
					],
					"projections_orig": [
						"450",
						"441",
						"500",
						"540",
						"570",
						"595"
					],
					"projections_percentage": [
						2.04,
						0,
						13.38,
						22.45,
						29.25,
						34.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1860
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.25,
					"enrolment": 521,
					"ligo": 0.76,
					"location": [
						151.125687585928,
						-33.8324671161413
					],
					"name": "Gladesville Public School",
					"playspace": 40.91,
					"projections": [
						447,
						521,
						590,
						645,
						655,
						655
					],
					"projections_orig": [
						"447",
						"521",
						"590",
						"645",
						"655",
						"655"
					],
					"projections_percentage": [
						-14.2,
						0,
						13.24,
						23.8,
						25.72,
						25.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1990
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.46,
					"enrolment": 466,
					"ligo": 0.78,
					"location": [
						151.110673319372,
						-33.8251000827941
					],
					"name": "Putney Public School",
					"playspace": 20.59,
					"projections": [
						445,
						466,
						610,
						665,
						700,
						715
					],
					"projections_orig": [
						"445",
						"466",
						"610",
						"665",
						"700",
						"715"
					],
					"projections_percentage": [
						-4.51,
						0,
						30.9,
						42.7,
						50.21,
						53.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2913
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 18
					},
					"classroomspace": 2.56,
					"enrolment": 605,
					"ligo": 0.85,
					"location": [
						151.084501603473,
						-33.8087597143442
					],
					"name": "West Ryde Public School",
					"playspace": 10.39,
					"projections": [
						307,
						605,
						505,
						540,
						575,
						605
					],
					"projections_orig": [
						"307",
						"605",
						"505",
						"540",
						"575",
						"605"
					],
					"projections_percentage": [
						-49.26,
						0,
						-16.53,
						-10.74,
						-4.96,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3023
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.48,
					"enrolment": 202,
					"ligo": 0.35,
					"location": [
						151.072600624564,
						-33.8153186631846
					],
					"name": "Melrose Park Public School",
					"playspace": 103.33,
					"projections": [
						136,
						202,
						210,
						235,
						260,
						280
					],
					"projections_orig": [
						"136",
						"202",
						"210",
						"235",
						"260",
						"280"
					],
					"projections_percentage": [
						-32.67,
						0,
						3.96,
						16.34,
						28.71,
						38.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3846
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 7
					},
					"classroomspace": 2.52,
					"enrolment": 309,
					"ligo": 0.72,
					"location": [
						151.097909114046,
						-33.8173353790618
					],
					"name": "Meadowbank Public School",
					"playspace": 19.61,
					"projections": [
						173,
						309,
						360,
						390,
						410,
						425
					],
					"projections_orig": [
						"173",
						"309",
						"360",
						"390",
						"410",
						"425"
					],
					"projections_percentage": [
						-44.01,
						0,
						16.5,
						26.21,
						32.69,
						37.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3863
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.86,
					"enrolment": 176,
					"ligo": 0.61,
					"location": [
						151.058174058618,
						-33.816333332384
					],
					"name": "Rydalmere East Public School",
					"playspace": 116.53,
					"projections": [
						191,
						176,
						220,
						245,
						270,
						285
					],
					"projections_orig": [
						"191",
						"176",
						"220",
						"245",
						"270",
						"285"
					],
					"projections_percentage": [
						8.52,
						0,
						25,
						39.2,
						53.41,
						61.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4123
				}
			],
			"uid": 10029
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 129
			},
			"enrolment": 3125,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Belrose Primary",
			"playspace": 52.22,
			"projections": [
				3125,
				3125,
				3245,
				3410,
				3425
			],
			"projections_percentage": [
				0,
				0,
				3.84,
				9.12,
				9.6
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.14,
					"enrolment": 298,
					"ligo": 0.63,
					"location": [
						151.224771183444,
						-33.7514466987687
					],
					"name": "Frenchs Forest Public School",
					"playspace": 56.87,
					"projections": [
						253,
						298,
						315,
						340,
						370,
						370
					],
					"projections_orig": [
						"253",
						"298",
						"315",
						"340",
						"370",
						"370"
					],
					"projections_percentage": [
						-15.1,
						0,
						5.7,
						14.09,
						24.16,
						24.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1946
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.09,
					"enrolment": 307,
					"ligo": 0.63,
					"location": [
						151.215087766293,
						-33.7274235908926
					],
					"name": "Belrose Public School",
					"playspace": 95.65,
					"projections": [
						308,
						307,
						325,
						345,
						365,
						370
					],
					"projections_orig": [
						"308",
						"307",
						"325",
						"345",
						"365",
						"370"
					],
					"projections_percentage": [
						0.33,
						0,
						5.86,
						12.38,
						18.89,
						20.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3748
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 21
					},
					"classroomspace": 2.71,
					"enrolment": 718,
					"ligo": 0.65,
					"location": [
						151.213971899983,
						-33.7619119298215
					],
					"name": "Forestville Public School",
					"playspace": 24.3,
					"projections": [
						592,
						718,
						705,
						725,
						750,
						750
					],
					"projections_orig": [
						"592",
						"718",
						"705",
						"725",
						"750",
						"750"
					],
					"projections_percentage": [
						-17.55,
						0,
						-1.81,
						0.97,
						4.46,
						4.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4019
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.49,
					"enrolment": 355,
					"ligo": 0.61,
					"location": [
						151.217892712114,
						-33.7393899938916
					],
					"name": "Wakehurst Public School",
					"playspace": 46.94,
					"projections": [
						348,
						355,
						380,
						410,
						440,
						440
					],
					"projections_orig": [
						"348",
						"355",
						"380",
						"410",
						"440",
						"440"
					],
					"projections_percentage": [
						-1.97,
						0,
						7.04,
						15.49,
						23.94,
						23.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4368
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 24
					},
					"classroomspace": 2.84,
					"enrolment": 702,
					"ligo": 0.52,
					"location": [
						151.216702245381,
						-33.7752141995901
					],
					"name": "Killarney Heights Public School",
					"playspace": 27.35,
					"projections": [
						593,
						702,
						690,
						695,
						700,
						700
					],
					"projections_orig": [
						"593",
						"702",
						"690",
						"695",
						"700",
						"700"
					],
					"projections_percentage": [
						-15.53,
						0,
						-1.71,
						-1,
						-0.28,
						-0.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4386
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.19,
					"enrolment": 527,
					"ligo": 0.45,
					"location": [
						151.204278052258,
						-33.7434309013953
					],
					"name": "Mimosa Public School",
					"playspace": 26.88,
					"projections": [
						432,
						527,
						510,
						520,
						565,
						575
					],
					"projections_orig": [
						"432",
						"527",
						"510",
						"520",
						"565",
						"575"
					],
					"projections_percentage": [
						-18.03,
						0,
						-3.23,
						-1.33,
						7.21,
						9.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4432
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.62,
					"enrolment": 218,
					"ligo": 0.43,
					"location": [
						151.195129012632,
						-33.7405979548407
					],
					"name": "Kambora Public School",
					"playspace": 87.53,
					"projections": [
						187,
						218,
						200,
						210,
						220,
						220
					],
					"projections_orig": [
						"187",
						"218",
						"200",
						"210",
						"220",
						"220"
					],
					"projections_percentage": [
						-14.22,
						0,
						-8.26,
						-3.67,
						0.92,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4515
				}
			],
			"uid": 10030
		},
		{
			"classrooms": {
				"demountable": 40,
				"permanent": 194
			},
			"enrolment": 5668,
			"level": "Primary",
			"ligo": 0.73,
			"name": "St Ives Primary",
			"playspace": 43.25,
			"projections": [
				5668,
				6165,
				6350,
				6490,
				6630
			],
			"projections_percentage": [
				0,
				8.77,
				12.03,
				14.5,
				16.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.7,
					"enrolment": 301,
					"ligo": 0.64,
					"location": [
						151.146848446957,
						-33.7146239655849
					],
					"name": "Turramurra North Public School",
					"playspace": 58.68,
					"projections": [
						286,
						301,
						350,
						355,
						365,
						375
					],
					"projections_orig": [
						"286",
						"301",
						"350",
						"355",
						"365",
						"375"
					],
					"projections_percentage": [
						-4.98,
						0,
						16.28,
						17.94,
						21.26,
						24.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3288
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 21
					},
					"classroomspace": 2.84,
					"enrolment": 594,
					"ligo": 0.7,
					"location": [
						151.121522061708,
						-33.7289740309048
					],
					"name": "Warrawee Public School",
					"playspace": 28.5,
					"projections": [
						583,
						594,
						670,
						695,
						705,
						710
					],
					"projections_orig": [
						"583",
						"594",
						"670",
						"695",
						"705",
						"710"
					],
					"projections_percentage": [
						-1.85,
						0,
						12.79,
						17,
						18.69,
						19.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3390
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 2.48,
					"enrolment": 663,
					"ligo": 0.78,
					"location": [
						151.141160506084,
						-33.7317076369474
					],
					"name": "Pymble Public School",
					"playspace": 14.11,
					"projections": [
						569,
						663,
						695,
						710,
						730,
						750
					],
					"projections_orig": [
						"569",
						"663",
						"695",
						"710",
						"730",
						"750"
					],
					"projections_percentage": [
						-14.18,
						0,
						4.83,
						7.09,
						10.11,
						13.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3777
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.55,
					"enrolment": 712,
					"ligo": 0.76,
					"location": [
						151.127267882141,
						-33.7145571340096
					],
					"name": "Wahroonga Public School",
					"playspace": 36.63,
					"projections": [
						685,
						712,
						800,
						830,
						850,
						855
					],
					"projections_orig": [
						"685",
						"712",
						"800",
						"830",
						"850",
						"855"
					],
					"projections_percentage": [
						-3.79,
						0,
						12.36,
						16.57,
						19.38,
						20.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3833
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 26
					},
					"classroomspace": 2.83,
					"enrolment": 577,
					"ligo": 0.83,
					"location": [
						151.113530426754,
						-33.7438716555798
					],
					"name": "Turramurra Public School",
					"playspace": 39.93,
					"projections": [
						476,
						577,
						605,
						615,
						625,
						645
					],
					"projections_orig": [
						"476",
						"577",
						"605",
						"615",
						"625",
						"645"
					],
					"projections_percentage": [
						-17.5,
						0,
						4.85,
						6.59,
						8.32,
						11.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3855
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.44,
					"enrolment": 572,
					"ligo": 0.77,
					"location": [
						151.139145621027,
						-33.7594866930365
					],
					"name": "Gordon West Public School",
					"playspace": 30.98,
					"projections": [
						503,
						572,
						650,
						680,
						695,
						710
					],
					"projections_orig": [
						"503",
						"572",
						"650",
						"680",
						"695",
						"710"
					],
					"projections_percentage": [
						-12.06,
						0,
						13.64,
						18.88,
						21.5,
						24.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3943
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.73,
					"enrolment": 335,
					"ligo": 0.72,
					"location": [
						151.157541578073,
						-33.7460699007841
					],
					"name": "Gordon East Public School",
					"playspace": 37.98,
					"projections": [
						321,
						335,
						395,
						420,
						425,
						430
					],
					"projections_orig": [
						"321",
						"335",
						"395",
						"420",
						"425",
						"430"
					],
					"projections_percentage": [
						-4.18,
						0,
						17.91,
						25.37,
						26.87,
						28.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3985
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.73,
					"enrolment": 343,
					"ligo": 0.68,
					"location": [
						151.123924576678,
						-33.7628973158596
					],
					"name": "West Pymble Public School",
					"playspace": 56.21,
					"projections": [
						287,
						343,
						355,
						365,
						375,
						385
					],
					"projections_orig": [
						"287",
						"343",
						"355",
						"365",
						"375",
						"385"
					],
					"projections_percentage": [
						-16.33,
						0,
						3.5,
						6.41,
						9.33,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4283
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 23
					},
					"classroomspace": 2.47,
					"enrolment": 899,
					"ligo": 0.76,
					"location": [
						151.162637933863,
						-33.7191629870251
					],
					"name": "St Ives North Public School",
					"playspace": 12.47,
					"projections": [
						685,
						899,
						950,
						955,
						975,
						1005
					],
					"projections_orig": [
						"685",
						"899",
						"950",
						"955",
						"975",
						"1005"
					],
					"projections_percentage": [
						-23.8,
						0,
						5.67,
						6.23,
						8.45,
						11.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4293
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 13
					},
					"classroomspace": 2.33,
					"enrolment": 487,
					"ligo": 0.73,
					"location": [
						151.165644886872,
						-33.7385294380491
					],
					"name": "St Ives Public School",
					"playspace": 28.05,
					"projections": [
						370,
						487,
						500,
						525,
						540,
						555
					],
					"projections_orig": [
						"370",
						"487",
						"500",
						"525",
						"540",
						"555"
					],
					"projections_percentage": [
						-24.02,
						0,
						2.67,
						7.8,
						10.88,
						13.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4331
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.35,
					"enrolment": 185,
					"ligo": 0.68,
					"location": [
						151.177926537855,
						-33.7243919512106
					],
					"name": "St Ives Park Public School",
					"playspace": 132.17,
					"projections": [
						169,
						185,
						195,
						200,
						205,
						210
					],
					"projections_orig": [
						"169",
						"185",
						"195",
						"200",
						"205",
						"210"
					],
					"projections_percentage": [
						-8.65,
						0,
						5.41,
						8.11,
						10.81,
						13.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4400
				}
			],
			"uid": 10031
		},
		{
			"classrooms": {
				"demountable": 64,
				"permanent": 286
			},
			"enrolment": 8418,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Dee Why Primary",
			"playspace": 27.64,
			"projections": [
				8418,
				8515,
				8665,
				8990,
				9205
			],
			"projections_percentage": [
				0,
				1.15,
				2.93,
				6.79,
				9.35
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.44,
					"enrolment": 400,
					"ligo": 0.85,
					"location": [
						151.285949424063,
						-33.7484188782483
					],
					"name": "Dee Why Public School",
					"playspace": 31.8,
					"projections": [
						219,
						400,
						365,
						365,
						370,
						370
					],
					"projections_orig": [
						"219",
						"400",
						"365",
						"365",
						"370",
						"370"
					],
					"projections_percentage": [
						-45.25,
						0,
						-8.75,
						-8.75,
						-7.5,
						-7.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1744
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 34
					},
					"classroomspace": 2.74,
					"enrolment": 1129,
					"ligo": 0.51,
					"location": [
						151.300000933268,
						-33.6774713530786
					],
					"name": "Mona Vale Public School",
					"playspace": 20.54,
					"projections": [
						883,
						1129,
						1145,
						1245,
						1355,
						1415
					],
					"projections_orig": [
						"883",
						"1129",
						"1145",
						"1245",
						"1355",
						"1415"
					],
					"projections_percentage": [
						-21.79,
						0,
						1.42,
						10.27,
						20.02,
						25.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2593
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 2.32,
					"enrolment": 440,
					"ligo": 0.68,
					"location": [
						151.297980011368,
						-33.7205876609439
					],
					"name": "Narrabeen Lakes Public School",
					"playspace": 10.74,
					"projections": [
						334,
						440,
						405,
						405,
						405,
						405
					],
					"projections_orig": [
						"334",
						"440",
						"405",
						"405",
						"405",
						"405"
					],
					"projections_percentage": [
						-24.09,
						0,
						-7.95,
						-7.95,
						-7.95,
						-7.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2706
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 26
					},
					"classroomspace": 2.75,
					"enrolment": 838,
					"ligo": 0.8,
					"location": [
						151.312778401982,
						-33.6611012167071
					],
					"name": "Newport Public School",
					"playspace": 12.14,
					"projections": [
						743,
						838,
						880,
						895,
						920,
						935
					],
					"projections_orig": [
						"743",
						"838",
						"880",
						"895",
						"920",
						"935"
					],
					"projections_percentage": [
						-11.34,
						0,
						5.01,
						6.8,
						9.79,
						11.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2740
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 33
					},
					"classroomspace": 2.37,
					"enrolment": 910,
					"ligo": 0.94,
					"location": [
						151.327180302895,
						-33.6397481348075
					],
					"name": "Avalon Public School",
					"playspace": 20.27,
					"projections": [
						894,
						910,
						930,
						935,
						970,
						995
					],
					"projections_orig": [
						"894",
						"910",
						"930",
						"935",
						"970",
						"995"
					],
					"projections_percentage": [
						-1.76,
						0,
						2.2,
						2.75,
						6.59,
						9.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3792
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.41,
					"enrolment": 491,
					"ligo": 0.52,
					"location": [
						151.273627522182,
						-33.7496860284521
					],
					"name": "Narraweena Public School",
					"playspace": 22.14,
					"projections": [
						326,
						491,
						430,
						430,
						430,
						430
					],
					"projections_orig": [
						"326",
						"491",
						"430",
						"430",
						"430",
						"430"
					],
					"projections_percentage": [
						-33.6,
						0,
						-12.42,
						-12.42,
						-12.42,
						-12.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3827
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 15
					},
					"classroomspace": 2.57,
					"enrolment": 664,
					"ligo": 0.83,
					"location": [
						151.29808031217,
						-33.6997695038372
					],
					"name": "Narrabeen North Public School",
					"playspace": 22.83,
					"projections": [
						495,
						664,
						665,
						685,
						695,
						700
					],
					"projections_orig": [
						"495",
						"664",
						"665",
						"685",
						"695",
						"700"
					],
					"projections_percentage": [
						-25.45,
						0,
						0.15,
						3.16,
						4.67,
						5.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3906
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 15
					},
					"classroomspace": 2.73,
					"enrolment": 633,
					"ligo": 0.69,
					"location": [
						151.292586652641,
						-33.7331379564161
					],
					"name": "Collaroy Plateau Public School",
					"playspace": 23.63,
					"projections": [
						566,
						633,
						645,
						640,
						640,
						640
					],
					"projections_orig": [
						"566",
						"633",
						"645",
						"640",
						"640",
						"640"
					],
					"projections_percentage": [
						-10.58,
						0,
						1.9,
						1.11,
						1.11,
						1.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3970
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 22
					},
					"classroomspace": 2.98,
					"enrolment": 592,
					"ligo": 0.61,
					"location": [
						151.259669127383,
						-33.7520951724615
					],
					"name": "Beacon Hill Public School",
					"playspace": 57.85,
					"projections": [
						605,
						592,
						645,
						665,
						690,
						685
					],
					"projections_orig": [
						"605",
						"592",
						"645",
						"665",
						"690",
						"685"
					],
					"projections_percentage": [
						2.2,
						0,
						8.95,
						12.33,
						16.55,
						15.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3971
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.48,
					"enrolment": 588,
					"ligo": 0.69,
					"location": [
						151.284517974012,
						-33.70406269759
					],
					"name": "Elanora Heights Public School",
					"playspace": 55.88,
					"projections": [
						546,
						588,
						565,
						545,
						630,
						725
					],
					"projections_orig": [
						"546",
						"588",
						"565",
						"545",
						"630",
						"725"
					],
					"projections_percentage": [
						-7.14,
						0,
						-3.91,
						-7.31,
						7.14,
						23.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4199
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 2.64,
					"enrolment": 724,
					"ligo": 0.7,
					"location": [
						151.273440809447,
						-33.7377392388515
					],
					"name": "Cromer Public School",
					"playspace": 21.65,
					"projections": [
						848,
						724,
						800,
						810,
						820,
						820
					],
					"projections_orig": [
						"848",
						"724",
						"800",
						"810",
						"820",
						"820"
					],
					"projections_percentage": [
						17.13,
						0,
						10.5,
						11.88,
						13.26,
						13.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4241
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.88,
					"enrolment": 498,
					"ligo": 0.64,
					"location": [
						151.286238645654,
						-33.7283494973938
					],
					"name": "Wheeler Heights Public School",
					"playspace": 37.44,
					"projections": [
						534,
						498,
						535,
						530,
						530,
						530
					],
					"projections_orig": [
						"534",
						"498",
						"535",
						"530",
						"530",
						"530"
					],
					"projections_percentage": [
						7.23,
						0,
						7.43,
						6.43,
						6.43,
						6.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4249
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.41,
					"enrolment": 511,
					"ligo": 0.73,
					"location": [
						151.314446805039,
						-33.6445753378815
					],
					"name": "Bilgola Plateau Public School",
					"playspace": 22.38,
					"projections": [
						464,
						511,
						505,
						515,
						535,
						555
					],
					"projections_orig": [
						"464",
						"511",
						"505",
						"515",
						"535",
						"555"
					],
					"projections_percentage": [
						-9.2,
						0,
						-1.17,
						0.78,
						4.7,
						8.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4359
				}
			],
			"uid": 10032
		},
		{
			"classrooms": {
				"demountable": 59,
				"permanent": 170
			},
			"enrolment": 5527,
			"level": "Primary",
			"ligo": 0.75,
			"name": "Hornsby Primary",
			"playspace": 47,
			"projections": [
				5527,
				5650,
				6150,
				6360,
				6390
			],
			"projections_percentage": [
				0,
				2.23,
				11.27,
				15.07,
				15.61
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 12
					},
					"classroomspace": 2.79,
					"enrolment": 398,
					"ligo": 0.59,
					"location": [
						151.113254423094,
						-33.6862746272847
					],
					"name": "Asquith Public School",
					"playspace": 34.34,
					"projections": [
						303,
						398,
						410,
						480,
						510,
						510
					],
					"projections_orig": [
						"303",
						"398",
						"410",
						"480",
						"510",
						"510"
					],
					"projections_percentage": [
						-23.87,
						0,
						3.02,
						20.6,
						28.14,
						28.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1070
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 2.59,
					"enrolment": 406,
					"ligo": 0.78,
					"location": [
						151.146838971181,
						-33.618140415501
					],
					"name": "Berowra Public School",
					"playspace": 55.46,
					"projections": [
						381,
						406,
						450,
						470,
						475,
						480
					],
					"projections_orig": [
						"381",
						"406",
						"450",
						"470",
						"475",
						"480"
					],
					"projections_percentage": [
						-6.16,
						0,
						10.84,
						15.76,
						17,
						18.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1205
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.38,
					"enrolment": 54,
					"ligo": 0.91,
					"location": [
						151.169196210226,
						-33.588955895145
					],
					"name": "Cowan Public School",
					"playspace": 166.52,
					"projections": [
						53,
						54,
						60,
						60,
						60,
						60
					],
					"projections_orig": [
						"53",
						"54",
						"60",
						"60",
						"60",
						"60"
					],
					"projections_percentage": [
						-1.85,
						0,
						11.11,
						11.11,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1668
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 353,
					"ligo": 0.7,
					"location": [
						151.097335421037,
						-33.7232975847471
					],
					"name": "Normanhurst Public School",
					"playspace": 42.63,
					"projections": [
						319,
						353,
						360,
						375,
						380,
						380
					],
					"projections_orig": [
						"319",
						"353",
						"360",
						"375",
						"380",
						"380"
					],
					"projections_percentage": [
						-9.63,
						0,
						1.98,
						6.23,
						7.65,
						7.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2760
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 17
					},
					"classroomspace": 2.41,
					"enrolment": 856,
					"ligo": 0.71,
					"location": [
						151.112067566075,
						-33.7079668184629
					],
					"name": "Waitara Public School",
					"playspace": 13.24,
					"projections": [
						606,
						856,
						805,
						875,
						920,
						920
					],
					"projections_orig": [
						"606",
						"856",
						"805",
						"875",
						"920",
						"920"
					],
					"projections_percentage": [
						-29.21,
						0,
						-5.96,
						2.22,
						7.48,
						7.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3334
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.58,
					"enrolment": 445,
					"ligo": 0.89,
					"location": [
						151.117027395413,
						-33.6725716510761
					],
					"name": "Mount Colah Public School",
					"playspace": 40.49,
					"projections": [
						395,
						445,
						465,
						540,
						565,
						570
					],
					"projections_orig": [
						"395",
						"445",
						"465",
						"540",
						"565",
						"570"
					],
					"projections_percentage": [
						-11.24,
						0,
						4.49,
						21.35,
						26.97,
						28.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3885
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.38,
					"enrolment": 174,
					"ligo": 0.67,
					"location": [
						151.135234638827,
						-33.6580540380818
					],
					"name": "Mount Kuring-gai Public School",
					"playspace": 34.7,
					"projections": [
						146,
						174,
						195,
						210,
						220,
						225
					],
					"projections_orig": [
						"146",
						"174",
						"195",
						"210",
						"220",
						"225"
					],
					"projections_percentage": [
						-16.09,
						0,
						12.07,
						20.69,
						26.44,
						29.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4049
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.51,
					"enrolment": 446,
					"ligo": 0.92,
					"location": [
						151.096645583359,
						-33.6697893726028
					],
					"name": "Hornsby Heights Public School",
					"playspace": 39.64,
					"projections": [
						344,
						446,
						435,
						490,
						515,
						515
					],
					"projections_orig": [
						"344",
						"446",
						"435",
						"490",
						"515",
						"515"
					],
					"projections_percentage": [
						-22.87,
						0,
						-2.47,
						9.87,
						15.47,
						15.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4274
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.8,
					"enrolment": 543,
					"ligo": 0.66,
					"location": [
						151.08805836025,
						-33.7217360428331
					],
					"name": "Normanhurst West Public School",
					"playspace": 28.13,
					"projections": [
						427,
						543,
						540,
						565,
						565,
						570
					],
					"projections_orig": [
						"427",
						"543",
						"540",
						"565",
						"565",
						"570"
					],
					"projections_percentage": [
						-21.36,
						0,
						-0.55,
						4.05,
						4.05,
						4.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4275
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 25
					},
					"classroomspace": 2.47,
					"enrolment": 837,
					"ligo": 0.54,
					"location": [
						151.098241425172,
						-33.681838435564
					],
					"name": "Hornsby North Public School",
					"playspace": 21,
					"projections": [
						814,
						837,
						890,
						995,
						1035,
						1040
					],
					"projections_orig": [
						"814",
						"837",
						"890",
						"995",
						"1035",
						"1040"
					],
					"projections_percentage": [
						-2.75,
						0,
						6.33,
						18.88,
						23.66,
						24.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4365
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.44,
					"enrolment": 395,
					"ligo": 0.85,
					"location": [
						151.142434309767,
						-33.6092067328493
					],
					"name": "Wideview Public School",
					"playspace": 54.58,
					"projections": [
						361,
						395,
						425,
						440,
						445,
						445
					],
					"projections_orig": [
						"361",
						"395",
						"425",
						"440",
						"445",
						"445"
					],
					"projections_percentage": [
						-8.61,
						0,
						7.59,
						11.39,
						12.66,
						12.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4433
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 17
					},
					"classroomspace": 2.87,
					"enrolment": 620,
					"ligo": 0.81,
					"location": [
						151.095621882663,
						-33.7126650523083
					],
					"name": "Hornsby South Public School",
					"playspace": 33.31,
					"projections": [
						484,
						620,
						615,
						650,
						670,
						675
					],
					"projections_orig": [
						"484",
						"620",
						"615",
						"650",
						"670",
						"675"
					],
					"projections_percentage": [
						-21.94,
						0,
						-0.81,
						4.84,
						8.06,
						8.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5191
				}
			],
			"uid": 10033
		},
		{
			"classrooms": {
				"demountable": 75,
				"permanent": 191
			},
			"enrolment": 6935,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Manly Primary",
			"playspace": 21.76,
			"projections": [
				6935,
				6860,
				6725,
				6795,
				6805
			],
			"projections_percentage": [
				0,
				-1.08,
				-3.03,
				-2.02,
				-1.87
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 554,
					"ligo": 0.8,
					"location": [
						151.250801040894,
						-33.7933485899455
					],
					"name": "Seaforth Public School",
					"playspace": 32.66,
					"projections": [
						478,
						554,
						550,
						550,
						560,
						565
					],
					"projections_orig": [
						"478",
						"554",
						"550",
						"550",
						"560",
						"565"
					],
					"projections_percentage": [
						-13.72,
						0,
						-0.72,
						-0.72,
						1.08,
						1.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1104
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.54,
					"enrolment": 312,
					"ligo": 0.61,
					"location": [
						151.270807491705,
						-33.7621637701868
					],
					"name": "Brookvale Public School",
					"playspace": 35.54,
					"projections": [
						167,
						312,
						245,
						245,
						245,
						245
					],
					"projections_orig": [
						"167",
						"312",
						"245",
						"245",
						"245",
						"245"
					],
					"projections_percentage": [
						-46.47,
						0,
						-21.47,
						-21.47,
						-21.47,
						-21.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1379
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 27
					},
					"classroomspace": 1.75,
					"enrolment": 1152,
					"ligo": 0.82,
					"location": [
						151.287013726799,
						-33.7726580321863
					],
					"name": "Harbord Public School",
					"playspace": 14.58,
					"projections": [
						1052,
						1152,
						1165,
						1120,
						1125,
						1120
					],
					"projections_orig": [
						"1052",
						"1152",
						"1165",
						"1120",
						"1125",
						"1120"
					],
					"projections_percentage": [
						-8.68,
						0,
						1.13,
						-2.78,
						-2.34,
						-2.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2133
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 27
					},
					"classroomspace": 2.47,
					"enrolment": 880,
					"ligo": 0.73,
					"location": [
						151.269581991557,
						-33.7925068737794
					],
					"name": "Manly West Public School",
					"playspace": 17.79,
					"projections": [
						824,
						880,
						920,
						885,
						895,
						900
					],
					"projections_orig": [
						"824",
						"880",
						"920",
						"885",
						"895",
						"900"
					],
					"projections_percentage": [
						-6.36,
						0,
						4.55,
						0.57,
						1.7,
						2.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2469
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 20
					},
					"classroomspace": 2.56,
					"enrolment": 739,
					"ligo": 0.86,
					"location": [
						151.258157758968,
						-33.8058705806229
					],
					"name": "Balgowlah Heights Public School",
					"playspace": 18.58,
					"projections": [
						634,
						739,
						755,
						730,
						745,
						750
					],
					"projections_orig": [
						"634",
						"739",
						"755",
						"730",
						"745",
						"750"
					],
					"projections_percentage": [
						-14.21,
						0,
						2.17,
						-1.22,
						0.81,
						1.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3736
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 17
					},
					"classroomspace": 2.77,
					"enrolment": 913,
					"ligo": 0.7,
					"location": [
						151.288397485715,
						-33.7645380630382
					],
					"name": "Curl Curl North Public School",
					"playspace": 20.07,
					"projections": [
						826,
						913,
						965,
						960,
						965,
						960
					],
					"projections_orig": [
						"826",
						"913",
						"965",
						"960",
						"965",
						"960"
					],
					"projections_percentage": [
						-9.53,
						0,
						5.7,
						5.15,
						5.7,
						5.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3925
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 1.84,
					"enrolment": 715,
					"ligo": 0.7,
					"location": [
						151.287186632047,
						-33.7996295943319
					],
					"name": "Manly Village Public School",
					"playspace": 6.84,
					"projections": [
						634,
						715,
						695,
						660,
						665,
						665
					],
					"projections_orig": [
						"634",
						"715",
						"695",
						"660",
						"665",
						"665"
					],
					"projections_percentage": [
						-11.33,
						0,
						-2.8,
						-7.69,
						-6.99,
						-6.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3950
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 13
					},
					"classroomspace": 2.87,
					"enrolment": 615,
					"ligo": 0.75,
					"location": [
						151.247593412536,
						-33.7831776488384
					],
					"name": "Balgowlah North Public School",
					"playspace": 36.68,
					"projections": [
						580,
						615,
						620,
						625,
						635,
						635
					],
					"projections_orig": [
						"580",
						"615",
						"620",
						"625",
						"635",
						"635"
					],
					"projections_percentage": [
						-5.69,
						0,
						0.81,
						1.63,
						3.25,
						3.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3984
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 7
					},
					"classroomspace": 2.78,
					"enrolment": 492,
					"ligo": 0.88,
					"location": [
						151.26064791528,
						-33.7839867910313
					],
					"name": "Manly Vale Public School",
					"playspace": 11.9,
					"projections": [
						307,
						492,
						415,
						415,
						415,
						420
					],
					"projections_orig": [
						"307",
						"492",
						"415",
						"415",
						"415",
						"420"
					],
					"projections_percentage": [
						-37.6,
						0,
						-15.65,
						-15.65,
						-15.65,
						-14.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4021
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.58,
					"enrolment": 563,
					"ligo": 0.76,
					"location": [
						151.249421315448,
						-33.7654369812292
					],
					"name": "Allambie Heights Public School",
					"playspace": 22.94,
					"projections": [
						460,
						563,
						530,
						535,
						545,
						545
					],
					"projections_orig": [
						"460",
						"563",
						"530",
						"535",
						"545",
						"545"
					],
					"projections_percentage": [
						-18.29,
						0,
						-5.86,
						-4.97,
						-3.2,
						-3.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4200
				}
			],
			"uid": 10034
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 17
			},
			"enrolment": 330,
			"level": "Primary",
			"ligo": 0.9,
			"name": "Terrey Hills Primary",
			"playspace": 109.94,
			"projections": [
				330,
				380,
				415,
				455,
				500
			],
			"projections_percentage": [
				0,
				15.15,
				25.76,
				37.88,
				51.52
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.08,
					"enrolment": 80,
					"ligo": 0.89,
					"location": [
						151.21522028973,
						-33.5481787600884
					],
					"name": "Brooklyn Public School",
					"playspace": 109.61,
					"projections": [
						95,
						80,
						105,
						110,
						110,
						110
					],
					"projections_orig": [
						"95",
						"80",
						"105",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						18.75,
						0,
						31.25,
						37.5,
						37.5,
						37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1377
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.29,
					"enrolment": 250,
					"ligo": 0.91,
					"location": [
						151.223608055379,
						-33.6854051218039
					],
					"name": "Terrey Hills Public School",
					"playspace": 110.27,
					"projections": [
						213,
						250,
						275,
						305,
						345,
						390
					],
					"projections_orig": [
						"213",
						"250",
						"275",
						"305",
						"345",
						"390"
					],
					"projections_percentage": [
						-14.8,
						0,
						10,
						22,
						38,
						56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3190
				}
			],
			"uid": 10035
		},
		{
			"classrooms": {
				"demountable": 32,
				"permanent": 150
			},
			"enrolment": 3887,
			"level": "Primary",
			"ligo": 0.74,
			"name": "Kogarah Primary",
			"playspace": 40.11,
			"projections": [
				3887,
				4225,
				4775,
				5210,
				5430
			],
			"projections_percentage": [
				0,
				8.7,
				22.85,
				34.04,
				39.7
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 2.8,
					"enrolment": 737,
					"ligo": 0.45,
					"location": [
						151.149950363396,
						-33.9628751677524
					],
					"name": "Brighton-Le-Sands Public School",
					"playspace": 32.43,
					"projections": [
						729,
						737,
						785,
						900,
						955,
						990
					],
					"projections_orig": [
						"729",
						"737",
						"785",
						"900",
						"955",
						"990"
					],
					"projections_percentage": [
						-1.09,
						0,
						6.51,
						22.12,
						29.58,
						34.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1358
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 22
					},
					"classroomspace": 2.24,
					"enrolment": 623,
					"ligo": 0.76,
					"location": [
						151.128497793146,
						-33.9727387927937
					],
					"name": "Carlton South Public School",
					"playspace": 16.39,
					"projections": [
						524,
						623,
						665,
						730,
						790,
						835
					],
					"projections_orig": [
						"524",
						"623",
						"665",
						"730",
						"790",
						"835"
					],
					"projections_percentage": [
						-15.89,
						0,
						6.74,
						17.17,
						26.81,
						34.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1513
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.92,
					"enrolment": 395,
					"ligo": 0.9,
					"location": [
						151.135652025498,
						-33.9619794808357
					],
					"name": "Kogarah Public School",
					"playspace": 17.59,
					"projections": [
						316,
						395,
						400,
						485,
						535,
						570
					],
					"projections_orig": [
						"316",
						"395",
						"400",
						"485",
						"535",
						"570"
					],
					"projections_percentage": [
						-20,
						0,
						1.27,
						22.78,
						35.44,
						44.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2319
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 3.49,
					"enrolment": 428,
					"ligo": 0.79,
					"location": [
						151.1417620686,
						-33.9523170635731
					],
					"name": "Rockdale Public School",
					"playspace": 9.38,
					"projections": [
						450,
						428,
						485,
						540,
						580,
						600
					],
					"projections_orig": [
						"450",
						"428",
						"485",
						"540",
						"580",
						"600"
					],
					"projections_percentage": [
						5.14,
						0,
						13.32,
						26.17,
						35.51,
						40.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2973
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 26
					},
					"classroomspace": 2.46,
					"enrolment": 633,
					"ligo": 0.86,
					"location": [
						151.128179260937,
						-33.9952874387931
					],
					"name": "Sans Souci Public School",
					"playspace": 28.11,
					"projections": [
						583,
						633,
						655,
						670,
						690,
						700
					],
					"projections_orig": [
						"583",
						"633",
						"655",
						"670",
						"690",
						"700"
					],
					"projections_percentage": [
						-7.9,
						0,
						3.48,
						5.85,
						9,
						10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3038
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 23
					},
					"classroomspace": 2.27,
					"enrolment": 591,
					"ligo": 0.65,
					"location": [
						151.142829032242,
						-33.9812911589111
					],
					"name": "Ramsgate Public School",
					"playspace": 16.64,
					"projections": [
						480,
						591,
						630,
						670,
						695,
						710
					],
					"projections_orig": [
						"480",
						"591",
						"630",
						"670",
						"695",
						"710"
					],
					"projections_percentage": [
						-18.78,
						0,
						6.6,
						13.37,
						17.6,
						20.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3830
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.3,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						151.161674162795,
						-33.9494679304849
					],
					"name": "Kyeemagh Infants School",
					"playspace": 179.32,
					"projections": [
						55,
						61,
						70,
						90,
						110,
						115
					],
					"projections_orig": [
						"55",
						"61",
						"70",
						"90",
						"110",
						"115"
					],
					"projections_percentage": [
						-9.84,
						0,
						14.75,
						47.54,
						80.33,
						88.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5141
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.72,
					"enrolment": 419,
					"ligo": 0.51,
					"location": [
						151.146907166984,
						-33.9407577124162
					],
					"name": "Arncliffe Public School",
					"playspace": 20.99,
					"projections": [
						396,
						419,
						535,
						690,
						855,
						910
					],
					"projections_orig": [
						"396",
						"419",
						"535",
						"690",
						"855",
						"910"
					],
					"projections_percentage": [
						-5.49,
						0,
						27.68,
						64.68,
						104.06,
						117.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7401
				}
			],
			"uid": 10036
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 66
			},
			"enrolment": 1324,
			"level": "Primary",
			"ligo": 0.8,
			"name": "Bexley Primary",
			"playspace": 32.09,
			"projections": [
				1324,
				1450,
				1615,
				1820,
				1910
			],
			"projections_percentage": [
				0,
				9.52,
				21.98,
				37.46,
				44.26
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 15
					},
					"classroomspace": 2.6,
					"enrolment": 545,
					"ligo": 0.65,
					"location": [
						151.119404293741,
						-33.9415691230378
					],
					"name": "Bexley North Public School",
					"playspace": 26.55,
					"projections": [
						449,
						545,
						560,
						620,
						685,
						720
					],
					"projections_orig": [
						"449",
						"545",
						"560",
						"620",
						"685",
						"720"
					],
					"projections_percentage": [
						-17.61,
						0,
						2.75,
						13.76,
						25.69,
						32.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2308
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.06,
					"enrolment": 339,
					"ligo": 0.66,
					"location": [
						151.137602227717,
						-33.9370237616066
					],
					"name": "Athelstane Public School",
					"playspace": 28.01,
					"projections": [
						311,
						339,
						370,
						425,
						520,
						555
					],
					"projections_orig": [
						"311",
						"339",
						"370",
						"425",
						"520",
						"555"
					],
					"projections_percentage": [
						-8.26,
						0,
						9.14,
						25.37,
						53.39,
						63.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3453
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 3.69,
					"enrolment": 97,
					"ligo": 1,
					"location": [
						151.144789186774,
						-33.9319741590921
					],
					"name": "Arncliffe West Infants School",
					"playspace": 47.34,
					"projections": [
						112,
						97,
						100,
						115,
						135,
						140
					],
					"projections_orig": [
						"112",
						"97",
						"100",
						"115",
						"135",
						"140"
					],
					"projections_percentage": [
						15.46,
						0,
						3.09,
						18.56,
						39.18,
						44.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5103
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.46,
					"enrolment": 58,
					"ligo": 1,
					"location": [
						151.125318234045,
						-33.9336341610531
					],
					"name": "Bardwell Park Infants School",
					"playspace": 26.59,
					"projections": [
						59,
						58,
						70,
						75,
						85,
						90
					],
					"projections_orig": [
						"59",
						"58",
						"70",
						"75",
						"85",
						"90"
					],
					"projections_percentage": [
						1.72,
						0,
						20.69,
						29.31,
						46.55,
						55.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5148
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.12,
					"enrolment": 285,
					"ligo": 0.71,
					"location": [
						151.129419890435,
						-33.9485336421339
					],
					"name": "Bexley Public School",
					"playspace": 31.97,
					"projections": [
						290,
						285,
						350,
						380,
						395,
						405
					],
					"projections_orig": [
						"290",
						"285",
						"350",
						"380",
						"395",
						"405"
					],
					"projections_percentage": [
						1.75,
						0,
						22.81,
						33.33,
						38.6,
						42.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7406
				}
			],
			"uid": 10037
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 49
			},
			"enrolment": 1079,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Blakehurst Primary",
			"playspace": 37,
			"projections": [
				1079,
				1150,
				1250,
				1340,
				1435
			],
			"projections_percentage": [
				0,
				6.58,
				15.85,
				24.19,
				32.99
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.64,
					"enrolment": 269,
					"ligo": 0.8,
					"location": [
						151.115394467153,
						-33.9833565266028
					],
					"name": "Blakehurst Public School",
					"playspace": 38.21,
					"projections": [
						366,
						269,
						310,
						340,
						375,
						400
					],
					"projections_orig": [
						"366",
						"269",
						"310",
						"340",
						"375",
						"400"
					],
					"projections_percentage": [
						36.06,
						0,
						15.24,
						26.39,
						39.41,
						48.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1255
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.44,
					"enrolment": 539,
					"ligo": 0.61,
					"location": [
						151.099874026887,
						-33.9857190292907
					],
					"name": "Connells Point Public School",
					"playspace": 42.66,
					"projections": [
						525,
						539,
						555,
						600,
						630,
						680
					],
					"projections_orig": [
						"525",
						"539",
						"555",
						"600",
						"630",
						"680"
					],
					"projections_percentage": [
						-2.6,
						0,
						2.97,
						11.32,
						16.88,
						26.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1613
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.46,
					"enrolment": 271,
					"ligo": 0.74,
					"location": [
						151.106243717522,
						-33.9967858241356
					],
					"name": "Bald Face Public School",
					"playspace": 30.13,
					"projections": [
						266,
						271,
						285,
						310,
						335,
						355
					],
					"projections_orig": [
						"266",
						"271",
						"285",
						"310",
						"335",
						"355"
					],
					"projections_percentage": [
						-1.85,
						0,
						5.17,
						14.39,
						23.62,
						31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3794
				}
			],
			"uid": 10038
		},
		{
			"classrooms": {
				"demountable": 34,
				"permanent": 170
			},
			"enrolment": 4145,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Hurstville Primary",
			"playspace": 25.69,
			"projections": [
				4145,
				4455,
				4825,
				5085,
				5195
			],
			"projections_percentage": [
				0,
				7.48,
				16.41,
				22.68,
				25.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 540,
					"ligo": 0.69,
					"location": [
						151.08455053349,
						-33.9535637685791
					],
					"name": "Beverly Hills Public School",
					"playspace": 28.85,
					"projections": [
						488,
						540,
						600,
						635,
						670,
						695
					],
					"projections_orig": [
						"488",
						"540",
						"600",
						"635",
						"670",
						"695"
					],
					"projections_percentage": [
						-9.63,
						0,
						11.11,
						17.59,
						24.07,
						28.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1215
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 36
					},
					"classroomspace": 2.79,
					"enrolment": 862,
					"ligo": 0.79,
					"location": [
						151.123081154896,
						-33.9635390385247
					],
					"name": "Carlton Public School",
					"playspace": 10.99,
					"projections": [
						865,
						862,
						935,
						1000,
						1035,
						1015
					],
					"projections_orig": [
						"865",
						"862",
						"935",
						"1000",
						"1035",
						"1015"
					],
					"projections_percentage": [
						0.35,
						0,
						8.47,
						16.01,
						20.07,
						17.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1512
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 46
					},
					"classroomspace": 2.75,
					"enrolment": 1236,
					"ligo": 0.76,
					"location": [
						151.111211013678,
						-33.9649060348519
					],
					"name": "Hurstville Public School",
					"playspace": 9.52,
					"projections": [
						1041,
						1236,
						1270,
						1420,
						1525,
						1580
					],
					"projections_orig": [
						"1041",
						"1236",
						"1270",
						"1420",
						"1525",
						"1580"
					],
					"projections_percentage": [
						-15.78,
						0,
						2.75,
						14.89,
						23.38,
						27.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2197
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 2.63,
					"enrolment": 502,
					"ligo": 0.81,
					"location": [
						151.098715784743,
						-33.9724003209257
					],
					"name": "Hurstville South Public School",
					"playspace": 17.46,
					"projections": [
						450,
						502,
						530,
						570,
						605,
						635
					],
					"projections_orig": [
						"450",
						"502",
						"530",
						"570",
						"605",
						"635"
					],
					"projections_percentage": [
						-10.36,
						0,
						5.58,
						13.55,
						20.52,
						26.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2198
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 27
					},
					"classroomspace": 2.98,
					"enrolment": 496,
					"ligo": 0.29,
					"location": [
						151.101896505354,
						-33.9479626048213
					],
					"name": "Kingsgrove Public School",
					"playspace": 49.01,
					"projections": [
						608,
						496,
						535,
						585,
						620,
						635
					],
					"projections_orig": [
						"608",
						"496",
						"535",
						"585",
						"620",
						"635"
					],
					"projections_percentage": [
						22.58,
						0,
						7.86,
						17.94,
						25,
						28.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2307
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.65,
					"enrolment": 457,
					"ligo": 0.78,
					"location": [
						151.087703611963,
						-33.9623473188772
					],
					"name": "Penshurst Public School",
					"playspace": 12.22,
					"projections": [
						426,
						457,
						525,
						550,
						565,
						570
					],
					"projections_orig": [
						"426",
						"457",
						"525",
						"550",
						"565",
						"570"
					],
					"projections_percentage": [
						-6.78,
						0,
						14.88,
						20.35,
						23.63,
						24.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2861
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 4.54,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						151.090727990426,
						-33.9730320947994
					],
					"name": "Hurstville Grove Infants School",
					"playspace": 51.78,
					"projections": [
						63,
						52,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"63",
						"52",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						21.15,
						0,
						15.38,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5195
				}
			],
			"uid": 10039
		},
		{
			"classrooms": {
				"demountable": 25,
				"permanent": 204
			},
			"enrolment": 4035,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Lakemba Primary",
			"playspace": 29.01,
			"projections": [
				4035,
				4565,
				5080,
				5480,
				5860
			],
			"projections_percentage": [
				0,
				13.14,
				25.9,
				35.81,
				45.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 4.92,
					"enrolment": 326,
					"ligo": 0.49,
					"location": [
						151.084359574785,
						-33.9104281455487
					],
					"name": "Belmore North Public School",
					"playspace": 19.49,
					"projections": [
						345,
						326,
						385,
						475,
						495,
						515
					],
					"projections_orig": [
						"345",
						"326",
						"385",
						"475",
						"495",
						"515"
					],
					"projections_percentage": [
						5.83,
						0,
						18.1,
						45.71,
						51.84,
						57.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1185
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4,
					"enrolment": 269,
					"ligo": 0.72,
					"location": [
						151.092151747631,
						-33.9251207413188
					],
					"name": "Belmore South Public School",
					"playspace": 58.92,
					"projections": [
						226,
						269,
						300,
						370,
						390,
						415
					],
					"projections_orig": [
						"226",
						"269",
						"300",
						"370",
						"390",
						"415"
					],
					"projections_percentage": [
						-15.99,
						0,
						11.52,
						37.55,
						44.98,
						54.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1186
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 17
					},
					"classroomspace": 2.8,
					"enrolment": 503,
					"ligo": 0.72,
					"location": [
						151.070906780903,
						-33.9231996269018
					],
					"name": "Lakemba Public School",
					"playspace": 11.97,
					"projections": [
						389,
						503,
						535,
						575,
						620,
						655
					],
					"projections_orig": [
						"389",
						"503",
						"535",
						"575",
						"620",
						"655"
					],
					"projections_percentage": [
						-22.66,
						0,
						6.36,
						14.31,
						23.26,
						30.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2360
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 29
					},
					"classroomspace": 3.3,
					"enrolment": 586,
					"ligo": 0.8,
					"location": [
						151.055621153403,
						-33.930711999804
					],
					"name": "Punchbowl Public School",
					"playspace": 41.57,
					"projections": [
						674,
						586,
						715,
						785,
						885,
						980
					],
					"projections_orig": [
						"674",
						"586",
						"715",
						"785",
						"885",
						"980"
					],
					"projections_percentage": [
						15.02,
						0,
						22.01,
						33.96,
						51.02,
						67.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2910
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 3.36,
					"enrolment": 385,
					"ligo": 0.63,
					"location": [
						151.085303250647,
						-33.934724335548
					],
					"name": "McCallums Hill Public School",
					"playspace": 29.99,
					"projections": [
						357,
						385,
						445,
						485,
						525,
						565
					],
					"projections_orig": [
						"357",
						"385",
						"445",
						"485",
						"525",
						"565"
					],
					"projections_percentage": [
						-7.27,
						0,
						15.58,
						25.97,
						36.36,
						46.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3886
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 25
					},
					"classroomspace": 2.65,
					"enrolment": 633,
					"ligo": 0.45,
					"location": [
						151.075346418815,
						-33.941404066174
					],
					"name": "Beverly Hills North Public School",
					"playspace": 27.08,
					"projections": [
						692,
						633,
						740,
						820,
						880,
						940
					],
					"projections_orig": [
						"692",
						"633",
						"740",
						"820",
						"880",
						"940"
					],
					"projections_percentage": [
						9.32,
						0,
						16.9,
						29.54,
						39.02,
						48.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3944
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 33
					},
					"classroomspace": 2.95,
					"enrolment": 742,
					"ligo": 0.86,
					"location": [
						151.073760750887,
						-33.9159310785725
					],
					"name": "Hampden Park Public School",
					"playspace": 22.62,
					"projections": [
						710,
						742,
						830,
						900,
						955,
						1010
					],
					"projections_orig": [
						"710",
						"742",
						"830",
						"900",
						"955",
						"1010"
					],
					"projections_percentage": [
						-4.31,
						0,
						11.86,
						21.29,
						28.71,
						36.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4494
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 2.59,
					"enrolment": 591,
					"ligo": 0.71,
					"location": [
						151.068216404997,
						-33.9248812281619
					],
					"name": "Wiley Park Public School",
					"playspace": 20.46,
					"projections": [
						552,
						591,
						615,
						670,
						730,
						780
					],
					"projections_orig": [
						"552",
						"591",
						"615",
						"670",
						"730",
						"780"
					],
					"projections_percentage": [
						-6.6,
						0,
						4.06,
						13.37,
						23.52,
						31.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4553
				}
			],
			"uid": 10040
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 37
			},
			"enrolment": 594,
			"level": "Primary",
			"ligo": 0.58,
			"name": "Riverwood Primary",
			"playspace": 90.1,
			"projections": [
				594,
				655,
				710,
				765,
				815
			],
			"projections_percentage": [
				0,
				10.27,
				19.53,
				28.79,
				37.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 4.75,
					"enrolment": 116,
					"ligo": 0.8,
					"location": [
						151.047557763619,
						-33.9470431308903
					],
					"name": "Riverwood Public School",
					"playspace": 139.92,
					"projections": [
						88,
						116,
						100,
						110,
						120,
						130
					],
					"projections_orig": [
						"88",
						"116",
						"100",
						"110",
						"120",
						"130"
					],
					"projections_percentage": [
						-24.14,
						0,
						-13.79,
						-5.17,
						3.45,
						12.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3743
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.55,
					"enrolment": 302,
					"ligo": 0.61,
					"location": [
						151.067672497865,
						-33.9488321091853
					],
					"name": "Narwee Public School",
					"playspace": 52.87,
					"projections": [
						245,
						302,
						355,
						380,
						405,
						430
					],
					"projections_orig": [
						"245",
						"302",
						"355",
						"380",
						"405",
						"430"
					],
					"projections_percentage": [
						-18.87,
						0,
						17.55,
						25.83,
						34.11,
						42.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3875
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.09,
					"enrolment": 176,
					"ligo": 0.32,
					"location": [
						151.056849218002,
						-33.9457928864993
					],
					"name": "Hannans Road Public School",
					"playspace": 77.52,
					"projections": [
						173,
						176,
						200,
						220,
						240,
						255
					],
					"projections_orig": [
						"173",
						"176",
						"200",
						"220",
						"240",
						"255"
					],
					"projections_percentage": [
						-1.7,
						0,
						13.64,
						25,
						36.36,
						44.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4092
				}
			],
			"uid": 10041
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 138
			},
			"enrolment": 3222,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Peakhurst Primary",
			"playspace": 46.81,
			"projections": [
				3222,
				3395,
				3525,
				3575,
				3640
			],
			"projections_percentage": [
				0,
				5.37,
				9.4,
				10.96,
				12.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.73,
					"enrolment": 380,
					"ligo": 0.56,
					"location": [
						151.081164287144,
						-33.9719108165538
					],
					"name": "Mortdale Public School",
					"playspace": 24.83,
					"projections": [
						358,
						380,
						370,
						380,
						375,
						375
					],
					"projections_orig": [
						"358",
						"380",
						"370",
						"380",
						"375",
						"375"
					],
					"projections_percentage": [
						-5.79,
						0,
						-2.63,
						0,
						-1.32,
						-1.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2624
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 14
					},
					"classroomspace": 2.46,
					"enrolment": 535,
					"ligo": 0.57,
					"location": [
						151.080726681959,
						-33.9852992606591
					],
					"name": "Oatley Public School",
					"playspace": 25.3,
					"projections": [
						411,
						535,
						530,
						545,
						540,
						540
					],
					"projections_orig": [
						"411",
						"535",
						"530",
						"545",
						"540",
						"540"
					],
					"projections_percentage": [
						-23.18,
						0,
						-0.93,
						1.87,
						0.93,
						0.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2796
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.36,
					"enrolment": 623,
					"ligo": 0.41,
					"location": [
						151.063068940508,
						-33.9559893767134
					],
					"name": "Peakhurst Public School",
					"playspace": 27.38,
					"projections": [
						511,
						623,
						645,
						680,
						710,
						740
					],
					"projections_orig": [
						"511",
						"623",
						"645",
						"680",
						"710",
						"740"
					],
					"projections_percentage": [
						-17.98,
						0,
						3.53,
						9.15,
						13.96,
						18.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2849
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.27,
					"enrolment": 273,
					"ligo": 0.87,
					"location": [
						151.045804663321,
						-33.9846947142711
					],
					"name": "Lugarno Public School",
					"playspace": 88.59,
					"projections": [
						287,
						273,
						330,
						345,
						355,
						365
					],
					"projections_orig": [
						"287",
						"273",
						"330",
						"345",
						"355",
						"365"
					],
					"projections_percentage": [
						5.13,
						0,
						20.88,
						26.37,
						30.04,
						33.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3796
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 18
					},
					"classroomspace": 2.47,
					"enrolment": 573,
					"ligo": 0.67,
					"location": [
						151.065806730683,
						-33.9785428210383
					],
					"name": "Oatley West Public School",
					"playspace": 22.23,
					"projections": [
						472,
						573,
						545,
						560,
						555,
						550
					],
					"projections_orig": [
						"472",
						"573",
						"545",
						"560",
						"555",
						"550"
					],
					"projections_percentage": [
						-17.63,
						0,
						-4.89,
						-2.27,
						-3.14,
						-4.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3797
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.44,
					"enrolment": 305,
					"ligo": 0.6,
					"location": [
						151.050246678927,
						-33.9620667820048
					],
					"name": "Peakhurst West Public School",
					"playspace": 73.1,
					"projections": [
						340,
						305,
						380,
						400,
						420,
						440
					],
					"projections_orig": [
						"340",
						"305",
						"380",
						"400",
						"420",
						"440"
					],
					"projections_percentage": [
						11.48,
						0,
						24.59,
						31.15,
						37.7,
						44.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4013
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.99,
					"enrolment": 274,
					"ligo": 0.63,
					"location": [
						151.073460636777,
						-33.9618183281781
					],
					"name": "Penshurst West Public School",
					"playspace": 61.74,
					"projections": [
						328,
						274,
						325,
						335,
						335,
						340
					],
					"projections_orig": [
						"328",
						"274",
						"325",
						"335",
						"335",
						"340"
					],
					"projections_percentage": [
						19.71,
						0,
						18.61,
						22.26,
						22.26,
						24.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4051
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.23,
					"enrolment": 259,
					"ligo": 0.55,
					"location": [
						151.055752920708,
						-33.9723618163573
					],
					"name": "Peakhurst South Public School",
					"playspace": 51.29,
					"projections": [
						279,
						259,
						270,
						280,
						285,
						290
					],
					"projections_orig": [
						"279",
						"259",
						"270",
						"280",
						"285",
						"290"
					],
					"projections_percentage": [
						7.72,
						0,
						4.25,
						8.11,
						10.04,
						11.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4323
				}
			],
			"uid": 10042
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 82
			},
			"enrolment": 1990,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Como Primary",
			"playspace": 48.58,
			"projections": [
				1990,
				1995,
				2035,
				2095,
				2135
			],
			"projections_percentage": [
				0,
				0.25,
				2.26,
				5.28,
				7.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.51,
					"enrolment": 104,
					"ligo": 0.47,
					"location": [
						151.068867999244,
						-34.0013468493641
					],
					"name": "Como Public School",
					"playspace": 59.08,
					"projections": [
						61,
						104,
						95,
						95,
						100,
						100
					],
					"projections_orig": [
						"61",
						"104",
						"95",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						-41.35,
						0,
						-8.65,
						-8.65,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1605
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 430,
					"ligo": 0.72,
					"location": [
						151.08088984486,
						-34.0081363829548
					],
					"name": "Oyster Bay Public School",
					"playspace": 24.04,
					"projections": [
						374,
						430,
						425,
						430,
						440,
						450
					],
					"projections_orig": [
						"374",
						"430",
						"425",
						"430",
						"440",
						"450"
					],
					"projections_percentage": [
						-13.02,
						0,
						-1.16,
						0,
						2.33,
						4.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3593
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.21,
					"enrolment": 133,
					"ligo": 0.65,
					"location": [
						151.061545679704,
						-34.0182656231847
					],
					"name": "Jannali Public School",
					"playspace": 87.75,
					"projections": [
						114,
						133,
						150,
						165,
						170,
						175
					],
					"projections_orig": [
						"114",
						"133",
						"150",
						"165",
						"170",
						"175"
					],
					"projections_percentage": [
						-14.29,
						0,
						12.78,
						24.06,
						27.82,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3829
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.93,
					"enrolment": 380,
					"ligo": 0.79,
					"location": [
						151.059695055995,
						-34.0046439732275
					],
					"name": "Como West Public School",
					"playspace": 16.87,
					"projections": [
						334,
						380,
						390,
						390,
						400,
						410
					],
					"projections_orig": [
						"334",
						"380",
						"390",
						"390",
						"400",
						"410"
					],
					"projections_percentage": [
						-12.11,
						0,
						2.63,
						2.63,
						5.26,
						7.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3896
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.17,
					"enrolment": 368,
					"ligo": 0.82,
					"location": [
						151.07277809379,
						-34.0173895442041
					],
					"name": "Jannali East Public School",
					"playspace": 25.97,
					"projections": [
						278,
						368,
						370,
						390,
						405,
						415
					],
					"projections_orig": [
						"278",
						"368",
						"370",
						"390",
						"405",
						"415"
					],
					"projections_percentage": [
						-24.46,
						0,
						0.54,
						5.98,
						10.05,
						12.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4004
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.53,
					"enrolment": 393,
					"ligo": 0.59,
					"location": [
						151.082970673767,
						-34.0135779585641
					],
					"name": "Kareela Public School",
					"playspace": 50.32,
					"projections": [
						341,
						393,
						400,
						400,
						410,
						415
					],
					"projections_orig": [
						"341",
						"393",
						"400",
						"400",
						"410",
						"415"
					],
					"projections_percentage": [
						-13.23,
						0,
						1.78,
						1.78,
						4.33,
						5.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4488
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.66,
					"enrolment": 182,
					"ligo": 0.61,
					"location": [
						151.056130404376,
						-34.0129096602753
					],
					"name": "Bonnet Bay Public School",
					"playspace": 76.05,
					"projections": [
						110,
						182,
						165,
						165,
						170,
						170
					],
					"projections_orig": [
						"110",
						"182",
						"165",
						"165",
						"170",
						"170"
					],
					"projections_percentage": [
						-39.56,
						0,
						-9.34,
						-9.34,
						-6.59,
						-6.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4507
				}
			],
			"uid": 10043
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 57
			},
			"enrolment": 1536,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Sylvania Primary",
			"playspace": 62,
			"projections": [
				1536,
				1635,
				1730,
				1800,
				1840
			],
			"projections_percentage": [
				0,
				6.45,
				12.63,
				17.19,
				19.79
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.87,
					"enrolment": 118,
					"ligo": 0.7,
					"location": [
						151.111313291391,
						-34.0082048111965
					],
					"name": "Sylvania Public School",
					"playspace": 62.77,
					"projections": [
						123,
						118,
						135,
						145,
						150,
						155
					],
					"projections_orig": [
						"123",
						"118",
						"135",
						"145",
						"150",
						"155"
					],
					"projections_percentage": [
						4.24,
						0,
						14.41,
						22.88,
						27.12,
						31.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3143
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.66,
					"enrolment": 83,
					"ligo": 0.44,
					"location": [
						151.123160108264,
						-34.0184867011977
					],
					"name": "Taren Point Public School",
					"playspace": 97.74,
					"projections": [
						81,
						83,
						90,
						95,
						100,
						100
					],
					"projections_orig": [
						"81",
						"83",
						"90",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						-2.41,
						0,
						8.43,
						14.46,
						20.48,
						20.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3168
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 24
					},
					"classroomspace": 2.63,
					"enrolment": 681,
					"ligo": 0.58,
					"location": [
						151.096536087928,
						-34.0130004521173
					],
					"name": "Sylvania Heights Public School",
					"playspace": 35.39,
					"projections": [
						626,
						681,
						700,
						715,
						740,
						755
					],
					"projections_orig": [
						"626",
						"681",
						"700",
						"715",
						"740",
						"755"
					],
					"projections_percentage": [
						-8.08,
						0,
						2.79,
						4.99,
						8.66,
						10.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4024
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 2.66,
					"enrolment": 312,
					"ligo": 0.69,
					"location": [
						151.11211263658,
						-34.0309702195828
					],
					"name": "Miranda North Public School",
					"playspace": 69.92,
					"projections": [
						268,
						312,
						340,
						380,
						405,
						415
					],
					"projections_orig": [
						"268",
						"312",
						"340",
						"380",
						"405",
						"415"
					],
					"projections_percentage": [
						-14.1,
						0,
						8.97,
						21.79,
						29.81,
						33.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4122
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.52,
					"enrolment": 342,
					"ligo": 0.63,
					"location": [
						151.088588571115,
						-34.0256745861275
					],
					"name": "Gymea North Public School",
					"playspace": 44.19,
					"projections": [
						337,
						342,
						370,
						395,
						405,
						415
					],
					"projections_orig": [
						"337",
						"342",
						"370",
						"395",
						"405",
						"415"
					],
					"projections_percentage": [
						-1.46,
						0,
						8.19,
						15.5,
						18.42,
						21.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4389
				}
			],
			"uid": 10044
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 76
			},
			"enrolment": 2177,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Cronulla Primary",
			"playspace": 46.07,
			"projections": [
				2534,
				2560,
				2610,
				2625,
				2640
			],
			"projections_percentage": [
				0,
				1.03,
				3,
				3.59,
				4.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 10
					},
					"classroomspace": 2.85,
					"enrolment": 389,
					"ligo": 0.52,
					"location": [
						151.147021710644,
						-34.0535837974654
					],
					"name": "Cronulla Public School",
					"playspace": 34.04,
					"projections": [
						202,
						389,
						340,
						350,
						355,
						360
					],
					"projections_orig": [
						"202",
						"389",
						"340",
						"350",
						"355",
						"360"
					],
					"projections_percentage": [
						-48.07,
						0,
						-12.6,
						-10.03,
						-8.74,
						-7.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1682
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.61,
					"enrolment": 209,
					"ligo": 0.97,
					"location": [
						151.204713700827,
						-34.0099886133899
					],
					"name": "Kurnell Public School",
					"playspace": 73.89,
					"projections": [
						198,
						209,
						215,
						220,
						220,
						220
					],
					"projections_orig": [
						"198",
						"209",
						"215",
						"220",
						"220",
						"220"
					],
					"projections_percentage": [
						-5.26,
						0,
						2.87,
						5.26,
						5.26,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2341
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.62,
					"enrolment": 318,
					"ligo": 0.68,
					"location": [
						151.153644789394,
						-34.0655568270115
					],
					"name": "Cronulla South Public School",
					"playspace": 24.38,
					"projections": [
						333,
						318,
						350,
						365,
						365,
						370
					],
					"projections_orig": [
						"333",
						"318",
						"350",
						"365",
						"365",
						"370"
					],
					"projections_percentage": [
						4.72,
						0,
						10.06,
						14.78,
						14.78,
						16.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3668
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.6,
					"enrolment": 203,
					"ligo": 0.99,
					"location": [
						151.153218458322,
						-34.0861193944416
					],
					"name": "Bundeena Public School",
					"playspace": 72.01,
					"projections": [
						198,
						203,
						200,
						200,
						200,
						200
					],
					"projections_orig": [
						"198",
						"203",
						"200",
						"200",
						"200",
						"200"
					],
					"projections_percentage": [
						-2.46,
						0,
						-1.48,
						-1.48,
						-1.48,
						-1.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3765
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.3,
					"enrolment": 500,
					"ligo": 0.66,
					"location": [
						151.145538145274,
						-34.0449557944347
					],
					"name": "Woolooware Public School",
					"playspace": 21.89,
					"projections": [
						430,
						500,
						540,
						560,
						570,
						575
					],
					"projections_orig": [
						"430",
						"500",
						"540",
						"560",
						"570",
						"575"
					],
					"projections_percentage": [
						-14,
						0,
						8,
						12,
						14,
						15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3957
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.34,
					"enrolment": 558,
					"ligo": 0.72,
					"location": [
						151.124641492604,
						-34.0367458338082
					],
					"name": "Caringbah North Public School",
					"playspace": 50.22,
					"projections": [
						507,
						915,
						915,
						915,
						915,
						915
					],
					"projections_orig": [
						"507",
						"915",
						"915",
						"915",
						"915",
						"915"
					],
					"projections_percentage": [
						-44.59,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3972
				}
			],
			"uid": 10045
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 65
			},
			"enrolment": 1759,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Lilli Pilli Primary",
			"playspace": 36.11,
			"projections": [
				1759,
				1850,
				1985,
				2030,
				2065
			],
			"projections_percentage": [
				0,
				5.17,
				12.85,
				15.41,
				17.4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.88,
					"enrolment": 281,
					"ligo": 0.52,
					"location": [
						151.122692107321,
						-34.0538921069686
					],
					"name": "Caringbah Public School",
					"playspace": 63.15,
					"projections": [
						298,
						281,
						310,
						340,
						350,
						355
					],
					"projections_orig": [
						"298",
						"281",
						"310",
						"340",
						"350",
						"355"
					],
					"projections_percentage": [
						6.05,
						0,
						10.32,
						21,
						24.56,
						26.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1508
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.36,
					"enrolment": 377,
					"ligo": 0.68,
					"location": [
						151.119103440725,
						-34.0664666617136
					],
					"name": "Lilli Pilli Public School",
					"playspace": 27.27,
					"projections": [
						397,
						377,
						395,
						425,
						435,
						440
					],
					"projections_orig": [
						"397",
						"377",
						"395",
						"425",
						"435",
						"440"
					],
					"projections_percentage": [
						5.31,
						0,
						4.77,
						12.73,
						15.38,
						16.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4084
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.2,
					"enrolment": 464,
					"ligo": 0.74,
					"location": [
						151.112997727985,
						-34.0454893115809
					],
					"name": "Laguna Street Public School",
					"playspace": 38.07,
					"projections": [
						408,
						464,
						455,
						500,
						515,
						530
					],
					"projections_orig": [
						"408",
						"464",
						"455",
						"500",
						"515",
						"530"
					],
					"projections_percentage": [
						-12.07,
						0,
						-1.94,
						7.76,
						10.99,
						14.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4230
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 22
					},
					"classroomspace": 2.66,
					"enrolment": 637,
					"ligo": 0.73,
					"location": [
						151.132469644565,
						-34.0517166992478
					],
					"name": "Burraneer Bay Public School",
					"playspace": 15.94,
					"projections": [
						677,
						637,
						690,
						720,
						730,
						740
					],
					"projections_orig": [
						"677",
						"637",
						"690",
						"720",
						"730",
						"740"
					],
					"projections_percentage": [
						6.28,
						0,
						8.32,
						13.03,
						14.6,
						16.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4259
				}
			],
			"uid": 10046
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 78
			},
			"enrolment": 1988,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Miranda Primary",
			"playspace": 24.64,
			"projections": [
				1988,
				2215,
				2325,
				2455,
				2525
			],
			"projections_percentage": [
				0,
				11.42,
				16.95,
				23.49,
				27.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 2.54,
					"enrolment": 824,
					"ligo": 0.81,
					"location": [
						151.082714570522,
						-34.0459341973764
					],
					"name": "Gymea Bay Public School",
					"playspace": 19.8,
					"projections": [
						846,
						824,
						935,
						980,
						1010,
						1035
					],
					"projections_orig": [
						"846",
						"824",
						"935",
						"980",
						"1010",
						"1035"
					],
					"projections_percentage": [
						2.67,
						0,
						13.47,
						18.93,
						22.57,
						25.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2116
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.38,
					"enrolment": 277,
					"ligo": 0.65,
					"location": [
						151.09698289363,
						-34.0345957014145
					],
					"name": "Miranda Public School",
					"playspace": 45.33,
					"projections": [
						253,
						277,
						320,
						365,
						405,
						425
					],
					"projections_orig": [
						"253",
						"277",
						"320",
						"365",
						"405",
						"425"
					],
					"projections_percentage": [
						-8.66,
						0,
						15.52,
						31.77,
						46.21,
						53.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2574
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 11
					},
					"classroomspace": 2.7,
					"enrolment": 401,
					"ligo": 0.7,
					"location": [
						151.072730872324,
						-34.0592421493878
					],
					"name": "Grays Point Public School",
					"playspace": 16.33,
					"projections": [
						369,
						401,
						420,
						435,
						445,
						455
					],
					"projections_orig": [
						"369",
						"401",
						"420",
						"435",
						"445",
						"455"
					],
					"projections_percentage": [
						-7.98,
						0,
						4.74,
						8.48,
						10.97,
						13.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3914
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.63,
					"enrolment": 486,
					"ligo": 0.63,
					"location": [
						151.102606218363,
						-34.0474821177797
					],
					"name": "Yowie Bay Public School",
					"playspace": 17.12,
					"projections": [
						469,
						486,
						540,
						545,
						595,
						610
					],
					"projections_orig": [
						"469",
						"486",
						"540",
						"545",
						"595",
						"610"
					],
					"projections_percentage": [
						-3.5,
						0,
						11.11,
						12.14,
						22.43,
						25.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4124
				}
			],
			"uid": 10047
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 65
			},
			"enrolment": 1216,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Sutherland Primary",
			"playspace": 52.3,
			"projections": [
				1216,
				1375,
				1500,
				1555,
				1590
			],
			"projections_percentage": [
				0,
				13.08,
				23.36,
				27.88,
				30.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.48,
					"enrolment": 264,
					"ligo": 0.54,
					"location": [
						151.058778005926,
						-34.0331239795281
					],
					"name": "Sutherland Public School",
					"playspace": 37.77,
					"projections": [
						217,
						264,
						310,
						360,
						380,
						395
					],
					"projections_orig": [
						"217",
						"264",
						"310",
						"360",
						"380",
						"395"
					],
					"projections_percentage": [
						-17.8,
						0,
						17.42,
						36.36,
						43.94,
						49.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.55,
					"enrolment": 268,
					"ligo": 0.53,
					"location": [
						151.067800690251,
						-34.0268325530119
					],
					"name": "Sutherland North Public School",
					"playspace": 52.58,
					"projections": [
						222,
						268,
						310,
						355,
						370,
						375
					],
					"projections_orig": [
						"222",
						"268",
						"310",
						"355",
						"370",
						"375"
					],
					"projections_percentage": [
						-17.16,
						0,
						15.67,
						32.46,
						38.06,
						39.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3822
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.45,
					"enrolment": 233,
					"ligo": 0.63,
					"location": [
						151.076270587096,
						-34.0327760637838
					],
					"name": "Kirrawee Public School",
					"playspace": 84.93,
					"projections": [
						235,
						233,
						275,
						300,
						305,
						310
					],
					"projections_orig": [
						"235",
						"233",
						"275",
						"300",
						"305",
						"310"
					],
					"projections_percentage": [
						0.86,
						0,
						18.03,
						28.76,
						30.9,
						33.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4075
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.7,
					"enrolment": 451,
					"ligo": 0.77,
					"location": [
						151.048684790397,
						-34.0463670061095
					],
					"name": "Loftus Public School",
					"playspace": 33.9,
					"projections": [
						504,
						451,
						480,
						485,
						500,
						510
					],
					"projections_orig": [
						"504",
						"451",
						"480",
						"485",
						"500",
						"510"
					],
					"projections_percentage": [
						11.75,
						0,
						6.43,
						7.54,
						10.86,
						13.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4221
				}
			],
			"uid": 10048
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 107
			},
			"enrolment": 2300,
			"level": "Primary",
			"ligo": 0.77,
			"name": "Engadine Primary",
			"playspace": 57.21,
			"projections": [
				2300,
				2345,
				2360,
				2420,
				2465
			],
			"projections_percentage": [
				0,
				1.96,
				2.61,
				5.22,
				7.17
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.27,
					"enrolment": 361,
					"ligo": 0.77,
					"location": [
						151.012889529202,
						-34.0643285075941
					],
					"name": "Engadine Public School",
					"playspace": 40.32,
					"projections": [
						263,
						361,
						340,
						345,
						360,
						375
					],
					"projections_orig": [
						"263",
						"361",
						"340",
						"345",
						"360",
						"375"
					],
					"projections_percentage": [
						-27.15,
						0,
						-5.82,
						-4.43,
						-0.28,
						3.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1845
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.91,
					"enrolment": 320,
					"ligo": 0.79,
					"location": [
						151.006599102054,
						-34.0866373166359
					],
					"name": "Heathcote Public School",
					"playspace": 11.64,
					"projections": [
						277,
						320,
						330,
						335,
						345,
						350
					],
					"projections_orig": [
						"277",
						"320",
						"330",
						"335",
						"345",
						"350"
					],
					"projections_percentage": [
						-13.44,
						0,
						3.12,
						4.69,
						7.81,
						9.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2149
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 5.51,
					"enrolment": 40,
					"ligo": 0.87,
					"location": [
						150.995535123929,
						-34.1374805792819
					],
					"name": "Waterfall Public School",
					"playspace": 154.33,
					"projections": [
						47,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"47",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						17.5,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3396
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 2.32,
					"enrolment": 731,
					"ligo": 0.77,
					"location": [
						151.002831398149,
						-34.0583542141056
					],
					"name": "Engadine West Public School",
					"playspace": 26.12,
					"projections": [
						754,
						731,
						790,
						800,
						820,
						835
					],
					"projections_orig": [
						"754",
						"731",
						"790",
						"800",
						"820",
						"835"
					],
					"projections_percentage": [
						3.15,
						0,
						8.07,
						9.44,
						12.18,
						14.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4292
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.45,
					"enrolment": 296,
					"ligo": 0.69,
					"location": [
						151.027452483266,
						-34.0568365043699
					],
					"name": "Yarrawarrah Public School",
					"playspace": 39.76,
					"projections": [
						179,
						296,
						275,
						275,
						280,
						285
					],
					"projections_orig": [
						"179",
						"296",
						"275",
						"275",
						"280",
						"285"
					],
					"projections_percentage": [
						-39.53,
						0,
						-7.09,
						-7.09,
						-5.41,
						-3.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4298
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.94,
					"enrolment": 427,
					"ligo": 0.72,
					"location": [
						151.024477215941,
						-34.0471976343015
					],
					"name": "Marton Public School",
					"playspace": 46.7,
					"projections": [
						367,
						427,
						435,
						430,
						440,
						445
					],
					"projections_orig": [
						"367",
						"427",
						"435",
						"430",
						"440",
						"445"
					],
					"projections_percentage": [
						-14.05,
						0,
						1.87,
						0.7,
						3.04,
						4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4431
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 4.33,
					"enrolment": 125,
					"ligo": 0.78,
					"location": [
						151.019885732261,
						-34.082655719723
					],
					"name": "Heathcote East Public School",
					"playspace": 81.6,
					"projections": [
						158,
						125,
						135,
						135,
						135,
						135
					],
					"projections_orig": [
						"158",
						"125",
						"135",
						"135",
						"135",
						"135"
					],
					"projections_percentage": [
						26.4,
						0,
						8,
						8,
						8,
						8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5272
				}
			],
			"uid": 10049
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 223
			},
			"enrolment": 2256,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Menai Primary",
			"playspace": 81.24,
			"projections": [
				3006,
				3205,
				3270,
				3330,
				3395
			],
			"projections_percentage": [
				0,
				6.62,
				8.78,
				10.78,
				12.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 9.13,
					"enrolment": 92,
					"ligo": 0.85,
					"location": [
						151.005828307197,
						-34.0122636563891
					],
					"name": "Menai Public School",
					"playspace": 179.46,
					"projections": [
						170,
						92,
						100,
						110,
						110,
						110
					],
					"projections_orig": [
						"170",
						"92",
						"100",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						84.78,
						0,
						8.7,
						19.57,
						19.57,
						19.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2520
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 4.48,
					"enrolment": 109,
					"ligo": 0.84,
					"location": [
						151.041904479547,
						-34.0261821176837
					],
					"name": "Woronora River Public School",
					"playspace": 60.75,
					"projections": [
						121,
						109,
						120,
						125,
						125,
						130
					],
					"projections_orig": [
						"121",
						"109",
						"120",
						"125",
						"125",
						"130"
					],
					"projections_percentage": [
						11.01,
						0,
						10.09,
						14.68,
						14.68,
						19.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.79,
					"enrolment": 207,
					"ligo": 0.58,
					"location": [
						151.043258600633,
						-33.9985420370741
					],
					"name": "Illawong Public School",
					"playspace": 84.69,
					"projections": [
						215,
						207,
						225,
						225,
						225,
						225
					],
					"projections_orig": [
						"215",
						"207",
						"225",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						3.86,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4077
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.6,
					"enrolment": 533,
					"ligo": 0.61,
					"location": [
						151.028801996242,
						-34.0192325771512
					],
					"name": "Bangor Public School",
					"playspace": 37.59,
					"projections": [
						509,
						533,
						530,
						535,
						545,
						550
					],
					"projections_orig": [
						"509",
						"533",
						"530",
						"535",
						"545",
						"550"
					],
					"projections_percentage": [
						-4.5,
						0,
						-0.56,
						0.38,
						2.25,
						3.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4536
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.76,
					"enrolment": 341,
					"ligo": 0.39,
					"location": [
						151.026637853788,
						-34.003297701935
					],
					"name": "Tharawal Public School",
					"playspace": 52.97,
					"projections": [
						350,
						341,
						340,
						345,
						345,
						350
					],
					"projections_orig": [
						"350",
						"341",
						"340",
						"345",
						"345",
						"350"
					],
					"projections_percentage": [
						2.64,
						0,
						-0.29,
						1.17,
						1.17,
						2.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4573
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 224,
					"ligo": 0.59,
					"location": [
						151.024678346599,
						-33.9919094892248
					],
					"name": "Alfords Point Public School",
					"playspace": 81.82,
					"projections": [
						230,
						224,
						240,
						240,
						240,
						240
					],
					"projections_orig": [
						"230",
						"224",
						"240",
						"240",
						"240",
						"240"
					],
					"projections_percentage": [
						2.68,
						0,
						7.14,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4605
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 70
					},
					"classroomspace": 5.79,
					"enrolment": 311,
					"ligo": 0.7,
					"location": [
						151.00674515831,
						-34.0357603468063
					],
					"name": "Lucas Heights Community School",
					"playspace": 63.28,
					"projections": [
						887,
						887,
						750,
						750,
						825,
						825,
						845,
						845,
						870,
						870,
						895,
						895
					],
					"projections_orig": [
						"887",
						"887",
						"750",
						"750",
						"825",
						"825",
						"845",
						"845",
						"870",
						"870",
						"895",
						"895"
					],
					"projections_percentage": [
						0,
						0,
						-15.45,
						-15.45,
						-6.99,
						-6.99,
						-4.74,
						-4.74,
						-1.92,
						-1.92,
						0.9,
						0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8271
				}
			],
			"uid": 10050
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 223
			},
			"enrolment": 2256,
			"level": "Secondary",
			"ligo": 0.66,
			"name": "Menai Primary",
			"playspace": 81.24,
			"projections": [
				3006,
				3205,
				3270,
				3330,
				3395
			],
			"projections_percentage": [
				0,
				6.62,
				8.78,
				10.78,
				12.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 9.13,
					"enrolment": 92,
					"ligo": 0.85,
					"location": [
						151.005828307197,
						-34.0122636563891
					],
					"name": "Menai Public School",
					"playspace": 179.46,
					"projections": [
						170,
						92,
						100,
						110,
						110,
						110
					],
					"projections_orig": [
						"170",
						"92",
						"100",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						84.78,
						0,
						8.7,
						19.57,
						19.57,
						19.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2520
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 4.48,
					"enrolment": 109,
					"ligo": 0.84,
					"location": [
						151.041904479547,
						-34.0261821176837
					],
					"name": "Woronora River Public School",
					"playspace": 60.75,
					"projections": [
						121,
						109,
						120,
						125,
						125,
						130
					],
					"projections_orig": [
						"121",
						"109",
						"120",
						"125",
						"125",
						"130"
					],
					"projections_percentage": [
						11.01,
						0,
						10.09,
						14.68,
						14.68,
						19.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.79,
					"enrolment": 207,
					"ligo": 0.58,
					"location": [
						151.043258600633,
						-33.9985420370741
					],
					"name": "Illawong Public School",
					"playspace": 84.69,
					"projections": [
						215,
						207,
						225,
						225,
						225,
						225
					],
					"projections_orig": [
						"215",
						"207",
						"225",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						3.86,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4077
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.6,
					"enrolment": 533,
					"ligo": 0.61,
					"location": [
						151.028801996242,
						-34.0192325771512
					],
					"name": "Bangor Public School",
					"playspace": 37.59,
					"projections": [
						509,
						533,
						530,
						535,
						545,
						550
					],
					"projections_orig": [
						"509",
						"533",
						"530",
						"535",
						"545",
						"550"
					],
					"projections_percentage": [
						-4.5,
						0,
						-0.56,
						0.38,
						2.25,
						3.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4536
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.76,
					"enrolment": 341,
					"ligo": 0.39,
					"location": [
						151.026637853788,
						-34.003297701935
					],
					"name": "Tharawal Public School",
					"playspace": 52.97,
					"projections": [
						350,
						341,
						340,
						345,
						345,
						350
					],
					"projections_orig": [
						"350",
						"341",
						"340",
						"345",
						"345",
						"350"
					],
					"projections_percentage": [
						2.64,
						0,
						-0.29,
						1.17,
						1.17,
						2.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4573
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 224,
					"ligo": 0.59,
					"location": [
						151.024678346599,
						-33.9919094892248
					],
					"name": "Alfords Point Public School",
					"playspace": 81.82,
					"projections": [
						230,
						224,
						240,
						240,
						240,
						240
					],
					"projections_orig": [
						"230",
						"224",
						"240",
						"240",
						"240",
						"240"
					],
					"projections_percentage": [
						2.68,
						0,
						7.14,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4605
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 70
					},
					"classroomspace": 5.79,
					"enrolment": 311,
					"ligo": 0.7,
					"location": [
						151.00674515831,
						-34.0357603468063
					],
					"name": "Lucas Heights Community School",
					"playspace": 63.28,
					"projections": [
						887,
						887,
						750,
						750,
						825,
						825,
						845,
						845,
						870,
						870,
						895,
						895
					],
					"projections_orig": [
						"887",
						"887",
						"750",
						"750",
						"825",
						"825",
						"845",
						"845",
						"870",
						"870",
						"895",
						"895"
					],
					"projections_percentage": [
						0,
						0,
						-15.45,
						-15.45,
						-6.99,
						-6.99,
						-4.74,
						-4.74,
						-1.92,
						-1.92,
						0.9,
						0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8271
				}
			],
			"uid": 10050
		},
		{
			"classrooms": {
				"demountable": 44,
				"permanent": 128
			},
			"enrolment": 4236,
			"level": "Primary",
			"ligo": 0.78,
			"name": "Narellan Primary",
			"playspace": 47.59,
			"projections": [
				4261,
				4855,
				7205,
				8890,
				10350
			],
			"projections_percentage": [
				0,
				13.94,
				69.09,
				108.64,
				142.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 2.3,
					"enrolment": 276,
					"ligo": 0.61,
					"location": [
						150.686659265721,
						-34.015462683473
					],
					"name": "Cobbitty Public School",
					"playspace": 37.38,
					"projections": [
						219,
						276,
						295,
						660,
						890,
						1115
					],
					"projections_orig": [
						"219",
						"276",
						"295",
						"660",
						"890",
						"1115"
					],
					"projections_percentage": [
						-20.65,
						0,
						6.88,
						139.13,
						222.46,
						303.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1580
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.59,
					"enrolment": 319,
					"ligo": 0.58,
					"location": [
						150.733577461764,
						-34.0415681880667
					],
					"name": "Narellan Public School",
					"playspace": 73.39,
					"projections": [
						285,
						319,
						415,
						500,
						600,
						605
					],
					"projections_orig": [
						"285",
						"319",
						"415",
						"500",
						"600",
						"605"
					],
					"projections_percentage": [
						-10.66,
						0,
						30.09,
						56.74,
						88.09,
						89.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2704
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.43,
					"enrolment": 708,
					"ligo": 0.82,
					"location": [
						150.761308220632,
						-34.060695343667
					],
					"name": "Mount Annan Public School",
					"playspace": 33.57,
					"projections": [
						616,
						708,
						815,
						1045,
						1290,
						1565
					],
					"projections_orig": [
						"616",
						"708",
						"815",
						"1045",
						"1290",
						"1565"
					],
					"projections_percentage": [
						-12.99,
						0,
						15.11,
						47.6,
						82.2,
						121.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4597
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 23
					},
					"classroomspace": 2.4,
					"enrolment": 842,
					"ligo": 0.77,
					"location": [
						150.744571918838,
						-34.0554474784333
					],
					"name": "Narellan Vale Public School",
					"playspace": 23.31,
					"projections": [
						800,
						842,
						1020,
						1320,
						1650,
						2015
					],
					"projections_orig": [
						"800",
						"842",
						"1020",
						"1320",
						"1650",
						"2015"
					],
					"projections_percentage": [
						-4.99,
						0,
						21.14,
						56.77,
						95.96,
						139.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4621
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 16
					},
					"classroomspace": 2.91,
					"enrolment": 587,
					"ligo": 0.82,
					"location": [
						150.770418239192,
						-34.0483375068347
					],
					"name": "Currans Hill Public School",
					"playspace": 35.93,
					"projections": [
						479,
						612,
						665,
						920,
						1190,
						1460
					],
					"projections_orig": [
						"479",
						"612",
						"665",
						"920",
						"1190",
						"1460"
					],
					"projections_percentage": [
						-21.73,
						0,
						8.66,
						50.33,
						94.44,
						138.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4625
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 23
					},
					"classroomspace": 2.39,
					"enrolment": 788,
					"ligo": 0.83,
					"location": [
						150.738709091781,
						-34.0263887301015
					],
					"name": "Harrington Park Public School",
					"playspace": 25.05,
					"projections": [
						806,
						788,
						870,
						1095,
						1355,
						1590
					],
					"projections_orig": [
						"806",
						"788",
						"870",
						"1095",
						"1355",
						"1590"
					],
					"projections_percentage": [
						2.28,
						0,
						10.41,
						38.96,
						71.95,
						101.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4628
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 22
					},
					"classroomspace": 2.93,
					"enrolment": 716,
					"ligo": 0.82,
					"location": [
						150.734876354088,
						-33.9974154525283
					],
					"name": "Oran Park Public School",
					"playspace": 104.51,
					"projections": [
						0,
						716,
						775,
						1665,
						1915,
						2000
					],
					"projections_orig": [
						"0",
						"716",
						"775",
						"1665",
						"1915",
						"2000"
					],
					"projections_percentage": [
						-100,
						0,
						8.24,
						132.54,
						167.46,
						179.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4651
				}
			],
			"uid": 10051
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 74
			},
			"enrolment": 2085,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Macquarie Fields Primary",
			"playspace": 27.11,
			"projections": [
				2085,
				2245,
				2660,
				2860,
				3250
			],
			"projections_percentage": [
				0,
				7.67,
				27.58,
				37.17,
				55.88
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 2.61,
					"enrolment": 605,
					"ligo": 0.6,
					"location": [
						150.867430716969,
						-33.9997482598808
					],
					"name": "Ingleburn Public School",
					"playspace": 21.55,
					"projections": [
						556,
						605,
						640,
						835,
						970,
						1130
					],
					"projections_orig": [
						"556",
						"605",
						"640",
						"835",
						"970",
						"1130"
					],
					"projections_percentage": [
						-8.1,
						0,
						5.79,
						38.02,
						60.33,
						86.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2206
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 25
					},
					"classroomspace": 2.46,
					"enrolment": 944,
					"ligo": 0.83,
					"location": [
						150.881521727451,
						-33.9950183998838
					],
					"name": "Macquarie Fields Public School",
					"playspace": 18.11,
					"projections": [
						683,
						944,
						975,
						1005,
						1005,
						1025
					],
					"projections_orig": [
						"683",
						"944",
						"975",
						"1005",
						"1005",
						"1025"
					],
					"projections_percentage": [
						-27.65,
						0,
						3.28,
						6.46,
						6.46,
						8.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4064
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.03,
					"enrolment": 536,
					"ligo": 0.72,
					"location": [
						150.86300679005,
						-34.0107047373427
					],
					"name": "Sackville Street Public School",
					"playspace": 41.68,
					"projections": [
						537,
						536,
						630,
						820,
						885,
						1095
					],
					"projections_orig": [
						"537",
						"536",
						"630",
						"820",
						"885",
						"1095"
					],
					"projections_percentage": [
						0.19,
						0,
						17.54,
						52.99,
						65.11,
						104.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4491
				}
			],
			"uid": 10052
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 88
			},
			"enrolment": 1801,
			"level": "Primary",
			"ligo": 0.57,
			"name": "Minto Primary",
			"playspace": 55.28,
			"projections": [
				1801,
				1855,
				1995,
				2065,
				2175
			],
			"projections_percentage": [
				0,
				3,
				10.77,
				14.66,
				20.77
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.55,
					"enrolment": 203,
					"ligo": 0.62,
					"location": [
						150.847060919032,
						-34.0292305259858
					],
					"name": "Minto Public School",
					"playspace": 54.74,
					"projections": [
						168,
						203,
						235,
						260,
						280,
						300
					],
					"projections_orig": [
						"168",
						"203",
						"235",
						"260",
						"280",
						"300"
					],
					"projections_percentage": [
						-17.24,
						0,
						15.76,
						28.08,
						37.93,
						47.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2572
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.56,
					"enrolment": 618,
					"ligo": 0.64,
					"location": [
						150.840154111847,
						-34.0499354575497
					],
					"name": "Leumeah Public School",
					"playspace": 31.3,
					"projections": [
						576,
						618,
						685,
						735,
						750,
						785
					],
					"projections_orig": [
						"576",
						"618",
						"685",
						"735",
						"750",
						"785"
					],
					"projections_percentage": [
						-6.8,
						0,
						10.84,
						18.93,
						21.36,
						27.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4058
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.78,
					"enrolment": 245,
					"ligo": 0.62,
					"location": [
						150.848057407769,
						-34.0381884912547
					],
					"name": "Campbellfield Public School",
					"playspace": 90.54,
					"projections": [
						159,
						245,
						230,
						250,
						260,
						275
					],
					"projections_orig": [
						"159",
						"245",
						"230",
						"250",
						"260",
						"275"
					],
					"projections_percentage": [
						-35.1,
						0,
						-6.12,
						2.04,
						6.12,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4490
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 3.54,
					"enrolment": 450,
					"ligo": 0.45,
					"location": [
						150.851202217383,
						-34.0276194871762
					],
					"name": "Sarah Redfern Public School",
					"playspace": 20.38,
					"projections": [
						335,
						450,
						405,
						420,
						430,
						445
					],
					"projections_orig": [
						"335",
						"450",
						"405",
						"420",
						"430",
						"445"
					],
					"projections_percentage": [
						-25.56,
						0,
						-10,
						-6.67,
						-4.44,
						-1.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4509
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.48,
					"enrolment": 285,
					"ligo": 0.52,
					"location": [
						150.857016793422,
						-34.0226200626754
					],
					"name": "The Grange Public School",
					"playspace": 79.46,
					"projections": [
						189,
						285,
						300,
						330,
						345,
						370
					],
					"projections_orig": [
						"189",
						"285",
						"300",
						"330",
						"345",
						"370"
					],
					"projections_percentage": [
						-33.68,
						0,
						5.26,
						15.79,
						21.05,
						29.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4518
				}
			],
			"uid": 10053
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 71
			},
			"enrolment": 1115,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Glenfield Primary",
			"playspace": 87.67,
			"projections": [
				1115,
				1235,
				1295,
				1320,
				1380
			],
			"projections_percentage": [
				0,
				10.76,
				16.14,
				18.39,
				23.77
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 2.48,
					"enrolment": 409,
					"ligo": 0.82,
					"location": [
						150.895843916908,
						-33.9712603357457
					],
					"name": "Glenfield Public School",
					"playspace": 33.5,
					"projections": [
						264,
						409,
						430,
						475,
						505,
						545
					],
					"projections_orig": [
						"264",
						"409",
						"430",
						"475",
						"505",
						"545"
					],
					"projections_percentage": [
						-35.45,
						0,
						5.13,
						16.14,
						23.47,
						33.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2001
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 5.27,
					"enrolment": 276,
					"ligo": 0.58,
					"location": [
						150.898250276534,
						-33.993358350418
					],
					"name": "Curran Public School",
					"playspace": 81.26,
					"projections": [
						280,
						276,
						310,
						300,
						280,
						270
					],
					"projections_orig": [
						"280",
						"276",
						"310",
						"300",
						"280",
						"270"
					],
					"projections_percentage": [
						1.45,
						0,
						12.32,
						8.7,
						1.45,
						-2.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4460
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 8.74,
					"enrolment": 163,
					"ligo": 0.68,
					"location": [
						150.896237563849,
						-33.9865031405672
					],
					"name": "Guise Public School",
					"playspace": 138.34,
					"projections": [
						141,
						163,
						170,
						170,
						170,
						170
					],
					"projections_orig": [
						"141",
						"163",
						"170",
						"170",
						"170",
						"170"
					],
					"projections_percentage": [
						-13.5,
						0,
						4.29,
						4.29,
						4.29,
						4.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4461
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.99,
					"enrolment": 267,
					"ligo": 0.54,
					"location": [
						150.90279236819,
						-33.9752312969404
					],
					"name": "Glenwood Public School",
					"playspace": 97.6,
					"projections": [
						289,
						267,
						325,
						350,
						365,
						395
					],
					"projections_orig": [
						"289",
						"267",
						"325",
						"350",
						"365",
						"395"
					],
					"projections_percentage": [
						8.24,
						0,
						21.72,
						31.09,
						36.7,
						47.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4529
				}
			],
			"uid": 10054
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 94
			},
			"enrolment": 2290,
			"level": "Primary",
			"ligo": 0.69,
			"name": "Campbelltown South Primary",
			"playspace": 49.56,
			"projections": [
				2290,
				2415,
				2830,
				3140,
				3315
			],
			"projections_percentage": [
				0,
				5.46,
				23.58,
				37.12,
				44.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.8,
					"enrolment": 266,
					"ligo": 0.66,
					"location": [
						150.81528348165,
						-34.0978772280444
					],
					"name": "Woodland Road Public School",
					"playspace": 81.53,
					"projections": [
						227,
						266,
						285,
						315,
						335,
						355
					],
					"projections_orig": [
						"227",
						"266",
						"285",
						"315",
						"335",
						"355"
					],
					"projections_percentage": [
						-14.66,
						0,
						7.14,
						18.42,
						25.94,
						33.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4492
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.95,
					"enrolment": 303,
					"ligo": 0.79,
					"location": [
						150.798301885277,
						-34.0873589888571
					],
					"name": "Ambarvale Public School",
					"playspace": 60.74,
					"projections": [
						260,
						303,
						325,
						415,
						500,
						565
					],
					"projections_orig": [
						"260",
						"303",
						"325",
						"415",
						"500",
						"565"
					],
					"projections_percentage": [
						-14.19,
						0,
						7.26,
						36.96,
						65.02,
						86.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4505
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 3,
					"enrolment": 717,
					"ligo": 0.62,
					"location": [
						150.794447624105,
						-34.1041469608988
					],
					"name": "Rosemeadow Public School",
					"playspace": 26.42,
					"projections": [
						568,
						717,
						720,
						865,
						990,
						1075
					],
					"projections_orig": [
						"568",
						"717",
						"720",
						"865",
						"990",
						"1075"
					],
					"projections_percentage": [
						-20.78,
						0,
						0.42,
						20.64,
						38.08,
						49.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4537
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.95,
					"enrolment": 531,
					"ligo": 0.73,
					"location": [
						150.790474874179,
						-34.0934226424436
					],
					"name": "Thomas Acres Public School",
					"playspace": 34.4,
					"projections": [
						524,
						531,
						565,
						710,
						790,
						790
					],
					"projections_orig": [
						"524",
						"531",
						"565",
						"710",
						"790",
						"790"
					],
					"projections_percentage": [
						-1.32,
						0,
						6.4,
						33.71,
						48.78,
						48.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4539
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 473,
					"ligo": 0.67,
					"location": [
						150.803627538148,
						-34.1097819768367
					],
					"name": "St Helens Park Public School",
					"playspace": 44.7,
					"projections": [
						477,
						473,
						520,
						525,
						525,
						530
					],
					"projections_orig": [
						"477",
						"473",
						"520",
						"525",
						"525",
						"530"
					],
					"projections_percentage": [
						0.85,
						0,
						9.94,
						10.99,
						10.99,
						12.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4603
				}
			],
			"uid": 10055
		},
		{
			"classrooms": {
				"demountable": 26,
				"permanent": 84
			},
			"enrolment": 2251,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Camden Primary",
			"playspace": 57.67,
			"projections": [
				2251,
				2500,
				3345,
				4155,
				4715
			],
			"projections_percentage": [
				0,
				11.06,
				48.6,
				84.58,
				109.46
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.72,
					"enrolment": 297,
					"ligo": 0.36,
					"location": [
						150.694218516619,
						-34.0522327715557
					],
					"name": "Camden Public School",
					"playspace": 77.21,
					"projections": [
						306,
						297,
						315,
						430,
						510,
						525
					],
					"projections_orig": [
						"306",
						"297",
						"315",
						"430",
						"510",
						"525"
					],
					"projections_percentage": [
						3.03,
						0,
						6.06,
						44.78,
						71.72,
						76.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1482
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 21
					},
					"classroomspace": 2.81,
					"enrolment": 821,
					"ligo": 0.7,
					"location": [
						150.694590334788,
						-34.0705946799473
					],
					"name": "Camden South Public School",
					"playspace": 23.96,
					"projections": [
						650,
						821,
						800,
						1100,
						1425,
						1735
					],
					"projections_orig": [
						"650",
						"821",
						"800",
						"1100",
						"1425",
						"1735"
					],
					"projections_percentage": [
						-20.83,
						0,
						-2.56,
						33.98,
						73.57,
						111.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4286
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.75,
					"enrolment": 447,
					"ligo": 0.64,
					"location": [
						150.711109329106,
						-34.0613529946601
					],
					"name": "Mawarra Public School",
					"playspace": 47.07,
					"projections": [
						408,
						447,
						500,
						595,
						680,
						700
					],
					"projections_orig": [
						"408",
						"447",
						"500",
						"595",
						"680",
						"700"
					],
					"projections_percentage": [
						-8.72,
						0,
						11.86,
						33.11,
						52.13,
						56.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4466
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 12
					},
					"classroomspace": 2.95,
					"enrolment": 477,
					"ligo": 0.42,
					"location": [
						150.721566695531,
						-34.0559075187287
					],
					"name": "Elderslie Public School",
					"playspace": 37.08,
					"projections": [
						260,
						477,
						460,
						580,
						710,
						810
					],
					"projections_orig": [
						"260",
						"477",
						"460",
						"580",
						"710",
						"810"
					],
					"projections_percentage": [
						-45.49,
						0,
						-3.56,
						21.59,
						48.85,
						69.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4646
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 6.37,
					"enrolment": 209,
					"ligo": 0.94,
					"location": [
						150.721566695531,
						-34.0559075187287
					],
					"name": "Spring Farm Public School",
					"playspace": 103.02,
					"projections": [
						0,
						209,
						425,
						640,
						830,
						945
					],
					"projections_orig": [
						"0",
						"209",
						"425",
						"640",
						"830",
						"945"
					],
					"projections_percentage": [
						-100,
						0,
						103.35,
						206.22,
						297.13,
						352.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4657
				}
			],
			"uid": 10056
		},
		{
			"classrooms": {
				"demountable": 24,
				"permanent": 167
			},
			"enrolment": 3816,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Fairfield Primary",
			"playspace": 28.48,
			"projections": [
				3816,
				3870,
				3875,
				3845,
				3905
			],
			"projections_percentage": [
				0,
				1.42,
				1.55,
				0.76,
				2.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 33
					},
					"classroomspace": 3.15,
					"enrolment": 580,
					"ligo": 0.61,
					"location": [
						150.955281683605,
						-33.8678770198042
					],
					"name": "Fairfield Public School",
					"playspace": 19.73,
					"projections": [
						554,
						580,
						630,
						655,
						685,
						715
					],
					"projections_orig": [
						"554",
						"580",
						"630",
						"655",
						"685",
						"715"
					],
					"projections_percentage": [
						-4.48,
						0,
						8.62,
						12.93,
						18.1,
						23.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1895
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 33
					},
					"classroomspace": 3.23,
					"enrolment": 723,
					"ligo": 0.64,
					"location": [
						150.92522193873,
						-33.8682490060173
					],
					"name": "Fairfield West Public School",
					"playspace": 25.83,
					"projections": [
						662,
						723,
						745,
						730,
						695,
						700
					],
					"projections_orig": [
						"662",
						"723",
						"745",
						"730",
						"695",
						"700"
					],
					"projections_percentage": [
						-8.44,
						0,
						3.04,
						0.97,
						-3.87,
						-3.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1896
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 27
					},
					"classroomspace": 3.28,
					"enrolment": 570,
					"ligo": 0.67,
					"location": [
						150.934772348483,
						-33.853726140249
					],
					"name": "Smithfield Public School",
					"playspace": 34.34,
					"projections": [
						497,
						570,
						550,
						545,
						555,
						565
					],
					"projections_orig": [
						"497",
						"570",
						"550",
						"545",
						"555",
						"565"
					],
					"projections_percentage": [
						-12.81,
						0,
						-3.51,
						-4.39,
						-2.63,
						-0.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3073
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 32
					},
					"classroomspace": 2.85,
					"enrolment": 984,
					"ligo": 0.73,
					"location": [
						150.939778935554,
						-33.8654278349126
					],
					"name": "Fairfield Heights Public School",
					"playspace": 11.91,
					"projections": [
						845,
						984,
						970,
						990,
						955,
						965
					],
					"projections_orig": [
						"845",
						"984",
						"970",
						"990",
						"955",
						"965"
					],
					"projections_percentage": [
						-14.13,
						0,
						-1.42,
						0.61,
						-2.95,
						-1.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3632
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 24
					},
					"classroomspace": 2.41,
					"enrolment": 626,
					"ligo": 0.73,
					"location": [
						150.940755704119,
						-33.8771667705698
					],
					"name": "Fairvale Public School",
					"playspace": 21.18,
					"projections": [
						566,
						626,
						630,
						625,
						625,
						630
					],
					"projections_orig": [
						"566",
						"626",
						"630",
						"625",
						"625",
						"630"
					],
					"projections_percentage": [
						-9.58,
						0,
						0.64,
						-0.16,
						-0.16,
						0.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4009
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.26,
					"enrolment": 333,
					"ligo": 0.67,
					"location": [
						150.916966029498,
						-33.8572980718862
					],
					"name": "Smithfield West Public School",
					"playspace": 57.86,
					"projections": [
						309,
						333,
						345,
						330,
						330,
						330
					],
					"projections_orig": [
						"309",
						"333",
						"345",
						"330",
						"330",
						"330"
					],
					"projections_percentage": [
						-7.21,
						0,
						3.6,
						-0.9,
						-0.9,
						-0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4355
				}
			],
			"uid": 10057
		},
		{
			"classrooms": {
				"demountable": 45,
				"permanent": 198
			},
			"enrolment": 4784,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Bonnyrigg Primary",
			"playspace": 44.22,
			"projections": [
				4784,
				5115,
				4980,
				4765,
				4770
			],
			"projections_percentage": [
				0,
				6.92,
				4.1,
				-0.4,
				-0.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 3.17,
					"enrolment": 418,
					"ligo": 0.73,
					"location": [
						150.882423964681,
						-33.859175742191
					],
					"name": "Bossley Park Public School",
					"playspace": 53.93,
					"projections": [
						382,
						418,
						465,
						450,
						435,
						440
					],
					"projections_orig": [
						"382",
						"418",
						"465",
						"450",
						"435",
						"440"
					],
					"projections_percentage": [
						-8.61,
						0,
						11.24,
						7.66,
						4.07,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1321
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 34
					},
					"classroomspace": 2.93,
					"enrolment": 764,
					"ligo": 0.56,
					"location": [
						150.898998978792,
						-33.8864680443515
					],
					"name": "St Johns Park Public School",
					"playspace": 30.57,
					"projections": [
						782,
						764,
						800,
						780,
						735,
						740
					],
					"projections_orig": [
						"782",
						"764",
						"800",
						"780",
						"735",
						"740"
					],
					"projections_percentage": [
						2.36,
						0,
						4.71,
						2.09,
						-3.8,
						-3.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3029
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 33
					},
					"classroomspace": 2.94,
					"enrolment": 977,
					"ligo": 0.69,
					"location": [
						150.909880528759,
						-33.8882990013686
					],
					"name": "Harrington Street Public School",
					"playspace": 17.6,
					"projections": [
						991,
						977,
						1025,
						1015,
						955,
						940
					],
					"projections_orig": [
						"991",
						"977",
						"1025",
						"1015",
						"955",
						"940"
					],
					"projections_percentage": [
						1.43,
						0,
						4.91,
						3.89,
						-2.25,
						-3.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4314
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 20
					},
					"classroomspace": 2.86,
					"enrolment": 507,
					"ligo": 0.41,
					"location": [
						150.911694550226,
						-33.8793245185741
					],
					"name": "King Park Public School",
					"playspace": 45.26,
					"projections": [
						521,
						507,
						515,
						495,
						485,
						485
					],
					"projections_orig": [
						"521",
						"507",
						"515",
						"495",
						"485",
						"485"
					],
					"projections_percentage": [
						2.76,
						0,
						1.58,
						-2.37,
						-4.34,
						-4.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4467
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.06,
					"enrolment": 252,
					"ligo": 0.45,
					"location": [
						150.887952919576,
						-33.8886651746655
					],
					"name": "Bonnyrigg Public School",
					"playspace": 75.8,
					"projections": [
						232,
						252,
						280,
						270,
						255,
						255
					],
					"projections_orig": [
						"232",
						"252",
						"280",
						"270",
						"255",
						"255"
					],
					"projections_percentage": [
						-7.94,
						0,
						11.11,
						7.14,
						1.19,
						1.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4545
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 20
					},
					"classroomspace": 3.1,
					"enrolment": 459,
					"ligo": 0.51,
					"location": [
						150.890730184434,
						-33.8670984795043
					],
					"name": "Prairievale Public School",
					"playspace": 43.86,
					"projections": [
						422,
						459,
						475,
						455,
						440,
						440
					],
					"projections_orig": [
						"422",
						"459",
						"475",
						"455",
						"440",
						"440"
					],
					"projections_percentage": [
						-8.06,
						0,
						3.49,
						-0.87,
						-4.14,
						-4.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4554
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 18
					},
					"classroomspace": 3.49,
					"enrolment": 541,
					"ligo": 0.47,
					"location": [
						150.905014466369,
						-33.8545263570675
					],
					"name": "William Stimson Public School",
					"playspace": 30.37,
					"projections": [
						567,
						541,
						600,
						580,
						575,
						580
					],
					"projections_orig": [
						"567",
						"541",
						"600",
						"580",
						"575",
						"580"
					],
					"projections_percentage": [
						4.81,
						0,
						10.91,
						7.21,
						6.28,
						7.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4563
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 25
					},
					"classroomspace": 2.95,
					"enrolment": 583,
					"ligo": 0.46,
					"location": [
						150.878813289688,
						-33.8736303999846
					],
					"name": "Governor Philip King Public School",
					"playspace": 39.21,
					"projections": [
						653,
						583,
						640,
						630,
						595,
						595
					],
					"projections_orig": [
						"653",
						"583",
						"640",
						"630",
						"595",
						"595"
					],
					"projections_percentage": [
						12.01,
						0,
						9.78,
						8.06,
						2.06,
						2.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4567
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.99,
					"enrolment": 283,
					"ligo": 0.72,
					"location": [
						150.875893601372,
						-33.8828935537812
					],
					"name": "Edensor Park Public School",
					"playspace": 61.4,
					"projections": [
						279,
						283,
						315,
						305,
						290,
						295
					],
					"projections_orig": [
						"279",
						"283",
						"315",
						"305",
						"290",
						"295"
					],
					"projections_percentage": [
						-1.41,
						0,
						11.31,
						7.77,
						2.47,
						4.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4583
				}
			],
			"uid": 10058
		},
		{
			"classrooms": {
				"demountable": 55,
				"permanent": 136
			},
			"enrolment": 4350,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Bonnyrigg Heights Primary",
			"playspace": 29.12,
			"projections": [
				4350,
				4535,
				5180,
				5770,
				6610
			],
			"projections_percentage": [
				0,
				4.25,
				19.08,
				32.64,
				51.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.72,
					"enrolment": 431,
					"ligo": 0.36,
					"location": [
						150.8683578896,
						-33.9020587286856
					],
					"name": "Green Valley Public School",
					"playspace": 23.07,
					"projections": [
						507,
						431,
						460,
						445,
						420,
						415
					],
					"projections_orig": [
						"507",
						"431",
						"460",
						"445",
						"420",
						"415"
					],
					"projections_percentage": [
						17.63,
						0,
						6.73,
						3.25,
						-2.55,
						-3.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2075
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.62,
					"enrolment": 651,
					"ligo": 0.78,
					"location": [
						150.84858353072,
						-33.9317043767776
					],
					"name": "Hoxton Park Public School",
					"playspace": 29.52,
					"projections": [
						570,
						651,
						765,
						1020,
						1215,
						1400
					],
					"projections_orig": [
						"570",
						"651",
						"765",
						"1020",
						"1215",
						"1400"
					],
					"projections_percentage": [
						-12.44,
						0,
						17.51,
						56.68,
						86.64,
						115.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2187
				},
				{
					"classrooms": {
						"demountable": 23,
						"permanent": 31
					},
					"classroomspace": 3.04,
					"enrolment": 1107,
					"ligo": 0.5,
					"location": [
						150.866779224688,
						-33.8900010525572
					],
					"name": "Bonnyrigg Heights Public School",
					"playspace": 22.36,
					"projections": [
						916,
						1107,
						980,
						980,
						920,
						890
					],
					"projections_orig": [
						"916",
						"1107",
						"980",
						"980",
						"920",
						"890"
					],
					"projections_percentage": [
						-17.25,
						0,
						-11.47,
						-11.47,
						-16.89,
						-19.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4594
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 22
					},
					"classroomspace": 2.26,
					"enrolment": 606,
					"ligo": 0.59,
					"location": [
						150.859391581517,
						-33.912056129619
					],
					"name": "Hinchinbrook Public School",
					"playspace": 51.52,
					"projections": [
						529,
						606,
						585,
						575,
						595,
						660
					],
					"projections_orig": [
						"529",
						"606",
						"585",
						"575",
						"595",
						"660"
					],
					"projections_percentage": [
						-12.71,
						0,
						-3.47,
						-5.12,
						-1.82,
						8.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4613
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 2.63,
					"enrolment": 797,
					"ligo": 0.84,
					"location": [
						150.838096006924,
						-33.9384546409992
					],
					"name": "Greenway Park Public School",
					"playspace": 21.99,
					"projections": [
						767,
						797,
						1010,
						1410,
						1840,
						2385
					],
					"projections_orig": [
						"767",
						"797",
						"1010",
						"1410",
						"1840",
						"2385"
					],
					"projections_percentage": [
						-3.76,
						0,
						26.73,
						76.91,
						130.87,
						199.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4624
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 22
					},
					"classroomspace": 2.71,
					"enrolment": 758,
					"ligo": 0.68,
					"location": [
						150.850787072464,
						-33.8881534990344
					],
					"name": "Cecil Hills Public School",
					"playspace": 26.26,
					"projections": [
						646,
						758,
						735,
						750,
						780,
						860
					],
					"projections_orig": [
						"646",
						"758",
						"735",
						"750",
						"780",
						"860"
					],
					"projections_percentage": [
						-14.78,
						0,
						-3.03,
						-1.06,
						2.9,
						13.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4635
				}
			],
			"uid": 10059
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 14
			},
			"enrolment": 451,
			"level": "Primary",
			"ligo": 0.83,
			"name": "Appin Primary",
			"playspace": 98.84,
			"projections": [
				451,
				460,
				645,
				860,
				1010
			],
			"projections_percentage": [
				0,
				2,
				43.02,
				90.69,
				123.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 2.51,
					"enrolment": 287,
					"ligo": 0.87,
					"location": [
						150.787934456696,
						-34.1996132565375
					],
					"name": "Appin Public School",
					"playspace": 81.44,
					"projections": [
						202,
						287,
						275,
						395,
						520,
						565
					],
					"projections_orig": [
						"202",
						"287",
						"275",
						"395",
						"520",
						"565"
					],
					"projections_percentage": [
						-29.62,
						0,
						-4.18,
						37.63,
						81.18,
						96.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1045
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.87,
					"enrolment": 164,
					"ligo": 0.79,
					"location": [
						150.713398423338,
						-34.1792128787377
					],
					"name": "Douglas Park Public School",
					"playspace": 116.23,
					"projections": [
						144,
						164,
						185,
						250,
						340,
						445
					],
					"projections_orig": [
						"144",
						"164",
						"185",
						"250",
						"340",
						"445"
					],
					"projections_percentage": [
						-12.2,
						0,
						12.8,
						52.44,
						107.32,
						171.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1770
				}
			],
			"uid": 10060
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 178
			},
			"enrolment": 2304,
			"level": "Primary",
			"ligo": 0.67,
			"name": "West Liverpool Primary",
			"playspace": 77.25,
			"projections": [
				2304,
				2400,
				2390,
				2375,
				2410
			],
			"projections_percentage": [
				0,
				4.17,
				3.73,
				3.08,
				4.6
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 4,
					"enrolment": 388,
					"ligo": 0.54,
					"location": [
						150.899160774279,
						-33.8998749544552
					],
					"name": "Mount Pritchard Public School",
					"playspace": 67.47,
					"projections": [
						442,
						388,
						425,
						415,
						395,
						400
					],
					"projections_orig": [
						"442",
						"388",
						"425",
						"415",
						"395",
						"400"
					],
					"projections_percentage": [
						13.92,
						0,
						9.54,
						6.96,
						1.8,
						3.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2648
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.78,
					"enrolment": 239,
					"ligo": 0.87,
					"location": [
						150.911774871981,
						-33.9049336640886
					],
					"name": "Mount Pritchard East Public School",
					"playspace": 52.96,
					"projections": [
						217,
						239,
						250,
						245,
						235,
						235
					],
					"projections_orig": [
						"217",
						"239",
						"250",
						"245",
						"235",
						"235"
					],
					"projections_percentage": [
						-9.21,
						0,
						4.6,
						2.51,
						-1.67,
						-1.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4210
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.13,
					"enrolment": 326,
					"ligo": 0.66,
					"location": [
						150.89086374878,
						-33.9169744117778
					],
					"name": "Sadleir Public School",
					"playspace": 62.85,
					"projections": [
						292,
						326,
						315,
						325,
						335,
						345
					],
					"projections_orig": [
						"292",
						"326",
						"315",
						"325",
						"335",
						"345"
					],
					"projections_percentage": [
						-10.43,
						0,
						-3.37,
						-0.31,
						2.76,
						5.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4319
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.65,
					"enrolment": 217,
					"ligo": 0.75,
					"location": [
						150.890035051024,
						-33.9091629358883
					],
					"name": "Heckenberg Public School",
					"playspace": 100.59,
					"projections": [
						217,
						217,
						235,
						230,
						235,
						235
					],
					"projections_orig": [
						"217",
						"217",
						"235",
						"230",
						"235",
						"235"
					],
					"projections_percentage": [
						0,
						0,
						8.29,
						5.99,
						8.29,
						8.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4336
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 6.43,
					"enrolment": 245,
					"ligo": 0.67,
					"location": [
						150.881287984179,
						-33.9108610937015
					],
					"name": "Busby Public School",
					"playspace": 93.2,
					"projections": [
						251,
						245,
						250,
						250,
						245,
						250
					],
					"projections_orig": [
						"251",
						"245",
						"250",
						"250",
						"245",
						"250"
					],
					"projections_percentage": [
						2.45,
						0,
						2.04,
						2.04,
						0,
						2.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4337
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 5.13,
					"enrolment": 221,
					"ligo": 0.7,
					"location": [
						150.87696311891,
						-33.9220848508684
					],
					"name": "Miller Public School",
					"playspace": 120.17,
					"projections": [
						229,
						221,
						205,
						210,
						220,
						225
					],
					"projections_orig": [
						"229",
						"221",
						"205",
						"210",
						"220",
						"225"
					],
					"projections_percentage": [
						3.62,
						0,
						-7.24,
						-4.98,
						-0.45,
						1.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4338
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 5.95,
					"enrolment": 277,
					"ligo": 0.72,
					"location": [
						150.897159187718,
						-33.9164188683212
					],
					"name": "Ashcroft Public School",
					"playspace": 78.26,
					"projections": [
						265,
						277,
						285,
						290,
						300,
						310
					],
					"projections_orig": [
						"265",
						"277",
						"285",
						"290",
						"300",
						"310"
					],
					"projections_percentage": [
						-4.33,
						0,
						2.89,
						4.69,
						8.3,
						11.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4344
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.61,
					"enrolment": 391,
					"ligo": 0.48,
					"location": [
						150.873428048142,
						-33.9058289104225
					],
					"name": "Busby West Public School",
					"playspace": 42.49,
					"projections": [
						496,
						391,
						435,
						425,
						410,
						410
					],
					"projections_orig": [
						"496",
						"391",
						"435",
						"425",
						"410",
						"410"
					],
					"projections_percentage": [
						26.85,
						0,
						11.25,
						8.7,
						4.86,
						4.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4396
				}
			],
			"uid": 10061
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 96
			},
			"enrolment": 2288,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Liverpool Primary",
			"playspace": 47.12,
			"projections": [
				2288,
				2810,
				3055,
				3255,
				3430
			],
			"projections_percentage": [
				0,
				22.81,
				33.52,
				42.26,
				49.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.36,
					"enrolment": 217,
					"ligo": 0.48,
					"location": [
						150.92954037897,
						-33.9104232176675
					],
					"name": "Warwick Farm Public School",
					"playspace": 119.76,
					"projections": [
						259,
						217,
						280,
						295,
						300,
						305
					],
					"projections_orig": [
						"259",
						"217",
						"280",
						"295",
						"300",
						"305"
					],
					"projections_percentage": [
						19.35,
						0,
						29.03,
						35.94,
						38.25,
						40.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3678
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 26
					},
					"classroomspace": 3.07,
					"enrolment": 638,
					"ligo": 0.63,
					"location": [
						150.907857271028,
						-33.926045778594
					],
					"name": "Liverpool West Public School",
					"playspace": 28.62,
					"projections": [
						571,
						638,
						705,
						755,
						775,
						810
					],
					"projections_orig": [
						"571",
						"638",
						"705",
						"755",
						"775",
						"810"
					],
					"projections_percentage": [
						-10.5,
						0,
						10.5,
						18.34,
						21.47,
						26.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4161
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 26
					},
					"classroomspace": 2.72,
					"enrolment": 688,
					"ligo": 0.78,
					"location": [
						150.91436305925,
						-33.9166178126482
					],
					"name": "Marsden Road Public School",
					"playspace": 28.75,
					"projections": [
						624,
						688,
						815,
						870,
						885,
						910
					],
					"projections_orig": [
						"624",
						"688",
						"815",
						"870",
						"885",
						"910"
					],
					"projections_percentage": [
						-9.3,
						0,
						18.46,
						26.45,
						28.63,
						32.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4278
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 28
					},
					"classroomspace": 2.73,
					"enrolment": 745,
					"ligo": 0.8,
					"location": [
						150.925240905855,
						-33.9235629918419
					],
					"name": "Liverpool Public School",
					"playspace": 11.37,
					"projections": [
						716,
						745,
						1010,
						1135,
						1295,
						1405
					],
					"projections_orig": [
						"716",
						"745",
						"1010",
						"1135",
						"1295",
						"1405"
					],
					"projections_percentage": [
						-3.89,
						0,
						35.57,
						52.35,
						73.83,
						88.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7424
				}
			],
			"uid": 10062
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 114
			},
			"enrolment": 3381,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Edmondson Park Primary",
			"playspace": 43.3,
			"projections": [
				3381,
				3585,
				3990,
				4210,
				4450
			],
			"projections_percentage": [
				0,
				6.03,
				18.01,
				24.52,
				31.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.53,
					"enrolment": 567,
					"ligo": 0.66,
					"location": [
						150.891018489151,
						-33.946661595715
					],
					"name": "Prestons Public School",
					"playspace": 55.14,
					"projections": [
						447,
						567,
						640,
						715,
						760,
						805
					],
					"projections_orig": [
						"447",
						"567",
						"640",
						"715",
						"760",
						"805"
					],
					"projections_percentage": [
						-21.16,
						0,
						12.87,
						26.1,
						34.04,
						41.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2901
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 25
					},
					"classroomspace": 2.59,
					"enrolment": 931,
					"ligo": 0.64,
					"location": [
						150.910254758079,
						-33.9435012704351
					],
					"name": "Casula Public School",
					"playspace": 18.58,
					"projections": [
						692,
						931,
						920,
						980,
						980,
						1000
					],
					"projections_orig": [
						"692",
						"931",
						"920",
						"980",
						"980",
						"1000"
					],
					"projections_percentage": [
						-25.67,
						0,
						-1.18,
						5.26,
						5.26,
						7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4198
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.41,
					"enrolment": 416,
					"ligo": 0.61,
					"location": [
						150.89325511284,
						-33.932175883842
					],
					"name": "Lurnea Public School",
					"playspace": 51.62,
					"projections": [
						424,
						416,
						440,
						480,
						500,
						530
					],
					"projections_orig": [
						"424",
						"416",
						"440",
						"480",
						"500",
						"530"
					],
					"projections_percentage": [
						1.92,
						0,
						5.77,
						15.38,
						20.19,
						27.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4289
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 6
					},
					"classroomspace": 3.02,
					"enrolment": 296,
					"ligo": 0.53,
					"location": [
						150.858809258137,
						-33.9746106852305
					],
					"name": "Bardia Public School",
					"playspace": 45.44,
					"projections": [
						0,
						296,
						275,
						370,
						465,
						500
					],
					"projections_orig": [
						"0",
						"296",
						"275",
						"370",
						"465",
						"500"
					],
					"projections_percentage": [
						-100,
						0,
						-7.09,
						25,
						57.09,
						68.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4311
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 5.07,
					"enrolment": 179,
					"ligo": 0.78,
					"location": [
						150.890352519849,
						-33.9246352416755
					],
					"name": "Cartwright Public School",
					"playspace": 71.72,
					"projections": [
						177,
						179,
						200,
						220,
						235,
						255
					],
					"projections_orig": [
						"177",
						"179",
						"200",
						"220",
						"235",
						"255"
					],
					"projections_percentage": [
						-1.12,
						0,
						11.73,
						22.91,
						31.28,
						42.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4360
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 24
					},
					"classroomspace": 2.9,
					"enrolment": 992,
					"ligo": 0.86,
					"location": [
						150.871860812695,
						-33.9463637040143
					],
					"name": "Dalmeny Public School",
					"playspace": 17.3,
					"projections": [
						936,
						992,
						1110,
						1225,
						1270,
						1360
					],
					"projections_orig": [
						"936",
						"992",
						"1110",
						"1225",
						"1270",
						"1360"
					],
					"projections_percentage": [
						-5.65,
						0,
						11.9,
						23.49,
						28.02,
						37.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4634
				}
			],
			"uid": 10063
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 76
			},
			"enrolment": 1362,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Rossmore Primary",
			"playspace": 133.35,
			"projections": [
				1362,
				1870,
				3055,
				5250,
				9150
			],
			"projections_percentage": [
				0,
				37.3,
				124.3,
				285.46,
				571.81
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.89,
					"enrolment": 271,
					"ligo": 0.7,
					"location": [
						150.812004223568,
						-33.9338326084582
					],
					"name": "Austral Public School",
					"playspace": 83.51,
					"projections": [
						344,
						271,
						460,
						780,
						1375,
						2310
					],
					"projections_orig": [
						"344",
						"271",
						"460",
						"780",
						"1375",
						"2310"
					],
					"projections_percentage": [
						26.94,
						0,
						69.74,
						187.82,
						407.38,
						752.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1077
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 3.34,
					"enrolment": 134,
					"ligo": 0.72,
					"location": [
						150.731151462594,
						-33.9390327150911
					],
					"name": "Bringelly Public School",
					"playspace": 153.05,
					"projections": [
						139,
						134,
						200,
						225,
						695,
						1580
					],
					"projections_orig": [
						"139",
						"134",
						"200",
						"225",
						"695",
						"1580"
					],
					"projections_percentage": [
						3.73,
						0,
						49.25,
						67.91,
						418.66,
						1079.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1360
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 4
					},
					"classroomspace": 4.88,
					"enrolment": 102,
					"ligo": 0.58,
					"location": [
						150.852064674412,
						-33.841038345282
					],
					"name": "Horsley Park Public School",
					"playspace": 280.76,
					"projections": [
						105,
						102,
						110,
						135,
						165,
						195
					],
					"projections_orig": [
						"105",
						"102",
						"110",
						"135",
						"165",
						"195"
					],
					"projections_percentage": [
						2.94,
						0,
						7.84,
						32.35,
						61.76,
						91.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2182
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.46,
					"enrolment": 83,
					"ligo": 0.81,
					"location": [
						150.691840025966,
						-33.8812260223337
					],
					"name": "Luddenham Public School",
					"playspace": 115.93,
					"projections": [
						81,
						83,
						110,
						125,
						150,
						180
					],
					"projections_orig": [
						"81",
						"83",
						"110",
						"125",
						"150",
						"180"
					],
					"projections_percentage": [
						-2.41,
						0,
						32.53,
						50.6,
						80.72,
						116.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2431
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.6,
					"enrolment": 152,
					"ligo": 0.53,
					"location": [
						150.810102737333,
						-33.9589513252469
					],
					"name": "Leppington Public School",
					"playspace": 160.82,
					"projections": [
						109,
						152,
						275,
						925,
						1635,
						2795
					],
					"projections_orig": [
						"109",
						"152",
						"275",
						"925",
						"1635",
						"2795"
					],
					"projections_percentage": [
						-28.29,
						0,
						80.92,
						508.55,
						975.66,
						1738.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2926
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 7.26,
					"enrolment": 99,
					"ligo": 0.55,
					"location": [
						150.770618344389,
						-33.9458291823145
					],
					"name": "Rossmore Public School",
					"playspace": 90.14,
					"projections": [
						144,
						99,
						215,
						275,
						490,
						1025
					],
					"projections_orig": [
						"144",
						"99",
						"215",
						"275",
						"490",
						"1025"
					],
					"projections_percentage": [
						45.45,
						0,
						117.17,
						177.78,
						394.95,
						935.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2999
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.63,
					"enrolment": 161,
					"ligo": 0.64,
					"location": [
						150.79030754117,
						-33.8839237682524
					],
					"name": "Kemps Creek Public School",
					"playspace": 120.99,
					"projections": [
						156,
						161,
						165,
						175,
						255,
						525
					],
					"projections_orig": [
						"156",
						"161",
						"165",
						"175",
						"255",
						"525"
					],
					"projections_percentage": [
						-3.11,
						0,
						2.48,
						8.7,
						58.39,
						226.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3615
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.03,
					"enrolment": 360,
					"ligo": 0.65,
					"location": [
						150.848804697493,
						-33.9177123427688
					],
					"name": "Middleton Grange Public School",
					"playspace": 61.57,
					"projections": [
						138,
						360,
						335,
						415,
						485,
						540
					],
					"projections_orig": [
						"138",
						"360",
						"335",
						"415",
						"485",
						"540"
					],
					"projections_percentage": [
						-61.67,
						0,
						-6.94,
						15.28,
						34.72,
						50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4647
				}
			],
			"uid": 10064
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 124
			},
			"enrolment": 3121,
			"level": "Primary",
			"ligo": 0.55,
			"name": "Chipping Norton Primary",
			"playspace": 42.29,
			"projections": [
				3121,
				3190,
				3325,
				3375,
				3465
			],
			"projections_percentage": [
				0,
				2.21,
				6.54,
				8.14,
				11.02
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.79,
					"enrolment": 327,
					"ligo": 0.38,
					"location": [
						150.960570865657,
						-33.908802956448
					],
					"name": "Chipping Norton Public School",
					"playspace": 60.02,
					"projections": [
						268,
						327,
						350,
						365,
						370,
						375
					],
					"projections_orig": [
						"268",
						"327",
						"350",
						"365",
						"370",
						"375"
					],
					"projections_percentage": [
						-18.04,
						0,
						7.03,
						11.62,
						13.15,
						14.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1560
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.92,
					"enrolment": 453,
					"ligo": 0.62,
					"location": [
						150.954583929942,
						-33.9481320579308
					],
					"name": "Hammondville Public School",
					"playspace": 45.91,
					"projections": [
						506,
						453,
						470,
						480,
						480,
						490
					],
					"projections_orig": [
						"506",
						"453",
						"470",
						"480",
						"480",
						"490"
					],
					"projections_percentage": [
						11.7,
						0,
						3.75,
						5.96,
						5.96,
						8.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2128
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 19
					},
					"classroomspace": 2.5,
					"enrolment": 619,
					"ligo": 0.54,
					"location": [
						150.936921557423,
						-33.9584932111104
					],
					"name": "Wattle Grove Public School",
					"playspace": 34.46,
					"projections": [
						548,
						619,
						620,
						635,
						640,
						655
					],
					"projections_orig": [
						"548",
						"619",
						"620",
						"635",
						"640",
						"655"
					],
					"projections_percentage": [
						-11.47,
						0,
						0.16,
						2.58,
						3.39,
						5.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3871
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.43,
					"enrolment": 686,
					"ligo": 0.53,
					"location": [
						150.953258838289,
						-33.9562751127164
					],
					"name": "Holsworthy Public School",
					"playspace": 46.38,
					"projections": [
						570,
						686,
						685,
						700,
						705,
						720
					],
					"projections_orig": [
						"570",
						"686",
						"685",
						"700",
						"705",
						"720"
					],
					"projections_percentage": [
						-16.91,
						0,
						-0.15,
						2.04,
						2.77,
						4.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4288
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.09,
					"enrolment": 401,
					"ligo": 0.75,
					"location": [
						150.951629934662,
						-33.9327402493539
					],
					"name": "Nuwarra Public School",
					"playspace": 37.93,
					"projections": [
						319,
						401,
						410,
						455,
						480,
						510
					],
					"projections_orig": [
						"319",
						"401",
						"410",
						"455",
						"480",
						"510"
					],
					"projections_percentage": [
						-20.45,
						0,
						2.24,
						13.47,
						19.7,
						27.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4420
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 23
					},
					"classroomspace": 2.59,
					"enrolment": 635,
					"ligo": 0.47,
					"location": [
						150.952176983889,
						-33.9256387066161
					],
					"name": "Newbridge Heights Public School",
					"playspace": 29.06,
					"projections": [
						595,
						635,
						655,
						690,
						700,
						715
					],
					"projections_orig": [
						"595",
						"635",
						"655",
						"690",
						"700",
						"715"
					],
					"projections_percentage": [
						-6.3,
						0,
						3.15,
						8.66,
						10.24,
						12.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4499
				}
			],
			"uid": 10065
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 88
			},
			"enrolment": 2126,
			"level": "Primary",
			"ligo": 0.74,
			"name": "Picton Primary",
			"playspace": 87.29,
			"projections": [
				2126,
				2279,
				2509,
				2709,
				2944
			],
			"projections_percentage": [
				0,
				7.2,
				18.02,
				27.42,
				38.48
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.54,
					"enrolment": 351,
					"ligo": 0.82,
					"location": [
						150.582333657521,
						-34.2933847727368
					],
					"name": "Bargo Public School",
					"playspace": 52.81,
					"projections": [
						381,
						351,
						355,
						370,
						370,
						370
					],
					"projections_orig": [
						"381",
						"351",
						"355",
						"370",
						"370",
						"370"
					],
					"projections_percentage": [
						8.55,
						0,
						1.14,
						5.41,
						5.41,
						5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1134
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.1,
					"enrolment": 170,
					"ligo": 0.84,
					"location": [
						150.543424630778,
						-34.2473394563535
					],
					"name": "Buxton Public School",
					"playspace": 142.61,
					"projections": [
						183,
						170,
						180,
						185,
						185,
						185
					],
					"projections_orig": [
						"183",
						"170",
						"180",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						7.65,
						0,
						5.88,
						8.82,
						8.82,
						8.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1460
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 14
					},
					"classroomspace": 3.02,
					"enrolment": 380,
					"ligo": 0.7,
					"location": [
						150.609406637959,
						-34.1760105230226
					],
					"name": "Picton Public School",
					"playspace": 28.12,
					"projections": [
						484,
						380,
						490,
						555,
						600,
						640
					],
					"projections_orig": [
						"484",
						"380",
						"490",
						"555",
						"600",
						"640"
					],
					"projections_percentage": [
						27.37,
						0,
						28.95,
						46.05,
						57.89,
						68.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2867
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.76,
					"enrolment": 398,
					"ligo": 0.66,
					"location": [
						150.589437897989,
						-34.2271017344063
					],
					"name": "Tahmoor Public School",
					"playspace": 55.36,
					"projections": [
						344,
						398,
						400,
						420,
						430,
						445
					],
					"projections_orig": [
						"344",
						"398",
						"400",
						"420",
						"430",
						"445"
					],
					"projections_percentage": [
						-13.57,
						0,
						0.5,
						5.53,
						8.04,
						11.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3148
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.43,
					"enrolment": 381,
					"ligo": 0.68,
					"location": [
						150.569539864734,
						-34.2040585847635
					],
					"name": "Thirlmere Public School",
					"playspace": 32.65,
					"projections": [
						351,
						381,
						385,
						405,
						410,
						415
					],
					"projections_orig": [
						"351",
						"381",
						"385",
						"405",
						"410",
						"415"
					],
					"projections_percentage": [
						-7.87,
						0,
						1.05,
						6.3,
						7.61,
						8.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3200
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5,
					"enrolment": 39,
					"ligo": 0.79,
					"location": [
						150.571280242992,
						-34.3209896620632
					],
					"name": "Yanderra Public School",
					"playspace": 245.79,
					"projections": [
						53,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"53",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						35.9,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3537
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 3.3,
					"enrolment": 407,
					"ligo": 0.69,
					"location": [
						150.684819117204,
						-34.2287892310207
					],
					"name": "Wilton Public School",
					"playspace": 53.66,
					"projections": [
						79,
						407,
						430,
						535,
						675,
						850
					],
					"projections_orig": [
						"79",
						"407",
						"430",
						"535",
						"675",
						"850"
					],
					"projections_percentage": [
						-80.59,
						0,
						5.65,
						31.45,
						65.85,
						108.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4650
				}
			],
			"uid": 10066
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 24
			},
			"enrolment": 578,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Cawdor Primary",
			"playspace": 102.77,
			"projections": [
				578,
				597,
				835,
				1065,
				1280
			],
			"projections_percentage": [
				0,
				3.29,
				44.46,
				84.26,
				121.45
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.26,
					"enrolment": 83,
					"ligo": 0.11,
					"location": [
						150.673887862265,
						-34.110212288967
					],
					"name": "Cawdor Public School",
					"playspace": 50,
					"projections": [
						59,
						83,
						80,
						110,
						135,
						155
					],
					"projections_orig": [
						"59",
						"83",
						"80",
						"110",
						"135",
						"155"
					],
					"projections_percentage": [
						-28.92,
						0,
						-3.61,
						32.53,
						62.65,
						86.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1537
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.66,
					"enrolment": 32,
					"ligo": 0.62,
					"location": [
						150.636099229439,
						-34.0712334417275
					],
					"name": "Mount Hunter Public School",
					"playspace": 239.54,
					"projections": [
						36,
						32,
						25,
						65,
						80,
						90
					],
					"projections_orig": [
						"36",
						"32",
						"<50",
						"65",
						"80",
						"90"
					],
					"projections_percentage": [
						12.5,
						0,
						-21.88,
						103.12,
						150,
						181.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2640
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.52,
					"enrolment": 152,
					"ligo": 0.85,
					"location": [
						150.508550975815,
						-34.079495760483
					],
					"name": "Oakdale Public School",
					"playspace": 83.8,
					"projections": [
						167,
						152,
						185,
						250,
						320,
						395
					],
					"projections_orig": [
						"167",
						"152",
						"185",
						"250",
						"320",
						"395"
					],
					"projections_percentage": [
						9.87,
						0,
						21.71,
						64.47,
						110.53,
						159.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2789
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.3,
					"enrolment": 311,
					"ligo": 0.88,
					"location": [
						150.571529579697,
						-34.0789236166551
					],
					"name": "The Oaks Public School",
					"playspace": 37.76,
					"projections": [
						300,
						311,
						300,
						410,
						530,
						640
					],
					"projections_orig": [
						"300",
						"311",
						"300",
						"410",
						"530",
						"640"
					],
					"projections_percentage": [
						-3.54,
						0,
						-3.54,
						31.83,
						70.42,
						105.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2793
				}
			],
			"uid": 10067
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 151
			},
			"enrolment": 2628,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Campbelltown Primary",
			"playspace": 68.76,
			"projections": [
				2628,
				3100,
				3360,
				3665,
				3990
			],
			"projections_percentage": [
				0,
				17.96,
				27.85,
				39.46,
				51.83
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.98,
					"enrolment": 319,
					"ligo": 0.74,
					"location": [
						150.81582082112,
						-34.0695569243044
					],
					"name": "Campbelltown Public School",
					"playspace": 30.91,
					"projections": [
						317,
						319,
						415,
						490,
						590,
						700
					],
					"projections_orig": [
						"317",
						"319",
						"415",
						"490",
						"590",
						"700"
					],
					"projections_percentage": [
						-0.63,
						0,
						30.09,
						53.61,
						84.95,
						119.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1486
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 3
					},
					"classroomspace": 2.96,
					"enrolment": 155,
					"ligo": 0.65,
					"location": [
						150.859316785257,
						-34.0727965918979
					],
					"name": "Kentlyn Public School",
					"playspace": 54.49,
					"projections": [
						124,
						155,
						165,
						170,
						175,
						180
					],
					"projections_orig": [
						"124",
						"155",
						"165",
						"170",
						"175",
						"180"
					],
					"projections_percentage": [
						-20,
						0,
						6.45,
						9.68,
						12.9,
						16.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2285
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.87,
					"enrolment": 333,
					"ligo": 0.6,
					"location": [
						150.825779742908,
						-34.0615622236796
					],
					"name": "Campbelltown North Public School",
					"playspace": 115.5,
					"projections": [
						367,
						333,
						445,
						490,
						575,
						665
					],
					"projections_orig": [
						"367",
						"333",
						"445",
						"490",
						"575",
						"665"
					],
					"projections_percentage": [
						10.21,
						0,
						33.63,
						47.15,
						72.67,
						99.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4126
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.06,
					"enrolment": 306,
					"ligo": 0.81,
					"location": [
						150.830647627643,
						-34.0720954150123
					],
					"name": "Campbelltown East Public School",
					"playspace": 76.13,
					"projections": [
						288,
						306,
						325,
						325,
						375,
						400
					],
					"projections_orig": [
						"288",
						"306",
						"325",
						"325",
						"375",
						"400"
					],
					"projections_percentage": [
						-5.88,
						0,
						6.21,
						6.21,
						22.55,
						30.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4277
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.54,
					"enrolment": 622,
					"ligo": 0.61,
					"location": [
						150.813812072714,
						-34.0864920469936
					],
					"name": "Bradbury Public School",
					"playspace": 47.18,
					"projections": [
						622,
						622,
						725,
						810,
						855,
						905
					],
					"projections_orig": [
						"622",
						"622",
						"725",
						"810",
						"855",
						"905"
					],
					"projections_percentage": [
						0,
						0,
						16.56,
						30.23,
						37.46,
						45.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4403
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.6,
					"enrolment": 266,
					"ligo": 0.66,
					"location": [
						150.82790495156,
						-34.088223869914
					],
					"name": "Briar Road Public School",
					"playspace": 67.56,
					"projections": [
						297,
						266,
						310,
						325,
						335,
						350
					],
					"projections_orig": [
						"297",
						"266",
						"310",
						"325",
						"335",
						"350"
					],
					"projections_percentage": [
						11.65,
						0,
						16.54,
						22.18,
						25.94,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4458
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 5.11,
					"enrolment": 207,
					"ligo": 0.61,
					"location": [
						150.833504043669,
						-34.082160177693
					],
					"name": "John Warby Public School",
					"playspace": 94.15,
					"projections": [
						308,
						207,
						245,
						260,
						265,
						280
					],
					"projections_orig": [
						"308",
						"207",
						"245",
						"260",
						"265",
						"280"
					],
					"projections_percentage": [
						48.79,
						0,
						18.36,
						25.6,
						28.02,
						35.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4479
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.34,
					"enrolment": 420,
					"ligo": 0.68,
					"location": [
						150.842525609621,
						-34.0671940345251
					],
					"name": "Ruse Public School",
					"playspace": 64.13,
					"projections": [
						382,
						420,
						470,
						490,
						495,
						510
					],
					"projections_orig": [
						"382",
						"420",
						"470",
						"490",
						"495",
						"510"
					],
					"projections_percentage": [
						-9.05,
						0,
						11.9,
						16.67,
						17.86,
						21.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4489
				}
			],
			"uid": 10068
		},
		{
			"classrooms": {
				"demountable": 24,
				"permanent": 180
			},
			"enrolment": 3537,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Cabramatta Primary",
			"playspace": 46.23,
			"projections": [
				3537,
				3770,
				3780,
				3630,
				3675
			],
			"projections_percentage": [
				0,
				6.59,
				6.87,
				2.63,
				3.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 3.38,
					"enrolment": 715,
					"ligo": 0.39,
					"location": [
						150.941797949178,
						-33.8962446974902
					],
					"name": "Cabramatta Public School",
					"playspace": 19.35,
					"projections": [
						792,
						715,
						835,
						875,
						840,
						855
					],
					"projections_orig": [
						"792",
						"715",
						"835",
						"875",
						"840",
						"855"
					],
					"projections_percentage": [
						10.77,
						0,
						16.78,
						22.38,
						17.48,
						19.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1472
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 43
					},
					"classroomspace": 3.44,
					"enrolment": 874,
					"ligo": 0.67,
					"location": [
						150.938627279339,
						-33.8861973075158
					],
					"name": "Canley Vale Public School",
					"playspace": 16.73,
					"projections": [
						930,
						874,
						910,
						910,
						870,
						880
					],
					"projections_orig": [
						"930",
						"874",
						"910",
						"910",
						"870",
						"880"
					],
					"projections_percentage": [
						6.41,
						0,
						4.12,
						4.12,
						-0.46,
						0.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1494
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 3.58,
					"enrolment": 562,
					"ligo": 0.74,
					"location": [
						150.922324998431,
						-33.8962032711731
					],
					"name": "Cabramatta West Public School",
					"playspace": 47.66,
					"projections": [
						569,
						562,
						620,
						615,
						585,
						590
					],
					"projections_orig": [
						"569",
						"562",
						"620",
						"615",
						"585",
						"590"
					],
					"projections_percentage": [
						1.25,
						0,
						10.32,
						9.43,
						4.09,
						4.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3980
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 3.17,
					"enrolment": 550,
					"ligo": 0.75,
					"location": [
						150.921730069824,
						-33.8853066708831
					],
					"name": "Canley Heights Public School",
					"playspace": 30.74,
					"projections": [
						572,
						550,
						610,
						600,
						580,
						590
					],
					"projections_orig": [
						"572",
						"550",
						"610",
						"600",
						"580",
						"590"
					],
					"projections_percentage": [
						4,
						0,
						10.91,
						9.09,
						5.45,
						7.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3983
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 7
					},
					"classroomspace": 4.46,
					"enrolment": 151,
					"ligo": 0.72,
					"location": [
						150.964616145768,
						-33.898300056327
					],
					"name": "Lansvale East Public School",
					"playspace": 144.84,
					"projections": [
						104,
						151,
						120,
						115,
						115,
						115
					],
					"projections_orig": [
						"104",
						"151",
						"120",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						-31.13,
						0,
						-20.53,
						-23.84,
						-23.84,
						-23.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4391
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 25
					},
					"classroomspace": 3.02,
					"enrolment": 685,
					"ligo": 0.73,
					"location": [
						150.952888492766,
						-33.8917435264393
					],
					"name": "Lansvale Public School",
					"playspace": 18.03,
					"projections": [
						704,
						685,
						675,
						665,
						640,
						645
					],
					"projections_orig": [
						"704",
						"685",
						"675",
						"665",
						"640",
						"645"
					],
					"projections_percentage": [
						2.77,
						0,
						-1.46,
						-2.92,
						-6.57,
						-5.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5220
				}
			],
			"uid": 10069
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 117
			},
			"enrolment": 2733,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Raby Road Primary",
			"playspace": 65.08,
			"projections": [
				2733,
				3210,
				4235,
				5320,
				6280
			],
			"projections_percentage": [
				0,
				17.45,
				54.96,
				94.66,
				129.78
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 33
					},
					"classroomspace": 2.6,
					"enrolment": 805,
					"ligo": 0.58,
					"location": [
						150.831097801242,
						-34.0218562650923
					],
					"name": "St Andrews Public School",
					"playspace": 22.67,
					"projections": [
						701,
						805,
						830,
						885,
						895,
						895
					],
					"projections_orig": [
						"701",
						"805",
						"830",
						"885",
						"895",
						"895"
					],
					"projections_percentage": [
						-12.92,
						0,
						3.11,
						9.94,
						11.18,
						11.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4481
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.96,
					"enrolment": 309,
					"ligo": 0.62,
					"location": [
						150.808690757717,
						-34.0434935998198
					],
					"name": "Claymore Public School",
					"playspace": 117.05,
					"projections": [
						403,
						309,
						375,
						530,
						700,
						840
					],
					"projections_orig": [
						"403",
						"309",
						"375",
						"530",
						"700",
						"840"
					],
					"projections_percentage": [
						30.42,
						0,
						21.36,
						71.52,
						126.54,
						171.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4510
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 2.54,
					"enrolment": 519,
					"ligo": 0.62,
					"location": [
						150.803151526146,
						-34.0488259255401
					],
					"name": "Blairmount Public School",
					"playspace": 45.36,
					"projections": [
						487,
						519,
						625,
						980,
						1480,
						2025
					],
					"projections_orig": [
						"487",
						"519",
						"625",
						"980",
						"1480",
						"2025"
					],
					"projections_percentage": [
						-6.17,
						0,
						20.42,
						88.82,
						185.16,
						290.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4535
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.72,
					"enrolment": 346,
					"ligo": 0.79,
					"location": [
						150.810304947558,
						-34.0280439926067
					],
					"name": "Eschol Park Public School",
					"playspace": 66.13,
					"projections": [
						355,
						346,
						350,
						455,
						545,
						620
					],
					"projections_orig": [
						"355",
						"346",
						"350",
						"455",
						"545",
						"620"
					],
					"projections_percentage": [
						2.6,
						0,
						1.16,
						31.5,
						57.51,
						79.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4558
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.57,
					"enrolment": 553,
					"ligo": 0.69,
					"location": [
						150.818838325561,
						-34.0161966521858
					],
					"name": "Robert Townson Public School",
					"playspace": 19.81,
					"projections": [
						580,
						553,
						795,
						1040,
						1250,
						1385
					],
					"projections_orig": [
						"580",
						"553",
						"795",
						"1040",
						"1250",
						"1385"
					],
					"projections_percentage": [
						4.88,
						0,
						43.76,
						88.07,
						126.04,
						150.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4569
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 5
					},
					"classroomspace": 2.99,
					"enrolment": 201,
					"ligo": 0.58,
					"location": [
						150.805032507808,
						-34.0222586190498
					],
					"name": "Kearns Public School",
					"playspace": 119.46,
					"projections": [
						203,
						201,
						235,
						345,
						450,
						515
					],
					"projections_orig": [
						"203",
						"201",
						"235",
						"345",
						"450",
						"515"
					],
					"projections_percentage": [
						1,
						0,
						16.92,
						71.64,
						123.88,
						156.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4593
				}
			],
			"uid": 10070
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 54
			},
			"enrolment": 1129,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Villawood Primary",
			"playspace": 92.74,
			"projections": [
				1129,
				1190,
				1260,
				1270,
				1310
			],
			"projections_percentage": [
				0,
				5.4,
				11.6,
				12.49,
				16.03
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 17
					},
					"classroomspace": 2.84,
					"enrolment": 452,
					"ligo": 0.35,
					"location": [
						150.986737710407,
						-33.8670170377887
					],
					"name": "Old Guildford Public School",
					"playspace": 30.72,
					"projections": [
						298,
						452,
						430,
						470,
						480,
						495
					],
					"projections_orig": [
						"298",
						"452",
						"430",
						"470",
						"480",
						"495"
					],
					"projections_percentage": [
						-34.07,
						0,
						-4.87,
						3.98,
						6.19,
						9.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2801
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3,
					"enrolment": 229,
					"ligo": 0.78,
					"location": [
						150.969928496161,
						-33.8857205787205
					],
					"name": "Carramar Public School",
					"playspace": 112.12,
					"projections": [
						244,
						229,
						270,
						275,
						275,
						285
					],
					"projections_orig": [
						"244",
						"229",
						"270",
						"275",
						"275",
						"285"
					],
					"projections_percentage": [
						6.55,
						0,
						17.9,
						20.09,
						20.09,
						24.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3328
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.85,
					"enrolment": 187,
					"ligo": 0.6,
					"location": [
						150.971446487537,
						-33.8652687119429
					],
					"name": "Yennora Public School",
					"playspace": 155.15,
					"projections": [
						163,
						187,
						195,
						205,
						205,
						210
					],
					"projections_orig": [
						"163",
						"187",
						"195",
						"205",
						"205",
						"210"
					],
					"projections_percentage": [
						-12.83,
						0,
						4.28,
						9.63,
						9.63,
						12.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3986
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.26,
					"enrolment": 261,
					"ligo": 0.71,
					"location": [
						150.971968664959,
						-33.8778743504033
					],
					"name": "Villawood North Public School",
					"playspace": 72.98,
					"projections": [
						296,
						261,
						295,
						310,
						310,
						320
					],
					"projections_orig": [
						"296",
						"261",
						"295",
						"310",
						"310",
						"320"
					],
					"projections_percentage": [
						13.41,
						0,
						13.03,
						18.77,
						18.77,
						22.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4065
				}
			],
			"uid": 10071
		},
		{
			"classrooms": {
				"demountable": 24,
				"permanent": 85
			},
			"enrolment": 2472,
			"level": "Primary",
			"ligo": 0.75,
			"name": "Glenmore Park Primary",
			"playspace": 72.81,
			"projections": [
				2472,
				2665,
				2820,
				2940,
				3080
			],
			"projections_percentage": [
				0,
				7.81,
				14.08,
				18.93,
				24.6
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.33,
					"enrolment": 83,
					"ligo": 0.74,
					"location": [
						150.651431593947,
						-33.8361749760247
					],
					"name": "Mulgoa Public School",
					"playspace": 153.98,
					"projections": [
						80,
						83,
						100,
						100,
						105,
						110
					],
					"projections_orig": [
						"80",
						"83",
						"100",
						"100",
						"105",
						"110"
					],
					"projections_percentage": [
						-3.61,
						0,
						20.48,
						20.48,
						26.51,
						32.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2659
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 2.51,
					"enrolment": 721,
					"ligo": 0.63,
					"location": [
						150.668128101967,
						-33.7763136772837
					],
					"name": "Regentville Public School",
					"playspace": 31.52,
					"projections": [
						658,
						721,
						785,
						805,
						820,
						835
					],
					"projections_orig": [
						"658",
						"721",
						"785",
						"805",
						"820",
						"835"
					],
					"projections_percentage": [
						-8.74,
						0,
						8.88,
						11.65,
						13.73,
						15.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2951
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.9,
					"enrolment": 92,
					"ligo": 0.73,
					"location": [
						150.64157451762,
						-33.8635376964966
					],
					"name": "Wallacia Public School",
					"playspace": 142.71,
					"projections": [
						84,
						92,
						125,
						160,
						200,
						230
					],
					"projections_orig": [
						"84",
						"92",
						"125",
						"160",
						"200",
						"230"
					],
					"projections_percentage": [
						-8.7,
						0,
						35.87,
						73.91,
						117.39,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3346
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.6,
					"enrolment": 351,
					"ligo": 0.89,
					"location": [
						150.605474510347,
						-33.8901189473057
					],
					"name": "Warragamba Public School",
					"playspace": 42.51,
					"projections": [
						373,
						351,
						405,
						465,
						510,
						570
					],
					"projections_orig": [
						"373",
						"351",
						"405",
						"465",
						"510",
						"570"
					],
					"projections_percentage": [
						6.27,
						0,
						15.38,
						32.48,
						45.3,
						62.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3744
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 675,
					"ligo": 0.81,
					"location": [
						150.681029380503,
						-33.7850809795646
					],
					"name": "Glenmore Park Public School",
					"playspace": 28.72,
					"projections": [
						619,
						675,
						700,
						720,
						730,
						745
					],
					"projections_orig": [
						"619",
						"675",
						"700",
						"720",
						"730",
						"745"
					],
					"projections_percentage": [
						-8.3,
						0,
						3.7,
						6.67,
						8.15,
						10.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4591
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 21
					},
					"classroomspace": 2.86,
					"enrolment": 550,
					"ligo": 0.68,
					"location": [
						150.689621013971,
						-33.7880420512103
					],
					"name": "Surveyors Creek Public School",
					"playspace": 37.4,
					"projections": [
						421,
						550,
						550,
						570,
						575,
						590
					],
					"projections_orig": [
						"421",
						"550",
						"550",
						"570",
						"575",
						"590"
					],
					"projections_percentage": [
						-23.45,
						0,
						0,
						3.64,
						4.55,
						7.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4631
				}
			],
			"uid": 10072
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 86
			},
			"enrolment": 1710,
			"level": "Primary",
			"ligo": 0.81,
			"name": "Blue Mountains Upper Primary",
			"playspace": 77.8,
			"projections": [
				1710,
				1845,
				1830,
				1795,
				1785
			],
			"projections_percentage": [
				0,
				7.89,
				7.02,
				4.97,
				4.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.56,
					"enrolment": 335,
					"ligo": 0.92,
					"location": [
						150.28554021333,
						-33.6386784702674
					],
					"name": "Blackheath Public School",
					"playspace": 28.18,
					"projections": [
						307,
						335,
						350,
						345,
						340,
						335
					],
					"projections_orig": [
						"307",
						"335",
						"350",
						"345",
						"340",
						"335"
					],
					"projections_percentage": [
						-8.36,
						0,
						4.48,
						2.99,
						1.49,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1246
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.15,
					"enrolment": 240,
					"ligo": 0.73,
					"location": [
						150.429053821006,
						-33.7214610912147
					],
					"name": "Lawson Public School",
					"playspace": 37.23,
					"projections": [
						171,
						240,
						250,
						250,
						245,
						250
					],
					"projections_orig": [
						"171",
						"240",
						"250",
						"250",
						"245",
						"250"
					],
					"projections_percentage": [
						-28.75,
						0,
						4.17,
						4.17,
						2.08,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2381
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 3.07,
					"enrolment": 267,
					"ligo": 0.64,
					"location": [
						150.336588720885,
						-33.7117160631759
					],
					"name": "Leura Public School",
					"playspace": 57.74,
					"projections": [
						313,
						267,
						300,
						300,
						290,
						290
					],
					"projections_orig": [
						"313",
						"267",
						"300",
						"300",
						"290",
						"290"
					],
					"projections_percentage": [
						17.23,
						0,
						12.36,
						12.36,
						8.61,
						8.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2391
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 11.4,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						150.231995692926,
						-33.7154165243031
					],
					"name": "Megalong Public School",
					"playspace": 130.33,
					"projections": [
						16,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						60,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2515
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 4.44,
					"enrolment": 68,
					"ligo": 0.86,
					"location": [
						150.253548221192,
						-33.5922355584722
					],
					"name": "Mount Victoria Public School",
					"playspace": 155.11,
					"projections": [
						84,
						68,
						75,
						80,
						75,
						75
					],
					"projections_orig": [
						"84",
						"68",
						"75",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						23.53,
						0,
						10.29,
						17.65,
						10.29,
						10.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2652
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.68,
					"enrolment": 373,
					"ligo": 0.83,
					"location": [
						150.372472774163,
						-33.7138043682895
					],
					"name": "Wentworth Falls Public School",
					"playspace": 34.73,
					"projections": [
						378,
						373,
						410,
						405,
						400,
						395
					],
					"projections_orig": [
						"378",
						"373",
						"410",
						"405",
						"400",
						"395"
					],
					"projections_percentage": [
						1.34,
						0,
						9.92,
						8.58,
						7.24,
						5.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3422
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.11,
					"enrolment": 141,
					"ligo": 0.8,
					"location": [
						150.315673749093,
						-33.6987974488108
					],
					"name": "Katoomba North Public School",
					"playspace": 96.98,
					"projections": [
						159,
						141,
						165,
						160,
						160,
						155
					],
					"projections_orig": [
						"159",
						"141",
						"165",
						"160",
						"160",
						"155"
					],
					"projections_percentage": [
						12.77,
						0,
						17.02,
						13.48,
						13.48,
						9.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3987
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.79,
					"enrolment": 276,
					"ligo": 0.69,
					"location": [
						150.313630485319,
						-33.7195463881693
					],
					"name": "Katoomba Public School",
					"playspace": 82.09,
					"projections": [
						248,
						276,
						285,
						280,
						275,
						275
					],
					"projections_orig": [
						"248",
						"276",
						"285",
						"280",
						"275",
						"275"
					],
					"projections_percentage": [
						-10.14,
						0,
						3.26,
						1.45,
						-0.36,
						-0.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4546
				}
			],
			"uid": 10073
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 78
			},
			"enrolment": 1879,
			"level": "Primary",
			"ligo": 0.79,
			"name": "Blue Mountains Mid Primary",
			"playspace": 48.97,
			"projections": [
				1879,
				1980,
				1960,
				1915,
				1910
			],
			"projections_percentage": [
				0,
				5.38,
				4.31,
				1.92,
				1.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 2.78,
					"enrolment": 457,
					"ligo": 0.67,
					"location": [
						150.573161402855,
						-33.7041140517797
					],
					"name": "Springwood Public School",
					"playspace": 52.79,
					"projections": [
						332,
						457,
						425,
						420,
						415,
						410
					],
					"projections_orig": [
						"332",
						"457",
						"425",
						"420",
						"415",
						"410"
					],
					"projections_percentage": [
						-27.35,
						0,
						-7,
						-8.1,
						-9.19,
						-10.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3095
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.79,
					"enrolment": 406,
					"ligo": 0.9,
					"location": [
						150.459501078816,
						-33.7262423828468
					],
					"name": "Hazelbrook Public School",
					"playspace": 41.89,
					"projections": [
						478,
						406,
						460,
						450,
						440,
						440
					],
					"projections_orig": [
						"478",
						"406",
						"460",
						"450",
						"440",
						"440"
					],
					"projections_percentage": [
						17.73,
						0,
						13.3,
						10.84,
						8.37,
						8.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3854
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.55,
					"enrolment": 326,
					"ligo": 0.84,
					"location": [
						150.545842398853,
						-33.6912767032821
					],
					"name": "Faulconbridge Public School",
					"playspace": 71.4,
					"projections": [
						338,
						326,
						340,
						340,
						330,
						330
					],
					"projections_orig": [
						"338",
						"326",
						"340",
						"340",
						"330",
						"330"
					],
					"projections_percentage": [
						3.68,
						0,
						4.29,
						4.29,
						1.23,
						1.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4354
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 2.53,
					"enrolment": 365,
					"ligo": 0.84,
					"location": [
						150.610521763187,
						-33.6696831016358
					],
					"name": "Winmalee Public School",
					"playspace": 36.9,
					"projections": [
						391,
						365,
						405,
						405,
						395,
						395
					],
					"projections_orig": [
						"391",
						"365",
						"405",
						"405",
						"395",
						"395"
					],
					"projections_percentage": [
						7.12,
						0,
						10.96,
						10.96,
						8.22,
						8.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4436
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.41,
					"enrolment": 325,
					"ligo": 0.7,
					"location": [
						150.586236868589,
						-33.6897795455703
					],
					"name": "Ellison Public School",
					"playspace": 41.87,
					"projections": [
						330,
						325,
						350,
						345,
						335,
						335
					],
					"projections_orig": [
						"330",
						"325",
						"350",
						"345",
						"335",
						"335"
					],
					"projections_percentage": [
						1.54,
						0,
						7.69,
						6.15,
						3.08,
						3.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4568
				}
			],
			"uid": 10074
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 61
			},
			"enrolment": 1466,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Blue Mountains Lower Primary",
			"playspace": 76.02,
			"projections": [
				1466,
				1585,
				1570,
				1535,
				1530
			],
			"projections_percentage": [
				0,
				8.12,
				7.09,
				4.71,
				4.37
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.01,
					"enrolment": 137,
					"ligo": 0.69,
					"location": [
						150.603709000798,
						-33.7366758575536
					],
					"name": "Blaxland Public School",
					"playspace": 136.8,
					"projections": [
						163,
						137,
						165,
						165,
						160,
						160
					],
					"projections_orig": [
						"163",
						"137",
						"165",
						"165",
						"160",
						"160"
					],
					"projections_percentage": [
						18.98,
						0,
						20.44,
						20.44,
						16.79,
						16.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1258
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.53,
					"enrolment": 280,
					"ligo": 0.65,
					"location": [
						150.617703523061,
						-33.7657027745992
					],
					"name": "Glenbrook Public School",
					"playspace": 60.49,
					"projections": [
						249,
						280,
						300,
						295,
						290,
						290
					],
					"projections_orig": [
						"249",
						"280",
						"300",
						"295",
						"290",
						"290"
					],
					"projections_percentage": [
						-11.07,
						0,
						7.14,
						5.36,
						3.57,
						3.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1994
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.65,
					"enrolment": 174,
					"ligo": 0.76,
					"location": [
						150.599071568183,
						-33.7277530635211
					],
					"name": "Warrimoo Public School",
					"playspace": 75.09,
					"projections": [
						201,
						174,
						195,
						195,
						190,
						190
					],
					"projections_orig": [
						"201",
						"174",
						"195",
						"195",
						"190",
						"190"
					],
					"projections_percentage": [
						15.52,
						0,
						12.07,
						12.07,
						9.2,
						9.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4195
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.45,
					"enrolment": 403,
					"ligo": 0.59,
					"location": [
						150.624288296988,
						-33.7464791527448
					],
					"name": "Blaxland East Public School",
					"playspace": 40.97,
					"projections": [
						382,
						403,
						435,
						430,
						420,
						420
					],
					"projections_orig": [
						"382",
						"403",
						"435",
						"430",
						"420",
						"420"
					],
					"projections_percentage": [
						-5.21,
						0,
						7.94,
						6.7,
						4.22,
						4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4313
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 3.08,
					"enrolment": 254,
					"ligo": 0.73,
					"location": [
						150.630322492268,
						-33.7720010013496
					],
					"name": "Lapstone Public School",
					"playspace": 53.33,
					"projections": [
						217,
						254,
						270,
						270,
						265,
						260
					],
					"projections_orig": [
						"217",
						"254",
						"270",
						"270",
						"265",
						"260"
					],
					"projections_percentage": [
						-14.57,
						0,
						6.3,
						6.3,
						4.33,
						2.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4424
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.14,
					"enrolment": 218,
					"ligo": 0.86,
					"location": [
						150.632872120137,
						-33.7300747338763
					],
					"name": "Mount Riverview Public School",
					"playspace": 89.43,
					"projections": [
						180,
						218,
						220,
						215,
						210,
						210
					],
					"projections_orig": [
						"180",
						"218",
						"220",
						"215",
						"210",
						"210"
					],
					"projections_percentage": [
						-17.43,
						0,
						0.92,
						-1.38,
						-3.67,
						-3.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4435
				}
			],
			"uid": 10075
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 45
			},
			"enrolment": 1075,
			"level": "Primary",
			"ligo": 0.78,
			"name": "Emu Plains Primary",
			"playspace": 61.78,
			"projections": [
				1075,
				1105,
				1100,
				1080,
				1075
			],
			"projections_percentage": [
				0,
				2.79,
				2.33,
				0.47,
				0
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 2.54,
					"enrolment": 485,
					"ligo": 0.84,
					"location": [
						150.658540717773,
						-33.755696934138
					],
					"name": "Emu Plains Public School",
					"playspace": 45.82,
					"projections": [
						385,
						485,
						500,
						500,
						490,
						490
					],
					"projections_orig": [
						"385",
						"485",
						"500",
						"500",
						"490",
						"490"
					],
					"projections_percentage": [
						-20.62,
						0,
						3.09,
						3.09,
						1.03,
						1.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1841
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.34,
					"enrolment": 337,
					"ligo": 0.8,
					"location": [
						150.649956396951,
						-33.7369078213267
					],
					"name": "Emu Heights Public School",
					"playspace": 72.19,
					"projections": [
						322,
						337,
						365,
						360,
						355,
						350
					],
					"projections_orig": [
						"322",
						"337",
						"365",
						"360",
						"355",
						"350"
					],
					"projections_percentage": [
						-4.45,
						0,
						8.31,
						6.82,
						5.34,
						3.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4442
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.62,
					"enrolment": 253,
					"ligo": 0.69,
					"location": [
						150.650865755212,
						-33.7650779581007
					],
					"name": "Leonay Public School",
					"playspace": 67.34,
					"projections": [
						209,
						253,
						240,
						240,
						235,
						235
					],
					"projections_orig": [
						"209",
						"253",
						"240",
						"240",
						"235",
						"235"
					],
					"projections_percentage": [
						-17.39,
						0,
						-5.14,
						-5.14,
						-7.11,
						-7.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4475
				}
			],
			"uid": 10076
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 43
			},
			"enrolment": 1142,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Kurrajong Primary",
			"playspace": 29.96,
			"projections": [
				1142,
				1260,
				1300,
				1315,
				1355
			],
			"projections_percentage": [
				0,
				10.33,
				13.84,
				15.15,
				18.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.37,
					"enrolment": 61,
					"ligo": 0.87,
					"location": [
						150.51631938742,
						-33.4973848441303
					],
					"name": "Bilpin Public School",
					"playspace": 9.54,
					"projections": [
						74,
						61,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"74",
						"61",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						21.31,
						0,
						14.75,
						14.75,
						14.75,
						14.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1228
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.07,
					"enrolment": 122,
					"ligo": 0.79,
					"location": [
						150.69611106805,
						-33.5064209116673
					],
					"name": "Comleroy Road Public School",
					"playspace": 6.53,
					"projections": [
						153,
						122,
						155,
						155,
						155,
						155
					],
					"projections_orig": [
						"153",
						"122",
						"155",
						"155",
						"155",
						"155"
					],
					"projections_percentage": [
						25.41,
						0,
						27.05,
						27.05,
						27.05,
						27.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1604
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.9,
					"enrolment": 182,
					"ligo": 0.46,
					"location": [
						150.692010169657,
						-33.5504802526539
					],
					"name": "Kurmond Public School",
					"playspace": 61.99,
					"projections": [
						206,
						182,
						215,
						220,
						220,
						225
					],
					"projections_orig": [
						"206",
						"182",
						"215",
						"220",
						"220",
						"225"
					],
					"projections_percentage": [
						13.19,
						0,
						18.13,
						20.88,
						20.88,
						23.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2340
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 6
					},
					"classroomspace": 2.81,
					"enrolment": 240,
					"ligo": 0.53,
					"location": [
						150.662905238008,
						-33.5556553764535
					],
					"name": "Kurrajong Public School",
					"playspace": 1.27,
					"projections": [
						225,
						240,
						270,
						280,
						285,
						295
					],
					"projections_orig": [
						"225",
						"240",
						"270",
						"280",
						"285",
						"295"
					],
					"projections_percentage": [
						-6.25,
						0,
						12.5,
						16.67,
						18.75,
						22.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2342
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 3.44,
					"enrolment": 104,
					"ligo": 0.74,
					"location": [
						150.639105487537,
						-33.5420154117902
					],
					"name": "Kurrajong North Public School",
					"playspace": 10.49,
					"projections": [
						84,
						104,
						110,
						110,
						115,
						120
					],
					"projections_orig": [
						"84",
						"104",
						"110",
						"110",
						"115",
						"120"
					],
					"projections_percentage": [
						-19.23,
						0,
						5.77,
						5.77,
						10.58,
						15.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2344
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.56,
					"enrolment": 206,
					"ligo": 0.81,
					"location": [
						150.717509508362,
						-33.581264920691
					],
					"name": "Richmond North Public School",
					"playspace": 105.6,
					"projections": [
						162,
						206,
						195,
						210,
						215,
						225
					],
					"projections_orig": [
						"162",
						"206",
						"195",
						"210",
						"215",
						"225"
					],
					"projections_percentage": [
						-21.36,
						0,
						-5.34,
						1.94,
						4.37,
						9.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2965
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 227,
					"ligo": 0.78,
					"location": [
						150.666072742396,
						-33.5945058871495
					],
					"name": "Grose View Public School",
					"playspace": 14.27,
					"projections": [
						294,
						227,
						245,
						255,
						255,
						265
					],
					"projections_orig": [
						"294",
						"227",
						"245",
						"255",
						"255",
						"265"
					],
					"projections_percentage": [
						29.52,
						0,
						7.93,
						12.33,
						12.33,
						16.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4483
				}
			],
			"uid": 10077
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 45
			},
			"enrolment": 1004,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Hawkesbury West Primary",
			"playspace": 83.43,
			"projections": [
				1004,
				1090,
				1135,
				1165,
				1200
			],
			"projections_percentage": [
				0,
				8.57,
				13.05,
				16.04,
				19.52
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.64,
					"enrolment": 45,
					"ligo": 0.94,
					"location": [
						150.740437782278,
						-33.3727959949823
					],
					"name": "Colo Heights Public School",
					"playspace": 96.13,
					"projections": [
						40,
						45,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"40",
						"45",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						-11.11,
						0,
						11.11,
						11.11,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1346
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.37,
					"enrolment": 126,
					"ligo": 0.72,
					"location": [
						150.877434584625,
						-33.5312007148259
					],
					"name": "Ebenezer Public School",
					"playspace": 37.08,
					"projections": [
						140,
						126,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"140",
						"126",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						11.11,
						0,
						3.17,
						3.17,
						3.17,
						3.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1813
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.97,
					"enrolment": 184,
					"ligo": 0.59,
					"location": [
						150.798758224189,
						-33.5580076097292
					],
					"name": "Freemans Reach Public School",
					"playspace": 53.35,
					"projections": [
						198,
						184,
						210,
						215,
						220,
						225
					],
					"projections_orig": [
						"198",
						"184",
						"210",
						"215",
						"220",
						"225"
					],
					"projections_percentage": [
						7.61,
						0,
						14.13,
						16.85,
						19.57,
						22.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1944
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.36,
					"enrolment": 246,
					"ligo": 0.82,
					"location": [
						150.766964485018,
						-33.5313670594965
					],
					"name": "Glossodia Public School",
					"playspace": 34.23,
					"projections": [
						213,
						246,
						260,
						275,
						285,
						290
					],
					"projections_orig": [
						"213",
						"246",
						"260",
						"275",
						"285",
						"290"
					],
					"projections_percentage": [
						-13.41,
						0,
						5.69,
						11.79,
						15.85,
						17.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2021
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.25,
					"enrolment": 57,
					"ligo": 0.71,
					"location": [
						150.778185552226,
						-33.5112934014607
					],
					"name": "Kurrajong East Public School",
					"playspace": 217.95,
					"projections": [
						111,
						57,
						80,
						85,
						80,
						85
					],
					"projections_orig": [
						"111",
						"57",
						"80",
						"85",
						"80",
						"85"
					],
					"projections_percentage": [
						94.74,
						0,
						40.35,
						49.12,
						40.35,
						49.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2343
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.33,
					"enrolment": 346,
					"ligo": 0.6,
					"location": [
						150.839753961222,
						-33.5577920816439
					],
					"name": "Wilberforce Public School",
					"playspace": 61.86,
					"projections": [
						329,
						346,
						360,
						380,
						400,
						420
					],
					"projections_orig": [
						"329",
						"346",
						"360",
						"380",
						"400",
						"420"
					],
					"projections_percentage": [
						-4.91,
						0,
						4.05,
						9.83,
						15.61,
						21.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3441
				}
			],
			"uid": 10078
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 48
			},
			"enrolment": 1045,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Richmond Primary",
			"playspace": 67.9,
			"projections": [
				1045,
				1185,
				1300,
				1335,
				1385
			],
			"projections_percentage": [
				0,
				13.4,
				24.4,
				27.75,
				32.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.75,
					"enrolment": 208,
					"ligo": 0.81,
					"location": [
						150.735553608576,
						-33.6469317635991
					],
					"name": "Londonderry Public School",
					"playspace": 112.34,
					"projections": [
						191,
						208,
						225,
						255,
						270,
						285
					],
					"projections_orig": [
						"191",
						"208",
						"225",
						"255",
						"270",
						"285"
					],
					"projections_percentage": [
						-8.17,
						0,
						8.17,
						22.6,
						29.81,
						37.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2421
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.3,
					"enrolment": 364,
					"ligo": 0.43,
					"location": [
						150.758268199255,
						-33.5992176565877
					],
					"name": "Richmond Public School",
					"playspace": 55.18,
					"projections": [
						347,
						364,
						395,
						430,
						440,
						455
					],
					"projections_orig": [
						"347",
						"364",
						"395",
						"430",
						"440",
						"455"
					],
					"projections_percentage": [
						-4.67,
						0,
						8.52,
						18.13,
						20.88,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3999
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.75,
					"enrolment": 110,
					"ligo": 0.67,
					"location": [
						150.677114201284,
						-33.6675399017512
					],
					"name": "Castlereagh Public School",
					"playspace": 51.3,
					"projections": [
						92,
						110,
						110,
						120,
						125,
						125
					],
					"projections_orig": [
						"92",
						"110",
						"110",
						"120",
						"125",
						"125"
					],
					"projections_percentage": [
						-16.36,
						0,
						0,
						9.09,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4148
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.01,
					"enrolment": 363,
					"ligo": 0.72,
					"location": [
						150.741506780262,
						-33.6030832776571
					],
					"name": "Hobartville Public School",
					"playspace": 52.78,
					"projections": [
						434,
						363,
						455,
						495,
						500,
						520
					],
					"projections_orig": [
						"434",
						"363",
						"455",
						"495",
						"500",
						"520"
					],
					"projections_percentage": [
						19.56,
						0,
						25.34,
						36.36,
						37.74,
						43.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4452
				}
			],
			"uid": 10079
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 65
			},
			"enrolment": 942,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Windsor Primary",
			"playspace": 65.34,
			"projections": [
				942,
				1150,
				1380,
				1595,
				1785
			],
			"projections_percentage": [
				0,
				22.08,
				46.5,
				69.32,
				89.49
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.17,
					"enrolment": 160,
					"ligo": 0.47,
					"location": [
						150.816228689141,
						-33.6108825910557
					],
					"name": "Windsor Public School",
					"playspace": 36.01,
					"projections": [
						204,
						160,
						205,
						225,
						245,
						260
					],
					"projections_orig": [
						"204",
						"160",
						"205",
						"225",
						"245",
						"260"
					],
					"projections_percentage": [
						27.5,
						0,
						28.12,
						40.62,
						53.12,
						62.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3459
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 5.31,
					"enrolment": 211,
					"ligo": 0.87,
					"location": [
						150.80484025251,
						-33.6181691338545
					],
					"name": "Windsor South Public School",
					"playspace": 80.53,
					"projections": [
						165,
						211,
						205,
						240,
						260,
						275
					],
					"projections_orig": [
						"165",
						"211",
						"205",
						"240",
						"260",
						"275"
					],
					"projections_percentage": [
						-21.8,
						0,
						-2.84,
						13.74,
						23.22,
						30.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4066
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.58,
					"enrolment": 332,
					"ligo": 0.55,
					"location": [
						150.794390945689,
						-33.640186200179
					],
					"name": "Bligh Park Public School",
					"playspace": 60.63,
					"projections": [
						401,
						332,
						395,
						480,
						565,
						645
					],
					"projections_orig": [
						"401",
						"332",
						"395",
						"480",
						"565",
						"645"
					],
					"projections_percentage": [
						20.78,
						0,
						18.98,
						44.58,
						70.18,
						94.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4585
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.06,
					"enrolment": 239,
					"ligo": 0.59,
					"location": [
						150.812361332178,
						-33.6409300387105
					],
					"name": "Windsor Park Public School",
					"playspace": 84.2,
					"projections": [
						282,
						239,
						345,
						435,
						525,
						605
					],
					"projections_orig": [
						"282",
						"239",
						"345",
						"435",
						"525",
						"605"
					],
					"projections_percentage": [
						17.99,
						0,
						44.35,
						82.01,
						119.67,
						153.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4614
				}
			],
			"uid": 10080
		},
		{
			"classrooms": {
				"demountable": 21,
				"permanent": 129
			},
			"enrolment": 3264,
			"level": "Primary",
			"ligo": 0.6,
			"name": "Penrith CBD Primary",
			"playspace": 52.32,
			"projections": [
				3264,
				3530,
				3745,
				3850,
				3920
			],
			"projections_percentage": [
				0,
				8.15,
				14.74,
				17.95,
				20.1
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 2.73,
					"enrolment": 426,
					"ligo": 0.6,
					"location": [
						150.726414628727,
						-33.7639655538434
					],
					"name": "Kingswood Public School",
					"playspace": 81.45,
					"projections": [
						332,
						426,
						435,
						465,
						475,
						480
					],
					"projections_orig": [
						"332",
						"426",
						"435",
						"465",
						"475",
						"480"
					],
					"projections_percentage": [
						-22.07,
						0,
						2.11,
						9.15,
						11.5,
						12.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2312
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 2.81,
					"enrolment": 113,
					"ligo": 0.5,
					"location": [
						150.721750956542,
						-33.7820677098075
					],
					"name": "Orchard Hills Public School",
					"playspace": 40.9,
					"projections": [
						88,
						113,
						110,
						115,
						120,
						125
					],
					"projections_orig": [
						"88",
						"113",
						"110",
						"115",
						"120",
						"125"
					],
					"projections_percentage": [
						-22.12,
						0,
						-2.65,
						1.77,
						6.19,
						10.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2815
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.3,
					"enrolment": 417,
					"ligo": 0.46,
					"location": [
						150.70532344924,
						-33.7554308453328
					],
					"name": "Penrith Public School",
					"playspace": 19.11,
					"projections": [
						396,
						417,
						505,
						535,
						580,
						595
					],
					"projections_orig": [
						"396",
						"417",
						"505",
						"535",
						"580",
						"595"
					],
					"projections_percentage": [
						-5.04,
						0,
						21.1,
						28.3,
						39.09,
						42.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2859
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.44,
					"enrolment": 508,
					"ligo": 0.49,
					"location": [
						150.701287009762,
						-33.7630679957137
					],
					"name": "Penrith South Public School",
					"playspace": 54.04,
					"projections": [
						382,
						508,
						525,
						555,
						570,
						585
					],
					"projections_orig": [
						"382",
						"508",
						"525",
						"555",
						"570",
						"585"
					],
					"projections_percentage": [
						-24.8,
						0,
						3.35,
						9.25,
						12.2,
						15.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4138
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 3.32,
					"enrolment": 328,
					"ligo": 0.61,
					"location": [
						150.7118836141,
						-33.7683337806041
					],
					"name": "Kingswood South Public School",
					"playspace": 56.79,
					"projections": [
						307,
						328,
						360,
						380,
						390,
						395
					],
					"projections_orig": [
						"307",
						"328",
						"360",
						"380",
						"390",
						"395"
					],
					"projections_percentage": [
						-6.4,
						0,
						9.76,
						15.85,
						18.9,
						20.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4339
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.7,
					"enrolment": 574,
					"ligo": 0.59,
					"location": [
						150.697048706689,
						-33.7770610138502
					],
					"name": "York Public School",
					"playspace": 53.57,
					"projections": [
						526,
						574,
						645,
						670,
						675,
						690
					],
					"projections_orig": [
						"526",
						"574",
						"645",
						"670",
						"675",
						"690"
					],
					"projections_percentage": [
						-8.36,
						0,
						12.37,
						16.72,
						17.6,
						20.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4482
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.5,
					"enrolment": 366,
					"ligo": 0.8,
					"location": [
						150.683316447607,
						-33.771938926553
					],
					"name": "Jamisontown Public School",
					"playspace": 72.54,
					"projections": [
						325,
						366,
						385,
						400,
						400,
						410
					],
					"projections_orig": [
						"325",
						"366",
						"385",
						"400",
						"400",
						"410"
					],
					"projections_percentage": [
						-11.2,
						0,
						5.19,
						9.29,
						9.29,
						12.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4544
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 18
					},
					"classroomspace": 3.05,
					"enrolment": 532,
					"ligo": 0.77,
					"location": [
						150.74584204423,
						-33.7732652158203
					],
					"name": "Claremont Meadows Public School",
					"playspace": 40.16,
					"projections": [
						422,
						532,
						565,
						625,
						640,
						640
					],
					"projections_orig": [
						"422",
						"532",
						"565",
						"625",
						"640",
						"640"
					],
					"projections_percentage": [
						-20.68,
						0,
						6.2,
						17.48,
						20.3,
						20.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4622
				}
			],
			"uid": 10081
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 84
			},
			"enrolment": 1877,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Penrith North Primary",
			"playspace": 59.37,
			"projections": [
				1877,
				2025,
				2110,
				2155,
				2200
			],
			"projections_percentage": [
				0,
				7.88,
				12.41,
				14.81,
				17.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 2.69,
					"enrolment": 530,
					"ligo": 0.72,
					"location": [
						150.725657005425,
						-33.7481983362315
					],
					"name": "Cambridge Park Public School",
					"playspace": 40.93,
					"projections": [
						451,
						530,
						575,
						595,
						605,
						615
					],
					"projections_orig": [
						"451",
						"530",
						"575",
						"595",
						"605",
						"615"
					],
					"projections_percentage": [
						-14.91,
						0,
						8.49,
						12.26,
						14.15,
						16.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4060
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.86,
					"enrolment": 135,
					"ligo": 0.76,
					"location": [
						150.71205014965,
						-33.7417737138503
					],
					"name": "Kingswood Park Public School",
					"playspace": 104.85,
					"projections": [
						148,
						135,
						150,
						155,
						160,
						165
					],
					"projections_orig": [
						"148",
						"135",
						"150",
						"155",
						"160",
						"165"
					],
					"projections_percentage": [
						9.63,
						0,
						11.11,
						14.81,
						18.52,
						22.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4346
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 3.66,
					"enrolment": 398,
					"ligo": 0.7,
					"location": [
						150.746007198791,
						-33.7560709137441
					],
					"name": "Werrington Public School",
					"playspace": 47.69,
					"projections": [
						411,
						398,
						460,
						485,
						500,
						510
					],
					"projections_orig": [
						"411",
						"398",
						"460",
						"485",
						"500",
						"510"
					],
					"projections_percentage": [
						3.27,
						0,
						15.58,
						21.86,
						25.63,
						28.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4473
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.63,
					"enrolment": 402,
					"ligo": 0.66,
					"location": [
						150.722821480506,
						-33.7374252822137
					],
					"name": "Cambridge Gardens Public School",
					"playspace": 52.53,
					"projections": [
						291,
						402,
						400,
						415,
						420,
						430
					],
					"projections_orig": [
						"291",
						"402",
						"400",
						"415",
						"420",
						"430"
					],
					"projections_percentage": [
						-27.61,
						0,
						-0.5,
						3.23,
						4.48,
						6.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4484
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 13
					},
					"classroomspace": 3.16,
					"enrolment": 412,
					"ligo": 0.64,
					"location": [
						150.746658511681,
						-33.744905316807
					],
					"name": "Werrington County Public School",
					"playspace": 50.84,
					"projections": [
						325,
						412,
						440,
						460,
						470,
						480
					],
					"projections_orig": [
						"325",
						"412",
						"440",
						"460",
						"470",
						"480"
					],
					"projections_percentage": [
						-21.12,
						0,
						6.8,
						11.65,
						14.08,
						16.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4541
				}
			],
			"uid": 10082
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 95
			},
			"enrolment": 2279,
			"level": "Primary",
			"ligo": 0.6,
			"name": "St Clair Primary",
			"playspace": 53.17,
			"projections": [
				2279,
				2390,
				2505,
				2590,
				2675
			],
			"projections_percentage": [
				0,
				4.87,
				9.92,
				13.65,
				17.38
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.79,
					"enrolment": 404,
					"ligo": 0.62,
					"location": [
						150.800283309353,
						-33.7967135407229
					],
					"name": "Clairgate Public School",
					"playspace": 52.96,
					"projections": [
						374,
						404,
						435,
						450,
						460,
						470
					],
					"projections_orig": [
						"374",
						"404",
						"435",
						"450",
						"460",
						"470"
					],
					"projections_percentage": [
						-7.43,
						0,
						7.67,
						11.39,
						13.86,
						16.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4527
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.63,
					"enrolment": 272,
					"ligo": 0.45,
					"location": [
						150.786997981092,
						-33.796197070162
					],
					"name": "St Clair Public School",
					"playspace": 98.15,
					"projections": [
						265,
						272,
						310,
						320,
						320,
						330
					],
					"projections_orig": [
						"265",
						"272",
						"310",
						"320",
						"320",
						"330"
					],
					"projections_percentage": [
						-2.57,
						0,
						13.97,
						17.65,
						17.65,
						21.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4531
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 20
					},
					"classroomspace": 2.52,
					"enrolment": 652,
					"ligo": 0.62,
					"location": [
						150.782462887474,
						-33.8060492137746
					],
					"name": "Blackwell Public School",
					"playspace": 28.53,
					"projections": [
						523,
						652,
						665,
						690,
						710,
						730
					],
					"projections_orig": [
						"523",
						"652",
						"665",
						"690",
						"710",
						"730"
					],
					"projections_percentage": [
						-19.79,
						0,
						1.99,
						5.83,
						8.9,
						11.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4559
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.66,
					"enrolment": 374,
					"ligo": 0.69,
					"location": [
						150.773922714087,
						-33.7937016358343
					],
					"name": "Banks Public School",
					"playspace": 52.57,
					"projections": [
						325,
						374,
						380,
						395,
						405,
						415
					],
					"projections_orig": [
						"325",
						"374",
						"380",
						"395",
						"405",
						"415"
					],
					"projections_percentage": [
						-13.1,
						0,
						1.6,
						5.61,
						8.29,
						10.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4571
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 20
					},
					"classroomspace": 2.52,
					"enrolment": 577,
					"ligo": 0.6,
					"location": [
						150.803415619054,
						-33.8048396070605
					],
					"name": "James Erskine Public School",
					"playspace": 33.62,
					"projections": [
						560,
						577,
						600,
						650,
						695,
						730
					],
					"projections_orig": [
						"560",
						"577",
						"600",
						"650",
						"695",
						"730"
					],
					"projections_percentage": [
						-2.95,
						0,
						3.99,
						12.65,
						20.45,
						26.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4579
				}
			],
			"uid": 10083
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 63
			},
			"enrolment": 1525,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Cranebrook Primary",
			"playspace": 74.89,
			"projections": [
				1525,
				1605,
				1770,
				1905,
				2270
			],
			"projections_percentage": [
				0,
				5.25,
				16.07,
				24.92,
				48.85
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.5,
					"enrolment": 355,
					"ligo": 0.42,
					"location": [
						150.752059852492,
						-33.7078072038979
					],
					"name": "Llandilo Public School",
					"playspace": 64.29,
					"projections": [
						284,
						355,
						420,
						500,
						575,
						905
					],
					"projections_orig": [
						"284",
						"355",
						"420",
						"500",
						"575",
						"905"
					],
					"projections_percentage": [
						-20,
						0,
						18.31,
						40.85,
						61.97,
						154.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2413
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.82,
					"enrolment": 258,
					"ligo": 0.73,
					"location": [
						150.707783698565,
						-33.7216811898758
					],
					"name": "Braddock Public School",
					"playspace": 140.12,
					"projections": [
						189,
						258,
						240,
						260,
						275,
						285
					],
					"projections_orig": [
						"189",
						"258",
						"240",
						"260",
						"275",
						"285"
					],
					"projections_percentage": [
						-26.74,
						0,
						-6.98,
						0.78,
						6.59,
						10.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4525
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 2.37,
					"enrolment": 516,
					"ligo": 0.61,
					"location": [
						150.7093850509,
						-33.7128779366819
					],
					"name": "Samuel Terry Public School",
					"playspace": 38.15,
					"projections": [
						481,
						516,
						555,
						595,
						620,
						635
					],
					"projections_orig": [
						"481",
						"516",
						"555",
						"595",
						"620",
						"635"
					],
					"projections_percentage": [
						-6.78,
						0,
						7.56,
						15.31,
						20.16,
						23.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4560
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 12
					},
					"classroomspace": 2.57,
					"enrolment": 396,
					"ligo": 0.31,
					"location": [
						150.708720794324,
						-33.7039954830488
					],
					"name": "Henry Fulton Public School",
					"playspace": 56.99,
					"projections": [
						310,
						396,
						390,
						415,
						435,
						445
					],
					"projections_orig": [
						"310",
						"396",
						"390",
						"415",
						"435",
						"445"
					],
					"projections_percentage": [
						-21.72,
						0,
						-1.52,
						4.8,
						9.85,
						12.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4619
				}
			],
			"uid": 10084
		},
		{
			"classrooms": {
				"demountable": 67,
				"permanent": 182
			},
			"enrolment": 4764,
			"level": "Primary",
			"ligo": 0.83,
			"name": "Auburn Primary",
			"playspace": 18.35,
			"projections": [
				4764,
				6410,
				8055,
				8665,
				9125
			],
			"projections_percentage": [
				0,
				34.55,
				69.08,
				81.88,
				91.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 28
					},
					"classroomspace": 2.69,
					"enrolment": 713,
					"ligo": 0.88,
					"location": [
						151.039228448383,
						-33.8411171289936
					],
					"name": "Auburn North Public School",
					"playspace": 25.11,
					"projections": [
						565,
						713,
						820,
						975,
						1045,
						1070
					],
					"projections_orig": [
						"565",
						"713",
						"820",
						"975",
						"1045",
						"1070"
					],
					"projections_percentage": [
						-20.76,
						0,
						15.01,
						36.75,
						46.56,
						50.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1073
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 26
					},
					"classroomspace": 3.63,
					"enrolment": 683,
					"ligo": 0.88,
					"location": [
						151.020267988256,
						-33.8600553852494
					],
					"name": "Auburn West Public School",
					"playspace": 14.38,
					"projections": [
						737,
						683,
						930,
						1020,
						995,
						990
					],
					"projections_orig": [
						"737",
						"683",
						"930",
						"1020",
						"995",
						"990"
					],
					"projections_percentage": [
						7.91,
						0,
						36.16,
						49.34,
						45.68,
						44.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1075
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 35
					},
					"classroomspace": 2.84,
					"enrolment": 894,
					"ligo": 0.79,
					"location": [
						151.027696123098,
						-33.8699295115984
					],
					"name": "Berala Public School",
					"playspace": 14.27,
					"projections": [
						881,
						894,
						1020,
						1185,
						1210,
						1235
					],
					"projections_orig": [
						"881",
						"894",
						"1020",
						"1185",
						"1210",
						"1235"
					],
					"projections_percentage": [
						-1.45,
						0,
						14.09,
						32.55,
						35.35,
						38.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1199
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 25
					},
					"classroomspace": 2.83,
					"enrolment": 740,
					"ligo": 0.75,
					"location": [
						151.046783064192,
						-33.8611955574813
					],
					"name": "Lidcombe Public School",
					"playspace": 20.54,
					"projections": [
						549,
						740,
						935,
						1115,
						1180,
						1240
					],
					"projections_orig": [
						"549",
						"740",
						"935",
						"1115",
						"1180",
						"1240"
					],
					"projections_percentage": [
						-25.81,
						0,
						26.35,
						50.68,
						59.46,
						67.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2394
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.52,
					"enrolment": 250,
					"ligo": 0.72,
					"location": [
						151.024817352281,
						-33.8857485404113
					],
					"name": "Regents Park Public School",
					"playspace": 20.6,
					"projections": [
						283,
						250,
						340,
						390,
						395,
						405
					],
					"projections_orig": [
						"283",
						"250",
						"340",
						"390",
						"395",
						"405"
					],
					"projections_percentage": [
						13.2,
						0,
						36,
						56,
						58,
						62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2950
				},
				{
					"classrooms": {
						"demountable": 23,
						"permanent": 18
					},
					"classroomspace": 2.89,
					"enrolment": 941,
					"ligo": 0.93,
					"location": [
						151.05424810258,
						-33.8407280685841
					],
					"name": "Newington Public School",
					"playspace": 12.23,
					"projections": [
						533,
						941,
						1380,
						2160,
						2525,
						2755
					],
					"projections_orig": [
						"533",
						"941",
						"1380",
						"2160",
						"2525",
						"2755"
					],
					"projections_percentage": [
						-43.36,
						0,
						46.65,
						129.54,
						168.33,
						192.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4627
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						151.05424810258,
						-33.8407280685841
					],
					"name": "Wentworth Point Public School (proposed)",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4662
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 34
					},
					"classroomspace": 3.89,
					"enrolment": 543,
					"ligo": 0.7,
					"location": [
						151.031918221151,
						-33.8550347255295
					],
					"name": "Auburn Public School",
					"playspace": 21.3,
					"projections": [
						583,
						543,
						985,
						1210,
						1315,
						1430
					],
					"projections_orig": [
						"583",
						"543",
						"985",
						"1210",
						"1315",
						"1430"
					],
					"projections_percentage": [
						7.37,
						0,
						81.4,
						122.84,
						142.17,
						163.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7403
				}
			],
			"uid": 10085
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 111
			},
			"enrolment": 3064,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Bankstown Primary",
			"playspace": 37.13,
			"projections": [
				3064,
				3575,
				4080,
				4595,
				4995
			],
			"projections_percentage": [
				0,
				16.68,
				33.16,
				49.97,
				63.02
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 8
					},
					"classroomspace": 2.72,
					"enrolment": 367,
					"ligo": 0.73,
					"location": [
						151.038595001779,
						-33.9058862470658
					],
					"name": "Bankstown North Public School",
					"playspace": 51.73,
					"projections": [
						370,
						367,
						470,
						545,
						625,
						690
					],
					"projections_orig": [
						"370",
						"367",
						"470",
						"545",
						"625",
						"690"
					],
					"projections_percentage": [
						0.82,
						0,
						28.07,
						48.5,
						70.3,
						88.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1124
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 23
					},
					"classroomspace": 2.82,
					"enrolment": 566,
					"ligo": 0.69,
					"location": [
						151.01357027348,
						-33.9250252490807
					],
					"name": "Condell Park Public School",
					"playspace": 21.25,
					"projections": [
						553,
						566,
						650,
						705,
						760,
						800
					],
					"projections_orig": [
						"553",
						"566",
						"650",
						"705",
						"760",
						"800"
					],
					"projections_percentage": [
						-2.3,
						0,
						14.84,
						24.56,
						34.28,
						41.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3789
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 20
					},
					"classroomspace": 3.26,
					"enrolment": 546,
					"ligo": 0.66,
					"location": [
						151.026893235243,
						-33.9080813866229
					],
					"name": "Yagoona Public School",
					"playspace": 30.75,
					"projections": [
						520,
						546,
						605,
						670,
						740,
						785
					],
					"projections_orig": [
						"520",
						"546",
						"605",
						"670",
						"740",
						"785"
					],
					"projections_percentage": [
						-4.76,
						0,
						10.81,
						22.71,
						35.53,
						43.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3869
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 3.32,
					"enrolment": 262,
					"ligo": 0.37,
					"location": [
						151.012911325612,
						-33.9141565216553
					],
					"name": "Wattawa Heights Public School",
					"playspace": 42.13,
					"projections": [
						240,
						262,
						300,
						330,
						360,
						380
					],
					"projections_orig": [
						"240",
						"262",
						"300",
						"330",
						"360",
						"380"
					],
					"projections_percentage": [
						-8.4,
						0,
						14.5,
						25.95,
						37.4,
						45.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4059
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 8
					},
					"classroomspace": 2.89,
					"enrolment": 312,
					"ligo": 0.53,
					"location": [
						151.019073883215,
						-33.9154250490517
					],
					"name": "Bankstown West Public School",
					"playspace": 35.39,
					"projections": [
						232,
						312,
						320,
						355,
						390,
						415
					],
					"projections_orig": [
						"232",
						"312",
						"320",
						"355",
						"390",
						"415"
					],
					"projections_percentage": [
						-25.64,
						0,
						2.56,
						13.78,
						25,
						33.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4142
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 2
					},
					"classroomspace": 3.39,
					"enrolment": 149,
					"ligo": 1,
					"location": [
						151.038879522757,
						-33.9306992741421
					],
					"name": "Bankstown South Infants School",
					"playspace": 66.69,
					"projections": [
						116,
						149,
						155,
						190,
						220,
						250
					],
					"projections_orig": [
						"116",
						"149",
						"155",
						"190",
						"220",
						"250"
					],
					"projections_percentage": [
						-22.15,
						0,
						4.03,
						27.52,
						47.65,
						67.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5246
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 41
					},
					"classroomspace": 2.64,
					"enrolment": 862,
					"ligo": 0.6,
					"location": [
						151.034786041055,
						-33.9216169501696
					],
					"name": "Bankstown Public School",
					"playspace": 12,
					"projections": [
						990,
						862,
						1075,
						1285,
						1500,
						1675
					],
					"projections_orig": [
						"990",
						"862",
						"1075",
						"1285",
						"1500",
						"1675"
					],
					"projections_percentage": [
						14.85,
						0,
						24.71,
						49.07,
						74.01,
						94.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7405
				}
			],
			"uid": 10086
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 139
			},
			"enrolment": 3322,
			"level": "Primary",
			"ligo": 0.64,
			"name": "Sefton Primary",
			"playspace": 39.61,
			"projections": [
				3322,
				3765,
				4175,
				4475,
				4630
			],
			"projections_percentage": [
				0,
				13.34,
				25.68,
				34.71,
				39.37
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.67,
					"enrolment": 353,
					"ligo": 0.54,
					"location": [
						151.005293029393,
						-33.9054308832447
					],
					"name": "Bass Hill Public School",
					"playspace": 51.71,
					"projections": [
						373,
						353,
						440,
						465,
						485,
						500
					],
					"projections_orig": [
						"373",
						"353",
						"440",
						"465",
						"485",
						"500"
					],
					"projections_percentage": [
						5.67,
						0,
						24.65,
						31.73,
						37.39,
						41.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1148
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 28
					},
					"classroomspace": 2.77,
					"enrolment": 679,
					"ligo": 0.67,
					"location": [
						151.001525992758,
						-33.8864173799669
					],
					"name": "Chester Hill Public School",
					"playspace": 34.5,
					"projections": [
						542,
						679,
						700,
						825,
						920,
						950
					],
					"projections_orig": [
						"542",
						"679",
						"700",
						"825",
						"920",
						"950"
					],
					"projections_percentage": [
						-20.18,
						0,
						3.09,
						21.5,
						35.49,
						39.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3698
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 28
					},
					"classroomspace": 2.4,
					"enrolment": 853,
					"ligo": 0.54,
					"location": [
						150.99244877628,
						-33.9118779317418
					],
					"name": "Georges Hall Public School",
					"playspace": 20.55,
					"projections": [
						811,
						853,
						915,
						930,
						965,
						995
					],
					"projections_orig": [
						"811",
						"853",
						"915",
						"930",
						"965",
						"995"
					],
					"projections_percentage": [
						-4.92,
						0,
						7.27,
						9.03,
						13.13,
						16.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3702
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 3.62,
					"enrolment": 261,
					"ligo": 0.78,
					"location": [
						150.985306306003,
						-33.889829014333
					],
					"name": "Villawood East Public School",
					"playspace": 66.24,
					"projections": [
						253,
						261,
						305,
						335,
						355,
						370
					],
					"projections_orig": [
						"253",
						"261",
						"305",
						"335",
						"355",
						"370"
					],
					"projections_percentage": [
						-3.07,
						0,
						16.86,
						28.35,
						36.02,
						41.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3977
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.48,
					"enrolment": 505,
					"ligo": 0.44,
					"location": [
						151.000336427955,
						-33.8731298320673
					],
					"name": "Chester Hill North Public School",
					"playspace": 43.77,
					"projections": [
						518,
						505,
						610,
						745,
						845,
						885
					],
					"projections_orig": [
						"518",
						"505",
						"610",
						"745",
						"845",
						"885"
					],
					"projections_percentage": [
						2.57,
						0,
						20.79,
						47.52,
						67.33,
						75.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3981
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.45,
					"enrolment": 576,
					"ligo": 0.54,
					"location": [
						151.021207833206,
						-33.8953491734546
					],
					"name": "Birrong Public School",
					"playspace": 22.82,
					"projections": [
						535,
						576,
						680,
						745,
						770,
						790
					],
					"projections_orig": [
						"535",
						"576",
						"680",
						"745",
						"770",
						"790"
					],
					"projections_percentage": [
						-7.12,
						0,
						18.06,
						29.34,
						33.68,
						37.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4057
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 2.46,
					"enrolment": 95,
					"ligo": 1,
					"location": [
						151.009135319793,
						-33.8894035242283
					],
					"name": "Sefton Infants School",
					"playspace": 37.68,
					"projections": [
						90,
						95,
						115,
						130,
						135,
						140
					],
					"projections_orig": [
						"90",
						"95",
						"115",
						"130",
						"135",
						"140"
					],
					"projections_percentage": [
						-5.26,
						0,
						21.05,
						36.84,
						42.11,
						47.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5188
				}
			],
			"uid": 10087
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 176
			},
			"enrolment": 3618,
			"level": "Primary",
			"ligo": 0.6,
			"name": "Padstow Primary",
			"playspace": 60.37,
			"projections": [
				3618,
				3960,
				4075,
				4215,
				4365
			],
			"projections_percentage": [
				0,
				9.45,
				12.63,
				16.5,
				20.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.41,
					"enrolment": 490,
					"ligo": 0.58,
					"location": [
						151.00032138068,
						-33.9653882392771
					],
					"name": "Panania Public School",
					"playspace": 51.65,
					"projections": [
						458,
						490,
						515,
						525,
						540,
						560
					],
					"projections_orig": [
						"458",
						"490",
						"515",
						"525",
						"540",
						"560"
					],
					"projections_percentage": [
						-6.53,
						0,
						5.1,
						7.14,
						10.2,
						14.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1809
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.39,
					"enrolment": 254,
					"ligo": 0.87,
					"location": [
						150.980305105822,
						-33.9414764518932
					],
					"name": "Milperra Public School",
					"playspace": 74.03,
					"projections": [
						228,
						254,
						270,
						275,
						280,
						290
					],
					"projections_orig": [
						"228",
						"254",
						"270",
						"275",
						"280",
						"290"
					],
					"projections_percentage": [
						-10.24,
						0,
						6.3,
						8.27,
						10.24,
						14.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2560
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.44,
					"enrolment": 340,
					"ligo": 0.61,
					"location": [
						151.031204856313,
						-33.9539026947552
					],
					"name": "Padstow Park Public School",
					"playspace": 61.05,
					"projections": [
						323,
						340,
						380,
						385,
						400,
						410
					],
					"projections_orig": [
						"323",
						"340",
						"380",
						"385",
						"400",
						"410"
					],
					"projections_percentage": [
						-5,
						0,
						11.76,
						13.24,
						17.65,
						20.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2826
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.04,
					"enrolment": 311,
					"ligo": 0.64,
					"location": [
						151.016376861956,
						-33.9443294149885
					],
					"name": "Revesby Public School",
					"playspace": 26.62,
					"projections": [
						305,
						311,
						350,
						360,
						370,
						380
					],
					"projections_orig": [
						"305",
						"311",
						"350",
						"360",
						"370",
						"380"
					],
					"projections_percentage": [
						-1.93,
						0,
						12.54,
						15.76,
						18.97,
						22.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2958
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.89,
					"enrolment": 180,
					"ligo": 0.39,
					"location": [
						150.992524813715,
						-33.9580746005681
					],
					"name": "East Hills Public School",
					"playspace": 74.15,
					"projections": [
						152,
						180,
						185,
						190,
						195,
						200
					],
					"projections_orig": [
						"152",
						"180",
						"185",
						"190",
						"195",
						"200"
					],
					"projections_percentage": [
						-15.56,
						0,
						2.78,
						5.56,
						8.33,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3924
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.42,
					"enrolment": 391,
					"ligo": 0.6,
					"location": [
						151.030801402577,
						-33.9667434734505
					],
					"name": "Padstow Heights Public School",
					"playspace": 42.51,
					"projections": [
						382,
						391,
						445,
						460,
						475,
						490
					],
					"projections_orig": [
						"382",
						"391",
						"445",
						"460",
						"475",
						"490"
					],
					"projections_percentage": [
						-2.3,
						0,
						13.81,
						17.65,
						21.48,
						25.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3958
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.31,
					"enrolment": 368,
					"ligo": 0.73,
					"location": [
						150.999790089148,
						-33.945876912284
					],
					"name": "Panania North Public School",
					"playspace": 61.79,
					"projections": [
						322,
						368,
						415,
						420,
						435,
						450
					],
					"projections_orig": [
						"322",
						"368",
						"415",
						"420",
						"435",
						"450"
					],
					"projections_percentage": [
						-12.5,
						0,
						12.77,
						14.13,
						18.21,
						22.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4012
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.35,
					"enrolment": 326,
					"ligo": 0.61,
					"location": [
						151.017201009737,
						-33.9596255879613
					],
					"name": "Revesby South Public School",
					"playspace": 51.23,
					"projections": [
						310,
						326,
						355,
						365,
						375,
						385
					],
					"projections_orig": [
						"310",
						"326",
						"355",
						"365",
						"375",
						"385"
					],
					"projections_percentage": [
						-4.91,
						0,
						8.9,
						11.96,
						15.03,
						18.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4016
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.58,
					"enrolment": 354,
					"ligo": 0.44,
					"location": [
						151.030618517707,
						-33.94368144689
					],
					"name": "Padstow North Public School",
					"playspace": 91.14,
					"projections": [
						345,
						354,
						400,
						435,
						470,
						500
					],
					"projections_orig": [
						"345",
						"354",
						"400",
						"435",
						"470",
						"500"
					],
					"projections_percentage": [
						-2.54,
						0,
						12.99,
						22.88,
						32.77,
						41.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4088
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.19,
					"enrolment": 204,
					"ligo": 0.48,
					"location": [
						151.008116295764,
						-33.9573092690013
					],
					"name": "Tower Street Public School",
					"playspace": 96.72,
					"projections": [
						177,
						204,
						205,
						210,
						215,
						220
					],
					"projections_orig": [
						"177",
						"204",
						"205",
						"210",
						"215",
						"220"
					],
					"projections_percentage": [
						-13.24,
						0,
						0.49,
						2.94,
						5.39,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4151
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.46,
					"enrolment": 400,
					"ligo": 0.63,
					"location": [
						151.009603216553,
						-33.9682168391521
					],
					"name": "Picnic Point Public School",
					"playspace": 33.16,
					"projections": [
						369,
						400,
						440,
						450,
						460,
						480
					],
					"projections_orig": [
						"369",
						"400",
						"440",
						"450",
						"460",
						"480"
					],
					"projections_percentage": [
						-7.75,
						0,
						10,
						12.5,
						15,
						20
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4342
				}
			],
			"uid": 10088
		},
		{
			"classrooms": {
				"demountable": 33,
				"permanent": 131
			},
			"enrolment": 3393,
			"level": "Primary",
			"ligo": 0.74,
			"name": "Toongabbie Primary",
			"playspace": 86.55,
			"projections": [
				3393,
				3690,
				3940,
				4155,
				4360
			],
			"projections_percentage": [
				0,
				8.75,
				16.12,
				22.46,
				28.5
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.53,
					"enrolment": 684,
					"ligo": 0.87,
					"location": [
						150.991506215155,
						-33.7862328246324
					],
					"name": "Northmead Public School",
					"playspace": 28.15,
					"projections": [
						630,
						684,
						750,
						780,
						800,
						815
					],
					"projections_orig": [
						"630",
						"684",
						"750",
						"780",
						"800",
						"815"
					],
					"projections_percentage": [
						-7.89,
						0,
						9.65,
						14.04,
						16.96,
						19.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2763
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 2.72,
					"enrolment": 621,
					"ligo": 0.5,
					"location": [
						150.967605634348,
						-33.7867643272827
					],
					"name": "Toongabbie Public School",
					"playspace": 23.47,
					"projections": [
						640,
						621,
						745,
						800,
						845,
						900
					],
					"projections_orig": [
						"640",
						"621",
						"745",
						"800",
						"845",
						"900"
					],
					"projections_percentage": [
						3.06,
						0,
						19.97,
						28.82,
						36.07,
						44.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3240
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 11
					},
					"classroomspace": 3.2,
					"enrolment": 662,
					"ligo": 0.8,
					"location": [
						150.966607755125,
						-33.8019475516991
					],
					"name": "Darcy Road Public School",
					"playspace": 22.82,
					"projections": [
						432,
						662,
						660,
						695,
						725,
						750
					],
					"projections_orig": [
						"432",
						"662",
						"660",
						"695",
						"725",
						"750"
					],
					"projections_percentage": [
						-34.74,
						0,
						-0.3,
						4.98,
						9.52,
						13.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4222
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 3.27,
					"enrolment": 253,
					"ligo": 0.6,
					"location": [
						150.956440432764,
						-33.792326732306
					],
					"name": "Toongabbie West Public School",
					"playspace": 57.57,
					"projections": [
						215,
						253,
						270,
						290,
						305,
						325
					],
					"projections_orig": [
						"215",
						"253",
						"270",
						"290",
						"305",
						"325"
					],
					"projections_percentage": [
						-15.02,
						0,
						6.72,
						14.62,
						20.55,
						28.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4364
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 13.9,
					"enrolment": 69,
					"ligo": 0.88,
					"location": [
						150.978813646416,
						-33.7971184714353
					],
					"name": "Toongabbie East Public School",
					"playspace": 403.63,
					"projections": [
						43,
						69,
						70,
						70,
						75,
						80
					],
					"projections_orig": [
						"43",
						"69",
						"70",
						"70",
						"75",
						"80"
					],
					"projections_percentage": [
						-37.68,
						0,
						1.45,
						1.45,
						8.7,
						15.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4366
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.91,
					"enrolment": 652,
					"ligo": 0.86,
					"location": [
						150.981800333395,
						-33.7734112073838
					],
					"name": "Winston Hills Public School",
					"playspace": 27.22,
					"projections": [
						567,
						652,
						725,
						790,
						850,
						900
					],
					"projections_orig": [
						"567",
						"652",
						"725",
						"790",
						"850",
						"900"
					],
					"projections_percentage": [
						-13.04,
						0,
						11.2,
						21.17,
						30.37,
						38.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4417
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 15
					},
					"classroomspace": 3.05,
					"enrolment": 452,
					"ligo": 0.67,
					"location": [
						150.967482953174,
						-33.7757764849631
					],
					"name": "Winston Heights Public School",
					"playspace": 42.96,
					"projections": [
						366,
						452,
						470,
						515,
						555,
						590
					],
					"projections_orig": [
						"366",
						"452",
						"470",
						"515",
						"555",
						"590"
					],
					"projections_percentage": [
						-19.03,
						0,
						3.98,
						13.94,
						22.79,
						30.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4471
				}
			],
			"uid": 10089
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 70
			},
			"enrolment": 1787,
			"level": "Primary",
			"ligo": 0.59,
			"name": "Dural Primary",
			"playspace": 195.29,
			"projections": [
				1787,
				1892,
				2027,
				2112,
				2172
			],
			"projections_percentage": [
				0,
				5.88,
				13.43,
				18.19,
				21.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.93,
					"enrolment": 78,
					"ligo": 0.74,
					"location": [
						151.051982831478,
						-33.622869027472
					],
					"name": "Arcadia Public School",
					"playspace": 256.56,
					"projections": [
						91,
						78,
						100,
						105,
						105,
						105
					],
					"projections_orig": [
						"91",
						"78",
						"100",
						"105",
						"105",
						"105"
					],
					"projections_percentage": [
						16.67,
						0,
						28.21,
						34.62,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1048
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 2.42,
					"enrolment": 430,
					"ligo": 0.39,
					"location": [
						151.027374512938,
						-33.6864033587423
					],
					"name": "Dural Public School",
					"playspace": 49.56,
					"projections": [
						429,
						430,
						485,
						515,
						535,
						545
					],
					"projections_orig": [
						"429",
						"430",
						"485",
						"515",
						"535",
						"545"
					],
					"projections_percentage": [
						-0.23,
						0,
						12.79,
						19.77,
						24.42,
						26.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1799
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 2.64,
					"enrolment": 263,
					"ligo": 0.59,
					"location": [
						151.045117416112,
						-33.6474796610273
					],
					"name": "Galston Public School",
					"playspace": 50.58,
					"projections": [
						235,
						263,
						280,
						290,
						295,
						295
					],
					"projections_orig": [
						"235",
						"263",
						"280",
						"290",
						"295",
						"295"
					],
					"projections_percentage": [
						-10.65,
						0,
						6.46,
						10.27,
						12.17,
						12.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1952
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 11
					},
					"classroomspace": 2.66,
					"enrolment": 440,
					"ligo": 0.51,
					"location": [
						151.00379652709,
						-33.7005579797182
					],
					"name": "Glenhaven Public School",
					"playspace": 26.43,
					"projections": [
						418,
						440,
						445,
						505,
						545,
						575
					],
					"projections_orig": [
						"418",
						"440",
						"445",
						"505",
						"545",
						"575"
					],
					"projections_percentage": [
						-5,
						0,
						1.14,
						14.77,
						23.86,
						30.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2003
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.07,
					"enrolment": 255,
					"ligo": 0.66,
					"location": [
						151.006907883892,
						-33.5997632344074
					],
					"name": "Glenorie Public School",
					"playspace": 88.47,
					"projections": [
						227,
						255,
						240,
						245,
						240,
						240
					],
					"projections_orig": [
						"227",
						"255",
						"240",
						"245",
						"240",
						"240"
					],
					"projections_percentage": [
						-10.98,
						0,
						-5.88,
						-3.92,
						-5.88,
						-5.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2012
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.57,
					"enrolment": 215,
					"ligo": 0.72,
					"location": [
						151.004517960504,
						-33.6648410166956
					],
					"name": "Kenthurst Public School",
					"playspace": 50.02,
					"projections": [
						196,
						215,
						225,
						235,
						245,
						255
					],
					"projections_orig": [
						"196",
						"215",
						"225",
						"235",
						"245",
						"255"
					],
					"projections_percentage": [
						-8.84,
						0,
						4.65,
						9.3,
						13.95,
						18.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2284
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.26,
					"enrolment": 22,
					"ligo": 0.41,
					"location": [
						151.022845467349,
						-33.644099069482
					],
					"name": "Middle Dural Public School",
					"playspace": 948.29,
					"projections": [
						27,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						22.73,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2542
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.34,
					"enrolment": 84,
					"ligo": 0.33,
					"location": [
						150.952119669322,
						-33.6689393151424
					],
					"name": "Annangrove Public School",
					"playspace": 92.38,
					"projections": [
						79,
						84,
						95,
						110,
						125,
						135
					],
					"projections_orig": [
						"79",
						"84",
						"95",
						"110",
						"125",
						"135"
					],
					"projections_percentage": [
						-5.95,
						0,
						13.1,
						30.95,
						48.81,
						60.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3719
				}
			],
			"uid": 10090
		},
		{
			"classrooms": {
				"demountable": 91,
				"permanent": 160
			},
			"enrolment": 5844,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Epping Primary",
			"playspace": 24.85,
			"projections": [
				5844,
				5820,
				6770,
				7090,
				7090
			],
			"projections_percentage": [
				0,
				-0.41,
				15.85,
				21.32,
				21.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 12
					},
					"classroomspace": 2.49,
					"enrolment": 433,
					"ligo": 0.72,
					"location": [
						151.087263751161,
						-33.7714852946658
					],
					"name": "Epping Public School",
					"playspace": 31.2,
					"projections": [
						364,
						433,
						495,
						630,
						680,
						685
					],
					"projections_orig": [
						"364",
						"433",
						"495",
						"630",
						"680",
						"685"
					],
					"projections_percentage": [
						-15.94,
						0,
						14.32,
						45.5,
						57.04,
						58.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1850
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 30
					},
					"classroomspace": 2.71,
					"enrolment": 1095,
					"ligo": 0.75,
					"location": [
						151.068473454784,
						-33.7736296269218
					],
					"name": "Epping West Public School",
					"playspace": 16.12,
					"projections": [
						664,
						1095,
						1070,
						1210,
						1240,
						1250
					],
					"projections_orig": [
						"664",
						"1095",
						"1070",
						"1210",
						"1240",
						"1250"
					],
					"projections_percentage": [
						-39.36,
						0,
						-2.28,
						10.5,
						13.24,
						14.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1851
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 26
					},
					"classroomspace": 2.57,
					"enrolment": 792,
					"ligo": 0.78,
					"location": [
						151.026316506371,
						-33.7683650226115
					],
					"name": "North Rocks Public School",
					"playspace": 21.23,
					"projections": [
						644,
						792,
						810,
						900,
						965,
						995
					],
					"projections_orig": [
						"644",
						"792",
						"810",
						"900",
						"965",
						"995"
					],
					"projections_percentage": [
						-18.69,
						0,
						2.27,
						13.64,
						21.84,
						25.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2764
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 9
					},
					"classroomspace": 2.79,
					"enrolment": 467,
					"ligo": 0.4,
					"location": [
						151.072950303679,
						-33.7628560764733
					],
					"name": "Epping Heights Public School",
					"playspace": 16.67,
					"projections": [
						363,
						467,
						470,
						570,
						610,
						615
					],
					"projections_orig": [
						"363",
						"467",
						"470",
						"570",
						"610",
						"615"
					],
					"projections_percentage": [
						-22.27,
						0,
						0.64,
						22.06,
						30.62,
						31.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4038
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.74,
					"enrolment": 337,
					"ligo": 0.67,
					"location": [
						151.051975738227,
						-33.7656610933689
					],
					"name": "Roselea Public School",
					"playspace": 38.22,
					"projections": [
						358,
						337,
						370,
						395,
						405,
						410
					],
					"projections_orig": [
						"358",
						"337",
						"370",
						"395",
						"405",
						"410"
					],
					"projections_percentage": [
						6.23,
						0,
						9.79,
						17.21,
						20.18,
						21.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4294
				},
				{
					"classrooms": {
						"demountable": 28,
						"permanent": 24
					},
					"classroomspace": 2.95,
					"enrolment": 1164,
					"ligo": 0.75,
					"location": [
						151.03600176175,
						-33.7827846939696
					],
					"name": "Carlingford West Public School",
					"playspace": 22.99,
					"projections": [
						740,
						1164,
						1095,
						1290,
						1340,
						1315
					],
					"projections_orig": [
						"740",
						"1164",
						"1095",
						"1290",
						"1340",
						"1315"
					],
					"projections_percentage": [
						-36.43,
						0,
						-5.93,
						10.82,
						15.12,
						12.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4393
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 30
					},
					"classroomspace": 2.72,
					"enrolment": 955,
					"ligo": 0.61,
					"location": [
						151.038942060953,
						-33.7661845167
					],
					"name": "Murray Farm Public School",
					"playspace": 16.08,
					"projections": [
						785,
						955,
						995,
						1160,
						1210,
						1195
					],
					"projections_orig": [
						"785",
						"955",
						"995",
						"1160",
						"1210",
						"1195"
					],
					"projections_percentage": [
						-17.8,
						0,
						4.19,
						21.47,
						26.7,
						25.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4401
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 13
					},
					"classroomspace": 2.87,
					"enrolment": 601,
					"ligo": 0.58,
					"location": [
						151.055676543096,
						-33.7800945995602
					],
					"name": "Carlingford Public School",
					"playspace": 36.3,
					"projections": [
						335,
						601,
						515,
						615,
						640,
						625
					],
					"projections_orig": [
						"335",
						"601",
						"515",
						"615",
						"640",
						"625"
					],
					"projections_percentage": [
						-44.26,
						0,
						-14.31,
						2.33,
						6.49,
						3.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7302
				}
			],
			"uid": 10091
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 80
			},
			"enrolment": 1352,
			"level": "Primary",
			"ligo": 0.64,
			"name": "Parramatta East Primary",
			"playspace": 108.42,
			"projections": [
				1352,
				1535,
				1715,
				1860,
				1920
			],
			"projections_percentage": [
				0,
				13.54,
				26.85,
				37.57,
				42.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.24,
					"enrolment": 240,
					"ligo": 0.68,
					"location": [
						151.017921035403,
						-33.7931126747346
					],
					"name": "Burnside Public School",
					"playspace": 74.23,
					"projections": [
						216,
						240,
						275,
						300,
						310,
						315
					],
					"projections_orig": [
						"216",
						"240",
						"275",
						"300",
						"310",
						"315"
					],
					"projections_percentage": [
						-10,
						0,
						14.58,
						25,
						29.17,
						31.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1433
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 5.15,
					"enrolment": 131,
					"ligo": 0.66,
					"location": [
						151.044981744152,
						-33.8129061547109
					],
					"name": "Rydalmere Public School",
					"playspace": 202.79,
					"projections": [
						124,
						131,
						140,
						155,
						175,
						185
					],
					"projections_orig": [
						"124",
						"131",
						"140",
						"155",
						"175",
						"185"
					],
					"projections_percentage": [
						-5.34,
						0,
						6.87,
						18.32,
						33.59,
						41.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3020
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 10
					},
					"classroomspace": 2.66,
					"enrolment": 400,
					"ligo": 0.68,
					"location": [
						151.036431291616,
						-33.8035327372181
					],
					"name": "Dundas Public School",
					"playspace": 30.5,
					"projections": [
						354,
						400,
						445,
						505,
						555,
						580
					],
					"projections_orig": [
						"354",
						"400",
						"445",
						"505",
						"555",
						"580"
					],
					"projections_percentage": [
						-11.5,
						0,
						11.25,
						26.25,
						38.75,
						45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4029
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.74,
					"enrolment": 202,
					"ligo": 0.35,
					"location": [
						151.022923756698,
						-33.7998273737877
					],
					"name": "Oatlands Public School",
					"playspace": 70.37,
					"projections": [
						166,
						202,
						220,
						250,
						270,
						275
					],
					"projections_orig": [
						"166",
						"202",
						"220",
						"250",
						"270",
						"275"
					],
					"projections_percentage": [
						-17.82,
						0,
						8.91,
						23.76,
						33.66,
						36.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4071
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 9.57,
					"enrolment": 54,
					"ligo": 0.8,
					"location": [
						151.042897399118,
						-33.7971367191462
					],
					"name": "Telopea Public School",
					"playspace": 232.28,
					"projections": [
						56,
						54,
						75,
						95,
						115,
						120
					],
					"projections_orig": [
						"56",
						"54",
						"75",
						"95",
						"115",
						"120"
					],
					"projections_percentage": [
						3.7,
						0,
						38.89,
						75.93,
						112.96,
						122.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4103
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.66,
					"enrolment": 161,
					"ligo": 0.69,
					"location": [
						151.058079712707,
						-33.8065797223109
					],
					"name": "Ermington West Public School",
					"playspace": 73.1,
					"projections": [
						146,
						161,
						175,
						185,
						200,
						205
					],
					"projections_orig": [
						"146",
						"161",
						"175",
						"185",
						"200",
						"205"
					],
					"projections_percentage": [
						-9.32,
						0,
						8.7,
						14.91,
						24.22,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4125
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.86,
					"enrolment": 164,
					"ligo": 0.62,
					"location": [
						151.057653368933,
						-33.7956366245182
					],
					"name": "Yates Avenue Public School",
					"playspace": 75.64,
					"projections": [
						226,
						164,
						205,
						225,
						235,
						240
					],
					"projections_orig": [
						"226",
						"164",
						"205",
						"225",
						"235",
						"240"
					],
					"projections_percentage": [
						37.8,
						0,
						25,
						37.2,
						43.29,
						46.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4157
				}
			],
			"uid": 10092
		},
		{
			"classrooms": {
				"demountable": 51,
				"permanent": 83
			},
			"enrolment": 3238,
			"level": "Primary",
			"ligo": 0.82,
			"name": "Quakers Hill East Primary",
			"playspace": 24.17,
			"projections": [
				3238,
				3515,
				3775,
				4020,
				4310
			],
			"projections_percentage": [
				0,
				8.55,
				16.58,
				24.15,
				33.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 21
					},
					"classroomspace": 2.43,
					"enrolment": 708,
					"ligo": 0.91,
					"location": [
						150.913083865353,
						-33.7328719495015
					],
					"name": "Quakers Hill East Public School",
					"playspace": 30.19,
					"projections": [
						623,
						708,
						735,
						775,
						820,
						870
					],
					"projections_orig": [
						"623",
						"708",
						"735",
						"775",
						"820",
						"870"
					],
					"projections_percentage": [
						-12.01,
						0,
						3.81,
						9.46,
						15.82,
						22.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4212
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 18
					},
					"classroomspace": 2.69,
					"enrolment": 636,
					"ligo": 0.69,
					"location": [
						150.886771256665,
						-33.7169967073852
					],
					"name": "Hambledon Public School",
					"playspace": 29.32,
					"projections": [
						608,
						636,
						820,
						875,
						900,
						955
					],
					"projections_orig": [
						"608",
						"636",
						"820",
						"875",
						"900",
						"955"
					],
					"projections_percentage": [
						-4.4,
						0,
						28.93,
						37.58,
						41.51,
						50.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4590
				},
				{
					"classrooms": {
						"demountable": 16,
						"permanent": 20
					},
					"classroomspace": 2.74,
					"enrolment": 868,
					"ligo": 0.81,
					"location": [
						150.902746487966,
						-33.7198487783075
					],
					"name": "Barnier Public School",
					"playspace": 22.05,
					"projections": [
						731,
						868,
						930,
						1035,
						1140,
						1255
					],
					"projections_orig": [
						"731",
						"868",
						"930",
						"1035",
						"1140",
						"1255"
					],
					"projections_percentage": [
						-15.78,
						0,
						7.14,
						19.24,
						31.34,
						44.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4599
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 24
					},
					"classroomspace": 2.82,
					"enrolment": 1026,
					"ligo": 0.88,
					"location": [
						150.927613221935,
						-33.7365221762417
					],
					"name": "Caddies Creek Public School",
					"playspace": 15.11,
					"projections": [
						922,
						1026,
						1030,
						1090,
						1160,
						1230
					],
					"projections_orig": [
						"922",
						"1026",
						"1030",
						"1090",
						"1160",
						"1230"
					],
					"projections_percentage": [
						-10.14,
						0,
						0.39,
						6.24,
						13.06,
						19.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4615
				}
			],
			"uid": 10093
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 127
			},
			"enrolment": 2723,
			"level": "Primary",
			"ligo": 0.57,
			"name": "Seven Hills Primary",
			"playspace": 59.94,
			"projections": [
				2723,
				2940,
				3235,
				3570,
				3890
			],
			"projections_percentage": [
				0,
				7.97,
				18.8,
				31.11,
				42.86
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.73,
					"enrolment": 256,
					"ligo": 0.52,
					"location": [
						150.954398604356,
						-33.7597482374251
					],
					"name": "Seven Hills North Public School",
					"playspace": 54.2,
					"projections": [
						178,
						256,
						245,
						260,
						275,
						290
					],
					"projections_orig": [
						"178",
						"256",
						"245",
						"260",
						"275",
						"290"
					],
					"projections_percentage": [
						-30.47,
						0,
						-4.3,
						1.56,
						7.42,
						13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3053
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 5.53,
					"enrolment": 127,
					"ligo": 0.54,
					"location": [
						150.937284391925,
						-33.770180521168
					],
					"name": "Seven Hills Public School",
					"playspace": 78.25,
					"projections": [
						122,
						127,
						135,
						150,
						165,
						180
					],
					"projections_orig": [
						"122",
						"127",
						"135",
						"150",
						"165",
						"180"
					],
					"projections_percentage": [
						-3.94,
						0,
						6.3,
						18.11,
						29.92,
						41.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3931
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 235,
					"ligo": 0.75,
					"location": [
						150.912277484816,
						-33.7577171961256
					],
					"name": "Blacktown North Public School",
					"playspace": 58.14,
					"projections": [
						151,
						235,
						265,
						320,
						405,
						500
					],
					"projections_orig": [
						"151",
						"235",
						"265",
						"320",
						"405",
						"500"
					],
					"projections_percentage": [
						-35.74,
						0,
						12.77,
						36.17,
						72.34,
						112.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4061
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 23
					},
					"classroomspace": 3.26,
					"enrolment": 433,
					"ligo": 0.59,
					"location": [
						150.921651710903,
						-33.76658535589
					],
					"name": "Seven Hills West Public School",
					"playspace": 35.47,
					"projections": [
						362,
						433,
						455,
						515,
						570,
						615
					],
					"projections_orig": [
						"362",
						"433",
						"455",
						"515",
						"570",
						"615"
					],
					"projections_percentage": [
						-16.4,
						0,
						5.08,
						18.94,
						31.64,
						42.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4162
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 7.98,
					"enrolment": 147,
					"ligo": 0.5,
					"location": [
						150.93227306708,
						-33.7597822407503
					],
					"name": "Lalor Park Public School",
					"playspace": 113.03,
					"projections": [
						138,
						147,
						160,
						170,
						180,
						190
					],
					"projections_orig": [
						"138",
						"147",
						"160",
						"170",
						"180",
						"190"
					],
					"projections_percentage": [
						-6.12,
						0,
						8.84,
						15.65,
						22.45,
						29.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.28,
					"enrolment": 507,
					"ligo": 0.46,
					"location": [
						150.942062149595,
						-33.7579938086823
					],
					"name": "Vardys Road Public School",
					"playspace": 39.83,
					"projections": [
						469,
						507,
						540,
						575,
						610,
						645
					],
					"projections_orig": [
						"469",
						"507",
						"540",
						"575",
						"610",
						"645"
					],
					"projections_percentage": [
						-7.5,
						0,
						6.51,
						13.41,
						20.32,
						27.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4248
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.71,
					"enrolment": 296,
					"ligo": 0.55,
					"location": [
						150.925526792935,
						-33.7544614344258
					],
					"name": "Lynwood Park Public School",
					"playspace": 81.97,
					"projections": [
						352,
						296,
						355,
						370,
						425,
						470
					],
					"projections_orig": [
						"352",
						"296",
						"355",
						"370",
						"425",
						"470"
					],
					"projections_percentage": [
						18.92,
						0,
						19.93,
						25,
						43.58,
						58.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4258
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 22
					},
					"classroomspace": 2.52,
					"enrolment": 722,
					"ligo": 0.67,
					"location": [
						150.923875599744,
						-33.7455929715575
					],
					"name": "Kings Langley Public School",
					"playspace": 18.62,
					"projections": [
						673,
						722,
						785,
						875,
						940,
						1000
					],
					"projections_orig": [
						"673",
						"722",
						"785",
						"875",
						"940",
						"1000"
					],
					"projections_percentage": [
						-6.79,
						0,
						8.73,
						21.19,
						30.19,
						38.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4528
				}
			],
			"uid": 10094
		},
		{
			"classrooms": {
				"demountable": 89,
				"permanent": 162
			},
			"enrolment": 6061,
			"level": "Primary",
			"ligo": 0.8,
			"name": "Castle Hill Primary",
			"playspace": 21.49,
			"projections": [
				6061,
				6460,
				7130,
				7870,
				8410
			],
			"projections_percentage": [
				0,
				6.58,
				17.64,
				29.85,
				38.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 27
					},
					"classroomspace": 2.47,
					"enrolment": 931,
					"ligo": 0.76,
					"location": [
						151.004409443853,
						-33.7281235822013
					],
					"name": "Castle Hill Public School",
					"playspace": 18.44,
					"projections": [
						760,
						931,
						1120,
						1365,
						1605,
						1800
					],
					"projections_orig": [
						"760",
						"931",
						"1120",
						"1365",
						"1605",
						"1800"
					],
					"projections_percentage": [
						-18.37,
						0,
						20.3,
						46.62,
						72.4,
						93.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1529
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.86,
					"enrolment": 516,
					"ligo": 0.87,
					"location": [
						150.991350743713,
						-33.7407003908552
					],
					"name": "Excelsior Public School",
					"playspace": 41.29,
					"projections": [
						401,
						516,
						535,
						600,
						650,
						680
					],
					"projections_orig": [
						"401",
						"516",
						"535",
						"600",
						"650",
						"680"
					],
					"projections_percentage": [
						-22.29,
						0,
						3.68,
						16.28,
						25.97,
						31.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1890
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 22
					},
					"classroomspace": 2.69,
					"enrolment": 887,
					"ligo": 0.9,
					"location": [
						150.999692540672,
						-33.7526586739295
					],
					"name": "Baulkham Hills North Public School",
					"playspace": 19.33,
					"projections": [
						762,
						887,
						975,
						1080,
						1215,
						1280
					],
					"projections_orig": [
						"762",
						"887",
						"975",
						"1080",
						"1215",
						"1280"
					],
					"projections_percentage": [
						-14.09,
						0,
						9.92,
						21.76,
						36.98,
						44.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4377
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 29
					},
					"classroomspace": 2.77,
					"enrolment": 824,
					"ligo": 0.81,
					"location": [
						150.981622758318,
						-33.761703318116
					],
					"name": "Jasper Road Public School",
					"playspace": 18.63,
					"projections": [
						726,
						824,
						810,
						905,
						1040,
						1120
					],
					"projections_orig": [
						"726",
						"824",
						"810",
						"905",
						"1040",
						"1120"
					],
					"projections_percentage": [
						-11.89,
						0,
						-1.7,
						9.83,
						26.21,
						35.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4382
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 21
					},
					"classroomspace": 2.78,
					"enrolment": 767,
					"ligo": 0.79,
					"location": [
						150.971363248296,
						-33.7480756582982
					],
					"name": "Crestwood Public School",
					"playspace": 22.39,
					"projections": [
						666,
						767,
						835,
						870,
						920,
						985
					],
					"projections_orig": [
						"666",
						"767",
						"835",
						"870",
						"920",
						"985"
					],
					"projections_percentage": [
						-13.17,
						0,
						8.87,
						13.43,
						19.95,
						28.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4441
				},
				{
					"classrooms": {
						"demountable": 28,
						"permanent": 28
					},
					"classroomspace": 2.72,
					"enrolment": 1374,
					"ligo": 0.85,
					"location": [
						150.963161562186,
						-33.7573054140554
					],
					"name": "Matthew Pearce Public School",
					"playspace": 13.93,
					"projections": [
						1028,
						1374,
						1335,
						1335,
						1345,
						1360
					],
					"projections_orig": [
						"1028",
						"1374",
						"1335",
						"1335",
						"1345",
						"1360"
					],
					"projections_percentage": [
						-25.18,
						0,
						-2.84,
						-2.84,
						-2.11,
						-1.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4526
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 18
					},
					"classroomspace": 2.54,
					"enrolment": 762,
					"ligo": 0.65,
					"location": [
						150.991385407306,
						-33.7139586261294
					],
					"name": "Samuel Gilbert Public School",
					"playspace": 16.42,
					"projections": [
						664,
						762,
						850,
						975,
						1095,
						1185
					],
					"projections_orig": [
						"664",
						"762",
						"850",
						"975",
						"1095",
						"1185"
					],
					"projections_percentage": [
						-12.86,
						0,
						11.55,
						27.95,
						43.7,
						55.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4574
				}
			],
			"uid": 10095
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 155
			},
			"enrolment": 3719,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Blacktown South Primary",
			"playspace": 50.99,
			"projections": [
				3719,
				4145,
				4525,
				4875,
				5205
			],
			"projections_percentage": [
				0,
				11.45,
				21.67,
				31.08,
				39.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.06,
					"enrolment": 225,
					"ligo": 0.65,
					"location": [
						150.871348508386,
						-33.7649532888973
					],
					"name": "Doonside Public School",
					"playspace": 68.68,
					"projections": [
						187,
						225,
						260,
						300,
						340,
						380
					],
					"projections_orig": [
						"187",
						"225",
						"260",
						"300",
						"340",
						"380"
					],
					"projections_percentage": [
						-16.89,
						0,
						15.56,
						33.33,
						51.11,
						68.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1760
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 3.23,
					"enrolment": 423,
					"ligo": 0.73,
					"location": [
						150.892216684504,
						-33.7710207452138
					],
					"name": "Blacktown West Public School",
					"playspace": 35.9,
					"projections": [
						408,
						423,
						485,
						545,
						605,
						670
					],
					"projections_orig": [
						"408",
						"423",
						"485",
						"545",
						"605",
						"670"
					],
					"projections_percentage": [
						-3.55,
						0,
						14.66,
						28.84,
						43.03,
						58.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4116
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.16,
					"enrolment": 252,
					"ligo": 0.75,
					"location": [
						150.92586218743,
						-33.7770179718775
					],
					"name": "Bert Oldfield Public School",
					"playspace": 123.42,
					"projections": [
						215,
						252,
						270,
						295,
						310,
						325
					],
					"projections_orig": [
						"215",
						"252",
						"270",
						"295",
						"310",
						"325"
					],
					"projections_percentage": [
						-14.68,
						0,
						7.14,
						17.06,
						23.02,
						28.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4192
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 29
					},
					"classroomspace": 2.42,
					"enrolment": 985,
					"ligo": 0.7,
					"location": [
						150.90680667851,
						-33.7810495759498
					],
					"name": "Blacktown South Public School",
					"playspace": 19.5,
					"projections": [
						819,
						985,
						1045,
						1155,
						1265,
						1360
					],
					"projections_orig": [
						"819",
						"985",
						"1045",
						"1155",
						"1265",
						"1360"
					],
					"projections_percentage": [
						-16.85,
						0,
						6.09,
						17.26,
						28.43,
						38.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4193
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.4,
					"enrolment": 575,
					"ligo": 0.78,
					"location": [
						150.893335739431,
						-33.7849044935515
					],
					"name": "Walters Road Public School",
					"playspace": 37.04,
					"projections": [
						516,
						575,
						645,
						680,
						715,
						750
					],
					"projections_orig": [
						"516",
						"575",
						"645",
						"680",
						"715",
						"750"
					],
					"projections_percentage": [
						-10.26,
						0,
						12.17,
						18.26,
						24.35,
						30.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4310
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 26
					},
					"classroomspace": 2.93,
					"enrolment": 555,
					"ligo": 0.51,
					"location": [
						150.917055542841,
						-33.7889410288748
					],
					"name": "Shelley Public School",
					"playspace": 42.1,
					"projections": [
						579,
						555,
						670,
						720,
						770,
						810
					],
					"projections_orig": [
						"579",
						"555",
						"670",
						"720",
						"770",
						"810"
					],
					"projections_percentage": [
						4.32,
						0,
						20.72,
						29.73,
						38.74,
						45.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4381
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 2.95,
					"enrolment": 704,
					"ligo": 0.64,
					"location": [
						150.935747319131,
						-33.7945991323979
					],
					"name": "Metella Road Public School",
					"playspace": 30.29,
					"projections": [
						621,
						704,
						770,
						830,
						870,
						910
					],
					"projections_orig": [
						"621",
						"704",
						"770",
						"830",
						"870",
						"910"
					],
					"projections_percentage": [
						-11.79,
						0,
						9.38,
						17.9,
						23.58,
						29.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4444
				}
			],
			"uid": 10096
		},
		{
			"classrooms": {
				"demountable": 27,
				"permanent": 194
			},
			"enrolment": 3161,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Lethbridge Park Primary",
			"playspace": 76.3,
			"projections": [
				3161,
				3505,
				3930,
				4305,
				4680
			],
			"projections_percentage": [
				0,
				10.88,
				24.33,
				36.19,
				48.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 6.02,
					"enrolment": 364,
					"ligo": 0.57,
					"location": [
						150.800854406806,
						-33.7372286801092
					],
					"name": "Lethbridge Park Public School",
					"playspace": 71.41,
					"projections": [
						405,
						364,
						440,
						470,
						500,
						530
					],
					"projections_orig": [
						"405",
						"364",
						"440",
						"470",
						"500",
						"530"
					],
					"projections_percentage": [
						11.26,
						0,
						20.88,
						29.12,
						37.36,
						45.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 8.13,
					"enrolment": 239,
					"ligo": 0.79,
					"location": [
						150.815497287723,
						-33.7390704590063
					],
					"name": "Blackett Public School",
					"playspace": 97.38,
					"projections": [
						273,
						239,
						275,
						295,
						315,
						330
					],
					"projections_orig": [
						"273",
						"239",
						"275",
						"295",
						"315",
						"330"
					],
					"projections_percentage": [
						14.23,
						0,
						15.06,
						23.43,
						31.8,
						38.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4453
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 9.26,
					"enrolment": 146,
					"ligo": 0.87,
					"location": [
						150.793236438952,
						-33.7261688069186
					],
					"name": "Willmot Public School",
					"playspace": 176.01,
					"projections": [
						215,
						146,
						225,
						250,
						270,
						290
					],
					"projections_orig": [
						"215",
						"146",
						"225",
						"250",
						"270",
						"290"
					],
					"projections_percentage": [
						47.26,
						0,
						54.11,
						71.23,
						84.93,
						98.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4470
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 5.55,
					"enrolment": 304,
					"ligo": 0.68,
					"location": [
						150.809431954501,
						-33.7262045684823
					],
					"name": "Shalvey Public School",
					"playspace": 83.99,
					"projections": [
						383,
						304,
						370,
						430,
						485,
						540
					],
					"projections_orig": [
						"383",
						"304",
						"370",
						"430",
						"485",
						"540"
					],
					"projections_percentage": [
						25.99,
						0,
						21.71,
						41.45,
						59.54,
						77.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4476
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 4.51,
					"enrolment": 382,
					"ligo": 0.6,
					"location": [
						150.826240843272,
						-33.7327335270981
					],
					"name": "Bidwill Public School",
					"playspace": 66.44,
					"projections": [
						479,
						382,
						445,
						525,
						600,
						680
					],
					"projections_orig": [
						"479",
						"382",
						"445",
						"525",
						"600",
						"680"
					],
					"projections_percentage": [
						25.39,
						0,
						16.49,
						37.43,
						57.07,
						78.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4480
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.68,
					"enrolment": 282,
					"ligo": 0.48,
					"location": [
						150.809352900983,
						-33.7325267602992
					],
					"name": "Noumea Public School",
					"playspace": 69.25,
					"projections": [
						288,
						282,
						320,
						345,
						365,
						385
					],
					"projections_orig": [
						"288",
						"282",
						"320",
						"345",
						"365",
						"385"
					],
					"projections_percentage": [
						2.13,
						0,
						13.48,
						22.34,
						29.43,
						36.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4493
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 23
					},
					"classroomspace": 2.73,
					"enrolment": 765,
					"ligo": 0.7,
					"location": [
						150.837566601271,
						-33.7346931786057
					],
					"name": "Hassall Grove Public School",
					"playspace": 30.5,
					"projections": [
						779,
						765,
						920,
						1080,
						1215,
						1350
					],
					"projections_orig": [
						"779",
						"765",
						"920",
						"1080",
						"1215",
						"1350"
					],
					"projections_percentage": [
						1.83,
						0,
						20.26,
						41.18,
						58.82,
						76.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4598
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 10
					},
					"classroomspace": 2.91,
					"enrolment": 679,
					"ligo": 0.91,
					"location": [
						150.782584220529,
						-33.7331419034383
					],
					"name": "Ropes Crossing Public School",
					"playspace": 15.46,
					"projections": [
						142,
						679,
						510,
						535,
						555,
						575
					],
					"projections_orig": [
						"142",
						"679",
						"510",
						"535",
						"555",
						"575"
					],
					"projections_percentage": [
						-79.09,
						0,
						-24.89,
						-21.21,
						-18.26,
						-15.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4645
				}
			],
			"uid": 10097
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 226
			},
			"enrolment": 4310,
			"level": "Primary",
			"ligo": 0.58,
			"name": "Mt Druitt Primary",
			"playspace": 61.04,
			"projections": [
				4310,
				4655,
				4990,
				5305,
				5605
			],
			"projections_percentage": [
				0,
				8,
				15.78,
				23.09,
				30.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.7,
					"enrolment": 472,
					"ligo": 0.48,
					"location": [
						150.837596331477,
						-33.7492487601415
					],
					"name": "Plumpton Public School",
					"playspace": 66,
					"projections": [
						493,
						472,
						550,
						585,
						620,
						655
					],
					"projections_orig": [
						"493",
						"472",
						"550",
						"585",
						"620",
						"655"
					],
					"projections_percentage": [
						4.45,
						0,
						16.53,
						23.94,
						31.36,
						38.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2887
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 23
					},
					"classroomspace": 2.53,
					"enrolment": 652,
					"ligo": 0.73,
					"location": [
						150.84015912433,
						-33.7687339171839
					],
					"name": "Rooty Hill Public School",
					"playspace": 28.21,
					"projections": [
						568,
						652,
						720,
						770,
						820,
						870
					],
					"projections_orig": [
						"568",
						"652",
						"720",
						"770",
						"820",
						"870"
					],
					"projections_percentage": [
						-12.88,
						0,
						10.43,
						18.1,
						25.77,
						33.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4056
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.5,
					"enrolment": 400,
					"ligo": 0.59,
					"location": [
						150.783250589628,
						-33.7559184711664
					],
					"name": "St Marys North Public School",
					"playspace": 46.23,
					"projections": [
						415,
						400,
						480,
						520,
						545,
						570
					],
					"projections_orig": [
						"415",
						"400",
						"480",
						"520",
						"545",
						"570"
					],
					"projections_percentage": [
						3.75,
						0,
						20,
						30,
						36.25,
						42.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4205
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 19
					},
					"classroomspace": 2.81,
					"enrolment": 590,
					"ligo": 0.75,
					"location": [
						150.813680344962,
						-33.763531734456
					],
					"name": "Mount Druitt Public School",
					"playspace": 32.32,
					"projections": [
						556,
						590,
						565,
						605,
						645,
						685
					],
					"projections_orig": [
						"556",
						"590",
						"565",
						"605",
						"645",
						"685"
					],
					"projections_percentage": [
						-5.76,
						0,
						-4.24,
						2.54,
						9.32,
						16.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4290
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 5.01,
					"enrolment": 334,
					"ligo": 0.56,
					"location": [
						150.81056720311,
						-33.7532377834465
					],
					"name": "Whalan Public School",
					"playspace": 79.41,
					"projections": [
						374,
						334,
						345,
						370,
						390,
						410
					],
					"projections_orig": [
						"374",
						"334",
						"345",
						"370",
						"390",
						"410"
					],
					"projections_percentage": [
						11.98,
						0,
						3.29,
						10.78,
						16.77,
						22.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4378
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 6.33,
					"enrolment": 337,
					"ligo": 0.69,
					"location": [
						150.795295148765,
						-33.7463771118576
					],
					"name": "Tregear Public School",
					"playspace": 90.47,
					"projections": [
						355,
						337,
						385,
						415,
						445,
						475
					],
					"projections_orig": [
						"355",
						"337",
						"385",
						"415",
						"445",
						"475"
					],
					"projections_percentage": [
						5.34,
						0,
						14.24,
						23.15,
						32.05,
						40.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4402
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.48,
					"enrolment": 253,
					"ligo": 0.72,
					"location": [
						150.806069431474,
						-33.7451786586706
					],
					"name": "Emerton Public School",
					"playspace": 64.21,
					"projections": [
						219,
						253,
						265,
						285,
						305,
						320
					],
					"projections_orig": [
						"219",
						"253",
						"265",
						"285",
						"305",
						"320"
					],
					"projections_percentage": [
						-13.44,
						0,
						4.74,
						12.65,
						20.55,
						26.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4422
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 4.59,
					"enrolment": 310,
					"ligo": 0.54,
					"location": [
						150.815228570272,
						-33.7450679635139
					],
					"name": "Dawson Public School",
					"playspace": 85.43,
					"projections": [
						387,
						310,
						340,
						365,
						390,
						410
					],
					"projections_orig": [
						"387",
						"310",
						"340",
						"365",
						"390",
						"410"
					],
					"projections_percentage": [
						24.84,
						0,
						9.68,
						17.74,
						25.81,
						32.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4446
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 23
					},
					"classroomspace": 3.1,
					"enrolment": 649,
					"ligo": 0.4,
					"location": [
						150.824868965105,
						-33.7474961039914
					],
					"name": "Hebersham Public School",
					"playspace": 32.7,
					"projections": [
						594,
						649,
						665,
						710,
						760,
						805
					],
					"projections_orig": [
						"594",
						"649",
						"665",
						"710",
						"760",
						"805"
					],
					"projections_percentage": [
						-8.47,
						0,
						2.47,
						9.4,
						17.1,
						24.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4447
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.24,
					"enrolment": 313,
					"ligo": 0.36,
					"location": [
						150.804820762091,
						-33.7594636355553
					],
					"name": "Madang Avenue Public School",
					"playspace": 85.46,
					"projections": [
						364,
						313,
						340,
						365,
						385,
						405
					],
					"projections_orig": [
						"364",
						"313",
						"340",
						"365",
						"385",
						"405"
					],
					"projections_percentage": [
						16.29,
						0,
						8.63,
						16.61,
						23,
						29.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4449
				}
			],
			"uid": 10098
		},
		{
			"classrooms": {
				"demountable": 34,
				"permanent": 79
			},
			"enrolment": 2796,
			"level": "Primary",
			"ligo": 0.77,
			"name": "Cherrybrook Primary",
			"playspace": 37.47,
			"projections": [
				2796,
				2775,
				2880,
				2960,
				3045
			],
			"projections_percentage": [
				0,
				-0.75,
				3,
				5.87,
				8.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.46,
					"enrolment": 592,
					"ligo": 0.75,
					"location": [
						151.072229076159,
						-33.7246784133177
					],
					"name": "Thornleigh West Public School",
					"playspace": 35.5,
					"projections": [
						573,
						592,
						590,
						610,
						610,
						610
					],
					"projections_orig": [
						"573",
						"592",
						"590",
						"610",
						"610",
						"610"
					],
					"projections_percentage": [
						-3.21,
						0,
						-0.34,
						3.04,
						3.04,
						3.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4276
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 2.79,
					"enrolment": 814,
					"ligo": 0.79,
					"location": [
						151.043326628318,
						-33.7315257629568
					],
					"name": "Cherrybrook Public School",
					"playspace": 34.27,
					"projections": [
						710,
						814,
						810,
						855,
						900,
						945
					],
					"projections_orig": [
						"710",
						"814",
						"810",
						"855",
						"900",
						"945"
					],
					"projections_percentage": [
						-12.78,
						0,
						-0.49,
						5.04,
						10.57,
						16.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4440
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 17
					},
					"classroomspace": 2.74,
					"enrolment": 656,
					"ligo": 0.72,
					"location": [
						151.038683067234,
						-33.7186333664553
					],
					"name": "John Purchase Public School",
					"playspace": 51.8,
					"projections": [
						666,
						656,
						665,
						680,
						690,
						705
					],
					"projections_orig": [
						"666",
						"656",
						"665",
						"680",
						"690",
						"705"
					],
					"projections_percentage": [
						1.52,
						0,
						1.37,
						3.66,
						5.18,
						7.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4572
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 16
					},
					"classroomspace": 2.55,
					"enrolment": 734,
					"ligo": 0.83,
					"location": [
						151.023762606671,
						-33.7212434816144
					],
					"name": "Oakhill Drive Public School",
					"playspace": 28.29,
					"projections": [
						553,
						734,
						710,
						735,
						760,
						785
					],
					"projections_orig": [
						"553",
						"734",
						"710",
						"735",
						"760",
						"785"
					],
					"projections_percentage": [
						-24.66,
						0,
						-3.27,
						0.14,
						3.54,
						6.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4604
				}
			],
			"uid": 10099
		},
		{
			"classrooms": {
				"demountable": 52,
				"permanent": 173
			},
			"enrolment": 4957,
			"level": "Primary",
			"ligo": 0.63,
			"name": "Merrylands Primary",
			"playspace": 41.16,
			"projections": [
				4957,
				5210,
				5695,
				6165,
				6450
			],
			"projections_percentage": [
				0,
				5.1,
				14.89,
				24.37,
				30.12
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 16,
						"permanent": 15
					},
					"classroomspace": 2.76,
					"enrolment": 748,
					"ligo": 0.47,
					"location": [
						150.940306320987,
						-33.8283442622197
					],
					"name": "Greystanes Public School",
					"playspace": 27.82,
					"projections": [
						634,
						748,
						800,
						860,
						915,
						955
					],
					"projections_orig": [
						"634",
						"748",
						"800",
						"860",
						"915",
						"955"
					],
					"projections_percentage": [
						-15.24,
						0,
						6.95,
						14.97,
						22.33,
						27.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2086
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 18
					},
					"classroomspace": 2.73,
					"enrolment": 560,
					"ligo": 0.78,
					"location": [
						150.981497026588,
						-33.8550650713543
					],
					"name": "Guildford Public School",
					"playspace": 25.7,
					"projections": [
						385,
						560,
						575,
						650,
						715,
						750
					],
					"projections_orig": [
						"385",
						"560",
						"575",
						"650",
						"715",
						"750"
					],
					"projections_percentage": [
						-31.25,
						0,
						2.68,
						16.07,
						27.68,
						33.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2093
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 14
					},
					"classroomspace": 2.71,
					"enrolment": 473,
					"ligo": 0.54,
					"location": [
						150.975519386388,
						-33.8401602014449
					],
					"name": "Merrylands Public School",
					"playspace": 22.27,
					"projections": [
						336,
						473,
						445,
						490,
						535,
						565
					],
					"projections_orig": [
						"336",
						"473",
						"445",
						"490",
						"535",
						"565"
					],
					"projections_percentage": [
						-28.96,
						0,
						-5.92,
						3.59,
						13.11,
						19.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2531
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 27
					},
					"classroomspace": 2.85,
					"enrolment": 741,
					"ligo": 0.45,
					"location": [
						150.974110204051,
						-33.8265329725747
					],
					"name": "Hilltop Road Public School",
					"playspace": 27.5,
					"projections": [
						610,
						741,
						855,
						945,
						1045,
						1085
					],
					"projections_orig": [
						"610",
						"741",
						"855",
						"945",
						"1045",
						"1085"
					],
					"projections_percentage": [
						-17.68,
						0,
						15.38,
						27.53,
						41.03,
						46.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3997
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 3.39,
					"enrolment": 425,
					"ligo": 0.59,
					"location": [
						150.967131373008,
						-33.8483289328641
					],
					"name": "Guildford West Public School",
					"playspace": 55.18,
					"projections": [
						461,
						425,
						470,
						495,
						520,
						535
					],
					"projections_orig": [
						"461",
						"425",
						"470",
						"495",
						"520",
						"535"
					],
					"projections_percentage": [
						8.47,
						0,
						10.59,
						16.47,
						22.35,
						25.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4000
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.96,
					"enrolment": 408,
					"ligo": 0.73,
					"location": [
						150.960376525948,
						-33.8194597992036
					],
					"name": "Ringrose Public School",
					"playspace": 52.78,
					"projections": [
						286,
						408,
						405,
						435,
						460,
						475
					],
					"projections_orig": [
						"286",
						"408",
						"405",
						"435",
						"460",
						"475"
					],
					"projections_percentage": [
						-29.9,
						0,
						-0.74,
						6.62,
						12.75,
						16.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4312
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.46,
					"enrolment": 344,
					"ligo": 0.59,
					"location": [
						150.959928540305,
						-33.8361168495277
					],
					"name": "Sherwood Grange Public School",
					"playspace": 64.5,
					"projections": [
						264,
						344,
						350,
						370,
						395,
						410
					],
					"projections_orig": [
						"264",
						"344",
						"350",
						"370",
						"395",
						"410"
					],
					"projections_percentage": [
						-23.26,
						0,
						1.74,
						7.56,
						14.83,
						19.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4328
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 20
					},
					"classroomspace": 2.83,
					"enrolment": 633,
					"ligo": 0.66,
					"location": [
						150.941606103392,
						-33.8145208408203
					],
					"name": "Beresford Road Public School",
					"playspace": 38.48,
					"projections": [
						429,
						633,
						595,
						630,
						665,
						685
					],
					"projections_orig": [
						"429",
						"633",
						"595",
						"630",
						"665",
						"685"
					],
					"projections_percentage": [
						-32.23,
						0,
						-6,
						-0.47,
						5.06,
						8.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4405
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.7,
					"enrolment": 246,
					"ligo": 0.67,
					"location": [
						150.940190262112,
						-33.8331172170239
					],
					"name": "Widemere Public School",
					"playspace": 78.8,
					"projections": [
						193,
						246,
						245,
						260,
						270,
						280
					],
					"projections_orig": [
						"193",
						"246",
						"245",
						"260",
						"270",
						"280"
					],
					"projections_percentage": [
						-21.54,
						0,
						-0.41,
						5.69,
						9.76,
						13.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4474
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.88,
					"enrolment": 379,
					"ligo": 0.78,
					"location": [
						150.990086231755,
						-33.8416899688346
					],
					"name": "Merrylands East Public School",
					"playspace": 18.55,
					"projections": [
						382,
						379,
						470,
						560,
						645,
						710
					],
					"projections_orig": [
						"382",
						"379",
						"470",
						"560",
						"645",
						"710"
					],
					"projections_percentage": [
						0.79,
						0,
						24.01,
						47.76,
						70.18,
						87.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5126
				}
			],
			"uid": 10100
		},
		{
			"classrooms": {
				"demountable": 56,
				"permanent": 99
			},
			"enrolment": 3557,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Pendle Hill Primary",
			"playspace": 36.75,
			"projections": [
				3557,
				3695,
				4030,
				4335,
				4525
			],
			"projections_percentage": [
				0,
				3.88,
				13.3,
				21.87,
				27.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 28,
						"permanent": 17
					},
					"classroomspace": 2.78,
					"enrolment": 1110,
					"ligo": 0.87,
					"location": [
						150.951128769664,
						-33.798655868916
					],
					"name": "Girraween Public School",
					"playspace": 12.13,
					"projections": [
						741,
						1110,
						1095,
						1175,
						1250,
						1305
					],
					"projections_orig": [
						"741",
						"1110",
						"1095",
						"1175",
						"1250",
						"1305"
					],
					"projections_percentage": [
						-33.24,
						0,
						-1.35,
						5.86,
						12.61,
						17.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1988
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.4,
					"enrolment": 219,
					"ligo": 0.84,
					"location": [
						150.942831356896,
						-33.7816672133956
					],
					"name": "The Meadows Public School",
					"playspace": 83.74,
					"projections": [
						195,
						219,
						235,
						260,
						285,
						310
					],
					"projections_orig": [
						"195",
						"219",
						"235",
						"260",
						"285",
						"310"
					],
					"projections_percentage": [
						-10.96,
						0,
						7.31,
						18.72,
						30.14,
						41.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2510
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 14
					},
					"classroomspace": 2.7,
					"enrolment": 529,
					"ligo": 0.77,
					"location": [
						150.968522431793,
						-33.8135733842176
					],
					"name": "Wentworthville Public School",
					"playspace": 24.42,
					"projections": [
						369,
						529,
						630,
						695,
						755,
						800
					],
					"projections_orig": [
						"369",
						"529",
						"630",
						"695",
						"755",
						"800"
					],
					"projections_percentage": [
						-30.25,
						0,
						19.09,
						31.38,
						42.72,
						51.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3423
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 39
					},
					"classroomspace": 2.42,
					"enrolment": 1408,
					"ligo": 0.95,
					"location": [
						150.98643644476,
						-33.8110879861551
					],
					"name": "Westmead Public School",
					"playspace": 9.46,
					"projections": [
						1013,
						1408,
						1400,
						1540,
						1665,
						1720
					],
					"projections_orig": [
						"1013",
						"1408",
						"1400",
						"1540",
						"1665",
						"1720"
					],
					"projections_percentage": [
						-28.05,
						0,
						-0.57,
						9.38,
						18.25,
						22.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3883
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 11
					},
					"classroomspace": 3.08,
					"enrolment": 291,
					"ligo": 0.8,
					"location": [
						150.953041851416,
						-33.8099257222635
					],
					"name": "Pendle Hill Public School",
					"playspace": 54.02,
					"projections": [
						277,
						291,
						335,
						360,
						380,
						390
					],
					"projections_orig": [
						"277",
						"291",
						"335",
						"360",
						"380",
						"390"
					],
					"projections_percentage": [
						-4.81,
						0,
						15.12,
						23.71,
						30.58,
						34.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3993
				}
			],
			"uid": 10101
		},
		{
			"classrooms": {
				"demountable": 54,
				"permanent": 80
			},
			"enrolment": 3210,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Parramatta CBD Primary",
			"playspace": 13.02,
			"projections": [
				3210,
				3590,
				4555,
				5555,
				6145
			],
			"projections_percentage": [
				0,
				11.84,
				41.9,
				73.05,
				91.43
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 21
					},
					"classroomspace": 1.93,
					"enrolment": 884,
					"ligo": 0.85,
					"location": [
						151.00784737274,
						-33.8162497377197
					],
					"name": "Parramatta Public School",
					"playspace": 3.01,
					"projections": [
						506,
						884,
						980,
						1325,
						1670,
						1915
					],
					"projections_orig": [
						"506",
						"884",
						"980",
						"1325",
						"1670",
						"1915"
					],
					"projections_percentage": [
						-42.76,
						0,
						10.86,
						49.89,
						88.91,
						116.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2840
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 9
					},
					"classroomspace": 2.17,
					"enrolment": 399,
					"ligo": 0.83,
					"location": [
						151.004401731495,
						-33.8043113250318
					],
					"name": "Parramatta North Public School",
					"playspace": 13.75,
					"projections": [
						262,
						399,
						430,
						525,
						640,
						670
					],
					"projections_orig": [
						"262",
						"399",
						"430",
						"525",
						"640",
						"670"
					],
					"projections_percentage": [
						-34.34,
						0,
						7.77,
						31.58,
						60.4,
						67.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2842
				},
				{
					"classrooms": {
						"demountable": 17,
						"permanent": 22
					},
					"classroomspace": 3.21,
					"enrolment": 782,
					"ligo": 0.85,
					"location": [
						150.990916509323,
						-33.8246678344757
					],
					"name": "Parramatta West Public School",
					"playspace": 6.67,
					"projections": [
						552,
						782,
						785,
						945,
						1110,
						1225
					],
					"projections_orig": [
						"552",
						"782",
						"785",
						"945",
						"1110",
						"1225"
					],
					"projections_percentage": [
						-29.41,
						0,
						0.38,
						20.84,
						41.94,
						56.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2843
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 482,
					"ligo": 0.71,
					"location": [
						151.018072556063,
						-33.8060969717196
					],
					"name": "Parramatta East Public School",
					"playspace": 22.74,
					"projections": [
						336,
						482,
						495,
						590,
						680,
						695
					],
					"projections_orig": [
						"336",
						"482",
						"495",
						"590",
						"680",
						"695"
					],
					"projections_percentage": [
						-30.29,
						0,
						2.7,
						22.41,
						41.08,
						44.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3840
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 20
					},
					"classroomspace": 2.73,
					"enrolment": 663,
					"ligo": 0.88,
					"location": [
						151.019464551575,
						-33.8243487556393
					],
					"name": "Rosehill Public School",
					"playspace": 18.92,
					"projections": [
						530,
						663,
						900,
						1170,
						1455,
						1640
					],
					"projections_orig": [
						"530",
						"663",
						"900",
						"1170",
						"1455",
						"1640"
					],
					"projections_percentage": [
						-20.06,
						0,
						35.75,
						76.47,
						119.46,
						147.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7444
				}
			],
			"uid": 10102
		},
		{
			"classrooms": {
				"demountable": 28,
				"permanent": 86
			},
			"enrolment": 2085,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Granville Primary",
			"playspace": 27.11,
			"projections": [
				2085,
				2420,
				2790,
				3125,
				3300
			],
			"projections_percentage": [
				0,
				16.07,
				33.81,
				49.88,
				58.27
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 32
					},
					"classroomspace": 3.01,
					"enrolment": 823,
					"ligo": 0.67,
					"location": [
						151.006039479983,
						-33.8573610204004
					],
					"name": "Blaxcell Street Public School",
					"playspace": 21.08,
					"projections": [
						869,
						823,
						960,
						1065,
						1175,
						1230
					],
					"projections_orig": [
						"869",
						"823",
						"960",
						"1065",
						"1175",
						"1230"
					],
					"projections_percentage": [
						5.59,
						0,
						16.65,
						29.4,
						42.77,
						49.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1257
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.87,
					"enrolment": 567,
					"ligo": 0.75,
					"location": [
						151.004827203956,
						-33.8335978159559
					],
					"name": "Granville Public School",
					"playspace": 20.28,
					"projections": [
						509,
						567,
						645,
						780,
						910,
						980
					],
					"projections_orig": [
						"509",
						"567",
						"645",
						"780",
						"910",
						"980"
					],
					"projections_percentage": [
						-10.23,
						0,
						13.76,
						37.57,
						60.49,
						72.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2064
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 14
					},
					"classroomspace": 3.08,
					"enrolment": 336,
					"ligo": 0.52,
					"location": [
						150.995825058224,
						-33.8487752287938
					],
					"name": "Granville South Public School",
					"playspace": 37.31,
					"projections": [
						225,
						336,
						355,
						420,
						470,
						500
					],
					"projections_orig": [
						"225",
						"336",
						"355",
						"420",
						"470",
						"500"
					],
					"projections_percentage": [
						-33.04,
						0,
						5.65,
						25,
						39.88,
						48.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2066
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 12
					},
					"classroomspace": 3.59,
					"enrolment": 359,
					"ligo": 0.75,
					"location": [
						151.010816906797,
						-33.8479494592838
					],
					"name": "Granville East Public School",
					"playspace": 29.77,
					"projections": [
						392,
						359,
						460,
						525,
						570,
						590
					],
					"projections_orig": [
						"392",
						"359",
						"460",
						"525",
						"570",
						"590"
					],
					"projections_percentage": [
						9.19,
						0,
						28.13,
						46.24,
						58.77,
						64.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5236
				}
			],
			"uid": 10103
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 71
			},
			"enrolment": 1877,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Greenacre Primary",
			"playspace": 32.41,
			"projections": [
				1877,
				1985,
				2120,
				2265,
				2390
			],
			"projections_percentage": [
				0,
				5.75,
				12.95,
				20.67,
				27.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 32
					},
					"classroomspace": 2.61,
					"enrolment": 850,
					"ligo": 0.56,
					"location": [
						151.056791408611,
						-33.910982043334
					],
					"name": "Greenacre Public School",
					"playspace": 12.21,
					"projections": [
						769,
						850,
						865,
						920,
						985,
						1035
					],
					"projections_orig": [
						"769",
						"850",
						"865",
						"920",
						"985",
						"1035"
					],
					"projections_percentage": [
						-9.53,
						0,
						1.76,
						8.24,
						15.88,
						21.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1123
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.04,
					"enrolment": 315,
					"ligo": 0.75,
					"location": [
						151.060902893283,
						-33.894711493801
					],
					"name": "Chullora Public School",
					"playspace": 49.77,
					"projections": [
						366,
						315,
						370,
						380,
						390,
						405
					],
					"projections_orig": [
						"366",
						"315",
						"370",
						"380",
						"390",
						"405"
					],
					"projections_percentage": [
						16.19,
						0,
						17.46,
						20.63,
						23.81,
						28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3808
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 15
					},
					"classroomspace": 2.77,
					"enrolment": 535,
					"ligo": 0.56,
					"location": [
						151.050853653323,
						-33.9060982853701
					],
					"name": "Banksia Road Public School",
					"playspace": 48.34,
					"projections": [
						362,
						535,
						545,
						595,
						645,
						685
					],
					"projections_orig": [
						"362",
						"535",
						"545",
						"595",
						"645",
						"685"
					],
					"projections_percentage": [
						-32.34,
						0,
						1.87,
						11.21,
						20.56,
						28.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4217
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 6
					},
					"classroomspace": 3.38,
					"enrolment": 177,
					"ligo": 1,
					"location": [
						151.050333113101,
						-33.9163405726803
					],
					"name": "Mount Lewis Infants School",
					"playspace": 19.3,
					"projections": [
						182,
						177,
						205,
						225,
						245,
						265
					],
					"projections_orig": [
						"182",
						"177",
						"205",
						"225",
						"245",
						"265"
					],
					"projections_percentage": [
						2.82,
						0,
						15.82,
						27.12,
						38.42,
						49.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5241
				}
			],
			"uid": 10104
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 144
			},
			"enrolment": 3458,
			"level": "Primary",
			"ligo": 0.63,
			"name": "Blacktown Primary",
			"playspace": 47.84,
			"projections": [
				3458,
				3810,
				4270,
				4655,
				4980
			],
			"projections_percentage": [
				0,
				10.18,
				23.48,
				34.62,
				44.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 25
					},
					"classroomspace": 2.61,
					"enrolment": 955,
					"ligo": 0.38,
					"location": [
						150.884194844544,
						-33.7374554141058
					],
					"name": "Quakers Hill Public School",
					"playspace": 22.88,
					"projections": [
						676,
						955,
						1010,
						1185,
						1310,
						1405
					],
					"projections_orig": [
						"676",
						"955",
						"1010",
						"1185",
						"1310",
						"1405"
					],
					"projections_percentage": [
						-29.21,
						0,
						5.76,
						24.08,
						37.17,
						47.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2918
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 3.39,
					"enrolment": 480,
					"ligo": 0.6,
					"location": [
						150.896160832556,
						-33.7571647563549
					],
					"name": "Marayong Public School",
					"playspace": 54.24,
					"projections": [
						489,
						480,
						555,
						615,
						660,
						710
					],
					"projections_orig": [
						"489",
						"480",
						"555",
						"615",
						"660",
						"710"
					],
					"projections_percentage": [
						1.88,
						0,
						15.62,
						28.12,
						37.5,
						47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4166
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.68,
					"enrolment": 322,
					"ligo": 0.64,
					"location": [
						150.897843200731,
						-33.7424072092128
					],
					"name": "Marayong Heights Public School",
					"playspace": 40.17,
					"projections": [
						316,
						322,
						350,
						390,
						430,
						460
					],
					"projections_orig": [
						"316",
						"322",
						"350",
						"390",
						"430",
						"460"
					],
					"projections_percentage": [
						-1.86,
						0,
						8.7,
						21.12,
						33.54,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4282
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.69,
					"enrolment": 350,
					"ligo": 0.68,
					"location": [
						150.8860747578,
						-33.7611331905306
					],
					"name": "Marayong South Public School",
					"playspace": 63.53,
					"projections": [
						283,
						350,
						395,
						420,
						445,
						470
					],
					"projections_orig": [
						"283",
						"350",
						"395",
						"420",
						"445",
						"470"
					],
					"projections_percentage": [
						-19.14,
						0,
						12.86,
						20,
						27.14,
						34.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4327
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.32,
					"enrolment": 483,
					"ligo": 0.64,
					"location": [
						150.868048961276,
						-33.7556430141507
					],
					"name": "Crawford Public School",
					"playspace": 41.83,
					"projections": [
						509,
						483,
						570,
						605,
						645,
						680
					],
					"projections_orig": [
						"509",
						"483",
						"570",
						"605",
						"645",
						"680"
					],
					"projections_percentage": [
						5.38,
						0,
						18.01,
						25.26,
						33.54,
						40.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4504
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3,
					"enrolment": 285,
					"ligo": 0.72,
					"location": [
						150.859599991462,
						-33.7351550617567
					],
					"name": "William Dean Public School",
					"playspace": 73.2,
					"projections": [
						256,
						285,
						340,
						385,
						420,
						445
					],
					"projections_orig": [
						"256",
						"285",
						"340",
						"385",
						"420",
						"445"
					],
					"projections_percentage": [
						-10.18,
						0,
						19.3,
						35.09,
						47.37,
						56.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4576
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.17,
					"enrolment": 583,
					"ligo": 0.73,
					"location": [
						150.853255886781,
						-33.7431988480154
					],
					"name": "Glendenning Public School",
					"playspace": 39.02,
					"projections": [
						505,
						583,
						590,
						670,
						745,
						810
					],
					"projections_orig": [
						"505",
						"583",
						"590",
						"670",
						"745",
						"810"
					],
					"projections_percentage": [
						-13.38,
						0,
						1.2,
						14.92,
						27.79,
						38.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4608
				}
			],
			"uid": 10105
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 78
			},
			"enrolment": 2455,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Pennant Hills Primary",
			"playspace": 30.54,
			"projections": [
				2455,
				2570,
				2755,
				2840,
				2900
			],
			"projections_percentage": [
				0,
				4.68,
				12.22,
				15.68,
				18.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 28
					},
					"classroomspace": 2.42,
					"enrolment": 835,
					"ligo": 0.78,
					"location": [
						151.065063643707,
						-33.7527329368585
					],
					"name": "Beecroft Public School",
					"playspace": 12.33,
					"projections": [
						711,
						835,
						860,
						910,
						920,
						925
					],
					"projections_orig": [
						"711",
						"835",
						"860",
						"910",
						"920",
						"925"
					],
					"projections_percentage": [
						-14.85,
						0,
						2.99,
						8.98,
						10.18,
						10.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1166
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 15
					},
					"classroomspace": 2.52,
					"enrolment": 546,
					"ligo": 0.83,
					"location": [
						151.068285992991,
						-33.7360441753883
					],
					"name": "Pennant Hills Public School",
					"playspace": 35.59,
					"projections": [
						511,
						546,
						585,
						615,
						625,
						625
					],
					"projections_orig": [
						"511",
						"546",
						"585",
						"615",
						"625",
						"625"
					],
					"projections_percentage": [
						-6.41,
						0,
						7.14,
						12.64,
						14.47,
						14.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2857
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 2.33,
					"enrolment": 650,
					"ligo": 0.6,
					"location": [
						151.050130513639,
						-33.7458516404836
					],
					"name": "West Pennant Hills Public School",
					"playspace": 24.33,
					"projections": [
						569,
						650,
						675,
						725,
						780,
						830
					],
					"projections_orig": [
						"569",
						"650",
						"675",
						"725",
						"780",
						"830"
					],
					"projections_percentage": [
						-12.46,
						0,
						3.85,
						11.54,
						20,
						27.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2858
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.21,
					"enrolment": 424,
					"ligo": 0.83,
					"location": [
						151.095542590062,
						-33.756840884127
					],
					"name": "Epping North Public School",
					"playspace": 49.91,
					"projections": [
						406,
						424,
						450,
						505,
						515,
						520
					],
					"projections_orig": [
						"406",
						"424",
						"450",
						"505",
						"515",
						"520"
					],
					"projections_percentage": [
						-4.25,
						0,
						6.13,
						19.1,
						21.46,
						22.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4165
				}
			],
			"uid": 10106
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 35
			},
			"enrolment": 654,
			"level": "Primary",
			"ligo": 0.53,
			"name": "Schofields Primary",
			"playspace": 207.28,
			"projections": [
				654,
				935,
				2575,
				3470,
				4660
			],
			"projections_percentage": [
				0,
				42.97,
				293.73,
				430.58,
				612.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.46,
					"enrolment": 56,
					"ligo": 0.53,
					"location": [
						150.832749108896,
						-33.6961592318258
					],
					"name": "Marsden Park Public School",
					"playspace": 297.71,
					"projections": [
						69,
						56,
						165,
						780,
						1095,
						1460
					],
					"projections_orig": [
						"69",
						"56",
						"165",
						"780",
						"1095",
						"1460"
					],
					"projections_percentage": [
						23.21,
						0,
						194.64,
						1292.86,
						1855.36,
						2507.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2489
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.37,
					"enrolment": 251,
					"ligo": 0.71,
					"location": [
						150.869733854412,
						-33.677761365872
					],
					"name": "Riverstone Public School",
					"playspace": 77.02,
					"projections": [
						301,
						251,
						310,
						700,
						945,
						1260
					],
					"projections_orig": [
						"301",
						"251",
						"310",
						"700",
						"945",
						"1260"
					],
					"projections_percentage": [
						19.92,
						0,
						23.51,
						178.88,
						276.49,
						401.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2970
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 7
					},
					"classroomspace": 3.57,
					"enrolment": 321,
					"ligo": 0.5,
					"location": [
						150.875363705058,
						-33.6922658997546
					],
					"name": "Schofields Public School",
					"playspace": 66.97,
					"projections": [
						290,
						321,
						410,
						940,
						1250,
						1565
					],
					"projections_orig": [
						"290",
						"321",
						"410",
						"940",
						"1250",
						"1565"
					],
					"projections_percentage": [
						-9.66,
						0,
						27.73,
						192.83,
						289.41,
						387.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3046
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.17,
					"enrolment": 26,
					"ligo": 0.38,
					"location": [
						150.857321728101,
						-33.6471327934044
					],
					"name": "Vineyard Public School",
					"playspace": 387.41,
					"projections": [
						36,
						26,
						50,
						155,
						180,
						375
					],
					"projections_orig": [
						"36",
						"26",
						"50",
						"155",
						"180",
						"375"
					],
					"projections_percentage": [
						38.46,
						0,
						92.31,
						496.15,
						592.31,
						1342.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3329
				}
			],
			"uid": 10107
		},
		{
			"classrooms": {
				"demountable": 64,
				"permanent": 73
			},
			"enrolment": 3262,
			"level": "Primary",
			"ligo": 0.86,
			"name": "The Ponds Primary",
			"playspace": 20.38,
			"projections": [
				3262,
				3690,
				3940,
				4205,
				4460
			],
			"projections_percentage": [
				0,
				13.12,
				20.78,
				28.91,
				36.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 20
					},
					"classroomspace": 2.51,
					"enrolment": 712,
					"ligo": 0.8,
					"location": [
						150.935466149672,
						-33.726752910774
					],
					"name": "Parklea Public School",
					"playspace": 28.05,
					"projections": [
						702,
						712,
						880,
						975,
						1055,
						1145
					],
					"projections_orig": [
						"702",
						"712",
						"880",
						"975",
						"1055",
						"1145"
					],
					"projections_percentage": [
						-1.4,
						0,
						23.6,
						36.94,
						48.17,
						60.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2838
				},
				{
					"classrooms": {
						"demountable": 21,
						"permanent": 14
					},
					"classroomspace": 2.93,
					"enrolment": 835,
					"ligo": 0.79,
					"location": [
						150.925484986101,
						-33.704324554498
					],
					"name": "Kellyville Ridge Public School",
					"playspace": 17.17,
					"projections": [
						774,
						835,
						935,
						1040,
						1160,
						1260
					],
					"projections_orig": [
						"774",
						"835",
						"935",
						"1040",
						"1160",
						"1260"
					],
					"projections_percentage": [
						-7.31,
						0,
						11.98,
						24.55,
						38.92,
						50.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4639
				},
				{
					"classrooms": {
						"demountable": 19,
						"permanent": 18
					},
					"classroomspace": 2.76,
					"enrolment": 903,
					"ligo": 0.86,
					"location": [
						150.912011995865,
						-33.7078947012482
					],
					"name": "John Palmer Public School",
					"playspace": 20.4,
					"projections": [
						512,
						903,
						935,
						945,
						975,
						1005
					],
					"projections_orig": [
						"512",
						"903",
						"935",
						"945",
						"975",
						"1005"
					],
					"projections_percentage": [
						-43.3,
						0,
						3.54,
						4.65,
						7.97,
						11.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4648
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 21
					},
					"classroomspace": 2.99,
					"enrolment": 812,
					"ligo": 0.87,
					"location": [
						150.899219169294,
						-33.7036966668922
					],
					"name": "Riverbank Public School",
					"playspace": 15.88,
					"projections": [
						0,
						812,
						940,
						980,
						1015,
						1050
					],
					"projections_orig": [
						"0",
						"812",
						"940",
						"980",
						"1015",
						"1050"
					],
					"projections_percentage": [
						-100,
						0,
						15.76,
						20.69,
						25,
						29.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4653
				}
			],
			"uid": 10108
		},
		{
			"classrooms": {
				"demountable": 54,
				"permanent": 101
			},
			"enrolment": 3678,
			"level": "Primary",
			"ligo": 0.82,
			"name": "Kellyville Primary",
			"playspace": 24.42,
			"projections": [
				3678,
				4440,
				6440,
				7785,
				9665
			],
			"projections_percentage": [
				0,
				20.72,
				75.1,
				111.66,
				162.78
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 22
					},
					"classroomspace": 2.61,
					"enrolment": 728,
					"ligo": 0.83,
					"location": [
						150.957641421517,
						-33.712109170982
					],
					"name": "Kellyville Public School",
					"playspace": 17.11,
					"projections": [
						530,
						728,
						915,
						1340,
						1715,
						2000
					],
					"projections_orig": [
						"530",
						"728",
						"915",
						"1340",
						"1715",
						"2000"
					],
					"projections_percentage": [
						-27.2,
						0,
						25.69,
						84.07,
						135.58,
						174.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2274
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 25
					},
					"classroomspace": 3.16,
					"enrolment": 656,
					"ligo": 0.8,
					"location": [
						150.920080913483,
						-33.6786555040913
					],
					"name": "Rouse Hill Public School",
					"playspace": 27.96,
					"projections": [
						866,
						656,
						980,
						1850,
						2190,
						3280
					],
					"projections_orig": [
						"866",
						"656",
						"980",
						"1850",
						"2190",
						"3280"
					],
					"projections_percentage": [
						32.01,
						0,
						49.39,
						182.01,
						233.84,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3008
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.48,
					"enrolment": 613,
					"ligo": 0.8,
					"location": [
						150.946293521181,
						-33.6972537112269
					],
					"name": "Beaumont Hills Public School",
					"playspace": 31.43,
					"projections": [
						613,
						613,
						710,
						900,
						1060,
						1185
					],
					"projections_orig": [
						"613",
						"613",
						"710",
						"900",
						"1060",
						"1185"
					],
					"projections_percentage": [
						0,
						0,
						15.82,
						46.82,
						72.92,
						93.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4630
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 14
					},
					"classroomspace": 2.55,
					"enrolment": 749,
					"ligo": 0.68,
					"location": [
						150.932631871527,
						-33.6885902184696
					],
					"name": "Ironbark Ridge Public School",
					"playspace": 21.48,
					"projections": [
						544,
						749,
						800,
						1070,
						1305,
						1520
					],
					"projections_orig": [
						"544",
						"749",
						"800",
						"1070",
						"1305",
						"1520"
					],
					"projections_percentage": [
						-27.37,
						0,
						6.81,
						42.86,
						74.23,
						102.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4638
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 20
					},
					"classroomspace": 2.87,
					"enrolment": 932,
					"ligo": 0.83,
					"location": [
						150.976524543576,
						-33.7073991442358
					],
					"name": "Sherwood Ridge Public School",
					"playspace": 24.14,
					"projections": [
						779,
						932,
						1035,
						1280,
						1515,
						1680
					],
					"projections_orig": [
						"779",
						"932",
						"1035",
						"1280",
						"1515",
						"1680"
					],
					"projections_percentage": [
						-16.42,
						0,
						11.05,
						37.34,
						62.55,
						80.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4640
				}
			],
			"uid": 10109
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 42
			},
			"enrolment": 1002,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Hawkesbury East Primary",
			"playspace": 277.71,
			"projections": [
				1002,
				1201,
				1441,
				1781,
				2086
			],
			"projections_percentage": [
				0,
				19.86,
				43.81,
				77.74,
				108.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.5,
					"enrolment": 52,
					"ligo": 0.57,
					"location": [
						150.90688477043,
						-33.5587671750102
					],
					"name": "Cattai Public School",
					"playspace": 85.26,
					"projections": [
						57,
						52,
						60,
						65,
						70,
						70
					],
					"projections_orig": [
						"57",
						"52",
						"60",
						"65",
						"70",
						"70"
					],
					"projections_percentage": [
						9.62,
						0,
						15.38,
						25,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1535
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.23,
					"enrolment": 28,
					"ligo": 0.42,
					"location": [
						150.976694650129,
						-33.6015425880439
					],
					"name": "Hillside Public School",
					"playspace": 400.87,
					"projections": [
						56,
						28,
						50,
						55,
						60,
						65
					],
					"projections_orig": [
						"56",
						"28",
						"50",
						"55",
						"60",
						"65"
					],
					"projections_percentage": [
						100,
						0,
						78.57,
						96.43,
						114.29,
						132.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2164
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.25,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						150.97197828918,
						-33.3206450175787
					],
					"name": "Macdonald Valley Public School",
					"playspace": 740.69,
					"projections": [
						8,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.27,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2439
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.74,
					"enrolment": 115,
					"ligo": 0.63,
					"location": [
						150.915991165076,
						-33.5936234394937
					],
					"name": "Maraylya Public School",
					"playspace": 95.2,
					"projections": [
						110,
						115,
						155,
						200,
						270,
						325
					],
					"projections_orig": [
						"110",
						"115",
						"155",
						"200",
						"270",
						"325"
					],
					"projections_percentage": [
						-4.35,
						0,
						34.78,
						73.91,
						134.78,
						182.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2472
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.41,
					"enrolment": 29,
					"ligo": 0.42,
					"location": [
						150.994250474276,
						-33.455557413087
					],
					"name": "Maroota Public School",
					"playspace": 348.11,
					"projections": [
						53,
						29,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"53",
						"29",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						82.76,
						0,
						72.41,
						72.41,
						72.41,
						72.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2480
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.48,
					"enrolment": 446,
					"ligo": 0.62,
					"location": [
						150.87057554826,
						-33.6197838366512
					],
					"name": "Oakville Public School",
					"playspace": 35.66,
					"projections": [
						426,
						446,
						550,
						730,
						965,
						1165
					],
					"projections_orig": [
						"426",
						"446",
						"550",
						"730",
						"965",
						"1165"
					],
					"projections_percentage": [
						-4.48,
						0,
						23.32,
						63.68,
						116.37,
						161.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2794
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 6
					},
					"classroomspace": 3.06,
					"enrolment": 286,
					"ligo": 0.65,
					"location": [
						150.859954616521,
						-33.5843094151674
					],
					"name": "Pitt Town Public School",
					"playspace": 82.3,
					"projections": [
						163,
						286,
						275,
						280,
						305,
						350
					],
					"projections_orig": [
						"163",
						"286",
						"275",
						"280",
						"305",
						"350"
					],
					"projections_percentage": [
						-43.01,
						0,
						-3.85,
						-2.1,
						6.64,
						22.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2884
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 8.72,
					"enrolment": 35,
					"ligo": 0.57,
					"location": [
						150.985052628361,
						-33.3861356144271
					],
					"name": "Wisemans Ferry Public School",
					"playspace": 433.56,
					"projections": [
						66,
						35,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"66",
						"35",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						88.57,
						0,
						42.86,
						42.86,
						42.86,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3470
				}
			],
			"uid": 10110
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 134
			},
			"enrolment": 3183,
			"level": "Primary",
			"ligo": 0.66,
			"name": "St Marys Primary",
			"playspace": 51.79,
			"projections": [
				3183,
				3405,
				3680,
				3910,
				4105
			],
			"projections_percentage": [
				0,
				6.97,
				15.61,
				22.84,
				28.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 23
					},
					"classroomspace": 2.39,
					"enrolment": 770,
					"ligo": 0.53,
					"location": [
						150.81265415491,
						-33.776958416077
					],
					"name": "Colyton Public School",
					"playspace": 27.07,
					"projections": [
						662,
						770,
						785,
						855,
						910,
						960
					],
					"projections_orig": [
						"662",
						"770",
						"785",
						"855",
						"910",
						"960"
					],
					"projections_percentage": [
						-14.03,
						0,
						1.95,
						11.04,
						18.18,
						24.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1596
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.39,
					"enrolment": 306,
					"ligo": 0.72,
					"location": [
						150.853862164885,
						-33.7877836797885
					],
					"name": "Eastern Creek Public School",
					"playspace": 55.95,
					"projections": [
						292,
						306,
						325,
						345,
						370,
						390
					],
					"projections_orig": [
						"292",
						"306",
						"325",
						"345",
						"370",
						"390"
					],
					"projections_percentage": [
						-4.58,
						0,
						6.21,
						12.75,
						20.92,
						27.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1808
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.95,
					"enrolment": 291,
					"ligo": 0.61,
					"location": [
						150.770330565374,
						-33.7685799398685
					],
					"name": "St Marys Public School",
					"playspace": 65.34,
					"projections": [
						228,
						291,
						300,
						330,
						355,
						375
					],
					"projections_orig": [
						"228",
						"291",
						"300",
						"330",
						"355",
						"375"
					],
					"projections_percentage": [
						-21.65,
						0,
						3.09,
						13.4,
						21.99,
						28.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3031
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 2.57,
					"enrolment": 495,
					"ligo": 0.63,
					"location": [
						150.789301929249,
						-33.7707406165155
					],
					"name": "Oxley Park Public School",
					"playspace": 39.12,
					"projections": [
						493,
						495,
						540,
						595,
						635,
						670
					],
					"projections_orig": [
						"493",
						"495",
						"540",
						"595",
						"635",
						"670"
					],
					"projections_percentage": [
						-0.4,
						0,
						9.09,
						20.2,
						28.28,
						35.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4055
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.84,
					"enrolment": 297,
					"ligo": 0.65,
					"location": [
						150.775488237882,
						-33.7795601681774
					],
					"name": "St Marys South Public School",
					"playspace": 83.78,
					"projections": [
						287,
						297,
						340,
						365,
						385,
						400
					],
					"projections_orig": [
						"287",
						"297",
						"340",
						"365",
						"385",
						"400"
					],
					"projections_percentage": [
						-3.37,
						0,
						14.48,
						22.9,
						29.63,
						34.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4279
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 3.27,
					"enrolment": 508,
					"ligo": 0.72,
					"location": [
						150.791139582858,
						-33.7839738756934
					],
					"name": "Bennett Road Public School",
					"playspace": 50.73,
					"projections": [
						451,
						508,
						570,
						610,
						645,
						665
					],
					"projections_orig": [
						"451",
						"508",
						"570",
						"610",
						"645",
						"665"
					],
					"projections_percentage": [
						-11.22,
						0,
						12.2,
						20.08,
						26.97,
						30.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4285
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.5,
					"enrolment": 516,
					"ligo": 0.76,
					"location": [
						150.831811017609,
						-33.7876058554851
					],
					"name": "Minchinbury Public School",
					"playspace": 40.55,
					"projections": [
						555,
						516,
						545,
						580,
						610,
						645
					],
					"projections_orig": [
						"555",
						"516",
						"545",
						"580",
						"610",
						"645"
					],
					"projections_percentage": [
						7.56,
						0,
						5.62,
						12.4,
						18.22,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4577
				}
			],
			"uid": 10111
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 155
			},
			"enrolment": 2712,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Albury City Primary",
			"playspace": 95,
			"projections": [
				2712,
				2670,
				2745,
				2770,
				2720
			],
			"projections_percentage": [
				0,
				-1.55,
				1.22,
				2.14,
				0.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 2.88,
					"enrolment": 574,
					"ligo": 0.79,
					"location": [
						146.920285140865,
						-36.0827945079037
					],
					"name": "Albury Public School",
					"playspace": 31.12,
					"projections": [
						618,
						574,
						620,
						640,
						640,
						620
					],
					"projections_orig": [
						"618",
						"574",
						"620",
						"640",
						"640",
						"620"
					],
					"projections_percentage": [
						7.67,
						0,
						8.01,
						11.5,
						11.5,
						8.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1017
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.94,
					"enrolment": 142,
					"ligo": 0.9,
					"location": [
						146.896314878771,
						-36.0774151944936
					],
					"name": "Albury West Public School",
					"playspace": 124.54,
					"projections": [
						122,
						142,
						130,
						130,
						135,
						130
					],
					"projections_orig": [
						"122",
						"142",
						"130",
						"130",
						"135",
						"130"
					],
					"projections_percentage": [
						-14.08,
						0,
						-8.45,
						-8.45,
						-4.93,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1019
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.29,
					"enrolment": 339,
					"ligo": 0.65,
					"location": [
						146.928184000598,
						-36.038016321529
					],
					"name": "Lavington Public School",
					"playspace": 114.88,
					"projections": [
						348,
						339,
						315,
						325,
						330,
						325
					],
					"projections_orig": [
						"348",
						"339",
						"315",
						"325",
						"330",
						"325"
					],
					"projections_percentage": [
						2.65,
						0,
						-7.08,
						-4.13,
						-2.65,
						-4.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2378
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.5,
					"enrolment": 487,
					"ligo": 0.9,
					"location": [
						146.982778452228,
						-36.0475263687704
					],
					"name": "Thurgoona Public School",
					"playspace": 55.69,
					"projections": [
						370,
						487,
						425,
						440,
						445,
						440
					],
					"projections_orig": [
						"370",
						"487",
						"425",
						"440",
						"445",
						"440"
					],
					"projections_percentage": [
						-24.02,
						0,
						-12.73,
						-9.65,
						-8.62,
						-9.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3208
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 4.37,
					"enrolment": 254,
					"ligo": 0.72,
					"location": [
						146.931440577263,
						-36.0644210028668
					],
					"name": "Albury North Public School",
					"playspace": 83.2,
					"projections": [
						251,
						254,
						275,
						280,
						285,
						280
					],
					"projections_orig": [
						"251",
						"254",
						"275",
						"280",
						"285",
						"280"
					],
					"projections_percentage": [
						-1.18,
						0,
						8.27,
						10.24,
						12.2,
						10.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3922
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 2.81,
					"enrolment": 348,
					"ligo": 0.46,
					"location": [
						146.947734286219,
						-36.0397396740408
					],
					"name": "Lavington East Public School",
					"playspace": 87.7,
					"projections": [
						336,
						348,
						345,
						355,
						355,
						350
					],
					"projections_orig": [
						"336",
						"348",
						"345",
						"355",
						"355",
						"350"
					],
					"projections_percentage": [
						-3.45,
						0,
						-0.86,
						2.01,
						2.01,
						0.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4168
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 5.43,
					"enrolment": 214,
					"ligo": 0.56,
					"location": [
						146.946534023287,
						-36.0492642209467
					],
					"name": "Hume Public School",
					"playspace": 142.45,
					"projections": [
						216,
						214,
						205,
						210,
						215,
						210
					],
					"projections_orig": [
						"216",
						"214",
						"205",
						"210",
						"215",
						"210"
					],
					"projections_percentage": [
						0.93,
						0,
						-4.21,
						-1.87,
						0.47,
						-1.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.77,
					"enrolment": 183,
					"ligo": 0.68,
					"location": [
						146.916999030304,
						-36.0557292409955
					],
					"name": "Glenroy Public School",
					"playspace": 103.48,
					"projections": [
						186,
						183,
						185,
						190,
						190,
						190
					],
					"projections_orig": [
						"186",
						"183",
						"185",
						"190",
						"190",
						"190"
					],
					"projections_percentage": [
						1.64,
						0,
						1.09,
						3.83,
						3.83,
						3.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4468
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.1,
					"enrolment": 171,
					"ligo": 0.61,
					"location": [
						146.95025584506,
						-36.0321306790772
					],
					"name": "Springdale Heights Public School",
					"playspace": 111.93,
					"projections": [
						170,
						171,
						170,
						175,
						175,
						175
					],
					"projections_orig": [
						"170",
						"171",
						"170",
						"175",
						"175",
						"175"
					],
					"projections_percentage": [
						-0.58,
						0,
						-0.58,
						2.34,
						2.34,
						2.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4523
				}
			],
			"uid": 10112
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 30
			},
			"enrolment": 792,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Leeton Town",
			"playspace": 115.47,
			"projections": [
				792,
				752,
				762,
				697,
				642
			],
			"projections_percentage": [
				0,
				-5.05,
				-3.79,
				-11.99,
				-18.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.63,
					"enrolment": 369,
					"ligo": 0.74,
					"location": [
						146.407734430993,
						-34.5459581522012
					],
					"name": "Leeton Public School",
					"playspace": 60.09,
					"projections": [
						384,
						369,
						380,
						385,
						350,
						320
					],
					"projections_orig": [
						"384",
						"369",
						"380",
						"385",
						"350",
						"320"
					],
					"projections_percentage": [
						4.07,
						0,
						2.98,
						4.34,
						-5.15,
						-13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2386
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 7.12,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						146.410933718096,
						-34.5981271210088
					],
					"name": "Yanco Public School",
					"playspace": 250.36,
					"projections": [
						57,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"57",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						54.05,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3536
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 7
					},
					"classroomspace": 2.69,
					"enrolment": 386,
					"ligo": 0.81,
					"location": [
						146.396107260313,
						-34.5622124413498
					],
					"name": "Parkview Public School",
					"playspace": 35.95,
					"projections": [
						225,
						386,
						335,
						340,
						310,
						285
					],
					"projections_orig": [
						"225",
						"386",
						"335",
						"340",
						"310",
						"285"
					],
					"projections_percentage": [
						-41.71,
						0,
						-13.21,
						-11.92,
						-19.69,
						-26.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4413
				}
			],
			"uid": 10113
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 183
			},
			"enrolment": 3809,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Wagga City Primary",
			"playspace": 48.77,
			"projections": [
				3809,
				4070,
				4175,
				4080,
				4080
			],
			"projections_percentage": [
				0,
				6.85,
				9.61,
				7.11,
				7.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 5
					},
					"classroomspace": 2.99,
					"enrolment": 223,
					"ligo": 0.85,
					"location": [
						147.467352694528,
						-35.1485845328688
					],
					"name": "Forest Hill Public School",
					"playspace": 91.58,
					"projections": [
						210,
						223,
						240,
						245,
						240,
						230
					],
					"projections_orig": [
						"210",
						"223",
						"240",
						"245",
						"240",
						"230"
					],
					"projections_percentage": [
						-5.83,
						0,
						7.62,
						9.87,
						7.62,
						3.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1930
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 530,
					"ligo": 0.71,
					"location": [
						147.380267320383,
						-35.1734680894194
					],
					"name": "Lake Albert Public School",
					"playspace": 37.95,
					"projections": [
						445,
						530,
						590,
						605,
						575,
						570
					],
					"projections_orig": [
						"445",
						"530",
						"590",
						"605",
						"575",
						"570"
					],
					"projections_percentage": [
						-16.04,
						0,
						11.32,
						14.15,
						8.49,
						7.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2357
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.4,
					"enrolment": 435,
					"ligo": 0.54,
					"location": [
						147.365235333366,
						-35.1075304736448
					],
					"name": "Wagga Wagga Public School",
					"playspace": 15.25,
					"projections": [
						382,
						435,
						450,
						460,
						445,
						445
					],
					"projections_orig": [
						"382",
						"435",
						"450",
						"460",
						"445",
						"445"
					],
					"projections_percentage": [
						-12.18,
						0,
						3.45,
						5.75,
						2.3,
						2.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3330
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 2.61,
					"enrolment": 271,
					"ligo": 0.67,
					"location": [
						147.379382675481,
						-35.0966053178279
					],
					"name": "North Wagga Public School",
					"playspace": 35.77,
					"projections": [
						249,
						271,
						265,
						270,
						270,
						270
					],
					"projections_orig": [
						"249",
						"271",
						"265",
						"270",
						"270",
						"270"
					],
					"projections_percentage": [
						-8.12,
						0,
						-2.21,
						-0.37,
						-0.37,
						-0.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3332
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.31,
					"enrolment": 318,
					"ligo": 0.44,
					"location": [
						147.366580374303,
						-35.1187025735858
					],
					"name": "South Wagga Public School",
					"playspace": 43.3,
					"projections": [
						297,
						318,
						335,
						355,
						345,
						350
					],
					"projections_orig": [
						"297",
						"318",
						"335",
						"355",
						"345",
						"350"
					],
					"projections_percentage": [
						-6.6,
						0,
						5.35,
						11.64,
						8.49,
						10.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3333
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.56,
					"enrolment": 80,
					"ligo": 1,
					"location": [
						147.296633206714,
						-35.1515811315981
					],
					"name": "Kapooka Public School",
					"playspace": 1.56,
					"projections": [
						57,
						80,
						75,
						80,
						80,
						80
					],
					"projections_orig": [
						"57",
						"80",
						"75",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-28.75,
						0,
						-6.25,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3923
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.42,
					"enrolment": 390,
					"ligo": 0.46,
					"location": [
						147.357145557115,
						-35.1281408808578
					],
					"name": "Turvey Park Public School",
					"playspace": 35.77,
					"projections": [
						350,
						390,
						415,
						425,
						415,
						420
					],
					"projections_orig": [
						"350",
						"390",
						"415",
						"425",
						"415",
						"420"
					],
					"projections_percentage": [
						-10.26,
						0,
						6.41,
						8.97,
						6.41,
						7.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4144
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.91,
					"enrolment": 456,
					"ligo": 0.64,
					"location": [
						147.372510035177,
						-35.1477198323025
					],
					"name": "Kooringal Public School",
					"playspace": 50.94,
					"projections": [
						420,
						456,
						545,
						555,
						530,
						530
					],
					"projections_orig": [
						"420",
						"456",
						"545",
						"555",
						"530",
						"530"
					],
					"projections_percentage": [
						-7.89,
						0,
						19.52,
						21.71,
						16.23,
						16.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4173
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 5.24,
					"enrolment": 274,
					"ligo": 0.6,
					"location": [
						147.351774228468,
						-35.1357792605959
					],
					"name": "Mount Austin Public School",
					"playspace": 81.74,
					"projections": [
						266,
						274,
						275,
						280,
						285,
						285
					],
					"projections_orig": [
						"266",
						"274",
						"275",
						"280",
						"285",
						"285"
					],
					"projections_percentage": [
						-2.92,
						0,
						0.36,
						2.19,
						4.01,
						4.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4215
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 4.66,
					"enrolment": 221,
					"ligo": 0.81,
					"location": [
						147.333479678367,
						-35.1237981558764
					],
					"name": "Ashmont Public School",
					"playspace": 58.53,
					"projections": [
						240,
						221,
						245,
						250,
						250,
						255
					],
					"projections_orig": [
						"240",
						"221",
						"245",
						"250",
						"250",
						"255"
					],
					"projections_percentage": [
						8.6,
						0,
						10.86,
						13.12,
						13.12,
						15.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4375
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.75,
					"enrolment": 250,
					"ligo": 0.69,
					"location": [
						147.348207854156,
						-35.1459597480476
					],
					"name": "Red Hill Public School",
					"playspace": 62.5,
					"projections": [
						213,
						250,
						245,
						250,
						255,
						255
					],
					"projections_orig": [
						"213",
						"250",
						"245",
						"250",
						"255",
						"255"
					],
					"projections_percentage": [
						-14.8,
						0,
						-2,
						0,
						2,
						2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4410
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.99,
					"enrolment": 361,
					"ligo": 0.48,
					"location": [
						147.377329434852,
						-35.1369003894338
					],
					"name": "Sturt Public School",
					"playspace": 70.39,
					"projections": [
						333,
						361,
						390,
						400,
						390,
						390
					],
					"projections_orig": [
						"333",
						"361",
						"390",
						"400",
						"390",
						"390"
					],
					"projections_percentage": [
						-7.76,
						0,
						8.03,
						10.8,
						8.03,
						8.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4457
				}
			],
			"uid": 10114
		},
		{
			"classrooms": {
				"demountable": 47,
				"permanent": 145
			},
			"enrolment": 4149,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Queanbeyan Yass Primary",
			"playspace": 67.48,
			"projections": [
				4149,
				4860,
				5100,
				5180,
				5250
			],
			"projections_percentage": [
				0,
				17.14,
				22.92,
				24.85,
				26.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.78,
					"enrolment": 492,
					"ligo": 0.85,
					"location": [
						149.445485541765,
						-35.255977522603
					],
					"name": "Bungendore Public School",
					"playspace": 37.63,
					"projections": [
						456,
						492,
						565,
						545,
						515,
						470
					],
					"projections_orig": [
						"456",
						"492",
						"565",
						"545",
						"515",
						"470"
					],
					"projections_percentage": [
						-7.32,
						0,
						14.84,
						10.77,
						4.67,
						-4.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1421
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 2.63,
					"enrolment": 104,
					"ligo": 0.88,
					"location": [
						149.266554275508,
						-35.029799131663
					],
					"name": "Gundaroo Public School",
					"playspace": 131.41,
					"projections": [
						85,
						104,
						95,
						100,
						95,
						95
					],
					"projections_orig": [
						"85",
						"104",
						"95",
						"100",
						"95",
						"95"
					],
					"projections_percentage": [
						-18.27,
						0,
						-8.65,
						-3.85,
						-8.65,
						-8.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2104
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 25
					},
					"classroomspace": 2.58,
					"enrolment": 753,
					"ligo": 0.44,
					"location": [
						149.237136692915,
						-35.3575053578809
					],
					"name": "Queanbeyan Public School",
					"playspace": 26.17,
					"projections": [
						769,
						753,
						935,
						995,
						1020,
						1040
					],
					"projections_orig": [
						"769",
						"753",
						"935",
						"995",
						"1020",
						"1040"
					],
					"projections_percentage": [
						2.12,
						0,
						24.17,
						32.14,
						35.46,
						38.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2922
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 5
					},
					"classroomspace": 2.77,
					"enrolment": 273,
					"ligo": 0.74,
					"location": [
						149.254378322472,
						-35.1659048320763
					],
					"name": "Sutton Public School",
					"playspace": 87,
					"projections": [
						181,
						273,
						295,
						295,
						290,
						280
					],
					"projections_orig": [
						"181",
						"273",
						"295",
						"295",
						"290",
						"280"
					],
					"projections_percentage": [
						-33.7,
						0,
						8.06,
						8.06,
						6.23,
						2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3137
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.68,
					"enrolment": 286,
					"ligo": 0.62,
					"location": [
						148.906919753339,
						-34.8375062161716
					],
					"name": "Yass Public School",
					"playspace": 56.41,
					"projections": [
						222,
						286,
						295,
						310,
						320,
						325
					],
					"projections_orig": [
						"222",
						"286",
						"295",
						"310",
						"320",
						"325"
					],
					"projections_percentage": [
						-22.38,
						0,
						3.15,
						8.39,
						11.89,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3549
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.85,
					"enrolment": 436,
					"ligo": 0.67,
					"location": [
						149.215334584971,
						-35.3474627835867
					],
					"name": "Queanbeyan West Public School",
					"playspace": 74.77,
					"projections": [
						420,
						436,
						515,
						555,
						565,
						595
					],
					"projections_orig": [
						"420",
						"436",
						"515",
						"555",
						"565",
						"595"
					],
					"projections_percentage": [
						-3.67,
						0,
						18.12,
						27.29,
						29.59,
						36.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4127
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 4
					},
					"classroomspace": 3.66,
					"enrolment": 204,
					"ligo": 0.69,
					"location": [
						149.246481440354,
						-35.34483908572
					],
					"name": "Queanbeyan East Public School",
					"playspace": 87.76,
					"projections": [
						190,
						204,
						220,
						230,
						245,
						255
					],
					"projections_orig": [
						"190",
						"204",
						"220",
						"230",
						"245",
						"255"
					],
					"projections_percentage": [
						-6.86,
						0,
						7.84,
						12.75,
						20.1,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4371
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 4.54,
					"enrolment": 376,
					"ligo": 0.72,
					"location": [
						149.228162149189,
						-35.3646182721723
					],
					"name": "Queanbeyan South Public School",
					"playspace": 78.05,
					"projections": [
						398,
						376,
						470,
						500,
						500,
						525
					],
					"projections_orig": [
						"398",
						"376",
						"470",
						"500",
						"500",
						"525"
					],
					"projections_percentage": [
						5.85,
						0,
						25,
						32.98,
						32.98,
						39.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4394
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 3.24,
					"enrolment": 300,
					"ligo": 0.61,
					"location": [
						148.920147264982,
						-34.8489947361532
					],
					"name": "Berinba Public School",
					"playspace": 75.43,
					"projections": [
						264,
						300,
						345,
						360,
						370,
						375
					],
					"projections_orig": [
						"264",
						"300",
						"345",
						"360",
						"370",
						"375"
					],
					"projections_percentage": [
						-12,
						0,
						15,
						20,
						23.33,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4450
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 23
					},
					"classroomspace": 2.6,
					"enrolment": 925,
					"ligo": 0.89,
					"location": [
						149.199577806672,
						-35.3858474130057
					],
					"name": "Jerrabomberra Public School",
					"playspace": 20.19,
					"projections": [
						850,
						925,
						1125,
						1210,
						1260,
						1290
					],
					"projections_orig": [
						"850",
						"925",
						"1125",
						"1210",
						"1260",
						"1290"
					],
					"projections_percentage": [
						-8.11,
						0,
						21.62,
						30.81,
						36.22,
						39.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4633
				}
			],
			"uid": 10115
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 79
			},
			"enrolment": 1861,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Albion Park Primary",
			"playspace": 53.93,
			"projections": [
				1861,
				1790,
				1820,
				1815,
				1820
			],
			"projections_percentage": [
				0,
				-3.82,
				-2.2,
				-2.47,
				-2.2
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.11,
					"enrolment": 432,
					"ligo": 0.69,
					"location": [
						150.772447303493,
						-34.5708526280196
					],
					"name": "Albion Park Public School",
					"playspace": 37.56,
					"projections": [
						452,
						432,
						440,
						445,
						445,
						445
					],
					"projections_orig": [
						"452",
						"432",
						"440",
						"445",
						"445",
						"445"
					],
					"projections_percentage": [
						4.63,
						0,
						1.85,
						3.01,
						3.01,
						3.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1015
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.77,
					"enrolment": 352,
					"ligo": 0.7,
					"location": [
						150.799675739986,
						-34.5684805659431
					],
					"name": "Albion Park Rail Public School",
					"playspace": 104.23,
					"projections": [
						367,
						352,
						355,
						360,
						360,
						365
					],
					"projections_orig": [
						"367",
						"352",
						"355",
						"360",
						"360",
						"365"
					],
					"projections_percentage": [
						4.26,
						0,
						0.85,
						2.27,
						2.27,
						3.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4121
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 22
					},
					"classroomspace": 2.36,
					"enrolment": 762,
					"ligo": 0.7,
					"location": [
						150.778643604003,
						-34.5914812883989
					],
					"name": "Mount Terry Public School",
					"playspace": 22.16,
					"projections": [
						645,
						762,
						720,
						735,
						730,
						730
					],
					"projections_orig": [
						"645",
						"762",
						"720",
						"735",
						"730",
						"730"
					],
					"projections_percentage": [
						-15.35,
						0,
						-5.51,
						-3.54,
						-4.2,
						-4.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4610
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 12
					},
					"classroomspace": 3.26,
					"enrolment": 315,
					"ligo": 0.16,
					"location": [
						150.755727898055,
						-34.5784303353752
					],
					"name": "Tullimbar Public School",
					"playspace": 51.76,
					"projections": [
						220,
						315,
						275,
						280,
						280,
						280
					],
					"projections_orig": [
						"220",
						"315",
						"275",
						"280",
						"280",
						"280"
					],
					"projections_percentage": [
						-30.16,
						0,
						-12.7,
						-11.11,
						-11.11,
						-11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4649
				}
			],
			"uid": 10116
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 156
			},
			"enrolment": 4065,
			"level": "Primary",
			"ligo": 0.75,
			"name": "Terrigal Primary",
			"playspace": 38.91,
			"projections": [
				4065,
				4155,
				4290,
				4310,
				4370
			],
			"projections_percentage": [
				0,
				2.21,
				5.54,
				6.03,
				7.5
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 17
					},
					"classroomspace": 2.44,
					"enrolment": 518,
					"ligo": 0.85,
					"location": [
						151.431455457706,
						-33.4704514097121
					],
					"name": "Avoca Beach Public School",
					"playspace": 15.29,
					"projections": [
						498,
						518,
						540,
						555,
						560,
						565
					],
					"projections_orig": [
						"498",
						"518",
						"540",
						"555",
						"560",
						"565"
					],
					"projections_percentage": [
						-3.86,
						0,
						4.25,
						7.14,
						8.11,
						9.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1082
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.63,
					"enrolment": 474,
					"ligo": 0.93,
					"location": [
						151.356904986171,
						-33.4779583636789
					],
					"name": "Brisbania Public School",
					"playspace": 31.41,
					"projections": [
						409,
						474,
						450,
						465,
						465,
						475
					],
					"projections_orig": [
						"409",
						"474",
						"450",
						"465",
						"465",
						"475"
					],
					"projections_percentage": [
						-13.71,
						0,
						-5.06,
						-1.9,
						-1.9,
						0.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1498
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.55,
					"enrolment": 338,
					"ligo": 0.64,
					"location": [
						151.41311538908,
						-33.4277840015381
					],
					"name": "Erina Heights Public School",
					"playspace": 16.43,
					"projections": [
						350,
						338,
						385,
						395,
						395,
						400
					],
					"projections_orig": [
						"350",
						"338",
						"385",
						"395",
						"395",
						"400"
					],
					"projections_percentage": [
						3.55,
						0,
						13.91,
						16.86,
						16.86,
						18.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1856
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.68,
					"enrolment": 407,
					"ligo": 0.73,
					"location": [
						151.379321602519,
						-33.4400386301948
					],
					"name": "Woodport Public School",
					"playspace": 46.91,
					"projections": [
						407,
						407,
						415,
						430,
						430,
						435
					],
					"projections_orig": [
						"407",
						"407",
						"415",
						"430",
						"430",
						"435"
					],
					"projections_percentage": [
						0,
						0,
						1.97,
						5.65,
						5.65,
						6.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1857
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.81,
					"enrolment": 160,
					"ligo": 0.63,
					"location": [
						151.408419175869,
						-33.4052473500983
					],
					"name": "Holgate Public School",
					"playspace": 32.91,
					"projections": [
						168,
						160,
						175,
						185,
						185,
						185
					],
					"projections_orig": [
						"168",
						"160",
						"175",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						5,
						0,
						9.38,
						15.62,
						15.62,
						15.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2171
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.64,
					"enrolment": 432,
					"ligo": 0.74,
					"location": [
						151.393879466869,
						-33.4684866865868
					],
					"name": "Kincumber Public School",
					"playspace": 36.5,
					"projections": [
						432,
						432,
						470,
						485,
						485,
						495
					],
					"projections_orig": [
						"432",
						"432",
						"470",
						"485",
						"485",
						"495"
					],
					"projections_percentage": [
						0,
						0,
						8.8,
						12.27,
						12.27,
						14.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2304
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 26
					},
					"classroomspace": 2.81,
					"enrolment": 810,
					"ligo": 0.84,
					"location": [
						151.438496516841,
						-33.4416858905275
					],
					"name": "Terrigal Public School",
					"playspace": 23.82,
					"projections": [
						676,
						810,
						790,
						815,
						820,
						830
					],
					"projections_orig": [
						"676",
						"810",
						"790",
						"815",
						"820",
						"830"
					],
					"projections_percentage": [
						-16.54,
						0,
						-2.47,
						0.62,
						1.23,
						2.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.91,
					"enrolment": 348,
					"ligo": 0.65,
					"location": [
						151.349465934417,
						-33.4368142167503
					],
					"name": "Gosford East Public School",
					"playspace": 71.13,
					"projections": [
						280,
						348,
						360,
						370,
						375,
						380
					],
					"projections_orig": [
						"280",
						"348",
						"360",
						"370",
						"375",
						"380"
					],
					"projections_percentage": [
						-19.54,
						0,
						3.45,
						6.32,
						7.76,
						9.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4218
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.14,
					"enrolment": 233,
					"ligo": 0.65,
					"location": [
						151.368892370086,
						-33.4293219968658
					],
					"name": "Chertsey Primary School",
					"playspace": 80.78,
					"projections": [
						225,
						233,
						240,
						250,
						250,
						255
					],
					"projections_orig": [
						"225",
						"233",
						"240",
						"250",
						"250",
						"255"
					],
					"projections_percentage": [
						-3.43,
						0,
						3,
						7.3,
						7.3,
						9.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4398
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.59,
					"enrolment": 345,
					"ligo": 0.82,
					"location": [
						151.436497996256,
						-33.4845389589281
					],
					"name": "Copacabana Public School",
					"playspace": 33.91,
					"projections": [
						280,
						345,
						330,
						340,
						345,
						350
					],
					"projections_orig": [
						"280",
						"345",
						"330",
						"340",
						"345",
						"350"
					],
					"projections_percentage": [
						-18.84,
						0,
						-4.35,
						-1.45,
						0,
						1.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4548
				}
			],
			"uid": 10117
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 37
			},
			"enrolment": 806,
			"level": "Primary",
			"ligo": 0.8,
			"name": "Kariong Mountains Primary",
			"playspace": 191.36,
			"projections": [
				806,
				911,
				936,
				951,
				961
			],
			"projections_percentage": [
				0,
				13.03,
				16.13,
				17.99,
				19.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.57,
					"enrolment": 68,
					"ligo": 0.77,
					"location": [
						151.21689936659,
						-33.2319671176974
					],
					"name": "Kulnura Public School",
					"playspace": 131.94,
					"projections": [
						91,
						68,
						70,
						70,
						75,
						75
					],
					"projections_orig": [
						"91",
						"68",
						"70",
						"70",
						"75",
						"75"
					],
					"projections_percentage": [
						33.82,
						0,
						2.94,
						2.94,
						10.29,
						10.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2334
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.89,
					"enrolment": 41,
					"ligo": 0.67,
					"location": [
						151.231508038572,
						-33.3263010416839
					],
					"name": "Peats Ridge Public School",
					"playspace": 128.78,
					"projections": [
						56,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"56",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						36.59,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2852
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 4.3,
					"enrolment": 63,
					"ligo": 0.68,
					"location": [
						151.290409221464,
						-33.3586097137886
					],
					"name": "Somersby Public School",
					"playspace": 165.57,
					"projections": [
						80,
						63,
						80,
						80,
						85,
						85
					],
					"projections_orig": [
						"80",
						"63",
						"80",
						"80",
						"85",
						"85"
					],
					"projections_percentage": [
						26.98,
						0,
						26.98,
						26.98,
						34.92,
						34.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3078
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.28,
					"enrolment": 72,
					"ligo": 0.96,
					"location": [
						151.243757362269,
						-33.2973423780099
					],
					"name": "Central Mangrove Public School",
					"playspace": 491.54,
					"projections": [
						79,
						72,
						70,
						75,
						75,
						75
					],
					"projections_orig": [
						"79",
						"72",
						"70",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						9.72,
						0,
						-2.78,
						4.17,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4110
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.51,
					"enrolment": 562,
					"ligo": 0.91,
					"location": [
						151.288691008836,
						-33.4411365588904
					],
					"name": "Kariong Public School",
					"playspace": 38.98,
					"projections": [
						643,
						562,
						650,
						670,
						675,
						685
					],
					"projections_orig": [
						"643",
						"562",
						"650",
						"670",
						"675",
						"685"
					],
					"projections_percentage": [
						14.41,
						0,
						15.66,
						19.22,
						20.11,
						21.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4580
				}
			],
			"uid": 10118
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 146
			},
			"enrolment": 3434,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Gosford Primary",
			"playspace": 35.46,
			"projections": [
				3434,
				3655,
				3765,
				3790,
				3850
			],
			"projections_percentage": [
				0,
				6.44,
				9.64,
				10.37,
				12.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.43,
					"enrolment": 538,
					"ligo": 0.56,
					"location": [
						151.333406570147,
						-33.4215559594425
					],
					"name": "Gosford Public School",
					"playspace": 19.49,
					"projections": [
						536,
						538,
						565,
						580,
						585,
						595
					],
					"projections_orig": [
						"536",
						"538",
						"565",
						"580",
						"585",
						"595"
					],
					"projections_percentage": [
						-0.37,
						0,
						5.02,
						7.81,
						8.74,
						10.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2049
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.38,
					"enrolment": 286,
					"ligo": 0.64,
					"location": [
						151.376230627238,
						-33.3816212929332
					],
					"name": "Lisarow Public School",
					"playspace": 43.72,
					"projections": [
						332,
						286,
						330,
						340,
						340,
						345
					],
					"projections_orig": [
						"332",
						"286",
						"330",
						"340",
						"340",
						"345"
					],
					"projections_percentage": [
						16.08,
						0,
						15.38,
						18.88,
						18.88,
						20.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.48,
					"enrolment": 386,
					"ligo": 0.74,
					"location": [
						151.363323858194,
						-33.3874807523214
					],
					"name": "Narara Public School",
					"playspace": 39.68,
					"projections": [
						336,
						386,
						385,
						395,
						395,
						405
					],
					"projections_orig": [
						"336",
						"386",
						"385",
						"395",
						"395",
						"405"
					],
					"projections_percentage": [
						-12.95,
						0,
						-0.26,
						2.33,
						2.33,
						4.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2703
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.51,
					"enrolment": 447,
					"ligo": 0.77,
					"location": [
						151.36938760508,
						-33.3550134075948
					],
					"name": "Ourimbah Public School",
					"playspace": 33.97,
					"projections": [
						380,
						447,
						460,
						475,
						480,
						490
					],
					"projections_orig": [
						"380",
						"447",
						"460",
						"475",
						"480",
						"490"
					],
					"projections_percentage": [
						-14.99,
						0,
						2.91,
						6.26,
						7.38,
						9.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2820
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.56,
					"enrolment": 525,
					"ligo": 0.93,
					"location": [
						151.328156446609,
						-33.4439164061601
					],
					"name": "Point Clare Public School",
					"playspace": 11.12,
					"projections": [
						492,
						525,
						570,
						585,
						590,
						600
					],
					"projections_orig": [
						"492",
						"525",
						"570",
						"585",
						"590",
						"600"
					],
					"projections_percentage": [
						-6.29,
						0,
						8.57,
						11.43,
						12.38,
						14.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4050
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.36,
					"enrolment": 353,
					"ligo": 0.72,
					"location": [
						151.356115561299,
						-33.409589437578
					],
					"name": "Wyoming Public School",
					"playspace": 46.75,
					"projections": [
						259,
						353,
						335,
						345,
						345,
						350
					],
					"projections_orig": [
						"259",
						"353",
						"335",
						"345",
						"345",
						"350"
					],
					"projections_percentage": [
						-26.63,
						0,
						-5.1,
						-2.27,
						-2.27,
						-0.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4397
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 2.55,
					"enrolment": 542,
					"ligo": 0.75,
					"location": [
						151.350402032169,
						-33.3833292079495
					],
					"name": "Niagara Park Public School",
					"playspace": 50.17,
					"projections": [
						493,
						542,
						550,
						570,
						575,
						580
					],
					"projections_orig": [
						"493",
						"542",
						"550",
						"570",
						"575",
						"580"
					],
					"projections_percentage": [
						-9.04,
						0,
						1.48,
						5.17,
						6.09,
						7.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4427
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.56,
					"enrolment": 357,
					"ligo": 0.64,
					"location": [
						151.361662779178,
						-33.3990996799917
					],
					"name": "Valley View Public School",
					"playspace": 38.76,
					"projections": [
						529,
						357,
						460,
						475,
						480,
						485
					],
					"projections_orig": [
						"529",
						"357",
						"460",
						"475",
						"480",
						"485"
					],
					"projections_percentage": [
						48.18,
						0,
						28.85,
						33.05,
						34.45,
						35.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4508
				}
			],
			"uid": 10119
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 129
			},
			"enrolment": 2926,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Woy Woy Primary",
			"playspace": 31.31,
			"projections": [
				2926,
				3070,
				3160,
				3185,
				3230
			],
			"projections_percentage": [
				0,
				4.92,
				8,
				8.85,
				10.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.3,
					"enrolment": 458,
					"ligo": 0.82,
					"location": [
						151.36340908129,
						-33.504168789793
					],
					"name": "Empire Bay Public School",
					"playspace": 26.65,
					"projections": [
						459,
						458,
						470,
						485,
						490,
						495
					],
					"projections_orig": [
						"459",
						"458",
						"470",
						"485",
						"490",
						"495"
					],
					"projections_percentage": [
						0.22,
						0,
						2.62,
						5.9,
						6.99,
						8.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1839
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.97,
					"enrolment": 557,
					"ligo": 0.6,
					"location": [
						151.332399362368,
						-33.5130897599395
					],
					"name": "Ettalong Public School",
					"playspace": 23.31,
					"projections": [
						547,
						557,
						605,
						620,
						625,
						635
					],
					"projections_orig": [
						"547",
						"557",
						"605",
						"620",
						"625",
						"635"
					],
					"projections_percentage": [
						-1.8,
						0,
						8.62,
						11.31,
						12.21,
						14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1864
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.43,
					"enrolment": 177,
					"ligo": 0.76,
					"location": [
						151.350593619541,
						-33.5260357400838
					],
					"name": "Pretty Beach Public School",
					"playspace": 25.36,
					"projections": [
						134,
						177,
						155,
						160,
						160,
						165
					],
					"projections_orig": [
						"134",
						"177",
						"155",
						"160",
						"160",
						"165"
					],
					"projections_percentage": [
						-24.29,
						0,
						-12.43,
						-9.6,
						-9.6,
						-6.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2902
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 30
					},
					"classroomspace": 2.28,
					"enrolment": 801,
					"ligo": 0.73,
					"location": [
						151.314575277563,
						-33.5256956382054
					],
					"name": "Umina Beach Public School",
					"playspace": 17.7,
					"projections": [
						758,
						801,
						845,
						870,
						875,
						890
					],
					"projections_orig": [
						"758",
						"801",
						"845",
						"870",
						"875",
						"890"
					],
					"projections_percentage": [
						-5.37,
						0,
						5.49,
						8.61,
						9.24,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3995
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 3.52,
					"enrolment": 494,
					"ligo": 0.69,
					"location": [
						151.321318470475,
						-33.5043918211174
					],
					"name": "Woy Woy South Public School",
					"playspace": 57.2,
					"projections": [
						538,
						494,
						530,
						545,
						550,
						555
					],
					"projections_orig": [
						"538",
						"494",
						"530",
						"545",
						"550",
						"555"
					],
					"projections_percentage": [
						8.91,
						0,
						7.29,
						10.32,
						11.34,
						12.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4329
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 3.02,
					"enrolment": 439,
					"ligo": 0.63,
					"location": [
						151.328303485527,
						-33.4911446078927
					],
					"name": "Woy Woy Public School",
					"playspace": 37.66,
					"projections": [
						478,
						439,
						465,
						480,
						485,
						490
					],
					"projections_orig": [
						"478",
						"439",
						"465",
						"480",
						"485",
						"490"
					],
					"projections_percentage": [
						8.88,
						0,
						5.92,
						9.34,
						10.48,
						11.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7445
				}
			],
			"uid": 10120
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 293
			},
			"enrolment": 7274,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Wyong Primary",
			"playspace": 63.89,
			"projections": [
				7274,
				8035,
				8460,
				8855,
				9460
			],
			"projections_percentage": [
				0,
				10.46,
				16.3,
				21.73,
				30.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.1,
					"enrolment": 71,
					"ligo": 0.82,
					"location": [
						151.380346399258,
						-33.2397606498797
					],
					"name": "Jilliby Public School",
					"playspace": 154.17,
					"projections": [
						107,
						71,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"107",
						"71",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						50.7,
						0,
						12.68,
						19.72,
						19.72,
						19.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2236
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 2.58,
					"enrolment": 672,
					"ligo": 0.65,
					"location": [
						151.484360025993,
						-33.2628960010368
					],
					"name": "Kanwal Public School",
					"playspace": 31.33,
					"projections": [
						735,
						672,
						775,
						825,
						855,
						905
					],
					"projections_orig": [
						"735",
						"672",
						"775",
						"825",
						"855",
						"905"
					],
					"projections_percentage": [
						9.38,
						0,
						15.33,
						22.77,
						27.23,
						34.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2259
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.94,
					"enrolment": 203,
					"ligo": 0.38,
					"location": [
						151.458792216914,
						-33.2837188760993
					],
					"name": "Tacoma Public School",
					"playspace": 80.68,
					"projections": [
						134,
						203,
						200,
						210,
						215,
						230
					],
					"projections_orig": [
						"134",
						"203",
						"200",
						"210",
						"215",
						"230"
					],
					"projections_percentage": [
						-33.99,
						0,
						-1.48,
						3.45,
						5.91,
						13.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3147
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 3.09,
					"enrolment": 523,
					"ligo": 0.75,
					"location": [
						151.549401498965,
						-33.2681454422499
					],
					"name": "Toukley Public School",
					"playspace": 42.13,
					"projections": [
						546,
						523,
						570,
						600,
						620,
						655
					],
					"projections_orig": [
						"546",
						"523",
						"570",
						"600",
						"620",
						"655"
					],
					"projections_percentage": [
						4.4,
						0,
						8.99,
						14.72,
						18.55,
						25.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3250
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 2.59,
					"enrolment": 512,
					"ligo": 0.7,
					"location": [
						151.414212387231,
						-33.313497400282
					],
					"name": "Tuggerah Public School",
					"playspace": 14.74,
					"projections": [
						478,
						512,
						540,
						565,
						595,
						605
					],
					"projections_orig": [
						"478",
						"512",
						"540",
						"565",
						"595",
						"605"
					],
					"projections_percentage": [
						-6.64,
						0,
						5.47,
						10.35,
						16.21,
						18.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3269
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.86,
					"enrolment": 447,
					"ligo": 0.72,
					"location": [
						151.425274516536,
						-33.2720882973558
					],
					"name": "Wyong Public School",
					"playspace": 46.51,
					"projections": [
						395,
						447,
						515,
						545,
						565,
						595
					],
					"projections_orig": [
						"395",
						"447",
						"515",
						"545",
						"565",
						"595"
					],
					"projections_percentage": [
						-11.63,
						0,
						15.21,
						21.92,
						26.4,
						33.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3527
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 2.87,
					"enrolment": 71,
					"ligo": 0.64,
					"location": [
						151.34803170743,
						-33.2675793353214
					],
					"name": "Wyong Creek Public School",
					"playspace": 219.28,
					"projections": [
						61,
						71,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"61",
						"71",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						-14.08,
						0,
						-15.49,
						-15.49,
						-8.45,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3528
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.55,
					"enrolment": 245,
					"ligo": 0.57,
					"location": [
						151.48550171265,
						-33.2791463549766
					],
					"name": "Tuggerawong Public School",
					"playspace": 49.2,
					"projections": [
						214,
						245,
						260,
						270,
						280,
						300
					],
					"projections_orig": [
						"214",
						"245",
						"260",
						"270",
						"280",
						"300"
					],
					"projections_percentage": [
						-12.65,
						0,
						6.12,
						10.2,
						14.29,
						22.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4097
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.54,
					"enrolment": 501,
					"ligo": 0.83,
					"location": [
						151.467380392675,
						-33.2505739829886
					],
					"name": "Warnervale Public School",
					"playspace": 41.99,
					"projections": [
						433,
						501,
						550,
						580,
						615,
						675
					],
					"projections_orig": [
						"433",
						"501",
						"550",
						"580",
						"615",
						"675"
					],
					"projections_percentage": [
						-13.57,
						0,
						9.78,
						15.77,
						22.75,
						34.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4117
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.54,
					"enrolment": 559,
					"ligo": 0.78,
					"location": [
						151.511108622369,
						-33.2529760456841
					],
					"name": "Gorokan Public School",
					"playspace": 35.1,
					"projections": [
						490,
						559,
						590,
						620,
						645,
						680
					],
					"projections_orig": [
						"490",
						"559",
						"590",
						"620",
						"645",
						"680"
					],
					"projections_percentage": [
						-12.34,
						0,
						5.55,
						10.91,
						15.38,
						21.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4517
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.56,
					"enrolment": 500,
					"ligo": 0.84,
					"location": [
						151.48394325543,
						-33.2420050641771
					],
					"name": "Woongarrah Public School",
					"playspace": 52.4,
					"projections": [
						551,
						500,
						585,
						630,
						655,
						715
					],
					"projections_orig": [
						"551",
						"500",
						"585",
						"630",
						"655",
						"715"
					],
					"projections_percentage": [
						10.2,
						0,
						17,
						26,
						31,
						43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4637
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 66
					},
					"classroomspace": 3.06,
					"enrolment": 1485,
					"ligo": 0.84,
					"location": [
						151.4654019058,
						-33.2648480111764
					],
					"name": "Wadalba Community School",
					"playspace": 31.55,
					"projections": [
						1296,
						1296,
						1485,
						1485,
						1655,
						1655,
						1735,
						1735,
						1830,
						1830,
						1975,
						1975
					],
					"projections_orig": [
						"1296",
						"1296",
						"1485",
						"1485",
						"1655",
						"1655",
						"1735",
						"1735",
						"1830",
						"1830",
						"1975",
						"1975"
					],
					"projections_percentage": [
						0,
						0,
						14.58,
						14.58,
						27.7,
						27.7,
						33.87,
						33.87,
						41.2,
						41.2,
						52.39,
						52.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8278
				}
			],
			"uid": 10121
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 293
			},
			"enrolment": 7274,
			"level": "Secondary",
			"ligo": 0.72,
			"name": "Wyong Primary",
			"playspace": 63.89,
			"projections": [
				7274,
				8035,
				8460,
				8855,
				9460
			],
			"projections_percentage": [
				0,
				10.46,
				16.3,
				21.73,
				30.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.1,
					"enrolment": 71,
					"ligo": 0.82,
					"location": [
						151.380346399258,
						-33.2397606498797
					],
					"name": "Jilliby Public School",
					"playspace": 154.17,
					"projections": [
						107,
						71,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"107",
						"71",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						50.7,
						0,
						12.68,
						19.72,
						19.72,
						19.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2236
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 2.58,
					"enrolment": 672,
					"ligo": 0.65,
					"location": [
						151.484360025993,
						-33.2628960010368
					],
					"name": "Kanwal Public School",
					"playspace": 31.33,
					"projections": [
						735,
						672,
						775,
						825,
						855,
						905
					],
					"projections_orig": [
						"735",
						"672",
						"775",
						"825",
						"855",
						"905"
					],
					"projections_percentage": [
						9.38,
						0,
						15.33,
						22.77,
						27.23,
						34.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2259
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.94,
					"enrolment": 203,
					"ligo": 0.38,
					"location": [
						151.458792216914,
						-33.2837188760993
					],
					"name": "Tacoma Public School",
					"playspace": 80.68,
					"projections": [
						134,
						203,
						200,
						210,
						215,
						230
					],
					"projections_orig": [
						"134",
						"203",
						"200",
						"210",
						"215",
						"230"
					],
					"projections_percentage": [
						-33.99,
						0,
						-1.48,
						3.45,
						5.91,
						13.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3147
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 3.09,
					"enrolment": 523,
					"ligo": 0.75,
					"location": [
						151.549401498965,
						-33.2681454422499
					],
					"name": "Toukley Public School",
					"playspace": 42.13,
					"projections": [
						546,
						523,
						570,
						600,
						620,
						655
					],
					"projections_orig": [
						"546",
						"523",
						"570",
						"600",
						"620",
						"655"
					],
					"projections_percentage": [
						4.4,
						0,
						8.99,
						14.72,
						18.55,
						25.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3250
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 2.59,
					"enrolment": 512,
					"ligo": 0.7,
					"location": [
						151.414212387231,
						-33.313497400282
					],
					"name": "Tuggerah Public School",
					"playspace": 14.74,
					"projections": [
						478,
						512,
						540,
						565,
						595,
						605
					],
					"projections_orig": [
						"478",
						"512",
						"540",
						"565",
						"595",
						"605"
					],
					"projections_percentage": [
						-6.64,
						0,
						5.47,
						10.35,
						16.21,
						18.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3269
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.86,
					"enrolment": 447,
					"ligo": 0.72,
					"location": [
						151.425274516536,
						-33.2720882973558
					],
					"name": "Wyong Public School",
					"playspace": 46.51,
					"projections": [
						395,
						447,
						515,
						545,
						565,
						595
					],
					"projections_orig": [
						"395",
						"447",
						"515",
						"545",
						"565",
						"595"
					],
					"projections_percentage": [
						-11.63,
						0,
						15.21,
						21.92,
						26.4,
						33.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3527
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 2.87,
					"enrolment": 71,
					"ligo": 0.64,
					"location": [
						151.34803170743,
						-33.2675793353214
					],
					"name": "Wyong Creek Public School",
					"playspace": 219.28,
					"projections": [
						61,
						71,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"61",
						"71",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						-14.08,
						0,
						-15.49,
						-15.49,
						-8.45,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3528
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.55,
					"enrolment": 245,
					"ligo": 0.57,
					"location": [
						151.48550171265,
						-33.2791463549766
					],
					"name": "Tuggerawong Public School",
					"playspace": 49.2,
					"projections": [
						214,
						245,
						260,
						270,
						280,
						300
					],
					"projections_orig": [
						"214",
						"245",
						"260",
						"270",
						"280",
						"300"
					],
					"projections_percentage": [
						-12.65,
						0,
						6.12,
						10.2,
						14.29,
						22.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4097
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.54,
					"enrolment": 501,
					"ligo": 0.83,
					"location": [
						151.467380392675,
						-33.2505739829886
					],
					"name": "Warnervale Public School",
					"playspace": 41.99,
					"projections": [
						433,
						501,
						550,
						580,
						615,
						675
					],
					"projections_orig": [
						"433",
						"501",
						"550",
						"580",
						"615",
						"675"
					],
					"projections_percentage": [
						-13.57,
						0,
						9.78,
						15.77,
						22.75,
						34.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4117
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.54,
					"enrolment": 559,
					"ligo": 0.78,
					"location": [
						151.511108622369,
						-33.2529760456841
					],
					"name": "Gorokan Public School",
					"playspace": 35.1,
					"projections": [
						490,
						559,
						590,
						620,
						645,
						680
					],
					"projections_orig": [
						"490",
						"559",
						"590",
						"620",
						"645",
						"680"
					],
					"projections_percentage": [
						-12.34,
						0,
						5.55,
						10.91,
						15.38,
						21.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4517
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.56,
					"enrolment": 500,
					"ligo": 0.84,
					"location": [
						151.48394325543,
						-33.2420050641771
					],
					"name": "Woongarrah Public School",
					"playspace": 52.4,
					"projections": [
						551,
						500,
						585,
						630,
						655,
						715
					],
					"projections_orig": [
						"551",
						"500",
						"585",
						"630",
						"655",
						"715"
					],
					"projections_percentage": [
						10.2,
						0,
						17,
						26,
						31,
						43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4637
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 66
					},
					"classroomspace": 3.06,
					"enrolment": 1485,
					"ligo": 0.84,
					"location": [
						151.4654019058,
						-33.2648480111764
					],
					"name": "Wadalba Community School",
					"playspace": 31.55,
					"projections": [
						1296,
						1296,
						1485,
						1485,
						1655,
						1655,
						1735,
						1735,
						1830,
						1830,
						1975,
						1975
					],
					"projections_orig": [
						"1296",
						"1296",
						"1485",
						"1485",
						"1655",
						"1655",
						"1735",
						"1735",
						"1830",
						"1830",
						"1975",
						"1975"
					],
					"projections_percentage": [
						0,
						0,
						14.58,
						14.58,
						27.7,
						27.7,
						33.87,
						33.87,
						41.2,
						41.2,
						52.39,
						52.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8278
				}
			],
			"uid": 10121
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 119
			},
			"enrolment": 2579,
			"level": "Primary",
			"ligo": 0.86,
			"name": "Lake Munmorah Primary",
			"playspace": 44.82,
			"projections": [
				2579,
				2690,
				2745,
				2800,
				2895
			],
			"projections_percentage": [
				0,
				4.3,
				6.44,
				8.57,
				12.25
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.52,
					"enrolment": 478,
					"ligo": 0.77,
					"location": [
						151.576064402591,
						-33.1885814562644
					],
					"name": "Lake Munmorah Public School",
					"playspace": 36.17,
					"projections": [
						460,
						478,
						470,
						470,
						475,
						485
					],
					"projections_orig": [
						"460",
						"478",
						"470",
						"470",
						"475",
						"485"
					],
					"projections_percentage": [
						-3.77,
						0,
						-1.67,
						-1.67,
						-0.63,
						1.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2362
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 2.87,
					"enrolment": 564,
					"ligo": 0.85,
					"location": [
						151.548708057253,
						-33.2263751054165
					],
					"name": "Budgewoi Public School",
					"playspace": 28.42,
					"projections": [
						541,
						564,
						615,
						640,
						665,
						700
					],
					"projections_orig": [
						"541",
						"564",
						"615",
						"640",
						"665",
						"700"
					],
					"projections_percentage": [
						-4.08,
						0,
						9.04,
						13.48,
						17.91,
						24.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4183
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.32,
					"enrolment": 234,
					"ligo": 0.91,
					"location": [
						151.537569568272,
						-33.1504058354827
					],
					"name": "Mannering Park Public School",
					"playspace": 79.89,
					"projections": [
						278,
						234,
						240,
						240,
						240,
						245
					],
					"projections_orig": [
						"278",
						"234",
						"240",
						"240",
						"240",
						"245"
					],
					"projections_percentage": [
						18.8,
						0,
						2.56,
						2.56,
						2.56,
						4.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4316
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.35,
					"enrolment": 357,
					"ligo": 0.92,
					"location": [
						151.581137059917,
						-33.135469124043
					],
					"name": "Gwandalan Public School",
					"playspace": 44.69,
					"projections": [
						331,
						357,
						365,
						385,
						400,
						420
					],
					"projections_orig": [
						"331",
						"357",
						"365",
						"385",
						"400",
						"420"
					],
					"projections_percentage": [
						-7.28,
						0,
						2.24,
						7.84,
						12.04,
						17.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4320
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.34,
					"enrolment": 394,
					"ligo": 0.82,
					"location": [
						151.515310327972,
						-33.2153754174477
					],
					"name": "Northlakes Public School",
					"playspace": 51.11,
					"projections": [
						467,
						394,
						405,
						410,
						415,
						425
					],
					"projections_orig": [
						"467",
						"394",
						"405",
						"410",
						"415",
						"425"
					],
					"projections_percentage": [
						18.53,
						0,
						2.79,
						4.06,
						5.33,
						7.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4588
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.63,
					"enrolment": 552,
					"ligo": 0.86,
					"location": [
						151.502843750283,
						-33.2116753300321
					],
					"name": "Blue Haven Public School",
					"playspace": 28.65,
					"projections": [
						604,
						552,
						595,
						600,
						605,
						620
					],
					"projections_orig": [
						"604",
						"552",
						"595",
						"600",
						"605",
						"620"
					],
					"projections_percentage": [
						9.42,
						0,
						7.79,
						8.7,
						9.6,
						12.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4623
				}
			],
			"uid": 10122
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 146
			},
			"enrolment": 4059,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Tuggerah Lakes Primary",
			"playspace": 36.18,
			"projections": [
				4059,
				4265,
				4410,
				4475,
				4580
			],
			"projections_percentage": [
				0,
				5.08,
				8.65,
				10.25,
				12.84
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 24
					},
					"classroomspace": 2.71,
					"enrolment": 758,
					"ligo": 0.63,
					"location": [
						151.435030971843,
						-33.3508411424812
					],
					"name": "Berkeley Vale Public School",
					"playspace": 23.67,
					"projections": [
						760,
						758,
						840,
						865,
						875,
						885
					],
					"projections_orig": [
						"760",
						"758",
						"840",
						"865",
						"875",
						"885"
					],
					"projections_percentage": [
						0.26,
						0,
						10.82,
						14.12,
						15.44,
						16.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1203
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 24
					},
					"classroomspace": 2.8,
					"enrolment": 517,
					"ligo": 0.89,
					"location": [
						151.492308110878,
						-33.3468383333411
					],
					"name": "The Entrance Public School",
					"playspace": 18.95,
					"projections": [
						620,
						517,
						590,
						620,
						645,
						680
					],
					"projections_orig": [
						"620",
						"517",
						"590",
						"620",
						"645",
						"680"
					],
					"projections_percentage": [
						19.92,
						0,
						14.12,
						19.92,
						24.76,
						31.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1849
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 452,
					"ligo": 0.76,
					"location": [
						151.456971960435,
						-33.3657059818545
					],
					"name": "Killarney Vale Public School",
					"playspace": 47.48,
					"projections": [
						331,
						452,
						425,
						435,
						440,
						450
					],
					"projections_orig": [
						"331",
						"452",
						"425",
						"435",
						"440",
						"450"
					],
					"projections_percentage": [
						-26.77,
						0,
						-5.97,
						-3.76,
						-2.65,
						-0.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4426
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 24
					},
					"classroomspace": 2.44,
					"enrolment": 739,
					"ligo": 0.51,
					"location": [
						151.475410550582,
						-33.3909569382872
					],
					"name": "Bateau Bay Public School",
					"playspace": 28.58,
					"projections": [
						675,
						739,
						760,
						785,
						800,
						815
					],
					"projections_orig": [
						"675",
						"739",
						"760",
						"785",
						"800",
						"815"
					],
					"projections_percentage": [
						-8.66,
						0,
						2.84,
						6.22,
						8.25,
						10.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4520
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 20
					},
					"classroomspace": 2.76,
					"enrolment": 743,
					"ligo": 0.82,
					"location": [
						151.448920452804,
						-33.4117267412739
					],
					"name": "Wamberal Public School",
					"playspace": 12.34,
					"projections": [
						531,
						743,
						715,
						740,
						745,
						755
					],
					"projections_orig": [
						"531",
						"743",
						"715",
						"740",
						"745",
						"755"
					],
					"projections_percentage": [
						-28.53,
						0,
						-3.77,
						-0.4,
						0.27,
						1.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4522
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.06,
					"enrolment": 374,
					"ligo": 0.76,
					"location": [
						151.431553289829,
						-33.3256156186319
					],
					"name": "Chittaway Bay Public School",
					"playspace": 80.24,
					"projections": [
						350,
						374,
						395,
						410,
						410,
						420
					],
					"projections_orig": [
						"350",
						"374",
						"395",
						"410",
						"410",
						"420"
					],
					"projections_percentage": [
						-6.42,
						0,
						5.61,
						9.63,
						9.63,
						12.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4542
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 15
					},
					"classroomspace": 2.5,
					"enrolment": 476,
					"ligo": 0.55,
					"location": [
						151.464985455847,
						-33.3754882513307
					],
					"name": "Brooke Avenue Public School",
					"playspace": 42.02,
					"projections": [
						447,
						476,
						540,
						555,
						560,
						575
					],
					"projections_orig": [
						"447",
						"476",
						"540",
						"555",
						"560",
						"575"
					],
					"projections_percentage": [
						-6.09,
						0,
						13.45,
						16.6,
						17.65,
						20.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4566
				}
			],
			"uid": 10123
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 191
			},
			"enrolment": 4387,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Callaghan Primary",
			"playspace": 80.6,
			"projections": [
				4387,
				4530,
				4730,
				4825,
				4870
			],
			"projections_percentage": [
				0,
				3.26,
				7.82,
				9.98,
				11.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.62,
					"enrolment": 107,
					"ligo": 0.42,
					"location": [
						151.617237027743,
						-32.8378216129621
					],
					"name": "Black Hill Public School",
					"playspace": 62.5,
					"projections": [
						78,
						107,
						110,
						115,
						115,
						115
					],
					"projections_orig": [
						"78",
						"107",
						"110",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						-27.1,
						0,
						2.8,
						7.48,
						7.48,
						7.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1247
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 7
					},
					"classroomspace": 2.73,
					"enrolment": 200,
					"ligo": 0.74,
					"location": [
						151.695253050888,
						-32.9042784050566
					],
					"name": "Jesmond Public School",
					"playspace": 20.64,
					"projections": [
						161,
						200,
						185,
						195,
						200,
						200
					],
					"projections_orig": [
						"161",
						"200",
						"185",
						"195",
						"200",
						"200"
					],
					"projections_percentage": [
						-19.5,
						0,
						-7.5,
						-2.5,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2234
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.2,
					"enrolment": 252,
					"ligo": 0.63,
					"location": [
						151.748597934052,
						-32.89603009908
					],
					"name": "Mayfield East Public School",
					"playspace": 40.76,
					"projections": [
						247,
						252,
						295,
						315,
						325,
						325
					],
					"projections_orig": [
						"247",
						"252",
						"295",
						"315",
						"325",
						"325"
					],
					"projections_percentage": [
						-1.98,
						0,
						17.06,
						25,
						28.97,
						28.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2506
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.04,
					"enrolment": 392,
					"ligo": 0.63,
					"location": [
						151.729401103028,
						-32.8885504263621
					],
					"name": "Mayfield West Public School",
					"playspace": 26.55,
					"projections": [
						317,
						392,
						365,
						390,
						400,
						405
					],
					"projections_orig": [
						"317",
						"392",
						"365",
						"390",
						"400",
						"405"
					],
					"projections_percentage": [
						-19.13,
						0,
						-6.89,
						-0.51,
						2.04,
						3.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2507
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.58,
					"enrolment": 113,
					"ligo": 0.59,
					"location": [
						151.61798265047,
						-32.8765305862486
					],
					"name": "Minmi Public School",
					"playspace": 119.81,
					"projections": [
						116,
						113,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"116",
						"113",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						2.65,
						0,
						-2.65,
						1.77,
						6.19,
						6.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2571
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.14,
					"enrolment": 255,
					"ligo": 0.74,
					"location": [
						151.695772361534,
						-32.8801833714709
					],
					"name": "Shortland Public School",
					"playspace": 91.87,
					"projections": [
						254,
						255,
						250,
						265,
						270,
						275
					],
					"projections_orig": [
						"254",
						"255",
						"250",
						"265",
						"270",
						"275"
					],
					"projections_percentage": [
						-0.39,
						0,
						-1.96,
						3.92,
						5.88,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3065
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.66,
					"enrolment": 257,
					"ligo": 0.62,
					"location": [
						151.670855758361,
						-32.9084085774848
					],
					"name": "Wallsend Public School",
					"playspace": 24.36,
					"projections": [
						261,
						257,
						290,
						295,
						295,
						295
					],
					"projections_orig": [
						"261",
						"257",
						"290",
						"295",
						"295",
						"295"
					],
					"projections_percentage": [
						1.56,
						0,
						12.84,
						14.79,
						14.79,
						14.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3357
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.35,
					"enrolment": 347,
					"ligo": 0.64,
					"location": [
						151.722807350158,
						-32.9055650570194
					],
					"name": "Waratah Public School",
					"playspace": 54.1,
					"projections": [
						431,
						347,
						395,
						420,
						435,
						435
					],
					"projections_orig": [
						"431",
						"347",
						"395",
						"420",
						"435",
						"435"
					],
					"projections_percentage": [
						24.21,
						0,
						13.83,
						21.04,
						25.36,
						25.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3377
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.34,
					"enrolment": 557,
					"ligo": 0.55,
					"location": [
						151.675298292902,
						-32.9207907909992
					],
					"name": "Wallsend South Public School",
					"playspace": 38.18,
					"projections": [
						551,
						557,
						565,
						575,
						580,
						580
					],
					"projections_orig": [
						"551",
						"557",
						"565",
						"575",
						"580",
						"580"
					],
					"projections_percentage": [
						-1.08,
						0,
						1.44,
						3.23,
						4.13,
						4.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3851
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 5.66,
					"enrolment": 72,
					"ligo": 0.42,
					"location": [
						151.715289074078,
						-32.8992141207512
					],
					"name": "Waratah West Public School",
					"playspace": 371.89,
					"projections": [
						78,
						72,
						75,
						80,
						85,
						85
					],
					"projections_orig": [
						"78",
						"72",
						"75",
						"80",
						"85",
						"85"
					],
					"projections_percentage": [
						8.33,
						0,
						4.17,
						11.11,
						18.06,
						18.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3932
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.51,
					"enrolment": 223,
					"ligo": 0.45,
					"location": [
						151.694931451093,
						-32.899464547509
					],
					"name": "Heaton Public School",
					"playspace": 158.7,
					"projections": [
						193,
						223,
						205,
						215,
						220,
						220
					],
					"projections_orig": [
						"193",
						"223",
						"205",
						"215",
						"220",
						"220"
					],
					"projections_percentage": [
						-13.45,
						0,
						-8.07,
						-3.59,
						-1.35,
						-1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.66,
					"enrolment": 379,
					"ligo": 0.64,
					"location": [
						151.665949985017,
						-32.9150616347286
					],
					"name": "Elermore Vale Public School",
					"playspace": 71.52,
					"projections": [
						410,
						379,
						415,
						420,
						420,
						420
					],
					"projections_orig": [
						"410",
						"379",
						"415",
						"420",
						"420",
						"420"
					],
					"projections_percentage": [
						8.18,
						0,
						9.5,
						10.82,
						10.82,
						10.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4163
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.56,
					"enrolment": 461,
					"ligo": 0.54,
					"location": [
						151.65891618405,
						-32.8822705353513
					],
					"name": "Maryland Public School",
					"playspace": 33.6,
					"projections": [
						493,
						461,
						515,
						540,
						555,
						575
					],
					"projections_orig": [
						"493",
						"461",
						"515",
						"540",
						"555",
						"575"
					],
					"projections_percentage": [
						6.94,
						0,
						11.71,
						17.14,
						20.39,
						24.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4600
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 2.29,
					"enrolment": 522,
					"ligo": 0.88,
					"location": [
						151.650609006063,
						-32.8732477927201
					],
					"name": "Glendore Public School",
					"playspace": 41.39,
					"projections": [
						443,
						522,
						510,
						540,
						555,
						570
					],
					"projections_orig": [
						"443",
						"522",
						"510",
						"540",
						"555",
						"570"
					],
					"projections_percentage": [
						-15.13,
						0,
						-2.3,
						3.45,
						6.32,
						9.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4620
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.96,
					"enrolment": 250,
					"ligo": 0.66,
					"location": [
						151.669202014083,
						-32.897290577825
					],
					"name": "Plattsburg Public School",
					"playspace": 53.07,
					"projections": [
						210,
						250,
						245,
						250,
						250,
						250
					],
					"projections_orig": [
						"210",
						"250",
						"245",
						"250",
						"250",
						"250"
					],
					"projections_percentage": [
						-16,
						0,
						-2,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7308
				}
			],
			"uid": 10124
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 242
			},
			"enrolment": 4946,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Newcastle Primary",
			"playspace": 34.08,
			"projections": [
				4946,
				5243,
				5533,
				5733,
				5753
			],
			"projections_percentage": [
				0,
				6,
				11.87,
				15.91,
				16.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.48,
					"enrolment": 106,
					"ligo": 0.84,
					"location": [
						151.765103795327,
						-32.9126595628632
					],
					"name": "Carrington Public School",
					"playspace": 28.52,
					"projections": [
						82,
						106,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"82",
						"106",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						-22.64,
						0,
						3.77,
						8.49,
						13.21,
						13.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1518
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.24,
					"enrolment": 138,
					"ligo": 0.4,
					"location": [
						151.74372881149,
						-32.9116663472211
					],
					"name": "Islington Public School",
					"playspace": 35.98,
					"projections": [
						75,
						138,
						135,
						145,
						150,
						150
					],
					"projections_orig": [
						"75",
						"138",
						"135",
						"145",
						"150",
						"150"
					],
					"projections_percentage": [
						-45.65,
						0,
						-2.17,
						5.07,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2212
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.64,
					"enrolment": 608,
					"ligo": 0.7,
					"location": [
						151.759806264846,
						-32.9394833093239
					],
					"name": "The Junction Public School",
					"playspace": 31.09,
					"projections": [
						584,
						608,
						660,
						700,
						725,
						725
					],
					"projections_orig": [
						"584",
						"608",
						"660",
						"700",
						"725",
						"725"
					],
					"projections_percentage": [
						-3.95,
						0,
						8.55,
						15.13,
						19.24,
						19.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2246
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.77,
					"enrolment": 247,
					"ligo": 0.64,
					"location": [
						151.777321214106,
						-32.9302875761928
					],
					"name": "Newcastle East Public School",
					"playspace": 15.66,
					"projections": [
						214,
						247,
						275,
						290,
						300,
						300
					],
					"projections_orig": [
						"214",
						"247",
						"275",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						-13.36,
						0,
						11.34,
						17.41,
						21.46,
						21.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2736
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.67,
					"enrolment": 269,
					"ligo": 0.74,
					"location": [
						151.781203243775,
						-32.911809659695
					],
					"name": "Stockton Public School",
					"playspace": 48.29,
					"projections": [
						265,
						269,
						300,
						315,
						330,
						330
					],
					"projections_orig": [
						"265",
						"269",
						"300",
						"315",
						"330",
						"330"
					],
					"projections_percentage": [
						-1.49,
						0,
						11.52,
						17.1,
						22.68,
						22.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3110
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.45,
					"enrolment": 327,
					"ligo": 0.72,
					"location": [
						151.751385844722,
						-32.9078552114312
					],
					"name": "Tighes Hill Public School",
					"playspace": 13.86,
					"projections": [
						230,
						327,
						350,
						370,
						385,
						385
					],
					"projections_orig": [
						"230",
						"327",
						"350",
						"370",
						"385",
						"385"
					],
					"projections_percentage": [
						-29.66,
						0,
						7.03,
						13.15,
						17.74,
						17.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3213
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.75,
					"enrolment": 419,
					"ligo": 0.67,
					"location": [
						151.753091440698,
						-32.9335341941561
					],
					"name": "Hamilton South Public School",
					"playspace": 25.86,
					"projections": [
						398,
						419,
						460,
						490,
						505,
						505
					],
					"projections_orig": [
						"398",
						"419",
						"460",
						"490",
						"505",
						"505"
					],
					"projections_percentage": [
						-5.01,
						0,
						9.79,
						16.95,
						20.53,
						20.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3795
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.15,
					"enrolment": 161,
					"ligo": 0.41,
					"location": [
						151.734300117445,
						-32.9176934610533
					],
					"name": "Hamilton North Public School",
					"playspace": 34.13,
					"projections": [
						163,
						161,
						185,
						195,
						205,
						205
					],
					"projections_orig": [
						"163",
						"161",
						"185",
						"195",
						"205",
						"205"
					],
					"projections_percentage": [
						1.24,
						0,
						14.91,
						21.12,
						27.33,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3897
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.26,
					"enrolment": 48,
					"ligo": 0.81,
					"location": [
						151.795262293547,
						-32.8721106939618
					],
					"name": "Fern Bay Public School",
					"playspace": 95.82,
					"projections": [
						28,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-41.67,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3996
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.7,
					"enrolment": 287,
					"ligo": 0.62,
					"location": [
						151.74278985416,
						-32.9235803078095
					],
					"name": "Hamilton Public School",
					"playspace": 16.35,
					"projections": [
						244,
						287,
						300,
						315,
						325,
						325
					],
					"projections_orig": [
						"244",
						"287",
						"300",
						"315",
						"325",
						"325"
					],
					"projections_percentage": [
						-14.98,
						0,
						4.53,
						9.76,
						13.24,
						13.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 3.99,
					"enrolment": 1168,
					"ligo": 0.1,
					"location": [
						151.727505924713,
						-32.9239077617365
					],
					"name": "Hunter School of Performing Arts",
					"playspace": 31.69,
					"projections": [
						1164,
						1164,
						1168,
						1168,
						1210,
						1210,
						1275,
						1275,
						1320,
						1320,
						1330,
						1330
					],
					"projections_orig": [
						"1164",
						"1164",
						"1168",
						"1168",
						"1210",
						"1210",
						"1275",
						"1275",
						"1320",
						"1320",
						"1330",
						"1330"
					],
					"projections_percentage": [
						0,
						0,
						0.34,
						0.34,
						3.95,
						3.95,
						9.54,
						9.54,
						13.4,
						13.4,
						14.26,
						14.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8819
				}
			],
			"uid": 10125
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 242
			},
			"enrolment": 4946,
			"level": "Secondary",
			"ligo": 0.56,
			"name": "Newcastle Primary",
			"playspace": 34.08,
			"projections": [
				4946,
				5243,
				5533,
				5733,
				5753
			],
			"projections_percentage": [
				0,
				6,
				11.87,
				15.91,
				16.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.48,
					"enrolment": 106,
					"ligo": 0.84,
					"location": [
						151.765103795327,
						-32.9126595628632
					],
					"name": "Carrington Public School",
					"playspace": 28.52,
					"projections": [
						82,
						106,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"82",
						"106",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						-22.64,
						0,
						3.77,
						8.49,
						13.21,
						13.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1518
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.24,
					"enrolment": 138,
					"ligo": 0.4,
					"location": [
						151.74372881149,
						-32.9116663472211
					],
					"name": "Islington Public School",
					"playspace": 35.98,
					"projections": [
						75,
						138,
						135,
						145,
						150,
						150
					],
					"projections_orig": [
						"75",
						"138",
						"135",
						"145",
						"150",
						"150"
					],
					"projections_percentage": [
						-45.65,
						0,
						-2.17,
						5.07,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2212
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.64,
					"enrolment": 608,
					"ligo": 0.7,
					"location": [
						151.759806264846,
						-32.9394833093239
					],
					"name": "The Junction Public School",
					"playspace": 31.09,
					"projections": [
						584,
						608,
						660,
						700,
						725,
						725
					],
					"projections_orig": [
						"584",
						"608",
						"660",
						"700",
						"725",
						"725"
					],
					"projections_percentage": [
						-3.95,
						0,
						8.55,
						15.13,
						19.24,
						19.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2246
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.77,
					"enrolment": 247,
					"ligo": 0.64,
					"location": [
						151.777321214106,
						-32.9302875761928
					],
					"name": "Newcastle East Public School",
					"playspace": 15.66,
					"projections": [
						214,
						247,
						275,
						290,
						300,
						300
					],
					"projections_orig": [
						"214",
						"247",
						"275",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						-13.36,
						0,
						11.34,
						17.41,
						21.46,
						21.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2736
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.67,
					"enrolment": 269,
					"ligo": 0.74,
					"location": [
						151.781203243775,
						-32.911809659695
					],
					"name": "Stockton Public School",
					"playspace": 48.29,
					"projections": [
						265,
						269,
						300,
						315,
						330,
						330
					],
					"projections_orig": [
						"265",
						"269",
						"300",
						"315",
						"330",
						"330"
					],
					"projections_percentage": [
						-1.49,
						0,
						11.52,
						17.1,
						22.68,
						22.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3110
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.45,
					"enrolment": 327,
					"ligo": 0.72,
					"location": [
						151.751385844722,
						-32.9078552114312
					],
					"name": "Tighes Hill Public School",
					"playspace": 13.86,
					"projections": [
						230,
						327,
						350,
						370,
						385,
						385
					],
					"projections_orig": [
						"230",
						"327",
						"350",
						"370",
						"385",
						"385"
					],
					"projections_percentage": [
						-29.66,
						0,
						7.03,
						13.15,
						17.74,
						17.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3213
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.75,
					"enrolment": 419,
					"ligo": 0.67,
					"location": [
						151.753091440698,
						-32.9335341941561
					],
					"name": "Hamilton South Public School",
					"playspace": 25.86,
					"projections": [
						398,
						419,
						460,
						490,
						505,
						505
					],
					"projections_orig": [
						"398",
						"419",
						"460",
						"490",
						"505",
						"505"
					],
					"projections_percentage": [
						-5.01,
						0,
						9.79,
						16.95,
						20.53,
						20.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3795
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.15,
					"enrolment": 161,
					"ligo": 0.41,
					"location": [
						151.734300117445,
						-32.9176934610533
					],
					"name": "Hamilton North Public School",
					"playspace": 34.13,
					"projections": [
						163,
						161,
						185,
						195,
						205,
						205
					],
					"projections_orig": [
						"163",
						"161",
						"185",
						"195",
						"205",
						"205"
					],
					"projections_percentage": [
						1.24,
						0,
						14.91,
						21.12,
						27.33,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3897
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.26,
					"enrolment": 48,
					"ligo": 0.81,
					"location": [
						151.795262293547,
						-32.8721106939618
					],
					"name": "Fern Bay Public School",
					"playspace": 95.82,
					"projections": [
						28,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-41.67,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3996
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.7,
					"enrolment": 287,
					"ligo": 0.62,
					"location": [
						151.74278985416,
						-32.9235803078095
					],
					"name": "Hamilton Public School",
					"playspace": 16.35,
					"projections": [
						244,
						287,
						300,
						315,
						325,
						325
					],
					"projections_orig": [
						"244",
						"287",
						"300",
						"315",
						"325",
						"325"
					],
					"projections_percentage": [
						-14.98,
						0,
						4.53,
						9.76,
						13.24,
						13.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 3.99,
					"enrolment": 1168,
					"ligo": 0.1,
					"location": [
						151.727505924713,
						-32.9239077617365
					],
					"name": "Hunter School of Performing Arts",
					"playspace": 31.69,
					"projections": [
						1164,
						1164,
						1168,
						1168,
						1210,
						1210,
						1275,
						1275,
						1320,
						1320,
						1330,
						1330
					],
					"projections_orig": [
						"1164",
						"1164",
						"1168",
						"1168",
						"1210",
						"1210",
						"1275",
						"1275",
						"1320",
						"1320",
						"1330",
						"1330"
					],
					"projections_percentage": [
						0,
						0,
						0.34,
						0.34,
						3.95,
						3.95,
						9.54,
						9.54,
						13.4,
						13.4,
						14.26,
						14.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8819
				}
			],
			"uid": 10125
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 91
			},
			"enrolment": 2367,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Cessnock Primary",
			"playspace": 153.79,
			"projections": [
				2367,
				2583,
				2688,
				2753,
				2793
			],
			"projections_percentage": [
				0,
				9.13,
				13.56,
				16.31,
				18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.33,
					"enrolment": 264,
					"ligo": 0.7,
					"location": [
						151.42581119306,
						-32.8089526262928
					],
					"name": "Abermain Public School",
					"playspace": 44.93,
					"projections": [
						212,
						264,
						255,
						265,
						270,
						275
					],
					"projections_orig": [
						"212",
						"264",
						"255",
						"265",
						"270",
						"275"
					],
					"projections_percentage": [
						-19.7,
						0,
						-3.41,
						0.38,
						2.27,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1003
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 6
					},
					"classroomspace": 2.83,
					"enrolment": 241,
					"ligo": 0.7,
					"location": [
						151.31633633649,
						-32.8589764930096
					],
					"name": "Bellbird Public School",
					"playspace": 45.1,
					"projections": [
						245,
						241,
						280,
						290,
						300,
						300
					],
					"projections_orig": [
						"245",
						"241",
						"280",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						1.66,
						0,
						16.18,
						20.33,
						24.48,
						24.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1177
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.93,
					"enrolment": 303,
					"ligo": 0.6,
					"location": [
						151.36377593992,
						-32.8408929807509
					],
					"name": "Cessnock Public School",
					"playspace": 45.8,
					"projections": [
						320,
						303,
						335,
						350,
						360,
						365
					],
					"projections_orig": [
						"320",
						"303",
						"335",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						5.61,
						0,
						10.56,
						15.51,
						18.81,
						20.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1542
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.29,
					"enrolment": 213,
					"ligo": 0.79,
					"location": [
						151.369726706261,
						-32.8272783678529
					],
					"name": "Cessnock East Public School",
					"playspace": 104.25,
					"projections": [
						197,
						213,
						235,
						245,
						250,
						255
					],
					"projections_orig": [
						"197",
						"213",
						"235",
						"245",
						"250",
						"255"
					],
					"projections_percentage": [
						-7.51,
						0,
						10.33,
						15.02,
						17.37,
						19.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1543
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.36,
					"enrolment": 395,
					"ligo": 0.72,
					"location": [
						151.345079991332,
						-32.8388460848359
					],
					"name": "Cessnock West Public School",
					"playspace": 19.63,
					"projections": [
						354,
						395,
						430,
						445,
						460,
						465
					],
					"projections_orig": [
						"354",
						"395",
						"430",
						"445",
						"460",
						"465"
					],
					"projections_percentage": [
						-10.38,
						0,
						8.86,
						12.66,
						16.46,
						17.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1545
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.76,
					"enrolment": 18,
					"ligo": 0.44,
					"location": [
						151.274017984363,
						-32.9580714824043
					],
					"name": "Congewai Public School",
					"playspace": 708.68,
					"projections": [
						14,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.22,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1822
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 2.57,
					"enrolment": 125,
					"ligo": 0.6,
					"location": [
						151.312463573184,
						-32.9152857981404
					],
					"name": "Ellalong Public School",
					"playspace": 67.79,
					"projections": [
						104,
						125,
						120,
						125,
						125,
						130
					],
					"projections_orig": [
						"104",
						"125",
						"120",
						"125",
						"125",
						"130"
					],
					"projections_percentage": [
						-16.8,
						0,
						-4,
						0,
						0,
						4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1826
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 2.53,
					"enrolment": 153,
					"ligo": 0.61,
					"location": [
						151.395778850069,
						-32.8568275920839
					],
					"name": "Kearsley Public School",
					"playspace": 80.69,
					"projections": [
						110,
						153,
						140,
						145,
						150,
						155
					],
					"projections_orig": [
						"110",
						"153",
						"140",
						"145",
						"150",
						"155"
					],
					"projections_percentage": [
						-28.1,
						0,
						-8.5,
						-5.23,
						-1.96,
						1.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2267
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.73,
					"enrolment": 76,
					"ligo": 0.51,
					"location": [
						151.369590822878,
						-32.8786352938445
					],
					"name": "Kitchener Public School",
					"playspace": 178.91,
					"projections": [
						79,
						76,
						90,
						95,
						95,
						95
					],
					"projections_orig": [
						"79",
						"76",
						"90",
						"95",
						"95",
						"95"
					],
					"projections_percentage": [
						3.95,
						0,
						18.42,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2315
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.86,
					"enrolment": 56,
					"ligo": 0.83,
					"location": [
						151.130306009153,
						-32.9923903161255
					],
					"name": "Laguna Public School",
					"playspace": 19.85,
					"projections": [
						40,
						56,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"40",
						"56",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						-28.57,
						0,
						7.14,
						16.07,
						16.07,
						16.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2356
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 4.48,
					"enrolment": 57,
					"ligo": 0.83,
					"location": [
						151.250491448997,
						-32.8889788625632
					],
					"name": "Millfield Public School",
					"playspace": 409.6,
					"projections": [
						64,
						57,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"64",
						"57",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						12.28,
						0,
						5.26,
						14.04,
						14.04,
						14.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2555
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 9
					},
					"classroomspace": 2.73,
					"enrolment": 422,
					"ligo": 0.45,
					"location": [
						151.348398166378,
						-32.8108227967433
					],
					"name": "Nulkaba Public School",
					"playspace": 26.86,
					"projections": [
						403,
						422,
						490,
						510,
						520,
						530
					],
					"projections_orig": [
						"403",
						"422",
						"490",
						"510",
						"520",
						"530"
					],
					"projections_percentage": [
						-4.5,
						0,
						16.11,
						20.85,
						23.22,
						25.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2771
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.28,
					"enrolment": 44,
					"ligo": 0.83,
					"location": [
						151.284748949326,
						-32.9014755876027
					],
					"name": "Paxton Public School",
					"playspace": 247.2,
					"projections": [
						80,
						44,
						70,
						70,
						75,
						75
					],
					"projections_orig": [
						"80",
						"44",
						"70",
						"70",
						"75",
						"75"
					],
					"projections_percentage": [
						81.82,
						0,
						59.09,
						59.09,
						70.45,
						70.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2846
				}
			],
			"uid": 10126
		},
		{
			"classrooms": {
				"demountable": 40,
				"permanent": 150
			},
			"enrolment": 4361,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Tweed Primary",
			"playspace": 84.06,
			"projections": [
				4361,
				4536,
				4655,
				4710,
				4805
			],
			"projections_percentage": [
				0,
				4.01,
				6.74,
				8,
				10.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 17
					},
					"classroomspace": 2.59,
					"enrolment": 637,
					"ligo": 0.53,
					"location": [
						153.544939512573,
						-28.2220253641416
					],
					"name": "Banora Point Public School",
					"playspace": 33.72,
					"projections": [
						570,
						637,
						640,
						665,
						685,
						700
					],
					"projections_orig": [
						"570",
						"637",
						"640",
						"665",
						"685",
						"700"
					],
					"projections_percentage": [
						-10.52,
						0,
						0.47,
						4.4,
						7.54,
						9.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.41,
					"enrolment": 320,
					"ligo": 0.73,
					"location": [
						153.468287894056,
						-28.2236527014165
					],
					"name": "Bilambil Public School",
					"playspace": 49.92,
					"projections": [
						271,
						320,
						360,
						350,
						360,
						365
					],
					"projections_orig": [
						"271",
						"320",
						"360",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						-15.31,
						0,
						12.5,
						9.38,
						12.5,
						14.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1224
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.82,
					"enrolment": 73,
					"ligo": 1,
					"location": [
						153.46689904554,
						-28.4355321242089
					],
					"name": "Burringbar Public School",
					"playspace": 225.49,
					"projections": [
						81,
						73,
						65,
						70,
						70,
						75
					],
					"projections_orig": [
						"81",
						"73",
						"65",
						"70",
						"70",
						"75"
					],
					"projections_percentage": [
						10.96,
						0,
						-10.96,
						-4.11,
						-4.11,
						2.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1449
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.96,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						153.429066714839,
						-28.2301779342569
					],
					"name": "Carool Public School",
					"playspace": 189.41,
					"projections": [
						32,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						77.78,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1515
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.32,
					"enrolment": 208,
					"ligo": 0.48,
					"location": [
						153.556074716219,
						-28.2628576264135
					],
					"name": "Cudgen Public School",
					"playspace": 18.23,
					"projections": [
						170,
						208,
						195,
						205,
						210,
						215
					],
					"projections_orig": [
						"170",
						"208",
						"195",
						"205",
						"210",
						"215"
					],
					"projections_percentage": [
						-18.27,
						0,
						-6.25,
						-1.44,
						0.96,
						3.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1696
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.53,
					"enrolment": 27,
					"ligo": 0.53,
					"location": [
						153.517132628414,
						-28.2875517827521
					],
					"name": "Duranbah Public School",
					"playspace": 169.32,
					"projections": [
						32,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.52,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1801
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.34,
					"enrolment": 41,
					"ligo": 0.69,
					"location": [
						153.565690862153,
						-28.1970614009006
					],
					"name": "Fingal Head Public School",
					"playspace": 228.4,
					"projections": [
						52,
						41,
						25,
						50,
						50,
						50
					],
					"projections_orig": [
						"52",
						"41",
						"<50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						26.83,
						0,
						-39.02,
						21.95,
						21.95,
						21.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1915
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.37,
					"enrolment": 462,
					"ligo": 0.51,
					"location": [
						153.500214707447,
						-28.2403296233827
					],
					"name": "Terranora Public School",
					"playspace": 35.5,
					"projections": [
						461,
						462,
						465,
						485,
						500,
						510
					],
					"projections_orig": [
						"461",
						"462",
						"465",
						"485",
						"500",
						"510"
					],
					"projections_percentage": [
						-0.22,
						0,
						0.65,
						4.98,
						8.23,
						10.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3189
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.55,
					"enrolment": 285,
					"ligo": 0.79,
					"location": [
						153.54211146087,
						-28.1692736841684
					],
					"name": "Tweed Heads Public School",
					"playspace": 31.3,
					"projections": [
						223,
						285,
						260,
						270,
						280,
						285
					],
					"projections_orig": [
						"223",
						"285",
						"260",
						"270",
						"280",
						"285"
					],
					"projections_percentage": [
						-21.75,
						0,
						-8.77,
						-5.26,
						-1.75,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3290
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 17
					},
					"classroomspace": 2.79,
					"enrolment": 692,
					"ligo": 0.88,
					"location": [
						153.568369581312,
						-28.3785343143034
					],
					"name": "Pottsville Beach Public School",
					"playspace": 21.14,
					"projections": [
						658,
						692,
						800,
						810,
						790,
						810
					],
					"projections_orig": [
						"658",
						"692",
						"800",
						"810",
						"790",
						"810"
					],
					"projections_percentage": [
						-4.91,
						0,
						15.61,
						17.05,
						14.16,
						17.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3578
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 11
					},
					"classroomspace": 2.71,
					"enrolment": 623,
					"ligo": 0.77,
					"location": [
						153.5790463543,
						-28.2591063310221
					],
					"name": "Kingscliff Public School",
					"playspace": 19.22,
					"projections": [
						469,
						623,
						665,
						675,
						660,
						670
					],
					"projections_orig": [
						"469",
						"623",
						"665",
						"675",
						"660",
						"670"
					],
					"projections_percentage": [
						-24.72,
						0,
						6.74,
						8.35,
						5.94,
						7.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4054
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.67,
					"enrolment": 204,
					"ligo": 0.54,
					"location": [
						153.540016727111,
						-28.1947773226597
					],
					"name": "Tweed Heads South Public School",
					"playspace": 50.95,
					"projections": [
						235,
						204,
						220,
						230,
						235,
						240
					],
					"projections_orig": [
						"235",
						"204",
						"220",
						"230",
						"235",
						"240"
					],
					"projections_percentage": [
						15.2,
						0,
						7.84,
						12.75,
						15.2,
						17.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4111
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.71,
					"enrolment": 509,
					"ligo": 0.69,
					"location": [
						153.525573898261,
						-28.216242616321
					],
					"name": "Centaur Public School",
					"playspace": 38.57,
					"projections": [
						481,
						509,
						495,
						515,
						530,
						540
					],
					"projections_orig": [
						"481",
						"509",
						"495",
						"515",
						"530",
						"540"
					],
					"projections_percentage": [
						-5.5,
						0,
						-2.75,
						1.18,
						4.13,
						6.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4607
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.75,
					"enrolment": 262,
					"ligo": 0.84,
					"location": [
						153.572451604275,
						-28.3388872954156
					],
					"name": "Bogangar Public School",
					"playspace": 65.69,
					"projections": [
						265,
						262,
						285,
						285,
						295,
						300
					],
					"projections_orig": [
						"265",
						"262",
						"285",
						"285",
						"295",
						"300"
					],
					"projections_percentage": [
						1.15,
						0,
						8.78,
						8.78,
						12.6,
						14.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4632
				}
			],
			"uid": 10127
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 207
			},
			"enrolment": 4047,
			"level": "Primary",
			"ligo": 0.6,
			"name": "Lake Macquarie West Primary",
			"playspace": 143.91,
			"projections": [
				4047,
				4025,
				4065,
				4050,
				4060
			],
			"projections_percentage": [
				0,
				-0.54,
				0.44,
				0.07,
				0.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.38,
					"enrolment": 32,
					"ligo": 0.62,
					"location": [
						151.538115008736,
						-33.0099877161941
					],
					"name": "Awaba Public School",
					"playspace": 159.82,
					"projections": [
						29,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.38,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1084
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 8.17,
					"enrolment": 59,
					"ligo": 0.53,
					"location": [
						151.622794777283,
						-32.9515630590033
					],
					"name": "Boolaroo Public School",
					"playspace": 90.56,
					"projections": [
						50,
						59,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"50",
						"59",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						-15.25,
						0,
						-6.78,
						-6.78,
						-6.78,
						-6.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1302
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.75,
					"enrolment": 63,
					"ligo": 0.25,
					"location": [
						151.583609782099,
						-32.9838102587299
					],
					"name": "Fassifern Public School",
					"playspace": 322.22,
					"projections": [
						58,
						63,
						60,
						60,
						60,
						60
					],
					"projections_orig": [
						"58",
						"63",
						"60",
						"60",
						"60",
						"60"
					],
					"projections_percentage": [
						-7.94,
						0,
						-4.76,
						-4.76,
						-4.76,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1904
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.57,
					"enrolment": 284,
					"ligo": 0.59,
					"location": [
						151.589241668606,
						-33.0428787475407
					],
					"name": "Rathmines Public School",
					"playspace": 79.46,
					"projections": [
						245,
						284,
						270,
						275,
						275,
						275
					],
					"projections_orig": [
						"245",
						"284",
						"270",
						"275",
						"275",
						"275"
					],
					"projections_percentage": [
						-13.73,
						0,
						-4.93,
						-3.17,
						-3.17,
						-3.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2193
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 4.54,
					"enrolment": 70,
					"ligo": 0.68,
					"location": [
						151.606407840887,
						-32.9626538159798
					],
					"name": "Teralba Public School",
					"playspace": 107.37,
					"projections": [
						68,
						70,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"68",
						"70",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						-2.86,
						0,
						7.14,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3183
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.53,
					"enrolment": 166,
					"ligo": 0.41,
					"location": [
						151.595308217794,
						-33.0085215258834
					],
					"name": "Toronto Public School",
					"playspace": 42.76,
					"projections": [
						201,
						166,
						195,
						195,
						195,
						195
					],
					"projections_orig": [
						"201",
						"166",
						"195",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						21.08,
						0,
						17.47,
						17.47,
						17.47,
						17.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3247
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.27,
					"enrolment": 109,
					"ligo": 0.81,
					"location": [
						151.583581567115,
						-33.0718535412889
					],
					"name": "Wangi Wangi Public School",
					"playspace": 119.44,
					"projections": [
						114,
						109,
						105,
						105,
						105,
						105
					],
					"projections_orig": [
						"114",
						"109",
						"105",
						"105",
						"105",
						"105"
					],
					"projections_percentage": [
						4.59,
						0,
						-3.67,
						-3.67,
						-3.67,
						-3.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3373
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.67,
					"enrolment": 429,
					"ligo": 0.65,
					"location": [
						151.649303957995,
						-32.9795129343659
					],
					"name": "Warners Bay Public School",
					"playspace": 32.45,
					"projections": [
						420,
						429,
						440,
						445,
						445,
						445
					],
					"projections_orig": [
						"420",
						"429",
						"440",
						"445",
						"445",
						"445"
					],
					"projections_percentage": [
						-2.1,
						0,
						2.56,
						3.73,
						3.73,
						3.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3384
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 13.2,
					"enrolment": 23,
					"ligo": 0.75,
					"location": [
						151.629602252155,
						-32.9375822476999
					],
					"name": "Argenton Public School",
					"playspace": 855.2,
					"projections": [
						53,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"53",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						130.43,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3904
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.61,
					"enrolment": 219,
					"ligo": 0.63,
					"location": [
						151.577993769278,
						-32.9988458673462
					],
					"name": "Blackalls Park Public School",
					"playspace": 70.17,
					"projections": [
						242,
						219,
						220,
						220,
						220,
						220
					],
					"projections_orig": [
						"242",
						"219",
						"220",
						"220",
						"220",
						"220"
					],
					"projections_percentage": [
						10.5,
						0,
						0.46,
						0.46,
						0.46,
						0.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3966
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 5.92,
					"enrolment": 113,
					"ligo": 0.38,
					"location": [
						151.621508207541,
						-32.959509726998
					],
					"name": "Speers Point Public School",
					"playspace": 102.36,
					"projections": [
						137,
						113,
						115,
						115,
						115,
						115
					],
					"projections_orig": [
						"137",
						"113",
						"115",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						21.24,
						0,
						1.77,
						1.77,
						1.77,
						1.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3968
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 7.91,
					"enrolment": 104,
					"ligo": 0.74,
					"location": [
						151.575783358569,
						-33.0077933444757
					],
					"name": "Biraban Public School",
					"playspace": 169.09,
					"projections": [
						103,
						104,
						110,
						110,
						110,
						110
					],
					"projections_orig": [
						"103",
						"104",
						"110",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						-0.96,
						0,
						5.77,
						5.77,
						5.77,
						5.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3988
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.01,
					"enrolment": 221,
					"ligo": 0.44,
					"location": [
						151.611457164425,
						-32.973366182359
					],
					"name": "Booragul Public School",
					"playspace": 90.57,
					"projections": [
						267,
						221,
						235,
						240,
						235,
						240
					],
					"projections_orig": [
						"267",
						"221",
						"235",
						"240",
						"235",
						"240"
					],
					"projections_percentage": [
						20.81,
						0,
						6.33,
						8.6,
						6.33,
						8.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4017
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.39,
					"enrolment": 245,
					"ligo": 0.73,
					"location": [
						151.610564444907,
						-33.0416022611789
					],
					"name": "Coal Point Public School",
					"playspace": 65.42,
					"projections": [
						232,
						245,
						225,
						225,
						225,
						225
					],
					"projections_orig": [
						"232",
						"245",
						"225",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						-5.31,
						0,
						-8.16,
						-8.16,
						-8.16,
						-8.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4022
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 18
					},
					"classroomspace": 2.41,
					"enrolment": 628,
					"ligo": 0.71,
					"location": [
						151.643276579499,
						-32.9910836552311
					],
					"name": "Eleebana Public School",
					"playspace": 35.01,
					"projections": [
						532,
						628,
						605,
						610,
						610,
						610
					],
					"projections_orig": [
						"532",
						"628",
						"605",
						"610",
						"610",
						"610"
					],
					"projections_percentage": [
						-15.29,
						0,
						-3.66,
						-2.87,
						-2.87,
						-2.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4034
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.39,
					"enrolment": 117,
					"ligo": 0.66,
					"location": [
						151.580276731374,
						-33.0608370253187
					],
					"name": "Arcadia Vale Public School",
					"playspace": 196.55,
					"projections": [
						109,
						117,
						120,
						125,
						120,
						125
					],
					"projections_orig": [
						"109",
						"117",
						"120",
						"125",
						"120",
						"125"
					],
					"projections_percentage": [
						-6.84,
						0,
						2.56,
						6.84,
						2.56,
						6.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4132
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.38,
					"enrolment": 564,
					"ligo": 0.77,
					"location": [
						151.642175798096,
						-33.008359625455
					],
					"name": "Valentine Public School",
					"playspace": 35.57,
					"projections": [
						472,
						564,
						530,
						535,
						535,
						535
					],
					"projections_orig": [
						"472",
						"564",
						"530",
						"535",
						"535",
						"535"
					],
					"projections_percentage": [
						-16.31,
						0,
						-6.03,
						-5.14,
						-5.14,
						-5.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4185
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 15
					},
					"classroomspace": 2.69,
					"enrolment": 438,
					"ligo": 0.41,
					"location": [
						151.643309683781,
						-32.9660922734363
					],
					"name": "Biddabah Public School",
					"playspace": 51.22,
					"projections": [
						423,
						438,
						455,
						460,
						455,
						455
					],
					"projections_orig": [
						"423",
						"438",
						"455",
						"460",
						"455",
						"455"
					],
					"projections_percentage": [
						-3.42,
						0,
						3.88,
						5.02,
						3.88,
						3.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4206
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 5.07,
					"enrolment": 163,
					"ligo": 0.64,
					"location": [
						151.600920256133,
						-32.9921270205201
					],
					"name": "Fennell Bay Public School",
					"playspace": 109,
					"projections": [
						153,
						163,
						155,
						160,
						160,
						160
					],
					"projections_orig": [
						"153",
						"163",
						"155",
						"160",
						"160",
						"160"
					],
					"projections_percentage": [
						-6.13,
						0,
						-4.91,
						-1.84,
						-1.84,
						-1.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4208
				}
			],
			"uid": 10128
		},
		{
			"classrooms": {
				"demountable": 26,
				"permanent": 175
			},
			"enrolment": 4392,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Port Stephens Primary",
			"playspace": 68.68,
			"projections": [
				4392,
				4743,
				4848,
				4933,
				4908
			],
			"projections_percentage": [
				0,
				7.99,
				10.38,
				12.32,
				11.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 3.55,
					"enrolment": 306,
					"ligo": 0.87,
					"location": [
						152.090008717033,
						-32.7767580680311
					],
					"name": "Anna Bay Public School",
					"playspace": 51.1,
					"projections": [
						383,
						306,
						380,
						390,
						400,
						400
					],
					"projections_orig": [
						"383",
						"306",
						"380",
						"390",
						"400",
						"400"
					],
					"projections_percentage": [
						25.16,
						0,
						24.18,
						27.45,
						30.72,
						30.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1040
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 4.34,
					"enrolment": 35,
					"ligo": 0.25,
					"location": [
						152.010631482553,
						-32.7663058241968
					],
					"name": "Bobs Farm Public School",
					"playspace": 166.17,
					"projections": [
						29,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-17.14,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1271
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 3.21,
					"enrolment": 119,
					"ligo": 0.9,
					"location": [
						151.965962298914,
						-32.654240079729
					],
					"name": "Karuah Public School",
					"playspace": 42.62,
					"projections": [
						75,
						119,
						115,
						110,
						105,
						105
					],
					"projections_orig": [
						"75",
						"119",
						"115",
						"110",
						"105",
						"105"
					],
					"projections_percentage": [
						-36.97,
						0,
						-3.36,
						-7.56,
						-11.76,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2263
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 2.61,
					"enrolment": 353,
					"ligo": 0.67,
					"location": [
						151.853947531166,
						-32.7393122665354
					],
					"name": "Medowie Public School",
					"playspace": 63.9,
					"projections": [
						351,
						353,
						365,
						360,
						345,
						335
					],
					"projections_orig": [
						"351",
						"353",
						"365",
						"360",
						"345",
						"335"
					],
					"projections_percentage": [
						-0.57,
						0,
						3.4,
						1.98,
						-2.27,
						-5.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2512
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.86,
					"enrolment": 64,
					"ligo": 0.12,
					"location": [
						151.704170898406,
						-32.7525013782796
					],
					"name": "Millers Forest Public School",
					"playspace": 88.11,
					"projections": [
						35,
						64,
						55,
						55,
						60,
						60
					],
					"projections_orig": [
						"35",
						"64",
						"55",
						"55",
						"60",
						"60"
					],
					"projections_percentage": [
						-45.31,
						0,
						-14.06,
						-14.06,
						-6.25,
						-6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2554
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.37,
					"enrolment": 33,
					"ligo": 0.26,
					"location": [
						151.699123420306,
						-32.7245057550042
					],
					"name": "Mount Kanwary Public School",
					"playspace": 57.73,
					"projections": [
						36,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						9.09,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2641
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.8,
					"enrolment": 362,
					"ligo": 0.7,
					"location": [
						152.112364445223,
						-32.7356385770897
					],
					"name": "Tomaree Public School",
					"playspace": 178.83,
					"projections": [
						443,
						362,
						480,
						495,
						505,
						510
					],
					"projections_orig": [
						"443",
						"362",
						"480",
						"495",
						"505",
						"510"
					],
					"projections_percentage": [
						22.38,
						0,
						32.6,
						36.74,
						39.5,
						40.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2723
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.72,
					"enrolment": 415,
					"ligo": 0.54,
					"location": [
						151.740657997696,
						-32.7661291039652
					],
					"name": "Raymond Terrace Public School",
					"playspace": 64.67,
					"projections": [
						367,
						415,
						440,
						460,
						475,
						475
					],
					"projections_orig": [
						"367",
						"415",
						"440",
						"460",
						"475",
						"475"
					],
					"projections_percentage": [
						-11.57,
						0,
						6.02,
						10.84,
						14.46,
						14.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2943
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 4.1,
					"enrolment": 87,
					"ligo": 0.69,
					"location": [
						151.903631457602,
						-32.7884460421666
					],
					"name": "Salt Ash Public School",
					"playspace": 40.47,
					"projections": [
						108,
						87,
						100,
						100,
						100,
						100
					],
					"projections_orig": [
						"108",
						"87",
						"100",
						"100",
						"100",
						"100"
					],
					"projections_percentage": [
						24.14,
						0,
						14.94,
						14.94,
						14.94,
						14.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3035
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 9
					},
					"classroomspace": 2.96,
					"enrolment": 351,
					"ligo": 0.74,
					"location": [
						152.064378016545,
						-32.7099784571803
					],
					"name": "Soldiers Point Public School",
					"playspace": 15.41,
					"projections": [
						342,
						351,
						395,
						405,
						415,
						415
					],
					"projections_orig": [
						"342",
						"351",
						"395",
						"405",
						"415",
						"415"
					],
					"projections_percentage": [
						-2.56,
						0,
						12.54,
						15.38,
						18.23,
						18.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3696
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.36,
					"enrolment": 308,
					"ligo": 0.77,
					"location": [
						151.75527357215,
						-32.7590490796796
					],
					"name": "Irrawang Public School",
					"playspace": 91.2,
					"projections": [
						294,
						308,
						315,
						335,
						350,
						350
					],
					"projections_orig": [
						"294",
						"308",
						"315",
						"335",
						"350",
						"350"
					],
					"projections_percentage": [
						-4.55,
						0,
						2.27,
						8.77,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4372
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 2.31,
					"enrolment": 579,
					"ligo": 0.94,
					"location": [
						152.004265294772,
						-32.72913587263
					],
					"name": "Tanilba Bay Public School",
					"playspace": 42.19,
					"projections": [
						475,
						579,
						615,
						630,
						645,
						645
					],
					"projections_orig": [
						"475",
						"579",
						"615",
						"630",
						"645",
						"645"
					],
					"projections_percentage": [
						-17.96,
						0,
						6.22,
						8.81,
						11.4,
						11.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4547
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 22
					},
					"classroomspace": 2.4,
					"enrolment": 606,
					"ligo": 0.83,
					"location": [
						151.877161033711,
						-32.7439541629152
					],
					"name": "Wirreanda Public School",
					"playspace": 25.31,
					"projections": [
						556,
						606,
						575,
						565,
						560,
						530
					],
					"projections_orig": [
						"556",
						"606",
						"575",
						"565",
						"560",
						"530"
					],
					"projections_percentage": [
						-8.25,
						0,
						-5.12,
						-6.77,
						-7.59,
						-12.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4564
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 12
					},
					"classroomspace": 2.49,
					"enrolment": 425,
					"ligo": 0.63,
					"location": [
						152.17314894559,
						-32.7288813103582
					],
					"name": "Shoal Bay Public School",
					"playspace": 42.57,
					"projections": [
						352,
						425,
						435,
						450,
						460,
						465
					],
					"projections_orig": [
						"352",
						"425",
						"435",
						"450",
						"460",
						"465"
					],
					"projections_percentage": [
						-17.18,
						0,
						2.35,
						5.88,
						8.24,
						9.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4589
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.27,
					"enrolment": 349,
					"ligo": 0.77,
					"location": [
						151.775327907097,
						-32.7587790612886
					],
					"name": "Grahamstown Public School",
					"playspace": 59.89,
					"projections": [
						415,
						349,
						405,
						425,
						445,
						450
					],
					"projections_orig": [
						"415",
						"349",
						"405",
						"425",
						"445",
						"450"
					],
					"projections_percentage": [
						18.91,
						0,
						16.05,
						21.78,
						27.51,
						28.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4609
				}
			],
			"uid": 10129
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 158
			},
			"enrolment": 3499,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Charlestown Primary",
			"playspace": 63.9,
			"projections": [
				3499,
				3535,
				3570,
				3560,
				3570
			],
			"projections_percentage": [
				0,
				1.03,
				2.03,
				1.74,
				2.03
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.81,
					"enrolment": 315,
					"ligo": 0.67,
					"location": [
						151.663135698827,
						-33.0299110048005
					],
					"name": "Belmont Public School",
					"playspace": 54.18,
					"projections": [
						289,
						315,
						310,
						315,
						310,
						315
					],
					"projections_orig": [
						"289",
						"315",
						"310",
						"315",
						"310",
						"315"
					],
					"projections_percentage": [
						-8.25,
						0,
						-1.59,
						0,
						-1.59,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1183
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 5,
					"enrolment": 130,
					"ligo": 0.63,
					"location": [
						151.696983870389,
						-32.965201213215
					],
					"name": "Charlestown Public School",
					"playspace": 23.07,
					"projections": [
						136,
						130,
						135,
						135,
						135,
						135
					],
					"projections_orig": [
						"136",
						"130",
						"135",
						"135",
						"135",
						"135"
					],
					"projections_percentage": [
						4.62,
						0,
						3.85,
						3.85,
						3.85,
						3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1550
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.64,
					"enrolment": 263,
					"ligo": 0.62,
					"location": [
						151.717016933809,
						-32.9894040586081
					],
					"name": "Dudley Public School",
					"playspace": 32.03,
					"projections": [
						245,
						263,
						270,
						270,
						270,
						270
					],
					"projections_orig": [
						"245",
						"263",
						"270",
						"270",
						"270",
						"270"
					],
					"projections_percentage": [
						-6.84,
						0,
						2.66,
						2.66,
						2.66,
						2.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1778
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 2.71,
					"enrolment": 284,
					"ligo": 0.86,
					"location": [
						151.71194257255,
						-33.0110497867105
					],
					"name": "Redhead Public School",
					"playspace": 49.65,
					"projections": [
						262,
						284,
						290,
						295,
						295,
						295
					],
					"projections_orig": [
						"262",
						"284",
						"290",
						"295",
						"295",
						"295"
					],
					"projections_percentage": [
						-7.75,
						0,
						2.11,
						3.87,
						3.87,
						3.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2946
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.27,
					"enrolment": 220,
					"ligo": 0.5,
					"location": [
						151.691681858245,
						-32.9843389271604
					],
					"name": "Wiripaang Public School",
					"playspace": 162.86,
					"projections": [
						127,
						220,
						220,
						220,
						220,
						220
					],
					"projections_orig": [
						"127",
						"220",
						"220",
						"220",
						"220",
						"220"
					],
					"projections_percentage": [
						-42.27,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3762
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.56,
					"enrolment": 326,
					"ligo": 0.6,
					"location": [
						151.713434894573,
						-32.9639318598949
					],
					"name": "Kahibah Public School",
					"playspace": 43.44,
					"projections": [
						288,
						326,
						315,
						320,
						320,
						320
					],
					"projections_orig": [
						"288",
						"326",
						"315",
						"320",
						"320",
						"320"
					],
					"projections_percentage": [
						-11.66,
						0,
						-3.37,
						-1.84,
						-1.84,
						-1.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3874
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 7.03,
					"enrolment": 151,
					"ligo": 0.87,
					"location": [
						151.678839745098,
						-32.9923057625142
					],
					"name": "Windale Public School",
					"playspace": 89.75,
					"projections": [
						253,
						151,
						195,
						200,
						200,
						200
					],
					"projections_orig": [
						"253",
						"151",
						"195",
						"200",
						"200",
						"200"
					],
					"projections_percentage": [
						67.55,
						0,
						29.14,
						32.45,
						32.45,
						32.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3893
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.39,
					"enrolment": 190,
					"ligo": 0.63,
					"location": [
						151.671950382339,
						-33.0201656063615
					],
					"name": "Belmont North Public School",
					"playspace": 92.88,
					"projections": [
						123,
						190,
						165,
						165,
						165,
						165
					],
					"projections_orig": [
						"123",
						"190",
						"165",
						"165",
						"165",
						"165"
					],
					"projections_percentage": [
						-35.26,
						0,
						-13.16,
						-13.16,
						-13.16,
						-13.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3927
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.91,
					"enrolment": 171,
					"ligo": 0.55,
					"location": [
						151.669308413973,
						-32.9775057676111
					],
					"name": "Mount Hutton Public School",
					"playspace": 77.26,
					"projections": [
						172,
						171,
						170,
						170,
						170,
						170
					],
					"projections_orig": [
						"172",
						"171",
						"170",
						"170",
						"170",
						"170"
					],
					"projections_percentage": [
						0.58,
						0,
						-0.58,
						-0.58,
						-0.58,
						-0.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3939
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.16,
					"enrolment": 243,
					"ligo": 0.51,
					"location": [
						151.705445016695,
						-32.9712831606353
					],
					"name": "Charlestown East Public School",
					"playspace": 87.82,
					"projections": [
						202,
						243,
						220,
						225,
						220,
						225
					],
					"projections_orig": [
						"202",
						"243",
						"220",
						"225",
						"220",
						"225"
					],
					"projections_percentage": [
						-16.87,
						0,
						-9.47,
						-7.41,
						-9.47,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4194
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.6,
					"enrolment": 217,
					"ligo": 0.45,
					"location": [
						151.687948825094,
						-32.9682238466324
					],
					"name": "Charlestown South Public School",
					"playspace": 65.21,
					"projections": [
						139,
						217,
						195,
						195,
						195,
						195
					],
					"projections_orig": [
						"139",
						"217",
						"195",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						-35.94,
						0,
						-10.14,
						-10.14,
						-10.14,
						-10.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4324
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.47,
					"enrolment": 551,
					"ligo": 0.67,
					"location": [
						151.664640555219,
						-33.0145834077935
					],
					"name": "Floraville Public School",
					"playspace": 11.2,
					"projections": [
						553,
						551,
						570,
						575,
						575,
						575
					],
					"projections_orig": [
						"553",
						"551",
						"570",
						"575",
						"575",
						"575"
					],
					"projections_percentage": [
						0.36,
						0,
						3.45,
						4.36,
						4.36,
						4.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4379
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.6,
					"enrolment": 438,
					"ligo": 0.54,
					"location": [
						151.687967830093,
						-33.0162716981391
					],
					"name": "Jewells Primary School",
					"playspace": 41.33,
					"projections": [
						505,
						438,
						480,
						485,
						485,
						485
					],
					"projections_orig": [
						"505",
						"438",
						"480",
						"485",
						"485",
						"485"
					],
					"projections_percentage": [
						15.3,
						0,
						9.59,
						10.73,
						10.73,
						10.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4469
				}
			],
			"uid": 10130
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 89
			},
			"enrolment": 2082,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Kotara Primary",
			"playspace": 40.33,
			"projections": [
				2082,
				2135,
				2205,
				2245,
				2245
			],
			"projections_percentage": [
				0,
				2.55,
				5.91,
				7.83,
				7.83
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.25,
					"enrolment": 273,
					"ligo": 0.78,
					"location": [
						151.730005683356,
						-32.9325618948815
					],
					"name": "Adamstown Public School",
					"playspace": 64.44,
					"projections": [
						235,
						273,
						280,
						285,
						290,
						290
					],
					"projections_orig": [
						"235",
						"273",
						"280",
						"285",
						"290",
						"290"
					],
					"projections_percentage": [
						-13.92,
						0,
						2.56,
						4.4,
						6.23,
						6.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1008
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 2.98,
					"enrolment": 158,
					"ligo": 0.68,
					"location": [
						151.741390437664,
						-32.9370571358803
					],
					"name": "Merewether Public School",
					"playspace": 44.59,
					"projections": [
						166,
						158,
						185,
						195,
						200,
						200
					],
					"projections_orig": [
						"166",
						"158",
						"185",
						"195",
						"200",
						"200"
					],
					"projections_percentage": [
						5.06,
						0,
						17.09,
						23.42,
						26.58,
						26.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2525
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.27,
					"enrolment": 460,
					"ligo": 0.51,
					"location": [
						151.717557876332,
						-32.9311409851811
					],
					"name": "New Lambton South Public School",
					"playspace": 31.27,
					"projections": [
						407,
						460,
						475,
						500,
						515,
						515
					],
					"projections_orig": [
						"407",
						"460",
						"475",
						"500",
						"515",
						"515"
					],
					"projections_percentage": [
						-11.52,
						0,
						3.26,
						8.7,
						11.96,
						11.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3798
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.03,
					"enrolment": 319,
					"ligo": 0.75,
					"location": [
						151.694933895439,
						-32.9468482267985
					],
					"name": "Kotara South Public School",
					"playspace": 62.5,
					"projections": [
						258,
						319,
						300,
						305,
						305,
						305
					],
					"projections_orig": [
						"258",
						"319",
						"300",
						"305",
						"305",
						"305"
					],
					"projections_percentage": [
						-19.12,
						0,
						-5.96,
						-4.39,
						-4.39,
						-4.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4203
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 530,
					"ligo": 0.56,
					"location": [
						151.712772458519,
						-32.9454693080959
					],
					"name": "Belair Public School",
					"playspace": 25.51,
					"projections": [
						479,
						530,
						530,
						535,
						535,
						535
					],
					"projections_orig": [
						"479",
						"530",
						"530",
						"535",
						"535",
						"535"
					],
					"projections_percentage": [
						-9.62,
						0,
						0,
						0.94,
						0.94,
						0.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4370
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.93,
					"enrolment": 342,
					"ligo": 0.64,
					"location": [
						151.738244834481,
						-32.947049327707
					],
					"name": "Merewether Heights Public School",
					"playspace": 13.64,
					"projections": [
						320,
						342,
						365,
						385,
						400,
						400
					],
					"projections_orig": [
						"320",
						"342",
						"365",
						"385",
						"400",
						"400"
					],
					"projections_percentage": [
						-6.43,
						0,
						6.73,
						12.57,
						16.96,
						16.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4416
				}
			],
			"uid": 10131
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 46
			},
			"enrolment": 1049,
			"level": "Primary",
			"ligo": 0.77,
			"name": "Swansea Primary",
			"playspace": 143.47,
			"projections": [
				1049,
				1075,
				1095,
				1095,
				1095
			],
			"projections_percentage": [
				0,
				2.48,
				4.39,
				4.39,
				4.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.26,
					"enrolment": 43,
					"ligo": 0.81,
					"location": [
						151.648405436278,
						-33.0739120460417
					],
					"name": "Pelican Flat Public School",
					"playspace": 340.21,
					"projections": [
						47,
						43,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"47",
						"43",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						9.3,
						0,
						16.28,
						16.28,
						16.28,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2476
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 2.78,
					"enrolment": 120,
					"ligo": 0.68,
					"location": [
						151.603961282201,
						-33.1357939444135
					],
					"name": "Nords Wharf Public School",
					"playspace": 123.28,
					"projections": [
						85,
						120,
						105,
						110,
						110,
						110
					],
					"projections_orig": [
						"85",
						"120",
						"105",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						-29.17,
						0,
						-12.5,
						-8.33,
						-8.33,
						-8.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2759
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.14,
					"enrolment": 232,
					"ligo": 0.83,
					"location": [
						151.636111184618,
						-33.0836675423834
					],
					"name": "Swansea Public School",
					"playspace": 35.68,
					"projections": [
						220,
						232,
						275,
						280,
						280,
						280
					],
					"projections_orig": [
						"220",
						"232",
						"275",
						"280",
						"280",
						"280"
					],
					"projections_percentage": [
						-5.17,
						0,
						18.53,
						20.69,
						20.69,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3141
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.45,
					"enrolment": 158,
					"ligo": 0.75,
					"location": [
						151.64951682282,
						-33.057984467019
					],
					"name": "Marks Point Public School",
					"playspace": 80.14,
					"projections": [
						185,
						158,
						155,
						160,
						160,
						160
					],
					"projections_orig": [
						"185",
						"158",
						"155",
						"160",
						"160",
						"160"
					],
					"projections_percentage": [
						17.09,
						0,
						-1.9,
						1.27,
						1.27,
						1.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3898
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.51,
					"enrolment": 96,
					"ligo": 0.76,
					"location": [
						151.653450578921,
						-33.0721230281809
					],
					"name": "Blacksmiths Public School",
					"playspace": 239.49,
					"projections": [
						123,
						96,
						105,
						105,
						105,
						105
					],
					"projections_orig": [
						"123",
						"96",
						"105",
						"105",
						"105",
						"105"
					],
					"projections_percentage": [
						28.12,
						0,
						9.38,
						9.38,
						9.38,
						9.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4197
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.45,
					"enrolment": 400,
					"ligo": 0.81,
					"location": [
						151.638547179011,
						-33.104085654651
					],
					"name": "Caves Beach Public School",
					"playspace": 42.01,
					"projections": [
						365,
						400,
						385,
						390,
						390,
						390
					],
					"projections_orig": [
						"365",
						"400",
						"385",
						"390",
						"390",
						"390"
					],
					"projections_percentage": [
						-8.75,
						0,
						-3.75,
						-2.5,
						-2.5,
						-2.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4367
				}
			],
			"uid": 10132
		},
		{
			"classrooms": {
				"demountable": 56,
				"permanent": 252
			},
			"enrolment": 6649,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Maitland Primary",
			"playspace": 59.69,
			"projections": [
				6649,
				7000,
				7270,
				7425,
				7450
			],
			"projections_percentage": [
				0,
				5.28,
				9.34,
				11.67,
				12.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.33,
					"enrolment": 272,
					"ligo": 0.66,
					"location": [
						151.6537523384,
						-32.8040787149929
					],
					"name": "Beresfield Public School",
					"playspace": 29.68,
					"projections": [
						322,
						272,
						325,
						340,
						345,
						350
					],
					"projections_orig": [
						"322",
						"272",
						"325",
						"340",
						"345",
						"350"
					],
					"projections_percentage": [
						18.38,
						0,
						19.49,
						25,
						26.84,
						28.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1201
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 9
					},
					"classroomspace": 3.05,
					"enrolment": 435,
					"ligo": 0.59,
					"location": [
						151.573521872535,
						-32.7075735936284
					],
					"name": "Bolwarra Public School",
					"playspace": 50.32,
					"projections": [
						392,
						435,
						460,
						460,
						455,
						445
					],
					"projections_orig": [
						"392",
						"435",
						"460",
						"460",
						"455",
						"445"
					],
					"projections_percentage": [
						-9.89,
						0,
						5.75,
						5.75,
						4.6,
						2.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1286
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 10
					},
					"classroomspace": 2.38,
					"enrolment": 386,
					"ligo": 0.84,
					"location": [
						151.350262965666,
						-32.6590042800808
					],
					"name": "Branxton Public School",
					"playspace": 23.91,
					"projections": [
						330,
						386,
						415,
						460,
						470,
						445
					],
					"projections_orig": [
						"330",
						"386",
						"415",
						"460",
						"470",
						"445"
					],
					"projections_percentage": [
						-14.51,
						0,
						7.51,
						19.17,
						21.76,
						15.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1341
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 2
					},
					"classroomspace": 2.79,
					"enrolment": 178,
					"ligo": 0.84,
					"location": [
						151.530421637957,
						-32.7518337786118
					],
					"name": "Gillieston Public School",
					"playspace": 92.45,
					"projections": [
						105,
						178,
						190,
						195,
						200,
						205
					],
					"projections_orig": [
						"105",
						"178",
						"190",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						-41.01,
						0,
						6.74,
						9.55,
						12.36,
						15.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1982
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.57,
					"enrolment": 187,
					"ligo": 0.91,
					"location": [
						151.38732143607,
						-32.6807001860885
					],
					"name": "Greta Public School",
					"playspace": 46.54,
					"projections": [
						206,
						187,
						220,
						230,
						235,
						235
					],
					"projections_orig": [
						"206",
						"187",
						"220",
						"230",
						"235",
						"235"
					],
					"projections_percentage": [
						10.16,
						0,
						17.65,
						22.99,
						25.67,
						25.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2084
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 3.16,
					"enrolment": 449,
					"ligo": 0.73,
					"location": [
						151.531591137713,
						-32.725112512395
					],
					"name": "Telarah Public School",
					"playspace": 30.83,
					"projections": [
						496,
						449,
						490,
						510,
						520,
						525
					],
					"projections_orig": [
						"496",
						"449",
						"490",
						"510",
						"520",
						"525"
					],
					"projections_percentage": [
						10.47,
						0,
						9.13,
						13.59,
						15.81,
						16.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2177
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.33,
					"enrolment": 55,
					"ligo": 0.41,
					"location": [
						151.603837248055,
						-32.6646740492067
					],
					"name": "Iona Public School",
					"playspace": 190.02,
					"projections": [
						66,
						55,
						65,
						65,
						60,
						60
					],
					"projections_orig": [
						"66",
						"55",
						"65",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						20,
						0,
						18.18,
						18.18,
						9.09,
						9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2211
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 2.64,
					"enrolment": 149,
					"ligo": 0.8,
					"location": [
						151.606037560963,
						-32.7006135225472
					],
					"name": "Largs Public School",
					"playspace": 63.58,
					"projections": [
						117,
						149,
						135,
						135,
						135,
						130
					],
					"projections_orig": [
						"117",
						"149",
						"135",
						"135",
						"135",
						"130"
					],
					"projections_percentage": [
						-21.48,
						0,
						-9.4,
						-9.4,
						-9.4,
						-12.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2374
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.62,
					"enrolment": 171,
					"ligo": 0.36,
					"location": [
						151.451469034318,
						-32.6996807840043
					],
					"name": "Lochinvar Public School",
					"playspace": 104.31,
					"projections": [
						95,
						171,
						165,
						175,
						175,
						180
					],
					"projections_orig": [
						"95",
						"171",
						"165",
						"175",
						"175",
						"180"
					],
					"projections_percentage": [
						-44.44,
						0,
						-3.51,
						2.34,
						2.34,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2417
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 2.78,
					"enrolment": 582,
					"ligo": 0.61,
					"location": [
						151.584910242014,
						-32.748457239193
					],
					"name": "Maitland East Public School",
					"playspace": 21.58,
					"projections": [
						543,
						582,
						655,
						680,
						695,
						700
					],
					"projections_orig": [
						"543",
						"582",
						"655",
						"680",
						"695",
						"700"
					],
					"projections_percentage": [
						-6.7,
						0,
						12.54,
						16.84,
						19.42,
						20.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2451
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.62,
					"enrolment": 219,
					"ligo": 0.61,
					"location": [
						151.631626783529,
						-32.7259066259276
					],
					"name": "Morpeth Public School",
					"playspace": 23.47,
					"projections": [
						188,
						219,
						235,
						245,
						250,
						250
					],
					"projections_orig": [
						"188",
						"219",
						"235",
						"245",
						"250",
						"250"
					],
					"projections_percentage": [
						-14.16,
						0,
						7.31,
						11.87,
						14.16,
						14.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2623
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.72,
					"enrolment": 375,
					"ligo": 0.65,
					"location": [
						151.604161110685,
						-32.7431723223951
					],
					"name": "Tenambit Public School",
					"playspace": 43.13,
					"projections": [
						328,
						375,
						385,
						400,
						410,
						415
					],
					"projections_orig": [
						"328",
						"375",
						"385",
						"400",
						"410",
						"415"
					],
					"projections_percentage": [
						-12.53,
						0,
						2.67,
						6.67,
						9.33,
						10.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3180
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.45,
					"enrolment": 590,
					"ligo": 0.85,
					"location": [
						151.641361514857,
						-32.7792821890393
					],
					"name": "Thornton Public School",
					"playspace": 127.2,
					"projections": [
						542,
						590,
						610,
						635,
						675,
						685
					],
					"projections_orig": [
						"542",
						"590",
						"610",
						"635",
						"675",
						"685"
					],
					"projections_percentage": [
						-8.14,
						0,
						3.39,
						7.63,
						14.41,
						16.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3204
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.53,
					"enrolment": 379,
					"ligo": 0.3,
					"location": [
						151.553804530514,
						-32.7355536709923
					],
					"name": "Maitland Public School",
					"playspace": 15.62,
					"projections": [
						300,
						379,
						375,
						385,
						390,
						395
					],
					"projections_orig": [
						"300",
						"379",
						"375",
						"385",
						"390",
						"395"
					],
					"projections_percentage": [
						-20.84,
						0,
						-1.06,
						1.58,
						2.9,
						4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3949
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.65,
					"enrolment": 155,
					"ligo": 0.46,
					"location": [
						151.663504372587,
						-32.8101509942166
					],
					"name": "Tarro Public School",
					"playspace": 123.06,
					"projections": [
						116,
						155,
						150,
						155,
						160,
						160
					],
					"projections_orig": [
						"116",
						"155",
						"150",
						"155",
						"160",
						"160"
					],
					"projections_percentage": [
						-25.16,
						0,
						-3.23,
						0,
						3.23,
						3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4263
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 5.69,
					"enrolment": 199,
					"ligo": 0.92,
					"location": [
						151.66915198165,
						-32.7924268117674
					],
					"name": "Woodberry Public School",
					"playspace": 112.83,
					"projections": [
						187,
						199,
						200,
						210,
						215,
						215
					],
					"projections_orig": [
						"187",
						"199",
						"200",
						"210",
						"215",
						"215"
					],
					"projections_percentage": [
						-6.03,
						0,
						0.5,
						5.53,
						8.04,
						8.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4459
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.1,
					"enrolment": 311,
					"ligo": 0.84,
					"location": [
						151.612310625293,
						-32.7642294066915
					],
					"name": "Metford Public School",
					"playspace": 48.43,
					"projections": [
						318,
						311,
						325,
						335,
						345,
						350
					],
					"projections_orig": [
						"318",
						"311",
						"325",
						"335",
						"345",
						"350"
					],
					"projections_percentage": [
						2.25,
						0,
						4.5,
						7.72,
						10.93,
						12.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4521
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 22
					},
					"classroomspace": 2.55,
					"enrolment": 876,
					"ligo": 0.8,
					"location": [
						151.529059227026,
						-32.7115128117547
					],
					"name": "Rutherford Public School",
					"playspace": 21,
					"projections": [
						606,
						876,
						875,
						905,
						925,
						935
					],
					"projections_orig": [
						"606",
						"876",
						"875",
						"905",
						"925",
						"935"
					],
					"projections_percentage": [
						-30.82,
						0,
						-0.11,
						3.31,
						5.59,
						6.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4561
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 17
					},
					"classroomspace": 2.79,
					"enrolment": 619,
					"ligo": 0.75,
					"location": [
						151.599397657566,
						-32.7726393759434
					],
					"name": "Ashtonfield Public School",
					"playspace": 6.34,
					"projections": [
						574,
						619,
						665,
						690,
						710,
						715
					],
					"projections_orig": [
						"574",
						"619",
						"665",
						"690",
						"710",
						"715"
					],
					"projections_percentage": [
						-7.27,
						0,
						7.43,
						11.47,
						14.7,
						15.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4642
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.58,
					"enrolment": 62,
					"ligo": 1,
					"location": [
						151.55922228186,
						-32.7275320489487
					],
					"name": "Nillo Infants School",
					"playspace": 19.4,
					"projections": [
						58,
						62,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"58",
						"62",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						-6.45,
						0,
						-3.23,
						-3.23,
						-11.29,
						-11.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5128
				}
			],
			"uid": 10133
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 45
			},
			"enrolment": 1219,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Morisset Primary",
			"playspace": 66.47,
			"projections": [
				1219,
				1220,
				1225,
				1225,
				1230
			],
			"projections_percentage": [
				0,
				0.08,
				0.49,
				0.49,
				0.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.64,
					"enrolment": 223,
					"ligo": 0.69,
					"location": [
						151.440912945326,
						-33.0808082762675
					],
					"name": "Cooranbong Public School",
					"playspace": 78.26,
					"projections": [
						169,
						223,
						200,
						200,
						200,
						200
					],
					"projections_orig": [
						"169",
						"223",
						"200",
						"200",
						"200",
						"200"
					],
					"projections_percentage": [
						-24.22,
						0,
						-10.31,
						-10.31,
						-10.31,
						-10.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1635
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 2
					},
					"classroomspace": 4.48,
					"enrolment": 115,
					"ligo": 0.48,
					"location": [
						151.498888110809,
						-33.0800632273603
					],
					"name": "Dora Creek Public School",
					"playspace": 79.86,
					"projections": [
						141,
						115,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"141",
						"115",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						22.61,
						0,
						13.04,
						13.04,
						13.04,
						13.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1762
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.6,
					"enrolment": 428,
					"ligo": 0.88,
					"location": [
						151.515563631862,
						-33.1137563616814
					],
					"name": "Bonnells Bay Public School",
					"playspace": 35.59,
					"projections": [
						348,
						428,
						420,
						420,
						420,
						420
					],
					"projections_orig": [
						"348",
						"428",
						"420",
						"420",
						"420",
						"420"
					],
					"projections_percentage": [
						-18.69,
						0,
						-1.87,
						-1.87,
						-1.87,
						-1.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2532
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.94,
					"enrolment": 235,
					"ligo": 0.49,
					"location": [
						151.488536611209,
						-33.102922155986
					],
					"name": "Morisset Public School",
					"playspace": 63.71,
					"projections": [
						239,
						235,
						240,
						245,
						245,
						245
					],
					"projections_orig": [
						"239",
						"235",
						"240",
						"245",
						"245",
						"245"
					],
					"projections_percentage": [
						1.7,
						0,
						2.13,
						4.26,
						4.26,
						4.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2621
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.7,
					"enrolment": 218,
					"ligo": 0.71,
					"location": [
						151.482866172352,
						-33.1758248322375
					],
					"name": "Wyee Public School",
					"playspace": 74.93,
					"projections": [
						202,
						218,
						230,
						230,
						230,
						235
					],
					"projections_orig": [
						"202",
						"218",
						"230",
						"230",
						"230",
						"235"
					],
					"projections_percentage": [
						-7.34,
						0,
						5.5,
						5.5,
						5.5,
						7.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3522
				}
			],
			"uid": 10134
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 158
			},
			"enrolment": 4024,
			"level": "Primary",
			"ligo": 0.69,
			"name": "Newcastle West Primary",
			"playspace": 66.82,
			"projections": [
				4024,
				4025,
				4135,
				4165,
				4185
			],
			"projections_percentage": [
				0,
				0.02,
				2.76,
				3.5,
				4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.36,
					"enrolment": 301,
					"ligo": 0.6,
					"location": [
						151.593477892751,
						-32.9324334884525
					],
					"name": "Barnsley Public School",
					"playspace": 56.73,
					"projections": [
						264,
						301,
						300,
						310,
						315,
						320
					],
					"projections_orig": [
						"264",
						"301",
						"300",
						"310",
						"315",
						"320"
					],
					"projections_percentage": [
						-12.29,
						0,
						-0.33,
						2.99,
						4.65,
						6.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1138
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.98,
					"enrolment": 225,
					"ligo": 0.54,
					"location": [
						151.658041246276,
						-32.9459242138991
					],
					"name": "Cardiff Public School",
					"playspace": 38.2,
					"projections": [
						225,
						225,
						220,
						225,
						225,
						225
					],
					"projections_orig": [
						"225",
						"225",
						"220",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						0,
						0,
						-2.22,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1505
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.21,
					"enrolment": 402,
					"ligo": 0.67,
					"location": [
						151.704721345559,
						-32.9117509390879
					],
					"name": "Lambton Public School",
					"playspace": 27.23,
					"projections": [
						369,
						402,
						430,
						455,
						470,
						470
					],
					"projections_orig": [
						"369",
						"402",
						"430",
						"455",
						"470",
						"470"
					],
					"projections_percentage": [
						-8.21,
						0,
						6.97,
						13.18,
						16.92,
						16.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2366
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.05,
					"enrolment": 598,
					"ligo": 0.78,
					"location": [
						151.712466662394,
						-32.9229420988449
					],
					"name": "New Lambton Public School",
					"playspace": 9.39,
					"projections": [
						592,
						598,
						645,
						675,
						690,
						690
					],
					"projections_orig": [
						"592",
						"598",
						"645",
						"675",
						"690",
						"690"
					],
					"projections_percentage": [
						-1,
						0,
						7.86,
						12.88,
						15.38,
						15.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2738
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.04,
					"enrolment": 221,
					"ligo": 0.77,
					"location": [
						151.580474275862,
						-32.9042611194444
					],
					"name": "West Wallsend Public School",
					"playspace": 36.65,
					"projections": [
						223,
						221,
						230,
						240,
						245,
						250
					],
					"projections_orig": [
						"223",
						"221",
						"230",
						"240",
						"245",
						"250"
					],
					"projections_percentage": [
						0.9,
						0,
						4.07,
						8.6,
						10.86,
						13.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3358
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.66,
					"enrolment": 587,
					"ligo": 0.83,
					"location": [
						151.621801778585,
						-32.9216319445102
					],
					"name": "Edgeworth Public School",
					"playspace": 75.72,
					"projections": [
						572,
						587,
						580,
						585,
						580,
						585
					],
					"projections_orig": [
						"572",
						"587",
						"580",
						"585",
						"580",
						"585"
					],
					"projections_percentage": [
						-2.56,
						0,
						-1.19,
						-0.34,
						-1.19,
						-0.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3564
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.71,
					"enrolment": 307,
					"ligo": 0.66,
					"location": [
						151.664168417772,
						-32.9534045193004
					],
					"name": "Cardiff South Public School",
					"playspace": 53.1,
					"projections": [
						316,
						307,
						300,
						305,
						305,
						305
					],
					"projections_orig": [
						"316",
						"307",
						"300",
						"305",
						"305",
						"305"
					],
					"projections_percentage": [
						2.93,
						0,
						-2.28,
						-0.65,
						-0.65,
						-0.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3895
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 3.37,
					"enrolment": 210,
					"ligo": 0.66,
					"location": [
						151.683611698462,
						-32.9477929383421
					],
					"name": "Garden Suburb Public School",
					"playspace": 153.08,
					"projections": [
						219,
						210,
						210,
						215,
						215,
						215
					],
					"projections_orig": [
						"219",
						"210",
						"210",
						"215",
						"215",
						"215"
					],
					"projections_percentage": [
						4.29,
						0,
						0,
						2.38,
						2.38,
						2.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4136
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 12
					},
					"classroomspace": 2.65,
					"enrolment": 409,
					"ligo": 0.65,
					"location": [
						151.609313552939,
						-32.9254684840409
					],
					"name": "Edgeworth Heights Public School",
					"playspace": 61.76,
					"projections": [
						295,
						409,
						370,
						375,
						375,
						375
					],
					"projections_orig": [
						"295",
						"409",
						"370",
						"375",
						"375",
						"375"
					],
					"projections_percentage": [
						-27.87,
						0,
						-9.54,
						-8.31,
						-8.31,
						-8.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4155
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.76,
					"enrolment": 241,
					"ligo": 0.66,
					"location": [
						151.653887452327,
						-32.9272821428591
					],
					"name": "Glendale East Public School",
					"playspace": 92.9,
					"projections": [
						160,
						241,
						210,
						210,
						210,
						210
					],
					"projections_orig": [
						"160",
						"241",
						"210",
						"210",
						"210",
						"210"
					],
					"projections_percentage": [
						-33.61,
						0,
						-12.86,
						-12.86,
						-12.86,
						-12.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4207
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.44,
					"enrolment": 285,
					"ligo": 0.42,
					"location": [
						151.681568986601,
						-32.9596546891916
					],
					"name": "Hillsborough Public School",
					"playspace": 47.11,
					"projections": [
						268,
						285,
						295,
						300,
						295,
						300
					],
					"projections_orig": [
						"268",
						"285",
						"295",
						"300",
						"295",
						"300"
					],
					"projections_percentage": [
						-5.96,
						0,
						3.51,
						5.26,
						3.51,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4318
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.7,
					"enrolment": 74,
					"ligo": 1,
					"location": [
						151.689069471013,
						-32.9348486169527
					],
					"name": "New Lambton Heights Infants School",
					"playspace": 61.86,
					"projections": [
						56,
						74,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"56",
						"74",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						-24.32,
						0,
						8.11,
						14.86,
						14.86,
						14.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5247
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.39,
					"enrolment": 164,
					"ligo": 0.68,
					"location": [
						151.665844475849,
						-32.9366534629972
					],
					"name": "Cardiff North Public School",
					"playspace": 154.98,
					"projections": [
						126,
						164,
						155,
						155,
						155,
						155
					],
					"projections_orig": [
						"126",
						"164",
						"155",
						"155",
						"155",
						"155"
					],
					"projections_percentage": [
						-23.17,
						0,
						-5.49,
						-5.49,
						-5.49,
						-5.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5260
				}
			],
			"uid": 10135
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 89
			},
			"enrolment": 1839,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Bathurst City Secondary",
			"playspace": 47.2,
			"projections": [
				1839,
				2160,
				2290,
				2345,
				2325
			],
			"projections_percentage": [
				0,
				17.46,
				24.52,
				27.51,
				26.43
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 49
					},
					"classroomspace": 3.48,
					"enrolment": 1071,
					"ligo": 0.68,
					"location": [
						149.569964273239,
						-33.4122712020023
					],
					"name": "Denison College of Secondary Education, Bathurst High Campus",
					"playspace": 24.11,
					"projections": [
						921,
						1071,
						1230,
						1305,
						1335,
						1330
					],
					"projections_orig": [
						"921",
						"1071",
						"1230",
						"1305",
						"1335",
						"1330"
					],
					"projections_percentage": [
						-14.01,
						0,
						14.85,
						21.85,
						24.65,
						24.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8103
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 3.6,
					"enrolment": 768,
					"ligo": 0.81,
					"location": [
						149.615434450582,
						-33.4116050059876
					],
					"name": "Denison College of Secondary Education, Kelso High Campus",
					"playspace": 70.3,
					"projections": [
						861,
						768,
						930,
						985,
						1010,
						995
					],
					"projections_orig": [
						"861",
						"768",
						"930",
						"985",
						"1010",
						"995"
					],
					"projections_percentage": [
						12.11,
						0,
						21.09,
						28.26,
						31.51,
						29.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8517
				}
			],
			"uid": 20001
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 103
			},
			"enrolment": 1143,
			"level": "Secondary",
			"ligo": 1,
			"name": "Broken Hill Secondary",
			"playspace": 102.16,
			"projections": [
				1143,
				1275,
				1275,
				1150,
				1000
			],
			"projections_percentage": [
				0,
				11.55,
				11.55,
				0.61,
				-12.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 5.15,
					"enrolment": 663,
					"ligo": 1,
					"location": [
						141.455509430076,
						-31.9600785498984
					],
					"name": "Broken Hill High School",
					"playspace": 60.48,
					"projections": [
						656,
						663,
						720,
						720,
						655,
						570
					],
					"projections_orig": [
						"656",
						"663",
						"720",
						"720",
						"655",
						"570"
					],
					"projections_percentage": [
						-1.06,
						0,
						8.6,
						8.6,
						-1.21,
						-14.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8105
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 7.34,
					"enrolment": 480,
					"ligo": 1,
					"location": [
						141.471929953901,
						-31.9361039154943
					],
					"name": "Willyama High School",
					"playspace": 143.83,
					"projections": [
						585,
						480,
						555,
						555,
						495,
						430
					],
					"projections_orig": [
						"585",
						"480",
						"555",
						"555",
						"495",
						"430"
					],
					"projections_percentage": [
						21.88,
						0,
						15.62,
						15.62,
						3.12,
						-10.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8491
				}
			],
			"uid": 20002
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 159
			},
			"enrolment": 2357,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Lake Illawarra Secondary",
			"playspace": 72.87,
			"projections": [
				2357,
				2555,
				2615,
				2630,
				2665
			],
			"projections_percentage": [
				0,
				8.4,
				10.95,
				11.58,
				13.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 54
					},
					"classroomspace": 3.76,
					"enrolment": 947,
					"ligo": 0.74,
					"location": [
						150.785581549329,
						-34.5013173440378
					],
					"name": "Dapto High School",
					"playspace": 85.92,
					"projections": [
						984,
						947,
						1035,
						1065,
						1075,
						1095
					],
					"projections_orig": [
						"984",
						"947",
						"1035",
						"1065",
						"1075",
						"1095"
					],
					"projections_percentage": [
						3.91,
						0,
						9.29,
						12.46,
						13.52,
						15.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8204
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 6.17,
					"enrolment": 608,
					"ligo": 0.84,
					"location": [
						150.804532573775,
						-34.4937545683395
					],
					"name": "Kanahooka High School",
					"playspace": 86.01,
					"projections": [
						641,
						608,
						660,
						670,
						670,
						685
					],
					"projections_orig": [
						"641",
						"608",
						"660",
						"670",
						"670",
						"685"
					],
					"projections_percentage": [
						5.43,
						0,
						8.55,
						10.2,
						10.2,
						12.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8489
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 46
					},
					"classroomspace": 4.18,
					"enrolment": 802,
					"ligo": 0.77,
					"location": [
						150.773674381241,
						-34.5757331672151
					],
					"name": "Albion Park High School",
					"playspace": 46.69,
					"projections": [
						952,
						802,
						860,
						880,
						885,
						885
					],
					"projections_orig": [
						"952",
						"802",
						"860",
						"880",
						"885",
						"885"
					],
					"projections_percentage": [
						18.7,
						0,
						7.23,
						9.73,
						10.35,
						10.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8586
				}
			],
			"uid": 20003
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 305
			},
			"enrolment": 4772,
			"level": "Secondary",
			"ligo": 0.68,
			"name": "Wollongong North",
			"playspace": 89.05,
			"projections": [
				4772,
				5085,
				5310,
				5460,
				5540
			],
			"projections_percentage": [
				0,
				6.56,
				11.27,
				14.42,
				16.09
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 48
					},
					"classroomspace": 3.14,
					"enrolment": 1160,
					"ligo": 0.33,
					"location": [
						150.889201987508,
						-34.4057672054305
					],
					"name": "Wollongong High School of the Performing Arts",
					"playspace": 44.69,
					"projections": [
						980,
						1160,
						1245,
						1310,
						1355,
						1375
					],
					"projections_orig": [
						"980",
						"1160",
						"1245",
						"1310",
						"1355",
						"1375"
					],
					"projections_percentage": [
						-15.52,
						0,
						7.33,
						12.93,
						16.81,
						18.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8143
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 8.6,
					"enrolment": 354,
					"ligo": 0.8,
					"location": [
						150.910803839896,
						-34.3762296105041
					],
					"name": "Corrimal High School",
					"playspace": 285.69,
					"projections": [
						496,
						354,
						455,
						475,
						485,
						490
					],
					"projections_orig": [
						"496",
						"354",
						"455",
						"475",
						"485",
						"490"
					],
					"projections_percentage": [
						40.11,
						0,
						28.53,
						34.18,
						37.01,
						38.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 4.56,
					"enrolment": 664,
					"ligo": 0.64,
					"location": [
						150.908844216827,
						-34.3447319731173
					],
					"name": "Woonona High School",
					"playspace": 86.11,
					"projections": [
						654,
						664,
						655,
						695,
						710,
						720
					],
					"projections_orig": [
						"654",
						"664",
						"655",
						"695",
						"710",
						"720"
					],
					"projections_percentage": [
						-1.51,
						0,
						-1.36,
						4.67,
						6.93,
						8.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8410
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 60
					},
					"classroomspace": 4.11,
					"enrolment": 962,
					"ligo": 0.6,
					"location": [
						150.888659028548,
						-34.4060499844733
					],
					"name": "Keira High School",
					"playspace": 51.85,
					"projections": [
						958,
						962,
						1050,
						1105,
						1140,
						1160
					],
					"projections_orig": [
						"958",
						"962",
						"1050",
						"1105",
						"1140",
						"1160"
					],
					"projections_percentage": [
						-0.42,
						0,
						9.15,
						14.86,
						18.5,
						20.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8541
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 4.31,
					"enrolment": 743,
					"ligo": 1,
					"location": [
						150.895789188923,
						-34.4185884250679
					],
					"name": "Smiths Hill High School",
					"playspace": 23.94,
					"projections": [
						759,
						743,
						745,
						745,
						745,
						745
					],
					"projections_orig": [
						"759",
						"743",
						"745",
						"745",
						"745",
						"745"
					],
					"projections_percentage": [
						2.15,
						0,
						0.27,
						0.27,
						0.27,
						0.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8542
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 4.2,
					"enrolment": 889,
					"ligo": 0.74,
					"location": [
						150.921880603601,
						-34.3363280131164
					],
					"name": "Bulli High School",
					"playspace": 42.02,
					"projections": [
						815,
						889,
						935,
						980,
						1025,
						1050
					],
					"projections_orig": [
						"815",
						"889",
						"935",
						"980",
						"1025",
						"1050"
					],
					"projections_percentage": [
						-8.32,
						0,
						5.17,
						10.24,
						15.3,
						18.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8878
				}
			],
			"uid": 20004
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 201
			},
			"enrolment": 2549,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Wollongong South",
			"playspace": 79.55,
			"projections": [
				2550,
				2870,
				2990,
				3075,
				3110
			],
			"projections_percentage": [
				0,
				12.55,
				17.25,
				20.59,
				21.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 4.92,
					"enrolment": 707,
					"ligo": 0.62,
					"location": [
						150.852720200109,
						-34.4798550580354
					],
					"name": "Illawarra Sports High School",
					"playspace": 62.54,
					"projections": [
						902,
						707,
						770,
						800,
						820,
						830
					],
					"projections_orig": [
						"902",
						"707",
						"770",
						"800",
						"820",
						"830"
					],
					"projections_percentage": [
						27.58,
						0,
						8.91,
						13.15,
						15.98,
						17.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8205
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 11.31,
					"enrolment": 252,
					"ligo": 1,
					"location": [
						150.913492460957,
						-34.4900060058424
					],
					"name": "Five Islands Secondary College",
					"playspace": 94.49,
					"projections": [
						307,
						253,
						315,
						325,
						335,
						335
					],
					"projections_orig": [
						"307",
						"253",
						"315",
						"325",
						"335",
						"335"
					],
					"projections_percentage": [
						21.34,
						0,
						24.51,
						28.46,
						32.41,
						32.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8373
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 49
					},
					"classroomspace": 3.65,
					"enrolment": 964,
					"ligo": 0.74,
					"location": [
						150.856278745131,
						-34.4397576125448
					],
					"name": "Figtree High School",
					"playspace": 59.12,
					"projections": [
						1086,
						964,
						1120,
						1175,
						1215,
						1230
					],
					"projections_orig": [
						"1086",
						"964",
						"1120",
						"1175",
						"1215",
						"1230"
					],
					"projections_percentage": [
						12.66,
						0,
						16.18,
						21.89,
						26.04,
						27.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8449
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 58
					},
					"classroomspace": 5.61,
					"enrolment": 626,
					"ligo": 0.76,
					"location": [
						150.877479407304,
						-34.4800585262436
					],
					"name": "Warrawong High School",
					"playspace": 102.03,
					"projections": [
						550,
						626,
						665,
						690,
						705,
						715
					],
					"projections_orig": [
						"550",
						"626",
						"665",
						"690",
						"705",
						"715"
					],
					"projections_percentage": [
						-12.14,
						0,
						6.23,
						10.22,
						12.62,
						14.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8480
				}
			],
			"uid": 20005
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 161
			},
			"enrolment": 2631,
			"level": "Secondary",
			"ligo": 0.77,
			"name": "Oak Flats",
			"playspace": 53.3,
			"projections": [
				2631,
				2685,
				2795,
				2795,
				2850
			],
			"projections_percentage": [
				0,
				2.05,
				6.23,
				6.23,
				8.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 60
					},
					"classroomspace": 3.08,
					"enrolment": 1237,
					"ligo": 0.79,
					"location": [
						150.858254269675,
						-34.5650355688858
					],
					"name": "Warilla High School",
					"playspace": 21.84,
					"projections": [
						1220,
						1237,
						1190,
						1245,
						1240,
						1260
					],
					"projections_orig": [
						"1220",
						"1237",
						"1190",
						"1245",
						"1240",
						"1260"
					],
					"projections_percentage": [
						-1.37,
						0,
						-3.8,
						0.65,
						0.24,
						1.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8418
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 6.04,
					"enrolment": 596,
					"ligo": 0.8,
					"location": [
						150.851818513684,
						-34.5407336794093
					],
					"name": "Lake Illawarra High School",
					"playspace": 70.18,
					"projections": [
						728,
						596,
						655,
						685,
						690,
						705
					],
					"projections_orig": [
						"728",
						"596",
						"655",
						"685",
						"690",
						"705"
					],
					"projections_percentage": [
						22.15,
						0,
						9.9,
						14.93,
						15.77,
						18.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8474
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 44
					},
					"classroomspace": 4.18,
					"enrolment": 798,
					"ligo": 0.73,
					"location": [
						150.832005263296,
						-34.5599228231219
					],
					"name": "Oak Flats High School",
					"playspace": 67.88,
					"projections": [
						824,
						798,
						840,
						865,
						865,
						885
					],
					"projections_orig": [
						"824",
						"798",
						"840",
						"865",
						"865",
						"885"
					],
					"projections_percentage": [
						3.26,
						0,
						5.26,
						8.4,
						8.4,
						10.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8906
				}
			],
			"uid": 20006
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 241
			},
			"enrolment": 3868,
			"level": "Secondary",
			"ligo": 0.63,
			"name": "Sydney Secondary",
			"playspace": 27.97,
			"projections": [
				3868,
				4175,
				4585,
				4730,
				4765
			],
			"projections_percentage": [
				0,
				7.94,
				18.54,
				22.29,
				23.19
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 58
					},
					"classroomspace": 11.94,
					"enrolment": 312,
					"ligo": 0.63,
					"location": [
						151.200688504191,
						-33.9275785951026
					],
					"name": "J J Cahill Memorial High School",
					"playspace": 64.67,
					"projections": [
						360,
						312,
						385,
						465,
						490,
						505
					],
					"projections_orig": [
						"360",
						"312",
						"385",
						"465",
						"490",
						"505"
					],
					"projections_percentage": [
						15.38,
						0,
						23.4,
						49.04,
						57.05,
						61.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8263
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 37
					},
					"classroomspace": 3.5,
					"enrolment": 773,
					"ligo": 0.54,
					"location": [
						151.169230477324,
						-33.8581850892366
					],
					"name": "Sydney Secondary College Balmain Campus",
					"playspace": 27.89,
					"projections": [
						613,
						773,
						990,
						1055,
						1100,
						1095
					],
					"projections_orig": [
						"613",
						"773",
						"990",
						"1055",
						"1100",
						"1095"
					],
					"projections_percentage": [
						-20.7,
						0,
						28.07,
						36.48,
						42.3,
						41.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8484
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.19,
					"enrolment": 950,
					"ligo": 0.36,
					"location": [
						151.158667114161,
						-33.8795888427483
					],
					"name": "Sydney Secondary College Leichhardt Campus",
					"playspace": 7.39,
					"projections": [
						730,
						950,
						800,
						905,
						940,
						910
					],
					"projections_orig": [
						"730",
						"950",
						"800",
						"905",
						"940",
						"910"
					],
					"projections_percentage": [
						-23.16,
						0,
						-15.79,
						-4.74,
						-1.05,
						-4.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8507
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 37
					},
					"classroomspace": 3.71,
					"enrolment": 700,
					"ligo": 0.57,
					"location": [
						151.188013233796,
						-33.8756346209741
					],
					"name": "Sydney Secondary College Blackwattle Bay Campus",
					"playspace": 27.92,
					"projections": [
						657,
						700,
						825,
						960,
						980,
						990
					],
					"projections_orig": [
						"657",
						"700",
						"825",
						"960",
						"980",
						"990"
					],
					"projections_percentage": [
						-6.14,
						0,
						17.86,
						37.14,
						40,
						41.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8539
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 3.33,
					"enrolment": 1133,
					"ligo": 0.7,
					"location": [
						151.275456977484,
						-33.8787414185695
					],
					"name": "Rose Bay Secondary College",
					"playspace": 11.96,
					"projections": [
						969,
						1133,
						1175,
						1200,
						1220,
						1265
					],
					"projections_orig": [
						"969",
						"1133",
						"1175",
						"1200",
						"1220",
						"1265"
					],
					"projections_percentage": [
						-14.47,
						0,
						3.71,
						5.91,
						7.68,
						11.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8555
				}
			],
			"uid": 20007
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 214
			},
			"enrolment": 3414,
			"level": "Secondary",
			"ligo": 1,
			"name": "Sydney Specialist Secondary",
			"playspace": 17.74,
			"projections": [
				3414,
				3530,
				3620,
				3645,
				3675
			],
			"projections_percentage": [
				0,
				3.4,
				6.03,
				6.77,
				7.64
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 58
					},
					"classroomspace": 2.96,
					"enrolment": 1208,
					"ligo": 1,
					"location": [
						151.218306488928,
						-33.8927839368237
					],
					"name": "Sydney Boys High School",
					"playspace": 8.42,
					"projections": [
						1184,
						1208,
						1210,
						1210,
						1210,
						1210
					],
					"projections_orig": [
						"1184",
						"1208",
						"1210",
						"1210",
						"1210",
						"1210"
					],
					"projections_percentage": [
						-1.99,
						0,
						0.17,
						0.17,
						0.17,
						0.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8137
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.31,
					"enrolment": 936,
					"ligo": 1,
					"location": [
						151.220506645579,
						-33.8944049217764
					],
					"name": "Sydney Girls High School",
					"playspace": 19.75,
					"projections": [
						939,
						936,
						935,
						935,
						935,
						935
					],
					"projections_orig": [
						"939",
						"936",
						"935",
						"935",
						"935",
						"935"
					],
					"projections_percentage": [
						0.32,
						0,
						-0.11,
						-0.11,
						-0.11,
						-0.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8138
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 5.53,
					"enrolment": 156,
					"ligo": 1,
					"location": [
						151.21411255871,
						-33.8629871867641
					],
					"name": "Conservatorium High School",
					"playspace": 21.13,
					"projections": [
						159,
						156,
						175,
						210,
						220,
						235
					],
					"projections_orig": [
						"159",
						"156",
						"175",
						"210",
						"220",
						"235"
					],
					"projections_percentage": [
						1.92,
						0,
						12.18,
						34.62,
						41.03,
						50.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8147
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 9.62,
					"enrolment": 171,
					"ligo": 1,
					"location": [
						151.205608448478,
						-33.8887012865309
					],
					"name": "Cleveland Street Intensive English High School",
					"playspace": 11.61,
					"projections": [
						196,
						171,
						265,
						320,
						335,
						350
					],
					"projections_orig": [
						"196",
						"171",
						"265",
						"320",
						"335",
						"350"
					],
					"projections_percentage": [
						14.62,
						0,
						54.97,
						87.13,
						95.91,
						104.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8288
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 4,
					"enrolment": 943,
					"ligo": 1,
					"location": [
						151.15311425248,
						-33.8891124089209
					],
					"name": "Fort Street High School",
					"playspace": 27.81,
					"projections": [
						930,
						943,
						945,
						945,
						945,
						945
					],
					"projections_orig": [
						"930",
						"943",
						"945",
						"945",
						"945",
						"945"
					],
					"projections_percentage": [
						-1.38,
						0,
						0.21,
						0.21,
						0.21,
						0.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8504
				}
			],
			"uid": 20008
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 223
			},
			"enrolment": 2414,
			"level": "Secondary",
			"ligo": 0.46,
			"name": "Randwick Secondary",
			"playspace": 51.21,
			"projections": [
				2414,
				3545,
				3970,
				4100,
				4200
			],
			"projections_percentage": [
				0,
				46.85,
				64.46,
				69.84,
				73.99
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 54
					},
					"classroomspace": 5.73,
					"enrolment": 640,
					"ligo": 0.41,
					"location": [
						151.23860305479,
						-33.9247664276705
					],
					"name": "Randwick Boys High School",
					"playspace": 32.95,
					"projections": [
						642,
						640,
						1000,
						1090,
						1125,
						1165
					],
					"projections_orig": [
						"642",
						"640",
						"1000",
						"1090",
						"1125",
						"1165"
					],
					"projections_percentage": [
						0.31,
						0,
						56.25,
						70.31,
						75.78,
						82.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8161
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.74,
					"enrolment": 997,
					"ligo": 0.38,
					"location": [
						151.239741992317,
						-33.9214223262121
					],
					"name": "Randwick Girls High School",
					"playspace": 20.33,
					"projections": [
						900,
						997,
						1410,
						1540,
						1585,
						1650
					],
					"projections_orig": [
						"900",
						"997",
						"1410",
						"1540",
						"1585",
						"1650"
					],
					"projections_percentage": [
						-9.73,
						0,
						41.42,
						54.46,
						58.98,
						65.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8220
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 12.39,
					"enrolment": 259,
					"ligo": 0.59,
					"location": [
						151.245272577184,
						-33.9650293579162
					],
					"name": "Matraville Sports High School",
					"playspace": 98.06,
					"projections": [
						300,
						259,
						360,
						445,
						470,
						465
					],
					"projections_orig": [
						"300",
						"259",
						"360",
						"445",
						"470",
						"465"
					],
					"projections_percentage": [
						15.83,
						0,
						39,
						71.81,
						81.47,
						79.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8249
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 7.46,
					"enrolment": 518,
					"ligo": 0.44,
					"location": [
						151.234894213603,
						-33.9450594274324
					],
					"name": "South Sydney High School",
					"playspace": 53.49,
					"projections": [
						676,
						518,
						775,
						895,
						920,
						920
					],
					"projections_orig": [
						"676",
						"518",
						"775",
						"895",
						"920",
						"920"
					],
					"projections_percentage": [
						30.5,
						0,
						49.61,
						72.78,
						77.61,
						77.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8545
				}
			],
			"uid": 20009
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 186
			},
			"enrolment": 3137,
			"level": "Secondary",
			"ligo": 0.38,
			"name": "Marrickville Secondary",
			"playspace": 31.43,
			"projections": [
				3137,
				3130,
				3465,
				3770,
				4000
			],
			"projections_percentage": [
				0,
				-0.22,
				10.46,
				20.18,
				27.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 2.78,
					"enrolment": 959,
					"ligo": 0.41,
					"location": [
						151.161909185031,
						-33.9194212366912
					],
					"name": "Tempe High School",
					"playspace": 28.6,
					"projections": [
						914,
						959,
						1035,
						1190,
						1325,
						1425
					],
					"projections_orig": [
						"914",
						"959",
						"1035",
						"1190",
						"1325",
						"1425"
					],
					"projections_percentage": [
						-4.69,
						0,
						7.92,
						24.09,
						38.16,
						48.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8506
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 45
					},
					"classroomspace": 3.35,
					"enrolment": 1050,
					"ligo": 0.41,
					"location": [
						151.177927968251,
						-33.8992682088216
					],
					"name": "Newtown High School of Performing Arts",
					"playspace": 17.93,
					"projections": [
						1007,
						1050,
						955,
						1015,
						1065,
						1120
					],
					"projections_orig": [
						"1007",
						"1050",
						"955",
						"1015",
						"1065",
						"1120"
					],
					"projections_percentage": [
						-4.1,
						0,
						-9.05,
						-3.33,
						1.43,
						6.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8530
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 10.15,
					"enrolment": 353,
					"ligo": 0.48,
					"location": [
						151.156340125709,
						-33.906652783001
					],
					"name": "Marrickville High School",
					"playspace": 61.14,
					"projections": [
						323,
						353,
						365,
						380,
						405,
						420
					],
					"projections_orig": [
						"323",
						"353",
						"365",
						"380",
						"405",
						"420"
					],
					"projections_percentage": [
						-8.5,
						0,
						3.4,
						7.65,
						14.73,
						18.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8540
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 3.38,
					"enrolment": 775,
					"ligo": 0.21,
					"location": [
						151.14483650357,
						-33.9032713525243
					],
					"name": "Dulwich High School of Visual Arts and Design",
					"playspace": 18.06,
					"projections": [
						624,
						775,
						775,
						880,
						975,
						1035
					],
					"projections_orig": [
						"624",
						"775",
						"775",
						"880",
						"975",
						"1035"
					],
					"projections_percentage": [
						-19.48,
						0,
						0,
						13.55,
						25.81,
						33.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8833
				}
			],
			"uid": 20010
		},
		{
			"classrooms": {
				"demountable": 25,
				"permanent": 293
			},
			"enrolment": 5800,
			"level": "Secondary",
			"ligo": 0.58,
			"name": "Strathfield Secondary",
			"playspace": 21.02,
			"projections": [
				5800,
				6500,
				7870,
				9035,
				9800
			],
			"projections_percentage": [
				0,
				12.07,
				35.69,
				55.78,
				68.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 49
					},
					"classroomspace": 3.26,
					"enrolment": 1159,
					"ligo": 0.56,
					"location": [
						151.077719776134,
						-33.8666185742818
					],
					"name": "Homebush Boys High School",
					"playspace": 15.96,
					"projections": [
						1314,
						1159,
						1185,
						1535,
						1880,
						2080
					],
					"projections_orig": [
						"1314",
						"1159",
						"1185",
						"1535",
						"1880",
						"2080"
					],
					"projections_percentage": [
						13.37,
						0,
						2.24,
						32.44,
						62.21,
						79.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8151
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 53
					},
					"classroomspace": 3.04,
					"enrolment": 1116,
					"ligo": 0.59,
					"location": [
						151.113084533084,
						-33.8759459776366
					],
					"name": "Burwood Girls High School",
					"playspace": 15.79,
					"projections": [
						1108,
						1116,
						1210,
						1405,
						1595,
						1785
					],
					"projections_orig": [
						"1108",
						"1116",
						"1210",
						"1405",
						"1595",
						"1785"
					],
					"projections_percentage": [
						-0.72,
						0,
						8.42,
						25.9,
						42.92,
						59.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8152
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 3.42,
					"enrolment": 1130,
					"ligo": 0.62,
					"location": [
						151.085227092165,
						-33.873106163966
					],
					"name": "Strathfield Girls High School",
					"playspace": 14.11,
					"projections": [
						1135,
						1130,
						1305,
						1600,
						1790,
						1885
					],
					"projections_orig": [
						"1135",
						"1130",
						"1305",
						"1600",
						"1790",
						"1885"
					],
					"projections_percentage": [
						0.44,
						0,
						15.49,
						41.59,
						58.41,
						66.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8169
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 4.56,
					"enrolment": 557,
					"ligo": 0.22,
					"location": [
						151.071879233123,
						-33.8855666852136
					],
					"name": "Strathfield South High School",
					"playspace": 46.2,
					"projections": [
						682,
						557,
						715,
						795,
						860,
						910
					],
					"projections_orig": [
						"682",
						"557",
						"715",
						"795",
						"860",
						"910"
					],
					"projections_percentage": [
						22.44,
						0,
						28.37,
						42.73,
						54.4,
						63.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8252
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 45
					},
					"classroomspace": 3.01,
					"enrolment": 1137,
					"ligo": 0.72,
					"location": [
						151.108829947127,
						-33.8646867339216
					],
					"name": "Concord High School",
					"playspace": 18.33,
					"projections": [
						852,
						1137,
						1310,
						1650,
						1920,
						2055
					],
					"projections_orig": [
						"852",
						"1137",
						"1310",
						"1650",
						"1920",
						"2055"
					],
					"projections_percentage": [
						-25.07,
						0,
						15.22,
						45.12,
						68.87,
						80.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8535
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 3.42,
					"enrolment": 701,
					"ligo": 0.34,
					"location": [
						151.1289155085,
						-33.8902041783211
					],
					"name": "Ashfield Boys High School",
					"playspace": 15.73,
					"projections": [
						705,
						701,
						775,
						885,
						990,
						1085
					],
					"projections_orig": [
						"705",
						"701",
						"775",
						"885",
						"990",
						"1085"
					],
					"projections_percentage": [
						0.57,
						0,
						10.56,
						26.25,
						41.23,
						54.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8832
				}
			],
			"uid": 20011
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 200
			},
			"enrolment": 3407,
			"level": "Secondary",
			"ligo": 0.55,
			"name": "Ryde Secondary",
			"playspace": 42.89,
			"projections": [
				3407,
				3755,
				4060,
				4335,
				4535
			],
			"projections_percentage": [
				0,
				10.21,
				19.17,
				27.24,
				33.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.38,
					"enrolment": 619,
					"ligo": 0.48,
					"location": [
						151.146971921999,
						-33.832750176133
					],
					"name": "Hunters Hill High School",
					"playspace": 77.78,
					"projections": [
						562,
						619,
						765,
						795,
						820,
						860
					],
					"projections_orig": [
						"562",
						"619",
						"765",
						"795",
						"820",
						"860"
					],
					"projections_percentage": [
						-9.21,
						0,
						23.59,
						28.43,
						32.47,
						38.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8207
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 4.29,
					"enrolment": 787,
					"ligo": 0.65,
					"location": [
						151.069629305768,
						-33.8037708403054
					],
					"name": "Marsden High School",
					"playspace": 50.9,
					"projections": [
						668,
						787,
						765,
						820,
						890,
						925
					],
					"projections_orig": [
						"668",
						"787",
						"765",
						"820",
						"890",
						"925"
					],
					"projections_percentage": [
						-15.12,
						0,
						-2.8,
						4.19,
						13.09,
						17.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8225
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 48
					},
					"classroomspace": 3.29,
					"enrolment": 952,
					"ligo": 0.51,
					"location": [
						151.141023721512,
						-33.839937829506
					],
					"name": "Riverside Girls High School",
					"playspace": 29.64,
					"projections": [
						947,
						952,
						1025,
						1115,
						1225,
						1285
					],
					"projections_orig": [
						"947",
						"952",
						"1025",
						"1115",
						"1225",
						"1285"
					],
					"projections_percentage": [
						-0.53,
						0,
						7.67,
						17.12,
						28.68,
						34.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8243
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 48
					},
					"classroomspace": 3.47,
					"enrolment": 1049,
					"ligo": 0.55,
					"location": [
						151.117654271069,
						-33.8135014093624
					],
					"name": "Ryde Secondary College",
					"playspace": 13.25,
					"projections": [
						1031,
						1049,
						1200,
						1330,
						1400,
						1465
					],
					"projections_orig": [
						"1031",
						"1049",
						"1200",
						"1330",
						"1400",
						"1465"
					],
					"projections_percentage": [
						-1.72,
						0,
						14.39,
						26.79,
						33.46,
						39.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8415
				}
			],
			"uid": 20012
		},
		{
			"classrooms": {
				"demountable": 53,
				"permanent": 438
			},
			"enrolment": 9440,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Chatswood Secondary",
			"playspace": 16.41,
			"projections": [
				9439,
				11135,
				11600,
				11905,
				12155
			],
			"projections_percentage": [
				0,
				17.97,
				22.89,
				26.13,
				28.77
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 3.46,
					"enrolment": 927,
					"ligo": 1,
					"location": [
						151.207577526963,
						-33.8288050762772
					],
					"name": "North Sydney Boys High School",
					"playspace": 15.2,
					"projections": [
						912,
						927,
						925,
						925,
						925,
						925
					],
					"projections_orig": [
						"912",
						"927",
						"925",
						"925",
						"925",
						"925"
					],
					"projections_percentage": [
						-1.62,
						0,
						-0.22,
						-0.22,
						-0.22,
						-0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8132
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 3.21,
					"enrolment": 923,
					"ligo": 1,
					"location": [
						151.203043679436,
						-33.8296142368394
					],
					"name": "North Sydney Girls High School",
					"playspace": 8.8,
					"projections": [
						930,
						923,
						925,
						925,
						925,
						925
					],
					"projections_orig": [
						"930",
						"923",
						"925",
						"925",
						"925",
						"925"
					],
					"projections_percentage": [
						0.76,
						0,
						0.22,
						0.22,
						0.22,
						0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8133
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 32
					},
					"classroomspace": 2.6,
					"enrolment": 968,
					"ligo": 0.49,
					"location": [
						151.199698636661,
						-33.8034673947306
					],
					"name": "Willoughby Girls High School",
					"playspace": 9.2,
					"projections": [
						925,
						968,
						1200,
						1230,
						1260,
						1305
					],
					"projections_orig": [
						"925",
						"968",
						"1200",
						"1230",
						"1260",
						"1305"
					],
					"projections_percentage": [
						-4.44,
						0,
						23.97,
						27.07,
						30.17,
						34.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8159
				},
				{
					"classrooms": {
						"demountable": 22,
						"permanent": 60
					},
					"classroomspace": 4,
					"enrolment": 1397,
					"ligo": 0.65,
					"location": [
						151.175383309832,
						-33.7989162504694
					],
					"name": "Chatswood High School",
					"playspace": 26.05,
					"projections": [
						1263,
						1397,
						1790,
						1860,
						1930,
						1970
					],
					"projections_orig": [
						"1263",
						"1397",
						"1790",
						"1860",
						"1930",
						"1970"
					],
					"projections_percentage": [
						-9.59,
						0,
						28.13,
						33.14,
						38.15,
						41.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8232
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 2.75,
					"enrolment": 1054,
					"ligo": 0.68,
					"location": [
						151.244044386698,
						-33.8297364378348
					],
					"name": "Mosman High School",
					"playspace": 5.27,
					"projections": [
						887,
						1054,
						1155,
						1180,
						1155,
						1170
					],
					"projections_orig": [
						"887",
						"1054",
						"1155",
						"1180",
						"1155",
						"1170"
					],
					"projections_percentage": [
						-15.84,
						0,
						9.58,
						11.95,
						9.58,
						11.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8326
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.65,
					"enrolment": 947,
					"ligo": 0.67,
					"location": [
						151.167377186253,
						-33.7400811143014
					],
					"name": "St Ives High School",
					"playspace": 44.48,
					"projections": [
						819,
						947,
						1115,
						1195,
						1245,
						1270
					],
					"projections_orig": [
						"819",
						"947",
						"1115",
						"1195",
						"1245",
						"1270"
					],
					"projections_percentage": [
						-13.52,
						0,
						17.74,
						26.19,
						31.47,
						34.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8400
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 54
					},
					"classroomspace": 3.2,
					"enrolment": 1256,
					"ligo": 0.77,
					"location": [
						151.113062400851,
						-33.7563852624068
					],
					"name": "Turramurra High School",
					"playspace": 21.09,
					"projections": [
						1199,
						1256,
						1405,
						1500,
						1535,
						1565
					],
					"projections_orig": [
						"1199",
						"1256",
						"1405",
						"1500",
						"1535",
						"1565"
					],
					"projections_percentage": [
						-4.54,
						0,
						11.86,
						19.43,
						22.21,
						24.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8435
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 62
					},
					"classroomspace": 2.8,
					"enrolment": 1598,
					"ligo": 0.85,
					"location": [
						151.174478487807,
						-33.7555601678891
					],
					"name": "Killara High School",
					"playspace": 14.72,
					"projections": [
						1527,
						1597,
						1815,
						1920,
						2035,
						2085
					],
					"projections_orig": [
						"1527",
						"1597",
						"1815",
						"1920",
						"2035",
						"2085"
					],
					"projections_percentage": [
						-4.38,
						0,
						13.65,
						20.23,
						27.43,
						30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8457
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.68,
					"enrolment": 370,
					"ligo": 0.61,
					"location": [
						151.203253693954,
						-33.8313043057769
					],
					"name": "Cammeraygal High School",
					"playspace": 2.89,
					"projections": [
						0,
						370,
						805,
						865,
						895,
						940
					],
					"projections_orig": [
						"0",
						"370",
						"805",
						"865",
						"895",
						"940"
					],
					"projections_percentage": [
						-100,
						0,
						117.57,
						133.78,
						141.89,
						154.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8910
				}
			],
			"uid": 20013
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 555
			},
			"enrolment": 9258,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Northern Beaches Secondary",
			"playspace": 45.23,
			"projections": [
				9258,
				9490,
				9730,
				10060,
				10220
			],
			"projections_percentage": [
				0,
				2.51,
				5.1,
				8.66,
				10.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 3.67,
					"enrolment": 853,
					"ligo": 0.4,
					"location": [
						151.230709494951,
						-33.7494939999734
					],
					"name": "The Forest High School",
					"playspace": 54.91,
					"projections": [
						749,
						853,
						845,
						855,
						885,
						910
					],
					"projections_orig": [
						"749",
						"853",
						"845",
						"855",
						"885",
						"910"
					],
					"projections_percentage": [
						-12.19,
						0,
						-0.94,
						0.23,
						3.75,
						6.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8372
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 3.11,
					"enrolment": 1046,
					"ligo": 0.62,
					"location": [
						151.303841034416,
						-33.6689861602621
					],
					"name": "Pittwater High School",
					"playspace": 45.23,
					"projections": [
						927,
						1046,
						1030,
						1125,
						1215,
						1245
					],
					"projections_orig": [
						"927",
						"1046",
						"1030",
						"1125",
						"1215",
						"1245"
					],
					"projections_percentage": [
						-11.38,
						0,
						-1.53,
						7.55,
						16.16,
						19.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8379
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.5,
					"enrolment": 910,
					"ligo": 0.57,
					"location": [
						151.21651059955,
						-33.7719181532549
					],
					"name": "Killarney Heights High School",
					"playspace": 24.3,
					"projections": [
						953,
						911,
						1030,
						1065,
						1090,
						1110
					],
					"projections_orig": [
						"953",
						"911",
						"1030",
						"1065",
						"1090",
						"1110"
					],
					"projections_percentage": [
						4.61,
						0,
						13.06,
						16.9,
						19.65,
						21.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8422
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 4.93,
					"enrolment": 717,
					"ligo": 0.89,
					"location": [
						151.335113055556,
						-33.632148696336
					],
					"name": "Barrenjoey High School",
					"playspace": 39.38,
					"projections": [
						642,
						717,
						660,
						680,
						705,
						730
					],
					"projections_orig": [
						"642",
						"717",
						"660",
						"680",
						"705",
						"730"
					],
					"projections_percentage": [
						-10.46,
						0,
						-7.95,
						-5.16,
						-1.67,
						1.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8454
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.34,
					"enrolment": 850,
					"ligo": 0.59,
					"location": [
						151.204323487698,
						-33.7441301478641
					],
					"name": "Davidson High School",
					"playspace": 45.39,
					"projections": [
						772,
						851,
						900,
						945,
						1010,
						1060
					],
					"projections_orig": [
						"772",
						"851",
						"900",
						"945",
						"1010",
						"1060"
					],
					"projections_percentage": [
						-9.28,
						0,
						5.76,
						11.05,
						18.68,
						24.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8479
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 60
					},
					"classroomspace": 7.49,
					"enrolment": 536,
					"ligo": 0.9,
					"location": [
						151.282908132875,
						-33.7374270898842
					],
					"name": "Northern Beaches Secondary College Cromer Campus",
					"playspace": 76.78,
					"projections": [
						721,
						535,
						650,
						660,
						680,
						690
					],
					"projections_orig": [
						"721",
						"535",
						"650",
						"660",
						"680",
						"690"
					],
					"projections_percentage": [
						34.77,
						0,
						21.5,
						23.36,
						27.1,
						28.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8511
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 4.36,
					"enrolment": 809,
					"ligo": 0.6,
					"location": [
						151.297538644626,
						-33.6998746635036
					],
					"name": "Narrabeen Sports High School",
					"playspace": 68.42,
					"projections": [
						384,
						808,
						860,
						910,
						950,
						950
					],
					"projections_orig": [
						"384",
						"808",
						"860",
						"910",
						"950",
						"950"
					],
					"projections_percentage": [
						-52.48,
						0,
						6.44,
						12.62,
						17.57,
						17.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8512
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 4,
					"enrolment": 788,
					"ligo": 1,
					"location": [
						151.280812082538,
						-33.7635690877234
					],
					"name": "Northern Beaches Secondary College Manly Campus",
					"playspace": 60.25,
					"projections": [
						797,
						788,
						790,
						790,
						790,
						790
					],
					"projections_orig": [
						"797",
						"788",
						"790",
						"790",
						"790",
						"790"
					],
					"projections_percentage": [
						1.14,
						0,
						0.25,
						0.25,
						0.25,
						0.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8567
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 4.08,
					"enrolment": 622,
					"ligo": 1,
					"location": [
						151.28049654696,
						-33.7685197940452
					],
					"name": "Northern Beaches Secondary College Freshwater Senior Campus",
					"playspace": 62.78,
					"projections": [
						643,
						622,
						680,
						675,
						675,
						665
					],
					"projections_orig": [
						"643",
						"622",
						"680",
						"675",
						"675",
						"665"
					],
					"projections_percentage": [
						3.38,
						0,
						9.32,
						8.52,
						8.52,
						6.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8568
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 52
					},
					"classroomspace": 2.92,
					"enrolment": 1312,
					"ligo": 1,
					"location": [
						151.271638447539,
						-33.7814287471044
					],
					"name": "Northern Beaches Secondary College Mackellar Girls Campus",
					"playspace": 10.48,
					"projections": [
						1208,
						1312,
						1290,
						1275,
						1305,
						1305
					],
					"projections_orig": [
						"1208",
						"1312",
						"1290",
						"1275",
						"1305",
						"1305"
					],
					"projections_percentage": [
						-7.93,
						0,
						-1.68,
						-2.82,
						-0.53,
						-0.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8831
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 3.38,
					"enrolment": 815,
					"ligo": 1,
					"location": [
						151.255199410975,
						-33.7966281210235
					],
					"name": "Northern Beaches Secondary College Balgowlah Boys Campus",
					"playspace": 9.65,
					"projections": [
						534,
						815,
						755,
						750,
						755,
						765
					],
					"projections_orig": [
						"534",
						"815",
						"755",
						"750",
						"755",
						"765"
					],
					"projections_percentage": [
						-34.48,
						0,
						-7.36,
						-7.98,
						-7.36,
						-6.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8851
				}
			],
			"uid": 20014
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 211
			},
			"enrolment": 3526,
			"level": "Secondary",
			"ligo": 0.73,
			"name": "Ku-Ring-Gai Secondary",
			"playspace": 49.93,
			"projections": [
				3526,
				3755,
				4025,
				4130,
				4190
			],
			"projections_percentage": [
				0,
				6.49,
				14.15,
				17.13,
				18.83
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 44
					},
					"classroomspace": 3.69,
					"enrolment": 733,
					"ligo": 1,
					"location": [
						151.101452907121,
						-33.7058285855033
					],
					"name": "Hornsby Girls High School",
					"playspace": 24.8,
					"projections": [
						729,
						733,
						735,
						735,
						735,
						735
					],
					"projections_orig": [
						"729",
						"733",
						"735",
						"735",
						"735",
						"735"
					],
					"projections_percentage": [
						-0.55,
						0,
						0.27,
						0.27,
						0.27,
						0.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8120
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 3.99,
					"enrolment": 755,
					"ligo": 1,
					"location": [
						151.100621663901,
						-33.7228386635394
					],
					"name": "Normanhurst Boys High School",
					"playspace": 58.51,
					"projections": [
						733,
						755,
						755,
						755,
						755,
						755
					],
					"projections_orig": [
						"733",
						"755",
						"755",
						"755",
						"755",
						"755"
					],
					"projections_percentage": [
						-2.91,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8211
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 37
					},
					"classroomspace": 3.92,
					"enrolment": 833,
					"ligo": 0.54,
					"location": [
						151.112055581737,
						-33.6906835283493
					],
					"name": "Asquith Girls High School",
					"playspace": 33.8,
					"projections": [
						952,
						833,
						985,
						1125,
						1185,
						1220
					],
					"projections_orig": [
						"952",
						"833",
						"985",
						"1125",
						"1185",
						"1220"
					],
					"projections_percentage": [
						14.29,
						0,
						18.25,
						35.05,
						42.26,
						46.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8222
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 38
					},
					"classroomspace": 4.26,
					"enrolment": 608,
					"ligo": 0.54,
					"location": [
						151.103644812999,
						-33.6922378899317
					],
					"name": "Asquith Boys High School",
					"playspace": 46.28,
					"projections": [
						586,
						608,
						635,
						735,
						765,
						775
					],
					"projections_orig": [
						"586",
						"608",
						"635",
						"735",
						"765",
						"775"
					],
					"projections_percentage": [
						-3.62,
						0,
						4.44,
						20.89,
						25.82,
						27.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8245
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.01,
					"enrolment": 597,
					"ligo": 0.57,
					"location": [
						151.152269866045,
						-33.6910957923245
					],
					"name": "Ku-ring-gai High School",
					"playspace": 86.24,
					"projections": [
						537,
						597,
						645,
						675,
						690,
						705
					],
					"projections_orig": [
						"537",
						"597",
						"645",
						"675",
						"690",
						"705"
					],
					"projections_percentage": [
						-10.05,
						0,
						8.04,
						13.07,
						15.58,
						18.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8416
				}
			],
			"uid": 20015
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 266
			},
			"enrolment": 4620,
			"level": "Secondary",
			"ligo": 0.56,
			"name": "Sutherland Secondary",
			"playspace": 43.59,
			"projections": [
				4619,
				4535,
				4900,
				5290,
				5485
			],
			"projections_percentage": [
				0,
				-1.82,
				6.08,
				14.53,
				18.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 2.76,
					"enrolment": 1198,
					"ligo": 0.57,
					"location": [
						151.095591293342,
						-34.0334076255913
					],
					"name": "Port Hacking High School",
					"playspace": 42.62,
					"projections": [
						1090,
						1198,
						1155,
						1230,
						1370,
						1440
					],
					"projections_orig": [
						"1090",
						"1198",
						"1155",
						"1230",
						"1370",
						"1440"
					],
					"projections_percentage": [
						-9.02,
						0,
						-3.59,
						2.67,
						14.36,
						20.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8230
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 4.83,
					"enrolment": 625,
					"ligo": 0.4,
					"location": [
						151.082475828839,
						-34.0287545714055
					],
					"name": "Gymea Technology High School",
					"playspace": 66.57,
					"projections": [
						691,
						625,
						660,
						710,
						740,
						760
					],
					"projections_orig": [
						"691",
						"625",
						"660",
						"710",
						"740",
						"760"
					],
					"projections_percentage": [
						10.56,
						0,
						5.6,
						13.6,
						18.4,
						21.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8386
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 69
					},
					"classroomspace": 3.26,
					"enrolment": 1232,
					"ligo": 0.65,
					"location": [
						151.074939917778,
						-34.0437940010131
					],
					"name": "Kirrawee High School",
					"playspace": 23.91,
					"projections": [
						1172,
						1232,
						1100,
						1230,
						1360,
						1400
					],
					"projections_orig": [
						"1172",
						"1232",
						"1100",
						"1230",
						"1360",
						"1400"
					],
					"projections_percentage": [
						-4.87,
						0,
						-10.71,
						-0.16,
						10.39,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8437
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.97,
					"enrolment": 812,
					"ligo": 0.38,
					"location": [
						151.104745140298,
						-34.0184229446234
					],
					"name": "Sylvania High School",
					"playspace": 60.83,
					"projections": [
						723,
						812,
						840,
						900,
						945,
						980
					],
					"projections_orig": [
						"723",
						"812",
						"840",
						"900",
						"945",
						"980"
					],
					"projections_percentage": [
						-10.96,
						0,
						3.45,
						10.84,
						16.38,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8463
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 39
					},
					"classroomspace": 3.77,
					"enrolment": 753,
					"ligo": 0.82,
					"location": [
						151.061031292206,
						-34.0216599001281
					],
					"name": "The Jannali High School",
					"playspace": 24,
					"projections": [
						742,
						752,
						780,
						830,
						875,
						905
					],
					"projections_orig": [
						"742",
						"752",
						"780",
						"830",
						"875",
						"905"
					],
					"projections_percentage": [
						-1.33,
						0,
						3.72,
						10.37,
						16.36,
						20.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8852
				}
			],
			"uid": 20016
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 54
			},
			"enrolment": 1276,
			"level": "Secondary",
			"ligo": 0.4,
			"name": "Menai Secondary",
			"playspace": 32.79,
			"projections": [
				1276,
				1450,
				1500,
				1535,
				1550
			],
			"projections_percentage": [
				0,
				13.64,
				17.55,
				20.3,
				21.47
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 54
					},
					"classroomspace": 2.87,
					"enrolment": 1276,
					"ligo": 0.4,
					"location": [
						151.022821150242,
						-34.0034922144102
					],
					"name": "Menai High School",
					"playspace": 32.79,
					"projections": [
						1183,
						1276,
						1450,
						1500,
						1535,
						1550
					],
					"projections_orig": [
						"1183",
						"1276",
						"1450",
						"1500",
						"1535",
						"1550"
					],
					"projections_percentage": [
						-7.29,
						0,
						13.64,
						17.55,
						20.3,
						21.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8583
				}
			],
			"uid": 20017
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 198
			},
			"enrolment": 3744,
			"level": "Secondary",
			"ligo": 0.63,
			"name": "Caringbah Secondary",
			"playspace": 64.06,
			"projections": [
				3745,
				3860,
				4055,
				4245,
				4350
			],
			"projections_percentage": [
				0,
				3.07,
				8.28,
				13.35,
				16.15
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.35,
					"enrolment": 915,
					"ligo": 1,
					"location": [
						151.121722303011,
						-34.0330835322115
					],
					"name": "Caringbah High School",
					"playspace": 49.2,
					"projections": [
						907,
						915,
						915,
						920,
						925,
						930
					],
					"projections_orig": [
						"907",
						"915",
						"915",
						"920",
						"925",
						"930"
					],
					"projections_percentage": [
						-0.87,
						0,
						0,
						0.55,
						1.09,
						1.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8240
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 2.66,
					"enrolment": 1000,
					"ligo": 0.63,
					"location": [
						151.156815212965,
						-34.0397450385485
					],
					"name": "Cronulla High School",
					"playspace": 47.47,
					"projections": [
						744,
						1000,
						985,
						1035,
						1065,
						1090
					],
					"projections_orig": [
						"744",
						"1000",
						"985",
						"1035",
						"1065",
						"1090"
					],
					"projections_percentage": [
						-25.6,
						0,
						-1.5,
						3.5,
						6.5,
						9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8261
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.12,
					"enrolment": 824,
					"ligo": 0.26,
					"location": [
						151.118409651334,
						-34.0314833739557
					],
					"name": "Endeavour Sports High School",
					"playspace": 106.8,
					"projections": [
						801,
						825,
						795,
						845,
						950,
						990
					],
					"projections_orig": [
						"801",
						"825",
						"795",
						"845",
						"950",
						"990"
					],
					"projections_percentage": [
						-2.91,
						0,
						-3.64,
						2.42,
						15.15,
						20
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8404
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.56,
					"enrolment": 1005,
					"ligo": 0.64,
					"location": [
						151.144404971388,
						-34.0402955150159
					],
					"name": "Woolooware High School",
					"playspace": 52.77,
					"projections": [
						1075,
						1005,
						1165,
						1255,
						1305,
						1340
					],
					"projections_orig": [
						"1075",
						"1005",
						"1165",
						"1255",
						"1305",
						"1340"
					],
					"projections_percentage": [
						6.97,
						0,
						15.92,
						24.88,
						29.85,
						33.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8433
				}
			],
			"uid": 20018
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 113
			},
			"enrolment": 1811,
			"level": "Secondary",
			"ligo": 0.76,
			"name": "Engadine Secondary",
			"playspace": 54.94,
			"projections": [
				1811,
				1970,
				2025,
				2125,
				2205
			],
			"projections_percentage": [
				0,
				8.78,
				11.82,
				17.34,
				21.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 50
					},
					"classroomspace": 4.18,
					"enrolment": 755,
					"ligo": 0.9,
					"location": [
						151.014713218706,
						-34.0813973996484
					],
					"name": "Heathcote High School",
					"playspace": 60.27,
					"projections": [
						832,
						755,
						885,
						915,
						960,
						1000
					],
					"projections_orig": [
						"832",
						"755",
						"885",
						"915",
						"960",
						"1000"
					],
					"projections_percentage": [
						10.2,
						0,
						17.22,
						21.19,
						27.15,
						32.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8246
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 63
					},
					"classroomspace": 3.52,
					"enrolment": 1056,
					"ligo": 0.62,
					"location": [
						151.018592842882,
						-34.0610389431858
					],
					"name": "Engadine High School",
					"playspace": 49.6,
					"projections": [
						990,
						1056,
						1085,
						1110,
						1165,
						1205
					],
					"projections_orig": [
						"990",
						"1056",
						"1085",
						"1110",
						"1165",
						"1205"
					],
					"projections_percentage": [
						-6.25,
						0,
						2.75,
						5.11,
						10.32,
						14.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8432
				}
			],
			"uid": 20019
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 201
			},
			"enrolment": 2576,
			"level": "Secondary",
			"ligo": 0.62,
			"name": "Georges River Secondary",
			"playspace": 42.77,
			"projections": [
				2576,
				2685,
				2955,
				3140,
				3295
			],
			"projections_percentage": [
				0,
				4.23,
				14.71,
				21.89,
				27.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.43,
					"enrolment": 882,
					"ligo": 1,
					"location": [
						151.080211295645,
						-33.9775593320306
					],
					"name": "Georges River College Oatley Senior Campus",
					"playspace": 37.68,
					"projections": [
						968,
						882,
						960,
						1050,
						1130,
						1180
					],
					"projections_orig": [
						"968",
						"882",
						"960",
						"1050",
						"1130",
						"1180"
					],
					"projections_percentage": [
						9.75,
						0,
						8.84,
						19.05,
						28.12,
						33.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8284
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 5.08,
					"enrolment": 703,
					"ligo": 0.4,
					"location": [
						151.057292814597,
						-33.9670617075588
					],
					"name": "Georges River College Peakhurst Campus",
					"playspace": 46.01,
					"projections": [
						621,
						703,
						695,
						745,
						780,
						810
					],
					"projections_orig": [
						"621",
						"703",
						"695",
						"745",
						"780",
						"810"
					],
					"projections_percentage": [
						-11.66,
						0,
						-1.14,
						5.97,
						10.95,
						15.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 8.07,
					"enrolment": 360,
					"ligo": 0.55,
					"location": [
						151.110307433607,
						-33.9621516848667
					],
					"name": "Georges River College Hurstville Boys Campus",
					"playspace": 72.84,
					"projections": [
						326,
						360,
						335,
						385,
						410,
						440
					],
					"projections_orig": [
						"326",
						"360",
						"335",
						"385",
						"410",
						"440"
					],
					"projections_percentage": [
						-9.44,
						0,
						-6.94,
						6.94,
						13.89,
						22.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8813
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 3.84,
					"enrolment": 631,
					"ligo": 0.52,
					"location": [
						151.086625237486,
						-33.964408624469
					],
					"name": "Georges River College Penshurst Girls Campus",
					"playspace": 14.53,
					"projections": [
						692,
						631,
						695,
						775,
						820,
						865
					],
					"projections_orig": [
						"692",
						"631",
						"695",
						"775",
						"820",
						"865"
					],
					"projections_percentage": [
						9.67,
						0,
						10.14,
						22.82,
						29.95,
						37.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8857
				}
			],
			"uid": 20020
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 281
			},
			"enrolment": 4466,
			"level": "Secondary",
			"ligo": 0.72,
			"name": "Kogarah Secondary",
			"playspace": 46,
			"projections": [
				4466,
				4645,
				4975,
				5305,
				5610
			],
			"projections_percentage": [
				0,
				4.01,
				11.4,
				18.79,
				25.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 41
					},
					"classroomspace": 3.11,
					"enrolment": 927,
					"ligo": 1,
					"location": [
						151.136480732683,
						-33.9583049963864
					],
					"name": "St George Girls High School",
					"playspace": 17.64,
					"projections": [
						953,
						927,
						925,
						925,
						925,
						925
					],
					"projections_orig": [
						"953",
						"927",
						"925",
						"925",
						"925",
						"925"
					],
					"projections_percentage": [
						2.8,
						0,
						-0.22,
						-0.22,
						-0.22,
						-0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 3.9,
					"enrolment": 917,
					"ligo": 1,
					"location": [
						151.114013826614,
						-33.9620973727078
					],
					"name": "Sydney Technical High School",
					"playspace": 32.91,
					"projections": [
						912,
						917,
						915,
						915,
						915,
						915
					],
					"projections_orig": [
						"912",
						"917",
						"915",
						"915",
						"915",
						"915"
					],
					"projections_percentage": [
						-0.55,
						0,
						-0.22,
						-0.22,
						-0.22,
						-0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8141
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 46
					},
					"classroomspace": 3.22,
					"enrolment": 1101,
					"ligo": 0.65,
					"location": [
						151.11279368152,
						-33.9815707372845
					],
					"name": "Blakehurst High School",
					"playspace": 15.46,
					"projections": [
						1073,
						1101,
						1175,
						1260,
						1370,
						1505
					],
					"projections_orig": [
						"1073",
						"1101",
						"1175",
						"1260",
						"1370",
						"1505"
					],
					"projections_percentage": [
						-2.54,
						0,
						6.72,
						14.44,
						24.43,
						36.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8236
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 7.83,
					"enrolment": 319,
					"ligo": 0.5,
					"location": [
						151.137559500031,
						-33.9693739580468
					],
					"name": "Moorefield Girls High School",
					"playspace": 56.96,
					"projections": [
						441,
						319,
						375,
						425,
						470,
						505
					],
					"projections_orig": [
						"441",
						"319",
						"375",
						"425",
						"470",
						"505"
					],
					"projections_percentage": [
						38.24,
						0,
						17.55,
						33.23,
						47.34,
						58.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8241
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.5,
					"enrolment": 968,
					"ligo": 0.61,
					"location": [
						151.134758472696,
						-33.9612353210319
					],
					"name": "Kogarah High School",
					"playspace": 12.14,
					"projections": [
						784,
						968,
						965,
						1120,
						1255,
						1370
					],
					"projections_orig": [
						"784",
						"968",
						"965",
						"1120",
						"1255",
						"1370"
					],
					"projections_percentage": [
						-19.01,
						0,
						-0.31,
						15.7,
						29.65,
						41.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8320
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 12.34,
					"enrolment": 234,
					"ligo": 0.55,
					"location": [
						151.137130492755,
						-33.9658353117995
					],
					"name": "James Cook Boys High School",
					"playspace": 140.89,
					"projections": [
						435,
						234,
						290,
						330,
						370,
						390
					],
					"projections_orig": [
						"435",
						"234",
						"290",
						"330",
						"370",
						"390"
					],
					"projections_percentage": [
						85.9,
						0,
						23.93,
						41.03,
						58.12,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8882
				}
			],
			"uid": 20021
		},
		{
			"classrooms": {
				"demountable": 27,
				"permanent": 371
			},
			"enrolment": 5398,
			"level": "Secondary",
			"ligo": 0.49,
			"name": "Canterbury Secondary",
			"playspace": 31.04,
			"projections": [
				5398,
				5890,
				6700,
				7420,
				8200
			],
			"projections_percentage": [
				0,
				9.11,
				24.12,
				37.46,
				51.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 7.41,
					"enrolment": 344,
					"ligo": 0.4,
					"location": [
						151.1231779079,
						-33.9045388591468
					],
					"name": "Canterbury Boys High School",
					"playspace": 51.28,
					"projections": [
						484,
						344,
						440,
						505,
						580,
						645
					],
					"projections_orig": [
						"484",
						"344",
						"440",
						"505",
						"580",
						"645"
					],
					"projections_percentage": [
						40.7,
						0,
						27.91,
						46.8,
						68.6,
						87.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8107
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.84,
					"enrolment": 497,
					"ligo": 0.7,
					"location": [
						151.053074525931,
						-33.923316397907
					],
					"name": "Punchbowl Boys High School",
					"playspace": 47.24,
					"projections": [
						414,
						497,
						530,
						585,
						640,
						720
					],
					"projections_orig": [
						"414",
						"497",
						"530",
						"585",
						"640",
						"720"
					],
					"projections_percentage": [
						-16.7,
						0,
						6.64,
						17.71,
						28.77,
						44.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8184
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 65
					},
					"classroomspace": 4.63,
					"enrolment": 873,
					"ligo": 0.42,
					"location": [
						151.098305431017,
						-33.9344094563357
					],
					"name": "Kingsgrove North High School",
					"playspace": 26.55,
					"projections": [
						893,
						873,
						975,
						1090,
						1195,
						1305
					],
					"projections_orig": [
						"893",
						"873",
						"975",
						"1090",
						"1195",
						"1305"
					],
					"projections_percentage": [
						2.29,
						0,
						11.68,
						24.86,
						36.88,
						49.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8221
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.16,
					"enrolment": 972,
					"ligo": 0.46,
					"location": [
						151.102610099491,
						-33.9484803682262
					],
					"name": "Kingsgrove High School",
					"playspace": 17.99,
					"projections": [
						1023,
						972,
						1055,
						1170,
						1280,
						1360
					],
					"projections_orig": [
						"1023",
						"972",
						"1055",
						"1170",
						"1280",
						"1360"
					],
					"projections_percentage": [
						5.25,
						0,
						8.54,
						20.37,
						31.69,
						39.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8247
				},
				{
					"classrooms": {
						"demountable": 27,
						"permanent": 39
					},
					"classroomspace": 3.85,
					"enrolment": 1190,
					"ligo": 0.34,
					"location": [
						151.077698559926,
						-33.9473873107061
					],
					"name": "Beverly Hills Girls High School",
					"playspace": 24.7,
					"projections": [
						1147,
						1190,
						1235,
						1370,
						1520,
						1660
					],
					"projections_orig": [
						"1147",
						"1190",
						"1235",
						"1370",
						"1520",
						"1660"
					],
					"projections_percentage": [
						-3.61,
						0,
						3.78,
						15.13,
						27.73,
						39.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8255
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 7.73,
					"enrolment": 318,
					"ligo": 0.68,
					"location": [
						151.084783232784,
						-33.9111492984973
					],
					"name": "Belmore Boys High School",
					"playspace": 33.85,
					"projections": [
						367,
						318,
						315,
						385,
						425,
						480
					],
					"projections_orig": [
						"367",
						"318",
						"315",
						"385",
						"425",
						"480"
					],
					"projections_percentage": [
						15.41,
						0,
						-0.94,
						21.07,
						33.65,
						50.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8804
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 43
					},
					"classroomspace": 3.6,
					"enrolment": 727,
					"ligo": 0.48,
					"location": [
						151.121812055875,
						-33.9077671731585
					],
					"name": "Canterbury Girls High School",
					"playspace": 17.33,
					"projections": [
						661,
						727,
						715,
						890,
						995,
						1155
					],
					"projections_orig": [
						"661",
						"727",
						"715",
						"890",
						"995",
						"1155"
					],
					"projections_percentage": [
						-9.08,
						0,
						-1.65,
						22.42,
						36.86,
						58.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8806
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 5.97,
					"enrolment": 477,
					"ligo": 0.44,
					"location": [
						151.065434328677,
						-33.9239840294488
					],
					"name": "Wiley Park Girls High School",
					"playspace": 29.4,
					"projections": [
						618,
						477,
						625,
						705,
						785,
						875
					],
					"projections_orig": [
						"618",
						"477",
						"625",
						"705",
						"785",
						"875"
					],
					"projections_percentage": [
						29.56,
						0,
						31.03,
						47.8,
						64.57,
						83.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8888
				}
			],
			"uid": 20022
		},
		{
			"classrooms": {
				"demountable": 48,
				"permanent": 350
			},
			"enrolment": 7230,
			"level": "Secondary",
			"ligo": 0.63,
			"name": "Fairfield Secondary",
			"playspace": 40.4,
			"projections": [
				7229,
				6660,
				6530,
				6575,
				6765
			],
			"projections_percentage": [
				0,
				-7.87,
				-9.67,
				-9.05,
				-6.42
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 88
					},
					"classroomspace": 3.92,
					"enrolment": 1487,
					"ligo": 0.65,
					"location": [
						150.929714616422,
						-33.8984276916141
					],
					"name": "Cabramatta High School",
					"playspace": 44.32,
					"projections": [
						1405,
						1487,
						1350,
						1335,
						1330,
						1350
					],
					"projections_orig": [
						"1405",
						"1487",
						"1350",
						"1335",
						"1330",
						"1350"
					],
					"projections_percentage": [
						-5.51,
						0,
						-9.21,
						-10.22,
						-10.56,
						-9.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8209
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 67
					},
					"classroomspace": 2.75,
					"enrolment": 1710,
					"ligo": 0.4,
					"location": [
						150.919499314633,
						-33.8682694200599
					],
					"name": "Westfields Sports High School",
					"playspace": 20.05,
					"projections": [
						1617,
						1709,
						1590,
						1545,
						1540,
						1560
					],
					"projections_orig": [
						"1617",
						"1709",
						"1590",
						"1545",
						"1540",
						"1560"
					],
					"projections_percentage": [
						-5.38,
						0,
						-6.96,
						-9.6,
						-9.89,
						-8.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8384
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 62
					},
					"classroomspace": 3.24,
					"enrolment": 1484,
					"ligo": 0.73,
					"location": [
						150.95146301688,
						-33.8852740712513
					],
					"name": "Canley Vale High School",
					"playspace": 12.39,
					"projections": [
						1303,
						1484,
						1355,
						1340,
						1330,
						1380
					],
					"projections_orig": [
						"1303",
						"1484",
						"1355",
						"1340",
						"1330",
						"1380"
					],
					"projections_percentage": [
						-12.2,
						0,
						-8.69,
						-9.7,
						-10.38,
						-7.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8393
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 54
					},
					"classroomspace": 3.38,
					"enrolment": 1373,
					"ligo": 0.63,
					"location": [
						150.92901328832,
						-33.874422792203
					],
					"name": "Fairvale High School",
					"playspace": 24.54,
					"projections": [
						1380,
						1373,
						1355,
						1315,
						1335,
						1355
					],
					"projections_orig": [
						"1380",
						"1373",
						"1355",
						"1315",
						"1335",
						"1355"
					],
					"projections_percentage": [
						0.51,
						0,
						-1.31,
						-4.22,
						-2.77,
						-1.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8456
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 79
					},
					"classroomspace": 4.43,
					"enrolment": 1176,
					"ligo": 0.72,
					"location": [
						150.956565883741,
						-33.8664855723696
					],
					"name": "Fairfield High School",
					"playspace": 100.69,
					"projections": [
						1024,
						1176,
						1010,
						995,
						1040,
						1120
					],
					"projections_orig": [
						"1024",
						"1176",
						"1010",
						"995",
						"1040",
						"1120"
					],
					"projections_percentage": [
						-12.93,
						0,
						-14.12,
						-15.39,
						-11.56,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8550
				}
			],
			"uid": 20023
		},
		{
			"classrooms": {
				"demountable": 51,
				"permanent": 216
			},
			"enrolment": 5057,
			"level": "Secondary",
			"ligo": 0.52,
			"name": "Bonnyrigg Secondary",
			"playspace": 39.56,
			"projections": [
				5058,
				5075,
				4965,
				4940,
				5010
			],
			"projections_percentage": [
				0,
				0.34,
				-1.84,
				-2.33,
				-0.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 22,
						"permanent": 47
					},
					"classroomspace": 3.05,
					"enrolment": 1510,
					"ligo": 0.52,
					"location": [
						150.891653639047,
						-33.895012273293
					],
					"name": "Bonnyrigg High School",
					"playspace": 29.6,
					"projections": [
						1038,
						1510,
						1290,
						1260,
						1240,
						1250
					],
					"projections_orig": [
						"1038",
						"1510",
						"1290",
						"1260",
						"1240",
						"1250"
					],
					"projections_percentage": [
						-31.26,
						0,
						-14.57,
						-16.56,
						-17.88,
						-17.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8260
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 56
					},
					"classroomspace": 4.3,
					"enrolment": 849,
					"ligo": 0.49,
					"location": [
						150.890388313377,
						-33.8742038351885
					],
					"name": "St Johns Park High School",
					"playspace": 69.99,
					"projections": [
						1157,
						849,
						945,
						905,
						895,
						905
					],
					"projections_orig": [
						"1157",
						"849",
						"945",
						"905",
						"895",
						"905"
					],
					"projections_percentage": [
						36.28,
						0,
						11.31,
						6.6,
						5.42,
						6.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8531
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 53
					},
					"classroomspace": 2.86,
					"enrolment": 1242,
					"ligo": 0.55,
					"location": [
						150.902610518289,
						-33.8596454896061
					],
					"name": "Prairiewood High School",
					"playspace": 31.04,
					"projections": [
						987,
						1243,
						1235,
						1210,
						1235,
						1260
					],
					"projections_orig": [
						"987",
						"1243",
						"1235",
						"1210",
						"1235",
						"1260"
					],
					"projections_percentage": [
						-20.6,
						0,
						-0.64,
						-2.65,
						-0.64,
						1.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8560
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 60
					},
					"classroomspace": 3.36,
					"enrolment": 1456,
					"ligo": 0.52,
					"location": [
						150.87619653653,
						-33.8698490106274
					],
					"name": "Bossley Park High School",
					"playspace": 27.63,
					"projections": [
						1505,
						1456,
						1605,
						1590,
						1570,
						1595
					],
					"projections_orig": [
						"1505",
						"1456",
						"1605",
						"1590",
						"1570",
						"1595"
					],
					"projections_percentage": [
						3.37,
						0,
						10.23,
						9.2,
						7.83,
						9.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8582
				}
			],
			"uid": 20024
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 250
			},
			"enrolment": 3754,
			"level": "Secondary",
			"ligo": 0.61,
			"name": "Cecil Hills Secondary",
			"playspace": 67.44,
			"projections": [
				3754,
				4050,
				4360,
				4750,
				5340
			],
			"projections_percentage": [
				0,
				7.88,
				16.14,
				26.53,
				42.25
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 57
					},
					"classroomspace": 3.04,
					"enrolment": 1324,
					"ligo": 0.8,
					"location": [
						150.85030115828,
						-33.8960224003344
					],
					"name": "Cecil Hills High School",
					"playspace": 30.87,
					"projections": [
						1191,
						1324,
						1350,
						1435,
						1555,
						1830
					],
					"projections_orig": [
						"1191",
						"1324",
						"1350",
						"1435",
						"1555",
						"1830"
					],
					"projections_percentage": [
						-10.05,
						0,
						1.96,
						8.38,
						17.45,
						38.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8273
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 47
					},
					"classroomspace": 6.45,
					"enrolment": 575,
					"ligo": 0.52,
					"location": [
						150.880110649561,
						-33.922861013213
					],
					"name": "Miller High School",
					"playspace": 74.78,
					"projections": [
						565,
						575,
						590,
						610,
						625,
						670
					],
					"projections_orig": [
						"565",
						"575",
						"590",
						"610",
						"625",
						"670"
					],
					"projections_percentage": [
						-1.74,
						0,
						2.61,
						6.09,
						8.7,
						16.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8394
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 5.88,
					"enrolment": 517,
					"ligo": 0.68,
					"location": [
						150.896150571402,
						-33.9194326485562
					],
					"name": "Ashcroft High School",
					"playspace": 85.51,
					"projections": [
						571,
						517,
						560,
						560,
						560,
						590
					],
					"projections_orig": [
						"571",
						"517",
						"560",
						"560",
						"560",
						"590"
					],
					"projections_percentage": [
						10.44,
						0,
						8.32,
						8.32,
						8.32,
						14.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8397
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 5.04,
					"enrolment": 693,
					"ligo": 0.44,
					"location": [
						150.874033830301,
						-33.9100140196117
					],
					"name": "James Busby High School",
					"playspace": 50.57,
					"projections": [
						749,
						693,
						725,
						700,
						700,
						700
					],
					"projections_orig": [
						"749",
						"693",
						"725",
						"700",
						"700",
						"700"
					],
					"projections_percentage": [
						8.08,
						0,
						4.62,
						1.01,
						1.01,
						1.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8460
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 4.45,
					"enrolment": 645,
					"ligo": 0.6,
					"location": [
						150.863339248491,
						-33.9188182086242
					],
					"name": "Hoxton Park High School",
					"playspace": 95.47,
					"projections": [
						708,
						645,
						825,
						1055,
						1310,
						1550
					],
					"projections_orig": [
						"708",
						"645",
						"825",
						"1055",
						"1310",
						"1550"
					],
					"projections_percentage": [
						9.77,
						0,
						27.91,
						63.57,
						103.1,
						140.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8485
				}
			],
			"uid": 20025
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 234
			},
			"enrolment": 3935,
			"level": "Secondary",
			"ligo": 0.53,
			"name": "Liverpool Secondary",
			"playspace": 54.25,
			"projections": [
				3935,
				4370,
				4570,
				4760,
				4950
			],
			"projections_percentage": [
				0,
				11.05,
				16.14,
				20.97,
				25.79
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 43
					},
					"classroomspace": 3.6,
					"enrolment": 966,
					"ligo": 0.4,
					"location": [
						150.931676143019,
						-33.9179257867168
					],
					"name": "Liverpool Girls High School",
					"playspace": 23.02,
					"projections": [
						1072,
						966,
						1075,
						1120,
						1165,
						1205
					],
					"projections_orig": [
						"1072",
						"966",
						"1075",
						"1120",
						"1165",
						"1205"
					],
					"projections_percentage": [
						10.97,
						0,
						11.28,
						15.94,
						20.6,
						24.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8176
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 5.53,
					"enrolment": 581,
					"ligo": 0.48,
					"location": [
						150.930644400837,
						-33.917727076059
					],
					"name": "Liverpool Boys High School",
					"playspace": 44.74,
					"projections": [
						590,
						581,
						640,
						670,
						700,
						725
					],
					"projections_orig": [
						"590",
						"581",
						"640",
						"670",
						"700",
						"725"
					],
					"projections_percentage": [
						1.55,
						0,
						10.15,
						15.32,
						20.48,
						24.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8186
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 51
					},
					"classroomspace": 5.01,
					"enrolment": 693,
					"ligo": 0.52,
					"location": [
						150.897173143749,
						-33.9417098745509
					],
					"name": "Lurnea High School",
					"playspace": 65.92,
					"projections": [
						735,
						693,
						810,
						870,
						925,
						975
					],
					"projections_orig": [
						"735",
						"693",
						"810",
						"870",
						"925",
						"975"
					],
					"projections_percentage": [
						6.06,
						0,
						16.88,
						25.54,
						33.48,
						40.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8401
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 3.26,
					"enrolment": 1038,
					"ligo": 0.46,
					"location": [
						150.957390645481,
						-33.925892418448
					],
					"name": "Moorebank High School",
					"playspace": 52.82,
					"projections": [
						1026,
						1038,
						1105,
						1150,
						1185,
						1230
					],
					"projections_orig": [
						"1026",
						"1038",
						"1105",
						"1150",
						"1185",
						"1230"
					],
					"projections_percentage": [
						-1.16,
						0,
						6.45,
						10.79,
						14.16,
						18.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8501
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 4.05,
					"enrolment": 657,
					"ligo": 0.78,
					"location": [
						150.951762585051,
						-33.9560056011231
					],
					"name": "Holsworthy High School",
					"playspace": 84.75,
					"projections": [
						681,
						657,
						740,
						760,
						785,
						815
					],
					"projections_orig": [
						"681",
						"657",
						"740",
						"760",
						"785",
						"815"
					],
					"projections_percentage": [
						3.65,
						0,
						12.63,
						15.68,
						19.48,
						24.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8564
				}
			],
			"uid": 20026
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 205
			},
			"enrolment": 2691,
			"level": "Secondary",
			"ligo": 0.68,
			"name": "Leumeah - Raby Road Secondary",
			"playspace": 75.84,
			"projections": [
				2691,
				2880,
				3615,
				4395,
				5115
			],
			"projections_percentage": [
				0,
				7.02,
				34.34,
				63.32,
				90.08
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 4.23,
					"enrolment": 794,
					"ligo": 0.54,
					"location": [
						150.848138652692,
						-34.0544278535283
					],
					"name": "Leumeah High School",
					"playspace": 51.29,
					"projections": [
						861,
						794,
						840,
						905,
						945,
						1005
					],
					"projections_orig": [
						"861",
						"794",
						"840",
						"905",
						"945",
						"1005"
					],
					"projections_percentage": [
						8.44,
						0,
						5.79,
						13.98,
						19.02,
						26.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8532
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 5.15,
					"enrolment": 602,
					"ligo": 0.72,
					"location": [
						150.85033064929,
						-34.0272178563749
					],
					"name": "Sarah Redfern High School",
					"playspace": 114.47,
					"projections": [
						483,
						602,
						600,
						650,
						700,
						750
					],
					"projections_orig": [
						"483",
						"602",
						"600",
						"650",
						"700",
						"750"
					],
					"projections_percentage": [
						-19.77,
						0,
						-0.33,
						7.97,
						16.28,
						24.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8551
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 5.66,
					"enrolment": 518,
					"ligo": 0.8,
					"location": [
						150.804444571289,
						-34.0408179346069
					],
					"name": "Eagle Vale High School",
					"playspace": 77.15,
					"projections": [
						662,
						518,
						525,
						835,
						1185,
						1490
					],
					"projections_orig": [
						"662",
						"518",
						"525",
						"835",
						"1185",
						"1490"
					],
					"projections_percentage": [
						27.8,
						0,
						1.35,
						61.2,
						128.76,
						187.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8569
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 46
					},
					"classroomspace": 4.02,
					"enrolment": 777,
					"ligo": 0.66,
					"location": [
						150.818245674557,
						-34.0155802238061
					],
					"name": "Robert Townson High School",
					"playspace": 60.47,
					"projections": [
						894,
						777,
						915,
						1225,
						1565,
						1870
					],
					"projections_orig": [
						"894",
						"777",
						"915",
						"1225",
						"1565",
						"1870"
					],
					"projections_percentage": [
						15.06,
						0,
						17.76,
						57.66,
						101.42,
						140.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8575
				}
			],
			"uid": 20027
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 265
			},
			"enrolment": 5167,
			"level": "Secondary",
			"ligo": 0.76,
			"name": "Camden Secondary",
			"playspace": 33.78,
			"projections": [
				5167,
				6165,
				8475,
				11105,
				13060
			],
			"projections_percentage": [
				0,
				19.31,
				64.02,
				114.92,
				152.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 50
					},
					"classroomspace": 3.46,
					"enrolment": 1156,
					"ligo": 0.91,
					"location": [
						150.606884250702,
						-34.1946055250096
					],
					"name": "Picton High School",
					"playspace": 22.34,
					"projections": [
						1279,
						1156,
						1330,
						1500,
						1695,
						1870
					],
					"projections_orig": [
						"1279",
						"1156",
						"1330",
						"1500",
						"1695",
						"1870"
					],
					"projections_percentage": [
						10.64,
						0,
						15.05,
						29.76,
						46.63,
						61.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8215
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 58
					},
					"classroomspace": 3.22,
					"enrolment": 1125,
					"ligo": 0.74,
					"location": [
						150.677698288036,
						-34.079394226071
					],
					"name": "Camden High School",
					"playspace": 38.76,
					"projections": [
						1176,
						1125,
						1205,
						1665,
						2175,
						2560
					],
					"projections_orig": [
						"1176",
						"1125",
						"1205",
						"1665",
						"2175",
						"2560"
					],
					"projections_percentage": [
						4.53,
						0,
						7.11,
						48,
						93.33,
						127.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8217
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 4.16,
					"enrolment": 757,
					"ligo": 0.8,
					"location": [
						150.761471714617,
						-34.0584325330353
					],
					"name": "Mount Annan High School",
					"playspace": 54.22,
					"projections": [
						723,
						757,
						920,
						1260,
						1590,
						1845
					],
					"projections_orig": [
						"723",
						"757",
						"920",
						"1260",
						"1590",
						"1845"
					],
					"projections_percentage": [
						-4.49,
						0,
						21.53,
						66.45,
						110.04,
						143.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8286
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 51
					},
					"classroomspace": 3.72,
					"enrolment": 988,
					"ligo": 0.43,
					"location": [
						150.716342648597,
						-34.0529475545397
					],
					"name": "Elderslie High School",
					"playspace": 28.52,
					"projections": [
						975,
						988,
						1255,
						1905,
						2680,
						3315
					],
					"projections_orig": [
						"975",
						"988",
						"1255",
						"1905",
						"2680",
						"3315"
					],
					"projections_percentage": [
						-1.32,
						0,
						27.02,
						92.81,
						171.26,
						235.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8521
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 2.79,
					"enrolment": 1141,
					"ligo": 0.7,
					"location": [
						150.739132082342,
						-34.0568792458214
					],
					"name": "Elizabeth Macarthur High School",
					"playspace": 25.06,
					"projections": [
						954,
						1141,
						1455,
						2145,
						2965,
						3470
					],
					"projections_orig": [
						"954",
						"1141",
						"1455",
						"2145",
						"2965",
						"3470"
					],
					"projections_percentage": [
						-16.39,
						0,
						27.52,
						87.99,
						159.86,
						204.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8584
				}
			],
			"uid": 20028
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 204
			},
			"enrolment": 2837,
			"level": "Secondary",
			"ligo": 0.67,
			"name": "Campbelltown Secondary",
			"playspace": 71.75,
			"projections": [
				2837,
				3235,
				3890,
				4765,
				5710
			],
			"projections_percentage": [
				0,
				14.03,
				37.12,
				67.96,
				101.27
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.35,
					"enrolment": 1103,
					"ligo": 0.58,
					"location": [
						150.822880380091,
						-34.0616916620086
					],
					"name": "Campbelltown Performing Arts High School",
					"playspace": 44.65,
					"projections": [
						1142,
						1103,
						1285,
						1410,
						1685,
						1965
					],
					"projections_orig": [
						"1142",
						"1103",
						"1285",
						"1410",
						"1685",
						"1965"
					],
					"projections_percentage": [
						3.54,
						0,
						16.5,
						27.83,
						52.77,
						78.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8180
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 7.45,
					"enrolment": 456,
					"ligo": 0.81,
					"location": [
						150.827722958697,
						-34.0878323406195
					],
					"name": "Airds High School",
					"playspace": 100.75,
					"projections": [
						443,
						456,
						515,
						575,
						620,
						670
					],
					"projections_orig": [
						"443",
						"456",
						"515",
						"575",
						"620",
						"670"
					],
					"projections_percentage": [
						-2.85,
						0,
						12.94,
						26.1,
						35.96,
						46.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8493
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 5.16,
					"enrolment": 743,
					"ligo": 0.68,
					"location": [
						150.800592689788,
						-34.1005769675329
					],
					"name": "Ambarvale High School",
					"playspace": 65.05,
					"projections": [
						823,
						743,
						800,
						1070,
						1400,
						1775
					],
					"projections_orig": [
						"823",
						"743",
						"800",
						"1070",
						"1400",
						"1775"
					],
					"projections_percentage": [
						10.77,
						0,
						7.67,
						44.01,
						88.43,
						138.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8570
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 32
					},
					"classroomspace": 4.5,
					"enrolment": 535,
					"ligo": 0.61,
					"location": [
						150.803007717226,
						-34.0814208338717
					],
					"name": "Thomas Reddall High School",
					"playspace": 76.57,
					"projections": [
						615,
						535,
						635,
						835,
						1060,
						1300
					],
					"projections_orig": [
						"615",
						"535",
						"635",
						"835",
						"1060",
						"1300"
					],
					"projections_percentage": [
						14.95,
						0,
						18.69,
						56.07,
						98.13,
						142.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8589
				}
			],
			"uid": 20029
		},
		{
			"classrooms": {
				"demountable": 27,
				"permanent": 210
			},
			"enrolment": 3267,
			"level": "Secondary",
			"ligo": 0.68,
			"name": "St Marys Secondary",
			"playspace": 69.13,
			"projections": [
				3267,
				3730,
				4045,
				4325,
				4605
			],
			"projections_percentage": [
				0,
				14.17,
				23.81,
				32.38,
				40.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 6.54,
					"enrolment": 661,
					"ligo": 0.63,
					"location": [
						150.7970160334,
						-33.7794073376222
					],
					"name": "Colyton High School",
					"playspace": 124.36,
					"projections": [
						820,
						661,
						785,
						845,
						905,
						955
					],
					"projections_orig": [
						"820",
						"661",
						"785",
						"845",
						"905",
						"955"
					],
					"projections_percentage": [
						24.05,
						0,
						18.76,
						27.84,
						36.91,
						44.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8443
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 53
					},
					"classroomspace": 6.37,
					"enrolment": 691,
					"ligo": 0.59,
					"location": [
						150.787752545245,
						-33.7940221834239
					],
					"name": "St Clair High School",
					"playspace": 53.98,
					"projections": [
						967,
						691,
						785,
						845,
						880,
						920
					],
					"projections_orig": [
						"967",
						"691",
						"785",
						"845",
						"880",
						"920"
					],
					"projections_percentage": [
						39.94,
						0,
						13.6,
						22.29,
						27.35,
						33.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8571
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 43
					},
					"classroomspace": 3.4,
					"enrolment": 997,
					"ligo": 0.52,
					"location": [
						150.803683764521,
						-33.8083566295718
					],
					"name": "Erskine Park High School",
					"playspace": 36.53,
					"projections": [
						1025,
						997,
						1080,
						1155,
						1220,
						1290
					],
					"projections_orig": [
						"1025",
						"997",
						"1080",
						"1155",
						"1220",
						"1290"
					],
					"projections_percentage": [
						2.81,
						0,
						8.32,
						15.85,
						22.37,
						29.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8590
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 3.82,
					"enrolment": 918,
					"ligo": 1,
					"location": [
						150.770744552459,
						-33.7637551344551
					],
					"name": "St Marys Senior High School",
					"playspace": 61.64,
					"projections": [
						919,
						918,
						1080,
						1200,
						1320,
						1440
					],
					"projections_orig": [
						"919",
						"918",
						"1080",
						"1200",
						"1320",
						"1440"
					],
					"projections_percentage": [
						0.11,
						0,
						17.65,
						30.72,
						43.79,
						56.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8870
				}
			],
			"uid": 20030
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 372
			},
			"enrolment": 6220,
			"level": "Secondary",
			"ligo": 0.7,
			"name": "Penrith Secondary",
			"playspace": 54.32,
			"projections": [
				6220,
				6770,
				7380,
				7850,
				8430
			],
			"projections_percentage": [
				0,
				8.84,
				18.65,
				26.21,
				35.53
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.75,
					"enrolment": 931,
					"ligo": 1,
					"location": [
						150.706254495186,
						-33.7556351151721
					],
					"name": "Penrith High School",
					"playspace": 39.7,
					"projections": [
						952,
						931,
						930,
						930,
						930,
						930
					],
					"projections_orig": [
						"952",
						"931",
						"930",
						"930",
						"930",
						"930"
					],
					"projections_percentage": [
						2.26,
						0,
						-0.11,
						-0.11,
						-0.11,
						-0.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8163
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 3.64,
					"enrolment": 849,
					"ligo": 0.8,
					"location": [
						150.671779079625,
						-33.7910714769555
					],
					"name": "Glenmore Park High School",
					"playspace": 49.01,
					"projections": [
						759,
						849,
						1010,
						1250,
						1495,
						1720
					],
					"projections_orig": [
						"759",
						"849",
						"1010",
						"1250",
						"1495",
						"1720"
					],
					"projections_percentage": [
						-10.6,
						0,
						18.96,
						47.23,
						76.09,
						102.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8276
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 51
					},
					"classroomspace": 3.12,
					"enrolment": 1148,
					"ligo": 0.42,
					"location": [
						150.670503353019,
						-33.7485441318525
					],
					"name": "Nepean Creative and Performing Arts High School",
					"playspace": 80.24,
					"projections": [
						834,
						1148,
						1180,
						1195,
						1225,
						1255
					],
					"projections_orig": [
						"834",
						"1148",
						"1180",
						"1195",
						"1225",
						"1255"
					],
					"projections_percentage": [
						-27.35,
						0,
						2.79,
						4.09,
						6.71,
						9.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8383
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.81,
					"enrolment": 730,
					"ligo": 0.65,
					"location": [
						150.715381096358,
						-33.7713884457732
					],
					"name": "Kingswood High School",
					"playspace": 72.74,
					"projections": [
						783,
						730,
						845,
						955,
						1005,
						1065
					],
					"projections_orig": [
						"783",
						"730",
						"845",
						"955",
						"1005",
						"1065"
					],
					"projections_percentage": [
						7.26,
						0,
						15.75,
						30.82,
						37.67,
						45.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8458
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 4.75,
					"enrolment": 743,
					"ligo": 0.66,
					"location": [
						150.734317588136,
						-33.75320230802
					],
					"name": "Cambridge Park High School",
					"playspace": 89.68,
					"projections": [
						604,
						743,
						745,
						810,
						840,
						870
					],
					"projections_orig": [
						"604",
						"743",
						"745",
						"810",
						"840",
						"870"
					],
					"projections_percentage": [
						-18.71,
						0,
						0.27,
						9.02,
						13.06,
						17.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8516
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 56
					},
					"classroomspace": 3.25,
					"enrolment": 1050,
					"ligo": 0.56,
					"location": [
						150.697431301359,
						-33.7751589934803
					],
					"name": "Jamison High School",
					"playspace": 29.09,
					"projections": [
						994,
						1050,
						1160,
						1245,
						1280,
						1315
					],
					"projections_orig": [
						"994",
						"1050",
						"1160",
						"1245",
						"1280",
						"1315"
					],
					"projections_percentage": [
						-5.33,
						0,
						10.48,
						18.57,
						21.9,
						25.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8559
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 4.08,
					"enrolment": 769,
					"ligo": 0.82,
					"location": [
						150.711139595325,
						-33.7212737038035
					],
					"name": "Cranebrook High School",
					"playspace": 19.77,
					"projections": [
						867,
						769,
						900,
						995,
						1075,
						1275
					],
					"projections_orig": [
						"867",
						"769",
						"900",
						"995",
						"1075",
						"1275"
					],
					"projections_percentage": [
						12.74,
						0,
						17.04,
						29.39,
						39.79,
						65.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8580
				}
			],
			"uid": 20031
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 203
			},
			"enrolment": 3293,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Blue Mountains Secondary",
			"playspace": 45.63,
			"projections": [
				3294,
				3315,
				3290,
				3270,
				3305
			],
			"projections_percentage": [
				0,
				0.64,
				-0.12,
				-0.73,
				0.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.72,
					"enrolment": 730,
					"ligo": 0.91,
					"location": [
						150.313175184361,
						-33.7278511280937
					],
					"name": "Katoomba High School",
					"playspace": 52.82,
					"projections": [
						541,
						730,
						670,
						670,
						670,
						675
					],
					"projections_orig": [
						"541",
						"730",
						"670",
						"670",
						"670",
						"675"
					],
					"projections_percentage": [
						-25.89,
						0,
						-8.22,
						-8.22,
						-8.22,
						-7.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8150
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 4.42,
					"enrolment": 698,
					"ligo": 0.69,
					"location": [
						150.550207009672,
						-33.6864247622996
					],
					"name": "Springwood High School",
					"playspace": 66.33,
					"projections": [
						686,
						698,
						715,
						705,
						700,
						710
					],
					"projections_orig": [
						"686",
						"698",
						"715",
						"705",
						"700",
						"710"
					],
					"projections_percentage": [
						-1.72,
						0,
						2.44,
						1,
						0.29,
						1.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8446
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 3.26,
					"enrolment": 1010,
					"ligo": 0.77,
					"location": [
						150.610209165964,
						-33.7557533207095
					],
					"name": "Blaxland High School",
					"playspace": 29.82,
					"projections": [
						936,
						1011,
						1025,
						1015,
						1005,
						1015
					],
					"projections_orig": [
						"936",
						"1011",
						"1025",
						"1015",
						"1005",
						"1015"
					],
					"projections_percentage": [
						-7.42,
						0,
						1.38,
						0.4,
						-0.59,
						0.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8522
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.28,
					"enrolment": 855,
					"ligo": 0.63,
					"location": [
						150.615636133441,
						-33.674183181584
					],
					"name": "Winmalee High School",
					"playspace": 33.55,
					"projections": [
						1011,
						855,
						905,
						900,
						895,
						905
					],
					"projections_orig": [
						"1011",
						"855",
						"905",
						"900",
						"895",
						"905"
					],
					"projections_percentage": [
						18.25,
						0,
						5.85,
						5.26,
						4.68,
						5.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8573
				}
			],
			"uid": 20032
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 193
			},
			"enrolment": 2494,
			"level": "Secondary",
			"ligo": 0.86,
			"name": "Hawkesbury Secondary",
			"playspace": 93.87,
			"projections": [
				2494,
				2960,
				3235,
				3545,
				3960
			],
			"projections_percentage": [
				0,
				18.68,
				29.71,
				42.14,
				58.78
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 51
					},
					"classroomspace": 5.49,
					"enrolment": 638,
					"ligo": 0.8,
					"location": [
						150.747046506367,
						-33.598842776943
					],
					"name": "Richmond High School",
					"playspace": 109.96,
					"projections": [
						783,
						638,
						820,
						925,
						1020,
						1120
					],
					"projections_orig": [
						"783",
						"638",
						"820",
						"925",
						"1020",
						"1120"
					],
					"projections_percentage": [
						22.73,
						0,
						28.53,
						44.98,
						59.87,
						75.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8178
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 8.06,
					"enrolment": 444,
					"ligo": 0.81,
					"location": [
						150.831713463101,
						-33.618883804518
					],
					"name": "Windsor High School",
					"playspace": 136.58,
					"projections": [
						498,
						444,
						530,
						610,
						770,
						995
					],
					"projections_orig": [
						"498",
						"444",
						"530",
						"610",
						"770",
						"995"
					],
					"projections_percentage": [
						12.16,
						0,
						19.37,
						37.39,
						73.42,
						124.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8396
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 54
					},
					"classroomspace": 3.76,
					"enrolment": 963,
					"ligo": 0.9,
					"location": [
						150.706168138493,
						-33.5703208855035
					],
					"name": "Colo High School",
					"playspace": 61.47,
					"projections": [
						1054,
						963,
						1085,
						1135,
						1170,
						1230
					],
					"projections_orig": [
						"1054",
						"963",
						"1085",
						"1135",
						"1170",
						"1230"
					],
					"projections_percentage": [
						9.45,
						0,
						12.67,
						17.86,
						21.5,
						27.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8526
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 5.02,
					"enrolment": 449,
					"ligo": 0.79,
					"location": [
						150.796710600277,
						-33.5600007232445
					],
					"name": "Hawkesbury High School",
					"playspace": 67.47,
					"projections": [
						550,
						449,
						525,
						565,
						585,
						615
					],
					"projections_orig": [
						"550",
						"449",
						"525",
						"565",
						"585",
						"615"
					],
					"projections_percentage": [
						22.49,
						0,
						16.93,
						25.84,
						30.29,
						36.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8565
				}
			],
			"uid": 20033
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 186
			},
			"enrolment": 3455,
			"level": "Secondary",
			"ligo": 0.42,
			"name": "East Hills Secondary",
			"playspace": 45.19,
			"projections": [
				3455,
				3600,
				3785,
				4010,
				4235
			],
			"projections_percentage": [
				0,
				4.2,
				9.55,
				16.06,
				22.58
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 41
					},
					"classroomspace": 2.91,
					"enrolment": 1059,
					"ligo": 0.34,
					"location": [
						150.992702878291,
						-33.9571025362659
					],
					"name": "East Hills Girls Technology High School",
					"playspace": 15.12,
					"projections": [
						1004,
						1059,
						1065,
						1105,
						1160,
						1215
					],
					"projections_orig": [
						"1004",
						"1059",
						"1065",
						"1105",
						"1160",
						"1215"
					],
					"projections_percentage": [
						-5.19,
						0,
						0.57,
						4.34,
						9.54,
						14.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8187
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 3.68,
					"enrolment": 788,
					"ligo": 0.32,
					"location": [
						150.993003256749,
						-33.9566484741002
					],
					"name": "East Hills Boys High School",
					"playspace": 64.7,
					"projections": [
						821,
						788,
						860,
						890,
						935,
						980
					],
					"projections_orig": [
						"821",
						"788",
						"860",
						"890",
						"935",
						"980"
					],
					"projections_percentage": [
						4.19,
						0,
						9.14,
						12.94,
						18.65,
						24.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8206
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 5.59,
					"enrolment": 565,
					"ligo": 0.61,
					"location": [
						151.020251595255,
						-33.9388400219207
					],
					"name": "Sir Joseph Banks High School",
					"playspace": 73.66,
					"projections": [
						535,
						565,
						590,
						660,
						740,
						805
					],
					"projections_orig": [
						"535",
						"565",
						"590",
						"660",
						"740",
						"805"
					],
					"projections_percentage": [
						-5.31,
						0,
						4.42,
						16.81,
						30.97,
						42.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8250
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 47
					},
					"classroomspace": 3.22,
					"enrolment": 1043,
					"ligo": 0.4,
					"location": [
						151.009008641488,
						-33.9650951243225
					],
					"name": "Picnic Point High School",
					"playspace": 27.26,
					"projections": [
						1025,
						1043,
						1085,
						1130,
						1175,
						1235
					],
					"projections_orig": [
						"1025",
						"1043",
						"1085",
						"1130",
						"1175",
						"1235"
					],
					"projections_percentage": [
						-1.73,
						0,
						4.03,
						8.34,
						12.66,
						18.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8377
				}
			],
			"uid": 20034
		},
		{
			"classrooms": {
				"demountable": 49,
				"permanent": 344
			},
			"enrolment": 5966,
			"level": "Secondary",
			"ligo": 0.62,
			"name": "Bankstown Secondary",
			"playspace": 53.64,
			"projections": [
				5965,
				6275,
				7165,
				7900,
				8420
			],
			"projections_percentage": [
				0,
				5.2,
				20.12,
				32.44,
				41.16
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 7,
					"enrolment": 400,
					"ligo": 0.56,
					"location": [
						151.024528293315,
						-33.8930346451862
					],
					"name": "Birrong Boys High School",
					"playspace": 50.3,
					"projections": [
						390,
						400,
						430,
						500,
						540,
						585
					],
					"projections_orig": [
						"390",
						"400",
						"430",
						"500",
						"540",
						"585"
					],
					"projections_percentage": [
						-2.5,
						0,
						7.5,
						25,
						35,
						46.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8213
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 48
					},
					"classroomspace": 4.96,
					"enrolment": 658,
					"ligo": 0.66,
					"location": [
						150.990812288043,
						-33.8984644636306
					],
					"name": "Bass High School",
					"playspace": 46.31,
					"projections": [
						786,
						657,
						770,
						815,
						855,
						910
					],
					"projections_orig": [
						"786",
						"657",
						"770",
						"815",
						"855",
						"910"
					],
					"projections_percentage": [
						19.63,
						0,
						17.2,
						24.05,
						30.14,
						38.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8223
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 37
					},
					"classroomspace": 4.18,
					"enrolment": 540,
					"ligo": 0.54,
					"location": [
						151.032731058664,
						-33.9204086627191
					],
					"name": "Bankstown Girls High School",
					"playspace": 7.9,
					"projections": [
						629,
						540,
						665,
						745,
						820,
						885
					],
					"projections_orig": [
						"629",
						"540",
						"665",
						"745",
						"820",
						"885"
					],
					"projections_percentage": [
						16.48,
						0,
						23.15,
						37.96,
						51.85,
						63.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8254
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 3.38,
					"enrolment": 1062,
					"ligo": 0.44,
					"location": [
						151.007666024617,
						-33.8793112958571
					],
					"name": "Sefton High School",
					"playspace": 19.79,
					"projections": [
						1035,
						1062,
						1035,
						1285,
						1460,
						1530
					],
					"projections_orig": [
						"1035",
						"1062",
						"1035",
						"1285",
						"1460",
						"1530"
					],
					"projections_percentage": [
						-2.54,
						0,
						-2.54,
						21,
						37.48,
						44.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8265
				},
				{
					"classrooms": {
						"demountable": 21,
						"permanent": 48
					},
					"classroomspace": 3.51,
					"enrolment": 1269,
					"ligo": 0.66,
					"location": [
						150.994638310415,
						-33.8750381902447
					],
					"name": "Chester Hill High School",
					"playspace": 31.79,
					"projections": [
						1088,
						1269,
						1185,
						1370,
						1555,
						1630
					],
					"projections_orig": [
						"1088",
						"1269",
						"1185",
						"1370",
						"1555",
						"1630"
					],
					"projections_percentage": [
						-14.26,
						0,
						-6.62,
						7.96,
						22.54,
						28.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8269
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 34
					},
					"classroomspace": 6.43,
					"enrolment": 431,
					"ligo": 1,
					"location": [
						151.021457036773,
						-33.9309548653418
					],
					"name": "Bankstown Senior College",
					"playspace": 155.11,
					"projections": [
						356,
						431,
						465,
						520,
						585,
						660
					],
					"projections_orig": [
						"356",
						"431",
						"465",
						"520",
						"585",
						"660"
					],
					"projections_percentage": [
						-17.4,
						0,
						7.89,
						20.65,
						35.73,
						53.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8381
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 42
					},
					"classroomspace": 3.48,
					"enrolment": 810,
					"ligo": 0.47,
					"location": [
						151.003203404045,
						-33.9240361704846
					],
					"name": "Condell Park High School",
					"playspace": 67.75,
					"projections": [
						587,
						810,
						770,
						820,
						885,
						935
					],
					"projections_orig": [
						"587",
						"810",
						"770",
						"820",
						"885",
						"935"
					],
					"projections_percentage": [
						-27.53,
						0,
						-4.94,
						1.23,
						9.26,
						15.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8398
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 34
					},
					"classroomspace": 3.51,
					"enrolment": 796,
					"ligo": 0.64,
					"location": [
						151.027131221881,
						-33.8893252291203
					],
					"name": "Birrong Girls High School",
					"playspace": 50.2,
					"projections": [
						852,
						796,
						955,
						1110,
						1200,
						1285
					],
					"projections_orig": [
						"852",
						"796",
						"955",
						"1110",
						"1200",
						"1285"
					],
					"projections_percentage": [
						7.04,
						0,
						19.97,
						39.45,
						50.75,
						61.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8854
				}
			],
			"uid": 20035
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 334
			},
			"enrolment": 6094,
			"level": "Secondary",
			"ligo": 0.51,
			"name": "Parramatta Secondary",
			"playspace": 49.97,
			"projections": [
				6094,
				6490,
				7580,
				8695,
				9640
			],
			"projections_percentage": [
				0,
				6.5,
				24.38,
				42.68,
				58.19
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 3.03,
					"enrolment": 870,
					"ligo": 0.24,
					"location": [
						150.996012855965,
						-33.8183636627729
					],
					"name": "Parramatta High School",
					"playspace": 2.2,
					"projections": [
						839,
						870,
						845,
						970,
						1090,
						1050
					],
					"projections_orig": [
						"839",
						"870",
						"845",
						"970",
						"1090",
						"1050"
					],
					"projections_percentage": [
						-3.56,
						0,
						-2.87,
						11.49,
						25.29,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8135
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 3.5,
					"enrolment": 1036,
					"ligo": 0.36,
					"location": [
						150.999374810974,
						-33.7890178479087
					],
					"name": "Northmead Creative and Performing Arts High School",
					"playspace": 63.87,
					"projections": [
						897,
						1036,
						1115,
						1320,
						1475,
						1560
					],
					"projections_orig": [
						"897",
						"1036",
						"1115",
						"1320",
						"1475",
						"1560"
					],
					"projections_percentage": [
						-13.42,
						0,
						7.63,
						27.41,
						42.37,
						50.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8229
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 3.91,
					"enrolment": 841,
					"ligo": 1,
					"location": [
						151.041647967685,
						-33.7827299668524
					],
					"name": "James Ruse Agricultural High School",
					"playspace": 29.12,
					"projections": [
						855,
						841,
						840,
						840,
						840,
						840
					],
					"projections_orig": [
						"855",
						"841",
						"840",
						"840",
						"840",
						"840"
					],
					"projections_percentage": [
						1.66,
						0,
						-0.12,
						-0.12,
						-0.12,
						-0.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8235
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 8.57,
					"enrolment": 354,
					"ligo": 0.84,
					"location": [
						150.961769652063,
						-33.7946491533639
					],
					"name": "Pendle Hill High School",
					"playspace": 132.94,
					"projections": [
						351,
						354,
						400,
						440,
						480,
						510
					],
					"projections_orig": [
						"351",
						"354",
						"400",
						"440",
						"480",
						"510"
					],
					"projections_percentage": [
						-0.85,
						0,
						12.99,
						24.29,
						35.59,
						44.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8395
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 40
					},
					"classroomspace": 3.27,
					"enrolment": 1022,
					"ligo": 0.3,
					"location": [
						151.011522278904,
						-33.8128624337093
					],
					"name": "Macarthur Girls High School",
					"playspace": 38.34,
					"projections": [
						1049,
						1022,
						1090,
						1310,
						1525,
						1665
					],
					"projections_orig": [
						"1049",
						"1022",
						"1090",
						"1310",
						"1525",
						"1665"
					],
					"projections_percentage": [
						2.64,
						0,
						6.65,
						28.18,
						49.22,
						62.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8822
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 2.19,
					"enrolment": 1330,
					"ligo": 0.26,
					"location": [
						151.006683329311,
						-33.8159869188613
					],
					"name": "Arthur Phillip High School",
					"playspace": 10.17,
					"projections": [
						1523,
						1330,
						1505,
						1835,
						2330,
						3015
					],
					"projections_orig": [
						"1523",
						"1330",
						"1505",
						"1835",
						"2330",
						"3015"
					],
					"projections_percentage": [
						14.51,
						0,
						13.16,
						37.97,
						75.19,
						126.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8892
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 4.25,
					"enrolment": 641,
					"ligo": 0.59,
					"location": [
						151.037899152021,
						-33.7849608654777
					],
					"name": "Cumberland High School",
					"playspace": 73.18,
					"projections": [
						609,
						641,
						695,
						865,
						955,
						1000
					],
					"projections_orig": [
						"609",
						"641",
						"695",
						"865",
						"955",
						"1000"
					],
					"projections_percentage": [
						-4.99,
						0,
						8.42,
						34.95,
						48.99,
						56.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8905
				}
			],
			"uid": 20036
		},
		{
			"classrooms": {
				"demountable": 70,
				"permanent": 505
			},
			"enrolment": 10262,
			"level": "Secondary",
			"ligo": 0.71,
			"name": "North East Secondary",
			"playspace": 35.71,
			"projections": [
				10261,
				11695,
				13525,
				15340,
				16970
			],
			"projections_percentage": [
				0,
				13.98,
				31.81,
				49.5,
				65.38
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.52,
					"enrolment": 839,
					"ligo": 0.77,
					"location": [
						150.933314779475,
						-33.6866322354719
					],
					"name": "Rouse Hill High School",
					"playspace": 45.33,
					"projections": [
						575,
						839,
						1045,
						1545,
						2030,
						2520
					],
					"projections_orig": [
						"575",
						"839",
						"1045",
						"1545",
						"2030",
						"2520"
					],
					"projections_percentage": [
						-31.47,
						0,
						24.55,
						84.15,
						141.95,
						200.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8291
				},
				{
					"classrooms": {
						"demountable": 23,
						"permanent": 45
					},
					"classroomspace": 2.9,
					"enrolment": 1595,
					"ligo": 0.69,
					"location": [
						150.998566848898,
						-33.7265584582817
					],
					"name": "Castle Hill High School",
					"playspace": 18.17,
					"projections": [
						1320,
						1595,
						1825,
						2190,
						2545,
						2835
					],
					"projections_orig": [
						"1320",
						"1595",
						"1825",
						"2190",
						"2545",
						"2835"
					],
					"projections_percentage": [
						-17.24,
						0,
						14.42,
						37.3,
						59.56,
						77.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8382
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 58
					},
					"classroomspace": 3.23,
					"enrolment": 1217,
					"ligo": 1,
					"location": [
						150.989727067928,
						-33.7526648531562
					],
					"name": "Baulkham Hills High School",
					"playspace": 30.55,
					"projections": [
						1203,
						1217,
						1215,
						1215,
						1215,
						1215
					],
					"projections_orig": [
						"1203",
						"1217",
						"1215",
						"1215",
						"1215",
						"1215"
					],
					"projections_percentage": [
						-1.15,
						0,
						-0.16,
						-0.16,
						-0.16,
						-0.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8464
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 55
					},
					"classroomspace": 3.52,
					"enrolment": 1072,
					"ligo": 0.72,
					"location": [
						150.968069297275,
						-33.7088210435145
					],
					"name": "Kellyville High School",
					"playspace": 40.15,
					"projections": [
						1006,
						1072,
						1395,
						1710,
						2015,
						2250
					],
					"projections_orig": [
						"1006",
						"1072",
						"1395",
						"1710",
						"2015",
						"2250"
					],
					"projections_percentage": [
						-6.16,
						0,
						30.13,
						59.51,
						87.97,
						109.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8477
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 59
					},
					"classroomspace": 5.7,
					"enrolment": 684,
					"ligo": 0.69,
					"location": [
						151.039526839205,
						-33.6608858823407
					],
					"name": "Galston High School",
					"playspace": 64.55,
					"projections": [
						771,
						684,
						745,
						800,
						835,
						875
					],
					"projections_orig": [
						"771",
						"684",
						"745",
						"800",
						"835",
						"875"
					],
					"projections_percentage": [
						12.72,
						0,
						8.92,
						16.96,
						22.08,
						27.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8481
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 3.92,
					"enrolment": 845,
					"ligo": 0.56,
					"location": [
						151.022244575508,
						-33.7659828459457
					],
					"name": "Muirfield High School",
					"playspace": 49.34,
					"projections": [
						819,
						844,
						885,
						1020,
						1125,
						1190
					],
					"projections_orig": [
						"819",
						"844",
						"885",
						"1020",
						"1125",
						"1190"
					],
					"projections_percentage": [
						-2.96,
						0,
						4.86,
						20.85,
						33.29,
						41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8498
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.32,
					"enrolment": 1103,
					"ligo": 0.66,
					"location": [
						150.970436467644,
						-33.769500095015
					],
					"name": "Model Farms High School",
					"playspace": 37.61,
					"projections": [
						1015,
						1103,
						1185,
						1320,
						1530,
						1675
					],
					"projections_orig": [
						"1015",
						"1103",
						"1185",
						"1320",
						"1530",
						"1675"
					],
					"projections_percentage": [
						-7.98,
						0,
						7.43,
						19.67,
						38.71,
						51.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8499
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 66
					},
					"classroomspace": 3.78,
					"enrolment": 976,
					"ligo": 0.45,
					"location": [
						150.975664562765,
						-33.7446381051969
					],
					"name": "Crestwood High School",
					"playspace": 26.2,
					"projections": [
						1022,
						976,
						1300,
						1530,
						1770,
						2035
					],
					"projections_orig": [
						"1022",
						"976",
						"1300",
						"1530",
						"1770",
						"2035"
					],
					"projections_percentage": [
						4.71,
						0,
						33.2,
						56.76,
						81.35,
						108.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8552
				},
				{
					"classrooms": {
						"demountable": 37,
						"permanent": 61
					},
					"classroomspace": 3.28,
					"enrolment": 1931,
					"ligo": 0.85,
					"location": [
						151.036957435731,
						-33.7201748126674
					],
					"name": "Cherrybrook Technology High School",
					"playspace": 9.46,
					"projections": [
						2050,
						1931,
						2100,
						2195,
						2275,
						2375
					],
					"projections_orig": [
						"2050",
						"1931",
						"2100",
						"2195",
						"2275",
						"2375"
					],
					"projections_percentage": [
						6.16,
						0,
						8.75,
						13.67,
						17.81,
						22.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8592
				}
			],
			"uid": 20037
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 382
			},
			"enrolment": 5520,
			"level": "Secondary",
			"ligo": 0.52,
			"name": "Blacktown Secondary",
			"playspace": 91.75,
			"projections": [
				5520,
				6065,
				6665,
				7265,
				8090
			],
			"projections_percentage": [
				0,
				9.87,
				20.74,
				31.61,
				46.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 48
					},
					"classroomspace": 4.57,
					"enrolment": 725,
					"ligo": 0.3,
					"location": [
						150.911313132441,
						-33.7630866341275
					],
					"name": "Blacktown Girls High School",
					"playspace": 35.78,
					"projections": [
						720,
						725,
						800,
						925,
						1055,
						1320
					],
					"projections_orig": [
						"720",
						"725",
						"800",
						"925",
						"1055",
						"1320"
					],
					"projections_percentage": [
						-0.69,
						0,
						10.34,
						27.59,
						45.52,
						82.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8224
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 8.29,
					"enrolment": 314,
					"ligo": 0.36,
					"location": [
						150.943277421801,
						-33.7634933189359
					],
					"name": "Seven Hills High School",
					"playspace": 243.45,
					"projections": [
						363,
						314,
						350,
						385,
						425,
						475
					],
					"projections_orig": [
						"363",
						"314",
						"350",
						"385",
						"425",
						"475"
					],
					"projections_percentage": [
						15.61,
						0,
						11.46,
						22.61,
						35.35,
						51.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8231
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.62,
					"enrolment": 511,
					"ligo": 0.33,
					"location": [
						150.911560294149,
						-33.7631412139614
					],
					"name": "Blacktown Boys High School",
					"playspace": 87.19,
					"projections": [
						390,
						511,
						505,
						580,
						655,
						820
					],
					"projections_orig": [
						"390",
						"511",
						"505",
						"580",
						"655",
						"820"
					],
					"projections_percentage": [
						-23.68,
						0,
						-1.17,
						13.5,
						28.18,
						60.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8244
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 47
					},
					"classroomspace": 4.33,
					"enrolment": 671,
					"ligo": 0.58,
					"location": [
						150.873493359692,
						-33.7563201824426
					],
					"name": "Doonside High School",
					"playspace": 92.13,
					"projections": [
						744,
						671,
						795,
						840,
						905,
						980
					],
					"projections_orig": [
						"744",
						"671",
						"795",
						"840",
						"905",
						"980"
					],
					"projections_percentage": [
						10.88,
						0,
						18.48,
						25.19,
						34.87,
						46.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8399
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 45
					},
					"classroomspace": 3.36,
					"enrolment": 1005,
					"ligo": 0.59,
					"location": [
						150.914531707263,
						-33.785848697881
					],
					"name": "Mitchell High School",
					"playspace": 43.77,
					"projections": [
						1063,
						1005,
						1160,
						1285,
						1405,
						1510
					],
					"projections_orig": [
						"1063",
						"1005",
						"1160",
						"1285",
						"1405",
						"1510"
					],
					"projections_percentage": [
						5.77,
						0,
						15.42,
						27.86,
						39.8,
						50.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8403
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 4.26,
					"enrolment": 892,
					"ligo": 0.34,
					"location": [
						150.940333277079,
						-33.7821110568939
					],
					"name": "The Hills Sports High School",
					"playspace": 71.76,
					"projections": [
						927,
						892,
						925,
						1045,
						1140,
						1230
					],
					"projections_orig": [
						"927",
						"892",
						"925",
						"1045",
						"1140",
						"1230"
					],
					"projections_percentage": [
						3.92,
						0,
						3.7,
						17.15,
						27.8,
						37.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8412
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 57
					},
					"classroomspace": 6.45,
					"enrolment": 643,
					"ligo": 0.62,
					"location": [
						150.890933926492,
						-33.7875549842979
					],
					"name": "Evans High School",
					"playspace": 101.98,
					"projections": [
						761,
						643,
						770,
						845,
						920,
						995
					],
					"projections_orig": [
						"761",
						"643",
						"770",
						"845",
						"920",
						"995"
					],
					"projections_percentage": [
						18.35,
						0,
						19.75,
						31.42,
						43.08,
						54.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 43
					},
					"classroomspace": 3.6,
					"enrolment": 759,
					"ligo": 1,
					"location": [
						150.944266471364,
						-33.7985526568163
					],
					"name": "Girraween High School",
					"playspace": 57.96,
					"projections": [
						754,
						759,
						760,
						760,
						760,
						760
					],
					"projections_orig": [
						"754",
						"759",
						"760",
						"760",
						"760",
						"760"
					],
					"projections_percentage": [
						-0.66,
						0,
						0.13,
						0.13,
						0.13,
						0.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8500
				}
			],
			"uid": 20038
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 354
			},
			"enrolment": 4317,
			"level": "Secondary",
			"ligo": 0.62,
			"name": "Mount Druitt Secondary",
			"playspace": 89.48,
			"projections": [
				4317,
				5010,
				5735,
				6490,
				7320
			],
			"projections_percentage": [
				0,
				16.05,
				32.85,
				50.34,
				69.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 7.75,
					"enrolment": 424,
					"ligo": 0.69,
					"location": [
						150.814751448757,
						-33.7447670995116
					],
					"name": "Chifley College Mount Druitt Campus",
					"playspace": 126.11,
					"projections": [
						632,
						424,
						545,
						595,
						640,
						695
					],
					"projections_orig": [
						"632",
						"424",
						"545",
						"595",
						"640",
						"695"
					],
					"projections_percentage": [
						49.06,
						0,
						28.54,
						40.33,
						50.94,
						63.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8459
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 35
					},
					"classroomspace": 3.85,
					"enrolment": 567,
					"ligo": 0.9,
					"location": [
						150.830210016594,
						-33.7707713102231
					],
					"name": "Chifley College Senior Campus",
					"playspace": 51.76,
					"projections": [
						616,
						567,
						610,
						685,
						755,
						830
					],
					"projections_orig": [
						"616",
						"567",
						"610",
						"685",
						"755",
						"830"
					],
					"projections_percentage": [
						8.64,
						0,
						7.58,
						20.81,
						33.16,
						46.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8473
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 10.72,
					"enrolment": 307,
					"ligo": 0.67,
					"location": [
						150.782192038941,
						-33.7507833122642
					],
					"name": "Chifley College Dunheved Campus",
					"playspace": 125.32,
					"projections": [
						290,
						307,
						310,
						350,
						395,
						435
					],
					"projections_orig": [
						"290",
						"307",
						"310",
						"350",
						"395",
						"435"
					],
					"projections_percentage": [
						-5.54,
						0,
						0.98,
						14.01,
						28.66,
						41.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8488
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 9.03,
					"enrolment": 320,
					"ligo": 0.59,
					"location": [
						150.80696730367,
						-33.7297387049822
					],
					"name": "Chifley College Shalvey Campus",
					"playspace": 187.43,
					"projections": [
						410,
						320,
						435,
						510,
						600,
						705
					],
					"projections_orig": [
						"410",
						"320",
						"435",
						"510",
						"600",
						"705"
					],
					"projections_percentage": [
						28.12,
						0,
						35.94,
						59.38,
						87.5,
						120.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8496
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 60
					},
					"classroomspace": 3.87,
					"enrolment": 964,
					"ligo": 0.35,
					"location": [
						150.834161715186,
						-33.7480003963669
					],
					"name": "Plumpton High School",
					"playspace": 41.38,
					"projections": [
						1066,
						964,
						1155,
						1370,
						1605,
						1865
					],
					"projections_orig": [
						"1066",
						"964",
						"1155",
						"1370",
						"1605",
						"1865"
					],
					"projections_percentage": [
						10.58,
						0,
						19.81,
						42.12,
						66.49,
						93.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8514
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 5.54,
					"enrolment": 610,
					"ligo": 0.56,
					"location": [
						150.827074259648,
						-33.7328550755504
					],
					"name": "Chifley College Bidwill Campus",
					"playspace": 52.94,
					"projections": [
						638,
						610,
						715,
						875,
						1045,
						1225
					],
					"projections_orig": [
						"638",
						"610",
						"715",
						"875",
						"1045",
						"1225"
					],
					"projections_percentage": [
						4.59,
						0,
						17.21,
						43.44,
						71.31,
						100.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8528
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 50
					},
					"classroomspace": 2.98,
					"enrolment": 1125,
					"ligo": 0.56,
					"location": [
						150.838226733506,
						-33.7721084560741
					],
					"name": "Rooty Hill High School",
					"playspace": 41.43,
					"projections": [
						1090,
						1125,
						1240,
						1350,
						1450,
						1565
					],
					"projections_orig": [
						"1090",
						"1125",
						"1240",
						"1350",
						"1450",
						"1565"
					],
					"projections_percentage": [
						-3.11,
						0,
						10.22,
						20,
						28.89,
						39.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8908
				}
			],
			"uid": 20039
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 244
			},
			"enrolment": 4314,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "North West Secondary",
			"playspace": 85.11,
			"projections": [
				4314,
				5135,
				6785,
				8100,
				9695
			],
			"projections_percentage": [
				0,
				19.03,
				57.28,
				87.76,
				124.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 19,
						"permanent": 53
					},
					"classroomspace": 3.18,
					"enrolment": 1481,
					"ligo": 0.86,
					"location": [
						150.937312348133,
						-33.7333193996382
					],
					"name": "Glenwood High School",
					"playspace": 23.61,
					"projections": [
						1475,
						1481,
						1600,
						1730,
						1825,
						1835
					],
					"projections_orig": [
						"1475",
						"1481",
						"1600",
						"1730",
						"1825",
						"1835"
					],
					"projections_percentage": [
						-0.41,
						0,
						8.04,
						16.81,
						23.23,
						23.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8268
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 34
					},
					"classroomspace": 4.11,
					"enrolment": 749,
					"ligo": 1,
					"location": [
						150.879574576527,
						-33.7260892229642
					],
					"name": "Wyndham College",
					"playspace": 45.18,
					"projections": [
						814,
						749,
						690,
						1355,
						1735,
						2130
					],
					"projections_orig": [
						"814",
						"749",
						"690",
						"1355",
						"1735",
						"2130"
					],
					"projections_percentage": [
						8.68,
						0,
						-7.88,
						80.91,
						131.64,
						184.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8277
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 54
					},
					"classroomspace": 3.59,
					"enrolment": 988,
					"ligo": 0.5,
					"location": [
						150.898235102327,
						-33.7284124165411
					],
					"name": "Quakers Hill High School",
					"playspace": 58.43,
					"projections": [
						1046,
						988,
						1225,
						1395,
						1535,
						1615
					],
					"projections_orig": [
						"1046",
						"988",
						"1225",
						"1395",
						"1535",
						"1615"
					],
					"projections_percentage": [
						5.87,
						0,
						23.99,
						41.19,
						55.36,
						63.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8594
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 44
					},
					"classroomspace": 9.75,
					"enrolment": 281,
					"ligo": 0.74,
					"location": [
						150.874495225114,
						-33.6798318610586
					],
					"name": "Riverstone High School",
					"playspace": 248.15,
					"projections": [
						331,
						281,
						400,
						970,
						1555,
						2550
					],
					"projections_orig": [
						"331",
						"281",
						"400",
						"970",
						"1555",
						"2550"
					],
					"projections_percentage": [
						17.79,
						0,
						42.35,
						245.2,
						453.38,
						807.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8907
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 4.42,
					"enrolment": 815,
					"ligo": 0.79,
					"location": [
						150.897293025243,
						-33.7040327249733
					],
					"name": "The Ponds High School",
					"playspace": 50.17,
					"projections": [
						0,
						815,
						1220,
						1335,
						1450,
						1565
					],
					"projections_orig": [
						"0",
						"815",
						"1220",
						"1335",
						"1450",
						"1565"
					],
					"projections_percentage": [
						-100,
						0,
						49.69,
						63.8,
						77.91,
						92.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8911
				}
			],
			"uid": 20040
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 242
			},
			"enrolment": 4693,
			"level": "Secondary",
			"ligo": 0.72,
			"name": "Epping Secondary",
			"playspace": 50.09,
			"projections": [
				4694,
				4810,
				5600,
				6010,
				6165
			],
			"projections_percentage": [
				0,
				2.47,
				19.3,
				28.04,
				31.34
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 65
					},
					"classroomspace": 3.52,
					"enrolment": 1268,
					"ligo": 0.83,
					"location": [
						151.07447675116,
						-33.7570894156359
					],
					"name": "Cheltenham Girls High School",
					"playspace": 32.54,
					"projections": [
						1262,
						1268,
						1355,
						1540,
						1630,
						1640
					],
					"projections_orig": [
						"1262",
						"1268",
						"1355",
						"1540",
						"1630",
						"1640"
					],
					"projections_percentage": [
						-0.47,
						0,
						6.86,
						21.45,
						28.55,
						29.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8208
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 63
					},
					"classroomspace": 4.12,
					"enrolment": 1043,
					"ligo": 0.64,
					"location": [
						151.061413909389,
						-33.7326281636164
					],
					"name": "Pennant Hills High School",
					"playspace": 59.54,
					"projections": [
						1089,
						1044,
						1120,
						1245,
						1320,
						1370
					],
					"projections_orig": [
						"1089",
						"1044",
						"1120",
						"1245",
						"1320",
						"1370"
					],
					"projections_percentage": [
						4.31,
						0,
						7.28,
						19.25,
						26.44,
						31.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8438
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 58
					},
					"classroomspace": 3.05,
					"enrolment": 1228,
					"ligo": 0.5,
					"location": [
						151.051882162942,
						-33.7656746821864
					],
					"name": "Carlingford High School",
					"playspace": 52.65,
					"projections": [
						1161,
						1228,
						1080,
						1285,
						1350,
						1375
					],
					"projections_orig": [
						"1161",
						"1228",
						"1080",
						"1285",
						"1350",
						"1375"
					],
					"projections_percentage": [
						-5.46,
						0,
						-12.05,
						4.64,
						9.93,
						11.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8447
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 56
					},
					"classroomspace": 3.63,
					"enrolment": 1154,
					"ligo": 0.92,
					"location": [
						151.101404455504,
						-33.7716706592085
					],
					"name": "Epping Boys High School",
					"playspace": 55.65,
					"projections": [
						1133,
						1154,
						1255,
						1530,
						1710,
						1780
					],
					"projections_orig": [
						"1133",
						"1154",
						"1255",
						"1530",
						"1710",
						"1780"
					],
					"projections_percentage": [
						-1.82,
						0,
						8.75,
						32.58,
						48.18,
						54.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8884
				}
			],
			"uid": 20041
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 145
			},
			"enrolment": 2329,
			"level": "Secondary",
			"ligo": 0.71,
			"name": "Albury City Secondary",
			"playspace": 67.13,
			"projections": [
				2329,
				2605,
				2660,
				2650,
				2550
			],
			"projections_percentage": [
				0,
				11.85,
				14.21,
				13.78,
				9.49
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.76,
					"enrolment": 974,
					"ligo": 0.68,
					"location": [
						146.916877335582,
						-36.0733838383111
					],
					"name": "Albury High School",
					"playspace": 45.41,
					"projections": [
						1094,
						974,
						1120,
						1135,
						1125,
						1085
					],
					"projections_orig": [
						"1094",
						"974",
						"1120",
						"1135",
						"1125",
						"1085"
					],
					"projections_percentage": [
						12.32,
						0,
						14.99,
						16.53,
						15.5,
						11.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8101
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 4.21,
					"enrolment": 717,
					"ligo": 0.72,
					"location": [
						146.929941755413,
						-36.0608553991017
					],
					"name": "James Fallon High School",
					"playspace": 59.55,
					"projections": [
						737,
						717,
						750,
						770,
						770,
						740
					],
					"projections_orig": [
						"737",
						"717",
						"750",
						"770",
						"770",
						"740"
					],
					"projections_percentage": [
						2.79,
						0,
						4.6,
						7.39,
						7.39,
						3.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8266
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 39
					},
					"classroomspace": 4.34,
					"enrolment": 638,
					"ligo": 0.74,
					"location": [
						146.946260101789,
						-36.0350896207299
					],
					"name": "Murray High School",
					"playspace": 96.44,
					"projections": [
						763,
						638,
						735,
						755,
						755,
						725
					],
					"projections_orig": [
						"763",
						"638",
						"735",
						"755",
						"755",
						"725"
					],
					"projections_percentage": [
						19.59,
						0,
						15.2,
						18.34,
						18.34,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8505
				}
			],
			"uid": 20042
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 171
			},
			"enrolment": 2473,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Wagga City Secondary",
			"playspace": 68.16,
			"projections": [
				2472,
				2940,
				3015,
				2975,
				2850
			],
			"projections_percentage": [
				0,
				18.93,
				21.97,
				20.35,
				15.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.45,
					"enrolment": 1063,
					"ligo": 0.7,
					"location": [
						147.364372422241,
						-35.1236651246579
					],
					"name": "Wagga Wagga High School",
					"playspace": 38.3,
					"projections": [
						1059,
						1063,
						1210,
						1240,
						1220,
						1170
					],
					"projections_orig": [
						"1059",
						"1063",
						"1210",
						"1240",
						"1220",
						"1170"
					],
					"projections_percentage": [
						-0.38,
						0,
						13.83,
						16.65,
						14.77,
						10.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8142
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 6.35,
					"enrolment": 497,
					"ligo": 0.92,
					"location": [
						147.353830370895,
						-35.1427892880488
					],
					"name": "Mount Austin High School",
					"playspace": 104.24,
					"projections": [
						577,
						497,
						625,
						640,
						635,
						605
					],
					"projections_orig": [
						"577",
						"497",
						"625",
						"640",
						"635",
						"605"
					],
					"projections_percentage": [
						16.1,
						0,
						25.75,
						28.77,
						27.77,
						21.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 60
					},
					"classroomspace": 4.41,
					"enrolment": 913,
					"ligo": 0.71,
					"location": [
						147.380037750123,
						-35.1431761959343
					],
					"name": "Kooringal High School",
					"playspace": 61.94,
					"projections": [
						893,
						912,
						1105,
						1135,
						1120,
						1075
					],
					"projections_orig": [
						"893",
						"912",
						"1105",
						"1135",
						"1120",
						"1075"
					],
					"projections_percentage": [
						-2.08,
						0,
						21.16,
						24.45,
						22.81,
						17.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8483
				}
			],
			"uid": 20043
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 108
			},
			"enrolment": 2377,
			"level": "Secondary",
			"ligo": 0.81,
			"name": "Queanbeyan Yass Secondary",
			"playspace": 59.16,
			"projections": [
				2377,
				3010,
				3295,
				3405,
				3410
			],
			"projections_percentage": [
				0,
				26.63,
				38.62,
				43.25,
				43.46
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 5.66,
					"enrolment": 561,
					"ligo": 0.78,
					"location": [
						149.221509867627,
						-35.352353850171
					],
					"name": "Queanbeyan High School",
					"playspace": 88.31,
					"projections": [
						479,
						561,
						610,
						685,
						705,
						690
					],
					"projections_orig": [
						"479",
						"561",
						"610",
						"685",
						"705",
						"690"
					],
					"projections_percentage": [
						-14.62,
						0,
						8.73,
						22.1,
						25.67,
						22.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8216
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 25
					},
					"classroomspace": 3.76,
					"enrolment": 506,
					"ligo": 0.93,
					"location": [
						148.910748302293,
						-34.8354514172657
					],
					"name": "Yass High School",
					"playspace": 57.47,
					"projections": [
						490,
						506,
						510,
						535,
						550,
						565
					],
					"projections_orig": [
						"490",
						"506",
						"510",
						"535",
						"550",
						"565"
					],
					"projections_percentage": [
						-3.16,
						0,
						0.79,
						5.73,
						8.7,
						11.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8334
				},
				{
					"classrooms": {
						"demountable": 16,
						"permanent": 37
					},
					"classroomspace": 2.66,
					"enrolment": 1310,
					"ligo": 0.73,
					"location": [
						149.224517275548,
						-35.366122659495
					],
					"name": "Karabar High School",
					"playspace": 31.71,
					"projections": [
						1174,
						1310,
						1890,
						2075,
						2150,
						2155
					],
					"projections_orig": [
						"1174",
						"1310",
						"1890",
						"2075",
						"2150",
						"2155"
					],
					"projections_percentage": [
						-10.38,
						0,
						44.27,
						58.4,
						64.12,
						64.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8524
				}
			],
			"uid": 20044
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 281
			},
			"enrolment": 4141,
			"level": "Secondary",
			"ligo": 0.46,
			"name": "Granville Secondary",
			"playspace": 55.48,
			"projections": [
				4141,
				4650,
				5275,
				5775,
				6180
			],
			"projections_percentage": [
				0,
				12.29,
				27.38,
				39.46,
				49.24
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 45
					},
					"classroomspace": 4.2,
					"enrolment": 752,
					"ligo": 0.42,
					"location": [
						150.967290445333,
						-33.8397500855887
					],
					"name": "Merrylands High School",
					"playspace": 81.9,
					"projections": [
						779,
						752,
						800,
						865,
						930,
						980
					],
					"projections_orig": [
						"779",
						"752",
						"800",
						"865",
						"930",
						"980"
					],
					"projections_percentage": [
						3.59,
						0,
						6.38,
						15.03,
						23.67,
						30.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8227
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 40
					},
					"classroomspace": 3.93,
					"enrolment": 805,
					"ligo": 0.65,
					"location": [
						151.034423928728,
						-33.8434942286421
					],
					"name": "Auburn Girls High School",
					"playspace": 12.81,
					"projections": [
						760,
						805,
						990,
						1180,
						1295,
						1375
					],
					"projections_orig": [
						"760",
						"805",
						"990",
						"1180",
						"1295",
						"1375"
					],
					"projections_percentage": [
						-5.59,
						0,
						22.98,
						46.58,
						60.87,
						70.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8253
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 3.25,
					"enrolment": 988,
					"ligo": 0.51,
					"location": [
						150.941810676985,
						-33.8122654499948
					],
					"name": "Greystanes High School",
					"playspace": 41.6,
					"projections": [
						982,
						988,
						1050,
						1155,
						1240,
						1325
					],
					"projections_orig": [
						"982",
						"988",
						"1050",
						"1155",
						"1240",
						"1325"
					],
					"projections_percentage": [
						-0.61,
						0,
						6.28,
						16.9,
						25.51,
						34.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8385
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 5.97,
					"enrolment": 548,
					"ligo": 0.1,
					"location": [
						150.949610890861,
						-33.8336059360408
					],
					"name": "Holroyd High School",
					"playspace": 92.57,
					"projections": [
						449,
						548,
						605,
						645,
						695,
						735
					],
					"projections_orig": [
						"449",
						"548",
						"605",
						"645",
						"695",
						"735"
					],
					"projections_percentage": [
						-18.07,
						0,
						10.4,
						17.7,
						26.82,
						34.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8424
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.18,
					"enrolment": 526,
					"ligo": 0.59,
					"location": [
						150.995955796014,
						-33.8609016502014
					],
					"name": "Granville South Creative and Performing Arts High School",
					"playspace": 71.76,
					"projections": [
						530,
						526,
						580,
						660,
						740,
						795
					],
					"projections_orig": [
						"530",
						"526",
						"580",
						"660",
						"740",
						"795"
					],
					"projections_percentage": [
						0.76,
						0,
						10.27,
						25.48,
						40.68,
						51.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8436
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.69,
					"enrolment": 522,
					"ligo": 0.51,
					"location": [
						151.008156138772,
						-33.8341922851812
					],
					"name": "Granville Boys High School",
					"playspace": 32.22,
					"projections": [
						477,
						522,
						625,
						770,
						875,
						970
					],
					"projections_orig": [
						"477",
						"522",
						"625",
						"770",
						"875",
						"970"
					],
					"projections_percentage": [
						-8.62,
						0,
						19.73,
						47.51,
						67.62,
						85.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8811
				}
			],
			"uid": 20045
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 146
			},
			"enrolment": 2619,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Terrigal Secondary",
			"playspace": 43.97,
			"projections": [
				2619,
				3050,
				3140,
				3155,
				3190
			],
			"projections_percentage": [
				0,
				16.46,
				19.89,
				20.47,
				21.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 42
					},
					"classroomspace": 4.08,
					"enrolment": 702,
					"ligo": 0.82,
					"location": [
						151.379514092071,
						-33.4402147162488
					],
					"name": "Erina High School",
					"playspace": 63.91,
					"projections": [
						919,
						702,
						815,
						835,
						840,
						850
					],
					"projections_orig": [
						"919",
						"702",
						"815",
						"835",
						"840",
						"850"
					],
					"projections_percentage": [
						30.91,
						0,
						16.1,
						18.95,
						19.66,
						21.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8405
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.27,
					"enrolment": 1021,
					"ligo": 0.67,
					"location": [
						151.428360905897,
						-33.4423396444461
					],
					"name": "Terrigal High School",
					"playspace": 33.42,
					"projections": [
						1264,
						1021,
						1265,
						1305,
						1310,
						1325
					],
					"projections_orig": [
						"1264",
						"1021",
						"1265",
						"1305",
						"1310",
						"1325"
					],
					"projections_percentage": [
						23.8,
						0,
						23.9,
						27.82,
						28.31,
						29.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8533
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 45
					},
					"classroomspace": 4.06,
					"enrolment": 896,
					"ligo": 0.74,
					"location": [
						151.383403209013,
						-33.4647365562456
					],
					"name": "Kincumber High School",
					"playspace": 34.57,
					"projections": [
						886,
						896,
						970,
						1000,
						1005,
						1015
					],
					"projections_orig": [
						"886",
						"896",
						"970",
						"1000",
						"1005",
						"1015"
					],
					"projections_percentage": [
						-1.12,
						0,
						8.26,
						11.61,
						12.17,
						13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8585
				}
			],
			"uid": 20046
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 228
			},
			"enrolment": 4152,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Gosford Secondary",
			"playspace": 37.08,
			"projections": [
				4153,
				4505,
				4615,
				4635,
				4680
			],
			"projections_percentage": [
				0,
				8.48,
				11.12,
				11.61,
				12.69
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.25,
					"enrolment": 1099,
					"ligo": 1,
					"location": [
						151.341741564743,
						-33.4186833394411
					],
					"name": "Gosford High School",
					"playspace": 30.35,
					"projections": [
						1110,
						1099,
						1100,
						1100,
						1100,
						1100
					],
					"projections_orig": [
						"1110",
						"1099",
						"1100",
						"1100",
						"1100",
						"1100"
					],
					"projections_percentage": [
						1,
						0,
						0.09,
						0.09,
						0.09,
						0.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8115
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 3.37,
					"enrolment": 576,
					"ligo": 0.87,
					"location": [
						151.296707077328,
						-33.4310001996405
					],
					"name": "Kariong Mountains High School",
					"playspace": 43.44,
					"projections": [
						440,
						576,
						620,
						640,
						645,
						655
					],
					"projections_orig": [
						"440",
						"576",
						"620",
						"640",
						"645",
						"655"
					],
					"projections_percentage": [
						-23.61,
						0,
						7.64,
						11.11,
						11.98,
						13.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8292
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 3.39,
					"enrolment": 769,
					"ligo": 0.5,
					"location": [
						151.335560595914,
						-33.4216037043869
					],
					"name": "Henry Kendall High School",
					"playspace": 23.86,
					"projections": [
						899,
						769,
						785,
						810,
						815,
						825
					],
					"projections_orig": [
						"899",
						"769",
						"785",
						"810",
						"815",
						"825"
					],
					"projections_percentage": [
						16.91,
						0,
						2.08,
						5.33,
						5.98,
						7.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8467
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 3.93,
					"enrolment": 745,
					"ligo": 0.78,
					"location": [
						151.370947574419,
						-33.3853137754174
					],
					"name": "Lisarow High School",
					"playspace": 47.7,
					"projections": [
						906,
						745,
						825,
						850,
						855,
						865
					],
					"projections_orig": [
						"906",
						"745",
						"825",
						"850",
						"855",
						"865"
					],
					"projections_percentage": [
						21.61,
						0,
						10.74,
						14.09,
						14.77,
						16.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8544
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 46
					},
					"classroomspace": 3.63,
					"enrolment": 963,
					"ligo": 0.57,
					"location": [
						151.333520225182,
						-33.3969166994657
					],
					"name": "Narara Valley High School",
					"playspace": 40.04,
					"projections": [
						1217,
						964,
						1175,
						1215,
						1220,
						1235
					],
					"projections_orig": [
						"1217",
						"964",
						"1175",
						"1215",
						"1220",
						"1235"
					],
					"projections_percentage": [
						26.24,
						0,
						21.89,
						26.04,
						26.56,
						28.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8591
				}
			],
			"uid": 20047
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 111
			},
			"enrolment": 1612,
			"level": "Secondary",
			"ligo": 0.95,
			"name": "Woy Woy Secondary",
			"playspace": 50.75,
			"projections": [
				1612,
				1640,
				1690,
				1715,
				1740
			],
			"projections_percentage": [
				0,
				1.74,
				4.84,
				6.39,
				7.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.91,
					"enrolment": 721,
					"ligo": 0.95,
					"location": [
						151.32487641685,
						-33.4927959218405
					],
					"name": "Brisbane Water Secondary College Woy Woy Campus",
					"playspace": 53.68,
					"projections": [
						765,
						721,
						770,
						790,
						795,
						805
					],
					"projections_orig": [
						"765",
						"721",
						"770",
						"790",
						"795",
						"805"
					],
					"projections_percentage": [
						6.1,
						0,
						6.8,
						9.57,
						10.26,
						11.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8374
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 63
					},
					"classroomspace": 4.55,
					"enrolment": 891,
					"ligo": 0.95,
					"location": [
						151.309466633195,
						-33.505763225264
					],
					"name": "Brisbane Water Secondary College Umina Campus",
					"playspace": 47.83,
					"projections": [
						886,
						891,
						870,
						900,
						920,
						935
					],
					"projections_orig": [
						"886",
						"891",
						"870",
						"900",
						"920",
						"935"
					],
					"projections_percentage": [
						-0.56,
						0,
						-2.36,
						1.01,
						3.25,
						4.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8513
				}
			],
			"uid": 20048
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 236
			},
			"enrolment": 3345,
			"level": "Secondary",
			"ligo": 0.77,
			"name": "Wyong Secondary",
			"playspace": 47.95,
			"projections": [
				3344,
				3755,
				3900,
				4005,
				4155
			],
			"projections_percentage": [
				0,
				12.29,
				16.63,
				19.77,
				24.25
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 5.32,
					"enrolment": 750,
					"ligo": 0.66,
					"location": [
						151.419746859582,
						-33.2820321678928
					],
					"name": "Wyong High School",
					"playspace": 47.66,
					"projections": [
						767,
						749,
						825,
						860,
						880,
						915
					],
					"projections_orig": [
						"767",
						"749",
						"825",
						"860",
						"880",
						"915"
					],
					"projections_percentage": [
						2.4,
						0,
						10.15,
						14.82,
						17.49,
						22.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8166
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 4.08,
					"enrolment": 733,
					"ligo": 0.87,
					"location": [
						151.575172670951,
						-33.1877943627311
					],
					"name": "Lake Munmorah High School",
					"playspace": 54.96,
					"projections": [
						900,
						733,
						795,
						815,
						825,
						850
					],
					"projections_orig": [
						"900",
						"733",
						"795",
						"815",
						"825",
						"850"
					],
					"projections_percentage": [
						22.78,
						0,
						8.46,
						11.19,
						12.55,
						15.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8279
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 54
					},
					"classroomspace": 3.73,
					"enrolment": 1012,
					"ligo": 0.68,
					"location": [
						151.507256983904,
						-33.241464063846
					],
					"name": "Gorokan High School",
					"playspace": 49.77,
					"projections": [
						1128,
						1012,
						1130,
						1195,
						1255,
						1310
					],
					"projections_orig": [
						"1128",
						"1012",
						"1130",
						"1195",
						"1255",
						"1310"
					],
					"projections_percentage": [
						11.46,
						0,
						11.66,
						18.08,
						24.01,
						29.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8515
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 68
					},
					"classroomspace": 4.92,
					"enrolment": 850,
					"ligo": 0.87,
					"location": [
						151.513681782103,
						-33.2158662791632
					],
					"name": "Northlakes High School",
					"playspace": 39.42,
					"projections": [
						1113,
						850,
						1005,
						1030,
						1045,
						1080
					],
					"projections_orig": [
						"1113",
						"850",
						"1005",
						"1030",
						"1045",
						"1080"
					],
					"projections_percentage": [
						30.94,
						0,
						18.24,
						21.18,
						22.94,
						27.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8547
				}
			],
			"uid": 20049
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 160
			},
			"enrolment": 2681,
			"level": "Secondary",
			"ligo": 0.79,
			"name": "Tuggerah Lakes Secondary",
			"playspace": 44.61,
			"projections": [
				2682,
				2760,
				2895,
				2965,
				2990
			],
			"projections_percentage": [
				0,
				2.91,
				7.94,
				10.55,
				11.48
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 3.17,
					"enrolment": 1064,
					"ligo": 0.76,
					"location": [
						151.45567281554,
						-33.39632602257
					],
					"name": "Tuggerah Lakes Secondary College Tumbi Umbi Campus",
					"playspace": 42.81,
					"projections": [
						1022,
						1064,
						1120,
						1180,
						1220,
						1230
					],
					"projections_orig": [
						"1022",
						"1064",
						"1120",
						"1180",
						"1220",
						"1230"
					],
					"projections_percentage": [
						-3.95,
						0,
						5.26,
						10.9,
						14.66,
						15.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8274
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 56
					},
					"classroomspace": 4.47,
					"enrolment": 865,
					"ligo": 0.87,
					"location": [
						151.475664086348,
						-33.3727883548988
					],
					"name": "Tuggerah Lakes Secondary College The Entrance Campus",
					"playspace": 56.43,
					"projections": [
						886,
						866,
						885,
						925,
						945,
						945
					],
					"projections_orig": [
						"886",
						"866",
						"885",
						"925",
						"945",
						"945"
					],
					"projections_percentage": [
						2.31,
						0,
						2.19,
						6.81,
						9.12,
						9.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8465
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 4.3,
					"enrolment": 752,
					"ligo": 0.75,
					"location": [
						151.425852406093,
						-33.3428807476129
					],
					"name": "Tuggerah Lakes Secondary College Berkeley Vale Campus",
					"playspace": 34.6,
					"projections": [
						807,
						752,
						755,
						790,
						800,
						815
					],
					"projections_orig": [
						"807",
						"752",
						"755",
						"790",
						"800",
						"815"
					],
					"projections_percentage": [
						7.31,
						0,
						0.4,
						5.05,
						6.38,
						8.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8563
				}
			],
			"uid": 20050
		},
		{
			"classrooms": {
				"demountable": 30,
				"permanent": 249
			},
			"enrolment": 4590,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Newcastle West Secondary",
			"playspace": 60.04,
			"projections": [
				4590,
				4610,
				4785,
				4900,
				4930
			],
			"projections_percentage": [
				0,
				0.44,
				4.25,
				6.75,
				7.41
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 43
					},
					"classroomspace": 3.19,
					"enrolment": 1066,
					"ligo": 0.72,
					"location": [
						151.667736658152,
						-32.8925446035538
					],
					"name": "Callaghan College Wallsend Campus",
					"playspace": 59.49,
					"projections": [
						976,
						1066,
						1085,
						1135,
						1175,
						1170
					],
					"projections_orig": [
						"976",
						"1066",
						"1085",
						"1135",
						"1175",
						"1170"
					],
					"projections_percentage": [
						-8.44,
						0,
						1.78,
						6.47,
						10.23,
						9.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8259
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 30
					},
					"classroomspace": 4.79,
					"enrolment": 557,
					"ligo": 0.77,
					"location": [
						151.582405346766,
						-32.911952328648
					],
					"name": "West Wallsend High School",
					"playspace": 116.3,
					"projections": [
						633,
						557,
						610,
						640,
						645,
						655
					],
					"projections_orig": [
						"633",
						"557",
						"610",
						"640",
						"645",
						"655"
					],
					"projections_percentage": [
						13.64,
						0,
						9.52,
						14.9,
						15.8,
						17.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8411
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 39
					},
					"classroomspace": 3.67,
					"enrolment": 801,
					"ligo": 0.68,
					"location": [
						151.640919569757,
						-32.9266354898411
					],
					"name": "Glendale High School",
					"playspace": 50.4,
					"projections": [
						798,
						801,
						800,
						805,
						805,
						810
					],
					"projections_orig": [
						"798",
						"801",
						"800",
						"805",
						"805",
						"810"
					],
					"projections_percentage": [
						-0.37,
						0,
						-0.12,
						0.5,
						0.5,
						1.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8466
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.17,
					"enrolment": 614,
					"ligo": 0.82,
					"location": [
						151.728474109456,
						-32.9050709166373
					],
					"name": "Callaghan College Waratah Technology Campus",
					"playspace": 33.97,
					"projections": [
						507,
						614,
						615,
						655,
						690,
						695
					],
					"projections_orig": [
						"507",
						"614",
						"615",
						"655",
						"690",
						"695"
					],
					"projections_percentage": [
						-17.43,
						0,
						0.16,
						6.68,
						12.38,
						13.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8508
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 50
					},
					"classroomspace": 4.59,
					"enrolment": 817,
					"ligo": 0.68,
					"location": [
						151.695996265179,
						-32.9017551154826
					],
					"name": "Callaghan College Jesmond Campus",
					"playspace": 48.93,
					"projections": [
						778,
						817,
						805,
						845,
						880,
						890
					],
					"projections_orig": [
						"778",
						"817",
						"805",
						"845",
						"880",
						"890"
					],
					"projections_percentage": [
						-4.77,
						0,
						-1.47,
						3.43,
						7.71,
						8.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8880
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 37
					},
					"classroomspace": 3.51,
					"enrolment": 735,
					"ligo": 0.75,
					"location": [
						151.670874985685,
						-32.9513042207077
					],
					"name": "Cardiff High School",
					"playspace": 51.13,
					"projections": [
						706,
						735,
						695,
						705,
						705,
						710
					],
					"projections_orig": [
						"706",
						"735",
						"695",
						"705",
						"705",
						"710"
					],
					"projections_percentage": [
						-3.95,
						0,
						-5.44,
						-4.08,
						-4.08,
						-3.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8903
				}
			],
			"uid": 20051
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 241
			},
			"enrolment": 4365,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Newcastle Secondary",
			"playspace": 25.84,
			"projections": [
				4366,
				4380,
				4505,
				4595,
				4660
			],
			"projections_percentage": [
				0,
				0.32,
				3.18,
				5.25,
				6.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 3.13,
					"enrolment": 1102,
					"ligo": 0.75,
					"location": [
						151.70751687095,
						-32.9488699862183
					],
					"name": "Kotara High School",
					"playspace": 19.09,
					"projections": [
						1044,
						1103,
						1080,
						1110,
						1125,
						1135
					],
					"projections_orig": [
						"1044",
						"1103",
						"1080",
						"1110",
						"1125",
						"1135"
					],
					"projections_percentage": [
						-5.35,
						0,
						-2.09,
						0.63,
						1.99,
						2.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8423
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 3.19,
					"enrolment": 1115,
					"ligo": 0.66,
					"location": [
						151.722382564768,
						-32.9173244107452
					],
					"name": "Lambton High School",
					"playspace": 16.44,
					"projections": [
						1041,
						1115,
						1100,
						1145,
						1185,
						1195
					],
					"projections_orig": [
						"1041",
						"1115",
						"1100",
						"1145",
						"1185",
						"1195"
					],
					"projections_percentage": [
						-6.64,
						0,
						-1.35,
						2.69,
						6.28,
						7.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8482
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 74
					},
					"classroomspace": 4.51,
					"enrolment": 1073,
					"ligo": 0.59,
					"location": [
						151.758030948638,
						-32.9325749251641
					],
					"name": "Newcastle High School",
					"playspace": 29.01,
					"projections": [
						1054,
						1073,
						1125,
						1175,
						1210,
						1255
					],
					"projections_orig": [
						"1054",
						"1073",
						"1125",
						"1175",
						"1210",
						"1255"
					],
					"projections_percentage": [
						-1.77,
						0,
						4.85,
						9.51,
						12.77,
						16.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8509
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 57
					},
					"classroomspace": 3.43,
					"enrolment": 1075,
					"ligo": 1,
					"location": [
						151.736183470305,
						-32.9297900395923
					],
					"name": "Merewether High School",
					"playspace": 38.81,
					"projections": [
						1090,
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"projections_orig": [
						"1090",
						"1075",
						"1075",
						"1075",
						"1075",
						"1075"
					],
					"projections_percentage": [
						1.4,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8510
				}
			],
			"uid": 20052
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 145
			},
			"enrolment": 2390,
			"level": "Secondary",
			"ligo": 0.82,
			"name": "Cessnock-Kurri Secondary",
			"playspace": 42.58,
			"projections": [
				2391,
				2505,
				2615,
				2705,
				2755
			],
			"projections_percentage": [
				0,
				4.77,
				9.37,
				13.13,
				15.22
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 5.81,
					"enrolment": 556,
					"ligo": 0.83,
					"location": [
						151.369127015942,
						-32.8419175506586
					],
					"name": "Cessnock High School",
					"playspace": 34.35,
					"projections": [
						595,
						557,
						590,
						615,
						630,
						640
					],
					"projections_orig": [
						"595",
						"557",
						"590",
						"615",
						"630",
						"640"
					],
					"projections_percentage": [
						6.82,
						0,
						5.92,
						10.41,
						13.11,
						14.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8108
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 42
					},
					"classroomspace": 3.58,
					"enrolment": 872,
					"ligo": 0.8,
					"location": [
						151.486876024136,
						-32.8109154171396
					],
					"name": "Kurri Kurri High School",
					"playspace": 35.63,
					"projections": [
						815,
						872,
						865,
						900,
						930,
						950
					],
					"projections_orig": [
						"815",
						"872",
						"865",
						"900",
						"930",
						"950"
					],
					"projections_percentage": [
						-6.54,
						0,
						-0.8,
						3.21,
						6.65,
						8.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8177
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 47
					},
					"classroomspace": 3.62,
					"enrolment": 962,
					"ligo": 0.82,
					"location": [
						151.331428079033,
						-32.8291788676724
					],
					"name": "Mount View High School",
					"playspace": 57.76,
					"projections": [
						1038,
						962,
						1050,
						1100,
						1145,
						1165
					],
					"projections_orig": [
						"1038",
						"962",
						"1050",
						"1100",
						"1145",
						"1165"
					],
					"projections_percentage": [
						7.9,
						0,
						9.15,
						14.35,
						19.02,
						21.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8574
				}
			],
			"uid": 20053
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 167
			},
			"enrolment": 2391,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Tweed Secondary",
			"playspace": 73.75,
			"projections": [
				2391,
				2865,
				3010,
				3070,
				3080
			],
			"projections_percentage": [
				0,
				19.82,
				25.89,
				28.4,
				28.82
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 4.01,
					"enrolment": 595,
					"ligo": 0.67,
					"location": [
						153.524851233424,
						-28.2162686697868
					],
					"name": "Banora Point High School",
					"playspace": 65.41,
					"projections": [
						543,
						595,
						600,
						625,
						645,
						660
					],
					"projections_orig": [
						"543",
						"595",
						"600",
						"625",
						"645",
						"660"
					],
					"projections_percentage": [
						-8.74,
						0,
						0.84,
						5.04,
						8.4,
						10.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8282
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 5.2,
					"enrolment": 757,
					"ligo": 0.71,
					"location": [
						153.541435869962,
						-28.1949614856715
					],
					"name": "Tweed River High School",
					"playspace": 106,
					"projections": [
						971,
						757,
						980,
						1020,
						1050,
						1070
					],
					"projections_orig": [
						"971",
						"757",
						"980",
						"1020",
						"1050",
						"1070"
					],
					"projections_percentage": [
						28.27,
						0,
						29.46,
						34.74,
						38.71,
						41.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8370
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 3.97,
					"enrolment": 1039,
					"ligo": 0.87,
					"location": [
						153.571345111842,
						-28.2665960032837
					],
					"name": "Kingscliff High School",
					"playspace": 49.84,
					"projections": [
						1254,
						1039,
						1285,
						1365,
						1375,
						1350
					],
					"projections_orig": [
						"1254",
						"1039",
						"1285",
						"1365",
						"1375",
						"1350"
					],
					"projections_percentage": [
						20.69,
						0,
						23.68,
						31.38,
						32.34,
						29.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8579
				}
			],
			"uid": 20054
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 379
			},
			"enrolment": 6725,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Lake Macquarie Secondary",
			"playspace": 63.18,
			"projections": [
				6725,
				6865,
				6960,
				6950,
				6990
			],
			"projections_percentage": [
				0,
				2.08,
				3.49,
				3.35,
				3.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 42
					},
					"classroomspace": 3.98,
					"enrolment": 921,
					"ligo": 0.77,
					"location": [
						151.660166891785,
						-33.0262683019845
					],
					"name": "Belmont High School",
					"playspace": 33.83,
					"projections": [
						1072,
						921,
						995,
						1000,
						1000,
						1005
					],
					"projections_orig": [
						"1072",
						"921",
						"995",
						"1000",
						"1000",
						"1005"
					],
					"projections_percentage": [
						16.4,
						0,
						8.03,
						8.58,
						8.58,
						9.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8203
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 5.63,
					"enrolment": 398,
					"ligo": 0.78,
					"location": [
						151.614234981758,
						-32.9756273615395
					],
					"name": "Lake Macquarie High School",
					"playspace": 131.5,
					"projections": [
						508,
						398,
						410,
						415,
						410,
						415
					],
					"projections_orig": [
						"508",
						"398",
						"410",
						"415",
						"410",
						"415"
					],
					"projections_percentage": [
						27.64,
						0,
						3.02,
						4.27,
						3.02,
						4.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8210
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 4.54,
					"enrolment": 770,
					"ligo": 0.43,
					"location": [
						151.691506500136,
						-32.9856677728013
					],
					"name": "Hunter Sports High School",
					"playspace": 99.26,
					"projections": [
						891,
						770,
						750,
						760,
						755,
						765
					],
					"projections_orig": [
						"891",
						"770",
						"750",
						"760",
						"755",
						"765"
					],
					"projections_percentage": [
						15.71,
						0,
						-2.6,
						-1.3,
						-1.95,
						-0.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8233
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 32
					},
					"classroomspace": 3.27,
					"enrolment": 679,
					"ligo": 0.88,
					"location": [
						151.640929112975,
						-33.1035003056768
					],
					"name": "Swansea High School",
					"playspace": 73.68,
					"projections": [
						650,
						679,
						660,
						665,
						665,
						670
					],
					"projections_orig": [
						"650",
						"679",
						"660",
						"665",
						"665",
						"670"
					],
					"projections_percentage": [
						-4.27,
						0,
						-2.8,
						-2.06,
						-2.06,
						-1.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8389
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 54
					},
					"classroomspace": 3.86,
					"enrolment": 959,
					"ligo": 0.65,
					"location": [
						151.713904528876,
						-32.9719323658965
					],
					"name": "Whitebridge High School",
					"playspace": 40.99,
					"projections": [
						1044,
						959,
						1005,
						1020,
						1020,
						1025
					],
					"projections_orig": [
						"1044",
						"959",
						"1005",
						"1020",
						"1020",
						"1025"
					],
					"projections_percentage": [
						8.86,
						0,
						4.8,
						6.36,
						6.36,
						6.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8390
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.56,
					"enrolment": 734,
					"ligo": 0.89,
					"location": [
						151.487843953477,
						-33.104707144364
					],
					"name": "Morisset High School",
					"playspace": 63.99,
					"projections": [
						836,
						734,
						795,
						815,
						815,
						810
					],
					"projections_orig": [
						"836",
						"734",
						"795",
						"815",
						"815",
						"810"
					],
					"projections_percentage": [
						13.9,
						0,
						8.31,
						11.04,
						11.04,
						10.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8413
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 55
					},
					"classroomspace": 3.24,
					"enrolment": 1301,
					"ligo": 0.83,
					"location": [
						151.652966859827,
						-32.9687051245795
					],
					"name": "Warners Bay High School",
					"playspace": 35.97,
					"projections": [
						1342,
						1301,
						1305,
						1330,
						1330,
						1340
					],
					"projections_orig": [
						"1342",
						"1301",
						"1305",
						"1330",
						"1330",
						"1340"
					],
					"projections_percentage": [
						3.15,
						0,
						0.31,
						2.23,
						2.23,
						3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8440
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.24,
					"enrolment": 963,
					"ligo": 0.79,
					"location": [
						151.583749396501,
						-33.0087108965174
					],
					"name": "Toronto High School",
					"playspace": 26.19,
					"projections": [
						891,
						963,
						945,
						955,
						955,
						960
					],
					"projections_orig": [
						"891",
						"963",
						"945",
						"955",
						"955",
						"960"
					],
					"projections_percentage": [
						-7.48,
						0,
						-1.87,
						-0.83,
						-0.83,
						-0.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8909
				}
			],
			"uid": 20055
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 145
			},
			"enrolment": 2745,
			"level": "Secondary",
			"ligo": 0.8,
			"name": "Port Stephens Secondary",
			"playspace": 53.77,
			"projections": [
				2745,
				2880,
				3045,
				3090,
				3110
			],
			"projections_percentage": [
				0,
				4.92,
				10.93,
				12.57,
				13.3
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 47
					},
					"classroomspace": 3.97,
					"enrolment": 792,
					"ligo": 0.63,
					"location": [
						151.733405087367,
						-32.7811706949422
					],
					"name": "Hunter River High School",
					"playspace": 65.93,
					"projections": [
						693,
						792,
						835,
						870,
						880,
						885
					],
					"projections_orig": [
						"693",
						"792",
						"835",
						"870",
						"880",
						"885"
					],
					"projections_percentage": [
						-12.5,
						0,
						5.43,
						9.85,
						11.11,
						11.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8219
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 53
					},
					"classroomspace": 3.88,
					"enrolment": 1206,
					"ligo": 0.92,
					"location": [
						152.112364453151,
						-32.7356385478459
					],
					"name": "Tomaree High School",
					"playspace": 49.46,
					"projections": [
						1266,
						1206,
						1290,
						1380,
						1405,
						1420
					],
					"projections_orig": [
						"1266",
						"1206",
						"1290",
						"1380",
						"1405",
						"1420"
					],
					"projections_percentage": [
						4.98,
						0,
						6.97,
						14.43,
						16.5,
						17.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8502
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 45
					},
					"classroomspace": 3.94,
					"enrolment": 747,
					"ligo": 0.85,
					"location": [
						151.766875625528,
						-32.7632252002387
					],
					"name": "Irrawang High School",
					"playspace": 45.93,
					"projections": [
						887,
						747,
						755,
						795,
						805,
						805
					],
					"projections_orig": [
						"887",
						"747",
						"755",
						"795",
						"805",
						"805"
					],
					"projections_percentage": [
						18.74,
						0,
						1.07,
						6.43,
						7.76,
						7.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8562
				}
			],
			"uid": 20056
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 213
			},
			"enrolment": 3921,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Maitland Secondary",
			"playspace": 37.27,
			"projections": [
				3921,
				4350,
				4535,
				4620,
				4685
			],
			"projections_percentage": [
				0,
				10.94,
				15.66,
				17.83,
				19.48
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.26,
					"enrolment": 899,
					"ligo": 0.75,
					"location": [
						151.596998211836,
						-32.7470143856334
					],
					"name": "Maitland High School",
					"playspace": 18.63,
					"projections": [
						856,
						899,
						940,
						960,
						970,
						975
					],
					"projections_orig": [
						"856",
						"899",
						"940",
						"960",
						"970",
						"975"
					],
					"projections_percentage": [
						-4.78,
						0,
						4.56,
						6.79,
						7.9,
						8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8126
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 54
					},
					"classroomspace": 2.95,
					"enrolment": 1274,
					"ligo": 0.61,
					"location": [
						151.591138306447,
						-32.744242443947
					],
					"name": "Maitland Grossmann High School",
					"playspace": 26.31,
					"projections": [
						1254,
						1274,
						1425,
						1495,
						1520,
						1545
					],
					"projections_orig": [
						"1254",
						"1274",
						"1425",
						"1495",
						"1520",
						"1545"
					],
					"projections_percentage": [
						-1.57,
						0,
						11.85,
						17.35,
						19.31,
						21.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8127
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 4.02,
					"enrolment": 713,
					"ligo": 0.87,
					"location": [
						151.660589897752,
						-32.7980756687372
					],
					"name": "Francis Greenway High School",
					"playspace": 57.25,
					"projections": [
						812,
						713,
						810,
						860,
						880,
						895
					],
					"projections_orig": [
						"812",
						"713",
						"810",
						"860",
						"880",
						"895"
					],
					"projections_percentage": [
						13.88,
						0,
						13.6,
						20.62,
						23.42,
						25.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8439
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 65
					},
					"classroomspace": 3.93,
					"enrolment": 1035,
					"ligo": 0.89,
					"location": [
						151.531920558882,
						-32.7111545152755
					],
					"name": "Rutherford High School",
					"playspace": 46.9,
					"projections": [
						1150,
						1035,
						1175,
						1220,
						1250,
						1270
					],
					"projections_orig": [
						"1150",
						"1035",
						"1175",
						"1220",
						"1250",
						"1270"
					],
					"projections_percentage": [
						11.11,
						0,
						13.53,
						17.87,
						20.77,
						22.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8572
				}
			],
			"uid": 20057
		},
		{
			"classrooms": {
				"demountable": 25,
				"permanent": 287
			},
			"enrolment": 5007,
			"level": "Secondary",
			"ligo": 0.77,
			"name": "South West Growth Area (North) Secondary",
			"playspace": 252.35,
			"projections": [
				5007,
				6495,
				8340,
				10650,
				13250
			],
			"projections_percentage": [
				0,
				29.72,
				66.57,
				112.7,
				164.63
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 44
					},
					"classroomspace": 3.36,
					"enrolment": 955,
					"ligo": 1,
					"location": [
						150.892377073846,
						-33.9696727971773
					],
					"name": "Hurlstone Agricultural High School",
					"playspace": 1256.73,
					"projections": [
						986,
						955,
						955,
						950,
						945,
						930
					],
					"projections_orig": [
						"986",
						"955",
						"955",
						"950",
						"945",
						"930"
					],
					"projections_percentage": [
						3.25,
						0,
						0,
						-0.52,
						-1.05,
						-2.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8121
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 43
					},
					"classroomspace": 4.77,
					"enrolment": 662,
					"ligo": 0.66,
					"location": [
						150.87256149969,
						-34.0052146068853
					],
					"name": "Ingleburn High School",
					"playspace": 69.54,
					"projections": [
						795,
						662,
						855,
						1145,
						1445,
						1790
					],
					"projections_orig": [
						"795",
						"662",
						"855",
						"1145",
						"1445",
						"1790"
					],
					"projections_percentage": [
						20.09,
						0,
						29.15,
						72.96,
						118.28,
						170.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8262
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 49
					},
					"classroomspace": 2.96,
					"enrolment": 1194,
					"ligo": 0.8,
					"location": [
						150.843454750446,
						-33.9452281704985
					],
					"name": "John Edmondson High School",
					"playspace": 26.25,
					"projections": [
						1105,
						1194,
						2185,
						3455,
						5220,
						7135
					],
					"projections_orig": [
						"1105",
						"1194",
						"2185",
						"3455",
						"5220",
						"7135"
					],
					"projections_percentage": [
						-7.45,
						0,
						83,
						189.36,
						337.19,
						497.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8290
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 4.51,
					"enrolment": 797,
					"ligo": 0.76,
					"location": [
						150.894608350515,
						-33.9528351557082
					],
					"name": "Casula High School",
					"playspace": 74.98,
					"projections": [
						664,
						797,
						865,
						980,
						1075,
						1220
					],
					"projections_orig": [
						"664",
						"797",
						"865",
						"980",
						"1075",
						"1220"
					],
					"projections_percentage": [
						-16.69,
						0,
						8.53,
						22.96,
						34.88,
						53.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8476
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 11.71,
					"enrolment": 294,
					"ligo": 0.67,
					"location": [
						150.892351050242,
						-33.9874604762047
					],
					"name": "James Meehan High School",
					"playspace": 65.31,
					"projections": [
						334,
						294,
						385,
						400,
						415,
						440
					],
					"projections_orig": [
						"334",
						"294",
						"385",
						"400",
						"415",
						"440"
					],
					"projections_percentage": [
						13.61,
						0,
						30.95,
						36.05,
						41.16,
						49.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8497
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 44
					},
					"classroomspace": 3.04,
					"enrolment": 1105,
					"ligo": 0.47,
					"location": [
						150.886219647293,
						-33.997866060942
					],
					"name": "Macquarie Fields High School",
					"playspace": 21.31,
					"projections": [
						1071,
						1105,
						1250,
						1410,
						1550,
						1735
					],
					"projections_orig": [
						"1071",
						"1105",
						"1250",
						"1410",
						"1550",
						"1735"
					],
					"projections_percentage": [
						-3.08,
						0,
						13.12,
						27.6,
						40.27,
						57.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8553
				}
			],
			"uid": 20058
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 213
			},
			"enrolment": 2025,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Inner Western Plains Network",
			"playspace": 311.03,
			"projections": [
				2026,
				2093,
				2033,
				1983,
				1973
			],
			"projections_percentage": [
				0,
				3.31,
				0.35,
				-2.12,
				-2.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 5.9,
					"enrolment": 108,
					"ligo": 1,
					"location": [
						149.069244423571,
						-30.9504523787765
					],
					"name": "Baradine Central School",
					"playspace": 139.94,
					"projections": [
						134,
						109,
						110,
						110,
						105,
						110
					],
					"projections_orig": [
						"134",
						"109",
						"110",
						"110",
						"105",
						"110"
					],
					"projections_percentage": [
						22.94,
						0,
						0.92,
						0.92,
						-3.67,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1130
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 9.43,
					"enrolment": 67,
					"ligo": 1,
					"location": [
						149.376032333899,
						-31.5532803268171
					],
					"name": "Binnaway Central School",
					"playspace": 273.75,
					"projections": [
						100,
						67,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"100",
						"67",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						49.25,
						0,
						11.94,
						11.94,
						11.94,
						11.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1237
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.54,
					"enrolment": 304,
					"ligo": 1,
					"location": [
						149.281687122708,
						-31.2794543726138
					],
					"name": "Coonabarabran Public School",
					"playspace": 65.67,
					"projections": [
						309,
						304,
						335,
						310,
						305,
						310
					],
					"projections_orig": [
						"309",
						"304",
						"335",
						"310",
						"305",
						"310"
					],
					"projections_percentage": [
						1.64,
						0,
						10.2,
						1.97,
						0.33,
						1.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1630
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 5.56,
					"enrolment": 195,
					"ligo": 1,
					"location": [
						148.387141157679,
						-30.9594382561554
					],
					"name": "Coonamble Public School",
					"playspace": 258.98,
					"projections": [
						219,
						195,
						215,
						185,
						185,
						185
					],
					"projections_orig": [
						"219",
						"195",
						"215",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						12.31,
						0,
						10.26,
						-5.13,
						-5.13,
						-5.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1631
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.19,
					"enrolment": 201,
					"ligo": 1,
					"location": [
						148.664138785053,
						-31.7075009234984
					],
					"name": "Gilgandra Public School",
					"playspace": 53.83,
					"projections": [
						201,
						201,
						190,
						185,
						185,
						185
					],
					"projections_orig": [
						"201",
						"201",
						"190",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						0,
						0,
						-5.47,
						-7.96,
						-7.96,
						-7.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1979
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 11.72,
					"enrolment": 74,
					"ligo": 0.93,
					"location": [
						148.475802940521,
						-31.3327606788151
					],
					"name": "Gulargambone Central School",
					"playspace": 204.88,
					"projections": [
						66,
						74,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"66",
						"74",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						-10.81,
						0,
						1.35,
						1.35,
						1.35,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2094
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.62,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						147.871379871191,
						-30.9309645807459
					],
					"name": "Quambone Public School",
					"playspace": 710.49,
					"projections": [
						23,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						53.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2919
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 8.67,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						148.910762998736,
						-31.4349109320988
					],
					"name": "Tooraweenah Public School",
					"playspace": 1294.51,
					"projections": [
						35,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"35",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						52.17,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3242
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 11.22,
					"enrolment": 198,
					"ligo": 1,
					"location": [
						147.836595797128,
						-31.7040702841512
					],
					"name": "Warren Central School",
					"playspace": 311.28,
					"projections": [
						247,
						198,
						180,
						175,
						175,
						180
					],
					"projections_orig": [
						"247",
						"198",
						"180",
						"175",
						"175",
						"180"
					],
					"projections_percentage": [
						24.75,
						0,
						-9.09,
						-11.62,
						-11.62,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3392
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 5.14,
					"enrolment": 397,
					"ligo": 1,
					"location": [
						149.283298904734,
						-31.28344767585
					],
					"name": "Coonabarabran High School",
					"playspace": 83.23,
					"projections": [
						424,
						397,
						385,
						380,
						370,
						355
					],
					"projections_orig": [
						"424",
						"397",
						"385",
						"380",
						"370",
						"355"
					],
					"projections_percentage": [
						6.8,
						0,
						-3.02,
						-4.28,
						-6.8,
						-10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8347
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 33
					},
					"classroomspace": 9.25,
					"enrolment": 240,
					"ligo": 1,
					"location": [
						148.665643838396,
						-31.7052082654448
					],
					"name": "Gilgandra High School",
					"playspace": 229.02,
					"projections": [
						327,
						240,
						295,
						290,
						270,
						270
					],
					"projections_orig": [
						"327",
						"240",
						"295",
						"290",
						"270",
						"270"
					],
					"projections_percentage": [
						36.25,
						0,
						22.92,
						20.83,
						12.5,
						12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8349
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 26
					},
					"classroomspace": 10.47,
					"enrolment": 203,
					"ligo": 0.96,
					"location": [
						148.391287383533,
						-30.9551865656227
					],
					"name": "Coonamble High School",
					"playspace": 106.76,
					"projections": [
						210,
						203,
						195,
						210,
						200,
						190
					],
					"projections_orig": [
						"210",
						"203",
						"195",
						"210",
						"200",
						"190"
					],
					"projections_percentage": [
						3.45,
						0,
						-3.94,
						3.45,
						-1.48,
						-6.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8451
				}
			],
			"uid": 30008
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 491
			},
			"enrolment": 6620,
			"level": "Combined",
			"ligo": 1,
			"name": "Lachlan Network",
			"playspace": 329.27,
			"projections": [
				6619,
				6668,
				6313,
				5963,
				5653
			],
			"projections_percentage": [
				0,
				0.74,
				-4.62,
				-9.91,
				-14.59
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.31,
					"enrolment": 50,
					"ligo": 1,
					"location": [
						147.678392635967,
						-33.3623139308499
					],
					"name": "Bedgerebong Public School",
					"playspace": 689.27,
					"projections": [
						36,
						50,
						50,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"50",
						"50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-28,
						0,
						0,
						-50,
						-50,
						-50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1164
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 14.5,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						147.798625523471,
						-33.1055259135789
					],
					"name": "Bogan Gate Public School",
					"playspace": 2702.18,
					"projections": [
						26,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						136.36,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1274
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.51,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						147.744499396931,
						-33.8448368721891
					],
					"name": "Caragabal Public School",
					"playspace": 442.46,
					"projections": [
						14,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-48.15,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1503
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.04,
					"enrolment": 281,
					"ligo": 1,
					"location": [
						147.149190252987,
						-33.0846515029126
					],
					"name": "Condobolin Public School",
					"playspace": 85.8,
					"projections": [
						273,
						281,
						265,
						245,
						230,
						215
					],
					"projections_orig": [
						"273",
						"281",
						"265",
						"245",
						"230",
						"215"
					],
					"projections_percentage": [
						-2.85,
						0,
						-5.69,
						-12.81,
						-18.15,
						-23.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1609
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 3.57,
					"enrolment": 391,
					"ligo": 1,
					"location": [
						148.690201114581,
						-33.8364078115025
					],
					"name": "Cowra Public School",
					"playspace": 24.46,
					"projections": [
						327,
						391,
						340,
						310,
						285,
						260
					],
					"projections_orig": [
						"327",
						"391",
						"340",
						"310",
						"285",
						"260"
					],
					"projections_percentage": [
						-16.37,
						0,
						-13.04,
						-20.72,
						-27.11,
						-33.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1671
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 10.61,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						148.368379147457,
						-33.4234041810687
					],
					"name": "Eugowra Public School",
					"playspace": 817.3,
					"projections": [
						27,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1870
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.71,
					"enrolment": 297,
					"ligo": 1,
					"location": [
						148.005849837739,
						-33.3871982665195
					],
					"name": "Forbes Public School",
					"playspace": 97.01,
					"projections": [
						282,
						297,
						285,
						250,
						235,
						220
					],
					"projections_orig": [
						"282",
						"297",
						"285",
						"250",
						"235",
						"220"
					],
					"projections_percentage": [
						-5.05,
						0,
						-4.04,
						-15.82,
						-20.88,
						-25.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1926
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 16.66,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						148.400656896921,
						-33.9976358120619
					],
					"name": "Greenethorpe Public School",
					"playspace": 529.94,
					"projections": [
						25,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						108.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2070
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.41,
					"enrolment": 191,
					"ligo": 1,
					"location": [
						148.167304299736,
						-33.8930922518073
					],
					"name": "Grenfell Public School",
					"playspace": 161.77,
					"projections": [
						188,
						191,
						205,
						180,
						170,
						160
					],
					"projections_orig": [
						"188",
						"191",
						"205",
						"180",
						"170",
						"160"
					],
					"projections_percentage": [
						-1.57,
						0,
						7.33,
						-5.76,
						-10.99,
						-16.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2082
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 5.63,
					"enrolment": 258,
					"ligo": 1,
					"location": [
						146.374498163008,
						-33.2946942000795
					],
					"name": "Lake Cargelligo Central School",
					"playspace": 51.99,
					"projections": [
						263,
						258,
						235,
						215,
						200,
						190
					],
					"projections_orig": [
						"263",
						"258",
						"235",
						"215",
						"200",
						"190"
					],
					"projections_percentage": [
						1.94,
						0,
						-8.91,
						-16.67,
						-22.48,
						-26.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2359
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.31,
					"enrolment": 310,
					"ligo": 1,
					"location": [
						148.243832243582,
						-32.2302282930769
					],
					"name": "Narromine Public School",
					"playspace": 36.62,
					"projections": [
						422,
						310,
						350,
						370,
						380,
						390
					],
					"projections_orig": [
						"422",
						"310",
						"350",
						"370",
						"380",
						"390"
					],
					"projections_percentage": [
						36.13,
						0,
						12.9,
						19.35,
						22.58,
						25.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2713
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.26,
					"enrolment": 132,
					"ligo": 1,
					"location": [
						147.194978320502,
						-31.5685453311989
					],
					"name": "Nyngan Public School",
					"playspace": 320.99,
					"projections": [
						151,
						132,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"151",
						"132",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						14.39,
						0,
						-1.52,
						-1.52,
						-1.52,
						-1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2785
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 3.08,
					"enrolment": 410,
					"ligo": 1,
					"location": [
						148.176827745359,
						-33.1333493975608
					],
					"name": "Parkes Public School",
					"playspace": 37.18,
					"projections": [
						476,
						410,
						465,
						430,
						380,
						365
					],
					"projections_orig": [
						"476",
						"410",
						"465",
						"430",
						"380",
						"365"
					],
					"projections_percentage": [
						16.1,
						0,
						13.41,
						4.88,
						-7.32,
						-10.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2835
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 6.58,
					"enrolment": 147,
					"ligo": 1,
					"location": [
						148.191721262054,
						-32.7279243512887
					],
					"name": "Peak Hill Central School",
					"playspace": 85.27,
					"projections": [
						181,
						147,
						145,
						150,
						155,
						155
					],
					"projections_orig": [
						"181",
						"147",
						"145",
						"150",
						"155",
						"155"
					],
					"projections_percentage": [
						23.13,
						0,
						-1.36,
						2.04,
						5.44,
						5.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2848
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 20.72,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						147.791661121654,
						-34.0104119718995
					],
					"name": "Quandialla Public School",
					"playspace": 916.88,
					"projections": [
						0,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"0",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-100,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2920
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 8.97,
					"enrolment": 88,
					"ligo": 1,
					"location": [
						147.353382438171,
						-32.2456096966049
					],
					"name": "Tottenham Central School",
					"playspace": 251.24,
					"projections": [
						109,
						88,
						90,
						80,
						75,
						75
					],
					"projections_orig": [
						"109",
						"88",
						"90",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						23.86,
						0,
						2.27,
						-9.09,
						-14.77,
						-14.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3249
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 5.36,
					"enrolment": 208,
					"ligo": 1,
					"location": [
						147.979808898831,
						-32.0328107892374
					],
					"name": "Trangie Central School",
					"playspace": 96.69,
					"projections": [
						164,
						207,
						200,
						210,
						215,
						220
					],
					"projections_orig": [
						"164",
						"207",
						"200",
						"210",
						"215",
						"220"
					],
					"projections_percentage": [
						-20.77,
						0,
						-3.38,
						1.45,
						3.86,
						6.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3254
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 6.37,
					"enrolment": 121,
					"ligo": 1,
					"location": [
						147.710497917906,
						-32.9251649601641
					],
					"name": "Trundle Central School",
					"playspace": 209.25,
					"projections": [
						107,
						121,
						100,
						105,
						105,
						110
					],
					"projections_orig": [
						"107",
						"121",
						"100",
						"105",
						"105",
						"110"
					],
					"projections_percentage": [
						-11.57,
						0,
						-17.36,
						-13.22,
						-13.22,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3259
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 9.05,
					"enrolment": 79,
					"ligo": 1,
					"location": [
						147.564732498098,
						-32.6351674319341
					],
					"name": "Tullamore Central School",
					"playspace": 611.16,
					"projections": [
						75,
						79,
						75,
						65,
						65,
						60
					],
					"projections_orig": [
						"75",
						"79",
						"75",
						"65",
						"65",
						"60"
					],
					"projections_percentage": [
						-5.06,
						0,
						-5.06,
						-17.72,
						-17.72,
						-24.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3270
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 9.05,
					"enrolment": 51,
					"ligo": 1,
					"location": [
						146.723438018481,
						-33.4236874249631
					],
					"name": "Tullibigeal Central School",
					"playspace": 536.56,
					"projections": [
						56,
						51,
						60,
						55,
						55,
						55
					],
					"projections_orig": [
						"56",
						"51",
						"60",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						9.8,
						0,
						17.65,
						7.84,
						7.84,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3272
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 2.62,
					"enrolment": 264,
					"ligo": 1,
					"location": [
						148.172623485822,
						-33.1467675991945
					],
					"name": "Middleton Public School",
					"playspace": 69.51,
					"projections": [
						270,
						264,
						240,
						215,
						200,
						190
					],
					"projections_orig": [
						"270",
						"264",
						"240",
						"215",
						"200",
						"190"
					],
					"projections_percentage": [
						2.27,
						0,
						-9.09,
						-18.56,
						-24.24,
						-28.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4089
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.78,
					"enrolment": 285,
					"ligo": 1,
					"location": [
						147.999944107519,
						-33.3701527635083
					],
					"name": "Forbes North Public School",
					"playspace": 120.8,
					"projections": [
						270,
						285,
						280,
						245,
						225,
						210
					],
					"projections_orig": [
						"270",
						"285",
						"280",
						"245",
						"225",
						"210"
					],
					"projections_percentage": [
						-5.26,
						0,
						-1.75,
						-14.04,
						-21.05,
						-26.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4100
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.83,
					"enrolment": 294,
					"ligo": 1,
					"location": [
						148.189484436647,
						-33.1363667730568
					],
					"name": "Parkes East Public School",
					"playspace": 61.54,
					"projections": [
						211,
						294,
						250,
						225,
						215,
						205
					],
					"projections_orig": [
						"211",
						"294",
						"250",
						"225",
						"215",
						"205"
					],
					"projections_percentage": [
						-28.23,
						0,
						-14.97,
						-23.47,
						-26.87,
						-30.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4204
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.95,
					"enrolment": 304,
					"ligo": 1,
					"location": [
						148.688585604444,
						-33.8218127445699
					],
					"name": "Mulyan Public School",
					"playspace": 103.95,
					"projections": [
						349,
						304,
						340,
						310,
						285,
						260
					],
					"projections_orig": [
						"349",
						"304",
						"340",
						"310",
						"285",
						"260"
					],
					"projections_percentage": [
						14.8,
						0,
						11.84,
						1.97,
						-6.25,
						-14.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5242
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 44
					},
					"classroomspace": 5.05,
					"enrolment": 605,
					"ligo": 1,
					"location": [
						148.180824171764,
						-33.138710142537
					],
					"name": "Parkes High School",
					"playspace": 49.93,
					"projections": [
						677,
						605,
						655,
						640,
						590,
						530
					],
					"projections_orig": [
						"677",
						"605",
						"655",
						"640",
						"590",
						"530"
					],
					"projections_percentage": [
						11.9,
						0,
						8.26,
						5.79,
						-2.48,
						-12.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8146
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 41
					},
					"classroomspace": 4.9,
					"enrolment": 569,
					"ligo": 1,
					"location": [
						148.687914058999,
						-33.815530092037
					],
					"name": "Cowra High School",
					"playspace": 121.88,
					"projections": [
						749,
						569,
						675,
						670,
						620,
						545
					],
					"projections_orig": [
						"749",
						"569",
						"675",
						"670",
						"620",
						"545"
					],
					"projections_percentage": [
						31.63,
						0,
						18.63,
						17.75,
						8.96,
						-4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8148
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 5.23,
					"enrolment": 390,
					"ligo": 1,
					"location": [
						148.011925142818,
						-33.3627773463266
					],
					"name": "Forbes High School",
					"playspace": 196.47,
					"projections": [
						390,
						390,
						345,
						315,
						285,
						255
					],
					"projections_orig": [
						"390",
						"390",
						"345",
						"315",
						"285",
						"255"
					],
					"projections_percentage": [
						0,
						0,
						-11.54,
						-19.23,
						-26.92,
						-34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8194
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 6.44,
					"enrolment": 171,
					"ligo": 1,
					"location": [
						148.163756723246,
						-33.9017079461063
					],
					"name": "The Henry Lawson High School",
					"playspace": 296.35,
					"projections": [
						224,
						171,
						165,
						160,
						140,
						130
					],
					"projections_orig": [
						"224",
						"171",
						"165",
						"160",
						"140",
						"130"
					],
					"projections_percentage": [
						30.99,
						0,
						-3.51,
						-6.43,
						-18.13,
						-23.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8314
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 7.87,
					"enrolment": 214,
					"ligo": 1,
					"location": [
						147.141615548873,
						-33.091277239563
					],
					"name": "Condobolin High School",
					"playspace": 206.05,
					"projections": [
						252,
						214,
						215,
						185,
						170,
						160
					],
					"projections_orig": [
						"252",
						"214",
						"215",
						"185",
						"170",
						"160"
					],
					"projections_percentage": [
						17.76,
						0,
						0.47,
						-13.55,
						-20.56,
						-25.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8346
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 7.67,
					"enrolment": 177,
					"ligo": 1,
					"location": [
						147.189449692351,
						-31.5611051521307
					],
					"name": "Nyngan High School",
					"playspace": 68.41,
					"projections": [
						183,
						177,
						175,
						160,
						155,
						160
					],
					"projections_orig": [
						"183",
						"177",
						"175",
						"160",
						"155",
						"160"
					],
					"projections_percentage": [
						3.39,
						0,
						-1.13,
						-9.6,
						-12.43,
						-9.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8353
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 8.78,
					"enrolment": 230,
					"ligo": 1,
					"location": [
						148.242892751698,
						-32.2301032379727
					],
					"name": "Narromine High School",
					"playspace": 208.53,
					"projections": [
						253,
						230,
						230,
						240,
						245,
						250
					],
					"projections_orig": [
						"253",
						"230",
						"230",
						"240",
						"245",
						"250"
					],
					"projections_percentage": [
						10,
						0,
						0,
						4.35,
						6.52,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8462
				}
			],
			"uid": 30009
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 126
			},
			"enrolment": 1721,
			"level": "Combined",
			"ligo": 0.55,
			"name": "Lithgow",
			"playspace": 69.78,
			"projections": [
				1721,
				1735,
				1675,
				1610,
				1535
			],
			"projections_percentage": [
				0,
				0.81,
				-2.67,
				-6.45,
				-10.81
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 4.15,
					"enrolment": 348,
					"ligo": 0.74,
					"location": [
						150.141598700548,
						-33.4835722663985
					],
					"name": "Cooerwull Public School",
					"playspace": 40.91,
					"projections": [
						295,
						348,
						300,
						290,
						280,
						270
					],
					"projections_orig": [
						"295",
						"348",
						"300",
						"290",
						"280",
						"270"
					],
					"projections_percentage": [
						-15.23,
						0,
						-13.79,
						-16.67,
						-19.54,
						-22.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1615
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 3.26,
					"enrolment": 453,
					"ligo": 0.48,
					"location": [
						150.159429392331,
						-33.4821133418147
					],
					"name": "Lithgow Public School",
					"playspace": 27.76,
					"projections": [
						444,
						453,
						460,
						425,
						410,
						400
					],
					"projections_orig": [
						"444",
						"453",
						"460",
						"425",
						"410",
						"400"
					],
					"projections_percentage": [
						-1.99,
						0,
						1.55,
						-6.18,
						-9.49,
						-11.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2410
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.32,
					"enrolment": 101,
					"ligo": 0.13,
					"location": [
						150.182518502938,
						-33.4654106777803
					],
					"name": "Zig Zag Public School",
					"playspace": 103.53,
					"projections": [
						68,
						101,
						85,
						80,
						80,
						80
					],
					"projections_orig": [
						"68",
						"101",
						"85",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-32.67,
						0,
						-15.84,
						-20.79,
						-20.79,
						-20.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3566
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 4.83,
					"enrolment": 819,
					"ligo": 0.86,
					"location": [
						150.163367669013,
						-33.4854183793769
					],
					"name": "Lithgow High School",
					"playspace": 106.91,
					"projections": [
						882,
						819,
						890,
						880,
						840,
						785
					],
					"projections_orig": [
						"882",
						"819",
						"890",
						"880",
						"840",
						"785"
					],
					"projections_percentage": [
						7.69,
						0,
						8.67,
						7.45,
						2.56,
						-4.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8125
				}
			],
			"uid": 30010
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 244
			},
			"enrolment": 4188,
			"level": "Combined",
			"ligo": 0.97,
			"name": "Macquarie Network",
			"playspace": 445.16,
			"projections": [
				4189,
				4400,
				4490,
				4440,
				4420
			],
			"projections_percentage": [
				0,
				5.04,
				7.19,
				5.99,
				5.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.59,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						148.899622472128,
						-32.1935838965433
					],
					"name": "Ballimore Public School",
					"playspace": 912.14,
					"projections": [
						10,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-52.38,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1111
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 5.13,
					"enrolment": 239,
					"ligo": 1,
					"location": [
						149.722298163527,
						-31.8224377866906
					],
					"name": "Coolah Central School",
					"playspace": 189.17,
					"projections": [
						237,
						240,
						225,
						215,
						215,
						215
					],
					"projections_orig": [
						"237",
						"240",
						"225",
						"215",
						"215",
						"215"
					],
					"projections_percentage": [
						-1.25,
						0,
						-6.25,
						-10.42,
						-10.42,
						-10.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1621
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 6.83,
					"enrolment": 192,
					"ligo": 1,
					"location": [
						149.392353409807,
						-32.0174122120399
					],
					"name": "Dunedoo Central School",
					"playspace": 118.74,
					"projections": [
						213,
						192,
						210,
						220,
						230,
						240
					],
					"projections_orig": [
						"213",
						"192",
						"210",
						"220",
						"230",
						"240"
					],
					"projections_percentage": [
						10.94,
						0,
						9.38,
						14.58,
						19.79,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1789
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.35,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						148.621028693746,
						-31.950677770433
					],
					"name": "Eumungerie Public School",
					"playspace": 197.05,
					"projections": [
						15,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-31.82,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1873
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.24,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						148.829112130724,
						-32.3962801771912
					],
					"name": "Geurie Public School",
					"playspace": 234.95,
					"projections": [
						41,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"41",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1972
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 7.48,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.268269931195,
						-32.3684495909664
					],
					"name": "Goolma Public School",
					"playspace": 1719.53,
					"projections": [
						5,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"5",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-37.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2036
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 10
					},
					"classroomspace": 2.84,
					"enrolment": 307,
					"ligo": 1,
					"location": [
						149.537485417056,
						-32.3602309644135
					],
					"name": "Gulgong Public School",
					"playspace": 36.06,
					"projections": [
						216,
						307,
						275,
						290,
						300,
						310
					],
					"projections_orig": [
						"216",
						"307",
						"275",
						"290",
						"300",
						"310"
					],
					"projections_percentage": [
						-29.64,
						0,
						-10.42,
						-5.54,
						-2.28,
						0.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2097
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 9.46,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						149.462268910244,
						-32.7838643647652
					],
					"name": "Hargraves Public School",
					"playspace": 460.07,
					"projections": [
						25,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						19.05,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.26,
					"enrolment": 19,
					"ligo": 1,
					"location": [
						149.845123661127,
						-32.6560734565184
					],
					"name": "Lue Public School",
					"playspace": 343.37,
					"projections": [
						23,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						21.05,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2432
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 2.87,
					"enrolment": 651,
					"ligo": 0.76,
					"location": [
						149.585148487815,
						-32.5953213052809
					],
					"name": "Mudgee Public School",
					"playspace": 31.66,
					"projections": [
						523,
						651,
						690,
						685,
						640,
						635
					],
					"projections_orig": [
						"523",
						"651",
						"690",
						"685",
						"640",
						"635"
					],
					"projections_percentage": [
						-19.66,
						0,
						5.99,
						5.22,
						-1.69,
						-2.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2656
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.29,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						149.051870425469,
						-32.7224678954576
					],
					"name": "Mumbil Public School",
					"playspace": 745.65,
					"projections": [
						25,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						66.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2669
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.5,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						149.068926735141,
						-32.8022344625188
					],
					"name": "Stuart Town Public School",
					"playspace": 1356.06,
					"projections": [
						16,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						77.78,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3127
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.96,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						149.742979351594,
						-32.2816610236388
					],
					"name": "Ulan Public School",
					"playspace": 689.43,
					"projections": [
						12,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-20,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3300
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 24
					},
					"classroomspace": 3.46,
					"enrolment": 487,
					"ligo": 1,
					"location": [
						148.943944715375,
						-32.5563300804071
					],
					"name": "Wellington Public School",
					"playspace": 31.8,
					"projections": [
						517,
						487,
						495,
						505,
						525,
						525
					],
					"projections_orig": [
						"517",
						"487",
						"495",
						"505",
						"525",
						"525"
					],
					"projections_percentage": [
						6.16,
						0,
						1.64,
						3.7,
						7.8,
						7.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 14.97,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						149.949335168013,
						-32.356750213238
					],
					"name": "Wollar Public School",
					"playspace": 1747.68,
					"projections": [
						6,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"6",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						50,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3473
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.07,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						148.759010446267,
						-32.3336827294561
					],
					"name": "Wongarbon Public School",
					"playspace": 179.39,
					"projections": [
						68,
						61,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"68",
						"61",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						11.48,
						0,
						-1.64,
						6.56,
						6.56,
						6.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3487
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 5.77,
					"enrolment": 122,
					"ligo": 1,
					"location": [
						148.650105050933,
						-32.7540834577182
					],
					"name": "Yeoval Central School",
					"playspace": 106.47,
					"projections": [
						140,
						122,
						130,
						135,
						140,
						145
					],
					"projections_orig": [
						"140",
						"122",
						"130",
						"135",
						"140",
						"145"
					],
					"projections_percentage": [
						14.75,
						0,
						6.56,
						10.66,
						14.75,
						18.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3555
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.41,
					"enrolment": 563,
					"ligo": 0.88,
					"location": [
						149.584780851368,
						-32.6057480276227
					],
					"name": "Cudgegong Valley Public School",
					"playspace": 55.2,
					"projections": [
						590,
						563,
						580,
						575,
						530,
						525
					],
					"projections_orig": [
						"590",
						"563",
						"580",
						"575",
						"530",
						"525"
					],
					"projections_percentage": [
						4.8,
						0,
						3.02,
						2.13,
						-5.86,
						-6.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4555
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 56
					},
					"classroomspace": 4.5,
					"enrolment": 854,
					"ligo": 0.83,
					"location": [
						149.582538309928,
						-32.5977165592307
					],
					"name": "Mudgee High School",
					"playspace": 30.18,
					"projections": [
						1076,
						854,
						985,
						1025,
						1000,
						950
					],
					"projections_orig": [
						"1076",
						"854",
						"985",
						"1025",
						"1000",
						"950"
					],
					"projections_percentage": [
						26,
						0,
						15.34,
						20.02,
						17.1,
						11.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8128
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 5.9,
					"enrolment": 309,
					"ligo": 1,
					"location": [
						148.947001412446,
						-32.5472185503205
					],
					"name": "Wellington High School",
					"playspace": 108.62,
					"projections": [
						330,
						309,
						330,
						345,
						355,
						365
					],
					"projections_orig": [
						"330",
						"309",
						"330",
						"345",
						"355",
						"365"
					],
					"projections_percentage": [
						6.8,
						0,
						6.8,
						11.65,
						14.89,
						18.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8197
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 5.6,
					"enrolment": 228,
					"ligo": 0.94,
					"location": [
						149.538842738127,
						-32.3601501579611
					],
					"name": "Gulgong High School",
					"playspace": 55.11,
					"projections": [
						289,
						228,
						245,
						255,
						265,
						270
					],
					"projections_orig": [
						"289",
						"228",
						"245",
						"255",
						"265",
						"270"
					],
					"projections_percentage": [
						26.75,
						0,
						7.46,
						11.84,
						16.23,
						18.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8546
				}
			],
			"uid": 30011
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 109
			},
			"enrolment": 1771,
			"level": "Combined",
			"ligo": 1,
			"name": "Orange Network",
			"playspace": 509.85,
			"projections": [
				1771,
				1792,
				1858,
				1921,
				1953
			],
			"projections_percentage": [
				0,
				1.19,
				4.91,
				8.47,
				10.28
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.09,
					"enrolment": 107,
					"ligo": 1,
					"location": [
						149.046496941412,
						-33.3067347202423
					],
					"name": "Canobolas Public School",
					"playspace": 124.29,
					"projections": [
						87,
						107,
						115,
						120,
						125,
						125
					],
					"projections_orig": [
						"87",
						"107",
						"115",
						"120",
						"125",
						"125"
					],
					"projections_percentage": [
						-18.69,
						0,
						7.48,
						12.15,
						16.82,
						16.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1495
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.94,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						149.141782587341,
						-33.6118824921832
					],
					"name": "Carcoar Public School",
					"playspace": 551.89,
					"projections": [
						10,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.09,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1504
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.13,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						148.807979095663,
						-33.4274585258254
					],
					"name": "Cargo Public School",
					"playspace": 255.72,
					"projections": [
						20,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.09,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1506
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.18,
					"enrolment": 80,
					"ligo": 1,
					"location": [
						148.739587460045,
						-33.2874828446304
					],
					"name": "Cudal Public School",
					"playspace": 74.98,
					"projections": [
						61,
						80,
						85,
						85,
						90,
						90
					],
					"projections_orig": [
						"61",
						"80",
						"85",
						"85",
						"90",
						"90"
					],
					"projections_percentage": [
						-23.75,
						0,
						6.25,
						6.25,
						12.5,
						12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1695
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						148.749974234705,
						-32.9315133998386
					],
					"name": "Cumnock Public School",
					"playspace": 346.09,
					"projections": [
						59,
						56,
						50,
						50,
						55,
						55
					],
					"projections_orig": [
						"59",
						"56",
						"50",
						"50",
						"55",
						"55"
					],
					"projections_percentage": [
						5.36,
						0,
						-10.71,
						-10.71,
						-1.79,
						-1.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1707
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 12,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						149.091335702436,
						-32.9371450348621
					],
					"name": "Euchareena Public School",
					"playspace": 1234.04,
					"projections": [
						11,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						120,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1869
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.51,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						148.43625171815,
						-33.6175762745576
					],
					"name": "Gooloogong Public School",
					"playspace": 1012.93,
					"projections": [
						29,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						93.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2038
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.48,
					"enrolment": 42,
					"ligo": 1,
					"location": [
						148.756365773194,
						-33.8105715079421
					],
					"name": "Holmwood Public School",
					"playspace": 290.89,
					"projections": [
						46,
						42,
						60,
						55,
						55,
						50
					],
					"projections_orig": [
						"46",
						"42",
						"60",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						9.52,
						0,
						42.86,
						30.95,
						30.95,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2172
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.36,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						149.04433394794,
						-33.6734546487459
					],
					"name": "Lyndhurst Public School",
					"playspace": 639.84,
					"projections": [
						29,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2436
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 17.6,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.069976257905,
						-33.6515664137554
					],
					"name": "Mandurama Public School",
					"playspace": 1339.85,
					"projections": [
						28,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						180,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2460
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.79,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						148.701195973646,
						-33.1839946835656
					],
					"name": "Manildra Public School",
					"playspace": 882.55,
					"projections": [
						36,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-18.18,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2465
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 28
					},
					"classroomspace": 4.19,
					"enrolment": 482,
					"ligo": 1,
					"location": [
						148.863396640399,
						-33.0990161416206
					],
					"name": "Molong Central School",
					"playspace": 54.3,
					"projections": [
						508,
						482,
						505,
						540,
						555,
						550
					],
					"projections_orig": [
						"508",
						"482",
						"505",
						"540",
						"555",
						"550"
					],
					"projections_percentage": [
						5.39,
						0,
						4.77,
						12.03,
						15.15,
						14.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2590
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.66,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						149.120338630546,
						-33.139329201765
					],
					"name": "Mullion Creek Public School",
					"playspace": 117.31,
					"projections": [
						45,
						54,
						25,
						50,
						50,
						55
					],
					"projections_orig": [
						"45",
						"54",
						"<50",
						"50",
						"50",
						"55"
					],
					"projections_percentage": [
						-16.67,
						0,
						-53.7,
						-7.41,
						-7.41,
						1.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2664
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 3.35,
					"enrolment": 102,
					"ligo": 1,
					"location": [
						149.112892382097,
						-33.1918830233939
					],
					"name": "Clergate Public School",
					"playspace": 58.18,
					"projections": [
						73,
						102,
						100,
						105,
						110,
						115
					],
					"projections_orig": [
						"73",
						"102",
						"100",
						"105",
						"110",
						"115"
					],
					"projections_percentage": [
						-28.43,
						0,
						-1.96,
						2.94,
						7.84,
						12.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2668
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.77,
					"enrolment": 117,
					"ligo": 1,
					"location": [
						149.012710458739,
						-33.2939642030939
					],
					"name": "Nashdale Public School",
					"playspace": 51.61,
					"projections": [
						54,
						117,
						100,
						105,
						110,
						115
					],
					"projections_orig": [
						"54",
						"117",
						"100",
						"105",
						"110",
						"115"
					],
					"projections_percentage": [
						-53.85,
						0,
						-14.53,
						-10.26,
						-5.98,
						-1.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2714
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.75,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						149.151181800089,
						-33.3988390478682
					],
					"name": "Spring Hill Public School",
					"playspace": 506.15,
					"projections": [
						38,
						37,
						25,
						25,
						50,
						50
					],
					"projections_orig": [
						"38",
						"37",
						"<50",
						"<50",
						"50",
						"50"
					],
					"projections_percentage": [
						2.7,
						0,
						-32.43,
						-32.43,
						35.14,
						35.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3089
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.45,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						149.096948758146,
						-33.3941180722129
					],
					"name": "Spring Terrace Public School",
					"playspace": 786.28,
					"projections": [
						37,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						23.33,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3093
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 8.97,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						148.848316482707,
						-33.7463434505117
					],
					"name": "Woodstock Public School",
					"playspace": 1175.77,
					"projections": [
						16,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3499
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.32,
					"enrolment": 43,
					"ligo": 1,
					"location": [
						148.984411395755,
						-33.2504364219233
					],
					"name": "Borenore Public School",
					"playspace": 129.2,
					"projections": [
						47,
						43,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"47",
						"43",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						9.3,
						0,
						-41.86,
						-41.86,
						-41.86,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3504
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 22.89,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						148.947411208271,
						-33.9672229137613
					],
					"name": "Wyangala Dam Public School",
					"playspace": 1381,
					"projections": [
						10,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.86,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3521
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.5,
					"enrolment": 216,
					"ligo": 1,
					"location": [
						148.664882434732,
						-33.56720373076
					],
					"name": "Canowindra Public School",
					"playspace": 64.53,
					"projections": [
						180,
						216,
						215,
						225,
						230,
						240
					],
					"projections_orig": [
						"180",
						"216",
						"215",
						"225",
						"230",
						"240"
					],
					"projections_percentage": [
						-16.67,
						0,
						-0.46,
						4.17,
						6.48,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7301
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 6.22,
					"enrolment": 247,
					"ligo": 1,
					"location": [
						148.670656115608,
						-33.5574101755072
					],
					"name": "Canowindra High School",
					"playspace": 139.37,
					"projections": [
						222,
						247,
						240,
						255,
						260,
						270
					],
					"projections_orig": [
						"222",
						"247",
						"240",
						"255",
						"260",
						"270"
					],
					"projections_percentage": [
						-10.12,
						0,
						-2.83,
						3.24,
						5.26,
						9.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8518
				}
			],
			"uid": 30012
		},
		{
			"classrooms": {
				"demountable": 30,
				"permanent": 155
			},
			"enrolment": 2641,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Rural Bathurst Network",
			"playspace": 323.96,
			"projections": [
				2640,
				2778,
				2908,
				2998,
				3053
			],
			"projections_percentage": [
				0,
				5.23,
				10.15,
				13.56,
				15.64
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.9,
					"enrolment": 300,
					"ligo": 1,
					"location": [
						149.251581533113,
						-33.5298941251686
					],
					"name": "Blayney Public School",
					"playspace": 47.39,
					"projections": [
						227,
						300,
						305,
						320,
						330,
						340
					],
					"projections_orig": [
						"227",
						"300",
						"305",
						"320",
						"330",
						"340"
					],
					"projections_percentage": [
						-24.33,
						0,
						1.67,
						6.67,
						10,
						13.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1260
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						149.527980757925,
						-33.9497971810395
					],
					"name": "Burraga Public School",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1437
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.09,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						149.986318256808,
						-33.1470530078321
					],
					"name": "Capertee Public School",
					"playspace": 861.41,
					"projections": [
						8,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-33.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1501
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 6.54,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						150.032658477077,
						-33.3001867792845
					],
					"name": "Cullen Bullen Public School",
					"playspace": 196.19,
					"projections": [
						21,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.59,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1700
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 11.98,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						150.048455690144,
						-33.6484708834064
					],
					"name": "Hampton Public School",
					"playspace": 1199.21,
					"projections": [
						28,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						460,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.31,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.415605332119,
						-33.0344894607959
					],
					"name": "Hill End Public School",
					"playspace": 58.93,
					"projections": [
						5,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"5",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-37.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2161
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.43,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						149.855957298595,
						-32.96656012727
					],
					"name": "Ilford Public School",
					"playspace": 490.19,
					"projections": [
						31,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.06,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2201
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.6,
					"enrolment": 146,
					"ligo": 1,
					"location": [
						149.974171494519,
						-32.8562710874638
					],
					"name": "Kandos Public School",
					"playspace": 21.59,
					"projections": [
						173,
						146,
						160,
						170,
						175,
						180
					],
					"projections_orig": [
						"173",
						"146",
						"160",
						"170",
						"175",
						"180"
					],
					"projections_percentage": [
						18.49,
						0,
						9.59,
						16.44,
						19.86,
						23.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2254
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.68,
					"enrolment": 46,
					"ligo": 1,
					"location": [
						149.920729789809,
						-33.4338146352428
					],
					"name": "Meadow Flat Public School",
					"playspace": 224.51,
					"projections": [
						48,
						46,
						55,
						55,
						60,
						60
					],
					"projections_orig": [
						"48",
						"46",
						"55",
						"55",
						"60",
						"60"
					],
					"projections_percentage": [
						4.35,
						0,
						19.57,
						19.57,
						30.43,
						30.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2509
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 4
					},
					"classroomspace": 2.83,
					"enrolment": 288,
					"ligo": 1,
					"location": [
						149.185535764606,
						-33.4456486870839
					],
					"name": "Millthorpe Public School",
					"playspace": 25.24,
					"projections": [
						208,
						288,
						265,
						280,
						290,
						300
					],
					"projections_orig": [
						"208",
						"288",
						"265",
						"280",
						"290",
						"300"
					],
					"projections_percentage": [
						-27.78,
						0,
						-7.99,
						-2.78,
						0.69,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2558
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.16,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						149.217034428911,
						-33.7092505029486
					],
					"name": "Neville Public School",
					"playspace": 1021.93,
					"projections": [
						13,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-23.53,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2732
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.27,
					"enrolment": 241,
					"ligo": 1,
					"location": [
						149.864811791342,
						-33.7037961407204
					],
					"name": "Oberon Public School",
					"playspace": 71.02,
					"projections": [
						240,
						241,
						245,
						255,
						265,
						275
					],
					"projections_orig": [
						"240",
						"241",
						"245",
						"255",
						"265",
						"275"
					],
					"projections_percentage": [
						-0.41,
						0,
						1.66,
						5.81,
						9.96,
						14.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2797
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.77,
					"enrolment": 82,
					"ligo": 1,
					"location": [
						149.719786651342,
						-33.5239173614698
					],
					"name": "O'Connell Public School",
					"playspace": 60.91,
					"projections": [
						69,
						82,
						80,
						85,
						90,
						90
					],
					"projections_orig": [
						"69",
						"82",
						"80",
						"85",
						"90",
						"90"
					],
					"projections_percentage": [
						-15.85,
						0,
						-2.44,
						3.66,
						9.76,
						9.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2798
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 7.71,
					"enrolment": 156,
					"ligo": 0.72,
					"location": [
						149.979749868341,
						-33.3545708580771
					],
					"name": "Portland Central School",
					"playspace": 60.1,
					"projections": [
						181,
						156,
						190,
						200,
						210,
						210
					],
					"projections_orig": [
						"181",
						"156",
						"190",
						"200",
						"210",
						"210"
					],
					"projections_percentage": [
						16.03,
						0,
						21.79,
						28.21,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2897
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.17,
					"enrolment": 89,
					"ligo": 1,
					"location": [
						149.973106317692,
						-32.7959670765477
					],
					"name": "Rylstone Public School",
					"playspace": 93.81,
					"projections": [
						92,
						89,
						90,
						95,
						100,
						100
					],
					"projections_orig": [
						"92",
						"89",
						"90",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						3.37,
						0,
						1.12,
						6.74,
						12.36,
						12.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3025
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.1,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.695333322702,
						-33.0818330976601
					],
					"name": "Sofala Public School",
					"playspace": 527.72,
					"projections": [
						13,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						30,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3077
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 7.6,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.326443779304,
						-33.8166295092179
					],
					"name": "Trunkey Public School",
					"playspace": "NA",
					"projections": [
						16,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						60,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3260
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 2.34,
					"enrolment": 300,
					"ligo": 1,
					"location": [
						150.071203565712,
						-33.4187695132892
					],
					"name": "Wallerawang Public School",
					"playspace": 134.26,
					"projections": [
						262,
						300,
						300,
						310,
						315,
						325
					],
					"projections_orig": [
						"262",
						"300",
						"300",
						"310",
						"315",
						"325"
					],
					"projections_percentage": [
						-12.67,
						0,
						0,
						3.33,
						5,
						8.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3354
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.23,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						149.693007817987,
						-33.1418736739584
					],
					"name": "Wattle Flat Public School",
					"playspace": 160.4,
					"projections": [
						18,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-30.77,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3402
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.8,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						150.215297356474,
						-33.0405084937572
					],
					"name": "Glen Alice Public School",
					"playspace": 420.55,
					"projections": [
						8,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-11.11,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3903
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 12.16,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						149.742081363505,
						-33.8461256115306
					],
					"name": "Black Springs Public School",
					"playspace": 1122.78,
					"projections": [
						20,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						122.22,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4190
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 27
					},
					"classroomspace": 7.79,
					"enrolment": 235,
					"ligo": 0.92,
					"location": [
						149.974114514213,
						-32.855590142865
					],
					"name": "Kandos High School",
					"playspace": 56.04,
					"projections": [
						257,
						234,
						235,
						250,
						255,
						265
					],
					"projections_orig": [
						"257",
						"234",
						"235",
						"250",
						"255",
						"265"
					],
					"projections_percentage": [
						9.83,
						0,
						0.43,
						6.84,
						8.97,
						13.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8318
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 17
					},
					"classroomspace": 4.83,
					"enrolment": 366,
					"ligo": 0.92,
					"location": [
						149.250917343563,
						-33.5319190956212
					],
					"name": "Blayney High School",
					"playspace": 137.53,
					"projections": [
						397,
						366,
						445,
						465,
						475,
						470
					],
					"projections_orig": [
						"397",
						"366",
						"445",
						"465",
						"475",
						"470"
					],
					"projections_percentage": [
						8.47,
						0,
						21.58,
						27.05,
						29.78,
						28.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8357
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 6.21,
					"enrolment": 224,
					"ligo": 0.88,
					"location": [
						149.859096763671,
						-33.7007422728358
					],
					"name": "Oberon High School",
					"playspace": 135.36,
					"projections": [
						219,
						224,
						240,
						255,
						265,
						270
					],
					"projections_orig": [
						"219",
						"224",
						"240",
						"255",
						"265",
						"270"
					],
					"projections_percentage": [
						-2.23,
						0,
						7.14,
						13.84,
						18.3,
						20.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8598
				}
			],
			"uid": 30013
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 18
			},
			"enrolment": 167,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Western Plains CWO",
			"playspace": 1460.32,
			"projections": [
				167,
				131,
				131,
				131,
				131
			],
			"projections_percentage": [
				0,
				-21.56,
				-21.56,
				-21.56,
				-21.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.34,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						146.908078132511,
						-31.2493858549166
					],
					"name": "Girilambone Public School",
					"playspace": 2182.28,
					"projections": [
						13,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						85.71,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1986
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.16,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						146.722928816162,
						-31.551028192104
					],
					"name": "Hermidale Public School",
					"playspace": 762.53,
					"projections": [
						12,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2155
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 6.67,
					"enrolment": 146,
					"ligo": 1,
					"location": [
						149.123610723193,
						-31.8180467819252
					],
					"name": "Mendooran Central School",
					"playspace": 240.35,
					"projections": [
						109,
						146,
						110,
						110,
						110,
						110
					],
					"projections_orig": [
						"109",
						"146",
						"110",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						-25.34,
						0,
						-24.66,
						-24.66,
						-24.66,
						-24.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2522
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 13.35,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						147.374157516447,
						-30.8780819854848
					],
					"name": "Marra Creek Public School",
					"playspace": 2656.11,
					"projections": [
						10,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						100,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4454
				}
			],
			"uid": 30014
		},
		{
			"classrooms": {
				"demountable": 32,
				"permanent": 262
			},
			"enrolment": 4471,
			"level": "Combined",
			"ligo": 0.68,
			"name": "Dubbo Urban",
			"playspace": 67.09,
			"projections": [
				4471,
				4880,
				4930,
				4790,
				4745
			],
			"projections_percentage": [
				0,
				9.15,
				10.27,
				7.13,
				6.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 17
					},
					"classroomspace": 2.44,
					"enrolment": 508,
					"ligo": 0.48,
					"location": [
						148.605867412442,
						-32.2487712293379
					],
					"name": "Dubbo Public School",
					"playspace": 15.26,
					"projections": [
						427,
						508,
						555,
						555,
						530,
						535
					],
					"projections_orig": [
						"427",
						"508",
						"555",
						"555",
						"530",
						"535"
					],
					"projections_percentage": [
						-15.94,
						0,
						9.25,
						9.25,
						4.33,
						5.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1775
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 10
					},
					"classroomspace": 3.1,
					"enrolment": 262,
					"ligo": 0.51,
					"location": [
						148.615947889731,
						-32.2406111478334
					],
					"name": "Dubbo North Public School",
					"playspace": 80.04,
					"projections": [
						244,
						262,
						265,
						265,
						265,
						270
					],
					"projections_orig": [
						"244",
						"262",
						"265",
						"265",
						"265",
						"270"
					],
					"projections_percentage": [
						-6.87,
						0,
						1.15,
						1.15,
						1.15,
						3.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1776
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 25
					},
					"classroomspace": 2.8,
					"enrolment": 682,
					"ligo": 0.58,
					"location": [
						148.610456107588,
						-32.2641705313361
					],
					"name": "Dubbo South Public School",
					"playspace": 33.17,
					"projections": [
						682,
						682,
						790,
						790,
						750,
						750
					],
					"projections_orig": [
						"682",
						"682",
						"790",
						"790",
						"750",
						"750"
					],
					"projections_percentage": [
						0,
						0,
						15.84,
						15.84,
						9.97,
						9.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1811
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 23
					},
					"classroomspace": 4.6,
					"enrolment": 334,
					"ligo": 0.79,
					"location": [
						148.588504147196,
						-32.2510935415325
					],
					"name": "Dubbo West Public School",
					"playspace": 91.15,
					"projections": [
						327,
						334,
						330,
						325,
						330,
						330
					],
					"projections_orig": [
						"327",
						"334",
						"330",
						"325",
						"330",
						"330"
					],
					"projections_percentage": [
						-2.1,
						0,
						-1.2,
						-2.69,
						-1.2,
						-1.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3591
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 22
					},
					"classroomspace": 2.94,
					"enrolment": 618,
					"ligo": 0.56,
					"location": [
						148.627778467209,
						-32.2529102009539
					],
					"name": "Orana Heights Public School",
					"playspace": 37.44,
					"projections": [
						537,
						618,
						660,
						660,
						630,
						635
					],
					"projections_orig": [
						"537",
						"618",
						"660",
						"660",
						"630",
						"635"
					],
					"projections_percentage": [
						-13.11,
						0,
						6.8,
						6.8,
						1.94,
						2.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4549
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 13
					},
					"classroomspace": 3.86,
					"enrolment": 328,
					"ligo": 0.67,
					"location": [
						148.639237043302,
						-32.2433736535965
					],
					"name": "Buninyong Public School",
					"playspace": 175.04,
					"projections": [
						269,
						328,
						335,
						325,
						325,
						330
					],
					"projections_orig": [
						"269",
						"328",
						"335",
						"325",
						"325",
						"330"
					],
					"projections_percentage": [
						-17.99,
						0,
						2.13,
						-0.91,
						-0.91,
						0.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4616
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 7.28,
					"enrolment": 528,
					"ligo": 0.99,
					"location": [
						148.628559049011,
						-32.2350608789206
					],
					"name": "Dubbo College Senior Campus",
					"playspace": 69.87,
					"projections": [
						532,
						528,
						560,
						580,
						565,
						545
					],
					"projections_orig": [
						"532",
						"528",
						"560",
						"580",
						"565",
						"545"
					],
					"projections_percentage": [
						0.76,
						0,
						6.06,
						9.85,
						7.01,
						3.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8110
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 42
					},
					"classroomspace": 3.58,
					"enrolment": 722,
					"ligo": 0.7,
					"location": [
						148.61144457443,
						-32.2683198648885
					],
					"name": "Dubbo College South Campus",
					"playspace": 35.8,
					"projections": [
						794,
						722,
						875,
						905,
						885,
						855
					],
					"projections_orig": [
						"794",
						"722",
						"875",
						"905",
						"885",
						"855"
					],
					"projections_percentage": [
						9.97,
						0,
						21.19,
						25.35,
						22.58,
						18.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8417
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 5.81,
					"enrolment": 489,
					"ligo": 0.82,
					"location": [
						148.583206230468,
						-32.2505486833623
					],
					"name": "Dubbo College Delroy Campus",
					"playspace": 66,
					"projections": [
						531,
						489,
						510,
						525,
						510,
						495
					],
					"projections_orig": [
						"531",
						"489",
						"510",
						"525",
						"510",
						"495"
					],
					"projections_percentage": [
						8.59,
						0,
						4.29,
						7.36,
						4.29,
						1.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8543
				}
			],
			"uid": 30015
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 234
			},
			"enrolment": 4334,
			"level": "Combined",
			"ligo": 0.64,
			"name": "Orange Urban",
			"playspace": 59.2,
			"projections": [
				4334,
				4705,
				4835,
				4795,
				4800
			],
			"projections_percentage": [
				0,
				8.56,
				11.56,
				10.64,
				10.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 2.6,
					"enrolment": 269,
					"ligo": 0.33,
					"location": [
						149.114510639803,
						-33.282124818061
					],
					"name": "Orange East Public School",
					"playspace": 42.71,
					"projections": [
						245,
						269,
						240,
						240,
						245,
						245
					],
					"projections_orig": [
						"245",
						"269",
						"240",
						"240",
						"245",
						"245"
					],
					"projections_percentage": [
						-8.92,
						0,
						-10.78,
						-10.78,
						-8.92,
						-8.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2811
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.82,
					"enrolment": 255,
					"ligo": 0.79,
					"location": [
						149.111656351805,
						-33.2972009971286
					],
					"name": "Glenroi Heights Public School",
					"playspace": 64.34,
					"projections": [
						296,
						255,
						225,
						230,
						230,
						235
					],
					"projections_orig": [
						"296",
						"255",
						"225",
						"230",
						"230",
						"235"
					],
					"projections_percentage": [
						16.08,
						0,
						-11.76,
						-9.8,
						-9.8,
						-7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4020
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.75,
					"enrolment": 636,
					"ligo": 0.69,
					"location": [
						149.079434570516,
						-33.2876761575455
					],
					"name": "Calare Public School",
					"playspace": 32.78,
					"projections": [
						626,
						636,
						700,
						720,
						700,
						715
					],
					"projections_orig": [
						"626",
						"636",
						"700",
						"720",
						"700",
						"715"
					],
					"projections_percentage": [
						-1.57,
						0,
						10.06,
						13.21,
						10.06,
						12.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4380
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 4.39,
					"enrolment": 245,
					"ligo": 0.55,
					"location": [
						149.116887470792,
						-33.2811971331768
					],
					"name": "Bowen Public School",
					"playspace": 79.03,
					"projections": [
						167,
						245,
						200,
						210,
						215,
						220
					],
					"projections_orig": [
						"167",
						"245",
						"200",
						"210",
						"215",
						"220"
					],
					"projections_percentage": [
						-31.84,
						0,
						-18.37,
						-14.29,
						-12.24,
						-10.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4538
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 19
					},
					"classroomspace": 2.63,
					"enrolment": 607,
					"ligo": 0.75,
					"location": [
						149.103255644456,
						-33.2695431269362
					],
					"name": "Bletchington Public School",
					"playspace": 48.72,
					"projections": [
						556,
						607,
						650,
						650,
						655,
						670
					],
					"projections_orig": [
						"556",
						"607",
						"650",
						"650",
						"655",
						"670"
					],
					"projections_percentage": [
						-8.4,
						0,
						7.08,
						7.08,
						7.91,
						10.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5265
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 3.03,
					"enrolment": 662,
					"ligo": 0.58,
					"location": [
						149.095896171708,
						-33.2856839638642
					],
					"name": "Orange Public School",
					"playspace": 31.52,
					"projections": [
						638,
						662,
						695,
						705,
						685,
						700
					],
					"projections_orig": [
						"638",
						"662",
						"695",
						"705",
						"685",
						"700"
					],
					"projections_percentage": [
						-3.63,
						0,
						4.98,
						6.5,
						3.47,
						5.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7307
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 54
					},
					"classroomspace": 3.38,
					"enrolment": 1074,
					"ligo": 0.64,
					"location": [
						149.086763033337,
						-33.2798581708923
					],
					"name": "Orange High School",
					"playspace": 52.28,
					"projections": [
						1043,
						1074,
						1215,
						1265,
						1255,
						1225
					],
					"projections_orig": [
						"1043",
						"1074",
						"1215",
						"1265",
						"1255",
						"1225"
					],
					"projections_percentage": [
						-2.89,
						0,
						13.13,
						17.78,
						16.85,
						14.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8134
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.23,
					"enrolment": 586,
					"ligo": 0.82,
					"location": [
						149.123117153191,
						-33.2900056868059
					],
					"name": "Canobolas Rural Technology High School",
					"playspace": 122.23,
					"projections": [
						832,
						586,
						780,
						815,
						810,
						790
					],
					"projections_orig": [
						"832",
						"586",
						"780",
						"815",
						"810",
						"790"
					],
					"projections_percentage": [
						41.98,
						0,
						33.11,
						39.08,
						38.23,
						34.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8444
				}
			],
			"uid": 30016
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 104
			},
			"enrolment": 1431,
			"level": "Combined",
			"ligo": 0.65,
			"name": "Broken Hill Primary",
			"playspace": 62.66,
			"projections": [
				1431,
				1540,
				1395,
				1270,
				1180
			],
			"projections_percentage": [
				0,
				7.62,
				-2.52,
				-11.25,
				-17.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 5.12,
					"enrolment": 249,
					"ligo": 0.92,
					"location": [
						141.4634527074,
						-31.9826693459389
					],
					"name": "Alma Public School",
					"playspace": 52.56,
					"projections": [
						227,
						249,
						255,
						240,
						220,
						205
					],
					"projections_orig": [
						"227",
						"249",
						"255",
						"240",
						"220",
						"205"
					],
					"projections_percentage": [
						-8.84,
						0,
						2.41,
						-3.61,
						-11.65,
						-17.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1028
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 5.14,
					"enrolment": 170,
					"ligo": 0.56,
					"location": [
						141.456141342345,
						-31.9558135540369
					],
					"name": "Broken Hill Public School",
					"playspace": 74.15,
					"projections": [
						262,
						170,
						195,
						185,
						170,
						155
					],
					"projections_orig": [
						"262",
						"170",
						"195",
						"185",
						"170",
						"155"
					],
					"projections_percentage": [
						54.12,
						0,
						14.71,
						8.82,
						0,
						-8.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1369
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.15,
					"enrolment": 260,
					"ligo": 0.7,
					"location": [
						141.472020128037,
						-31.9439382364838
					],
					"name": "Broken Hill North Public School",
					"playspace": 91.16,
					"projections": [
						295,
						260,
						270,
						240,
						220,
						205
					],
					"projections_orig": [
						"295",
						"260",
						"270",
						"240",
						"220",
						"205"
					],
					"projections_percentage": [
						13.46,
						0,
						3.85,
						-7.69,
						-15.38,
						-21.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1371
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.86,
					"enrolment": 313,
					"ligo": 0.56,
					"location": [
						141.440944275152,
						-31.960973993679
					],
					"name": "Burke Ward Public School",
					"playspace": 46.23,
					"projections": [
						327,
						313,
						345,
						310,
						275,
						255
					],
					"projections_orig": [
						"327",
						"313",
						"345",
						"310",
						"275",
						"255"
					],
					"projections_percentage": [
						4.47,
						0,
						10.22,
						-0.96,
						-12.14,
						-18.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1432
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.08,
					"enrolment": 330,
					"ligo": 0.61,
					"location": [
						141.460987820323,
						-31.9414733263736
					],
					"name": "Morgan Street Public School",
					"playspace": 46.68,
					"projections": [
						343,
						330,
						345,
						300,
						275,
						255
					],
					"projections_orig": [
						"343",
						"330",
						"345",
						"300",
						"275",
						"255"
					],
					"projections_percentage": [
						3.94,
						0,
						4.55,
						-9.09,
						-16.67,
						-22.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4232
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 5.2,
					"enrolment": 109,
					"ligo": 0.53,
					"location": [
						141.439764124043,
						-31.9700664871442
					],
					"name": "Railway Town Public School",
					"playspace": 65.17,
					"projections": [
						152,
						109,
						130,
						120,
						110,
						105
					],
					"projections_orig": [
						"152",
						"109",
						"130",
						"120",
						"110",
						"105"
					],
					"projections_percentage": [
						39.45,
						0,
						19.27,
						10.09,
						0.92,
						-3.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4233
				}
			],
			"uid": 30017
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 19
			},
			"enrolment": 164,
			"level": "Combined",
			"ligo": 1,
			"name": "Deniliquin Network FW",
			"playspace": 554.18,
			"projections": [
				164,
				157,
				147,
				147,
				142
			],
			"projections_percentage": [
				0,
				-4.27,
				-10.37,
				-10.37,
				-13.41
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 6.65,
					"enrolment": 157,
					"ligo": 1,
					"location": [
						143.564473785258,
						-34.6364970378697
					],
					"name": "Balranald Central School",
					"playspace": 160.26,
					"projections": [
						133,
						157,
						150,
						140,
						140,
						135
					],
					"projections_orig": [
						"133",
						"157",
						"150",
						"140",
						"140",
						"135"
					],
					"projections_percentage": [
						-15.29,
						0,
						-4.46,
						-10.83,
						-10.83,
						-14.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1115
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 19.41,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						143.941780767169,
						-33.3984894133797
					],
					"name": "Clare Public School",
					"playspace": 948.1,
					"projections": [
						11,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						57.14,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4565
				}
			],
			"uid": 30018
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 49
			},
			"enrolment": 292,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Far West Network",
			"playspace": 980.16,
			"projections": [
				292,
				308,
				298,
				288,
				283
			],
			"projections_percentage": [
				0,
				5.48,
				2.05,
				-1.37,
				-3.08
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.77,
					"enrolment": 83,
					"ligo": 1,
					"location": [
						142.744906888411,
						-34.5755435485924
					],
					"name": "Euston Public School",
					"playspace": 99.61,
					"projections": [
						89,
						83,
						70,
						65,
						60,
						60
					],
					"projections_orig": [
						"89",
						"83",
						"70",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						7.23,
						0,
						-15.66,
						-21.69,
						-27.71,
						-27.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1885
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 26.81,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						144.301523441855,
						-32.8982505860945
					],
					"name": "Ivanhoe Central School",
					"playspace": 450.91,
					"projections": [
						43,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"43",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						86.96,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2213
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 10.07,
					"enrolment": 96,
					"ligo": 1,
					"location": [
						142.412648538088,
						-32.3947114435595
					],
					"name": "Menindee Central School",
					"playspace": 367.38,
					"projections": [
						126,
						96,
						90,
						90,
						85,
						80
					],
					"projections_orig": [
						"126",
						"96",
						"90",
						"90",
						"85",
						"80"
					],
					"projections_percentage": [
						31.25,
						0,
						-6.25,
						-6.25,
						-11.46,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2523
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 64.5,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						142.01092390967,
						-29.4316463735826
					],
					"name": "Tibooburra Outback Public School",
					"playspace": 4878.04,
					"projections": [
						15,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						275,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3211
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.16,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						143.090106192295,
						-30.8504721560148
					],
					"name": "White Cliffs Public School",
					"playspace": 418.7,
					"projections": [
						9,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"9",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-30.77,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3435
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 12.57,
					"enrolment": 60,
					"ligo": 1,
					"location": [
						143.375821673116,
						-31.5580403860968
					],
					"name": "Wilcannia Central School",
					"playspace": 200.98,
					"projections": [
						142,
						60,
						95,
						90,
						90,
						90
					],
					"projections_orig": [
						"142",
						"60",
						"95",
						"90",
						"90",
						"90"
					],
					"projections_percentage": [
						136.67,
						0,
						58.33,
						50,
						50,
						50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3442
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.6,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						142.012622638144,
						-33.8444746221559
					],
					"name": "Palinyewah Public School",
					"playspace": 445.51,
					"projections": [
						11,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.38,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3912
				}
			],
			"uid": 30019
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 193
			},
			"enrolment": 2015,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Rural Western Plains FW",
			"playspace": 446.5,
			"projections": [
				2015,
				1917,
				1837,
				1777,
				1762
			],
			"projections_percentage": [
				0,
				-4.86,
				-8.83,
				-11.81,
				-12.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 4.47,
					"enrolment": 226,
					"ligo": 1,
					"location": [
						145.949235037158,
						-30.094326601074
					],
					"name": "Bourke Public School",
					"playspace": 150.88,
					"projections": [
						202,
						226,
						260,
						225,
						225,
						225
					],
					"projections_orig": [
						"202",
						"226",
						"260",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						-10.62,
						0,
						15.04,
						-0.44,
						-0.44,
						-0.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1326
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 7.01,
					"enrolment": 154,
					"ligo": 1,
					"location": [
						146.859341578685,
						-29.9644694815919
					],
					"name": "Brewarrina Central School",
					"playspace": 88.81,
					"projections": [
						190,
						154,
						150,
						150,
						150,
						150
					],
					"projections_orig": [
						"190",
						"154",
						"150",
						"150",
						"150",
						"150"
					],
					"projections_percentage": [
						23.38,
						0,
						-2.6,
						-2.6,
						-2.6,
						-2.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1350
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.84,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						148.964841541578,
						-30.1022655195616
					],
					"name": "Burren Junction Public School",
					"playspace": 193.05,
					"projections": [
						45,
						52,
						55,
						55,
						50,
						50
					],
					"projections_orig": [
						"45",
						"52",
						"55",
						"55",
						"50",
						"50"
					],
					"projections_percentage": [
						-13.46,
						0,
						5.77,
						5.77,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1447
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.52,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						147.688115720509,
						-30.4615289906861
					],
					"name": "Carinda Public School",
					"playspace": 1079.9,
					"projections": [
						27,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						68.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1507
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.84,
					"enrolment": 280,
					"ligo": 1,
					"location": [
						145.837014600059,
						-31.5012676844532
					],
					"name": "Cobar Public School",
					"playspace": 123.64,
					"projections": [
						330,
						280,
						290,
						275,
						275,
						280
					],
					"projections_orig": [
						"330",
						"280",
						"290",
						"275",
						"275",
						"280"
					],
					"projections_percentage": [
						17.86,
						0,
						3.57,
						-1.79,
						-1.79,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1578
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 6.98,
					"enrolment": 112,
					"ligo": 0.91,
					"location": [
						148.57854368178,
						-29.5434237240757
					],
					"name": "Collarenebri Central School",
					"playspace": 81.45,
					"projections": [
						85,
						112,
						80,
						80,
						70,
						70
					],
					"projections_orig": [
						"85",
						"112",
						"80",
						"80",
						"70",
						"70"
					],
					"projections_percentage": [
						-24.11,
						0,
						-28.57,
						-28.57,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1589
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.48,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						146.396975568451,
						-33.0553633287201
					],
					"name": "Euabalong West Public School",
					"playspace": 329.68,
					"projections": [
						19,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.52,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1867
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 23.68,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						147.454618488507,
						-29.1162439209619
					],
					"name": "Goodooga Central School",
					"playspace": 826.98,
					"projections": [
						47,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"47",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						27.03,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2033
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 25
					},
					"classroomspace": 4.71,
					"enrolment": 393,
					"ligo": 0.87,
					"location": [
						147.979403810976,
						-29.4260096755276
					],
					"name": "Lightning Ridge Central School",
					"playspace": 78.36,
					"projections": [
						390,
						393,
						345,
						325,
						305,
						290
					],
					"projections_orig": [
						"390",
						"393",
						"345",
						"325",
						"305",
						"290"
					],
					"projections_percentage": [
						-0.76,
						0,
						-12.21,
						-17.3,
						-22.39,
						-26.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2395
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.35,
					"enrolment": 135,
					"ligo": 1,
					"location": [
						148.115470873899,
						-30.0194233542571
					],
					"name": "Walgett Community College - Primary School",
					"playspace": 141,
					"projections": [
						125,
						135,
						105,
						100,
						95,
						90
					],
					"projections_orig": [
						"125",
						"135",
						"105",
						"100",
						"95",
						"90"
					],
					"projections_percentage": [
						-7.41,
						0,
						-22.22,
						-25.93,
						-29.63,
						-33.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3342
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 11.16,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						144.144935953638,
						-29.7054433220553
					],
					"name": "Wanaaring Public School",
					"playspace": 1890.61,
					"projections": [
						11,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						10,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3365
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.03,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						148.912127716637,
						-29.8143621839827
					],
					"name": "Rowena Public School",
					"playspace": 303.03,
					"projections": [
						33,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						13.79,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3580
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 26.06,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						145.117425872381,
						-30.5353977385036
					],
					"name": "Louth Public School",
					"playspace": 601.61,
					"projections": [
						4,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"4",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3594
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 9.5,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						145.846137077583,
						-29.3185153775988
					],
					"name": "Enngonia Public School",
					"playspace": 242.64,
					"projections": [
						17,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.73,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3626
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 13.87,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						146.920076841579,
						-29.2399999831596
					],
					"name": "Weilmoringle Public School",
					"playspace": 1171.56,
					"projections": [
						14,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.69,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4305
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 15
					},
					"classroomspace": 7.66,
					"enrolment": 142,
					"ligo": 1,
					"location": [
						145.947164423602,
						-30.0909444879625
					],
					"name": "Bourke High School",
					"playspace": 215.72,
					"projections": [
						154,
						142,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"154",
						"142",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						8.45,
						0,
						-8.45,
						-8.45,
						-8.45,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8355
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 5.86,
					"enrolment": 258,
					"ligo": 1,
					"location": [
						145.826715610342,
						-31.5026801530073
					],
					"name": "Cobar High School",
					"playspace": 238.79,
					"projections": [
						241,
						258,
						260,
						255,
						240,
						245
					],
					"projections_orig": [
						"241",
						"258",
						"260",
						"255",
						"240",
						"245"
					],
					"projections_percentage": [
						-6.59,
						0,
						0.78,
						-1.16,
						-6.98,
						-5.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8356
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 12.46,
					"enrolment": 111,
					"ligo": 0.95,
					"location": [
						148.120024372393,
						-30.0270333764265
					],
					"name": "Walgett Community College - High School",
					"playspace": 279.23,
					"projections": [
						117,
						111,
						90,
						90,
						85,
						80
					],
					"projections_orig": [
						"117",
						"111",
						"90",
						"90",
						"85",
						"80"
					],
					"projections_percentage": [
						5.41,
						0,
						-18.92,
						-18.92,
						-23.42,
						-27.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8475
				}
			],
			"uid": 30020
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 61
			},
			"enrolment": 794,
			"level": "Combined",
			"ligo": 0.8,
			"name": "Sunraysia",
			"playspace": 267.39,
			"projections": [
				794,
				771,
				761,
				726,
				691
			],
			"projections_percentage": [
				0,
				-2.9,
				-4.16,
				-8.56,
				-12.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.8,
					"enrolment": 113,
					"ligo": 0.76,
					"location": [
						142.181871501105,
						-34.1702866632164
					],
					"name": "Buronga Public School",
					"playspace": 140.09,
					"projections": [
						86,
						113,
						95,
						95,
						90,
						90
					],
					"projections_orig": [
						"86",
						"113",
						"95",
						"95",
						"90",
						"90"
					],
					"projections_percentage": [
						-23.89,
						0,
						-15.93,
						-15.93,
						-20.35,
						-20.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1688
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 9.31,
					"enrolment": 62,
					"ligo": 0.91,
					"location": [
						142.041141744291,
						-34.0916584753109
					],
					"name": "Dareton Public School",
					"playspace": 268.29,
					"projections": [
						63,
						62,
						65,
						65,
						60,
						60
					],
					"projections_orig": [
						"63",
						"62",
						"65",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						1.61,
						0,
						4.84,
						4.84,
						-3.23,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1732
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.98,
					"enrolment": 181,
					"ligo": 0.93,
					"location": [
						142.222713542232,
						-34.1790885974289
					],
					"name": "Gol Gol Public School",
					"playspace": 79.04,
					"projections": [
						192,
						181,
						185,
						180,
						175,
						165
					],
					"projections_orig": [
						"192",
						"181",
						"185",
						"180",
						"175",
						"165"
					],
					"projections_percentage": [
						6.08,
						0,
						2.21,
						-0.55,
						-3.31,
						-8.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2027
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.76,
					"enrolment": 21,
					"ligo": 0.37,
					"location": [
						141.894266641016,
						-34.026039568017
					],
					"name": "Pomona Public School",
					"playspace": 858.92,
					"projections": [
						30,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.86,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2893
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.5,
					"enrolment": 143,
					"ligo": 0.8,
					"location": [
						141.918445730567,
						-34.1033942794493
					],
					"name": "Wentworth Public School",
					"playspace": 57.63,
					"projections": [
						142,
						143,
						120,
						115,
						110,
						110
					],
					"projections_orig": [
						"142",
						"143",
						"120",
						"115",
						"110",
						"110"
					],
					"projections_percentage": [
						-0.7,
						0,
						-16.08,
						-19.58,
						-23.08,
						-23.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3421
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 25
					},
					"classroomspace": 6.69,
					"enrolment": 274,
					"ligo": 1,
					"location": [
						142.058701731489,
						-34.0945073210629
					],
					"name": "Coomealla High School",
					"playspace": 200.35,
					"projections": [
						349,
						274,
						285,
						285,
						270,
						245
					],
					"projections_orig": [
						"349",
						"274",
						"285",
						"285",
						"270",
						"245"
					],
					"projections_percentage": [
						27.37,
						0,
						4.01,
						4.01,
						-1.46,
						-10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8494
				}
			],
			"uid": 30021
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 3
			},
			"enrolment": 33,
			"level": "Combined",
			"ligo": 1,
			"name": "Lord Howe Island",
			"playspace": 109.36,
			"projections": [
				33,
				33,
				33,
				33,
				33
			],
			"projections_percentage": [
				0,
				0,
				0,
				0,
				0
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.32,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						159.068780569961,
						-31.5302180394254
					],
					"name": "Lord Howe Island Central School",
					"playspace": 109.36,
					"projections": [
						22,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-33.33,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1921
				}
			],
			"uid": 30022
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 130
			},
			"enrolment": 2600,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Barrington",
			"playspace": 188.93,
			"projections": [
				2600,
				2416,
				2346,
				2261,
				2161
			],
			"projections_percentage": [
				0,
				-7.08,
				-9.77,
				-13.04,
				-16.88
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.29,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						151.910966286796,
						-31.9710587492479
					],
					"name": "Barrington Public School",
					"playspace": 98.98,
					"projections": [
						70,
						54,
						60,
						60,
						55,
						50
					],
					"projections_orig": [
						"70",
						"54",
						"60",
						"60",
						"55",
						"50"
					],
					"projections_percentage": [
						29.63,
						0,
						11.11,
						11.11,
						1.85,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1143
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.87,
					"enrolment": 140,
					"ligo": 0.94,
					"location": [
						151.776151232925,
						-32.5890465986167
					],
					"name": "Clarence Town Public School",
					"playspace": 71.58,
					"projections": [
						156,
						140,
						135,
						135,
						130,
						125
					],
					"projections_orig": [
						"156",
						"140",
						"135",
						"135",
						"130",
						"125"
					],
					"projections_percentage": [
						11.43,
						0,
						-3.57,
						-3.57,
						-7.14,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1564
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.83,
					"enrolment": 260,
					"ligo": 0.88,
					"location": [
						151.757378843866,
						-32.4058898125351
					],
					"name": "Dungog Public School",
					"playspace": 25.69,
					"projections": [
						203,
						260,
						260,
						255,
						250,
						240
					],
					"projections_orig": [
						"203",
						"260",
						"260",
						"255",
						"250",
						"240"
					],
					"projections_percentage": [
						-21.92,
						0,
						0,
						-1.92,
						-3.85,
						-7.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1792
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.61,
					"enrolment": 26,
					"ligo": 0.4,
					"location": [
						151.798379908761,
						-32.5257873668052
					],
					"name": "Glen William Public School",
					"playspace": 95.58,
					"projections": [
						29,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.54,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2020
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.36,
					"enrolment": 84,
					"ligo": 0.77,
					"location": [
						151.538579231935,
						-32.4272316216156
					],
					"name": "Gresford Public School",
					"playspace": 69.22,
					"projections": [
						62,
						84,
						80,
						80,
						75,
						75
					],
					"projections_orig": [
						"62",
						"84",
						"80",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						-26.19,
						0,
						-4.76,
						-4.76,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2083
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.52,
					"enrolment": 86,
					"ligo": 0.65,
					"location": [
						151.650300265915,
						-32.7164710762437
					],
					"name": "Hinton Public School",
					"playspace": 72.22,
					"projections": [
						108,
						86,
						90,
						90,
						90,
						85
					],
					"projections_orig": [
						"108",
						"86",
						"90",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						25.58,
						0,
						4.65,
						4.65,
						4.65,
						-1.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2167
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.32,
					"enrolment": 12,
					"ligo": 0.5,
					"location": [
						151.623757744235,
						-32.565555680794
					],
					"name": "Martins Creek Public School",
					"playspace": 446.63,
					"projections": [
						16,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2493
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.29,
					"enrolment": 106,
					"ligo": 0.74,
					"location": [
						151.612428295527,
						-32.6030478061266
					],
					"name": "Paterson Public School",
					"playspace": 110.97,
					"projections": [
						98,
						106,
						95,
						90,
						90,
						85
					],
					"projections_orig": [
						"98",
						"106",
						"95",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						-7.55,
						0,
						-10.38,
						-15.09,
						-15.09,
						-19.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2844
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.51,
					"enrolment": 198,
					"ligo": 0.81,
					"location": [
						151.730440175033,
						-32.6621749071927
					],
					"name": "Seaham Public School",
					"playspace": 48,
					"projections": [
						217,
						198,
						210,
						205,
						200,
						195
					],
					"projections_orig": [
						"217",
						"198",
						"210",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						9.6,
						0,
						6.06,
						3.54,
						1.01,
						-1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3048
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.19,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						151.938580202894,
						-32.1171736385373
					],
					"name": "Stratford Public School",
					"playspace": 1030.37,
					"projections": [
						16,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						23.08,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3119
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.89,
					"enrolment": 91,
					"ligo": 1,
					"location": [
						151.9649892227,
						-32.4027685868078
					],
					"name": "Stroud Public School",
					"playspace": 279.59,
					"projections": [
						90,
						91,
						90,
						90,
						90,
						85
					],
					"projections_orig": [
						"90",
						"91",
						"90",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						-1.1,
						0,
						-1.1,
						-1.1,
						-1.1,
						-6.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3125
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.74,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						151.932009902482,
						-32.3478136748864
					],
					"name": "Stroud Road Public School",
					"playspace": 369.32,
					"projections": [
						28,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						86.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3126
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.19,
					"enrolment": 108,
					"ligo": 0.81,
					"location": [
						151.576986971922,
						-32.5419859190658
					],
					"name": "Vacy Public School",
					"playspace": 45.79,
					"projections": [
						90,
						108,
						100,
						100,
						95,
						95
					],
					"projections_orig": [
						"90",
						"108",
						"100",
						"100",
						"95",
						"95"
					],
					"projections_percentage": [
						-16.67,
						0,
						-7.41,
						-7.41,
						-12.04,
						-12.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3321
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.59,
					"enrolment": 348,
					"ligo": 1,
					"location": [
						151.960760802631,
						-32.0097112632031
					],
					"name": "Gloucester Public School",
					"playspace": 29.34,
					"projections": [
						309,
						348,
						300,
						270,
						255,
						240
					],
					"projections_orig": [
						"309",
						"348",
						"300",
						"270",
						"255",
						"240"
					],
					"projections_percentage": [
						-11.21,
						0,
						-13.79,
						-22.41,
						-26.72,
						-31.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7303
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 18
					},
					"classroomspace": 4.03,
					"enrolment": 363,
					"ligo": 0.85,
					"location": [
						151.960986593641,
						-32.0168579402889
					],
					"name": "Gloucester High School",
					"playspace": 144.3,
					"projections": [
						352,
						363,
						320,
						305,
						285,
						255
					],
					"projections_orig": [
						"352",
						"363",
						"320",
						"305",
						"285",
						"255"
					],
					"projections_percentage": [
						-3.03,
						0,
						-11.85,
						-15.98,
						-21.49,
						-29.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8371
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 3.63,
					"enrolment": 696,
					"ligo": 0.86,
					"location": [
						151.75090828138,
						-32.3980148192262
					],
					"name": "Dungog High School",
					"playspace": 85.23,
					"projections": [
						645,
						696,
						610,
						600,
						580,
						565
					],
					"projections_orig": [
						"645",
						"696",
						"610",
						"600",
						"580",
						"565"
					],
					"projections_percentage": [
						-7.33,
						0,
						-12.36,
						-13.79,
						-16.67,
						-18.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8472
				}
			],
			"uid": 30025
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 220
			},
			"enrolment": 3987,
			"level": "Combined",
			"ligo": 0.92,
			"name": "Great Lakes",
			"playspace": 137.35,
			"projections": [
				3986,
				4321,
				4196,
				3966,
				3706
			],
			"projections_percentage": [
				0,
				8.4,
				5.27,
				-0.5,
				-7.02
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.9,
					"enrolment": 79,
					"ligo": 1,
					"location": [
						151.959730383607,
						-32.4715008384812
					],
					"name": "Booral Public School",
					"playspace": 213.49,
					"projections": [
						71,
						79,
						65,
						65,
						65,
						60
					],
					"projections_orig": [
						"71",
						"79",
						"65",
						"65",
						"65",
						"60"
					],
					"projections_percentage": [
						-10.13,
						0,
						-17.72,
						-17.72,
						-17.72,
						-24.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1311
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 33
					},
					"classroomspace": 6.04,
					"enrolment": 398,
					"ligo": 0.85,
					"location": [
						152.211912692333,
						-32.4124489561469
					],
					"name": "Bulahdelah Central School",
					"playspace": 74.22,
					"projections": [
						498,
						397,
						435,
						435,
						415,
						385
					],
					"projections_orig": [
						"498",
						"397",
						"435",
						"435",
						"415",
						"385"
					],
					"projections_percentage": [
						25.44,
						0,
						9.57,
						9.57,
						4.53,
						-3.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1402
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.95,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						152.448090504452,
						-32.3885665806073
					],
					"name": "Bungwahl Public School",
					"playspace": 230.81,
					"projections": [
						38,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						5.56,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1424
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 328,
					"ligo": 1,
					"location": [
						152.540403564271,
						-32.3414011747002
					],
					"name": "Pacific Palms Public School",
					"playspace": 70.52,
					"projections": [
						268,
						328,
						350,
						315,
						300,
						290
					],
					"projections_orig": [
						"268",
						"328",
						"350",
						"315",
						"300",
						"290"
					],
					"projections_percentage": [
						-18.29,
						0,
						6.71,
						-3.96,
						-8.54,
						-11.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1551
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.67,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						152.318449014228,
						-32.2231130165947
					],
					"name": "Coolongolook Public School",
					"playspace": 565.56,
					"projections": [
						34,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"34",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-2.86,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1627
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 30
					},
					"classroomspace": 2.8,
					"enrolment": 744,
					"ligo": 0.93,
					"location": [
						152.524557712562,
						-32.1813812428563
					],
					"name": "Forster Public School",
					"playspace": 38.29,
					"projections": [
						721,
						744,
						815,
						775,
						715,
						670
					],
					"projections_orig": [
						"721",
						"744",
						"815",
						"775",
						"715",
						"670"
					],
					"projections_percentage": [
						-3.09,
						0,
						9.54,
						4.17,
						-3.9,
						-9.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1936
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 4
					},
					"classroomspace": 2.7,
					"enrolment": 191,
					"ligo": 0.91,
					"location": [
						152.381440541537,
						-32.097215818587
					],
					"name": "Nabiac Public School",
					"playspace": 43.14,
					"projections": [
						192,
						191,
						190,
						185,
						175,
						170
					],
					"projections_orig": [
						"192",
						"191",
						"190",
						"185",
						"175",
						"170"
					],
					"projections_percentage": [
						0.52,
						0,
						-0.52,
						-3.14,
						-8.38,
						-10.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2695
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.3,
					"enrolment": 170,
					"ligo": 1,
					"location": [
						152.158100945364,
						-32.6673872108264
					],
					"name": "Tea Gardens Public School",
					"playspace": 71.02,
					"projections": [
						235,
						170,
						255,
						250,
						240,
						230
					],
					"projections_orig": [
						"235",
						"170",
						"255",
						"250",
						"240",
						"230"
					],
					"projections_percentage": [
						38.24,
						0,
						50,
						47.06,
						41.18,
						35.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3175
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.5,
					"enrolment": 376,
					"ligo": 0.73,
					"location": [
						152.494488126967,
						-32.171894802293
					],
					"name": "Tuncurry Public School",
					"playspace": 43.66,
					"projections": [
						382,
						376,
						415,
						385,
						360,
						340
					],
					"projections_orig": [
						"382",
						"376",
						"415",
						"385",
						"360",
						"340"
					],
					"projections_percentage": [
						1.6,
						0,
						10.37,
						2.39,
						-4.26,
						-9.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4533
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 28
					},
					"classroomspace": 3.58,
					"enrolment": 487,
					"ligo": 0.94,
					"location": [
						152.494870295997,
						-32.1603259847564
					],
					"name": "Great Lakes College Senior Campus",
					"playspace": 87.95,
					"projections": [
						479,
						487,
						490,
						485,
						460,
						420
					],
					"projections_orig": [
						"479",
						"487",
						"490",
						"485",
						"460",
						"420"
					],
					"projections_percentage": [
						-1.64,
						0,
						0.62,
						-0.41,
						-5.54,
						-13.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8281
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 3.07,
					"enrolment": 553,
					"ligo": 0.81,
					"location": [
						152.494870295997,
						-32.1603259847564
					],
					"name": "Great Lakes College Tuncurry Campus",
					"playspace": 81.43,
					"projections": [
						520,
						553,
						570,
						565,
						535,
						490
					],
					"projections_orig": [
						"520",
						"553",
						"570",
						"565",
						"535",
						"490"
					],
					"projections_percentage": [
						-5.97,
						0,
						3.07,
						2.17,
						-3.25,
						-11.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8289
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 5.68,
					"enrolment": 590,
					"ligo": 0.93,
					"location": [
						152.528513343253,
						-32.2140846574175
					],
					"name": "Great Lakes College Forster Campus",
					"playspace": 128.09,
					"projections": [
						655,
						590,
						665,
						665,
						630,
						580
					],
					"projections_orig": [
						"655",
						"590",
						"665",
						"665",
						"630",
						"580"
					],
					"projections_percentage": [
						11.02,
						0,
						12.71,
						12.71,
						6.78,
						-1.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8534
				}
			],
			"uid": 30028
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 53
			},
			"enrolment": 1212,
			"level": "Combined",
			"ligo": 0.75,
			"name": "Kurri Kurri",
			"playspace": 93.24,
			"projections": [
				1212,
				1256,
				1310,
				1350,
				1360
			],
			"projections_percentage": [
				0,
				3.63,
				8.09,
				11.39,
				12.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.19,
					"enrolment": 41,
					"ligo": 0.84,
					"location": [
						151.479048026107,
						-32.9010509450037
					],
					"name": "Mulbring Public School",
					"playspace": 254.84,
					"projections": [
						65,
						41,
						25,
						50,
						50,
						50
					],
					"projections_orig": [
						"65",
						"41",
						"<50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						58.54,
						0,
						-39.02,
						21.95,
						21.95,
						21.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2658
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 4
					},
					"classroomspace": 2.65,
					"enrolment": 261,
					"ligo": 0.35,
					"location": [
						151.484801566309,
						-32.831515150892
					],
					"name": "Pelaw Main Public School",
					"playspace": 30.67,
					"projections": [
						201,
						261,
						255,
						265,
						275,
						275
					],
					"projections_orig": [
						"201",
						"261",
						"255",
						"265",
						"275",
						"275"
					],
					"projections_percentage": [
						-22.99,
						0,
						-2.3,
						1.53,
						5.36,
						5.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2855
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.11,
					"enrolment": 190,
					"ligo": 0.87,
					"location": [
						151.461035202719,
						-32.8094346245112
					],
					"name": "Weston Public School",
					"playspace": 69.06,
					"projections": [
						193,
						190,
						200,
						210,
						215,
						215
					],
					"projections_orig": [
						"193",
						"190",
						"200",
						"210",
						"215",
						"215"
					],
					"projections_percentage": [
						1.58,
						0,
						5.26,
						10.53,
						13.16,
						13.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3431
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.9,
					"enrolment": 72,
					"ligo": 1,
					"location": [
						151.496020431696,
						-32.8231598528091
					],
					"name": "Stanford Merthyr Infants School",
					"playspace": 90.71,
					"projections": [
						68,
						72,
						75,
						75,
						80,
						80
					],
					"projections_orig": [
						"68",
						"72",
						"75",
						"75",
						"80",
						"80"
					],
					"projections_percentage": [
						-5.56,
						0,
						4.17,
						4.17,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5133
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.59,
					"enrolment": 648,
					"ligo": 0.71,
					"location": [
						151.477795269895,
						-32.8207055460627
					],
					"name": "Kurri Kurri Public School",
					"playspace": 20.9,
					"projections": [
						620,
						648,
						685,
						710,
						730,
						740
					],
					"projections_orig": [
						"620",
						"648",
						"685",
						"710",
						"730",
						"740"
					],
					"projections_percentage": [
						-4.32,
						0,
						5.71,
						9.57,
						12.65,
						14.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7422
				}
			],
			"uid": 30030
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 103
			},
			"enrolment": 2182,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Muswellbrook",
			"playspace": 212.06,
			"projections": [
				2182,
				2393,
				2483,
				2433,
				2423
			],
			"projections_percentage": [
				0,
				9.67,
				13.79,
				11.5,
				11.04
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.07,
					"enrolment": 163,
					"ligo": 1,
					"location": [
						150.687076776807,
						-32.3858144449494
					],
					"name": "Denman Public School",
					"playspace": 104.85,
					"projections": [
						212,
						163,
						200,
						210,
						210,
						215
					],
					"projections_orig": [
						"212",
						"163",
						"200",
						"210",
						"210",
						"215"
					],
					"projections_percentage": [
						30.06,
						0,
						22.7,
						28.83,
						28.83,
						31.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1749
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.52,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						150.568584097841,
						-32.3356673185689
					],
					"name": "Sandy Hollow Public School",
					"playspace": 573.12,
					"projections": [
						46,
						30,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"46",
						"30",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						53.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1974
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.85,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						150.665127235894,
						-32.4588946965625
					],
					"name": "Martindale Public School",
					"playspace": 464.8,
					"projections": [
						17,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						30.77,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2492
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 22
					},
					"classroomspace": 2.52,
					"enrolment": 600,
					"ligo": 0.76,
					"location": [
						150.895016845331,
						-32.2588832317446
					],
					"name": "Muswellbrook Public School",
					"playspace": 30.07,
					"projections": [
						566,
						600,
						675,
						690,
						660,
						670
					],
					"projections_orig": [
						"566",
						"600",
						"675",
						"690",
						"660",
						"670"
					],
					"projections_percentage": [
						-5.67,
						0,
						12.5,
						15,
						10,
						11.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2688
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.94,
					"enrolment": 548,
					"ligo": 0.88,
					"location": [
						150.88985801063,
						-32.2733268531591
					],
					"name": "Muswellbrook South Public School",
					"playspace": 41.76,
					"projections": [
						396,
						548,
						555,
						565,
						540,
						550
					],
					"projections_orig": [
						"396",
						"548",
						"555",
						"565",
						"540",
						"550"
					],
					"projections_percentage": [
						-27.74,
						0,
						1.28,
						3.1,
						-1.46,
						0.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3876
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 49
					},
					"classroomspace": 4.01,
					"enrolment": 828,
					"ligo": 0.95,
					"location": [
						150.898863471219,
						-32.2681322208235
					],
					"name": "Muswellbrook High School",
					"playspace": 57.79,
					"projections": [
						778,
						828,
						900,
						955,
						960,
						925
					],
					"projections_orig": [
						"778",
						"828",
						"900",
						"955",
						"960",
						"925"
					],
					"projections_percentage": [
						-6.04,
						0,
						8.7,
						15.34,
						15.94,
						11.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8164
				}
			],
			"uid": 30035
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 131
			},
			"enrolment": 2778,
			"level": "Combined",
			"ligo": 0.75,
			"name": "Singleton",
			"playspace": 344.56,
			"projections": [
				2778,
				3015,
				3105,
				3145,
				3188
			],
			"projections_percentage": [
				0,
				8.53,
				11.77,
				13.21,
				14.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.1,
					"enrolment": 80,
					"ligo": 0.83,
					"location": [
						151.104381587469,
						-32.7450708879833
					],
					"name": "Broke Public School",
					"playspace": 247.35,
					"projections": [
						58,
						80,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"58",
						"80",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						-27.5,
						0,
						0,
						6.25,
						6.25,
						6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1367
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.27,
					"enrolment": 42,
					"ligo": 0.91,
					"location": [
						150.906720120335,
						-32.4969765755282
					],
					"name": "Jerrys Plains Public School",
					"playspace": 217.53,
					"projections": [
						26,
						42,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"26",
						"42",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						-38.1,
						0,
						-40.48,
						-40.48,
						-40.48,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2231
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 6.89,
					"enrolment": 37,
					"ligo": 0.67,
					"location": [
						151.290573328184,
						-32.6093925672315
					],
					"name": "Kirkton Public School",
					"playspace": 145.93,
					"projections": [
						64,
						37,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"64",
						"37",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						72.97,
						0,
						48.65,
						48.65,
						48.65,
						48.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2314
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 6.39,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						151.005769897549,
						-32.6959833805048
					],
					"name": "Milbrodale Public School",
					"playspace": 2219.28,
					"projections": [
						8,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2550
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.78,
					"enrolment": 59,
					"ligo": 0.54,
					"location": [
						151.189006865063,
						-32.4089298646062
					],
					"name": "Mount Pleasant Public School",
					"playspace": 86.77,
					"projections": [
						59,
						59,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"59",
						"59",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						0,
						0,
						1.69,
						1.69,
						10.17,
						10.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2647
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.6,
					"enrolment": 465,
					"ligo": 0.53,
					"location": [
						151.172379397098,
						-32.56359929729
					],
					"name": "Singleton Public School",
					"playspace": 25.15,
					"projections": [
						423,
						465,
						485,
						495,
						500,
						505
					],
					"projections_orig": [
						"423",
						"465",
						"485",
						"495",
						"500",
						"505"
					],
					"projections_percentage": [
						-9.03,
						0,
						4.3,
						6.45,
						7.53,
						8.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3070
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.21,
					"enrolment": 566,
					"ligo": 0.76,
					"location": [
						151.163112747345,
						-32.5488655489661
					],
					"name": "Singleton Heights Public School",
					"playspace": 48.35,
					"projections": [
						622,
						566,
						620,
						635,
						640,
						645
					],
					"projections_orig": [
						"622",
						"566",
						"620",
						"635",
						"640",
						"645"
					],
					"projections_percentage": [
						9.89,
						0,
						9.54,
						12.19,
						13.07,
						13.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4486
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.39,
					"enrolment": 356,
					"ligo": 0.68,
					"location": [
						151.175934121256,
						-32.5687799320255
					],
					"name": "King Street Public School",
					"playspace": 74.26,
					"projections": [
						437,
						356,
						400,
						410,
						415,
						420
					],
					"projections_orig": [
						"437",
						"356",
						"400",
						"410",
						"415",
						"420"
					],
					"projections_percentage": [
						22.75,
						0,
						12.36,
						15.17,
						16.57,
						17.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4514
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 55
					},
					"classroomspace": 3.91,
					"enrolment": 1165,
					"ligo": 0.87,
					"location": [
						151.176819121039,
						-32.5680509320849
					],
					"name": "Singleton High School",
					"playspace": 36.46,
					"projections": [
						1236,
						1165,
						1265,
						1315,
						1335,
						1355
					],
					"projections_orig": [
						"1236",
						"1165",
						"1265",
						"1315",
						"1335",
						"1355"
					],
					"projections_percentage": [
						6.09,
						0,
						8.58,
						12.88,
						14.59,
						16.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8202
				}
			],
			"uid": 30039
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 90
			},
			"enrolment": 1503,
			"level": "Combined",
			"ligo": 0.96,
			"name": "Upper Hunter",
			"playspace": 623.4,
			"projections": [
				1503,
				1654,
				1609,
				1564,
				1519
			],
			"projections_percentage": [
				0,
				10.05,
				7.05,
				4.06,
				1.06
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.71,
					"enrolment": 231,
					"ligo": 1,
					"location": [
						150.889178092738,
						-32.1660862932814
					],
					"name": "Aberdeen Public School",
					"playspace": 52.5,
					"projections": [
						208,
						231,
						255,
						240,
						240,
						235
					],
					"projections_orig": [
						"208",
						"231",
						"255",
						"240",
						"240",
						"235"
					],
					"projections_percentage": [
						-9.96,
						0,
						10.39,
						3.9,
						3.9,
						1.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1002
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.22,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						151.130342519536,
						-31.9890169144958
					],
					"name": "Belltrees Public School",
					"playspace": 3439.35,
					"projections": [
						13,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1182
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.27,
					"enrolment": 39,
					"ligo": 1,
					"location": [
						150.893214981464,
						-31.778992337093
					],
					"name": "Blandford Public School",
					"playspace": 124.14,
					"projections": [
						40,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"40",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						2.56,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1256
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.1,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						149.97771775755,
						-32.0050189114271
					],
					"name": "Cassilis Public School",
					"playspace": 1456.95,
					"projections": [
						21,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1527
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.34,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						151.304111132462,
						-31.8172848348861
					],
					"name": "Ellerston Public School",
					"playspace": 225.88,
					"projections": [
						22,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-12,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1830
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 15
					},
					"classroomspace": 4.24,
					"enrolment": 285,
					"ligo": 0.79,
					"location": [
						150.352236418506,
						-32.1453647406722
					],
					"name": "Merriwa Central School",
					"playspace": 79.85,
					"projections": [
						231,
						285,
						245,
						240,
						235,
						225
					],
					"projections_orig": [
						"231",
						"285",
						"245",
						"240",
						"235",
						"225"
					],
					"projections_percentage": [
						-18.95,
						0,
						-14.04,
						-15.79,
						-17.54,
						-21.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2528
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.28,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						150.832540079886,
						-31.7624860170601
					],
					"name": "Murrurundi Public School",
					"playspace": 108.83,
					"projections": [
						58,
						53,
						60,
						55,
						55,
						55
					],
					"projections_orig": [
						"58",
						"53",
						"60",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						9.43,
						0,
						13.21,
						3.77,
						3.77,
						3.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2686
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 19
					},
					"classroomspace": 2.51,
					"enrolment": 451,
					"ligo": 1,
					"location": [
						150.86295071958,
						-32.0495917201343
					],
					"name": "Scone Public School",
					"playspace": 28.79,
					"projections": [
						508,
						451,
						565,
						550,
						520,
						515
					],
					"projections_orig": [
						"508",
						"451",
						"565",
						"550",
						"520",
						"515"
					],
					"projections_percentage": [
						12.64,
						0,
						25.28,
						21.95,
						15.3,
						14.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7311
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 5.38,
					"enrolment": 394,
					"ligo": 0.88,
					"location": [
						150.872617232191,
						-32.0562611035993
					],
					"name": "Scone High School",
					"playspace": 94.32,
					"projections": [
						444,
						394,
						440,
						435,
						425,
						400
					],
					"projections_orig": [
						"444",
						"394",
						"440",
						"435",
						"425",
						"400"
					],
					"projections_percentage": [
						12.69,
						0,
						11.68,
						10.41,
						7.87,
						1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8409
				}
			],
			"uid": 30040
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 107
			},
			"enrolment": 2652,
			"level": "Combined",
			"ligo": 0.88,
			"name": "Ulladulla/Milton",
			"playspace": 37.34,
			"projections": [
				2652,
				2515,
				2505,
				2450,
				2385
			],
			"projections_percentage": [
				0,
				-5.17,
				-5.54,
				-7.62,
				-10.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 24
					},
					"classroomspace": 2.88,
					"enrolment": 693,
					"ligo": 0.81,
					"location": [
						150.43627028714,
						-35.3146929490312
					],
					"name": "Milton Public School",
					"playspace": 43.71,
					"projections": [
						558,
						693,
						685,
						680,
						670,
						650
					],
					"projections_orig": [
						"558",
						"693",
						"685",
						"680",
						"670",
						"650"
					],
					"projections_percentage": [
						-19.48,
						0,
						-1.15,
						-1.88,
						-3.32,
						-6.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2565
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 22
					},
					"classroomspace": 2.66,
					"enrolment": 725,
					"ligo": 0.87,
					"location": [
						150.46980318167,
						-35.3563661121291
					],
					"name": "Ulladulla Public School",
					"playspace": 32.34,
					"projections": [
						627,
						725,
						685,
						680,
						665,
						645
					],
					"projections_orig": [
						"627",
						"725",
						"685",
						"680",
						"665",
						"645"
					],
					"projections_percentage": [
						-13.52,
						0,
						-5.52,
						-6.21,
						-8.28,
						-11.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3302
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 61
					},
					"classroomspace": 3.41,
					"enrolment": 1234,
					"ligo": 0.96,
					"location": [
						150.47115168817,
						-35.3593094549874
					],
					"name": "Ulladulla High School",
					"playspace": 35.97,
					"projections": [
						1149,
						1234,
						1145,
						1145,
						1115,
						1090
					],
					"projections_orig": [
						"1149",
						"1234",
						"1145",
						"1145",
						"1115",
						"1090"
					],
					"projections_percentage": [
						-6.89,
						0,
						-7.21,
						-7.21,
						-9.64,
						-11.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8495
				}
			],
			"uid": 30043
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 292
			},
			"enrolment": 4359,
			"level": "Combined",
			"ligo": 0.92,
			"name": "Cootamundra Network RM",
			"playspace": 425.54,
			"projections": [
				4360,
				4339,
				4144,
				3904,
				3642
			],
			"projections_percentage": [
				0,
				-0.48,
				-4.95,
				-10.46,
				-16.47
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.66,
					"enrolment": 78,
					"ligo": 1,
					"location": [
						148.063166154964,
						-35.3129504040392
					],
					"name": "Adelong Public School",
					"playspace": 206.87,
					"projections": [
						89,
						78,
						75,
						75,
						75,
						70
					],
					"projections_orig": [
						"89",
						"78",
						"75",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						14.1,
						0,
						-3.85,
						-3.85,
						-3.85,
						-10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1009
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 5.03,
					"enrolment": 132,
					"ligo": 1,
					"location": [
						147.21793061169,
						-34.3473740756136
					],
					"name": "Ariah Park Central School",
					"playspace": 120.07,
					"projections": [
						119,
						132,
						125,
						115,
						110,
						100
					],
					"projections_orig": [
						"119",
						"132",
						"125",
						"115",
						"110",
						"100"
					],
					"projections_percentage": [
						-9.85,
						0,
						-5.3,
						-12.88,
						-16.67,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1055
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 12.02,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						147.38505653996,
						-34.147363454227
					],
					"name": "Barmedman Public School",
					"playspace": 1303.57,
					"projections": [
						18,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						28.57,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1137
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 4.75,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						148.39988020117,
						-35.0834524157993
					],
					"name": "Bongongo Public School",
					"playspace": 1102.03,
					"projections": [
						11,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-31.25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1293
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.34,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						148.232136910646,
						-35.1568357793331
					],
					"name": "Brungle Public School",
					"playspace": 2254.01,
					"projections": [
						24,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"24",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						140,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1387
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.02,
					"enrolment": 323,
					"ligo": 1,
					"location": [
						147.200705633574,
						-34.8118402917545
					],
					"name": "Coolamon Central School",
					"playspace": 35.63,
					"projections": [
						258,
						323,
						305,
						305,
						300,
						280
					],
					"projections_orig": [
						"258",
						"323",
						"305",
						"305",
						"300",
						"280"
					],
					"projections_percentage": [
						-20.12,
						0,
						-5.57,
						-5.57,
						-7.12,
						-13.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1624
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.3,
					"enrolment": 295,
					"ligo": 0.59,
					"location": [
						148.026941219618,
						-34.6395023617423
					],
					"name": "Cootamundra Public School",
					"playspace": 36.19,
					"projections": [
						244,
						295,
						255,
						245,
						235,
						220
					],
					"projections_orig": [
						"244",
						"295",
						"255",
						"245",
						"235",
						"220"
					],
					"projections_percentage": [
						-17.29,
						0,
						-13.56,
						-16.95,
						-20.34,
						-25.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1636
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.88,
					"enrolment": 20,
					"ligo": 1,
					"location": [
						147.781487395767,
						-34.9103407024103
					],
					"name": "Eurongilly Public School",
					"playspace": 321.35,
					"projections": [
						17,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1883
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 10.24,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						147.039279180598,
						-34.79654786838
					],
					"name": "Ganmain Public School",
					"playspace": 896.93,
					"projections": [
						39,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						50,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1954
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.32,
					"enrolment": 154,
					"ligo": 1,
					"location": [
						148.108373648521,
						-35.0516499114088
					],
					"name": "Gundagai Public School",
					"playspace": 293.4,
					"projections": [
						149,
						154,
						135,
						130,
						125,
						115
					],
					"projections_orig": [
						"149",
						"154",
						"135",
						"130",
						"125",
						"115"
					],
					"projections_percentage": [
						-3.25,
						0,
						-12.34,
						-15.58,
						-18.83,
						-25.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2102
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.4,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						148.102553650512,
						-35.0803887964764
					],
					"name": "Gundagai South Public School",
					"playspace": 430.63,
					"projections": [
						85,
						53,
						55,
						55,
						50,
						25
					],
					"projections_orig": [
						"85",
						"53",
						"55",
						"55",
						"50",
						"<50"
					],
					"projections_percentage": [
						60.38,
						0,
						3.77,
						3.77,
						-5.66,
						-52.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2103
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.94,
					"enrolment": 28,
					"ligo": 1,
					"location": [
						147.740231833808,
						-34.8139012192777
					],
					"name": "Illabo Public School",
					"playspace": 392.41,
					"projections": [
						28,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2203
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.99,
					"enrolment": 135,
					"ligo": 0.89,
					"location": [
						147.585278960156,
						-34.8739625448868
					],
					"name": "Junee Public School",
					"playspace": 100.71,
					"projections": [
						129,
						135,
						140,
						145,
						140,
						130
					],
					"projections_orig": [
						"129",
						"135",
						"140",
						"145",
						"140",
						"130"
					],
					"projections_percentage": [
						-4.44,
						0,
						3.7,
						7.41,
						3.7,
						-3.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2247
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 4
					},
					"classroomspace": 2.75,
					"enrolment": 162,
					"ligo": 0.56,
					"location": [
						147.584504318211,
						-34.8552936426542
					],
					"name": "Junee North Public School",
					"playspace": 52.93,
					"projections": [
						191,
						162,
						170,
						170,
						165,
						155
					],
					"projections_orig": [
						"191",
						"162",
						"170",
						"170",
						"165",
						"155"
					],
					"projections_percentage": [
						17.9,
						0,
						4.94,
						4.94,
						1.85,
						-4.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2248
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.98,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						147.355144095925,
						-34.8283395019903
					],
					"name": "Marrar Public School",
					"playspace": 777.62,
					"projections": [
						28,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						86.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2485
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.38,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						146.92798413654,
						-34.769614988315
					],
					"name": "Matong Public School",
					"playspace": 814.72,
					"projections": [
						44,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						69.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2501
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.44,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						147.907969094659,
						-35.0541064314476
					],
					"name": "Nangus Public School",
					"playspace": 779.32,
					"projections": [
						32,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						10.34,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2699
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.38,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						147.883273225633,
						-34.4973220954575
					],
					"name": "Stockinbingal Public School",
					"playspace": 226.35,
					"projections": [
						37,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.31,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.1,
					"enrolment": 279,
					"ligo": 0.74,
					"location": [
						147.534671138143,
						-34.444916446533
					],
					"name": "Temora Public School",
					"playspace": 22.36,
					"projections": [
						209,
						279,
						245,
						225,
						210,
						200
					],
					"projections_orig": [
						"209",
						"279",
						"245",
						"225",
						"210",
						"200"
					],
					"projections_percentage": [
						-25.09,
						0,
						-12.19,
						-19.35,
						-24.73,
						-28.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3178
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.97,
					"enrolment": 314,
					"ligo": 0.62,
					"location": [
						148.217621164659,
						-35.3024085084743
					],
					"name": "Tumut Public School",
					"playspace": 44.79,
					"projections": [
						343,
						314,
						350,
						310,
						285,
						265
					],
					"projections_orig": [
						"343",
						"314",
						"350",
						"310",
						"285",
						"265"
					],
					"projections_percentage": [
						9.24,
						0,
						11.46,
						-1.27,
						-9.24,
						-15.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3278
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.37,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						148.159096752089,
						-34.5243442489961
					],
					"name": "Wallendbeen Public School",
					"playspace": 1145.52,
					"projections": [
						16,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						14.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3353
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 3.21,
					"enrolment": 146,
					"ligo": 0.74,
					"location": [
						147.523526138967,
						-34.450640393908
					],
					"name": "Temora West Public School",
					"playspace": 205.03,
					"projections": [
						156,
						146,
						145,
						140,
						130,
						125
					],
					"projections_orig": [
						"156",
						"146",
						"145",
						"140",
						"130",
						"125"
					],
					"projections_percentage": [
						6.85,
						0,
						-0.68,
						-4.11,
						-10.96,
						-14.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4209
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 5.81,
					"enrolment": 130,
					"ligo": 0.7,
					"location": [
						148.013920847077,
						-34.6424423153949
					],
					"name": "E A Southee Public School",
					"playspace": 166.61,
					"projections": [
						215,
						130,
						165,
						160,
						150,
						140
					],
					"projections_orig": [
						"215",
						"130",
						"165",
						"160",
						"150",
						"140"
					],
					"projections_percentage": [
						65.38,
						0,
						26.92,
						23.08,
						15.38,
						7.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4383
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 8
					},
					"classroomspace": 3.38,
					"enrolment": 296,
					"ligo": 0.83,
					"location": [
						148.229607621144,
						-35.3149451601717
					],
					"name": "Franklin Public School",
					"playspace": 63.7,
					"projections": [
						295,
						296,
						315,
						265,
						250,
						235
					],
					"projections_orig": [
						"295",
						"296",
						"315",
						"265",
						"250",
						"235"
					],
					"projections_percentage": [
						-0.34,
						0,
						6.42,
						-10.47,
						-15.54,
						-20.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4456
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 4.8,
					"enrolment": 351,
					"ligo": 1,
					"location": [
						147.54092068207,
						-34.4417197653749
					],
					"name": "Temora High School",
					"playspace": 79.41,
					"projections": [
						371,
						351,
						355,
						325,
						290,
						275
					],
					"projections_orig": [
						"371",
						"351",
						"355",
						"325",
						"290",
						"275"
					],
					"projections_percentage": [
						5.7,
						0,
						1.14,
						-7.41,
						-17.38,
						-21.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8168
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 7.48,
					"enrolment": 203,
					"ligo": 1,
					"location": [
						147.590493034036,
						-34.869408946834
					],
					"name": "Junee High School",
					"playspace": 163.61,
					"projections": [
						246,
						204,
						225,
						230,
						220,
						210
					],
					"projections_orig": [
						"246",
						"204",
						"225",
						"230",
						"220",
						"210"
					],
					"projections_percentage": [
						20.59,
						0,
						10.29,
						12.75,
						7.84,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8179
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 6.86,
					"enrolment": 315,
					"ligo": 1,
					"location": [
						148.019332648864,
						-34.6355058261483
					],
					"name": "Cootamundra High School",
					"playspace": 128.05,
					"projections": [
						376,
						315,
						285,
						290,
						270,
						240
					],
					"projections_orig": [
						"376",
						"315",
						"285",
						"290",
						"270",
						"240"
					],
					"projections_percentage": [
						19.37,
						0,
						-9.52,
						-7.94,
						-14.29,
						-23.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8190
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 35
					},
					"classroomspace": 4.21,
					"enrolment": 563,
					"ligo": 1,
					"location": [
						148.220184708587,
						-35.3128378942835
					],
					"name": "Tumut High School",
					"playspace": 53.33,
					"projections": [
						565,
						563,
						565,
						535,
						490,
						430
					],
					"projections_orig": [
						"565",
						"563",
						"565",
						"535",
						"490",
						"430"
					],
					"projections_percentage": [
						0.36,
						0,
						0.36,
						-4.97,
						-12.97,
						-23.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8343
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 5.55,
					"enrolment": 206,
					"ligo": 1,
					"location": [
						148.100228354432,
						-35.0579608521979
					],
					"name": "Gundagai High School",
					"playspace": 123.57,
					"projections": [
						222,
						206,
						205,
						200,
						185,
						175
					],
					"projections_orig": [
						"222",
						"206",
						"205",
						"200",
						"185",
						"175"
					],
					"projections_percentage": [
						7.77,
						0,
						-0.49,
						-2.91,
						-10.19,
						-15.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8442
				}
			],
			"uid": 30045
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 312
			},
			"enrolment": 3790,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Deniliquin Network RM",
			"playspace": 462.7,
			"projections": [
				3790,
				3510,
				3400,
				3280,
				3136
			],
			"projections_percentage": [
				0,
				-7.39,
				-10.29,
				-13.46,
				-17.26
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.55,
					"enrolment": 151,
					"ligo": 1,
					"location": [
						144.12848865298,
						-35.6273520080064
					],
					"name": "Barham Public School",
					"playspace": 128.32,
					"projections": [
						165,
						151,
						155,
						145,
						135,
						125
					],
					"projections_orig": [
						"165",
						"151",
						"155",
						"145",
						"135",
						"125"
					],
					"projections_percentage": [
						9.27,
						0,
						2.65,
						-3.97,
						-10.6,
						-17.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1135
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.68,
					"enrolment": 153,
					"ligo": 1,
					"location": [
						145.696508770555,
						-35.9127892742736
					],
					"name": "Barooga Public School",
					"playspace": 114.39,
					"projections": [
						148,
						153,
						160,
						150,
						140,
						130
					],
					"projections_orig": [
						"148",
						"153",
						"160",
						"150",
						"140",
						"130"
					],
					"projections_percentage": [
						-3.27,
						0,
						4.58,
						-1.96,
						-8.5,
						-15.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1139
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.46,
					"enrolment": 81,
					"ligo": 1,
					"location": [
						145.815507649309,
						-35.6587207455738
					],
					"name": "Berrigan Public School",
					"playspace": 208.46,
					"projections": [
						74,
						81,
						75,
						70,
						65,
						60
					],
					"projections_orig": [
						"74",
						"81",
						"75",
						"70",
						"65",
						"60"
					],
					"projections_percentage": [
						-8.64,
						0,
						-7.41,
						-13.58,
						-19.75,
						-25.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1207
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.28,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						145.349870056973,
						-35.579814751989
					],
					"name": "Blighty Public School",
					"playspace": 189.84,
					"projections": [
						30,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-16.67,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1261
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.87,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						144.886334432158,
						-33.8668229141847
					],
					"name": "Booligal Public School",
					"playspace": 667.48,
					"projections": [
						10,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1303
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.07,
					"enrolment": 48,
					"ligo": 1,
					"location": [
						144.597707373558,
						-35.7856431334799
					],
					"name": "Bunnaloo Public School",
					"playspace": 257.06,
					"projections": [
						46,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"46",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-4.17,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1425
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 11.87,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						145.431843318175,
						-34.4083240213921
					],
					"name": "Carrathool Public School",
					"playspace": 3405.71,
					"projections": [
						12,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						71.43,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1517
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.08,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						145.179373036024,
						-35.3054803023697
					],
					"name": "Conargo Public School",
					"playspace": 765.12,
					"projections": [
						26,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						62.5,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1606
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.78,
					"enrolment": 196,
					"ligo": 1,
					"location": [
						144.844356799559,
						-34.505650761512
					],
					"name": "Hay Public School",
					"playspace": 93.27,
					"projections": [
						212,
						196,
						170,
						160,
						155,
						150
					],
					"projections_orig": [
						"212",
						"196",
						"170",
						"160",
						"155",
						"150"
					],
					"projections_percentage": [
						8.16,
						0,
						-13.27,
						-18.37,
						-20.92,
						-23.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2145
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 7.62,
					"enrolment": 40,
					"ligo": 1,
					"location": [
						145.729760509615,
						-35.3545034872328
					],
					"name": "Jerilderie Public School",
					"playspace": 227.37,
					"projections": [
						43,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"43",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.5,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2226
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.69,
					"enrolment": 64,
					"ligo": 1,
					"location": [
						144.902922467883,
						-35.816052922635
					],
					"name": "Mathoura Public School",
					"playspace": 192.53,
					"projections": [
						58,
						64,
						60,
						55,
						55,
						50
					],
					"projections_orig": [
						"58",
						"64",
						"60",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						-9.38,
						0,
						-6.25,
						-14.06,
						-14.06,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2500
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.23,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						145.308663911255,
						-35.4635669988092
					],
					"name": "Mayrung Public School",
					"playspace": 212.81,
					"projections": [
						31,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.9,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2508
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 3.45,
					"enrolment": 206,
					"ligo": 1,
					"location": [
						144.763310165609,
						-36.1148683852224
					],
					"name": "Moama Public School",
					"playspace": 67.64,
					"projections": [
						247,
						206,
						195,
						200,
						200,
						195
					],
					"projections_orig": [
						"247",
						"206",
						"195",
						"200",
						"200",
						"195"
					],
					"projections_percentage": [
						19.9,
						0,
						-5.34,
						-2.91,
						-2.91,
						-5.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2584
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 13.38,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						144.033524855089,
						-35.0898035024564
					],
					"name": "Moulamein Public School",
					"playspace": 292.36,
					"projections": [
						42,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"42",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-4.55,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2632
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.77,
					"enrolment": 51,
					"ligo": 1,
					"location": [
						146.007065621257,
						-35.9874066482704
					],
					"name": "Mulwala Public School",
					"playspace": 144.05,
					"projections": [
						61,
						51,
						55,
						50,
						50,
						25
					],
					"projections_orig": [
						"61",
						"51",
						"55",
						"50",
						"50",
						"<50"
					],
					"projections_percentage": [
						19.61,
						0,
						7.84,
						-1.96,
						-1.96,
						-50.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2667
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 11.36,
					"enrolment": 67,
					"ligo": 1,
					"location": [
						146.169855945716,
						-35.552306912927
					],
					"name": "Oaklands Central School",
					"playspace": 455,
					"projections": [
						66,
						67,
						85,
						75,
						70,
						65
					],
					"projections_orig": [
						"66",
						"67",
						"85",
						"75",
						"70",
						"65"
					],
					"projections_percentage": [
						-1.49,
						0,
						26.87,
						11.94,
						4.48,
						-2.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2791
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 6.34,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						146.047075973054,
						-35.7315106304148
					],
					"name": "Savernake Public School",
					"playspace": 1972.06,
					"projections": [
						20,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						100,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3041
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.66,
					"enrolment": 154,
					"ligo": 1,
					"location": [
						145.568390165788,
						-35.8134183153876
					],
					"name": "Tocumwal Public School",
					"playspace": 94.56,
					"projections": [
						119,
						154,
						110,
						100,
						90,
						80
					],
					"projections_orig": [
						"119",
						"154",
						"110",
						"100",
						"90",
						"80"
					],
					"projections_percentage": [
						-22.73,
						0,
						-28.57,
						-35.06,
						-41.56,
						-48.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3225
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 8.31,
					"enrolment": 121,
					"ligo": 1,
					"location": [
						143.337598015368,
						-35.0276884099083
					],
					"name": "Tooleybuc Central School",
					"playspace": 452.66,
					"projections": [
						115,
						121,
						100,
						90,
						90,
						90
					],
					"projections_orig": [
						"115",
						"121",
						"100",
						"90",
						"90",
						"90"
					],
					"projections_percentage": [
						-4.96,
						0,
						-17.36,
						-25.62,
						-25.62,
						-25.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3235
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 42.11,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						146.26664908217,
						-35.3278051543142
					],
					"name": "Urana Public School",
					"playspace": 650.55,
					"projections": [
						44,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						238.46,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3314
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 16.14,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						144.393209670501,
						-35.4669742205909
					],
					"name": "Wakool Burraboi Public School",
					"playspace": 1992.06,
					"projections": [
						30,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						150,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3336
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 5.55,
					"enrolment": 201,
					"ligo": 1,
					"location": [
						145.575397232516,
						-35.6397280960363
					],
					"name": "Finley Public School",
					"playspace": 75.25,
					"projections": [
						210,
						201,
						185,
						165,
						150,
						140
					],
					"projections_orig": [
						"210",
						"201",
						"185",
						"165",
						"150",
						"140"
					],
					"projections_percentage": [
						4.48,
						0,
						-7.96,
						-17.91,
						-25.37,
						-30.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3945
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.58,
					"enrolment": 282,
					"ligo": 0.75,
					"location": [
						144.957105004307,
						-35.5377751759467
					],
					"name": "Deniliquin South Public School",
					"playspace": 115.93,
					"projections": [
						293,
						282,
						240,
						250,
						255,
						250
					],
					"projections_orig": [
						"293",
						"282",
						"240",
						"250",
						"255",
						"250"
					],
					"projections_percentage": [
						3.9,
						0,
						-14.89,
						-11.35,
						-9.57,
						-11.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4112
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.52,
					"enrolment": 146,
					"ligo": 0.82,
					"location": [
						144.981216055196,
						-35.5251318275518
					],
					"name": "Deniliquin North Public School",
					"playspace": 130.34,
					"projections": [
						151,
						146,
						115,
						120,
						120,
						120
					],
					"projections_orig": [
						"151",
						"146",
						"115",
						"120",
						"120",
						"120"
					],
					"projections_percentage": [
						3.42,
						0,
						-21.23,
						-17.81,
						-17.81,
						-17.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4281
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 6.16,
					"enrolment": 229,
					"ligo": 1,
					"location": [
						145.882655983031,
						-34.8055852806193
					],
					"name": "Coleambally Central School",
					"playspace": 237.96,
					"projections": [
						233,
						229,
						230,
						210,
						200,
						185
					],
					"projections_orig": [
						"233",
						"229",
						"230",
						"210",
						"200",
						"185"
					],
					"projections_percentage": [
						1.75,
						0,
						0.44,
						-8.3,
						-12.66,
						-19.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4348
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.66,
					"enrolment": 164,
					"ligo": 0.81,
					"location": [
						144.951844650974,
						-35.5249025158169
					],
					"name": "Edward Public School",
					"playspace": 176.17,
					"projections": [
						192,
						164,
						135,
						145,
						145,
						145
					],
					"projections_orig": [
						"192",
						"164",
						"135",
						"145",
						"145",
						"145"
					],
					"projections_percentage": [
						17.07,
						0,
						-17.68,
						-11.59,
						-11.59,
						-11.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4418
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 7.03,
					"enrolment": 187,
					"ligo": 1,
					"location": [
						144.841604456615,
						-34.5049603706985
					],
					"name": "Hay War Memorial High School",
					"playspace": 235.96,
					"projections": [
						189,
						187,
						150,
						135,
						130,
						130
					],
					"projections_orig": [
						"189",
						"187",
						"150",
						"135",
						"130",
						"130"
					],
					"projections_percentage": [
						1.07,
						0,
						-19.79,
						-27.81,
						-30.48,
						-30.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8119
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 4.75,
					"enrolment": 536,
					"ligo": 1,
					"location": [
						144.960233596785,
						-35.536602401731
					],
					"name": "Deniliquin High School",
					"playspace": 56.56,
					"projections": [
						574,
						536,
						540,
						575,
						570,
						560
					],
					"projections_orig": [
						"574",
						"536",
						"540",
						"575",
						"570",
						"560"
					],
					"projections_percentage": [
						7.09,
						0,
						0.75,
						7.28,
						6.34,
						4.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8218
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 5.71,
					"enrolment": 383,
					"ligo": 1,
					"location": [
						145.573338977903,
						-35.6403164312449
					],
					"name": "Finley High School",
					"playspace": 121.36,
					"projections": [
						428,
						383,
						360,
						325,
						290,
						250
					],
					"projections_orig": [
						"428",
						"383",
						"360",
						"325",
						"290",
						"250"
					],
					"projections_percentage": [
						11.75,
						0,
						-6.01,
						-15.14,
						-24.28,
						-34.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8360
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 9.14,
					"enrolment": 153,
					"ligo": 1,
					"location": [
						144.130962442988,
						-35.6244529392821
					],
					"name": "Barham High School",
					"playspace": 148.09,
					"projections": [
						176,
						153,
						125,
						115,
						105,
						95
					],
					"projections_orig": [
						"176",
						"153",
						"125",
						"115",
						"105",
						"95"
					],
					"projections_percentage": [
						15.03,
						0,
						-18.3,
						-24.84,
						-31.37,
						-37.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8461
				}
			],
			"uid": 30046
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 172
			},
			"enrolment": 2186,
			"level": "Combined",
			"ligo": 1,
			"name": "Griffith Network",
			"playspace": 760.07,
			"projections": [
				2186,
				2242,
				2158,
				2028,
				1878
			],
			"projections_percentage": [
				0,
				2.56,
				-1.28,
				-7.23,
				-14.09
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 13.61,
					"enrolment": 66,
					"ligo": 1,
					"location": [
						146.901709819357,
						-34.3543884858945
					],
					"name": "Ardlethan Central School",
					"playspace": 103.16,
					"projections": [
						109,
						66,
						80,
						75,
						70,
						65
					],
					"projections_orig": [
						"109",
						"66",
						"80",
						"75",
						"70",
						"65"
					],
					"projections_percentage": [
						65.15,
						0,
						21.21,
						13.64,
						6.06,
						-1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1051
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 6
					},
					"classroomspace": 6.74,
					"enrolment": 123,
					"ligo": 1,
					"location": [
						146.572314348131,
						-34.2878318974544
					],
					"name": "Barellan Central School",
					"playspace": 157.1,
					"projections": [
						122,
						123,
						100,
						90,
						85,
						75
					],
					"projections_orig": [
						"122",
						"123",
						"100",
						"90",
						"85",
						"75"
					],
					"projections_percentage": [
						-0.81,
						0,
						-18.7,
						-26.83,
						-30.89,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1131
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.75,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						146.963253344752,
						-34.3267529446107
					],
					"name": "Beckom Public School",
					"playspace": 1128.83,
					"projections": [
						13,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1160
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.84,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						146.352594256909,
						-34.2285971999365
					],
					"name": "Binya Public School",
					"playspace": 997.67,
					"projections": [
						17,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						54.55,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1238
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.24,
					"enrolment": 96,
					"ligo": 1,
					"location": [
						145.993368453082,
						-34.5720294090203
					],
					"name": "Darlington Point Public School",
					"playspace": 281.66,
					"projections": [
						108,
						96,
						105,
						95,
						90,
						85
					],
					"projections_orig": [
						"108",
						"96",
						"105",
						"95",
						"90",
						"85"
					],
					"projections_percentage": [
						12.5,
						0,
						9.38,
						-1.04,
						-6.25,
						-11.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1736
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.57,
					"enrolment": 48,
					"ligo": 1,
					"location": [
						145.708812554572,
						-33.9764825119664
					],
					"name": "Goolgowi Public School",
					"playspace": 412.9,
					"projections": [
						70,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"70",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						45.83,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2035
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 6.92,
					"enrolment": 162,
					"ligo": 1,
					"location": [
						145.539454316774,
						-33.4812182691609
					],
					"name": "Hillston Central School",
					"playspace": 215.24,
					"projections": [
						177,
						162,
						150,
						140,
						130,
						120
					],
					"projections_orig": [
						"177",
						"162",
						"150",
						"140",
						"130",
						"120"
					],
					"projections_percentage": [
						9.26,
						0,
						-7.41,
						-13.58,
						-19.75,
						-25.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2165
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.44,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						146.327500390363,
						-33.6148502222993
					],
					"name": "Naradhan Public School",
					"playspace": 277.54,
					"projections": [
						13,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2701
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.56,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						146.258677619712,
						-33.8400119033937
					],
					"name": "Rankins Springs Public School",
					"playspace": 930.77,
					"projections": [
						18,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-18.18,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2935
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.15,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						146.877901082243,
						-33.9927036002746
					],
					"name": "Tallimba Public School",
					"playspace": 239.79,
					"projections": [
						26,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3153
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 8.19,
					"enrolment": 94,
					"ligo": 1,
					"location": [
						146.977375346761,
						-33.6384663973174
					],
					"name": "Ungarie Central School",
					"playspace": 411.45,
					"projections": [
						97,
						94,
						95,
						85,
						80,
						75
					],
					"projections_orig": [
						"97",
						"94",
						"95",
						"85",
						"80",
						"75"
					],
					"projections_percentage": [
						3.19,
						0,
						1.06,
						-9.57,
						-14.89,
						-20.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3311
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.05,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						146.330427577213,
						-34.525403816546
					],
					"name": "Wamoon Public School",
					"playspace": 207.39,
					"projections": [
						32,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.67,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3364
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.72,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						146.619176022767,
						-33.8791970515995
					],
					"name": "Weethalle Public School",
					"playspace": 680.43,
					"projections": [
						29,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						38.1,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3415
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.8,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						146.180434507185,
						-34.5191492333556
					],
					"name": "Whitton-Murrami Public School",
					"playspace": 277.8,
					"projections": [
						0,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"0",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-100,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3438
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.8,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						147.242139910185,
						-33.9234433195497
					],
					"name": "Wyalong Public School",
					"playspace": 324.71,
					"projections": [
						55,
						56,
						50,
						25,
						25,
						25
					],
					"projections_orig": [
						"55",
						"56",
						"50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-1.79,
						0,
						-10.71,
						-55.36,
						-55.36,
						-55.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3518
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.77,
					"enrolment": 293,
					"ligo": 1,
					"location": [
						147.2039706132,
						-33.9188121478431
					],
					"name": "West Wyalong Public School",
					"playspace": 91.54,
					"projections": [
						317,
						293,
						285,
						250,
						235,
						220
					],
					"projections_orig": [
						"317",
						"293",
						"285",
						"250",
						"235",
						"220"
					],
					"projections_percentage": [
						8.19,
						0,
						-2.73,
						-14.68,
						-19.8,
						-24.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3519
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 5.37,
					"enrolment": 313,
					"ligo": 1,
					"location": [
						146.381320050514,
						-34.6338279187293
					],
					"name": "Yanco Agricultural High School",
					"playspace": 7355.17,
					"projections": [
						368,
						313,
						365,
						365,
						345,
						305
					],
					"projections_orig": [
						"368",
						"313",
						"365",
						"365",
						"345",
						"305"
					],
					"projections_percentage": [
						17.57,
						0,
						16.61,
						16.61,
						10.22,
						-2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8144
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 4.68,
					"enrolment": 446,
					"ligo": 1,
					"location": [
						146.404309071392,
						-34.546901894756
					],
					"name": "Leeton High School",
					"playspace": 186.95,
					"projections": [
						457,
						446,
						500,
						515,
						490,
						440
					],
					"projections_orig": [
						"457",
						"446",
						"500",
						"515",
						"490",
						"440"
					],
					"projections_percentage": [
						2.47,
						0,
						12.11,
						15.47,
						9.87,
						-1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8156
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 4.94,
					"enrolment": 320,
					"ligo": 1,
					"location": [
						147.202772668496,
						-33.9155667303204
					],
					"name": "West Wyalong High School",
					"playspace": 161.14,
					"projections": [
						340,
						320,
						295,
						270,
						230,
						220
					],
					"projections_orig": [
						"340",
						"320",
						"295",
						"270",
						"230",
						"220"
					],
					"projections_percentage": [
						6.25,
						0,
						-7.81,
						-15.62,
						-28.12,
						-31.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8392
				}
			],
			"uid": 30047
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 66
			},
			"enrolment": 647,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Albury Network East",
			"playspace": 688.09,
			"projections": [
				647,
				669,
				669,
				659,
				634
			],
			"projections_percentage": [
				0,
				3.4,
				3.4,
				1.85,
				-2.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 11.23,
					"enrolment": 117,
					"ligo": 1,
					"location": [
						148.147453752521,
						-35.5220865787403
					],
					"name": "Batlow Technology School",
					"playspace": 163.07,
					"projections": [
						163,
						117,
						150,
						150,
						150,
						140
					],
					"projections_orig": [
						"163",
						"117",
						"150",
						"150",
						"150",
						"140"
					],
					"projections_percentage": [
						39.32,
						0,
						28.21,
						28.21,
						28.21,
						19.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1152
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 4.15,
					"enrolment": 142,
					"ligo": 1,
					"location": [
						147.319826939629,
						-35.7166340251219
					],
					"name": "Holbrook Public School",
					"playspace": 196.78,
					"projections": [
						171,
						142,
						145,
						145,
						150,
						145
					],
					"projections_orig": [
						"171",
						"142",
						"145",
						"145",
						"150",
						"145"
					],
					"projections_percentage": [
						20.42,
						0,
						2.11,
						2.11,
						5.63,
						2.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2170
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.12,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						147.762234668291,
						-35.4833663576347
					],
					"name": "Humula Public School",
					"playspace": 1731.24,
					"projections": [
						12,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-14.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2188
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.6,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						147.861982318776,
						-35.670327178576
					],
					"name": "Rosewood Public School",
					"playspace": 733.43,
					"projections": [
						24,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"24",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2996
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.77,
					"enrolment": 157,
					"ligo": 1,
					"location": [
						148.013550565093,
						-35.7755974269371
					],
					"name": "Tumbarumba Public School",
					"playspace": 83.94,
					"projections": [
						188,
						157,
						155,
						155,
						150,
						145
					],
					"projections_orig": [
						"188",
						"157",
						"155",
						"155",
						"150",
						"145"
					],
					"projections_percentage": [
						19.75,
						0,
						-1.27,
						-1.27,
						-4.46,
						-7.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3275
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 17.98,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						148.132203859824,
						-36.2143464986008
					],
					"name": "Khancoban Public School",
					"playspace": 1611.94,
					"projections": [
						26,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						52.94,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4270
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 7.01,
					"enrolment": 182,
					"ligo": 1,
					"location": [
						148.016701061706,
						-35.782539278187
					],
					"name": "Tumbarumba High School",
					"playspace": 296.23,
					"projections": [
						192,
						182,
						170,
						170,
						160,
						155
					],
					"projections_orig": [
						"192",
						"182",
						"170",
						"170",
						"160",
						"155"
					],
					"projections_percentage": [
						5.49,
						0,
						-6.59,
						-6.59,
						-12.09,
						-14.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8450
				}
			],
			"uid": 30048
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 136
			},
			"enrolment": 1685,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Wagga Network",
			"playspace": 559.38,
			"projections": [
				1685,
				1589,
				1587,
				1529,
				1469
			],
			"projections_percentage": [
				0,
				-5.7,
				-5.82,
				-9.26,
				-12.82
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.89,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						146.605854502317,
						-35.1067270996722
					],
					"name": "Boree Creek Public School",
					"playspace": 580.85,
					"projections": [
						18,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-21.74,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1318
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 6.62,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						147.249647822818,
						-35.1892101706032
					],
					"name": "Uranquinty Public School",
					"playspace": 492.43,
					"projections": [
						55,
						37,
						25,
						50,
						25,
						25
					],
					"projections_orig": [
						"55",
						"37",
						"<50",
						"50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						48.65,
						0,
						-32.43,
						35.14,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1499
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.59,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						147.127129720513,
						-35.0883922898426
					],
					"name": "Collingullie Public School",
					"playspace": 3467.97,
					"projections": [
						28,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						133.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1591
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.51,
					"enrolment": 120,
					"ligo": 1,
					"location": [
						147.039975098262,
						-35.6674980052161
					],
					"name": "Culcairn Public School",
					"playspace": 67.22,
					"projections": [
						116,
						120,
						105,
						105,
						110,
						105
					],
					"projections_orig": [
						"116",
						"120",
						"105",
						"105",
						"110",
						"105"
					],
					"projections_percentage": [
						-3.33,
						0,
						-12.5,
						-12.5,
						-8.33,
						-12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1698
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.29,
					"enrolment": 134,
					"ligo": 1,
					"location": [
						147.031040172447,
						-35.5168296623665
					],
					"name": "Henty Public School",
					"playspace": 91.57,
					"projections": [
						113,
						134,
						115,
						120,
						120,
						120
					],
					"projections_orig": [
						"113",
						"134",
						"115",
						"120",
						"120",
						"120"
					],
					"projections_percentage": [
						-15.67,
						0,
						-14.18,
						-10.45,
						-10.45,
						-10.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2154
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.27,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						147.511463711291,
						-35.209200745912
					],
					"name": "Ladysmith Public School",
					"playspace": 478.76,
					"projections": [
						39,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.18,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2353
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 12.17,
					"enrolment": 86,
					"ligo": 1,
					"location": [
						146.713835973614,
						-35.222515088996
					],
					"name": "Lockhart Central School",
					"playspace": 177.03,
					"projections": [
						94,
						86,
						105,
						110,
						105,
						100
					],
					"projections_orig": [
						"94",
						"86",
						"105",
						"110",
						"105",
						"100"
					],
					"projections_percentage": [
						9.3,
						0,
						22.09,
						27.91,
						22.09,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2418
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.28,
					"enrolment": 265,
					"ligo": 1,
					"location": [
						146.548250002114,
						-34.7444168295606
					],
					"name": "Narrandera Public School",
					"playspace": 54.03,
					"projections": [
						235,
						265,
						235,
						220,
						205,
						195
					],
					"projections_orig": [
						"235",
						"265",
						"235",
						"220",
						"205",
						"195"
					],
					"projections_percentage": [
						-11.32,
						0,
						-11.32,
						-16.98,
						-22.64,
						-26.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2710
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.95,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						146.798688721424,
						-35.4659970227155
					],
					"name": "Pleasant Hills Public School",
					"playspace": 202.45,
					"projections": [
						14,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-36.36,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2886
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.14,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						146.579880052451,
						-35.5953018237575
					],
					"name": "Rand Public School",
					"playspace": 898.46,
					"projections": [
						17,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.73,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2933
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 5.66,
					"enrolment": 160,
					"ligo": 1,
					"location": [
						147.115167006008,
						-35.2670646989453
					],
					"name": "The Rock Central School",
					"playspace": 39.13,
					"projections": [
						156,
						160,
						160,
						160,
						160,
						150
					],
					"projections_orig": [
						"156",
						"160",
						"160",
						"160",
						"160",
						"150"
					],
					"projections_percentage": [
						-2.5,
						0,
						0,
						0,
						0,
						-6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2976
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.87,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						147.739278384621,
						-35.2783161943192
					],
					"name": "Tarcutta Public School",
					"playspace": 1283.44,
					"projections": [
						15,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.14,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3165
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.44,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						147.06071867591,
						-35.3872057437668
					],
					"name": "Yerong Creek Public School",
					"playspace": 386.3,
					"projections": [
						28,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.69,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3556
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.87,
					"enrolment": 63,
					"ligo": 1,
					"location": [
						146.564219072154,
						-34.749980695398
					],
					"name": "Narrandera East Infants School",
					"playspace": 248.93,
					"projections": [
						53,
						63,
						60,
						55,
						55,
						50
					],
					"projections_orig": [
						"53",
						"63",
						"60",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						-15.87,
						0,
						-4.76,
						-12.7,
						-12.7,
						-20.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 6.75,
					"enrolment": 263,
					"ligo": 1,
					"location": [
						146.565522671196,
						-34.742892233934
					],
					"name": "Narrandera High School",
					"playspace": 295.47,
					"projections": [
						311,
						263,
						280,
						250,
						220,
						210
					],
					"projections_orig": [
						"311",
						"263",
						"280",
						"250",
						"220",
						"210"
					],
					"projections_percentage": [
						18.25,
						0,
						6.46,
						-4.94,
						-16.35,
						-20.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8157
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 4.4,
					"enrolment": 405,
					"ligo": 1,
					"location": [
						147.043718622472,
						-35.6622996852362
					],
					"name": "Billabong High School",
					"playspace": 186.04,
					"projections": [
						350,
						405,
						340,
						365,
						365,
						350
					],
					"projections_orig": [
						"350",
						"405",
						"340",
						"365",
						"365",
						"350"
					],
					"projections_percentage": [
						-13.58,
						0,
						-16.05,
						-9.88,
						-9.88,
						-13.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8503
				}
			],
			"uid": 30049
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 177
			},
			"enrolment": 3432,
			"level": "Combined",
			"ligo": 0.75,
			"name": "Griffith Urban",
			"playspace": 184.07,
			"projections": [
				3432,
				3320,
				3152,
				2987,
				2837
			],
			"projections_percentage": [
				0,
				-3.26,
				-8.16,
				-12.97,
				-17.34
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.56,
					"enrolment": 181,
					"ligo": 0.71,
					"location": [
						146.101454846829,
						-34.2521613845286
					],
					"name": "Beelbangera Public School",
					"playspace": 134.1,
					"projections": [
						164,
						181,
						155,
						150,
						145,
						140
					],
					"projections_orig": [
						"164",
						"181",
						"155",
						"150",
						"145",
						"140"
					],
					"projections_percentage": [
						-9.39,
						0,
						-14.36,
						-17.13,
						-19.89,
						-22.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1167
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.38,
					"enrolment": 363,
					"ligo": 0.83,
					"location": [
						146.036418460723,
						-34.2910690909114
					],
					"name": "Griffith Public School",
					"playspace": 105.74,
					"projections": [
						359,
						363,
						370,
						360,
						335,
						325
					],
					"projections_orig": [
						"359",
						"363",
						"370",
						"360",
						"335",
						"325"
					],
					"projections_percentage": [
						-1.1,
						0,
						1.93,
						-0.83,
						-7.71,
						-10.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2087
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 7
					},
					"classroomspace": 3.06,
					"enrolment": 263,
					"ligo": 0.64,
					"location": [
						146.041713082586,
						-34.3300902465495
					],
					"name": "Hanwood Public School",
					"playspace": 43.74,
					"projections": [
						248,
						263,
						255,
						230,
						215,
						205
					],
					"projections_orig": [
						"248",
						"263",
						"255",
						"230",
						"215",
						"205"
					],
					"projections_percentage": [
						-5.7,
						0,
						-3.04,
						-12.55,
						-18.25,
						-22.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2132
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 2.64,
					"enrolment": 125,
					"ligo": 0.6,
					"location": [
						146.032502998774,
						-34.2480176558549
					],
					"name": "Lake Wyangan Public School",
					"playspace": 137.35,
					"projections": [
						105,
						125,
						115,
						105,
						100,
						95
					],
					"projections_orig": [
						"105",
						"125",
						"115",
						"105",
						"100",
						"95"
					],
					"projections_percentage": [
						-16,
						0,
						-8,
						-16,
						-20,
						-24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2363
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.63,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						145.984121729161,
						-34.260734569058
					],
					"name": "Tharbogang Public School",
					"playspace": 662.08,
					"projections": [
						39,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.43,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3195
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 3.17,
					"enrolment": 124,
					"ligo": 1,
					"location": [
						146.197779145196,
						-34.2528616174848
					],
					"name": "Yenda Public School",
					"playspace": 143.56,
					"projections": [
						182,
						124,
						130,
						120,
						115,
						105
					],
					"projections_orig": [
						"182",
						"124",
						"130",
						"120",
						"115",
						"105"
					],
					"projections_percentage": [
						46.77,
						0,
						4.84,
						-3.23,
						-7.26,
						-15.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3554
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.99,
					"enrolment": 27,
					"ligo": 0.71,
					"location": [
						146.086035922516,
						-34.3002214271824
					],
					"name": "Yoogali Public School",
					"playspace": 584.57,
					"projections": [
						65,
						27,
						50,
						25,
						25,
						25
					],
					"projections_orig": [
						"65",
						"27",
						"50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						140.74,
						0,
						85.19,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3561
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.64,
					"enrolment": 364,
					"ligo": 0.65,
					"location": [
						146.047658307385,
						-34.2800852367475
					],
					"name": "Griffith North Public School",
					"playspace": 30.36,
					"projections": [
						398,
						364,
						335,
						325,
						315,
						305
					],
					"projections_orig": [
						"398",
						"364",
						"335",
						"325",
						"315",
						"305"
					],
					"projections_percentage": [
						9.34,
						0,
						-7.97,
						-10.71,
						-13.46,
						-16.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4027
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 18
					},
					"classroomspace": 2.81,
					"enrolment": 571,
					"ligo": 0.56,
					"location": [
						146.061927451081,
						-34.2870715781754
					],
					"name": "Griffith East Public School",
					"playspace": 23.28,
					"projections": [
						502,
						571,
						525,
						500,
						455,
						435
					],
					"projections_orig": [
						"502",
						"571",
						"525",
						"500",
						"455",
						"435"
					],
					"projections_percentage": [
						-12.08,
						0,
						-8.06,
						-12.43,
						-20.32,
						-23.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4268
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 51
					},
					"classroomspace": 5.91,
					"enrolment": 572,
					"ligo": 0.91,
					"location": [
						146.03950513474,
						-34.2912590732409
					],
					"name": "Griffith High School",
					"playspace": 90.43,
					"projections": [
						492,
						572,
						530,
						510,
						490,
						455
					],
					"projections_orig": [
						"492",
						"572",
						"530",
						"510",
						"490",
						"455"
					],
					"projections_percentage": [
						-13.99,
						0,
						-7.34,
						-10.84,
						-14.34,
						-20.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8118
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 41
					},
					"classroomspace": 3.71,
					"enrolment": 807,
					"ligo": 0.66,
					"location": [
						146.07136397175,
						-34.2810400535969
					],
					"name": "Wade High School",
					"playspace": 69.52,
					"projections": [
						828,
						807,
						820,
						790,
						755,
						710
					],
					"projections_orig": [
						"828",
						"807",
						"820",
						"790",
						"755",
						"710"
					],
					"projections_percentage": [
						2.6,
						0,
						1.61,
						-2.11,
						-6.44,
						-12.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8470
				}
			],
			"uid": 30050
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 96
			},
			"enrolment": 1266,
			"level": "Combined",
			"ligo": 0.97,
			"name": "Rural Albury Network West",
			"playspace": 598.05,
			"projections": [
				1266,
				1386,
				1341,
				1281,
				1216
			],
			"projections_percentage": [
				0,
				9.48,
				5.92,
				1.18,
				-3.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.07,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						146.679009127263,
						-35.8236707218937
					],
					"name": "Brocklesby Public School",
					"playspace": 1902.44,
					"projections": [
						31,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						158.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1363
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.87,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						146.800458848776,
						-35.8374943717516
					],
					"name": "Burrumbuttock Public School",
					"playspace": 209.32,
					"projections": [
						27,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.62,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1453
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.51,
					"enrolment": 259,
					"ligo": 0.95,
					"location": [
						146.393776532683,
						-35.9919729806587
					],
					"name": "Corowa Public School",
					"playspace": 134.05,
					"projections": [
						257,
						259,
						250,
						240,
						225,
						215
					],
					"projections_orig": [
						"257",
						"259",
						"250",
						"240",
						"225",
						"215"
					],
					"projections_percentage": [
						-0.77,
						0,
						-3.47,
						-7.34,
						-13.13,
						-16.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1658
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.88,
					"enrolment": 53,
					"ligo": 0.56,
					"location": [
						146.376740761629,
						-36.021571023682
					],
					"name": "Corowa South Public School",
					"playspace": 247.38,
					"projections": [
						85,
						53,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"85",
						"53",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						60.38,
						0,
						13.21,
						13.21,
						3.77,
						3.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1659
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.4,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						146.997840123755,
						-35.8327307950242
					],
					"name": "Gerogery Public School",
					"playspace": 59.46,
					"projections": [
						14,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1969
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.8,
					"enrolment": 206,
					"ligo": 1,
					"location": [
						146.635904535062,
						-35.9807159374404
					],
					"name": "Howlong Public School",
					"playspace": 108.98,
					"projections": [
						172,
						206,
						185,
						165,
						155,
						140
					],
					"projections_orig": [
						"172",
						"206",
						"185",
						"165",
						"155",
						"140"
					],
					"projections_percentage": [
						-16.5,
						0,
						-10.19,
						-19.9,
						-24.76,
						-32.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2186
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 3.45,
					"enrolment": 195,
					"ligo": 1,
					"location": [
						146.885926978431,
						-35.9583883183405
					],
					"name": "Jindera Public School",
					"playspace": 133.66,
					"projections": [
						183,
						195,
						180,
						185,
						185,
						185
					],
					"projections_orig": [
						"183",
						"195",
						"180",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						-6.15,
						0,
						-7.69,
						-5.13,
						-5.13,
						-5.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2239
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.44,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						146.368351179426,
						-35.8555245940803
					],
					"name": "Lowesdale Public School",
					"playspace": 750.59,
					"projections": [
						11,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-47.62,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2429
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 15.05,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						147.164395748658,
						-35.9004065276855
					],
					"name": "Mullengandra Public School",
					"playspace": 1129.34,
					"projections": [
						15,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						150,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2662
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.09,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						146.726836351548,
						-35.6879393542357
					],
					"name": "Walbundrie Public School",
					"playspace": 1130.72,
					"projections": [
						20,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3338
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.01,
					"enrolment": 45,
					"ligo": 1,
					"location": [
						146.901933531975,
						-35.7593234387174
					],
					"name": "Walla Walla Public School",
					"playspace": 497.3,
					"projections": [
						39,
						45,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"45",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-13.33,
						0,
						-44.44,
						-44.44,
						-44.44,
						-44.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3352
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.99,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						147.007262520262,
						-35.968095039886
					],
					"name": "Table Top Public School",
					"playspace": 295.26,
					"projections": [
						67,
						61,
						75,
						75,
						80,
						75
					],
					"projections_orig": [
						"67",
						"61",
						"75",
						"75",
						"80",
						"75"
					],
					"projections_percentage": [
						9.84,
						0,
						22.95,
						22.95,
						31.15,
						22.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3534
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 26.44,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						148.380250390432,
						-35.9334599188892
					],
					"name": "Cabramurra Public School",
					"playspace": 53.69,
					"projections": [
						7,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3928
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.34,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						148.301002893553,
						-35.5802470335985
					],
					"name": "Talbingo Public School",
					"playspace": 2156.92,
					"projections": [
						11,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						10,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4374
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 7.19,
					"enrolment": 336,
					"ligo": 1,
					"location": [
						146.380925474662,
						-35.9934177673172
					],
					"name": "Corowa High School",
					"playspace": 161.58,
					"projections": [
						530,
						336,
						480,
						460,
						425,
						390
					],
					"projections_orig": [
						"530",
						"336",
						"480",
						"460",
						"425",
						"390"
					],
					"projections_percentage": [
						57.74,
						0,
						42.86,
						36.9,
						26.49,
						16.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8308
				}
			],
			"uid": 30051
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 179
			},
			"enrolment": 2829,
			"level": "Combined",
			"ligo": 0.59,
			"name": "Armidale",
			"playspace": 230.54,
			"projections": [
				2830,
				3478,
				3688,
				3738,
				3750
			],
			"projections_percentage": [
				0,
				22.9,
				30.32,
				32.08,
				32.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 4.5,
					"enrolment": 436,
					"ligo": 0.46,
					"location": [
						151.66469368021,
						-30.5201346381184
					],
					"name": "Armidale City Public School",
					"playspace": 53.9,
					"projections": [
						444,
						436,
						485,
						490,
						490,
						500
					],
					"projections_orig": [
						"444",
						"436",
						"485",
						"490",
						"490",
						"500"
					],
					"projections_percentage": [
						1.83,
						0,
						11.24,
						12.39,
						12.39,
						14.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1057
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 6.32,
					"enrolment": 127,
					"ligo": 0.68,
					"location": [
						151.650729386814,
						-30.5106722960712
					],
					"name": "Drummond Memorial Public School",
					"playspace": 204.76,
					"projections": [
						138,
						127,
						170,
						180,
						185,
						190
					],
					"projections_orig": [
						"138",
						"127",
						"170",
						"180",
						"185",
						"190"
					],
					"projections_percentage": [
						8.66,
						0,
						33.86,
						41.73,
						45.67,
						49.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1058
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 23
					},
					"classroomspace": 2.7,
					"enrolment": 528,
					"ligo": 0.49,
					"location": [
						151.674189198904,
						-30.5029017055723
					],
					"name": "Ben Venue Public School",
					"playspace": 27.4,
					"projections": [
						579,
						528,
						655,
						680,
						665,
						680
					],
					"projections_orig": [
						"579",
						"528",
						"655",
						"680",
						"665",
						"680"
					],
					"projections_percentage": [
						9.66,
						0,
						24.05,
						28.79,
						25.95,
						28.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1198
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.53,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						151.637821404152,
						-30.5715781335387
					],
					"name": "Kellys Plains Public School",
					"playspace": 1074.4,
					"projections": [
						41,
						38,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"41",
						"38",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						7.89,
						0,
						-34.21,
						-34.21,
						-34.21,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2273
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.83,
					"enrolment": 165,
					"ligo": 0.31,
					"location": [
						151.63740611691,
						-30.5247790496338
					],
					"name": "Martins Gully Public School",
					"playspace": 126.2,
					"projections": [
						166,
						165,
						185,
						195,
						200,
						205
					],
					"projections_orig": [
						"166",
						"165",
						"185",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						0.61,
						0,
						12.12,
						18.18,
						21.21,
						24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2494
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 5.61,
					"enrolment": 109,
					"ligo": 0.6,
					"location": [
						151.676240802101,
						-30.523029872741
					],
					"name": "Newling Public School",
					"playspace": 246.07,
					"projections": [
						87,
						109,
						100,
						100,
						105,
						110
					],
					"projections_orig": [
						"87",
						"109",
						"100",
						"100",
						"105",
						"110"
					],
					"projections_percentage": [
						-20.18,
						0,
						-8.26,
						-8.26,
						-3.67,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4478
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 3.01,
					"enrolment": 229,
					"ligo": 0.41,
					"location": [
						151.655938376239,
						-30.4971243612964
					],
					"name": "Sandon Public School",
					"playspace": 94.5,
					"projections": [
						254,
						229,
						250,
						265,
						275,
						280
					],
					"projections_orig": [
						"254",
						"229",
						"250",
						"265",
						"275",
						"280"
					],
					"projections_percentage": [
						10.92,
						0,
						9.17,
						15.72,
						20.09,
						22.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5696
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 48
					},
					"classroomspace": 5.97,
					"enrolment": 571,
					"ligo": 0.73,
					"location": [
						151.653232461072,
						-30.5207110530726
					],
					"name": "Armidale High School",
					"playspace": 170.03,
					"projections": [
						707,
						572,
						875,
						955,
						975,
						950
					],
					"projections_orig": [
						"707",
						"572",
						"875",
						"955",
						"975",
						"950"
					],
					"projections_percentage": [
						23.6,
						0,
						52.97,
						66.96,
						70.45,
						66.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8102
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 38
					},
					"classroomspace": 4.54,
					"enrolment": 626,
					"ligo": 0.63,
					"location": [
						151.664471750333,
						-30.4935303339125
					],
					"name": "Duval High School",
					"playspace": 77.64,
					"projections": [
						628,
						626,
						720,
						785,
						805,
						785
					],
					"projections_orig": [
						"628",
						"626",
						"720",
						"785",
						"805",
						"785"
					],
					"projections_percentage": [
						0.32,
						0,
						15.02,
						25.4,
						28.59,
						25.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8492
				}
			],
			"uid": 30052
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 359
			},
			"enrolment": 4378,
			"level": "Combined",
			"ligo": 0.94,
			"name": "Barwon",
			"playspace": 507.7,
			"projections": [
				4378,
				4568,
				4363,
				4098,
				3888
			],
			"projections_percentage": [
				0,
				4.34,
				-0.34,
				-6.4,
				-11.19
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.68,
					"enrolment": 170,
					"ligo": 0.81,
					"location": [
						151.094958812105,
						-29.3209613294088
					],
					"name": "Ashford Central School",
					"playspace": 126.26,
					"projections": [
						175,
						170,
						195,
						195,
						180,
						170
					],
					"projections_orig": [
						"175",
						"170",
						"195",
						"195",
						"180",
						"170"
					],
					"projections_percentage": [
						2.94,
						0,
						14.71,
						14.71,
						5.88,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1066
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						149.795646497729,
						-29.9183546567076
					],
					"name": "Bellata Public School",
					"playspace": 681.68,
					"projections": [
						30,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.86,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1175
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 6.29,
					"enrolment": 184,
					"ligo": 0.85,
					"location": [
						150.56835448721,
						-29.866694069516
					],
					"name": "Bingara Central School",
					"playspace": 134.01,
					"projections": [
						211,
						184,
						195,
						195,
						195,
						195
					],
					"projections_orig": [
						"211",
						"184",
						"195",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						14.67,
						0,
						5.98,
						5.98,
						5.98,
						5.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1234
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 13.97,
					"enrolment": 68,
					"ligo": 0.98,
					"location": [
						150.361541592546,
						-28.6156983307735
					],
					"name": "Boggabilla Central School",
					"playspace": 2351.85,
					"projections": [
						176,
						68,
						90,
						80,
						80,
						70
					],
					"projections_orig": [
						"176",
						"68",
						"90",
						"80",
						"80",
						"70"
					],
					"projections_percentage": [
						158.82,
						0,
						32.35,
						17.65,
						17.65,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1275
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.21,
					"enrolment": 115,
					"ligo": 1,
					"location": [
						150.043563944914,
						-30.705945708419
					],
					"name": "Boggabri Public School",
					"playspace": 95.49,
					"projections": [
						103,
						115,
						120,
						120,
						115,
						115
					],
					"projections_orig": [
						"103",
						"115",
						"120",
						"120",
						"115",
						"115"
					],
					"projections_percentage": [
						-10.43,
						0,
						4.35,
						4.35,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1276
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 12.14,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						151.277638884771,
						-29.0462706803323
					],
					"name": "Bonshaw Public School",
					"playspace": 758.3,
					"projections": [
						17,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						41.67,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1296
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						149.577549044387,
						-28.7247616272878
					],
					"name": "Boomi Public School",
					"playspace": 413.64,
					"projections": [
						38,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1307
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 7.95,
					"enrolment": 99,
					"ligo": 0.63,
					"location": [
						151.076176369381,
						-30.1682575387672
					],
					"name": "Bundarra Central School",
					"playspace": 136.06,
					"projections": [
						139,
						99,
						140,
						135,
						130,
						130
					],
					"projections_orig": [
						"139",
						"99",
						"140",
						"135",
						"130",
						"130"
					],
					"projections_percentage": [
						40.4,
						0,
						41.41,
						36.36,
						31.31,
						31.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1415
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.01,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						150.83057877161,
						-29.6513696161863
					],
					"name": "Delungra Public School",
					"playspace": 501.68,
					"projections": [
						27,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1747
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.86,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						150.13154434218,
						-30.4931226889214
					],
					"name": "Fairfax Public School",
					"playspace": 375.04,
					"projections": [
						8,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-42.86,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1894
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.84,
					"enrolment": 19,
					"ligo": 1,
					"location": [
						149.634742538656,
						-29.076260633568
					],
					"name": "Garah Public School",
					"playspace": 966.83,
					"projections": [
						26,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						36.84,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1956
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.91,
					"enrolment": 62,
					"ligo": 1,
					"location": [
						151.11564679111,
						-29.8517752635533
					],
					"name": "Gilgai Public School",
					"playspace": 282.21,
					"projections": [
						60,
						62,
						55,
						55,
						65,
						60
					],
					"projections_orig": [
						"60",
						"62",
						"55",
						"55",
						"65",
						"60"
					],
					"projections_percentage": [
						-3.23,
						0,
						-11.29,
						-11.29,
						4.84,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1978
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.46,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						150.332842311156,
						-29.5850660328344
					],
					"name": "Gravesend Public School",
					"playspace": 467.17,
					"projections": [
						26,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-25.71,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2068
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.08,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						150.97922832102,
						-29.7793390711955
					],
					"name": "Gum Flat Public School",
					"playspace": 724.12,
					"projections": [
						30,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-14.29,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2100
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 17.97,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						148.974412540968,
						-30.6113219005351
					],
					"name": "Gwabegar Public School",
					"playspace": "NA",
					"projections": [
						8,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						14.29,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2115
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.81,
					"enrolment": 640,
					"ligo": 0.74,
					"location": [
						149.838821984483,
						-29.4655530152074
					],
					"name": "Moree Public School",
					"playspace": 46.07,
					"projections": [
						665,
						640,
						630,
						555,
						485,
						440
					],
					"projections_orig": [
						"665",
						"640",
						"630",
						"555",
						"485",
						"440"
					],
					"projections_percentage": [
						3.91,
						0,
						-1.56,
						-13.28,
						-24.22,
						-31.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2618
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 11.51,
					"enrolment": 71,
					"ligo": 0.93,
					"location": [
						148.991365669367,
						-28.9802180525237
					],
					"name": "Mungindi Central School",
					"playspace": 194.67,
					"projections": [
						118,
						71,
						80,
						75,
						70,
						60
					],
					"projections_orig": [
						"118",
						"71",
						"80",
						"75",
						"70",
						"60"
					],
					"projections_percentage": [
						66.2,
						0,
						12.68,
						5.63,
						-1.41,
						-15.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2675
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.88,
					"enrolment": 402,
					"ligo": 0.83,
					"location": [
						149.784552266553,
						-30.3247650856087
					],
					"name": "Narrabri Public School",
					"playspace": 27.15,
					"projections": [
						393,
						402,
						415,
						370,
						355,
						340
					],
					"projections_orig": [
						"393",
						"402",
						"415",
						"370",
						"355",
						"340"
					],
					"projections_percentage": [
						-2.24,
						0,
						3.23,
						-7.96,
						-11.69,
						-15.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2708
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.75,
					"enrolment": 347,
					"ligo": 0.53,
					"location": [
						149.762748294863,
						-30.3445578571505
					],
					"name": "Narrabri West Public School",
					"playspace": 76.89,
					"projections": [
						259,
						347,
						340,
						305,
						295,
						280
					],
					"projections_orig": [
						"259",
						"347",
						"340",
						"305",
						"295",
						"280"
					],
					"projections_percentage": [
						-25.36,
						0,
						-2.02,
						-12.1,
						-14.99,
						-19.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2709
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.27,
					"enrolment": 40,
					"ligo": 1,
					"location": [
						150.39238367236,
						-28.9265647988465
					],
					"name": "North Star Public School",
					"playspace": 258.44,
					"projections": [
						36,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2765
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 11.52,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						150.140248337199,
						-29.4736214062777
					],
					"name": "Pallamallawa Public School",
					"playspace": 1078.69,
					"projections": [
						33,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						57.14,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2827
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.26,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						148.888809524535,
						-30.3519732313293
					],
					"name": "Pilliga Public School",
					"playspace": 230.59,
					"projections": [
						8,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-50,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2870
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 7.61,
					"enrolment": 62,
					"ligo": 1,
					"location": [
						151.213614104623,
						-29.9581593512434
					],
					"name": "Tingha Public School",
					"playspace": 364.02,
					"projections": [
						97,
						62,
						70,
						70,
						65,
						60
					],
					"projections_orig": [
						"97",
						"62",
						"70",
						"70",
						"65",
						"60"
					],
					"projections_percentage": [
						56.45,
						0,
						12.9,
						12.9,
						4.84,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3218
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 8.04,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						150.479630606928,
						-28.6704238579368
					],
					"name": "Toomelah Public School",
					"playspace": 232.18,
					"projections": [
						59,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"59",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						59.46,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3239
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.86,
					"enrolment": 174,
					"ligo": 1,
					"location": [
						150.574443589046,
						-29.5410228729679
					],
					"name": "Warialda Public School",
					"playspace": 95.05,
					"projections": [
						167,
						174,
						165,
						170,
						170,
						170
					],
					"projections_orig": [
						"167",
						"174",
						"165",
						"170",
						"170",
						"170"
					],
					"projections_percentage": [
						-4.02,
						0,
						-5.17,
						-2.3,
						-2.3,
						-2.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3382
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 7.15,
					"enrolment": 132,
					"ligo": 1,
					"location": [
						149.443096208867,
						-30.2239315698184
					],
					"name": "Wee Waa Public School",
					"playspace": 82.37,
					"projections": [
						151,
						132,
						140,
						140,
						135,
						135
					],
					"projections_orig": [
						"151",
						"132",
						"140",
						"140",
						"135",
						"135"
					],
					"projections_percentage": [
						14.39,
						0,
						6.06,
						6.06,
						2.27,
						2.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3416
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.79,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						150.776549013241,
						-28.9019454859166
					],
					"name": "Yetman Public School",
					"playspace": 366.67,
					"projections": [
						29,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						26.09,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3559
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 17.32,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						150.3084652997,
						-29.1250691386656
					],
					"name": "Croppa Creek Public School",
					"playspace": 2171.72,
					"projections": [
						19,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						58.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3717
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 7.75,
					"enrolment": 118,
					"ligo": 0.76,
					"location": [
						149.840638832374,
						-29.4763032562964
					],
					"name": "Moree East Public School",
					"playspace": 554.24,
					"projections": [
						118,
						118,
						125,
						115,
						105,
						95
					],
					"projections_orig": [
						"118",
						"118",
						"125",
						"115",
						"105",
						"95"
					],
					"projections_percentage": [
						0,
						0,
						5.93,
						-2.54,
						-11.02,
						-19.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4118
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.61,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						150.10204243857,
						-28.8686273161017
					],
					"name": "Tulloona Public School",
					"playspace": 744.67,
					"projections": [
						4,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"4",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-63.64,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4225
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 6.65,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						149.229016233393,
						-29.470469350583
					],
					"name": "Bullarah Public School",
					"playspace": 1121.7,
					"projections": [
						8,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-11.11,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4228
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 9.18,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.439769723311,
						-29.6455608510889
					],
					"name": "Mallawa Public School",
					"playspace": 1618.09,
					"projections": [
						14,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4262
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 34
					},
					"classroomspace": 4.38,
					"enrolment": 526,
					"ligo": 0.94,
					"location": [
						149.781069586869,
						-30.3346617972592
					],
					"name": "Narrabri High School",
					"playspace": 70.6,
					"projections": [
						608,
						526,
						595,
						585,
						530,
						490
					],
					"projections_orig": [
						"608",
						"526",
						"595",
						"585",
						"530",
						"490"
					],
					"projections_percentage": [
						15.59,
						0,
						13.12,
						11.22,
						0.76,
						-6.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8170
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 6.56,
					"enrolment": 180,
					"ligo": 0.96,
					"location": [
						149.456368213716,
						-30.2191430399067
					],
					"name": "Wee Waa High School",
					"playspace": 364.13,
					"projections": [
						179,
						180,
						170,
						170,
						165,
						160
					],
					"projections_orig": [
						"179",
						"180",
						"170",
						"170",
						"165",
						"160"
					],
					"projections_percentage": [
						-0.56,
						0,
						-5.56,
						-5.56,
						-8.33,
						-11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8270
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 7.95,
					"enrolment": 240,
					"ligo": 0.96,
					"location": [
						149.842043428647,
						-29.4655672757332
					],
					"name": "Moree Secondary College Albert St Campus",
					"playspace": 124.58,
					"projections": [
						225,
						240,
						230,
						225,
						190,
						175
					],
					"projections_orig": [
						"225",
						"240",
						"230",
						"225",
						"190",
						"175"
					],
					"projections_percentage": [
						-6.25,
						0,
						-4.17,
						-6.25,
						-20.83,
						-27.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8325
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 9.38,
					"enrolment": 216,
					"ligo": 0.91,
					"location": [
						149.839689003719,
						-29.481234137249
					],
					"name": "Moree Secondary College Carol Ave Campus",
					"playspace": 213.6,
					"projections": [
						304,
						216,
						230,
						220,
						185,
						165
					],
					"projections_orig": [
						"304",
						"216",
						"230",
						"220",
						"185",
						"165"
					],
					"projections_percentage": [
						40.74,
						0,
						6.48,
						1.85,
						-14.35,
						-23.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8471
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 7.36,
					"enrolment": 184,
					"ligo": 0.77,
					"location": [
						150.574133599952,
						-29.5481324786475
					],
					"name": "Warialda High School",
					"playspace": 226.66,
					"projections": [
						196,
						184,
						195,
						195,
						195,
						190
					],
					"projections_orig": [
						"196",
						"184",
						"195",
						"195",
						"195",
						"190"
					],
					"projections_percentage": [
						6.52,
						0,
						5.98,
						5.98,
						5.98,
						3.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8519
				}
			],
			"uid": 30053
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 55
			},
			"enrolment": 986,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Glen Innes",
			"playspace": 369.61,
			"projections": [
				986,
				1003,
				978,
				938,
				888
			],
			"projections_percentage": [
				0,
				1.72,
				-0.81,
				-4.87,
				-9.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.1,
					"enrolment": 377,
					"ligo": 0.97,
					"location": [
						151.738852122545,
						-29.7348499112961
					],
					"name": "Glen Innes Public School",
					"playspace": 162.21,
					"projections": [
						435,
						377,
						395,
						370,
						355,
						340
					],
					"projections_orig": [
						"435",
						"377",
						"395",
						"370",
						"355",
						"340"
					],
					"projections_percentage": [
						15.38,
						0,
						4.77,
						-1.86,
						-5.84,
						-9.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2005
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.88,
					"enrolment": 51,
					"ligo": 1,
					"location": [
						151.896420500494,
						-29.7761449680703
					],
					"name": "Red Range Public School",
					"playspace": 361.89,
					"projections": [
						21,
						51,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"51",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-58.82,
						0,
						-50.98,
						-50.98,
						-50.98,
						-50.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2948
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 10.36,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						152.110759861208,
						-29.6917800062728
					],
					"name": "Wytaliba Public School",
					"playspace": 1000.85,
					"projections": [
						6,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"6",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-45.45,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4556
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.45,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						151.724231079582,
						-29.7388675771351
					],
					"name": "Glen Innes West Infants School",
					"playspace": 270.01,
					"projections": [
						42,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"42",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						2.44,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5116
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 4.53,
					"enrolment": 506,
					"ligo": 0.94,
					"location": [
						151.741759236674,
						-29.7437290512253
					],
					"name": "Glen Innes High School",
					"playspace": 53.11,
					"projections": [
						552,
						506,
						505,
						505,
						480,
						445
					],
					"projections_orig": [
						"552",
						"506",
						"505",
						"505",
						"480",
						"445"
					],
					"projections_percentage": [
						9.09,
						0,
						-0.2,
						-0.2,
						-5.14,
						-12.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8114
				}
			],
			"uid": 30054
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 97
			},
			"enrolment": 1277,
			"level": "Combined",
			"ligo": 0.9,
			"name": "Gunnedah",
			"playspace": 707.65,
			"projections": [
				1277,
				1421,
				1421,
				1331,
				1286
			],
			"projections_percentage": [
				0,
				11.28,
				11.28,
				4.23,
				0.7
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.17,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						150.446949775058,
						-30.9855336755368
					],
					"name": "Carroll Public School",
					"playspace": 273.05,
					"projections": [
						13,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-38.1,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1520
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 7.94,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						150.264383626456,
						-31.1169190059109
					],
					"name": "Curlewis Public School",
					"playspace": 442.26,
					"projections": [
						36,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-12.2,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1712
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 6.1,
					"enrolment": 156,
					"ligo": 0.6,
					"location": [
						150.256358866749,
						-30.977103932429
					],
					"name": "Gunnedah Public School",
					"playspace": 57.64,
					"projections": [
						134,
						156,
						135,
						135,
						135,
						130
					],
					"projections_orig": [
						"134",
						"156",
						"135",
						"135",
						"135",
						"130"
					],
					"projections_percentage": [
						-14.1,
						0,
						-13.46,
						-13.46,
						-13.46,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.15,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						149.906939175661,
						-31.098829422842
					],
					"name": "Mullaley Public School",
					"playspace": 363.79,
					"projections": [
						26,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-36.59,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2660
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 35.6,
					"enrolment": 3,
					"ligo": 1,
					"location": [
						149.828471820183,
						-31.3489245740626
					],
					"name": "Tambar Springs Public School",
					"playspace": 3430.61,
					"projections": [
						10,
						3,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"3",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						233.33,
						0,
						733.33,
						733.33,
						733.33,
						733.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3156
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 20
					},
					"classroomspace": 2.64,
					"enrolment": 628,
					"ligo": 0.73,
					"location": [
						150.251328389812,
						-30.9917330258561
					],
					"name": "Gunnedah South Public School",
					"playspace": 35.64,
					"projections": [
						511,
						628,
						690,
						665,
						615,
						605
					],
					"projections_orig": [
						"511",
						"628",
						"690",
						"665",
						"615",
						"605"
					],
					"projections_percentage": [
						-18.63,
						0,
						9.87,
						5.89,
						-2.07,
						-3.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4018
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 7.95,
					"enrolment": 387,
					"ligo": 0.96,
					"location": [
						150.249872114695,
						-30.9829375764588
					],
					"name": "Gunnedah High School",
					"playspace": 350.59,
					"projections": [
						566,
						387,
						490,
						515,
						475,
						445
					],
					"projections_orig": [
						"566",
						"387",
						"490",
						"515",
						"475",
						"445"
					],
					"projections_percentage": [
						46.25,
						0,
						26.61,
						33.07,
						22.74,
						14.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8188
				}
			],
			"uid": 30055
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 125
			},
			"enrolment": 2212,
			"level": "Combined",
			"ligo": 0.65,
			"name": "Inverell",
			"playspace": 60.1,
			"projections": [
				2212,
				2215,
				2180,
				2065,
				1975
			],
			"projections_percentage": [
				0,
				0.14,
				-1.45,
				-6.65,
				-10.71
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.7,
					"enrolment": 488,
					"ligo": 0.57,
					"location": [
						151.122170875016,
						-29.7736762681945
					],
					"name": "Inverell Public School",
					"playspace": 27.45,
					"projections": [
						404,
						488,
						450,
						430,
						410,
						400
					],
					"projections_orig": [
						"404",
						"488",
						"450",
						"430",
						"410",
						"400"
					],
					"projections_percentage": [
						-17.21,
						0,
						-7.79,
						-11.89,
						-15.98,
						-18.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2209
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 35
					},
					"classroomspace": 2.95,
					"enrolment": 649,
					"ligo": 0.84,
					"location": [
						151.102233303771,
						-29.7702752002161
					],
					"name": "Ross Hill Public School",
					"playspace": 32.09,
					"projections": [
						696,
						649,
						695,
						685,
						645,
						640
					],
					"projections_orig": [
						"696",
						"649",
						"695",
						"685",
						"645",
						"640"
					],
					"projections_percentage": [
						7.24,
						0,
						7.09,
						5.55,
						-0.62,
						-1.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2997
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 29
					},
					"classroomspace": 4.68,
					"enrolment": 582,
					"ligo": 0.76,
					"location": [
						151.109901187757,
						-29.7660095726559
					],
					"name": "Inverell High School",
					"playspace": 24.75,
					"projections": [
						634,
						582,
						600,
						600,
						575,
						530
					],
					"projections_orig": [
						"634",
						"582",
						"600",
						"600",
						"575",
						"530"
					],
					"projections_percentage": [
						8.93,
						0,
						3.09,
						3.09,
						-1.2,
						-8.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8122
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 5.39,
					"enrolment": 493,
					"ligo": 0.44,
					"location": [
						151.131242915909,
						-29.7674996547944
					],
					"name": "Macintyre High School",
					"playspace": 156.1,
					"projections": [
						469,
						493,
						470,
						465,
						435,
						405
					],
					"projections_orig": [
						"469",
						"493",
						"470",
						"465",
						"435",
						"405"
					],
					"projections_percentage": [
						-4.87,
						0,
						-4.67,
						-5.68,
						-11.76,
						-17.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8490
				}
			],
			"uid": 30056
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 35
			},
			"enrolment": 412,
			"level": "Combined",
			"ligo": 1,
			"name": "Northern Tablelands",
			"playspace": 450.36,
			"projections": [
				412,
				434,
				449,
				459,
				464
			],
			"projections_percentage": [
				0,
				5.34,
				8.98,
				11.41,
				12.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.26,
					"enrolment": 40,
					"ligo": 1,
					"location": [
						151.784060717176,
						-30.2301712752181
					],
					"name": "Bald Blair Public School",
					"playspace": 291.61,
					"projections": [
						27,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-32.5,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1098
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 17.81,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						151.661579899497,
						-30.0169807756324
					],
					"name": "Ben Lomond Public School",
					"playspace": 684.91,
					"projections": [
						12,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						100,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1196
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.98,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						151.657993517424,
						-30.3089537670592
					],
					"name": "Black Mountain Public School",
					"playspace": 232.18,
					"projections": [
						31,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						19.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1249
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7,
					"enrolment": 19,
					"ligo": 1,
					"location": [
						152.053182018164,
						-30.5182851400672
					],
					"name": "Chandler Public School",
					"playspace": "NA",
					"projections": [
						7,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-63.16,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1547
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 15.3,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						152.349318871881,
						-30.4030532957888
					],
					"name": "Ebor Public School",
					"playspace": 888.97,
					"projections": [
						4,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"4",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-50,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1814
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 5.13,
					"enrolment": 313,
					"ligo": 0.97,
					"location": [
						151.675962851726,
						-30.2224657824918
					],
					"name": "Guyra Central School",
					"playspace": 154.12,
					"projections": [
						325,
						313,
						335,
						350,
						360,
						365
					],
					"projections_orig": [
						"325",
						"313",
						"335",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						3.83,
						0,
						7.03,
						11.82,
						15.02,
						16.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2114
				}
			],
			"uid": 30057
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 89
			},
			"enrolment": 968,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Peel",
			"playspace": 389.19,
			"projections": [
				968,
				1056,
				1066,
				1031,
				1016
			],
			"projections_percentage": [
				0,
				9.09,
				10.12,
				6.51,
				4.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 7.43,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						150.846536450395,
						-30.9300536837366
					],
					"name": "Attunga Public School",
					"playspace": 250.38,
					"projections": [
						28,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.15,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1071
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 10.35,
					"enrolment": 185,
					"ligo": 0.91,
					"location": [
						150.600928587019,
						-30.3823600801974
					],
					"name": "Barraba Central School",
					"playspace": 457.19,
					"projections": [
						181,
						185,
						210,
						210,
						205,
						200
					],
					"projections_orig": [
						"181",
						"185",
						"210",
						"210",
						"205",
						"200"
					],
					"projections_percentage": [
						-2.16,
						0,
						13.51,
						13.51,
						10.81,
						8.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1140
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.12,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						151.150884343953,
						-30.8861404951828
					],
					"name": "Bendemeer Public School",
					"playspace": 1198.85,
					"projections": [
						23,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						43.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.6,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						150.735555178402,
						-31.2632193806598
					],
					"name": "Currabubula Public School",
					"playspace": 355.72,
					"projections": [
						37,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						27.59,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1714
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.24,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						151.132326080477,
						-31.2205513635458
					],
					"name": "Dungowan Public School",
					"playspace": 373.72,
					"projections": [
						38,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						171.43,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1793
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.27,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						150.830550861038,
						-31.2206785039636
					],
					"name": "Duri Public School",
					"playspace": 505.31,
					"projections": [
						28,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.22,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1802
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.73,
					"enrolment": 188,
					"ligo": 1,
					"location": [
						151.054516570416,
						-31.0539570526528
					],
					"name": "Kootingal Public School",
					"playspace": 82.03,
					"projections": [
						199,
						188,
						190,
						190,
						185,
						180
					],
					"projections_orig": [
						"199",
						"188",
						"190",
						"190",
						"185",
						"180"
					],
					"projections_percentage": [
						5.85,
						0,
						1.06,
						1.06,
						-1.6,
						-4.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2327
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.9,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						151.075024185375,
						-31.0192505691181
					],
					"name": "Moonbi Public School",
					"playspace": 680.32,
					"projections": [
						53,
						52,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"53",
						"52",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						1.92,
						0,
						34.62,
						34.62,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2608
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.12,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						151.127969573364,
						-31.4602584168429
					],
					"name": "Nundle Public School",
					"playspace": 63.04,
					"projections": [
						61,
						55,
						70,
						70,
						65,
						65
					],
					"projections_orig": [
						"61",
						"55",
						"70",
						"70",
						"65",
						"65"
					],
					"projections_percentage": [
						10.91,
						0,
						27.27,
						27.27,
						18.18,
						18.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2781
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.23,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						150.640924241834,
						-30.9384731655004
					],
					"name": "Somerton Public School",
					"playspace": 397.01,
					"projections": [
						11,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-31.25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3079
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.04,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						151.148595592722,
						-31.3021372662287
					],
					"name": "Woolomin Public School",
					"playspace": 169.25,
					"projections": [
						37,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						15.62,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3506
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 5.84,
					"enrolment": 312,
					"ligo": 0.94,
					"location": [
						150.728071495625,
						-30.7497762746558
					],
					"name": "Manilla Central School",
					"playspace": 137.43,
					"projections": [
						357,
						312,
						340,
						350,
						330,
						325
					],
					"projections_orig": [
						"357",
						"312",
						"340",
						"350",
						"330",
						"325"
					],
					"projections_percentage": [
						14.42,
						0,
						8.97,
						12.18,
						5.77,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7305
				}
			],
			"uid": 30058
		},
		{
			"classrooms": {
				"demountable": 31,
				"permanent": 328
			},
			"enrolment": 6494,
			"level": "Combined",
			"ligo": 0.73,
			"name": "Tamworth",
			"playspace": 122.64,
			"projections": [
				6494,
				6880,
				6880,
				6720,
				6600
			],
			"projections_percentage": [
				0,
				5.94,
				5.94,
				3.48,
				1.63
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.43,
					"enrolment": 141,
					"ligo": 1,
					"location": [
						150.916561581343,
						-31.2035593273161
					],
					"name": "Timbumburi Public School",
					"playspace": 96.93,
					"projections": [
						127,
						141,
						140,
						140,
						135,
						135
					],
					"projections_orig": [
						"127",
						"141",
						"140",
						"140",
						"135",
						"135"
					],
					"projections_percentage": [
						-9.93,
						0,
						-0.71,
						-0.71,
						-4.26,
						-4.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1016
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.42,
					"enrolment": 211,
					"ligo": 0.63,
					"location": [
						151.003664443626,
						-31.1274740078931
					],
					"name": "Nemingha Public School",
					"playspace": 127.2,
					"projections": [
						200,
						211,
						210,
						210,
						210,
						205
					],
					"projections_orig": [
						"200",
						"211",
						"210",
						"210",
						"210",
						"205"
					],
					"projections_percentage": [
						-5.21,
						0,
						-0.47,
						-0.47,
						-0.47,
						-2.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2725
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 30
					},
					"classroomspace": 2.21,
					"enrolment": 910,
					"ligo": 0.66,
					"location": [
						150.935909397265,
						-31.0854227404346
					],
					"name": "Tamworth Public School",
					"playspace": 31.1,
					"projections": [
						748,
						910,
						920,
						915,
						885,
						870
					],
					"projections_orig": [
						"748",
						"910",
						"920",
						"915",
						"885",
						"870"
					],
					"projections_percentage": [
						-17.8,
						0,
						1.1,
						0.55,
						-2.75,
						-4.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3157
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.87,
					"enrolment": 377,
					"ligo": 0.31,
					"location": [
						150.920023641969,
						-31.0916463360794
					],
					"name": "Tamworth West Public School",
					"playspace": 31.71,
					"projections": [
						209,
						377,
						370,
						360,
						360,
						360
					],
					"projections_orig": [
						"209",
						"377",
						"370",
						"360",
						"360",
						"360"
					],
					"projections_percentage": [
						-44.56,
						0,
						-1.86,
						-4.51,
						-4.51,
						-4.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3158
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 2.78,
					"enrolment": 88,
					"ligo": 1,
					"location": [
						151.009349473319,
						-31.0847945925027
					],
					"name": "Tintinhull Public School",
					"playspace": 415.65,
					"projections": [
						42,
						88,
						80,
						80,
						80,
						80
					],
					"projections_orig": [
						"42",
						"88",
						"80",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-52.27,
						0,
						-9.09,
						-9.09,
						-9.09,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3221
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 15
					},
					"classroomspace": 2.71,
					"enrolment": 506,
					"ligo": 0.66,
					"location": [
						150.873190348568,
						-31.0936775769253
					],
					"name": "Westdale Public School",
					"playspace": 60.68,
					"projections": [
						453,
						506,
						540,
						535,
						510,
						510
					],
					"projections_orig": [
						"453",
						"506",
						"540",
						"535",
						"510",
						"510"
					],
					"projections_percentage": [
						-10.47,
						0,
						6.72,
						5.73,
						0.79,
						0.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3428
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.77,
					"enrolment": 337,
					"ligo": 0.85,
					"location": [
						150.896208083128,
						-31.0586222888925
					],
					"name": "Oxley Vale Public School",
					"playspace": 87.09,
					"projections": [
						324,
						337,
						330,
						335,
						335,
						330
					],
					"projections_orig": [
						"324",
						"337",
						"330",
						"335",
						"335",
						"330"
					],
					"projections_percentage": [
						-3.86,
						0,
						-2.08,
						-0.59,
						-0.59,
						-2.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3690
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.87,
					"enrolment": 673,
					"ligo": 0.53,
					"location": [
						150.913053260926,
						-31.1055467728664
					],
					"name": "Tamworth South Public School",
					"playspace": 80.7,
					"projections": [
						763,
						673,
						775,
						775,
						740,
						740
					],
					"projections_orig": [
						"763",
						"673",
						"775",
						"775",
						"740",
						"740"
					],
					"projections_percentage": [
						13.37,
						0,
						15.16,
						15.16,
						9.96,
						9.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3882
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.71,
					"enrolment": 311,
					"ligo": 0.74,
					"location": [
						150.900908691411,
						-31.1133140140391
					],
					"name": "Hillvue Public School",
					"playspace": 85.94,
					"projections": [
						260,
						311,
						290,
						290,
						290,
						290
					],
					"projections_orig": [
						"260",
						"311",
						"290",
						"290",
						"290",
						"290"
					],
					"projections_percentage": [
						-16.4,
						0,
						-6.75,
						-6.75,
						-6.75,
						-6.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4437
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 4.65,
					"enrolment": 616,
					"ligo": 1,
					"location": [
						150.978872171808,
						-31.1431101850885
					],
					"name": "Farrer Memorial Agricultural High School",
					"playspace": 376.96,
					"projections": [
						604,
						616,
						630,
						635,
						640,
						640
					],
					"projections_orig": [
						"604",
						"616",
						"630",
						"635",
						"640",
						"640"
					],
					"projections_percentage": [
						-1.95,
						0,
						2.27,
						3.08,
						3.9,
						3.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8111
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 5.34,
					"enrolment": 680,
					"ligo": 0.7,
					"location": [
						150.91566391094,
						-31.1055248709455
					],
					"name": "Tamworth High School",
					"playspace": 89.87,
					"projections": [
						737,
						680,
						780,
						785,
						765,
						735
					],
					"projections_orig": [
						"737",
						"680",
						"780",
						"785",
						"765",
						"735"
					],
					"projections_percentage": [
						8.38,
						0,
						14.71,
						15.44,
						12.5,
						8.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8139
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 47
					},
					"classroomspace": 3.56,
					"enrolment": 960,
					"ligo": 0.73,
					"location": [
						150.939916518273,
						-31.0796874802216
					],
					"name": "Oxley High School",
					"playspace": 33.03,
					"projections": [
						1028,
						960,
						1085,
						1090,
						1065,
						1020
					],
					"projections_orig": [
						"1028",
						"960",
						"1085",
						"1090",
						"1065",
						"1020"
					],
					"projections_percentage": [
						7.08,
						0,
						13.02,
						13.54,
						10.94,
						6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8455
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 36
					},
					"classroomspace": 3.87,
					"enrolment": 684,
					"ligo": 0.68,
					"location": [
						150.893807878993,
						-31.0984714301996
					],
					"name": "Peel High School",
					"playspace": 77.42,
					"projections": [
						516,
						684,
						730,
						730,
						705,
						685
					],
					"projections_orig": [
						"516",
						"684",
						"730",
						"730",
						"705",
						"685"
					],
					"projections_percentage": [
						-24.56,
						0,
						6.73,
						6.73,
						3.07,
						0.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8525
				}
			],
			"uid": 30059
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 57
			},
			"enrolment": 662,
			"level": "Combined",
			"ligo": 0.97,
			"name": "Tenterfield",
			"playspace": 447.8,
			"projections": [
				663,
				659,
				649,
				614,
				594
			],
			"projections_percentage": [
				0,
				-0.6,
				-2.11,
				-7.39,
				-10.41
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 12.31,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						151.848406525011,
						-29.4425920767542
					],
					"name": "Deepwater Public School",
					"playspace": 420.76,
					"projections": [
						30,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						114.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1742
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.69,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						152.374430616269,
						-28.9294671380342
					],
					"name": "Drake Public School",
					"playspace": 5.35,
					"projections": [
						28,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.15,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1771
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 7.27,
					"enrolment": 83,
					"ligo": 0.81,
					"location": [
						151.601810024367,
						-29.4472803581213
					],
					"name": "Emmaville Central School",
					"playspace": 284.38,
					"projections": [
						71,
						84,
						70,
						70,
						65,
						65
					],
					"projections_orig": [
						"71",
						"84",
						"70",
						"70",
						"65",
						"65"
					],
					"projections_percentage": [
						-15.48,
						0,
						-16.67,
						-16.67,
						-22.62,
						-22.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1838
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.75,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						151.933940826214,
						-28.9275302535882
					],
					"name": "Jennings Public School",
					"playspace": 1648.36,
					"projections": [
						18,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						63.64,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2223
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.39,
					"enrolment": 231,
					"ligo": 1,
					"location": [
						152.024708503587,
						-29.0562938302505
					],
					"name": "The Sir Henry Parkes Memorial Public School",
					"playspace": 165.8,
					"projections": [
						268,
						231,
						250,
						245,
						235,
						225
					],
					"projections_orig": [
						"268",
						"231",
						"250",
						"245",
						"235",
						"225"
					],
					"projections_percentage": [
						16.02,
						0,
						8.23,
						6.06,
						1.73,
						-2.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3182
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.87,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						151.54211163129,
						-29.004924454651
					],
					"name": "Mingoola Public School",
					"playspace": 554.3,
					"projections": [
						11,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4115
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 5.94,
					"enrolment": 279,
					"ligo": 0.96,
					"location": [
						152.018038913481,
						-29.0534368265812
					],
					"name": "Tenterfield High School",
					"playspace": 55.64,
					"projections": [
						240,
						279,
						270,
						265,
						245,
						235
					],
					"projections_orig": [
						"240",
						"279",
						"270",
						"265",
						"245",
						"235"
					],
					"projections_percentage": [
						-13.98,
						0,
						-3.23,
						-5.02,
						-12.19,
						-15.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8358
				}
			],
			"uid": 30060
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 35
			},
			"enrolment": 287,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Walcha",
			"playspace": 1401.28,
			"projections": [
				287,
				306,
				321,
				331,
				341
			],
			"projections_percentage": [
				0,
				6.62,
				11.85,
				15.33,
				18.82
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 10.86,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						151.409014634077,
						-31.2980556344433
					],
					"name": "Niangala Public School",
					"playspace": 627.64,
					"projections": [
						22,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						214.29,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2748
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 18.35,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						151.715752841473,
						-31.4829892090925
					],
					"name": "Nowendoc Public School",
					"playspace": 1688.92,
					"projections": [
						7,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						16.67,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2768
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 7.84,
					"enrolment": 251,
					"ligo": 0.94,
					"location": [
						151.604572059981,
						-30.9806421226294
					],
					"name": "Walcha Central School",
					"playspace": 227.55,
					"projections": [
						324,
						251,
						270,
						285,
						295,
						305
					],
					"projections_orig": [
						"324",
						"251",
						"270",
						"285",
						"295",
						"305"
					],
					"projections_percentage": [
						29.08,
						0,
						7.57,
						13.55,
						17.53,
						21.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3340
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.55,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						151.343498320157,
						-30.9694024070231
					],
					"name": "Woolbrook Public School",
					"playspace": 3410.59,
					"projections": [
						17,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						54.55,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3501
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.52,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						151.948018390997,
						-31.2511799364849
					],
					"name": "Yarrowitch Public School",
					"playspace": 1051.71,
					"projections": [
						13,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3547
				}
			],
			"uid": 30061
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 70
			},
			"enrolment": 997,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Wollemi",
			"playspace": 7190.48,
			"projections": [
				997,
				988,
				978,
				953,
				923
			],
			"projections_percentage": [
				0,
				-0.9,
				-1.91,
				-4.41,
				-7.42
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.22,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						150.238072643118,
						-31.6403017727576
					],
					"name": "Blackville Public School",
					"playspace": 2347.8,
					"projections": [
						11,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.38,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1252
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 15.22,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.901631681626,
						-31.453891581533
					],
					"name": "Premer Public School",
					"playspace": 2252.01,
					"projections": [
						21,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						162.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2900
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 8.67,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						150.253890259298,
						-31.3923983389639
					],
					"name": "Spring Ridge Public School",
					"playspace": 499.02,
					"projections": [
						33,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						22.22,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3091
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.79,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						150.419316809354,
						-31.3949409852953
					],
					"name": "Walhallow Public School",
					"playspace": 58761.36,
					"projections": [
						19,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						35.71,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3343
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 6.15,
					"enrolment": 31,
					"ligo": 1,
					"location": [
						150.828804274777,
						-31.5406715148223
					],
					"name": "Wallabadah Public School",
					"playspace": 231.88,
					"projections": [
						39,
						31,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"31",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25.81,
						0,
						-19.35,
						-19.35,
						-19.35,
						-19.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3345
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.12,
					"enrolment": 117,
					"ligo": 1,
					"location": [
						150.651269511279,
						-31.3488026446629
					],
					"name": "Werris Creek Public School",
					"playspace": 120.52,
					"projections": [
						105,
						117,
						110,
						110,
						105,
						105
					],
					"projections_orig": [
						"105",
						"117",
						"110",
						"110",
						"105",
						"105"
					],
					"projections_percentage": [
						-10.26,
						0,
						-5.98,
						-5.98,
						-10.26,
						-10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3425
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.3,
					"enrolment": 50,
					"ligo": 1,
					"location": [
						150.727970410289,
						-31.6568696648503
					],
					"name": "Willow Tree Public School",
					"playspace": 341.79,
					"projections": [
						56,
						50,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"56",
						"50",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						12,
						0,
						-50,
						-50,
						-50,
						-50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3451
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.72,
					"enrolment": 286,
					"ligo": 1,
					"location": [
						150.678432128028,
						-31.4981863238253
					],
					"name": "Quirindi Public School",
					"playspace": 125.19,
					"projections": [
						376,
						286,
						305,
						290,
						285,
						280
					],
					"projections_orig": [
						"376",
						"286",
						"305",
						"290",
						"285",
						"280"
					],
					"projections_percentage": [
						31.47,
						0,
						6.64,
						1.4,
						-0.35,
						-2.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3947
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 4.79,
					"enrolment": 451,
					"ligo": 0.95,
					"location": [
						150.67945623797,
						-31.501197257676
					],
					"name": "Quirindi High School",
					"playspace": 34.75,
					"projections": [
						418,
						451,
						430,
						435,
						420,
						395
					],
					"projections_orig": [
						"418",
						"451",
						"430",
						"435",
						"420",
						"395"
					],
					"projections_percentage": [
						-7.32,
						0,
						-4.66,
						-3.55,
						-6.87,
						-12.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8174
				}
			],
			"uid": 30062
		},
		{
			"classrooms": {
				"demountable": 69,
				"permanent": 344
			},
			"enrolment": 7101,
			"level": "Combined",
			"ligo": 0.87,
			"name": "Ballina-Byron",
			"playspace": 147.41,
			"projections": [
				7101,
				8182,
				8192,
				7917,
				7607
			],
			"projections_percentage": [
				0,
				15.22,
				15.36,
				11.49,
				7.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 13
					},
					"classroomspace": 2.65,
					"enrolment": 536,
					"ligo": 0.72,
					"location": [
						153.437723303544,
						-28.8396262563992
					],
					"name": "Alstonville Public School",
					"playspace": 27.22,
					"projections": [
						549,
						536,
						625,
						610,
						570,
						565
					],
					"projections_orig": [
						"549",
						"536",
						"625",
						"610",
						"570",
						"565"
					],
					"projections_percentage": [
						2.43,
						0,
						16.6,
						13.81,
						6.34,
						5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1030
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 5.27,
					"enrolment": 247,
					"ligo": 0.93,
					"location": [
						153.564165104344,
						-28.8694214925114
					],
					"name": "Ballina Public School",
					"playspace": 63.65,
					"projections": [
						276,
						247,
						300,
						285,
						285,
						280
					],
					"projections_orig": [
						"276",
						"247",
						"300",
						"285",
						"285",
						"280"
					],
					"projections_percentage": [
						11.74,
						0,
						21.46,
						15.38,
						15.38,
						13.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1112
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 8
					},
					"classroomspace": 2.65,
					"enrolment": 298,
					"ligo": 0.88,
					"location": [
						153.526183161249,
						-28.6852123409437
					],
					"name": "Bangalow Public School",
					"playspace": 23.56,
					"projections": [
						207,
						298,
						340,
						320,
						305,
						300
					],
					"projections_orig": [
						"207",
						"298",
						"340",
						"320",
						"305",
						"300"
					],
					"projections_percentage": [
						-30.54,
						0,
						14.09,
						7.38,
						2.35,
						0.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1118
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 0
					},
					"classroomspace": 3.55,
					"enrolment": 107,
					"ligo": 1,
					"location": [
						153.345883553902,
						-28.7665269348735
					],
					"name": "Bexhill Public School",
					"playspace": 86.12,
					"projections": [
						105,
						107,
						115,
						120,
						115,
						115
					],
					"projections_orig": [
						"105",
						"107",
						"115",
						"120",
						"115",
						"115"
					],
					"projections_percentage": [
						-1.87,
						0,
						7.48,
						12.15,
						7.48,
						7.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1217
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 2.55,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						153.437010034268,
						-29.0027204161133
					],
					"name": "Broadwater Public School",
					"playspace": 129.67,
					"projections": [
						37,
						52,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"52",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-28.85,
						0,
						-51.92,
						-51.92,
						-51.92,
						-51.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1361
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 20
					},
					"classroomspace": 2.58,
					"enrolment": 662,
					"ligo": 0.84,
					"location": [
						153.614444133224,
						-28.6478717645783
					],
					"name": "Byron Bay Public School",
					"playspace": 20.65,
					"projections": [
						635,
						662,
						785,
						765,
						735,
						700
					],
					"projections_orig": [
						"635",
						"662",
						"785",
						"765",
						"735",
						"700"
					],
					"projections_percentage": [
						-4.08,
						0,
						18.58,
						15.56,
						11.03,
						5.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1470
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 12.51,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						153.4579257346,
						-28.9836129421355
					],
					"name": "Cabbage Tree Island Public School",
					"playspace": 363.76,
					"projections": [
						17,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1471
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.12,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						153.505079149082,
						-28.9148276315703
					],
					"name": "Empire Vale Public School",
					"playspace": 392.43,
					"projections": [
						44,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						22.22,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1840
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 33
					},
					"classroomspace": 4.93,
					"enrolment": 497,
					"ligo": 0.66,
					"location": [
						153.426309533424,
						-29.1137245707767
					],
					"name": "Evans River Community School",
					"playspace": 67.26,
					"projections": [
						482,
						497,
						545,
						555,
						540,
						520
					],
					"projections_orig": [
						"482",
						"497",
						"545",
						"555",
						"540",
						"520"
					],
					"projections_percentage": [
						-3.02,
						0,
						9.66,
						11.67,
						8.65,
						4.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1886
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.7,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						153.498792919802,
						-28.7679743090759
					],
					"name": "Fernleigh Public School",
					"playspace": 259.78,
					"projections": [
						21,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-19.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.9,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						153.532887784508,
						-28.7175088701649
					],
					"name": "Newrybar Public School",
					"playspace": 639.71,
					"projections": [
						30,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.11,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2741
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.31,
					"enrolment": 68,
					"ligo": 1,
					"location": [
						153.407551614115,
						-28.8710619345838
					],
					"name": "Rous Public School",
					"playspace": 209.58,
					"projections": [
						69,
						68,
						75,
						75,
						75,
						70
					],
					"projections_orig": [
						"69",
						"68",
						"75",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						1.47,
						0,
						10.29,
						10.29,
						10.29,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3006
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.43,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						153.468515186502,
						-28.9506428623861
					],
					"name": "Wardell Public School",
					"playspace": 174.38,
					"projections": [
						41,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"41",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.82,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3378
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.67,
					"enrolment": 296,
					"ligo": 0.66,
					"location": [
						153.419249026946,
						-28.826281797127
					],
					"name": "Wollongbar Public School",
					"playspace": 69.41,
					"projections": [
						222,
						296,
						310,
						285,
						285,
						280
					],
					"projections_orig": [
						"222",
						"296",
						"310",
						"285",
						"285",
						"280"
					],
					"projections_percentage": [
						-25,
						0,
						4.73,
						-3.72,
						-3.72,
						-5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3475
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.38,
					"enrolment": 131,
					"ligo": 1,
					"location": [
						153.33981071851,
						-29.0751158898731
					],
					"name": "Woodburn Public School",
					"playspace": 125.23,
					"projections": [
						108,
						131,
						115,
						115,
						115,
						115
					],
					"projections_orig": [
						"108",
						"131",
						"115",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						-17.56,
						0,
						-12.21,
						-12.21,
						-12.21,
						-12.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3490
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 8
					},
					"classroomspace": 2.79,
					"enrolment": 368,
					"ligo": 0.92,
					"location": [
						153.590310209206,
						-28.7932697711901
					],
					"name": "Lennox Head Public School",
					"playspace": 50.25,
					"projections": [
						343,
						368,
						410,
						390,
						375,
						370
					],
					"projections_orig": [
						"343",
						"368",
						"410",
						"390",
						"375",
						"370"
					],
					"projections_percentage": [
						-6.79,
						0,
						11.41,
						5.98,
						1.9,
						0.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4184
				},
				{
					"classrooms": {
						"demountable": 26,
						"permanent": 64
					},
					"classroomspace": 3.73,
					"enrolment": 1587,
					"ligo": 0.62,
					"location": [
						153.587775486168,
						-28.850809074175
					],
					"name": "Southern Cross School",
					"playspace": 39.61,
					"projections": [
						1386,
						1587,
						1810,
						1835,
						1760,
						1685
					],
					"projections_orig": [
						"1386",
						"1587",
						"1810",
						"1835",
						"1760",
						"1685"
					],
					"projections_percentage": [
						-12.67,
						0,
						14.05,
						15.63,
						10.9,
						6.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4428
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.63,
					"enrolment": 168,
					"ligo": 1,
					"location": [
						153.500066325811,
						-28.7955949842741
					],
					"name": "Teven-Tintenbar Public School",
					"playspace": 142.17,
					"projections": [
						139,
						168,
						165,
						165,
						160,
						160
					],
					"projections_orig": [
						"139",
						"168",
						"165",
						"165",
						"160",
						"160"
					],
					"projections_percentage": [
						-17.26,
						0,
						-1.79,
						-1.79,
						-4.76,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4578
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 10.24,
					"enrolment": 330,
					"ligo": 0.8,
					"location": [
						153.563978381192,
						-28.8664015229221
					],
					"name": "Ballina High School",
					"playspace": 137.84,
					"projections": [
						503,
						330,
						485,
						500,
						485,
						445
					],
					"projections_orig": [
						"503",
						"330",
						"485",
						"500",
						"485",
						"445"
					],
					"projections_percentage": [
						52.42,
						0,
						46.97,
						51.52,
						46.97,
						34.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8195
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 36
					},
					"classroomspace": 3.27,
					"enrolment": 852,
					"ligo": 0.71,
					"location": [
						153.614828994309,
						-28.6679259645412
					],
					"name": "Byron Bay High School",
					"playspace": 43.67,
					"projections": [
						826,
						852,
						955,
						1000,
						970,
						920
					],
					"projections_orig": [
						"826",
						"852",
						"955",
						"1000",
						"970",
						"920"
					],
					"projections_percentage": [
						-3.05,
						0,
						12.09,
						17.37,
						13.85,
						7.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8577
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 42
					},
					"classroomspace": 3.49,
					"enrolment": 752,
					"ligo": 0.62,
					"location": [
						153.433868873435,
						-28.841142391789
					],
					"name": "Alstonville High School",
					"playspace": 29.63,
					"projections": [
						887,
						752,
						945,
						970,
						940,
						880
					],
					"projections_orig": [
						"887",
						"752",
						"945",
						"970",
						"940",
						"880"
					],
					"projections_percentage": [
						17.95,
						0,
						25.66,
						28.99,
						25,
						17.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8578
				}
			],
			"uid": 30063
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 97
			},
			"enrolment": 1562,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Bellingen",
			"playspace": 342.62,
			"projections": [
				1562,
				1615,
				1605,
				1525,
				1460
			],
			"projections_percentage": [
				0,
				3.39,
				2.75,
				-2.37,
				-6.53
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.81,
					"enrolment": 372,
					"ligo": 1,
					"location": [
						152.892920069978,
						-30.4532501684389
					],
					"name": "Bellingen Public School",
					"playspace": 79.77,
					"projections": [
						319,
						372,
						420,
						385,
						355,
						340
					],
					"projections_orig": [
						"319",
						"372",
						"420",
						"385",
						"355",
						"340"
					],
					"projections_percentage": [
						-14.25,
						0,
						12.9,
						3.49,
						-4.57,
						-8.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1181
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.82,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						152.542261665027,
						-30.1892281440144
					],
					"name": "Dundurrabin Public School",
					"playspace": "NA",
					"projections": [
						27,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						28.57,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1788
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 10.66,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						152.422232462915,
						-30.2945687385232
					],
					"name": "Hernani Public School",
					"playspace": 1631.92,
					"projections": [
						14,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						180,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2156
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.02,
					"enrolment": 32,
					"ligo": 0.76,
					"location": [
						153.012647660171,
						-30.4496226974575
					],
					"name": "Raleigh Public School",
					"playspace": 266.5,
					"projections": [
						34,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"34",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.25,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2931
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.48,
					"enrolment": 68,
					"ligo": 1,
					"location": [
						153.028836526363,
						-30.4459948844715
					],
					"name": "Repton Public School",
					"playspace": 104.4,
					"projections": [
						65,
						68,
						65,
						65,
						60,
						60
					],
					"projections_orig": [
						"65",
						"68",
						"65",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						-4.41,
						0,
						-4.41,
						-4.41,
						-11.76,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2955
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.55,
					"enrolment": 201,
					"ligo": 0.76,
					"location": [
						153.019924519059,
						-30.4949253505655
					],
					"name": "Urunga Public School",
					"playspace": 41.18,
					"projections": [
						226,
						201,
						185,
						180,
						170,
						165
					],
					"projections_orig": [
						"226",
						"201",
						"185",
						"180",
						"170",
						"165"
					],
					"projections_percentage": [
						12.44,
						0,
						-7.96,
						-10.45,
						-15.42,
						-17.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3318
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.97,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						152.691639760038,
						-30.4320472552653
					],
					"name": "Orama Public School",
					"playspace": 237.39,
					"projections": [
						36,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4534
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 7.12,
					"enrolment": 95,
					"ligo": 1,
					"location": [
						152.710449727111,
						-30.3436811835301
					],
					"name": "Dorrigo Public School",
					"playspace": 270.87,
					"projections": [
						137,
						95,
						125,
						130,
						135,
						140
					],
					"projections_orig": [
						"137",
						"95",
						"125",
						"130",
						"135",
						"140"
					],
					"projections_percentage": [
						44.21,
						0,
						31.58,
						36.84,
						42.11,
						47.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7316
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 3.38,
					"enrolment": 578,
					"ligo": 0.87,
					"location": [
						152.905994898211,
						-30.4548758637841
					],
					"name": "Bellingen High School",
					"playspace": 82.07,
					"projections": [
						609,
						578,
						570,
						585,
						535,
						480
					],
					"projections_orig": [
						"609",
						"578",
						"570",
						"585",
						"535",
						"480"
					],
					"projections_percentage": [
						5.36,
						0,
						-1.38,
						1.21,
						-7.44,
						-16.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8258
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.76,
					"enrolment": 163,
					"ligo": 0.93,
					"location": [
						152.70613621372,
						-30.3382108116675
					],
					"name": "Dorrigo High School",
					"playspace": 369.51,
					"projections": [
						187,
						163,
						165,
						175,
						185,
						190
					],
					"projections_orig": [
						"187",
						"163",
						"165",
						"175",
						"185",
						"190"
					],
					"projections_percentage": [
						14.72,
						0,
						1.23,
						7.36,
						13.5,
						16.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8453
				}
			],
			"uid": 30064
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 86
			},
			"enrolment": 1512,
			"level": "Combined",
			"ligo": 0.94,
			"name": "Clarence Valley East",
			"playspace": 157.8,
			"projections": [
				1512,
				1804,
				1839,
				1774,
				1689
			],
			"projections_percentage": [
				0,
				19.31,
				21.63,
				17.33,
				11.71
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.13,
					"enrolment": 59,
					"ligo": 1,
					"location": [
						153.231486233439,
						-29.3875695343611
					],
					"name": "Chatsworth Island Public School",
					"playspace": 95.29,
					"projections": [
						89,
						59,
						70,
						70,
						65,
						65
					],
					"projections_orig": [
						"89",
						"59",
						"70",
						"70",
						"65",
						"65"
					],
					"projections_percentage": [
						50.85,
						0,
						18.64,
						18.64,
						10.17,
						10.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1553
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.32,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						153.078141336062,
						-29.5695976519419
					],
					"name": "Cowper Public School",
					"playspace": 128.61,
					"projections": [
						31,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-18.42,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1670
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 4
					},
					"classroomspace": 2.62,
					"enrolment": 201,
					"ligo": 0.78,
					"location": [
						153.234104471332,
						-29.4888161475803
					],
					"name": "Gulmarrad Public School",
					"playspace": 69.9,
					"projections": [
						194,
						201,
						185,
						185,
						180,
						175
					],
					"projections_orig": [
						"194",
						"201",
						"185",
						"185",
						"180",
						"175"
					],
					"projections_percentage": [
						-3.48,
						0,
						-7.96,
						-7.96,
						-10.45,
						-12.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2099
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.88,
					"enrolment": 63,
					"ligo": 1,
					"location": [
						153.239724545327,
						-29.4258282119201
					],
					"name": "Harwood Island Public School",
					"playspace": 213.17,
					"projections": [
						60,
						63,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"60",
						"63",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						-4.76,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2142
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.36,
					"enrolment": 69,
					"ligo": 1,
					"location": [
						153.099941480016,
						-29.4909301061852
					],
					"name": "Lawrence Public School",
					"playspace": 154.52,
					"projections": [
						82,
						69,
						80,
						80,
						75,
						75
					],
					"projections_orig": [
						"82",
						"69",
						"80",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						18.84,
						0,
						15.94,
						15.94,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2379
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.23,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						153.10743183757,
						-29.6672483374038
					],
					"name": "Tucabia Public School",
					"playspace": 445.04,
					"projections": [
						54,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"54",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						50,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3263
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 5.04,
					"enrolment": 166,
					"ligo": 0.75,
					"location": [
						153.200603972719,
						-29.4568686503147
					],
					"name": "Maclean Public School",
					"playspace": 89.11,
					"projections": [
						186,
						166,
						195,
						195,
						190,
						185
					],
					"projections_orig": [
						"186",
						"166",
						"195",
						"195",
						"190",
						"185"
					],
					"projections_percentage": [
						12.05,
						0,
						17.47,
						17.47,
						14.46,
						11.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3946
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.97,
					"enrolment": 880,
					"ligo": 0.96,
					"location": [
						153.199786633042,
						-29.465678161083
					],
					"name": "Maclean High School",
					"playspace": 66.76,
					"projections": [
						1108,
						880,
						1125,
						1160,
						1115,
						1040
					],
					"projections_orig": [
						"1108",
						"880",
						"1125",
						"1160",
						"1115",
						"1040"
					],
					"projections_percentage": [
						25.91,
						0,
						27.84,
						31.82,
						26.7,
						18.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8362
				}
			],
			"uid": 30065
		},
		{
			"classrooms": {
				"demountable": 31,
				"permanent": 395
			},
			"enrolment": 6070,
			"level": "Combined",
			"ligo": 0.69,
			"name": "Coffs Harbour",
			"playspace": 93.39,
			"projections": [
				6069,
				6780,
				6885,
				6600,
				6400
			],
			"projections_percentage": [
				0,
				11.72,
				13.45,
				8.75,
				5.45
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 8
					},
					"classroomspace": 2.76,
					"enrolment": 442,
					"ligo": 0.59,
					"location": [
						153.076889974113,
						-30.3347628831225
					],
					"name": "Boambee Public School",
					"playspace": 38.83,
					"projections": [
						315,
						442,
						475,
						465,
						440,
						405
					],
					"projections_orig": [
						"315",
						"442",
						"475",
						"465",
						"440",
						"405"
					],
					"projections_percentage": [
						-28.73,
						0,
						7.47,
						5.2,
						-0.45,
						-8.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1266
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.91,
					"enrolment": 406,
					"ligo": 0.59,
					"location": [
						153.121242489069,
						-30.3024216861211
					],
					"name": "Coffs Harbour Public School",
					"playspace": 73.99,
					"projections": [
						324,
						406,
						465,
						475,
						460,
						470
					],
					"projections_orig": [
						"324",
						"406",
						"465",
						"475",
						"460",
						"470"
					],
					"projections_percentage": [
						-20.2,
						0,
						14.53,
						17,
						13.3,
						15.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1584
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 18
					},
					"classroomspace": 2.36,
					"enrolment": 676,
					"ligo": 0.77,
					"location": [
						153.131291266221,
						-30.2540670238547
					],
					"name": "Kororo Public School",
					"playspace": 12.57,
					"projections": [
						544,
						676,
						695,
						705,
						675,
						685
					],
					"projections_orig": [
						"544",
						"676",
						"695",
						"705",
						"675",
						"685"
					],
					"projections_percentage": [
						-19.53,
						0,
						2.81,
						4.29,
						-0.15,
						1.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2330
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.57,
					"enrolment": 356,
					"ligo": 0.62,
					"location": [
						153.097442731499,
						-30.3638397471458
					],
					"name": "Sawtell Public School",
					"playspace": 23.5,
					"projections": [
						256,
						356,
						385,
						375,
						330,
						320
					],
					"projections_orig": [
						"256",
						"356",
						"385",
						"375",
						"330",
						"320"
					],
					"projections_percentage": [
						-28.09,
						0,
						8.15,
						5.34,
						-7.3,
						-10.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3042
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 2.57,
					"enrolment": 623,
					"ligo": 0.62,
					"location": [
						153.103340556724,
						-30.2925947375822
					],
					"name": "Narranga Public School",
					"playspace": 49.59,
					"projections": [
						603,
						623,
						740,
						755,
						730,
						740
					],
					"projections_orig": [
						"603",
						"623",
						"740",
						"755",
						"730",
						"740"
					],
					"projections_percentage": [
						-3.21,
						0,
						18.78,
						21.19,
						17.17,
						18.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4404
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.91,
					"enrolment": 312,
					"ligo": 0.67,
					"location": [
						153.111616592213,
						-30.2838923881987
					],
					"name": "Tyalla Public School",
					"playspace": 94.38,
					"projections": [
						380,
						312,
						365,
						375,
						365,
						375
					],
					"projections_orig": [
						"380",
						"312",
						"365",
						"375",
						"365",
						"375"
					],
					"projections_percentage": [
						21.79,
						0,
						16.99,
						20.19,
						16.99,
						20.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4503
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.57,
					"enrolment": 272,
					"ligo": 0.5,
					"location": [
						153.08225117065,
						-30.353350677837
					],
					"name": "Toormina Public School",
					"playspace": 39.82,
					"projections": [
						301,
						272,
						320,
						310,
						275,
						265
					],
					"projections_orig": [
						"301",
						"272",
						"320",
						"310",
						"275",
						"265"
					],
					"projections_percentage": [
						10.66,
						0,
						17.65,
						13.97,
						1.1,
						-2.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4506
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.92,
					"enrolment": 210,
					"ligo": 0.62,
					"location": [
						153.078953502328,
						-30.3630542952789
					],
					"name": "William Bayldon Public School",
					"playspace": 152.22,
					"projections": [
						201,
						210,
						220,
						200,
						190,
						185
					],
					"projections_orig": [
						"201",
						"210",
						"220",
						"200",
						"190",
						"185"
					],
					"projections_percentage": [
						-4.29,
						0,
						4.76,
						-4.76,
						-9.52,
						-11.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4602
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 3.24,
					"enrolment": 947,
					"ligo": 0.77,
					"location": [
						153.136267596833,
						-30.3049988117123
					],
					"name": "Coffs Harbour High School",
					"playspace": 6.56,
					"projections": [
						905,
						947,
						1010,
						1065,
						1050,
						1005
					],
					"projections_orig": [
						"905",
						"947",
						"1010",
						"1065",
						"1050",
						"1005"
					],
					"projections_percentage": [
						-4.44,
						0,
						6.65,
						12.46,
						10.88,
						6.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 112
					},
					"classroomspace": 12.76,
					"enrolment": 503,
					"ligo": 1,
					"location": [
						153.102391358028,
						-30.330026920245
					],
					"name": "Coffs Harbour Senior College",
					"playspace": 493.13,
					"projections": [
						498,
						503,
						560,
						560,
						530,
						490
					],
					"projections_orig": [
						"498",
						"503",
						"560",
						"560",
						"530",
						"490"
					],
					"projections_percentage": [
						-0.99,
						0,
						11.33,
						11.33,
						5.37,
						-2.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8272
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 53
					},
					"classroomspace": 6.52,
					"enrolment": 595,
					"ligo": 0.73,
					"location": [
						153.111811070385,
						-30.2828694664838
					],
					"name": "Orara High School",
					"playspace": 76.46,
					"projections": [
						683,
						594,
						720,
						770,
						770,
						745
					],
					"projections_orig": [
						"683",
						"594",
						"720",
						"770",
						"770",
						"745"
					],
					"projections_percentage": [
						14.98,
						0,
						21.21,
						29.63,
						29.63,
						25.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8469
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 44
					},
					"classroomspace": 4.19,
					"enrolment": 728,
					"ligo": 0.84,
					"location": [
						153.085299200771,
						-30.3509533917512
					],
					"name": "Toormina High School",
					"playspace": 59.61,
					"projections": [
						810,
						728,
						825,
						830,
						785,
						715
					],
					"projections_orig": [
						"810",
						"728",
						"825",
						"830",
						"785",
						"715"
					],
					"projections_percentage": [
						11.26,
						0,
						13.32,
						14.01,
						7.83,
						-1.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8527
				}
			],
			"uid": 30066
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 177
			},
			"enrolment": 3520,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Grafton",
			"playspace": 107.12,
			"projections": [
				3519,
				4090,
				4095,
				3880,
				3670
			],
			"projections_percentage": [
				0,
				16.23,
				16.37,
				10.26,
				4.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 5.42,
					"enrolment": 84,
					"ligo": 1,
					"location": [
						152.890192427205,
						-29.8320185920293
					],
					"name": "Coutts Crossing Public School",
					"playspace": 235.79,
					"projections": [
						58,
						84,
						80,
						80,
						80,
						80
					],
					"projections_orig": [
						"58",
						"84",
						"80",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-30.95,
						0,
						-4.76,
						-4.76,
						-4.76,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1666
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 2.66,
					"enrolment": 679,
					"ligo": 0.64,
					"location": [
						152.934004811389,
						-29.6858719811393
					],
					"name": "Grafton Public School",
					"playspace": 52.05,
					"projections": [
						668,
						679,
						755,
						735,
						695,
						665
					],
					"projections_orig": [
						"668",
						"679",
						"755",
						"735",
						"695",
						"665"
					],
					"projections_percentage": [
						-1.62,
						0,
						11.19,
						8.25,
						2.36,
						-2.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2060
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 2.75,
					"enrolment": 596,
					"ligo": 0.9,
					"location": [
						152.937832810497,
						-29.7098491251606
					],
					"name": "South Grafton Public School",
					"playspace": 34.48,
					"projections": [
						594,
						596,
						660,
						645,
						595,
						575
					],
					"projections_orig": [
						"594",
						"596",
						"660",
						"645",
						"595",
						"575"
					],
					"projections_percentage": [
						-0.34,
						0,
						10.74,
						8.22,
						-0.17,
						-3.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2061
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 5.43,
					"enrolment": 134,
					"ligo": 1,
					"location": [
						152.932429683562,
						-29.7246565049542
					],
					"name": "Gillwinga Public School",
					"playspace": 266.07,
					"projections": [
						147,
						134,
						130,
						130,
						125,
						125
					],
					"projections_orig": [
						"147",
						"134",
						"130",
						"130",
						"125",
						"125"
					],
					"projections_percentage": [
						9.7,
						0,
						-2.99,
						-2.99,
						-6.72,
						-6.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4421
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 12
					},
					"classroomspace": 2.71,
					"enrolment": 513,
					"ligo": 0.71,
					"location": [
						152.929654171074,
						-29.6700026937435
					],
					"name": "Westlawn Public School",
					"playspace": 36.74,
					"projections": [
						472,
						513,
						575,
						560,
						515,
						500
					],
					"projections_orig": [
						"472",
						"513",
						"575",
						"560",
						"515",
						"500"
					],
					"projections_percentage": [
						-7.99,
						0,
						12.09,
						9.16,
						0.39,
						-2.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5238
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 49
					},
					"classroomspace": 3.24,
					"enrolment": 946,
					"ligo": 0.69,
					"location": [
						152.933000951539,
						-29.6832030643159
					],
					"name": "Grafton High School",
					"playspace": 30.15,
					"projections": [
						929,
						945,
						1055,
						1085,
						1045,
						965
					],
					"projections_orig": [
						"929",
						"945",
						"1055",
						"1085",
						"1045",
						"965"
					],
					"projections_percentage": [
						-1.69,
						0,
						11.64,
						14.81,
						10.58,
						2.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8117
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 5.21,
					"enrolment": 568,
					"ligo": 0.85,
					"location": [
						152.931025145768,
						-29.7163694551154
					],
					"name": "South Grafton High School",
					"playspace": 94.59,
					"projections": [
						1002,
						568,
						835,
						860,
						825,
						760
					],
					"projections_orig": [
						"1002",
						"568",
						"835",
						"860",
						"825",
						"760"
					],
					"projections_percentage": [
						76.41,
						0,
						47.01,
						51.41,
						45.25,
						33.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8406
				}
			],
			"uid": 30068
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 52
			},
			"enrolment": 1196,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Greater Taree",
			"playspace": 413.17,
			"projections": [
				1196,
				1230,
				1185,
				1120,
				1088
			],
			"projections_percentage": [
				0,
				2.84,
				-0.92,
				-6.35,
				-9.03
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.52,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						152.282799269665,
						-31.71198700389
					],
					"name": "Bobin Public School",
					"playspace": 1046.12,
					"projections": [
						9,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"9",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-47.06,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1269
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.46,
					"enrolment": 49,
					"ligo": 1,
					"location": [
						152.609699249824,
						-31.8273162082654
					],
					"name": "Coopernook Public School",
					"playspace": 690.02,
					"projections": [
						38,
						49,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"49",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.45,
						0,
						-48.98,
						-48.98,
						-48.98,
						-48.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1632
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.42,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						152.292074454291,
						-31.618954870861
					],
					"name": "Elands Public School",
					"playspace": 177.31,
					"projections": [
						14,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						16.67,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1824
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.44,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						152.594280055087,
						-31.7126468505732
					],
					"name": "Hannam Vale Public School",
					"playspace": 353.11,
					"projections": [
						21,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-4.55,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2131
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.73,
					"enrolment": 109,
					"ligo": 1,
					"location": [
						152.688471048984,
						-31.8706997789901
					],
					"name": "Harrington Public School",
					"playspace": 52.82,
					"projections": [
						107,
						109,
						105,
						100,
						95,
						90
					],
					"projections_orig": [
						"107",
						"109",
						"105",
						"100",
						"95",
						"90"
					],
					"projections_percentage": [
						-1.83,
						0,
						-3.67,
						-8.26,
						-12.84,
						-17.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2139
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.41,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						152.696243391551,
						-31.7326745680164
					],
					"name": "Johns River Public School",
					"playspace": 579.89,
					"projections": [
						35,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"35",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						169.23,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2243
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.17,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						152.271302764864,
						-32.0464422370226
					],
					"name": "Krambach Public School",
					"playspace": 231.98,
					"projections": [
						28,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-26.32,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2333
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.26,
					"enrolment": 48,
					"ligo": 1,
					"location": [
						152.532993851949,
						-31.7842476419691
					],
					"name": "Lansdowne Public School",
					"playspace": 144.88,
					"projections": [
						73,
						48,
						55,
						55,
						50,
						25
					],
					"projections_orig": [
						"73",
						"48",
						"55",
						"55",
						"50",
						"<50"
					],
					"projections_percentage": [
						52.08,
						0,
						14.58,
						14.58,
						4.17,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2370
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 1.93,
					"enrolment": 31,
					"ligo": 1,
					"location": [
						152.467860701715,
						-31.7058410577095
					],
					"name": "Upper Lansdowne Public School",
					"playspace": 279.98,
					"projections": [
						20,
						31,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"31",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-35.48,
						0,
						-19.35,
						-19.35,
						-19.35,
						-19.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2372
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.94,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						152.612945225429,
						-31.8969931508518
					],
					"name": "Mitchells Island Public School",
					"playspace": 943.92,
					"projections": [
						44,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						69.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2580
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.3,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						152.651697622763,
						-31.7695690527296
					],
					"name": "Moorland Public School",
					"playspace": 122.03,
					"projections": [
						48,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"48",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						17.07,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2616
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.19,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						152.179341147085,
						-31.8819709402143
					],
					"name": "Mount George Public School",
					"playspace": 448.19,
					"projections": [
						31,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						3.33,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2637
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 14
					},
					"classroomspace": 2.68,
					"enrolment": 511,
					"ligo": 1,
					"location": [
						152.589579587965,
						-31.9720106848188
					],
					"name": "Old Bar Public School",
					"playspace": 23.13,
					"projections": [
						361,
						511,
						525,
						505,
						455,
						440
					],
					"projections_orig": [
						"361",
						"511",
						"525",
						"505",
						"455",
						"440"
					],
					"projections_percentage": [
						-29.35,
						0,
						2.74,
						-1.17,
						-10.96,
						-13.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2799
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 16.71,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						152.567564263184,
						-31.912642721882
					],
					"name": "Oxley Island Public School",
					"playspace": 1006.38,
					"projections": [
						46,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"46",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						666.67,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2823
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 6
					},
					"classroomspace": 2.87,
					"enrolment": 243,
					"ligo": 0.89,
					"location": [
						152.535866140821,
						-32.0415227808827
					],
					"name": "Hallidays Point Public School",
					"playspace": 97.85,
					"projections": [
						215,
						243,
						260,
						240,
						235,
						225
					],
					"projections_orig": [
						"215",
						"243",
						"260",
						"240",
						"235",
						"225"
					],
					"projections_percentage": [
						-11.52,
						0,
						7,
						-1.23,
						-3.29,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4611
				}
			],
			"uid": 30069
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 81
			},
			"enrolment": 2250,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Hastings",
			"playspace": 270.36,
			"projections": [
				2250,
				2430,
				2420,
				2330,
				2230
			],
			"projections_percentage": [
				0,
				8,
				7.56,
				3.56,
				-0.89
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 2.74,
					"enrolment": 140,
					"ligo": 1,
					"location": [
						152.680253217495,
						-31.4363505554266
					],
					"name": "Beechwood Public School",
					"playspace": 118.19,
					"projections": [
						141,
						140,
						140,
						140,
						140,
						140
					],
					"projections_orig": [
						"141",
						"140",
						"140",
						"140",
						"140",
						"140"
					],
					"projections_percentage": [
						0.71,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1165
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.41,
					"enrolment": 28,
					"ligo": 1,
					"location": [
						152.472347389542,
						-31.6056742086577
					],
					"name": "Comboyne Public School",
					"playspace": 675.05,
					"projections": [
						26,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-7.14,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1601
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.33,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						152.730643725237,
						-31.5808497012296
					],
					"name": "Herons Creek Public School",
					"playspace": 87.61,
					"projections": [
						40,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"40",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						5.26,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2157
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.49,
					"enrolment": 57,
					"ligo": 1,
					"location": [
						152.66061840272,
						-31.4780038848408
					],
					"name": "Huntingdon Public School",
					"playspace": 585.72,
					"projections": [
						47,
						57,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"47",
						"57",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						-17.54,
						0,
						-3.51,
						-3.51,
						-3.51,
						-3.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2190
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.18,
					"enrolment": 204,
					"ligo": 1,
					"location": [
						152.70039540974,
						-31.627516838426
					],
					"name": "Kendall Public School",
					"playspace": 311.57,
					"projections": [
						202,
						204,
						200,
						200,
						195,
						190
					],
					"projections_orig": [
						"202",
						"204",
						"200",
						"200",
						"195",
						"190"
					],
					"projections_percentage": [
						-0.98,
						0,
						-1.96,
						-1.96,
						-4.41,
						-6.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2280
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.58,
					"enrolment": 203,
					"ligo": 0.86,
					"location": [
						152.796914895151,
						-31.65180480839
					],
					"name": "Laurieton Public School",
					"playspace": 28.49,
					"projections": [
						214,
						203,
						205,
						205,
						200,
						195
					],
					"projections_orig": [
						"214",
						"203",
						"205",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						5.42,
						0,
						0.99,
						0.99,
						-1.48,
						-3.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2377
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.36,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						152.486961582381,
						-31.4376395994676
					],
					"name": "Long Flat Public School",
					"playspace": 375.46,
					"projections": [
						31,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-29.55,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2423
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.88,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						152.631409750208,
						-31.2388690384102
					],
					"name": "Rollands Plains Upper Public School",
					"playspace": 512.76,
					"projections": [
						28,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						12,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2985
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.63,
					"enrolment": 105,
					"ligo": 1,
					"location": [
						152.794237294311,
						-31.333898447091
					],
					"name": "Telegraph Point Public School",
					"playspace": 152.53,
					"projections": [
						97,
						105,
						100,
						100,
						95,
						95
					],
					"projections_orig": [
						"97",
						"105",
						"100",
						"100",
						"95",
						"95"
					],
					"projections_percentage": [
						-7.62,
						0,
						-4.76,
						-4.76,
						-9.52,
						-9.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3176
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 2.89,
					"enrolment": 264,
					"ligo": 0.49,
					"location": [
						152.821437413353,
						-31.6348529553698
					],
					"name": "North Haven Public School",
					"playspace": 77.45,
					"projections": [
						370,
						264,
						370,
						350,
						330,
						320
					],
					"projections_orig": [
						"370",
						"264",
						"370",
						"350",
						"330",
						"320"
					],
					"projections_percentage": [
						40.15,
						0,
						40.15,
						32.58,
						25,
						21.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4149
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 35
					},
					"classroomspace": 2.41,
					"enrolment": 1142,
					"ligo": 0.89,
					"location": [
						152.735653091268,
						-31.6394864403356
					],
					"name": "Camden Haven High School",
					"playspace": 49.12,
					"projections": [
						1093,
						1142,
						1225,
						1235,
						1180,
						1100
					],
					"projections_orig": [
						"1093",
						"1142",
						"1225",
						"1235",
						"1180",
						"1100"
					],
					"projections_percentage": [
						-4.29,
						0,
						7.27,
						8.14,
						3.33,
						-3.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8280
				}
			],
			"uid": 30070
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 143
			},
			"enrolment": 2211,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Kempsey",
			"playspace": 81.53,
			"projections": [
				2211,
				2491,
				2526,
				2431,
				2326
			],
			"projections_percentage": [
				0,
				12.66,
				14.25,
				9.95,
				5.2
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.62,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						152.802543122589,
						-31.0594556878004
					],
					"name": "Green Hill Public School",
					"playspace": 153.97,
					"projections": [
						45,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"45",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						73.08,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2071
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.35,
					"enrolment": 222,
					"ligo": 0.6,
					"location": [
						152.846670916257,
						-31.0833187163617
					],
					"name": "Kempsey East Public School",
					"playspace": 39.64,
					"projections": [
						248,
						222,
						225,
						230,
						225,
						220
					],
					"projections_orig": [
						"248",
						"222",
						"225",
						"230",
						"225",
						"220"
					],
					"projections_percentage": [
						11.71,
						0,
						1.35,
						3.6,
						1.35,
						-0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2278
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.17,
					"enrolment": 350,
					"ligo": 0.82,
					"location": [
						152.829529621091,
						-31.0777881430211
					],
					"name": "Kempsey West Public School",
					"playspace": 56.53,
					"projections": [
						341,
						350,
						410,
						400,
						365,
						350
					],
					"projections_orig": [
						"341",
						"350",
						"410",
						"400",
						"365",
						"350"
					],
					"projections_percentage": [
						-2.57,
						0,
						17.14,
						14.29,
						4.29,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2279
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 4.76,
					"enrolment": 143,
					"ligo": 0.85,
					"location": [
						152.828842755435,
						-31.0947181116452
					],
					"name": "Kempsey South Public School",
					"playspace": 154.54,
					"projections": [
						130,
						143,
						125,
						125,
						125,
						125
					],
					"projections_orig": [
						"130",
						"143",
						"125",
						"125",
						"125",
						"125"
					],
					"projections_percentage": [
						-9.09,
						0,
						-12.59,
						-12.59,
						-12.59,
						-12.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4196
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 2.28,
					"enrolment": 321,
					"ligo": 1,
					"location": [
						152.787356378056,
						-31.0545970395402
					],
					"name": "Aldavilla Public School",
					"playspace": 70.02,
					"projections": [
						253,
						321,
						320,
						300,
						290,
						280
					],
					"projections_orig": [
						"253",
						"321",
						"320",
						"300",
						"290",
						"280"
					],
					"projections_percentage": [
						-21.18,
						0,
						-0.31,
						-6.54,
						-9.66,
						-12.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4601
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 5.44,
					"enrolment": 469,
					"ligo": 0.86,
					"location": [
						152.825243238773,
						-31.0688867586906
					],
					"name": "Kempsey High School",
					"playspace": 59.39,
					"projections": [
						518,
						469,
						505,
						530,
						505,
						485
					],
					"projections_orig": [
						"518",
						"469",
						"505",
						"530",
						"505",
						"485"
					],
					"projections_percentage": [
						10.45,
						0,
						7.68,
						13.01,
						7.68,
						3.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8123
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 44
					},
					"classroomspace": 4.72,
					"enrolment": 680,
					"ligo": 0.68,
					"location": [
						152.824499958701,
						-31.0904247775374
					],
					"name": "Melville High School",
					"playspace": 36.62,
					"projections": [
						940,
						680,
						880,
						915,
						895,
						840
					],
					"projections_orig": [
						"940",
						"680",
						"880",
						"915",
						"895",
						"840"
					],
					"projections_percentage": [
						38.24,
						0,
						29.41,
						34.56,
						31.62,
						23.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8566
				}
			],
			"uid": 30071
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 107
			},
			"enrolment": 1271,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Kyogle",
			"playspace": 480.02,
			"projections": [
				1271,
				1448,
				1448,
				1383,
				1343
			],
			"projections_percentage": [
				0,
				13.93,
				13.93,
				8.81,
				5.66
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.44,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						153.149057271369,
						-28.5508858926735
					],
					"name": "Barkers Vale Public School",
					"playspace": 663.76,
					"projections": [
						66,
						55,
						60,
						60,
						60,
						60
					],
					"projections_orig": [
						"66",
						"55",
						"60",
						"60",
						"60",
						"60"
					],
					"projections_percentage": [
						20,
						0,
						9.09,
						9.09,
						9.09,
						9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 8.39,
					"enrolment": 126,
					"ligo": 0.97,
					"location": [
						152.623980666612,
						-28.7357637755539
					],
					"name": "Bonalbo Central School",
					"playspace": 168.91,
					"projections": [
						185,
						126,
						145,
						145,
						145,
						145
					],
					"projections_orig": [
						"185",
						"126",
						"145",
						"145",
						"145",
						"145"
					],
					"projections_percentage": [
						46.83,
						0,
						15.08,
						15.08,
						15.08,
						15.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1290
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.26,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						153.022570154089,
						-28.4889278887629
					],
					"name": "Collins Creek Public School",
					"playspace": 489.58,
					"projections": [
						15,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.14,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1593
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.08,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						152.875543128889,
						-28.7246700919684
					],
					"name": "Doubtful Creek Public School",
					"playspace": 414.15,
					"projections": [
						9,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"9",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-43.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1769
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.99,
					"enrolment": 295,
					"ligo": 1,
					"location": [
						153.003984298776,
						-28.624873328604
					],
					"name": "Kyogle Public School",
					"playspace": 47.82,
					"projections": [
						294,
						295,
						380,
						360,
						335,
						330
					],
					"projections_orig": [
						"294",
						"295",
						"380",
						"360",
						"335",
						"330"
					],
					"projections_percentage": [
						-0.34,
						0,
						28.81,
						22.03,
						13.56,
						11.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2349
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.03,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						152.801003586722,
						-28.8480496865866
					],
					"name": "Mummulgum Public School",
					"playspace": 681.59,
					"projections": [
						20,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-20,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2671
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.07,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						152.597089395027,
						-28.6541324569092
					],
					"name": "Old Bonalbo Public School",
					"playspace": 458.55,
					"projections": [
						19,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.52,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2800
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.4,
					"enrolment": 31,
					"ligo": 1,
					"location": [
						152.933260091923,
						-28.4764027908947
					],
					"name": "The Risk Public School",
					"playspace": 422.03,
					"projections": [
						29,
						31,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"31",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.45,
						0,
						-19.35,
						-19.35,
						-19.35,
						-19.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2968
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.48,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						152.893956812912,
						-28.4683529968059
					],
					"name": "Rukenvale Public School",
					"playspace": 1238.81,
					"projections": [
						23,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						155.56,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3013
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.51,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						152.936909457291,
						-28.7556528946666
					],
					"name": "Stratheden Public School",
					"playspace": 271.44,
					"projections": [
						33,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						43.48,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3122
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.88,
					"enrolment": 49,
					"ligo": 1,
					"location": [
						152.568113259663,
						-28.8884806117029
					],
					"name": "Tabulam Public School",
					"playspace": 276.38,
					"projections": [
						58,
						49,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"58",
						"49",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						18.37,
						0,
						22.45,
						22.45,
						12.24,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3145
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 13.22,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						152.546726033472,
						-28.4738846537081
					],
					"name": "Urbenville Public School",
					"playspace": 1742.99,
					"projections": [
						23,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						64.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3316
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.28,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						152.964445352043,
						-28.5114277169669
					],
					"name": "Wiangaree Public School",
					"playspace": 560.48,
					"projections": [
						15,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-44.44,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3439
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 5.98,
					"enrolment": 178,
					"ligo": 0.81,
					"location": [
						152.609674779457,
						-28.3892421597539
					],
					"name": "Woodenbong Central School",
					"playspace": 158.16,
					"projections": [
						214,
						178,
						190,
						190,
						180,
						180
					],
					"projections_orig": [
						"214",
						"178",
						"190",
						"190",
						"180",
						"180"
					],
					"projections_percentage": [
						20.22,
						0,
						6.74,
						6.74,
						1.12,
						1.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3491
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 4.22,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						152.817616204166,
						-28.5820707960685
					],
					"name": "Afterlee Public School",
					"playspace": 31.44,
					"projections": [
						13,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.78,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3640
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 4.34,
					"enrolment": 370,
					"ligo": 0.86,
					"location": [
						153.000320047723,
						-28.6261077254842
					],
					"name": "Kyogle High School",
					"playspace": 54.17,
					"projections": [
						421,
						370,
						415,
						435,
						410,
						375
					],
					"projections_orig": [
						"421",
						"370",
						"415",
						"435",
						"410",
						"375"
					],
					"projections_percentage": [
						13.78,
						0,
						12.16,
						17.57,
						10.81,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8189
				}
			],
			"uid": 30072
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 242
			},
			"enrolment": 3537,
			"level": "Combined",
			"ligo": 0.68,
			"name": "Lismore",
			"playspace": 104.48,
			"projections": [
				3537,
				3879,
				4004,
				3944,
				3824
			],
			"projections_percentage": [
				0,
				9.67,
				13.2,
				11.51,
				8.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.82,
					"enrolment": 78,
					"ligo": 0.6,
					"location": [
						153.231133187365,
						-28.8305102163095
					],
					"name": "Caniaba Public School",
					"playspace": 159.24,
					"projections": [
						59,
						78,
						80,
						80,
						80,
						75
					],
					"projections_orig": [
						"59",
						"78",
						"80",
						"80",
						"80",
						"75"
					],
					"projections_percentage": [
						-24.36,
						0,
						2.56,
						2.56,
						2.56,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1492
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 5.2,
					"enrolment": 87,
					"ligo": 1,
					"location": [
						153.282396278641,
						-28.9922994363894
					],
					"name": "Coraki Public School",
					"playspace": 62.99,
					"projections": [
						113,
						87,
						100,
						100,
						100,
						100
					],
					"projections_orig": [
						"113",
						"87",
						"100",
						"100",
						"100",
						"100"
					],
					"projections_percentage": [
						29.89,
						0,
						14.94,
						14.94,
						14.94,
						14.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1644
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.72,
					"enrolment": 338,
					"ligo": 0.53,
					"location": [
						153.291596717412,
						-28.8139811952973
					],
					"name": "Lismore Public School",
					"playspace": 51.07,
					"projections": [
						332,
						338,
						390,
						395,
						385,
						385
					],
					"projections_orig": [
						"332",
						"338",
						"390",
						"395",
						"385",
						"385"
					],
					"projections_percentage": [
						-1.78,
						0,
						15.38,
						16.86,
						13.91,
						13.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1780
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.98,
					"enrolment": 255,
					"ligo": 0.79,
					"location": [
						153.323163372489,
						-28.8189768069588
					],
					"name": "Goonellabah Public School",
					"playspace": 72.49,
					"projections": [
						207,
						255,
						270,
						275,
						275,
						275
					],
					"projections_orig": [
						"207",
						"255",
						"270",
						"275",
						"275",
						"275"
					],
					"projections_percentage": [
						-18.82,
						0,
						5.88,
						7.84,
						7.84,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2041
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.81,
					"enrolment": 240,
					"ligo": 0.63,
					"location": [
						153.261545516621,
						-28.8092921856462
					],
					"name": "Lismore South Public School",
					"playspace": 64.85,
					"projections": [
						240,
						240,
						230,
						235,
						235,
						235
					],
					"projections_orig": [
						"240",
						"240",
						"230",
						"235",
						"235",
						"235"
					],
					"projections_percentage": [
						0,
						0,
						-4.17,
						-2.08,
						-2.08,
						-2.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2409
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.66,
					"enrolment": 24,
					"ligo": 1,
					"location": [
						153.305760105175,
						-28.8908851909161
					],
					"name": "Wyrallah Public School",
					"playspace": 272.76,
					"projections": [
						19,
						24,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"24",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-20.83,
						0,
						4.17,
						4.17,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3529
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 18
					},
					"classroomspace": 2.4,
					"enrolment": 529,
					"ligo": 0.43,
					"location": [
						153.293093318021,
						-28.8300379640585
					],
					"name": "Wyrallah Road Public School",
					"playspace": 64.95,
					"projections": [
						491,
						529,
						560,
						560,
						535,
						530
					],
					"projections_orig": [
						"491",
						"529",
						"560",
						"560",
						"535",
						"530"
					],
					"projections_percentage": [
						-7.18,
						0,
						5.86,
						5.86,
						1.13,
						0.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3856
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.93,
					"enrolment": 223,
					"ligo": 0.56,
					"location": [
						153.301145941911,
						-28.8069008395779
					],
					"name": "Lismore Heights Public School",
					"playspace": 67.17,
					"projections": [
						241,
						223,
						240,
						245,
						250,
						250
					],
					"projections_orig": [
						"241",
						"223",
						"240",
						"245",
						"250",
						"250"
					],
					"projections_percentage": [
						8.07,
						0,
						7.62,
						9.87,
						12.11,
						12.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4085
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 7.01,
					"enrolment": 73,
					"ligo": 0.53,
					"location": [
						153.271801429361,
						-28.8207024963378
					],
					"name": "Albert Park Public School",
					"playspace": 231.75,
					"projections": [
						52,
						73,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"52",
						"73",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						-28.77,
						0,
						-24.66,
						-24.66,
						-24.66,
						-24.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4177
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 48
					},
					"classroomspace": 8.52,
					"enrolment": 375,
					"ligo": 0.72,
					"location": [
						153.295356700568,
						-28.8217300055923
					],
					"name": "The Rivers Secondary College, Lismore High Campus",
					"playspace": 121.01,
					"projections": [
						0,
						375,
						425,
						450,
						435,
						410
					],
					"projections_orig": [
						"0",
						"375",
						"425",
						"450",
						"435",
						"410"
					],
					"projections_percentage": [
						-100,
						0,
						13.33,
						20,
						16,
						9.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8124
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 3.49,
					"enrolment": 811,
					"ligo": 0.62,
					"location": [
						153.278294198478,
						-28.7992664490217
					],
					"name": "The Rivers Secondary College, Richmond River High Campus",
					"playspace": 26.94,
					"projections": [
						0,
						811,
						950,
						990,
						980,
						930
					],
					"projections_orig": [
						"0",
						"811",
						"950",
						"990",
						"980",
						"930"
					],
					"projections_percentage": [
						-100,
						0,
						17.14,
						22.07,
						20.84,
						14.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 5.19,
					"enrolment": 504,
					"ligo": 0.69,
					"location": [
						153.338214119347,
						-28.8170696998836
					],
					"name": "The Rivers Secondary College, Kadina High Campus",
					"playspace": 58.5,
					"projections": [
						0,
						504,
						555,
						595,
						590,
						555
					],
					"projections_orig": [
						"0",
						"504",
						"555",
						"595",
						"590",
						"555"
					],
					"projections_percentage": [
						-100,
						0,
						10.12,
						18.06,
						17.06,
						10.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8520
				}
			],
			"uid": 30073
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 45
			},
			"enrolment": 905,
			"level": "Combined",
			"ligo": 1,
			"name": "Macleay",
			"playspace": 161.44,
			"projections": [
				905,
				1004,
				1029,
				1024,
				1029
			],
			"projections_percentage": [
				0,
				10.94,
				13.7,
				13.15,
				13.7
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.17,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						152.50854374498,
						-30.8188089290674
					],
					"name": "Bellbrook Public School",
					"playspace": 203.69,
					"projections": [
						40,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"40",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1178
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.77,
					"enrolment": 178,
					"ligo": 1,
					"location": [
						152.971183811439,
						-31.1876643869652
					],
					"name": "Crescent Head Public School",
					"playspace": 15.4,
					"projections": [
						174,
						178,
						180,
						195,
						205,
						210
					],
					"projections_orig": [
						"174",
						"178",
						"180",
						"195",
						"205",
						"210"
					],
					"projections_percentage": [
						-2.25,
						0,
						1.12,
						9.55,
						15.17,
						17.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1681
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.25,
					"enrolment": 155,
					"ligo": 1,
					"location": [
						152.879292612713,
						-31.0345084186134
					],
					"name": "Frederickton Public School",
					"playspace": 114.27,
					"projections": [
						181,
						155,
						160,
						165,
						165,
						165
					],
					"projections_orig": [
						"181",
						"155",
						"160",
						"165",
						"165",
						"165"
					],
					"projections_percentage": [
						16.77,
						0,
						3.23,
						6.45,
						6.45,
						6.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1943
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.19,
					"enrolment": 50,
					"ligo": 1,
					"location": [
						152.945989707692,
						-31.0263699373113
					],
					"name": "Gladstone Public School",
					"playspace": 98.1,
					"projections": [
						39,
						50,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"50",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22,
						0,
						-50,
						-50,
						-50,
						-50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1991
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 7.39,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						152.994309040276,
						-30.9909509957185
					],
					"name": "Kinchela Public School",
					"playspace": 438.13,
					"projections": [
						28,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						3.7,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2303
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						152.635781141336,
						-30.8624732180884
					],
					"name": "Millbank Public School",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2553
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 5.29,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						152.941267774105,
						-31.0174333552852
					],
					"name": "Smithtown Public School",
					"playspace": 150,
					"projections": [
						65,
						61,
						80,
						85,
						90,
						95
					],
					"projections_orig": [
						"65",
						"61",
						"80",
						"85",
						"90",
						"95"
					],
					"projections_percentage": [
						6.56,
						0,
						31.15,
						39.34,
						47.54,
						55.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3075
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 8
					},
					"classroomspace": 2.56,
					"enrolment": 303,
					"ligo": 1,
					"location": [
						153.039092680345,
						-30.8912257027434
					],
					"name": "South West Rocks Public School",
					"playspace": 13.65,
					"projections": [
						328,
						303,
						360,
						355,
						330,
						320
					],
					"projections_orig": [
						"328",
						"303",
						"360",
						"355",
						"330",
						"320"
					],
					"projections_percentage": [
						8.25,
						0,
						18.81,
						17.16,
						8.91,
						5.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3083
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4,
					"enrolment": 43,
					"ligo": 1,
					"location": [
						152.625087257642,
						-30.9261877192086
					],
					"name": "Willawarrin Public School",
					"playspace": 148.94,
					"projections": [
						45,
						43,
						50,
						50,
						55,
						55
					],
					"projections_orig": [
						"45",
						"43",
						"50",
						"50",
						"55",
						"55"
					],
					"projections_percentage": [
						4.65,
						0,
						16.28,
						16.28,
						27.91,
						27.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3445
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.96,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						152.992939439664,
						-30.819720635783
					],
					"name": "Stuarts Point Public School",
					"playspace": 270.8,
					"projections": [
						62,
						56,
						65,
						70,
						70,
						75
					],
					"projections_orig": [
						"62",
						"56",
						"65",
						"70",
						"70",
						"75"
					],
					"projections_percentage": [
						10.71,
						0,
						16.07,
						25,
						25,
						33.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3643
				}
			],
			"uid": 30074
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 84
			},
			"enrolment": 1763,
			"level": "Combined",
			"ligo": 0.8,
			"name": "Mullumbimby",
			"playspace": 162.41,
			"projections": [
				1763,
				1957,
				2007,
				2032,
				2032
			],
			"projections_percentage": [
				0,
				11,
				13.84,
				15.26,
				15.26
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 12
					},
					"classroomspace": 2.66,
					"enrolment": 359,
					"ligo": 0.62,
					"location": [
						153.541246754968,
						-28.4907842097361
					],
					"name": "Ocean Shores Public School",
					"playspace": 32.39,
					"projections": [
						346,
						359,
						430,
						415,
						420,
						425
					],
					"projections_orig": [
						"346",
						"359",
						"430",
						"415",
						"420",
						"425"
					],
					"projections_percentage": [
						-3.62,
						0,
						19.78,
						15.6,
						16.99,
						18.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1227
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.26,
					"enrolment": 170,
					"ligo": 0.58,
					"location": [
						153.550944618295,
						-28.5407489204601
					],
					"name": "Brunswick Heads Public School",
					"playspace": 35.37,
					"projections": [
						176,
						170,
						160,
						170,
						175,
						180
					],
					"projections_orig": [
						"176",
						"170",
						"160",
						"170",
						"175",
						"180"
					],
					"projections_percentage": [
						3.53,
						0,
						-5.88,
						0,
						2.94,
						5.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1389
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 2
					},
					"classroomspace": 3.12,
					"enrolment": 135,
					"ligo": 0.3,
					"location": [
						153.4878090368,
						-28.6257850267652
					],
					"name": "Coorabell Public School",
					"playspace": 59.08,
					"projections": [
						110,
						135,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"110",
						"135",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						-18.52,
						0,
						-3.7,
						-3.7,
						-3.7,
						-3.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1634
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.15,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						153.445119379674,
						-28.5231653915532
					],
					"name": "Durrumbul Public School",
					"playspace": 783.87,
					"projections": [
						89,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"89",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						178.12,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1803
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.68,
					"enrolment": 35,
					"ligo": 0.77,
					"location": [
						153.43973713168,
						-28.6095031426567
					],
					"name": "Goonengerry Public School",
					"playspace": 187.41,
					"projections": [
						29,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-17.14,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2042
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.54,
					"enrolment": 189,
					"ligo": 0.83,
					"location": [
						153.504889889698,
						-28.5524452291741
					],
					"name": "Mullumbimby Public School",
					"playspace": 123.54,
					"projections": [
						240,
						189,
						240,
						235,
						240,
						245
					],
					"projections_orig": [
						"240",
						"189",
						"240",
						"235",
						"240",
						"245"
					],
					"projections_percentage": [
						26.98,
						0,
						26.98,
						24.34,
						26.98,
						29.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2665
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.36,
					"enrolment": 58,
					"ligo": 1,
					"location": [
						153.479198329313,
						-28.5050434025133
					],
					"name": "The Pocket Public School",
					"playspace": 106.93,
					"projections": [
						62,
						58,
						55,
						60,
						60,
						65
					],
					"projections_orig": [
						"62",
						"58",
						"55",
						"60",
						"60",
						"65"
					],
					"projections_percentage": [
						6.9,
						0,
						-5.17,
						3.45,
						3.45,
						12.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2890
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 1
					},
					"classroomspace": 3.76,
					"enrolment": 106,
					"ligo": 1,
					"location": [
						153.412598444654,
						-28.4983757491755
					],
					"name": "Main Arm Upper Public School",
					"playspace": 103.7,
					"projections": [
						80,
						106,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"80",
						"106",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						-24.53,
						0,
						3.77,
						8.49,
						13.21,
						13.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3236
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 4.07,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						153.425858689291,
						-28.5715998766882
					],
					"name": "Wilsons Creek Public School",
					"playspace": 157.81,
					"projections": [
						61,
						53,
						55,
						60,
						60,
						65
					],
					"projections_orig": [
						"61",
						"53",
						"55",
						"60",
						"60",
						"65"
					],
					"projections_percentage": [
						15.09,
						0,
						3.77,
						13.21,
						13.21,
						22.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3454
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 43
					},
					"classroomspace": 4.13,
					"enrolment": 626,
					"ligo": 0.87,
					"location": [
						153.494980907017,
						-28.5589681802827
					],
					"name": "Mullumbimby High School",
					"playspace": 33.98,
					"projections": [
						686,
						626,
						710,
						755,
						760,
						735
					],
					"projections_orig": [
						"686",
						"626",
						"710",
						"755",
						"760",
						"735"
					],
					"projections_percentage": [
						9.58,
						0,
						13.42,
						20.61,
						21.41,
						17.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8193
				}
			],
			"uid": 30076
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 161
			},
			"enrolment": 2079,
			"level": "Combined",
			"ligo": 0.87,
			"name": "Murwillumbah",
			"playspace": 145.2,
			"projections": [
				2079,
				2423,
				2523,
				2543,
				2543
			],
			"projections_percentage": [
				0,
				16.55,
				21.36,
				22.32,
				22.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.81,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						153.275034982926,
						-28.3120352804755
					],
					"name": "Chillingham Public School",
					"playspace": 108.79,
					"projections": [
						38,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.57,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1558
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.88,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						153.434644519518,
						-28.3098109608209
					],
					"name": "Condong Public School",
					"playspace": 44.05,
					"projections": [
						60,
						56,
						70,
						75,
						75,
						80
					],
					"projections_orig": [
						"60",
						"56",
						"70",
						"75",
						"75",
						"80"
					],
					"projections_percentage": [
						7.14,
						0,
						25,
						33.93,
						33.93,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1611
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.18,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						153.496559241371,
						-28.456307611751
					],
					"name": "Crabbes Creek Public School",
					"playspace": 76.33,
					"projections": [
						34,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"34",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10.53,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1674
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.66,
					"enrolment": 85,
					"ligo": 1,
					"location": [
						153.326205694933,
						-28.3116785355297
					],
					"name": "Crystal Creek Public School",
					"playspace": 108.21,
					"projections": [
						78,
						85,
						85,
						90,
						90,
						95
					],
					"projections_orig": [
						"78",
						"85",
						"85",
						"90",
						"90",
						"95"
					],
					"projections_percentage": [
						-8.24,
						0,
						0,
						5.88,
						5.88,
						11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1690
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.5,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						153.382242939687,
						-28.2885933236657
					],
					"name": "Dungay Public School",
					"playspace": 183.73,
					"projections": [
						58,
						53,
						60,
						65,
						65,
						70
					],
					"projections_orig": [
						"58",
						"53",
						"60",
						"65",
						"65",
						"70"
					],
					"projections_percentage": [
						9.43,
						0,
						13.21,
						22.64,
						22.64,
						32.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1791
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.76,
					"enrolment": 301,
					"ligo": 0.88,
					"location": [
						153.391542094593,
						-28.3299688402209
					],
					"name": "Murwillumbah Public School",
					"playspace": 17.43,
					"projections": [
						248,
						301,
						310,
						310,
						320,
						325
					],
					"projections_orig": [
						"248",
						"301",
						"310",
						"310",
						"320",
						"325"
					],
					"projections_percentage": [
						-17.61,
						0,
						2.99,
						2.99,
						6.31,
						7.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2687
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.78,
					"enrolment": 34,
					"ligo": 1,
					"location": [
						153.403964212169,
						-28.3944885832877
					],
					"name": "Stokers Siding Public School",
					"playspace": 221.08,
					"projections": [
						59,
						34,
						55,
						55,
						60,
						60
					],
					"projections_orig": [
						"59",
						"34",
						"55",
						"55",
						"60",
						"60"
					],
					"projections_percentage": [
						73.53,
						0,
						61.76,
						61.76,
						76.47,
						76.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3112
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.51,
					"enrolment": 20,
					"ligo": 0.57,
					"location": [
						153.462790135716,
						-28.2740291087932
					],
					"name": "Tumbulgum Public School",
					"playspace": 502.81,
					"projections": [
						41,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"41",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						105,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3277
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.98,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						153.204771533992,
						-28.3548470505313
					],
					"name": "Tyalgum Public School",
					"playspace": 114.79,
					"projections": [
						52,
						52,
						50,
						50,
						55,
						55
					],
					"projections_orig": [
						"52",
						"52",
						"50",
						"50",
						"55",
						"55"
					],
					"projections_percentage": [
						0,
						0,
						-3.85,
						-3.85,
						5.77,
						5.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3293
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.49,
					"enrolment": 145,
					"ligo": 1,
					"location": [
						153.335510651799,
						-28.4140382655708
					],
					"name": "Uki Public School",
					"playspace": 176.99,
					"projections": [
						96,
						145,
						150,
						155,
						160,
						160
					],
					"projections_orig": [
						"96",
						"145",
						"150",
						"155",
						"160",
						"160"
					],
					"projections_percentage": [
						-33.79,
						0,
						3.45,
						6.9,
						10.34,
						10.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3298
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 3.18,
					"enrolment": 301,
					"ligo": 0.56,
					"location": [
						153.405139493864,
						-28.321807873444
					],
					"name": "Murwillumbah East Public School",
					"playspace": 77.02,
					"projections": [
						316,
						301,
						380,
						380,
						380,
						385
					],
					"projections_orig": [
						"316",
						"301",
						"380",
						"380",
						"380",
						"385"
					],
					"projections_percentage": [
						4.98,
						0,
						26.25,
						26.25,
						26.25,
						27.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4101
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						153.399551380114,
						-28.3403189066652
					],
					"name": "Murwillumbah South Infants School",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5172
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 62
					},
					"classroomspace": 8.08,
					"enrolment": 485,
					"ligo": 0.65,
					"location": [
						153.391164319268,
						-28.3337139845843
					],
					"name": "Murwillumbah High School",
					"playspace": 120.54,
					"projections": [
						641,
						485,
						630,
						665,
						670,
						650
					],
					"projections_orig": [
						"641",
						"485",
						"630",
						"665",
						"670",
						"650"
					],
					"projections_percentage": [
						32.16,
						0,
						29.9,
						37.11,
						38.14,
						34.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 4.95,
					"enrolment": 474,
					"ligo": 0.56,
					"location": [
						153.362774410156,
						-28.3337247513134
					],
					"name": "Wollumbin High School",
					"playspace": 135.77,
					"projections": [
						464,
						474,
						540,
						585,
						575,
						570
					],
					"projections_orig": [
						"464",
						"474",
						"540",
						"585",
						"575",
						"570"
					],
					"projections_percentage": [
						-2.11,
						0,
						13.92,
						23.42,
						21.31,
						20.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8596
				}
			],
			"uid": 30077
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 141
			},
			"enrolment": 2176,
			"level": "Combined",
			"ligo": 0.84,
			"name": "Nambucca",
			"playspace": 212.97,
			"projections": [
				2175,
				2298,
				2228,
				2148,
				2033
			],
			"projections_percentage": [
				0,
				5.66,
				2.44,
				-1.24,
				-6.53
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 18
					},
					"classroomspace": 4.46,
					"enrolment": 229,
					"ligo": 0.65,
					"location": [
						152.853588059558,
						-30.6440736044768
					],
					"name": "Bowraville Central School",
					"playspace": 45.44,
					"projections": [
						235,
						229,
						225,
						215,
						210,
						200
					],
					"projections_orig": [
						"235",
						"229",
						"225",
						"215",
						"210",
						"200"
					],
					"projections_percentage": [
						2.62,
						0,
						-1.75,
						-6.11,
						-8.3,
						-12.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1336
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.26,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						152.875308315404,
						-30.8326652885316
					],
					"name": "Eungai Public School",
					"playspace": 243.42,
					"projections": [
						70,
						52,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"70",
						"52",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						34.62,
						0,
						15.38,
						15.38,
						5.77,
						5.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1874
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 11
					},
					"classroomspace": 2.62,
					"enrolment": 374,
					"ligo": 1,
					"location": [
						152.916589868401,
						-30.7088059485
					],
					"name": "Macksville Public School",
					"playspace": 43.12,
					"projections": [
						398,
						374,
						440,
						415,
						390,
						375
					],
					"projections_orig": [
						"398",
						"374",
						"440",
						"415",
						"390",
						"375"
					],
					"projections_percentage": [
						6.42,
						0,
						17.65,
						10.96,
						4.28,
						0.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2444
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 12.76,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						152.690748451235,
						-30.7792049759742
					],
					"name": "Medlow Public School",
					"playspace": 981.95,
					"projections": [
						19,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						137.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2511
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.42,
					"enrolment": 288,
					"ligo": 0.65,
					"location": [
						153.005772284087,
						-30.6417040278649
					],
					"name": "Nambucca Heads Public School",
					"playspace": 52.19,
					"projections": [
						256,
						288,
						280,
						260,
						255,
						245
					],
					"projections_orig": [
						"256",
						"288",
						"280",
						"260",
						"255",
						"245"
					],
					"projections_percentage": [
						-11.11,
						0,
						-2.78,
						-9.72,
						-11.46,
						-14.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2696
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 2.74,
					"enrolment": 101,
					"ligo": 1,
					"location": [
						152.995521391047,
						-30.7493018066275
					],
					"name": "Scotts Head Public School",
					"playspace": 177.36,
					"projections": [
						75,
						101,
						100,
						100,
						105,
						105
					],
					"projections_orig": [
						"75",
						"101",
						"100",
						"100",
						"105",
						"105"
					],
					"projections_percentage": [
						-25.74,
						0,
						-0.99,
						-0.99,
						3.96,
						3.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3635
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.39,
					"enrolment": 219,
					"ligo": 0.7,
					"location": [
						152.984632841184,
						-30.6423527956123
					],
					"name": "Frank Partridge VC Public School",
					"playspace": 103.54,
					"projections": [
						228,
						219,
						215,
						205,
						200,
						190
					],
					"projections_orig": [
						"228",
						"219",
						"215",
						"205",
						"200",
						"190"
					],
					"projections_percentage": [
						4.11,
						0,
						-1.83,
						-6.39,
						-8.68,
						-13.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4581
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 42
					},
					"classroomspace": 4.97,
					"enrolment": 533,
					"ligo": 0.75,
					"location": [
						152.917430248814,
						-30.7140821042249
					],
					"name": "Macksville High School",
					"playspace": 132.34,
					"projections": [
						632,
						533,
						600,
						605,
						580,
						540
					],
					"projections_orig": [
						"632",
						"533",
						"600",
						"605",
						"580",
						"540"
					],
					"projections_percentage": [
						18.57,
						0,
						12.57,
						13.51,
						8.82,
						1.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8162
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 6.84,
					"enrolment": 372,
					"ligo": 0.8,
					"location": [
						152.985192635305,
						-30.6405253311969
					],
					"name": "Nambucca Heads High School",
					"playspace": 137.33,
					"projections": [
						473,
						371,
						370,
						360,
						345,
						315
					],
					"projections_orig": [
						"473",
						"371",
						"370",
						"360",
						"345",
						"315"
					],
					"projections_percentage": [
						27.49,
						0,
						-0.27,
						-2.96,
						-7.01,
						-15.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8595
				}
			],
			"uid": 30078
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 115
			},
			"enrolment": 2515,
			"level": "Combined",
			"ligo": 0.9,
			"name": "Orara",
			"playspace": 154.57,
			"projections": [
				2515,
				2686,
				2711,
				2591,
				2506
			],
			"projections_percentage": [
				0,
				6.8,
				7.79,
				3.02,
				-0.36
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 2.43,
					"enrolment": 155,
					"ligo": 0.55,
					"location": [
						153.032242859296,
						-30.3795216482822
					],
					"name": "Bonville Public School",
					"playspace": 65.04,
					"projections": [
						100,
						155,
						145,
						145,
						140,
						135
					],
					"projections_orig": [
						"100",
						"155",
						"145",
						"145",
						"140",
						"135"
					],
					"projections_percentage": [
						-35.48,
						0,
						-6.45,
						-6.45,
						-9.68,
						-12.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1297
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.31,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						153.011949677997,
						-30.2209626475831
					],
					"name": "Coramba Public School",
					"playspace": 232.15,
					"projections": [
						56,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"56",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						47.37,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1647
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 6
					},
					"classroomspace": 2.5,
					"enrolment": 195,
					"ligo": 0.85,
					"location": [
						153.193188086367,
						-30.02179690515
					],
					"name": "Corindi Public School",
					"playspace": 92.01,
					"projections": [
						162,
						195,
						200,
						200,
						195,
						190
					],
					"projections_orig": [
						"162",
						"195",
						"200",
						"200",
						"195",
						"190"
					],
					"projections_percentage": [
						-16.92,
						0,
						2.56,
						2.56,
						0,
						-2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1654
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 6.91,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						152.981499601181,
						-30.3660157571455
					],
					"name": "Crossmaglen Public School",
					"playspace": 412.06,
					"projections": [
						16,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						45.45,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1685
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 2.97,
					"enrolment": 113,
					"ligo": 1,
					"location": [
						153.047576057618,
						-30.2525545442646
					],
					"name": "Karangi Public School",
					"playspace": 45.38,
					"projections": [
						80,
						113,
						130,
						130,
						125,
						120
					],
					"projections_orig": [
						"80",
						"113",
						"130",
						"130",
						"125",
						"120"
					],
					"projections_percentage": [
						-29.2,
						0,
						15.04,
						15.04,
						10.62,
						6.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2260
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.91,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						152.899073660679,
						-30.2072886861121
					],
					"name": "Lowanna Public School",
					"playspace": 429.79,
					"projections": [
						26,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						13.04,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2428
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.7,
					"enrolment": 131,
					"ligo": 1,
					"location": [
						153.005518726207,
						-30.1362649628907
					],
					"name": "Nana Glen Public School",
					"playspace": 164.06,
					"projections": [
						83,
						131,
						115,
						115,
						110,
						110
					],
					"projections_orig": [
						"83",
						"131",
						"115",
						"115",
						"110",
						"110"
					],
					"projections_percentage": [
						-36.64,
						0,
						-12.21,
						-12.21,
						-16.03,
						-16.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2698
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.94,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						153.013751069203,
						-30.2893267693071
					],
					"name": "Orara Upper Public School",
					"playspace": 172.99,
					"projections": [
						33,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10.81,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2814
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.42,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						152.885263406563,
						-30.2429131764234
					],
					"name": "Ulong Public School",
					"playspace": 181.24,
					"projections": [
						25,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						13.64,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3304
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.29,
					"enrolment": 359,
					"ligo": 0.77,
					"location": [
						153.196069659256,
						-30.1129993139422
					],
					"name": "Woolgoolga Public School",
					"playspace": 23.66,
					"projections": [
						346,
						359,
						385,
						380,
						345,
						335
					],
					"projections_orig": [
						"346",
						"359",
						"385",
						"380",
						"345",
						"335"
					],
					"projections_percentage": [
						-3.62,
						0,
						7.24,
						5.85,
						-3.9,
						-6.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3503
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.81,
					"enrolment": 353,
					"ligo": 0.89,
					"location": [
						153.185087541003,
						-30.1531499123879
					],
					"name": "Sandy Beach Public School",
					"playspace": 130.61,
					"projections": [
						340,
						353,
						410,
						410,
						380,
						380
					],
					"projections_orig": [
						"340",
						"353",
						"410",
						"410",
						"380",
						"380"
					],
					"projections_percentage": [
						-3.68,
						0,
						16.15,
						16.15,
						7.65,
						7.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4557
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.55,
					"enrolment": 215,
					"ligo": 0.71,
					"location": [
						153.189204901129,
						-30.0780885687448
					],
					"name": "Mullaway Public School",
					"playspace": 40.63,
					"projections": [
						165,
						215,
						205,
						205,
						200,
						195
					],
					"projections_orig": [
						"165",
						"215",
						"205",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						-23.26,
						0,
						-4.65,
						-4.65,
						-6.98,
						-9.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4606
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 3.08,
					"enrolment": 863,
					"ligo": 0.91,
					"location": [
						153.189755442961,
						-30.1005871968602
					],
					"name": "Woolgoolga High School",
					"playspace": 19.84,
					"projections": [
						918,
						863,
						965,
						995,
						965,
						910
					],
					"projections_orig": [
						"918",
						"863",
						"965",
						"995",
						"965",
						"910"
					],
					"projections_percentage": [
						6.37,
						0,
						11.82,
						15.3,
						11.82,
						5.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8548
				}
			],
			"uid": 30080
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 250
			},
			"enrolment": 5107,
			"level": "Combined",
			"ligo": 0.8,
			"name": "Port Macquarie",
			"playspace": 61.46,
			"projections": [
				5106,
				5965,
				6050,
				5920,
				5790
			],
			"projections_percentage": [
				0,
				16.82,
				18.49,
				15.94,
				13.4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 3.34,
					"enrolment": 427,
					"ligo": 0.63,
					"location": [
						152.913250918274,
						-31.4299540681681
					],
					"name": "Port Macquarie Public School",
					"playspace": 36.73,
					"projections": [
						431,
						427,
						540,
						545,
						520,
						520
					],
					"projections_orig": [
						"431",
						"427",
						"540",
						"545",
						"520",
						"520"
					],
					"projections_percentage": [
						0.94,
						0,
						26.46,
						27.63,
						21.78,
						21.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2899
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 25
					},
					"classroomspace": 2.57,
					"enrolment": 730,
					"ligo": 0.95,
					"location": [
						152.729493064254,
						-31.4551400274998
					],
					"name": "Wauchope Public School",
					"playspace": 28.56,
					"projections": [
						686,
						730,
						775,
						780,
						755,
						750
					],
					"projections_orig": [
						"686",
						"730",
						"775",
						"780",
						"755",
						"750"
					],
					"projections_percentage": [
						-6.03,
						0,
						6.16,
						6.85,
						3.42,
						2.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3404
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.03,
					"enrolment": 320,
					"ligo": 0.82,
					"location": [
						152.891847562862,
						-31.4371488427259
					],
					"name": "Westport Public School",
					"playspace": 61.61,
					"projections": [
						315,
						320,
						375,
						365,
						360,
						360
					],
					"projections_orig": [
						"315",
						"320",
						"375",
						"365",
						"360",
						"360"
					],
					"projections_percentage": [
						-1.56,
						0,
						17.19,
						14.06,
						12.5,
						12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4411
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 20
					},
					"classroomspace": 2.48,
					"enrolment": 699,
					"ligo": 0.7,
					"location": [
						152.918358087772,
						-31.4539166474465
					],
					"name": "Hastings Public School",
					"playspace": 32.77,
					"projections": [
						536,
						699,
						760,
						765,
						730,
						735
					],
					"projections_orig": [
						"536",
						"699",
						"760",
						"765",
						"730",
						"735"
					],
					"projections_percentage": [
						-23.32,
						0,
						8.73,
						9.44,
						4.43,
						5.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4524
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 24
					},
					"classroomspace": 2.55,
					"enrolment": 730,
					"ligo": 0.73,
					"location": [
						152.926687320341,
						-31.472872714075
					],
					"name": "Tacking Point Public School",
					"playspace": 26.62,
					"projections": [
						745,
						730,
						855,
						860,
						840,
						830
					],
					"projections_orig": [
						"745",
						"730",
						"855",
						"860",
						"840",
						"830"
					],
					"projections_percentage": [
						2.05,
						0,
						17.12,
						17.81,
						15.07,
						13.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4617
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 1
					},
					"classroomspace": 1.65,
					"enrolment": 183,
					"ligo": 1,
					"location": [
						152.913265754462,
						-31.430142157401
					],
					"name": "North East Public School of Distance Education",
					"playspace": "NA",
					"projections": [
						160,
						183,
						240,
						230,
						235,
						235
					],
					"projections_orig": [
						"160",
						"183",
						"240",
						"230",
						"235",
						"235"
					],
					"projections_percentage": [
						-12.57,
						0,
						31.15,
						25.68,
						28.42,
						28.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4643
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 0
					},
					"classroomspace": 2.65,
					"enrolment": 215,
					"ligo": 0.87,
					"location": [
						152.826744188346,
						-31.5683874665493
					],
					"name": "Lake Cathie Public School",
					"playspace": 120.77,
					"projections": [
						0,
						215,
						280,
						265,
						260,
						250
					],
					"projections_orig": [
						"0",
						"215",
						"280",
						"265",
						"260",
						"250"
					],
					"projections_percentage": [
						-100,
						0,
						30.23,
						23.26,
						20.93,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4654
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 39
					},
					"classroomspace": 4.08,
					"enrolment": 621,
					"ligo": 0.9,
					"location": [
						152.731432323118,
						-31.4519853462824
					],
					"name": "Wauchope High School",
					"playspace": 87.76,
					"projections": [
						662,
						621,
						700,
						725,
						715,
						675
					],
					"projections_orig": [
						"662",
						"621",
						"700",
						"725",
						"715",
						"675"
					],
					"projections_percentage": [
						6.6,
						0,
						12.72,
						16.75,
						15.14,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8173
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 39
					},
					"classroomspace": 3.93,
					"enrolment": 675,
					"ligo": 0.58,
					"location": [
						152.920051980424,
						-31.4339678893898
					],
					"name": "Hastings Secondary College, Port Macquarie Campus",
					"playspace": 36.14,
					"projections": [
						0,
						674,
						820,
						865,
						860,
						820
					],
					"projections_orig": [
						"0",
						"674",
						"820",
						"865",
						"860",
						"820"
					],
					"projections_percentage": [
						-100,
						0,
						21.66,
						28.34,
						27.6,
						21.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8364
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 7.4,
					"enrolment": 507,
					"ligo": 0.79,
					"location": [
						152.892975295612,
						-31.4353586916102
					],
					"name": "Hastings Secondary College, Westport Campus",
					"playspace": 122.14,
					"projections": [
						0,
						507,
						620,
						650,
						645,
						615
					],
					"projections_orig": [
						"0",
						"507",
						"620",
						"650",
						"645",
						"615"
					],
					"projections_percentage": [
						-100,
						0,
						22.29,
						28.21,
						27.22,
						21.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8554
				}
			],
			"uid": 30081
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 73
			},
			"enrolment": 1051,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Richmond Valley",
			"playspace": 253.32,
			"projections": [
				1051,
				1087,
				1092,
				1092,
				1067
			],
			"projections_percentage": [
				0,
				3.43,
				3.9,
				3.9,
				1.52
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.42,
					"enrolment": 93,
					"ligo": 1,
					"location": [
						153.230024168693,
						-28.7638281969547
					],
					"name": "Blakebrook Public School",
					"playspace": 116.64,
					"projections": [
						98,
						93,
						90,
						90,
						90,
						90
					],
					"projections_orig": [
						"98",
						"93",
						"90",
						"90",
						"90",
						"90"
					],
					"projections_percentage": [
						5.38,
						0,
						-3.23,
						-3.23,
						-3.23,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1254
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.07,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						153.280291157813,
						-28.6747397827643
					],
					"name": "The Channon Public School",
					"playspace": 7.32,
					"projections": [
						53,
						41,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"53",
						"41",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						29.27,
						0,
						21.95,
						21.95,
						21.95,
						21.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1548
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.89,
					"enrolment": 91,
					"ligo": 1,
					"location": [
						153.410103893878,
						-28.7243593090029
					],
					"name": "Clunes Public School",
					"playspace": 235.76,
					"projections": [
						110,
						91,
						100,
						100,
						100,
						95
					],
					"projections_orig": [
						"110",
						"91",
						"100",
						"100",
						"100",
						"95"
					],
					"projections_percentage": [
						20.88,
						0,
						9.89,
						9.89,
						9.89,
						4.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1574
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.14,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						153.220263361456,
						-28.6628594191432
					],
					"name": "Coffee Camp Public School",
					"playspace": 50,
					"projections": [
						92,
						54,
						65,
						65,
						65,
						65
					],
					"projections_orig": [
						"92",
						"54",
						"65",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						70.37,
						0,
						20.37,
						20.37,
						20.37,
						20.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1583
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.91,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						153.362455484748,
						-28.713620651878
					],
					"name": "Corndale Public School",
					"playspace": 658.87,
					"projections": [
						21,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1656
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.79,
					"enrolment": 90,
					"ligo": 1,
					"location": [
						153.314912700036,
						-28.6867415891686
					],
					"name": "Dunoon Public School",
					"playspace": 190.09,
					"projections": [
						58,
						90,
						85,
						85,
						85,
						80
					],
					"projections_orig": [
						"58",
						"90",
						"85",
						"85",
						"85",
						"80"
					],
					"projections_percentage": [
						-35.56,
						0,
						-5.56,
						-5.56,
						-5.56,
						-11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1797
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.06,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						153.407950025535,
						-28.763687720417
					],
					"name": "Eltham Public School",
					"playspace": 99.96,
					"projections": [
						50,
						55,
						65,
						65,
						65,
						65
					],
					"projections_orig": [
						"50",
						"55",
						"65",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						-9.09,
						0,
						18.18,
						18.18,
						18.18,
						18.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1835
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.68,
					"enrolment": 43,
					"ligo": 0.94,
					"location": [
						153.438791306418,
						-28.6879881068245
					],
					"name": "Eureka Public School",
					"playspace": 250.8,
					"projections": [
						30,
						43,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"43",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-30.23,
						0,
						-41.86,
						-41.86,
						-41.86,
						-41.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1879
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.75,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						153.23214492054,
						-28.7097026366102
					],
					"name": "Goolmangar Public School",
					"playspace": 598.05,
					"projections": [
						29,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						61.11,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2037
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.32,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						153.181891231827,
						-28.6783123355951
					],
					"name": "Jiggi Public School",
					"playspace": 156.73,
					"projections": [
						46,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"46",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						53.33,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2235
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.01,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						153.1139961051,
						-28.6486682137637
					],
					"name": "Larnook Public School",
					"playspace": 488.62,
					"projections": [
						42,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"42",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2375
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.32,
					"enrolment": 83,
					"ligo": 1,
					"location": [
						153.297252857136,
						-28.7298595967507
					],
					"name": "Modanville Public School",
					"playspace": 171.67,
					"projections": [
						105,
						83,
						80,
						80,
						80,
						75
					],
					"projections_orig": [
						"105",
						"83",
						"80",
						"80",
						"80",
						"75"
					],
					"projections_percentage": [
						26.51,
						0,
						-3.61,
						-3.61,
						-3.61,
						-9.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2585
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 7.22,
					"enrolment": 214,
					"ligo": 0.6,
					"location": [
						153.221118126987,
						-28.5955153751125
					],
					"name": "Nimbin Central School",
					"playspace": 306.9,
					"projections": [
						170,
						214,
						210,
						210,
						210,
						205
					],
					"projections_orig": [
						"170",
						"214",
						"210",
						"210",
						"210",
						"205"
					],
					"projections_percentage": [
						-20.56,
						0,
						-1.87,
						-1.87,
						-1.87,
						-4.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2751
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.4,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						153.314810865486,
						-28.6382773595625
					],
					"name": "Whian Whian Public School",
					"playspace": 246.24,
					"projections": [
						18,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						12.5,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2980
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.03,
					"enrolment": 42,
					"ligo": 1,
					"location": [
						153.387890128091,
						-28.6779303541129
					],
					"name": "Rosebank Public School",
					"playspace": 196.17,
					"projections": [
						52,
						42,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"52",
						"42",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						23.81,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2987
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.62,
					"enrolment": 111,
					"ligo": 0.28,
					"location": [
						153.354558517816,
						-28.8544926988083
					],
					"name": "Tregeagle Public School",
					"playspace": 62.87,
					"projections": [
						114,
						111,
						115,
						120,
						120,
						115
					],
					"projections_orig": [
						"114",
						"111",
						"115",
						"120",
						"120",
						"115"
					],
					"projections_percentage": [
						2.7,
						0,
						3.6,
						8.11,
						8.11,
						3.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3255
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.14,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						153.266053920836,
						-28.6313238217729
					],
					"name": "Tuntable Creek Public School",
					"playspace": 202.11,
					"projections": [
						13,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-13.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3283
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.99,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						153.402267143339,
						-28.6074819214642
					],
					"name": "Upper Coopers Creek Public School",
					"playspace": 520.94,
					"projections": [
						13,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						30,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3760
				}
			],
			"uid": 30082
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 240
			},
			"enrolment": 4026,
			"level": "Combined",
			"ligo": 0.76,
			"name": "Taree",
			"playspace": 84.21,
			"projections": [
				4026,
				4410,
				4320,
				4120,
				3880
			],
			"projections_percentage": [
				0,
				9.54,
				7.3,
				2.33,
				-3.63
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.45,
					"enrolment": 313,
					"ligo": 1,
					"location": [
						152.521993826671,
						-31.9004078054616
					],
					"name": "Cundletown Public School",
					"playspace": 34.4,
					"projections": [
						249,
						313,
						330,
						305,
						295,
						285
					],
					"projections_orig": [
						"249",
						"313",
						"330",
						"305",
						"295",
						"285"
					],
					"projections_percentage": [
						-20.45,
						0,
						5.43,
						-2.56,
						-5.75,
						-8.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1708
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 11.68,
					"enrolment": 81,
					"ligo": 0.54,
					"location": [
						152.462660754095,
						-31.9105263954364
					],
					"name": "Taree Public School",
					"playspace": 86.12,
					"projections": [
						66,
						81,
						75,
						75,
						70,
						70
					],
					"projections_orig": [
						"66",
						"81",
						"75",
						"75",
						"70",
						"70"
					],
					"projections_percentage": [
						-18.52,
						0,
						-7.41,
						-7.41,
						-13.58,
						-13.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3167
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.38,
					"enrolment": 187,
					"ligo": 1,
					"location": [
						152.414184858582,
						-31.9333740764323
					],
					"name": "Tinonee Public School",
					"playspace": 93.89,
					"projections": [
						179,
						187,
						180,
						175,
						170,
						165
					],
					"projections_orig": [
						"179",
						"187",
						"180",
						"175",
						"170",
						"165"
					],
					"projections_percentage": [
						-4.28,
						0,
						-3.74,
						-6.42,
						-9.09,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3219
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.38,
					"enrolment": 518,
					"ligo": 0.74,
					"location": [
						152.445576027058,
						-31.907557431424
					],
					"name": "Taree West Public School",
					"playspace": 34.65,
					"projections": [
						524,
						518,
						570,
						550,
						505,
						490
					],
					"projections_orig": [
						"524",
						"518",
						"570",
						"550",
						"505",
						"490"
					],
					"projections_percentage": [
						1.16,
						0,
						10.04,
						6.18,
						-2.51,
						-5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3909
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.33,
					"enrolment": 270,
					"ligo": 0.62,
					"location": [
						152.482557574602,
						-31.8991265192236
					],
					"name": "Chatham Public School",
					"playspace": 51.57,
					"projections": [
						327,
						270,
						305,
						290,
						280,
						275
					],
					"projections_orig": [
						"327",
						"270",
						"305",
						"290",
						"280",
						"275"
					],
					"projections_percentage": [
						21.11,
						0,
						12.96,
						7.41,
						3.7,
						1.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4014
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 10.45,
					"enrolment": 112,
					"ligo": 0.8,
					"location": [
						152.46178071538,
						-31.8924342466449
					],
					"name": "Manning Gardens Public School",
					"playspace": 275.43,
					"projections": [
						184,
						112,
						150,
						150,
						145,
						140
					],
					"projections_orig": [
						"184",
						"112",
						"150",
						"150",
						"145",
						"140"
					],
					"projections_percentage": [
						64.29,
						0,
						33.93,
						33.93,
						29.46,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4552
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.86,
					"enrolment": 191,
					"ligo": 0.6,
					"location": [
						152.376669570038,
						-31.8695377475036
					],
					"name": "Wingham Brush Public School",
					"playspace": 108.61,
					"projections": [
						226,
						191,
						210,
						210,
						205,
						195
					],
					"projections_orig": [
						"226",
						"191",
						"210",
						"210",
						"205",
						"195"
					],
					"projections_percentage": [
						18.32,
						0,
						9.95,
						9.95,
						7.33,
						2.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4575
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.57,
					"enrolment": 327,
					"ligo": 0.74,
					"location": [
						152.34995315051,
						-31.8643774376891
					],
					"name": "Wingham Public School",
					"playspace": 87.38,
					"projections": [
						287,
						327,
						360,
						325,
						315,
						305
					],
					"projections_orig": [
						"287",
						"327",
						"360",
						"325",
						"315",
						"305"
					],
					"projections_percentage": [
						-12.23,
						0,
						10.09,
						-0.61,
						-3.67,
						-6.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7314
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.93,
					"enrolment": 897,
					"ligo": 0.68,
					"location": [
						152.463435544572,
						-31.9097589665286
					],
					"name": "Taree High School",
					"playspace": 14.69,
					"projections": [
						977,
						897,
						950,
						955,
						910,
						835
					],
					"projections_orig": [
						"977",
						"897",
						"950",
						"955",
						"910",
						"835"
					],
					"projections_percentage": [
						8.92,
						0,
						5.91,
						6.47,
						1.45,
						-6.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8140
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 32
					},
					"classroomspace": 3.93,
					"enrolment": 540,
					"ligo": 0.79,
					"location": [
						152.380483269516,
						-31.8676992733965
					],
					"name": "Wingham High School",
					"playspace": 60.04,
					"projections": [
						725,
						540,
						645,
						650,
						620,
						565
					],
					"projections_orig": [
						"725",
						"540",
						"645",
						"650",
						"620",
						"565"
					],
					"projections_percentage": [
						34.26,
						0,
						19.44,
						20.37,
						14.81,
						4.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8391
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 5.69,
					"enrolment": 590,
					"ligo": 0.82,
					"location": [
						152.480050463205,
						-31.8965649928199
					],
					"name": "Chatham High School",
					"playspace": 79.48,
					"projections": [
						672,
						590,
						635,
						635,
						605,
						555
					],
					"projections_orig": [
						"672",
						"590",
						"635",
						"635",
						"605",
						"555"
					],
					"projections_percentage": [
						13.9,
						0,
						7.63,
						7.63,
						2.54,
						-5.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8414
				}
			],
			"uid": 30083
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 11
			},
			"enrolment": 226,
			"level": "Combined",
			"ligo": 1,
			"name": "Clarence Valley",
			"playspace": 482.32,
			"projections": [
				226,
				225,
				225,
				220,
				215
			],
			"projections_percentage": [
				0,
				-0.44,
				-0.44,
				-2.65,
				-4.87
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 18.07,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						152.605226250185,
						-29.2232096952156
					],
					"name": "Baryulgil Public School",
					"playspace": 1845.46,
					"projections": [
						8,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						14.29,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1146
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.68,
					"enrolment": 78,
					"ligo": 1,
					"location": [
						152.776239799694,
						-29.5847320906823
					],
					"name": "Copmanhurst Public School",
					"playspace": 130.52,
					"projections": [
						62,
						78,
						75,
						75,
						70,
						70
					],
					"projections_orig": [
						"62",
						"78",
						"75",
						"75",
						"70",
						"70"
					],
					"projections_percentage": [
						-20.51,
						0,
						-3.85,
						-3.85,
						-10.26,
						-10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1642
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.06,
					"enrolment": 68,
					"ligo": 1,
					"location": [
						152.976922971966,
						-30.0534180958064
					],
					"name": "Glenreagh Public School",
					"playspace": 172.91,
					"projections": [
						91,
						68,
						75,
						75,
						75,
						70
					],
					"projections_orig": [
						"91",
						"68",
						"75",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						33.82,
						0,
						10.29,
						10.29,
						10.29,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2016
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.33,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						152.727959045988,
						-29.9474923913239
					],
					"name": "Nymboida Public School",
					"playspace": 207.12,
					"projections": [
						13,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.78,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2784
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.52,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						153.265548486268,
						-29.8707530411929
					],
					"name": "Wooli Public School",
					"playspace": 55.6,
					"projections": [
						37,
						55,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"37",
						"55",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						-32.73,
						0,
						-9.09,
						-9.09,
						-9.09,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2841
				}
			],
			"uid": 30085
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 39
			},
			"enrolment": 364,
			"level": "Combined",
			"ligo": 1,
			"name": "Cootamundra Network ST",
			"playspace": 440.65,
			"projections": [
				364,
				363,
				343,
				328,
				318
			],
			"projections_percentage": [
				0,
				-0.27,
				-5.77,
				-9.89,
				-12.64
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.13,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						148.625156517092,
						-34.67015103694
					],
					"name": "Binalong Public School",
					"playspace": 388.46,
					"projections": [
						30,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						15.38,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1230
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.44,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						148.334975327458,
						-34.819893932492
					],
					"name": "Jugiong Public School",
					"playspace": 180.75,
					"projections": [
						26,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-3.7,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2245
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.33,
					"enrolment": 151,
					"ligo": 1,
					"location": [
						148.359163203752,
						-34.5518211723202
					],
					"name": "Murrumburrah Public School",
					"playspace": 259.8,
					"projections": [
						146,
						151,
						145,
						135,
						130,
						125
					],
					"projections_orig": [
						"146",
						"151",
						"145",
						"135",
						"130",
						"125"
					],
					"projections_percentage": [
						-3.31,
						0,
						-3.97,
						-10.6,
						-13.91,
						-17.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2685
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.38,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						148.24522127251,
						-34.4268561860091
					],
					"name": "Wombat Public School",
					"playspace": 219.04,
					"projections": [
						39,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						56,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3482
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 6.84,
					"enrolment": 135,
					"ligo": 1,
					"location": [
						148.370087925079,
						-34.5596868277349
					],
					"name": "Murrumburrah High School",
					"playspace": 1155.19,
					"projections": [
						181,
						135,
						140,
						130,
						120,
						115
					],
					"projections_orig": [
						"181",
						"135",
						"140",
						"130",
						"120",
						"115"
					],
					"projections_percentage": [
						34.07,
						0,
						3.7,
						-3.7,
						-11.11,
						-14.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8328
				}
			],
			"uid": 30087
		},
		{
			"classrooms": {
				"demountable": 44,
				"permanent": 379
			},
			"enrolment": 7503,
			"level": "Combined",
			"ligo": 0.79,
			"name": "Far South Coast Network",
			"playspace": 174.29,
			"projections": [
				7503,
				7798,
				7508,
				7118,
				6703
			],
			"projections_percentage": [
				0,
				3.93,
				0.07,
				-5.13,
				-10.66
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.85,
					"enrolment": 587,
					"ligo": 0.8,
					"location": [
						150.18903514064,
						-35.6998684797424
					],
					"name": "Batemans Bay Public School",
					"playspace": 8.93,
					"projections": [
						523,
						587,
						595,
						560,
						500,
						470
					],
					"projections_orig": [
						"523",
						"587",
						"595",
						"560",
						"500",
						"470"
					],
					"projections_percentage": [
						-10.9,
						0,
						1.36,
						-4.6,
						-14.82,
						-19.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1149
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.05,
					"enrolment": 336,
					"ligo": 0.86,
					"location": [
						149.841134240661,
						-36.6704263692867
					],
					"name": "Bega Valley Public School",
					"playspace": 193.79,
					"projections": [
						344,
						336,
						365,
						350,
						335,
						325
					],
					"projections_orig": [
						"344",
						"336",
						"365",
						"350",
						"335",
						"325"
					],
					"projections_percentage": [
						2.38,
						0,
						8.63,
						4.17,
						-0.3,
						-3.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1168
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.39,
					"enrolment": 52,
					"ligo": 0.63,
					"location": [
						149.571269478582,
						-36.6308163626938
					],
					"name": "Bemboka Public School",
					"playspace": 302.07,
					"projections": [
						49,
						52,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"49",
						"52",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						-5.77,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1189
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.26,
					"enrolment": 179,
					"ligo": 0.88,
					"location": [
						150.06448122225,
						-36.4206126383106
					],
					"name": "Bermagui Public School",
					"playspace": 104.18,
					"projections": [
						161,
						179,
						195,
						195,
						190,
						190
					],
					"projections_orig": [
						"161",
						"179",
						"195",
						"195",
						"190",
						"190"
					],
					"projections_percentage": [
						-10.06,
						0,
						8.94,
						8.94,
						6.15,
						6.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1204
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 7.91,
					"enrolment": 74,
					"ligo": 1,
					"location": [
						150.05393912717,
						-36.0971920250806
					],
					"name": "Bodalla Public School",
					"playspace": 444.59,
					"projections": [
						131,
						74,
						90,
						85,
						80,
						75
					],
					"projections_orig": [
						"131",
						"74",
						"90",
						"85",
						"80",
						"75"
					],
					"projections_percentage": [
						77.03,
						0,
						21.62,
						14.86,
						8.11,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1272
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.34,
					"enrolment": 58,
					"ligo": 0.78,
					"location": [
						149.696019754952,
						-36.7686291394147
					],
					"name": "Candelo Public School",
					"playspace": 149.84,
					"projections": [
						80,
						58,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"80",
						"58",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						37.93,
						0,
						20.69,
						20.69,
						20.69,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1490
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 5.06,
					"enrolment": 70,
					"ligo": 0.79,
					"location": [
						149.882994378305,
						-36.3873422422581
					],
					"name": "Cobargo Public School",
					"playspace": 272.59,
					"projections": [
						84,
						70,
						80,
						75,
						75,
						75
					],
					"projections_orig": [
						"84",
						"70",
						"80",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						20,
						0,
						14.29,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1579
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.78,
					"enrolment": 265,
					"ligo": 0.91,
					"location": [
						149.907606271958,
						-37.0628109834117
					],
					"name": "Eden Public School",
					"playspace": 57.68,
					"projections": [
						275,
						265,
						285,
						270,
						265,
						260
					],
					"projections_orig": [
						"275",
						"265",
						"285",
						"270",
						"265",
						"260"
					],
					"projections_percentage": [
						3.77,
						0,
						7.55,
						1.89,
						0,
						-1.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1816
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 18
					},
					"classroomspace": 2.85,
					"enrolment": 413,
					"ligo": 0.86,
					"location": [
						149.916701271837,
						-36.8872004283635
					],
					"name": "Merimbula Public School",
					"playspace": 26.51,
					"projections": [
						403,
						413,
						435,
						410,
						390,
						380
					],
					"projections_orig": [
						"403",
						"413",
						"435",
						"410",
						"390",
						"380"
					],
					"projections_percentage": [
						-2.42,
						0,
						5.33,
						-0.73,
						-5.57,
						-7.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2526
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.22,
					"enrolment": 38,
					"ligo": 0.29,
					"location": [
						150.140536170272,
						-35.7857104281924
					],
					"name": "Mogo Public School",
					"playspace": 542.67,
					"projections": [
						62,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"62",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						63.16,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2586
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.39,
					"enrolment": 340,
					"ligo": 0.84,
					"location": [
						150.075411514919,
						-35.9126380949165
					],
					"name": "Moruya Public School",
					"playspace": 52.51,
					"projections": [
						368,
						340,
						380,
						360,
						330,
						310
					],
					"projections_orig": [
						"368",
						"340",
						"380",
						"360",
						"330",
						"310"
					],
					"projections_percentage": [
						8.24,
						0,
						11.76,
						5.88,
						-2.94,
						-8.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2628
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 11
					},
					"classroomspace": 2.68,
					"enrolment": 422,
					"ligo": 0.91,
					"location": [
						150.137594135546,
						-36.2195029229757
					],
					"name": "Narooma Public School",
					"playspace": 31.26,
					"projections": [
						392,
						422,
						445,
						405,
						400,
						390
					],
					"projections_orig": [
						"392",
						"422",
						"445",
						"405",
						"400",
						"390"
					],
					"projections_percentage": [
						-7.11,
						0,
						5.45,
						-4.03,
						-5.21,
						-7.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2758
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 11
					},
					"classroomspace": 3.11,
					"enrolment": 343,
					"ligo": 0.71,
					"location": [
						149.872484639203,
						-36.9256163392801
					],
					"name": "Pambula Public School",
					"playspace": 53.53,
					"projections": [
						303,
						343,
						330,
						310,
						305,
						300
					],
					"projections_orig": [
						"303",
						"343",
						"330",
						"310",
						"305",
						"300"
					],
					"projections_percentage": [
						-11.66,
						0,
						-3.79,
						-9.62,
						-11.08,
						-12.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2831
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.92,
					"enrolment": 61,
					"ligo": 0.88,
					"location": [
						149.867710454467,
						-36.4647158852232
					],
					"name": "Quaama Public School",
					"playspace": 438.81,
					"projections": [
						61,
						61,
						55,
						55,
						55,
						50
					],
					"projections_orig": [
						"61",
						"61",
						"55",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						0,
						0,
						-9.84,
						-9.84,
						-9.84,
						-18.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2917
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 3.8,
					"enrolment": 20,
					"ligo": 0.69,
					"location": [
						149.975518933694,
						-36.6405220981141
					],
					"name": "Tanja Public School",
					"playspace": 307.15,
					"projections": [
						25,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3159
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.43,
					"enrolment": 212,
					"ligo": 0.83,
					"location": [
						149.979496359978,
						-36.7331292636724
					],
					"name": "Tathra Public School",
					"playspace": 76.92,
					"projections": [
						161,
						212,
						190,
						185,
						185,
						180
					],
					"projections_orig": [
						"161",
						"212",
						"190",
						"185",
						"185",
						"180"
					],
					"projections_percentage": [
						-24.06,
						0,
						-10.38,
						-12.74,
						-12.74,
						-15.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3173
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.53,
					"enrolment": 42,
					"ligo": 0.27,
					"location": [
						150.072503539423,
						-36.3152447536411
					],
					"name": "Central Tilba Public School",
					"playspace": 194.45,
					"projections": [
						37,
						42,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"42",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-11.9,
						0,
						-40.48,
						-40.48,
						-40.48,
						-40.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.18,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						149.694775980747,
						-37.0848366843216
					],
					"name": "Towamba Public School",
					"playspace": 681.56,
					"projections": [
						29,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						81.25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3252
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.71,
					"enrolment": 63,
					"ligo": 0.59,
					"location": [
						149.811356866831,
						-36.8322295878387
					],
					"name": "Wolumla Public School",
					"playspace": 174.09,
					"projections": [
						54,
						63,
						60,
						60,
						60,
						55
					],
					"projections_orig": [
						"54",
						"63",
						"60",
						"60",
						"60",
						"55"
					],
					"projections_percentage": [
						-14.29,
						0,
						-4.76,
						-4.76,
						-4.76,
						-12.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3479
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.45,
					"enrolment": 22,
					"ligo": 0.91,
					"location": [
						149.646762347447,
						-36.9291952606736
					],
					"name": "Wyndham Public School",
					"playspace": 263.77,
					"projections": [
						26,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.18,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3525
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.15,
					"enrolment": 306,
					"ligo": 0.75,
					"location": [
						150.209082719013,
						-35.7414035036223
					],
					"name": "Sunshine Bay Public School",
					"playspace": 64.43,
					"projections": [
						335,
						306,
						335,
						305,
						290,
						270
					],
					"projections_orig": [
						"335",
						"306",
						"335",
						"305",
						"290",
						"270"
					],
					"projections_percentage": [
						9.48,
						0,
						9.48,
						-0.33,
						-5.23,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4562
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 2.36,
					"enrolment": 372,
					"ligo": 0.7,
					"location": [
						150.171287821221,
						-35.8449065928245
					],
					"name": "Broulee Public School",
					"playspace": 21.78,
					"projections": [
						277,
						372,
						330,
						300,
						285,
						265
					],
					"projections_orig": [
						"277",
						"372",
						"330",
						"300",
						"285",
						"265"
					],
					"projections_percentage": [
						-25.54,
						0,
						-11.29,
						-19.35,
						-23.39,
						-28.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4612
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.13,
					"enrolment": 780,
					"ligo": 0.92,
					"location": [
						149.839550057902,
						-36.6785006360218
					],
					"name": "Bega High School",
					"playspace": 22.64,
					"projections": [
						931,
						780,
						805,
						800,
						765,
						710
					],
					"projections_orig": [
						"931",
						"780",
						"805",
						"800",
						"765",
						"710"
					],
					"projections_percentage": [
						19.36,
						0,
						3.21,
						2.56,
						-1.92,
						-8.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8165
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 36
					},
					"classroomspace": 4.57,
					"enrolment": 648,
					"ligo": 0.73,
					"location": [
						150.08098382885,
						-35.9193780666272
					],
					"name": "Moruya High School",
					"playspace": 80.76,
					"projections": [
						714,
						648,
						700,
						685,
						635,
						560
					],
					"projections_orig": [
						"714",
						"648",
						"700",
						"685",
						"635",
						"560"
					],
					"projections_percentage": [
						10.19,
						0,
						8.02,
						5.71,
						-2.01,
						-13.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8368
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 29
					},
					"classroomspace": 3.74,
					"enrolment": 651,
					"ligo": 0.9,
					"location": [
						149.905842271621,
						-37.0560688610777
					],
					"name": "Eden Marine High School",
					"playspace": 44.47,
					"projections": [
						718,
						651,
						710,
						705,
						670,
						625
					],
					"projections_orig": [
						"718",
						"651",
						"710",
						"705",
						"670",
						"625"
					],
					"projections_percentage": [
						10.29,
						0,
						9.06,
						8.29,
						2.92,
						-3.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8487
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 4.59,
					"enrolment": 458,
					"ligo": 0.91,
					"location": [
						150.127041064939,
						-36.2356151740259
					],
					"name": "Narooma High School",
					"playspace": 61.41,
					"projections": [
						461,
						458,
						470,
						475,
						440,
						410
					],
					"projections_orig": [
						"461",
						"458",
						"470",
						"475",
						"440",
						"410"
					],
					"projections_percentage": [
						0.66,
						0,
						2.62,
						3.71,
						-3.93,
						-10.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8536
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 34
					},
					"classroomspace": 4.1,
					"enrolment": 675,
					"ligo": 0.96,
					"location": [
						150.195549218759,
						-35.7299340080396
					],
					"name": "Batemans Bay High School",
					"playspace": 33.43,
					"projections": [
						688,
						675,
						685,
						660,
						605,
						545
					],
					"projections_orig": [
						"688",
						"675",
						"685",
						"660",
						"605",
						"545"
					],
					"projections_percentage": [
						1.93,
						0,
						1.48,
						-2.22,
						-10.37,
						-19.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8581
				}
			],
			"uid": 30088
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 172
			},
			"enrolment": 2794,
			"level": "Combined",
			"ligo": 0.84,
			"name": "Rural Queanbeyan Network",
			"playspace": 355.82,
			"projections": [
				2794,
				2957,
				2907,
				2777,
				2612
			],
			"projections_percentage": [
				0,
				5.83,
				4.04,
				-0.61,
				-6.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.47,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						148.776089045557,
						-35.9936970692004
					],
					"name": "Adaminaby Public School",
					"playspace": 1119.75,
					"projections": [
						19,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1007
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.22,
					"enrolment": 63,
					"ligo": 0.92,
					"location": [
						148.828574940849,
						-36.3717149604943
					],
					"name": "Berridale Public School",
					"playspace": 298.65,
					"projections": [
						97,
						63,
						80,
						75,
						75,
						70
					],
					"projections_orig": [
						"97",
						"63",
						"80",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						53.97,
						0,
						26.98,
						19.05,
						19.05,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1206
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.05,
					"enrolment": 113,
					"ligo": 0.94,
					"location": [
						149.233934032893,
						-36.9180921734943
					],
					"name": "Bombala Public School",
					"playspace": 159.93,
					"projections": [
						130,
						113,
						110,
						110,
						105,
						105
					],
					"projections_orig": [
						"130",
						"113",
						"110",
						"110",
						"105",
						"105"
					],
					"projections_percentage": [
						15.04,
						0,
						-2.65,
						-2.65,
						-7.08,
						-7.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1288
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 4.46,
					"enrolment": 371,
					"ligo": 0.7,
					"location": [
						149.798487827143,
						-35.4396456452642
					],
					"name": "Braidwood Central School",
					"playspace": 36.47,
					"projections": [
						431,
						371,
						440,
						430,
						395,
						365
					],
					"projections_orig": [
						"431",
						"371",
						"440",
						"430",
						"395",
						"365"
					],
					"projections_percentage": [
						16.17,
						0,
						18.6,
						15.9,
						6.47,
						-1.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1340
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 7.6,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.147182108564,
						-35.9539397987998
					],
					"name": "Bredbo Public School",
					"playspace": 1370.64,
					"projections": [
						25,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						150,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1347
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.68,
					"enrolment": 39,
					"ligo": 0.95,
					"location": [
						149.449600802382,
						-35.5879124526632
					],
					"name": "Captains Flat Public School",
					"playspace": 180.23,
					"projections": [
						38,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-2.56,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1502
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.01,
					"enrolment": 30,
					"ligo": 0.83,
					"location": [
						149.433340596072,
						-34.9141193962539
					],
					"name": "Collector Public School",
					"playspace": 89.68,
					"projections": [
						28,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.67,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1590
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 4.49,
					"enrolment": 249,
					"ligo": 0.8,
					"location": [
						149.125051940578,
						-36.236921993705
					],
					"name": "Cooma Public School",
					"playspace": 32.21,
					"projections": [
						165,
						249,
						240,
						235,
						230,
						220
					],
					"projections_orig": [
						"165",
						"249",
						"240",
						"235",
						"230",
						"220"
					],
					"projections_percentage": [
						-33.73,
						0,
						-3.61,
						-5.62,
						-7.63,
						-11.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1628
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.18,
					"enrolment": 25,
					"ligo": 0.8,
					"location": [
						148.836287431852,
						-36.5032472179435
					],
					"name": "Dalgety Public School",
					"playspace": 275.75,
					"projections": [
						10,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-60,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1722
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.97,
					"enrolment": 34,
					"ligo": 1,
					"location": [
						148.938376214018,
						-37.0419723902224
					],
					"name": "Delegate Public School",
					"playspace": 663.36,
					"projections": [
						38,
						34,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"34",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.76,
						0,
						-26.47,
						-26.47,
						-26.47,
						-26.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1745
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 7.66,
					"enrolment": 8,
					"ligo": 0.73,
					"location": [
						149.364185694272,
						-35.8704892465434
					],
					"name": "Jerangle Public School",
					"playspace": 878.95,
					"projections": [
						14,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2225
				},
				{
					"classrooms": {
						"demountable": 17,
						"permanent": 24
					},
					"classroomspace": 3.4,
					"enrolment": 770,
					"ligo": 0.96,
					"location": [
						148.618826693655,
						-36.4158974569464
					],
					"name": "Jindabyne Central School",
					"playspace": 17.87,
					"projections": [
						603,
						770,
						740,
						710,
						690,
						635
					],
					"projections_orig": [
						"603",
						"770",
						"740",
						"710",
						"690",
						"635"
					],
					"projections_percentage": [
						-21.69,
						0,
						-3.9,
						-7.79,
						-10.39,
						-17.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2237
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 3.9,
					"enrolment": 39,
					"ligo": 0.65,
					"location": [
						149.161826203225,
						-35.7054790376383
					],
					"name": "Michelago Public School",
					"playspace": 149.04,
					"projections": [
						21,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-46.15,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2540
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.77,
					"enrolment": 30,
					"ligo": 0.96,
					"location": [
						149.289097708343,
						-36.5106601106226
					],
					"name": "Nimmitabel Public School",
					"playspace": 645.35,
					"projections": [
						27,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2752
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.39,
					"enrolment": 42,
					"ligo": 0.81,
					"location": [
						149.655419891606,
						-35.0673603811582
					],
					"name": "Tarago Public School",
					"playspace": 292.37,
					"projections": [
						32,
						42,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"42",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-23.81,
						0,
						-40.48,
						-40.48,
						-40.48,
						-40.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3162
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 6.8,
					"enrolment": 19,
					"ligo": 0.52,
					"location": [
						149.834060433516,
						-35.0097520864694
					],
					"name": "Windellama Public School",
					"playspace": 137.22,
					"projections": [
						28,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						47.37,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3457
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.26,
					"enrolment": 330,
					"ligo": 0.54,
					"location": [
						149.13040796229,
						-36.217554226975
					],
					"name": "Cooma North Public School",
					"playspace": 38.6,
					"projections": [
						296,
						330,
						345,
						335,
						315,
						305
					],
					"projections_orig": [
						"296",
						"330",
						"345",
						"335",
						"315",
						"305"
					],
					"projections_percentage": [
						-10.3,
						0,
						4.55,
						1.52,
						-4.55,
						-7.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3890
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 6.65,
					"enrolment": 486,
					"ligo": 0.91,
					"location": [
						149.133964128803,
						-36.2159750892186
					],
					"name": "Monaro High School",
					"playspace": 94.27,
					"projections": [
						582,
						486,
						580,
						590,
						550,
						500
					],
					"projections_orig": [
						"582",
						"486",
						"580",
						"590",
						"550",
						"500"
					],
					"projections_percentage": [
						19.75,
						0,
						19.34,
						21.4,
						13.17,
						2.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8196
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 9.1,
					"enrolment": 120,
					"ligo": 0.93,
					"location": [
						149.232718483294,
						-36.9169350038638
					],
					"name": "Bombala High School",
					"playspace": 280.23,
					"projections": [
						172,
						120,
						130,
						130,
						125,
						120
					],
					"projections_orig": [
						"172",
						"120",
						"130",
						"130",
						"125",
						"120"
					],
					"projections_percentage": [
						43.33,
						0,
						8.33,
						8.33,
						4.17,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8486
				}
			],
			"uid": 30089
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 174
			},
			"enrolment": 2499,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Rural Southern Tablelands Network",
			"playspace": 703.3,
			"projections": [
				2500,
				2506,
				2486,
				2441,
				2396
			],
			"projections_percentage": [
				0,
				0.24,
				-0.56,
				-2.36,
				-4.16
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.48,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						149.144492089331,
						-34.0863214147169
					],
					"name": "Bigga Public School",
					"playspace": 3320.15,
					"projections": [
						7,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-46.15,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1223
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.79,
					"enrolment": 12,
					"ligo": 0.67,
					"location": [
						149.367252486068,
						-34.3315192568867
					],
					"name": "Binda Public School",
					"playspace": 863.91,
					"projections": [
						15,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1231
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 7.97,
					"enrolment": 216,
					"ligo": 0.97,
					"location": [
						148.7249605436,
						-34.4367942526277
					],
					"name": "Boorowa Central School",
					"playspace": 125.88,
					"projections": [
						252,
						216,
						240,
						225,
						215,
						205
					],
					"projections_orig": [
						"252",
						"216",
						"240",
						"225",
						"215",
						"205"
					],
					"projections_percentage": [
						16.67,
						0,
						11.11,
						4.17,
						-0.46,
						-5.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1313
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.81,
					"enrolment": 29,
					"ligo": 0.93,
					"location": [
						148.812565473573,
						-34.7697206494024
					],
					"name": "Bowning Public School",
					"playspace": 661.17,
					"projections": [
						48,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"48",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						65.52,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1334
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 12.57,
					"enrolment": 9,
					"ligo": 0.78,
					"location": [
						149.487480021133,
						-34.7902957182474
					],
					"name": "Breadalbane Public School",
					"playspace": 710.22,
					"projections": [
						7,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.22,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1345
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 12.59,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						147.874627216799,
						-34.1197177484418
					],
					"name": "Bribbaree Public School",
					"playspace": 1504.57,
					"projections": [
						18,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						38.46,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1354
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.2,
					"enrolment": 217,
					"ligo": 0.8,
					"location": [
						149.469431194679,
						-34.4599560212233
					],
					"name": "Crookwell Public School",
					"playspace": 29.34,
					"projections": [
						178,
						217,
						220,
						235,
						245,
						255
					],
					"projections_orig": [
						"178",
						"217",
						"220",
						"235",
						"245",
						"255"
					],
					"projections_percentage": [
						-17.97,
						0,
						1.38,
						8.29,
						12.9,
						17.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1684
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.72,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						149.179504678734,
						-34.719706345596
					],
					"name": "Dalton Public School",
					"playspace": 1264.39,
					"projections": [
						14,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-17.65,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1723
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.42,
					"enrolment": 78,
					"ligo": 0.88,
					"location": [
						149.265609858917,
						-34.7830366533832
					],
					"name": "Gunning Public School",
					"playspace": 141.96,
					"projections": [
						45,
						78,
						75,
						75,
						80,
						80
					],
					"projections_orig": [
						"45",
						"78",
						"75",
						"75",
						"80",
						"80"
					],
					"projections_percentage": [
						-42.31,
						0,
						-3.85,
						-3.85,
						2.56,
						2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2111
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.69,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						148.558863031609,
						-34.0355220950605
					],
					"name": "Koorawatha Public School",
					"playspace": 554.28,
					"projections": [
						19,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-40.62,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2326
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 10.94,
					"enrolment": 15,
					"ligo": 0.5,
					"location": [
						149.526915228793,
						-34.4064005353545
					],
					"name": "Laggan Public School",
					"playspace": 481.59,
					"projections": [
						21,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2354
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.7,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						148.214811616399,
						-34.243586918281
					],
					"name": "Maimuru Public School",
					"playspace": 983.38,
					"projections": [
						26,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						85.71,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2448
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.49,
					"enrolment": 100,
					"ligo": 0.87,
					"location": [
						150.005512173949,
						-34.7126669149111
					],
					"name": "Marulan Public School",
					"playspace": 68.45,
					"projections": [
						130,
						100,
						110,
						115,
						120,
						125
					],
					"projections_orig": [
						"130",
						"100",
						"110",
						"115",
						"120",
						"125"
					],
					"projections_percentage": [
						30,
						0,
						10,
						15,
						20,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2496
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 7.78,
					"enrolment": 24,
					"ligo": 1,
					"location": [
						148.347646037548,
						-34.1933289600946
					],
					"name": "Monteagle Public School",
					"playspace": 1812.86,
					"projections": [
						44,
						24,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"24",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						83.33,
						0,
						4.17,
						4.17,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2599
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.79,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						148.516075949554,
						-34.2976949305444
					],
					"name": "Murringo Public School",
					"playspace": 340.1,
					"projections": [
						27,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.86,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2681
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 13.73,
					"enrolment": 4,
					"ligo": 0.4,
					"location": [
						148.992593414996,
						-34.391981018994
					],
					"name": "Rugby Public School",
					"playspace": 1173.23,
					"projections": [
						14,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						250,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3012
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.61,
					"enrolment": 11,
					"ligo": 0.56,
					"location": [
						148.906501780881,
						-34.522064267751
					],
					"name": "Rye Park Public School",
					"playspace": 922.23,
					"projections": [
						28,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						154.55,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3024
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.29,
					"enrolment": 34,
					"ligo": 0.97,
					"location": [
						149.820420477926,
						-34.3980913491752
					],
					"name": "Taralga Public School",
					"playspace": 218.55,
					"projections": [
						53,
						34,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"53",
						"34",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						55.88,
						0,
						-26.47,
						-26.47,
						-26.47,
						-26.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3163
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.54,
					"enrolment": 14,
					"ligo": 0.5,
					"location": [
						149.681663362389,
						-34.8211337246337
					],
					"name": "Tirranna Public School",
					"playspace": 222.17,
					"projections": [
						14,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3222
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 15.2,
					"enrolment": 5,
					"ligo": 0.67,
					"location": [
						148.673545918381,
						-35.1097987499635
					],
					"name": "Wee Jasper Public School",
					"playspace": 1101.67,
					"projections": [
						14,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						180,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3412
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 22
					},
					"classroomspace": 2.72,
					"enrolment": 534,
					"ligo": 0.59,
					"location": [
						148.290079068179,
						-34.3213246635125
					],
					"name": "Young Public School",
					"playspace": 41.51,
					"projections": [
						566,
						534,
						550,
						530,
						505,
						480
					],
					"projections_orig": [
						"566",
						"534",
						"550",
						"530",
						"505",
						"480"
					],
					"projections_percentage": [
						5.99,
						0,
						3,
						-0.75,
						-5.43,
						-10.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3563
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.06,
					"enrolment": 255,
					"ligo": 0.84,
					"location": [
						148.304912086095,
						-34.3097576807123
					],
					"name": "Young North Public School",
					"playspace": 126.01,
					"projections": [
						228,
						255,
						255,
						250,
						235,
						225
					],
					"projections_orig": [
						"228",
						"255",
						"255",
						"250",
						"235",
						"225"
					],
					"projections_percentage": [
						-10.59,
						0,
						0,
						-1.96,
						-7.84,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4131
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 4.55,
					"enrolment": 578,
					"ligo": 1,
					"location": [
						148.293086372555,
						-34.3170781731505
					],
					"name": "Young High School",
					"playspace": 45.04,
					"projections": [
						612,
						578,
						525,
						510,
						485,
						460
					],
					"projections_orig": [
						"612",
						"578",
						"525",
						"510",
						"485",
						"460"
					],
					"projections_percentage": [
						5.88,
						0,
						-9.17,
						-11.76,
						-16.09,
						-20.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8155
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 6.44,
					"enrolment": 240,
					"ligo": 0.94,
					"location": [
						149.465627476665,
						-34.4523493107898
					],
					"name": "Crookwell High School",
					"playspace": 166.5,
					"projections": [
						292,
						241,
						250,
						265,
						275,
						285
					],
					"projections_orig": [
						"292",
						"241",
						"250",
						"265",
						"275",
						"285"
					],
					"projections_percentage": [
						21.16,
						0,
						3.73,
						9.96,
						14.11,
						18.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8452
				}
			],
			"uid": 30090
		},
		{
			"classrooms": {
				"demountable": 21,
				"permanent": 201
			},
			"enrolment": 4344,
			"level": "Combined",
			"ligo": 0.68,
			"name": "Rural Wolondilly Network",
			"playspace": 212.61,
			"projections": [
				4344,
				4360,
				4385,
				4355,
				4295
			],
			"projections_percentage": [
				0,
				0.37,
				0.94,
				0.25,
				-1.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 8.05,
					"enrolment": 17,
					"ligo": 0.43,
					"location": [
						150.479171590715,
						-34.612631224134
					],
					"name": "Avoca Public School",
					"playspace": 329.66,
					"projections": [
						30,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						76.47,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1081
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.29,
					"enrolment": 222,
					"ligo": 0.73,
					"location": [
						150.476171495419,
						-34.4004140553949
					],
					"name": "Colo Vale Public School",
					"playspace": 46.31,
					"projections": [
						243,
						222,
						230,
						230,
						230,
						225
					],
					"projections_orig": [
						"243",
						"222",
						"230",
						"230",
						"230",
						"225"
					],
					"projections_percentage": [
						9.46,
						0,
						3.6,
						3.6,
						3.6,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1085
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 3.05,
					"enrolment": 141,
					"ligo": 0.55,
					"location": [
						150.341281870546,
						-34.4862144029113
					],
					"name": "Berrima Public School",
					"playspace": 73.72,
					"projections": [
						100,
						141,
						125,
						130,
						130,
						125
					],
					"projections_orig": [
						"100",
						"141",
						"125",
						"130",
						"130",
						"125"
					],
					"projections_percentage": [
						-29.08,
						0,
						-11.35,
						-7.8,
						-7.8,
						-11.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1209
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 1.7,
					"enrolment": 590,
					"ligo": 0.82,
					"location": [
						150.419643907276,
						-34.4815442733276
					],
					"name": "Bowral Public School",
					"playspace": 18.74,
					"projections": [
						520,
						590,
						595,
						595,
						590,
						580
					],
					"projections_orig": [
						"520",
						"590",
						"595",
						"595",
						"590",
						"580"
					],
					"projections_percentage": [
						-11.86,
						0,
						0.85,
						0.85,
						0,
						-1.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1335
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.88,
					"enrolment": 180,
					"ligo": 0.84,
					"location": [
						150.299322099299,
						-34.6580079923616
					],
					"name": "Bundanoon Public School",
					"playspace": 77.91,
					"projections": [
						193,
						180,
						190,
						195,
						195,
						195
					],
					"projections_orig": [
						"193",
						"180",
						"190",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						7.22,
						0,
						5.56,
						8.33,
						8.33,
						8.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1414
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.32,
					"enrolment": 28,
					"ligo": 0.68,
					"location": [
						150.516136653065,
						-34.5929375544635
					],
					"name": "Burrawang Public School",
					"playspace": 534.75,
					"projections": [
						33,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						17.86,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1445
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.36,
					"enrolment": 133,
					"ligo": 0.61,
					"location": [
						150.321600842172,
						-34.6168853498846
					],
					"name": "Exeter Public School",
					"playspace": 86.02,
					"projections": [
						72,
						133,
						95,
						100,
						100,
						100
					],
					"projections_orig": [
						"72",
						"133",
						"95",
						"100",
						"100",
						"100"
					],
					"projections_percentage": [
						-45.86,
						0,
						-28.57,
						-24.81,
						-24.81,
						-24.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1891
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.8,
					"enrolment": 28,
					"ligo": 0.08,
					"location": [
						150.483769444151,
						-34.5226874160461
					],
					"name": "Glenquarry Public School",
					"playspace": 455.02,
					"projections": [
						24,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"24",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-14.29,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2015
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 4.49,
					"enrolment": 146,
					"ligo": 0.91,
					"location": [
						150.491242184952,
						-34.3540371180264
					],
					"name": "Hill Top Public School",
					"playspace": 84.98,
					"projections": [
						213,
						146,
						185,
						185,
						185,
						180
					],
					"projections_orig": [
						"213",
						"146",
						"185",
						"185",
						"185",
						"180"
					],
					"projections_percentage": [
						45.89,
						0,
						26.71,
						26.71,
						26.71,
						23.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2166
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.94,
					"enrolment": 33,
					"ligo": 0.31,
					"location": [
						150.529757614832,
						-34.5523810012052
					],
					"name": "Kangaloon Public School",
					"playspace": 167.38,
					"projections": [
						33,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2255
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 18
					},
					"classroomspace": 2.75,
					"enrolment": 500,
					"ligo": 0.78,
					"location": [
						150.445196486573,
						-34.4483662401899
					],
					"name": "Mittagong Public School",
					"playspace": 51.38,
					"projections": [
						378,
						500,
						450,
						455,
						450,
						445
					],
					"projections_orig": [
						"378",
						"500",
						"450",
						"455",
						"450",
						"445"
					],
					"projections_percentage": [
						-24.4,
						0,
						-10,
						-9,
						-10,
						-11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2581
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 25
					},
					"classroomspace": 3.28,
					"enrolment": 536,
					"ligo": 0.8,
					"location": [
						150.365721481795,
						-34.5501106917422
					],
					"name": "Moss Vale Public School",
					"playspace": 36.39,
					"projections": [
						542,
						536,
						495,
						495,
						490,
						480
					],
					"projections_orig": [
						"542",
						"536",
						"495",
						"495",
						"490",
						"480"
					],
					"projections_percentage": [
						1.12,
						0,
						-7.65,
						-7.65,
						-8.58,
						-10.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2631
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.65,
					"enrolment": 16,
					"ligo": 0.56,
					"location": [
						150.221652981628,
						-34.6689002416012
					],
					"name": "Penrose Public School",
					"playspace": 279.1,
					"projections": [
						12,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2860
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.76,
					"enrolment": 154,
					"ligo": 0.88,
					"location": [
						150.591839761337,
						-34.5887040456456
					],
					"name": "Robertson Public School",
					"playspace": 161.78,
					"projections": [
						197,
						154,
						155,
						155,
						155,
						155
					],
					"projections_orig": [
						"197",
						"154",
						"155",
						"155",
						"155",
						"155"
					],
					"projections_percentage": [
						27.92,
						0,
						0.65,
						0.65,
						0.65,
						0.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2971
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.05,
					"enrolment": 62,
					"ligo": 0.72,
					"location": [
						150.083438995629,
						-34.7211419671575
					],
					"name": "Tallong Public School",
					"playspace": 117.64,
					"projections": [
						26,
						62,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"26",
						"62",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						-58.06,
						0,
						-3.23,
						-3.23,
						4.84,
						4.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3154
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.88,
					"enrolment": 33,
					"ligo": 0.81,
					"location": [
						150.152545954417,
						-34.6886023319484
					],
					"name": "Wingello Public School",
					"playspace": 1215.92,
					"projections": [
						31,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.06,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3461
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 3.92,
					"enrolment": 865,
					"ligo": 0.85,
					"location": [
						150.424784005116,
						-34.4890264090405
					],
					"name": "Bowral High School",
					"playspace": 36.03,
					"projections": [
						917,
						865,
						950,
						950,
						935,
						920
					],
					"projections_orig": [
						"917",
						"865",
						"950",
						"950",
						"935",
						"920"
					],
					"projections_percentage": [
						6.01,
						0,
						9.83,
						9.83,
						8.09,
						6.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8104
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 37
					},
					"classroomspace": 3.9,
					"enrolment": 660,
					"ligo": 0.85,
					"location": [
						150.384851904144,
						-34.5534984645849
					],
					"name": "Moss Vale High School",
					"playspace": 54.18,
					"projections": [
						608,
						660,
						675,
						680,
						675,
						670
					],
					"projections_orig": [
						"608",
						"660",
						"675",
						"680",
						"675",
						"670"
					],
					"projections_percentage": [
						-7.88,
						0,
						2.27,
						3.03,
						2.27,
						1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8388
				}
			],
			"uid": 30091
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 171
			},
			"enrolment": 3376,
			"level": "Combined",
			"ligo": 0.56,
			"name": "Goulburn Urban",
			"playspace": 80.8,
			"projections": [
				3376,
				3270,
				3360,
				3410,
				3440
			],
			"projections_percentage": [
				0,
				-3.14,
				-0.47,
				1.01,
				1.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3,
					"enrolment": 185,
					"ligo": 0.57,
					"location": [
						149.718340993456,
						-34.7507575015929
					],
					"name": "Goulburn Public School",
					"playspace": 94.78,
					"projections": [
						162,
						185,
						155,
						160,
						160,
						165
					],
					"projections_orig": [
						"162",
						"185",
						"155",
						"160",
						"160",
						"165"
					],
					"projections_percentage": [
						-12.43,
						0,
						-16.22,
						-13.51,
						-13.51,
						-10.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2053
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 3
					},
					"classroomspace": 3.56,
					"enrolment": 164,
					"ligo": 0.56,
					"location": [
						149.729817271454,
						-34.7626047171658
					],
					"name": "Goulburn East Public School",
					"playspace": 37.64,
					"projections": [
						98,
						164,
						140,
						145,
						150,
						150
					],
					"projections_orig": [
						"98",
						"164",
						"140",
						"145",
						"150",
						"150"
					],
					"projections_percentage": [
						-40.24,
						0,
						-14.63,
						-11.59,
						-8.54,
						-8.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2054
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.71,
					"enrolment": 313,
					"ligo": 0.45,
					"location": [
						149.734626456155,
						-34.7450462861994
					],
					"name": "Goulburn North Public School",
					"playspace": 52.49,
					"projections": [
						266,
						313,
						285,
						295,
						300,
						305
					],
					"projections_orig": [
						"266",
						"313",
						"285",
						"295",
						"300",
						"305"
					],
					"projections_percentage": [
						-15.02,
						0,
						-8.95,
						-5.75,
						-4.15,
						-2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2055
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.56,
					"enrolment": 156,
					"ligo": 0.37,
					"location": [
						149.712533827106,
						-34.7597238420738
					],
					"name": "Goulburn South Public School",
					"playspace": 76.37,
					"projections": [
						148,
						156,
						145,
						150,
						155,
						155
					],
					"projections_orig": [
						"148",
						"156",
						"145",
						"150",
						"155",
						"155"
					],
					"projections_percentage": [
						-5.13,
						0,
						-7.05,
						-3.85,
						-0.64,
						-0.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2056
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.31,
					"enrolment": 428,
					"ligo": 0.51,
					"location": [
						149.700872913887,
						-34.7587522353529
					],
					"name": "Goulburn West Public School",
					"playspace": 42.98,
					"projections": [
						368,
						428,
						390,
						405,
						410,
						415
					],
					"projections_orig": [
						"368",
						"428",
						"390",
						"405",
						"410",
						"415"
					],
					"projections_percentage": [
						-14.02,
						0,
						-8.88,
						-5.37,
						-4.21,
						-3.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3741
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 3.11,
					"enrolment": 253,
					"ligo": 0.73,
					"location": [
						149.74001841799,
						-34.7237271563547
					],
					"name": "Bradfordville Public School",
					"playspace": 90.73,
					"projections": [
						229,
						253,
						255,
						260,
						265,
						270
					],
					"projections_orig": [
						"229",
						"253",
						"255",
						"260",
						"265",
						"270"
					],
					"projections_percentage": [
						-9.49,
						0,
						0.79,
						2.77,
						4.74,
						6.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4406
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.57,
					"enrolment": 319,
					"ligo": 0.48,
					"location": [
						149.710307836977,
						-34.7423400445116
					],
					"name": "Wollondilly Public School",
					"playspace": 203.41,
					"projections": [
						371,
						319,
						345,
						355,
						365,
						365
					],
					"projections_orig": [
						"371",
						"319",
						"345",
						"355",
						"365",
						"365"
					],
					"projections_percentage": [
						16.3,
						0,
						8.15,
						11.29,
						14.42,
						14.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4438
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.71,
					"enrolment": 680,
					"ligo": 0.66,
					"location": [
						149.710362583441,
						-34.746530942171
					],
					"name": "Goulburn High School",
					"playspace": 28.54,
					"projections": [
						645,
						680,
						715,
						725,
						725,
						725
					],
					"projections_orig": [
						"645",
						"680",
						"715",
						"725",
						"725",
						"725"
					],
					"projections_percentage": [
						-5.15,
						0,
						5.15,
						6.62,
						6.62,
						6.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8116
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 43
					},
					"classroomspace": 3.66,
					"enrolment": 878,
					"ligo": 0.72,
					"location": [
						149.728916419231,
						-34.7311524230005
					],
					"name": "Mulwaree High School",
					"playspace": 100.24,
					"projections": [
						843,
						878,
						840,
						865,
						880,
						890
					],
					"projections_orig": [
						"843",
						"878",
						"840",
						"865",
						"880",
						"890"
					],
					"projections_percentage": [
						-3.99,
						0,
						-4.33,
						-1.48,
						0.23,
						1.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8468
				}
			],
			"uid": 30092
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 90
			},
			"enrolment": 2158,
			"level": "Combined",
			"ligo": 0.85,
			"name": "Kiama",
			"playspace": 55.92,
			"projections": [
				2158,
				2125,
				2170,
				2150,
				2175
			],
			"projections_percentage": [
				0,
				-1.53,
				0.56,
				-0.37,
				0.79
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 2.15,
					"enrolment": 453,
					"ligo": 0.97,
					"location": [
						150.821822717439,
						-34.7499852196086
					],
					"name": "Gerringong Public School",
					"playspace": 48.06,
					"projections": [
						395,
						453,
						465,
						470,
						470,
						470
					],
					"projections_orig": [
						"395",
						"453",
						"465",
						"470",
						"470",
						"470"
					],
					"projections_percentage": [
						-12.8,
						0,
						2.65,
						3.75,
						3.75,
						3.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1971
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.48,
					"enrolment": 114,
					"ligo": 0.76,
					"location": [
						150.773884043084,
						-34.6440992263525
					],
					"name": "Jamberoo Public School",
					"playspace": 115.19,
					"projections": [
						126,
						114,
						110,
						110,
						110,
						110
					],
					"projections_orig": [
						"126",
						"114",
						"110",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						10.53,
						0,
						-3.51,
						-3.51,
						-3.51,
						-3.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2218
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.01,
					"enrolment": 502,
					"ligo": 0.79,
					"location": [
						150.851653966916,
						-34.6701200985339
					],
					"name": "Kiama Public School",
					"playspace": 33.03,
					"projections": [
						366,
						502,
						440,
						450,
						445,
						445
					],
					"projections_orig": [
						"366",
						"502",
						"440",
						"450",
						"445",
						"445"
					],
					"projections_percentage": [
						-27.09,
						0,
						-12.35,
						-10.36,
						-11.35,
						-11.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2293
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 53
					},
					"classroomspace": 3.58,
					"enrolment": 1089,
					"ligo": 0.88,
					"location": [
						150.846199167135,
						-34.6810659907353
					],
					"name": "Kiama High School",
					"playspace": 27.42,
					"projections": [
						1211,
						1089,
						1110,
						1140,
						1125,
						1150
					],
					"projections_orig": [
						"1211",
						"1089",
						"1110",
						"1140",
						"1125",
						"1150"
					],
					"projections_percentage": [
						11.2,
						0,
						1.93,
						4.68,
						3.31,
						5.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8171
				}
			],
			"uid": 30097
		},
		{
			"classrooms": {
				"demountable": 35,
				"permanent": 329
			},
			"enrolment": 6248,
			"level": "Combined",
			"ligo": 0.63,
			"name": "Nowra",
			"playspace": 108.54,
			"projections": [
				6248,
				6455,
				6495,
				6425,
				6325
			],
			"projections_percentage": [
				0,
				3.31,
				3.95,
				2.83,
				1.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.84,
					"enrolment": 342,
					"ligo": 0.82,
					"location": [
						150.690660501567,
						-34.7776347928421
					],
					"name": "Berry Public School",
					"playspace": 112.17,
					"projections": [
						285,
						342,
						330,
						335,
						330,
						330
					],
					"projections_orig": [
						"285",
						"342",
						"330",
						"335",
						"330",
						"330"
					],
					"projections_percentage": [
						-16.67,
						0,
						-3.51,
						-2.05,
						-3.51,
						-3.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1211
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 4.06,
					"enrolment": 347,
					"ligo": 0.76,
					"location": [
						150.607974834102,
						-34.8486069430738
					],
					"name": "Bomaderry Public School",
					"playspace": 62.73,
					"projections": [
						300,
						347,
						315,
						320,
						315,
						310
					],
					"projections_orig": [
						"300",
						"347",
						"315",
						"320",
						"315",
						"310"
					],
					"projections_percentage": [
						-13.54,
						0,
						-9.22,
						-7.78,
						-9.22,
						-10.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1287
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.76,
					"enrolment": 307,
					"ligo": 0.37,
					"location": [
						150.557060242185,
						-34.8210920691647
					],
					"name": "Cambewarra Public School",
					"playspace": 85.11,
					"projections": [
						316,
						307,
						320,
						325,
						320,
						315
					],
					"projections_orig": [
						"316",
						"307",
						"320",
						"325",
						"320",
						"315"
					],
					"projections_percentage": [
						2.93,
						0,
						4.23,
						5.86,
						4.23,
						2.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1481
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.67,
					"enrolment": 203,
					"ligo": 0.93,
					"location": [
						150.740099260361,
						-34.8538984270682
					],
					"name": "Shoalhaven Heads Public School",
					"playspace": 85.83,
					"projections": [
						162,
						203,
						190,
						195,
						195,
						195
					],
					"projections_orig": [
						"162",
						"203",
						"190",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						-20.2,
						0,
						-6.4,
						-3.94,
						-3.94,
						-3.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1625
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.22,
					"enrolment": 56,
					"ligo": 0.47,
					"location": [
						150.594176506642,
						-34.9663193678722
					],
					"name": "Falls Creek Public School",
					"playspace": 577.33,
					"projections": [
						63,
						56,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"63",
						"56",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						12.5,
						0,
						-1.79,
						-1.79,
						-1.79,
						-1.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1901
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.61,
					"enrolment": 80,
					"ligo": 0.97,
					"location": [
						150.531836372958,
						-34.7356707190899
					],
					"name": "Kangaroo Valley Public School",
					"playspace": 72.04,
					"projections": [
						98,
						80,
						85,
						85,
						85,
						85
					],
					"projections_orig": [
						"98",
						"80",
						"85",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						22.5,
						0,
						6.25,
						6.25,
						6.25,
						6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2256
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.79,
					"enrolment": 618,
					"ligo": 0.5,
					"location": [
						150.599828567022,
						-34.8788180039002
					],
					"name": "Nowra Public School",
					"playspace": 63.45,
					"projections": [
						630,
						618,
						645,
						650,
						640,
						625
					],
					"projections_orig": [
						"630",
						"618",
						"645",
						"650",
						"640",
						"625"
					],
					"projections_percentage": [
						1.94,
						0,
						4.37,
						5.18,
						3.56,
						1.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2769
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 1
					},
					"classroomspace": 3.52,
					"enrolment": 88,
					"ligo": 0.19,
					"location": [
						150.630921655707,
						-34.8668529931848
					],
					"name": "Terara Public School",
					"playspace": 59.2,
					"projections": [
						87,
						88,
						90,
						90,
						90,
						85
					],
					"projections_orig": [
						"87",
						"88",
						"90",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						-1.14,
						0,
						2.27,
						2.27,
						2.27,
						-3.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3185
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.79,
					"enrolment": 91,
					"ligo": 0.39,
					"location": [
						150.730873411984,
						-34.9075097883423
					],
					"name": "Greenwell Point Public School",
					"playspace": 78.18,
					"projections": [
						50,
						91,
						75,
						75,
						70,
						70
					],
					"projections_orig": [
						"50",
						"91",
						"75",
						"75",
						"70",
						"70"
					],
					"projections_percentage": [
						-45.05,
						0,
						-17.58,
						-17.58,
						-23.08,
						-23.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3872
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 3
					},
					"classroomspace": 2.86,
					"enrolment": 166,
					"ligo": 0.36,
					"location": [
						150.566322664623,
						-34.9364236093918
					],
					"name": "Nowra Hill Public School",
					"playspace": 100.28,
					"projections": [
						107,
						166,
						135,
						135,
						135,
						130
					],
					"projections_orig": [
						"107",
						"166",
						"135",
						"135",
						"135",
						"130"
					],
					"projections_percentage": [
						-35.54,
						0,
						-18.67,
						-18.67,
						-18.67,
						-21.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4106
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.68,
					"enrolment": 538,
					"ligo": 0.42,
					"location": [
						150.590079146408,
						-34.8601540285192
					],
					"name": "Illaroo Road Public School",
					"playspace": 47.76,
					"projections": [
						542,
						538,
						565,
						570,
						565,
						550
					],
					"projections_orig": [
						"542",
						"538",
						"565",
						"570",
						"565",
						"550"
					],
					"projections_percentage": [
						0.74,
						0,
						5.02,
						5.95,
						5.02,
						2.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4246
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 3.96,
					"enrolment": 349,
					"ligo": 0.9,
					"location": [
						150.608816374142,
						-34.8822975982108
					],
					"name": "Nowra East Public School",
					"playspace": 56.67,
					"projections": [
						322,
						349,
						340,
						340,
						335,
						330
					],
					"projections_orig": [
						"322",
						"349",
						"340",
						"340",
						"335",
						"330"
					],
					"projections_percentage": [
						-7.74,
						0,
						-2.58,
						-2.58,
						-4.01,
						-5.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4256
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.84,
					"enrolment": 213,
					"ligo": 0.83,
					"location": [
						150.761223347329,
						-34.9329583702412
					],
					"name": "Culburra Public School",
					"playspace": 116.1,
					"projections": [
						215,
						213,
						200,
						205,
						200,
						195
					],
					"projections_orig": [
						"215",
						"213",
						"200",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						0.94,
						0,
						-6.1,
						-3.76,
						-6.1,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4485
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 3.21,
					"enrolment": 227,
					"ligo": 0.57,
					"location": [
						150.577220410341,
						-34.8554446141487
					],
					"name": "North Nowra Public School",
					"playspace": 84.19,
					"projections": [
						267,
						227,
						245,
						245,
						240,
						235
					],
					"projections_orig": [
						"267",
						"227",
						"245",
						"245",
						"240",
						"235"
					],
					"projections_percentage": [
						17.62,
						0,
						7.93,
						7.93,
						5.73,
						3.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4618
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.66,
					"enrolment": 208,
					"ligo": 0.88,
					"location": [
						150.715362231713,
						-34.9953200216291
					],
					"name": "Callala Public School",
					"playspace": 55.92,
					"projections": [
						277,
						208,
						255,
						255,
						255,
						250
					],
					"projections_orig": [
						"277",
						"208",
						"255",
						"255",
						"255",
						"250"
					],
					"projections_percentage": [
						33.17,
						0,
						22.6,
						22.6,
						22.6,
						20.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4626
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 55
					},
					"classroomspace": 3.82,
					"enrolment": 996,
					"ligo": 0.45,
					"location": [
						150.610009520451,
						-34.8713559404314
					],
					"name": "Nowra High School",
					"playspace": 99.81,
					"projections": [
						1076,
						996,
						1050,
						1050,
						1050,
						1030
					],
					"projections_orig": [
						"1076",
						"996",
						"1050",
						"1050",
						"1050",
						"1030"
					],
					"projections_percentage": [
						8.03,
						0,
						5.42,
						5.42,
						5.42,
						3.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8201
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 56
					},
					"classroomspace": 4.68,
					"enrolment": 756,
					"ligo": 0.81,
					"location": [
						150.602161048127,
						-34.8436623648324
					],
					"name": "Bomaderry High School",
					"playspace": 104.17,
					"projections": [
						918,
						756,
						825,
						830,
						820,
						825
					],
					"projections_orig": [
						"918",
						"756",
						"825",
						"830",
						"820",
						"825"
					],
					"projections_percentage": [
						21.43,
						0,
						9.13,
						9.79,
						8.47,
						9.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8448
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 53
					},
					"classroomspace": 5.08,
					"enrolment": 663,
					"ligo": 0.78,
					"location": [
						150.610523709208,
						-34.8959032084583
					],
					"name": "Shoalhaven High School",
					"playspace": 92.74,
					"projections": [
						803,
						663,
						735,
						735,
						725,
						710
					],
					"projections_orig": [
						"803",
						"663",
						"735",
						"735",
						"725",
						"710"
					],
					"projections_percentage": [
						21.12,
						0,
						10.86,
						10.86,
						9.35,
						7.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8561
				}
			],
			"uid": 30098
		},
		{
			"classrooms": {
				"demountable": 31,
				"permanent": 115
			},
			"enrolment": 2936,
			"level": "Combined",
			"ligo": 0.71,
			"name": "Jervis Bay",
			"playspace": 42.96,
			"projections": [
				2936,
				2880,
				2890,
				2850,
				2795
			],
			"projections_percentage": [
				0,
				-1.91,
				-1.57,
				-2.93,
				-4.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 4
					},
					"classroomspace": 2.99,
					"enrolment": 180,
					"ligo": 0.24,
					"location": [
						150.668017574806,
						-35.0373558439013
					],
					"name": "Huskisson Public School",
					"playspace": 31.26,
					"projections": [
						107,
						180,
						135,
						140,
						135,
						135
					],
					"projections_orig": [
						"107",
						"180",
						"135",
						"140",
						"135",
						"135"
					],
					"projections_percentage": [
						-40.56,
						0,
						-25,
						-22.22,
						-25,
						-25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2199
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.19,
					"enrolment": 148,
					"ligo": 0.55,
					"location": [
						150.586516189471,
						-35.0546448735959
					],
					"name": "Tomerong Public School",
					"playspace": 76.64,
					"projections": [
						116,
						148,
						125,
						125,
						125,
						120
					],
					"projections_orig": [
						"116",
						"148",
						"125",
						"125",
						"125",
						"120"
					],
					"projections_percentage": [
						-21.62,
						0,
						-15.54,
						-15.54,
						-15.54,
						-18.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3226
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.9,
					"enrolment": 230,
					"ligo": 0.92,
					"location": [
						150.584538978322,
						-35.1671035492109
					],
					"name": "Sussex Inlet Public School",
					"playspace": 55.07,
					"projections": [
						218,
						230,
						250,
						250,
						245,
						240
					],
					"projections_orig": [
						"218",
						"230",
						"250",
						"250",
						"245",
						"240"
					],
					"projections_percentage": [
						-5.22,
						0,
						8.7,
						8.7,
						6.52,
						4.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3659
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 13
					},
					"classroomspace": 2.66,
					"enrolment": 432,
					"ligo": 0.74,
					"location": [
						150.563431823632,
						-35.091350963966
					],
					"name": "St Georges Basin Public School",
					"playspace": 34.09,
					"projections": [
						421,
						432,
						440,
						445,
						440,
						430
					],
					"projections_orig": [
						"421",
						"432",
						"440",
						"445",
						"440",
						"430"
					],
					"projections_percentage": [
						-2.55,
						0,
						1.85,
						3.01,
						1.85,
						-0.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3673
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 18
					},
					"classroomspace": 3.22,
					"enrolment": 494,
					"ligo": 0.77,
					"location": [
						150.629467456082,
						-35.105933387751
					],
					"name": "Sanctuary Point Public School",
					"playspace": 40.73,
					"projections": [
						480,
						494,
						530,
						530,
						525,
						515
					],
					"projections_orig": [
						"480",
						"494",
						"530",
						"530",
						"525",
						"515"
					],
					"projections_percentage": [
						-2.83,
						0,
						7.29,
						7.29,
						6.28,
						4.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4464
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.5,
					"enrolment": 327,
					"ligo": 0.79,
					"location": [
						150.670321368764,
						-35.0729844927443
					],
					"name": "Vincentia Public School",
					"playspace": 40.58,
					"projections": [
						330,
						327,
						340,
						345,
						340,
						330
					],
					"projections_orig": [
						"330",
						"327",
						"340",
						"345",
						"340",
						"330"
					],
					"projections_percentage": [
						0.92,
						0,
						3.98,
						5.5,
						3.98,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4592
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 49
					},
					"classroomspace": 3.69,
					"enrolment": 1125,
					"ligo": 0.96,
					"location": [
						150.663588999367,
						-35.0771364223198
					],
					"name": "Vincentia High School",
					"playspace": 22.38,
					"projections": [
						1156,
						1125,
						1060,
						1055,
						1040,
						1025
					],
					"projections_orig": [
						"1156",
						"1125",
						"1060",
						"1055",
						"1040",
						"1025"
					],
					"projections_percentage": [
						2.76,
						0,
						-5.78,
						-6.22,
						-7.56,
						-8.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8593
				}
			],
			"uid": 30099
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 31
			},
			"enrolment": 421,
			"level": "Combined",
			"ligo": 1,
			"name": "Uralla",
			"playspace": 238.98,
			"projections": [
				421,
				481,
				506,
				521,
				553
			],
			"projections_percentage": [
				0,
				14.25,
				20.19,
				23.75,
				31.35
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.97,
					"enrolment": 43,
					"ligo": 1,
					"location": [
						151.450383963504,
						-30.7593430932681
					],
					"name": "Kentucky Public School",
					"playspace": 279.4,
					"projections": [
						29,
						43,
						50,
						55,
						55,
						60
					],
					"projections_orig": [
						"29",
						"43",
						"50",
						"55",
						"55",
						"60"
					],
					"projections_percentage": [
						-32.56,
						0,
						16.28,
						27.91,
						27.91,
						39.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2286
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.33,
					"enrolment": 28,
					"ligo": 1,
					"location": [
						151.116056224399,
						-30.5066337746623
					],
					"name": "Kingstown Public School",
					"playspace": 209.76,
					"projections": [
						39,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						39.29,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2310
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.12,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						151.491799168465,
						-30.6134427564557
					],
					"name": "Rocky River Public School",
					"playspace": 394.41,
					"projections": [
						43,
						38,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"43",
						"38",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						13.16,
						0,
						-34.21,
						-34.21,
						-34.21,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2983
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 5.19,
					"enrolment": 312,
					"ligo": 1,
					"location": [
						151.493599997438,
						-30.6408680353554
					],
					"name": "Uralla Central School",
					"playspace": 72.34,
					"projections": [
						340,
						312,
						365,
						385,
						400,
						415
					],
					"projections_orig": [
						"340",
						"312",
						"365",
						"385",
						"400",
						"415"
					],
					"projections_percentage": [
						8.97,
						0,
						16.99,
						23.4,
						28.21,
						33.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3864
				}
			],
			"uid": 30100
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 23
			},
			"enrolment": 627,
			"level": "Combined",
			"ligo": 1,
			"name": "Maclean",
			"playspace": 155.79,
			"projections": [
				627,
				710,
				685,
				660,
				640
			],
			"projections_percentage": [
				0,
				13.24,
				9.25,
				5.26,
				2.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 3.07,
					"enrolment": 136,
					"ligo": 1,
					"location": [
						153.348587621943,
						-29.4052467503885
					],
					"name": "Iluka Public School",
					"playspace": 69.07,
					"projections": [
						142,
						136,
						140,
						140,
						135,
						130
					],
					"projections_orig": [
						"142",
						"136",
						"140",
						"140",
						"135",
						"130"
					],
					"projections_percentage": [
						4.41,
						0,
						2.94,
						2.94,
						-0.74,
						-4.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2204
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.61,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						153.288689564034,
						-29.419777033976
					],
					"name": "Palmers Island Public School",
					"playspace": 172.2,
					"projections": [
						61,
						54,
						60,
						60,
						60,
						55
					],
					"projections_orig": [
						"61",
						"54",
						"60",
						"60",
						"60",
						"55"
					],
					"projections_percentage": [
						12.96,
						0,
						11.11,
						11.11,
						11.11,
						1.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2829
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.77,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						153.030189655078,
						-29.6289849502458
					],
					"name": "Ulmarra Public School",
					"playspace": 181.5,
					"projections": [
						82,
						61,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"82",
						"61",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						34.43,
						0,
						14.75,
						14.75,
						14.75,
						14.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3303
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.68,
					"enrolment": 376,
					"ligo": 1,
					"location": [
						153.352080575946,
						-29.4409001902375
					],
					"name": "Yamba Public School",
					"playspace": 200.38,
					"projections": [
						384,
						376,
						440,
						415,
						395,
						385
					],
					"projections_orig": [
						"384",
						"376",
						"440",
						"415",
						"395",
						"385"
					],
					"projections_percentage": [
						2.13,
						0,
						17.02,
						10.37,
						5.05,
						2.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3533
				}
			],
			"uid": 30101
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 88
			},
			"enrolment": 1712,
			"level": "Combined",
			"ligo": 0.88,
			"name": "Casino",
			"playspace": 303.12,
			"projections": [
				1712,
				1838,
				1858,
				1773,
				1708
			],
			"projections_percentage": [
				0,
				7.36,
				8.53,
				3.56,
				-0.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.79,
					"enrolment": 718,
					"ligo": 0.67,
					"location": [
						153.047678266783,
						-28.8670508197798
					],
					"name": "Casino Public School",
					"playspace": 26.65,
					"projections": [
						548,
						718,
						760,
						750,
						700,
						690
					],
					"projections_orig": [
						"548",
						"718",
						"760",
						"750",
						"700",
						"690"
					],
					"projections_percentage": [
						-23.68,
						0,
						5.85,
						4.46,
						-2.51,
						-3.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1526
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.32,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						153.00390230931,
						-28.9308386857661
					],
					"name": "Leeville Public School",
					"playspace": 652.85,
					"projections": [
						55,
						52,
						55,
						55,
						50,
						50
					],
					"projections_orig": [
						"55",
						"52",
						"55",
						"55",
						"50",
						"50"
					],
					"projections_percentage": [
						5.77,
						0,
						5.77,
						5.77,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1740
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.73,
					"enrolment": 42,
					"ligo": 1,
					"location": [
						153.077086762054,
						-28.7496139151956
					],
					"name": "Manifold Public School",
					"playspace": 123.35,
					"projections": [
						22,
						42,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"42",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-47.62,
						0,
						-40.48,
						-40.48,
						-40.48,
						-40.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2464
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.56,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						152.955017437556,
						-29.0864292816282
					],
					"name": "Rappville Public School",
					"playspace": 828.8,
					"projections": [
						20,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						81.82,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2937
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.08,
					"enrolment": 226,
					"ligo": 0.67,
					"location": [
						153.037678733745,
						-28.8556073884968
					],
					"name": "Casino West Public School",
					"playspace": 102.26,
					"projections": [
						294,
						226,
						230,
						235,
						230,
						225
					],
					"projections_orig": [
						"294",
						"226",
						"230",
						"235",
						"230",
						"225"
					],
					"projections_percentage": [
						30.09,
						0,
						1.77,
						3.98,
						1.77,
						-0.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5166
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 4.37,
					"enrolment": 663,
					"ligo": 0.95,
					"location": [
						153.043067796707,
						-28.843919733525
					],
					"name": "Casino High School",
					"playspace": 84.79,
					"projections": [
						756,
						663,
						740,
						765,
						740,
						690
					],
					"projections_orig": [
						"756",
						"663",
						"740",
						"765",
						"740",
						"690"
					],
					"projections_percentage": [
						14.03,
						0,
						11.61,
						15.38,
						11.61,
						4.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8154
				}
			],
			"uid": 30102
		}
	],
	"projections": {
		"average": [
			7.79,
			15.29,
			20.85,
			25.98
		],
		"maximum": [
			13.98,
			31.81,
			49.5,
			65.38
		],
		"minimum": [
			0,
			0,
			0,
			0
		]
	},
	"total_student_population": 4533045
};


//////////////////
// WEBPACK FOOTER
// ./src/data/data.json
// module id = 277
// module chunks = 0